/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 199);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(206);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(254);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["_63"] = isActivePaymentsLoading;
/* harmony export (immutable) */ __webpack_exports__["_93"] = isGuideOpen;
/* harmony export (immutable) */ __webpack_exports__["_10"] = getGuideShownDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__ = __webpack_require__(326);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors_schools__["r"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__ = __webpack_require__(327);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors_students__["q"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__ = __webpack_require__(328);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors_basket__["u"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__ = __webpack_require__(329);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors_dinners__["y"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors_shop__ = __webpack_require__(330);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors_shop__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors_shop__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors_shop__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors_shop__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors_shop__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors_shop__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors_shop__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors_shop__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors_shop__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors_shop__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors_shop__["k"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors_history__ = __webpack_require__(331);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors_history__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return __WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors_history__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__ = __webpack_require__(332);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors_clubs__["y"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__ = __webpack_require__(333);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors_payments__["t"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_school_money_selectors_parental_consent__ = __webpack_require__(334);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_8_state_school_money_selectors_parental_consent__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return __WEBPACK_IMPORTED_MODULE_8_state_school_money_selectors_parental_consent__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return __WEBPACK_IMPORTED_MODULE_8_state_school_money_selectors_parental_consent__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return __WEBPACK_IMPORTED_MODULE_8_state_school_money_selectors_parental_consent__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return __WEBPACK_IMPORTED_MODULE_8_state_school_money_selectors_parental_consent__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return __WEBPACK_IMPORTED_MODULE_8_state_school_money_selectors_parental_consent__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return __WEBPACK_IMPORTED_MODULE_8_state_school_money_selectors_parental_consent__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_school_money_selectors_parents__ = __webpack_require__(335);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9_state_school_money_selectors_parents__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return __WEBPACK_IMPORTED_MODULE_9_state_school_money_selectors_parents__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return __WEBPACK_IMPORTED_MODULE_9_state_school_money_selectors_parents__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return __WEBPACK_IMPORTED_MODULE_9_state_school_money_selectors_parents__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return __WEBPACK_IMPORTED_MODULE_9_state_school_money_selectors_parents__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_school_money_selectors_checkout__ = __webpack_require__(336);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_10_state_school_money_selectors_checkout__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_10_state_school_money_selectors_checkout__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_10_state_school_money_selectors_checkout__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_10_state_school_money_selectors_checkout__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_10_state_school_money_selectors_checkout__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_10_state_school_money_selectors_checkout__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return __WEBPACK_IMPORTED_MODULE_10_state_school_money_selectors_checkout__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_state_school_money_selectors_secure_trading__ = __webpack_require__(337);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return __WEBPACK_IMPORTED_MODULE_11_state_school_money_selectors_secure_trading__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return __WEBPACK_IMPORTED_MODULE_11_state_school_money_selectors_secure_trading__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return __WEBPACK_IMPORTED_MODULE_11_state_school_money_selectors_secure_trading__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return __WEBPACK_IMPORTED_MODULE_11_state_school_money_selectors_secure_trading__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return __WEBPACK_IMPORTED_MODULE_11_state_school_money_selectors_secure_trading__["e"]; });
/**
 * @returns {boolean}
 */function isActivePaymentsLoading(state){return state.getIn(["school_money","isActivePaymentsLoading"]);}/**
 * @returns {boolean}
 */function isGuideOpen(state){return state.getIn(["school_money","isGuideOpen"]);}/**
 * @returns {string}
 */function getGuideShownDate(state){return state.getIn(["school_money","guideShownDate"]);}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(242)();
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return FETCH_ALL; });
/* harmony export (immutable) */ __webpack_exports__["_56"] = fetchAll;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return SECURE_TRADING_PROCESS_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return SECURE_TRADING_PROCESS_TOKEN_COMPLETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return SECURE_TRADING_THREEDS_STATUS_UPDATE; });
/* unused harmony export SECURE_TRADING_RESET */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return SECURE_TRADING_RESET_COMPLETED; });
/* unused harmony export SECURE_TRADING_THREEDS_RESPONSE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return SECURE_TRADING_GET_JWT_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return SECURE_TRADING_PROCESS_PAYMENT_RESPONSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return SECURE_TRADING_GET_JWT_STRING_COMPLETED; });
/* harmony export (immutable) */ __webpack_exports__["_86"] = processSecureTradingToken;
/* unused harmony export processSecureTradingTokenSucceeded */
/* unused harmony export updateSecureTradingThreeDSStatus */
/* unused harmony export resetSecureTrading */
/* unused harmony export resetSecureTradingSucceeded */
/* unused harmony export processSecureTrading3DSResponse */
/* harmony export (immutable) */ __webpack_exports__["_67"] = getSecureTradingGetJwtString;
/* harmony export (immutable) */ __webpack_exports__["_68"] = getSecureTradingGetJwtStringComplete;
/* harmony export (immutable) */ __webpack_exports__["_85"] = processSecureTradingPaymentResponse;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return PARENTS_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return PARENTS_FETCH_COMPLETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return PARENT_EMAIL_ADDRESS_UPDATE; });
/* harmony export (immutable) */ __webpack_exports__["_59"] = fetchParents;
/* harmony export (immutable) */ __webpack_exports__["_60"] = fetchParentsSucceeded;
/* harmony export (immutable) */ __webpack_exports__["_111"] = updateParentEmailAddress;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return SCHOOLS_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return SCHOOLS_FETCH_COMPLETED; });
/* harmony export (immutable) */ __webpack_exports__["_61"] = fetchSchools;
/* harmony export (immutable) */ __webpack_exports__["_62"] = fetchSchoolsSucceeded;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return STUDENTS_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return STUDENTS_FETCH_COMPLETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return SET_LAST_STUDENT; });
/* harmony export (immutable) */ __webpack_exports__["_65"] = fetchStudents;
/* harmony export (immutable) */ __webpack_exports__["_66"] = fetchStudentsSucceeded;
/* harmony export (immutable) */ __webpack_exports__["_106"] = setLastStudent;
/* unused harmony export CREDITS_FETCH */
/* unused harmony export CREDITS_FETCH_COMPLETED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CREDIT_TOP_UP_ADD_TO_BASKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CREDIT_TOP_UP_REMOVE_FROM_BASKET; });
/* unused harmony export fetchCredits */
/* unused harmony export fetchCreditsSucceeded */
/* harmony export (immutable) */ __webpack_exports__["_36"] = addCreditTopUpToBasket;
/* harmony export (immutable) */ __webpack_exports__["_88"] = removeCreditTopUpFromBasket;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return BASKET_ITEM_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BASKET_ITEM_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return BASKET_ITEM_DELETE_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BASKET_ITEMS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BASKET_ITEMS_ISSUES_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BASKET_ITEMS_VALIDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BASKET_ITEMS_RESOLVE_ISSUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BASKET_ITEMS_ISSUES_MODAL_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BASKET_ITEMS_ISSUES_MODAL_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return SET_EXPANDED_SCHOOL_BASKET; });
/* harmony export (immutable) */ __webpack_exports__["_98"] = setBasketItem;
/* harmony export (immutable) */ __webpack_exports__["_52"] = deleteBasketItem;
/* harmony export (immutable) */ __webpack_exports__["_53"] = deleteBasketItemGroup;
/* harmony export (immutable) */ __webpack_exports__["_40"] = clearBasketItems;
/* harmony export (immutable) */ __webpack_exports__["_99"] = setBasketItemsIssues;
/* harmony export (immutable) */ __webpack_exports__["_115"] = validateBasketItems;
/* harmony export (immutable) */ __webpack_exports__["_92"] = resolveBasketItemsIssues;
/* unused harmony export openBasketItemsIssuesModal */
/* unused harmony export closeBasketItemsIssuesModal */
/* harmony export (immutable) */ __webpack_exports__["_105"] = setExpandedSchoolBasket;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVE_PAYMENTS_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTIVE_PAYMENTS_FETCH_COMPLETED; });
/* harmony export (immutable) */ __webpack_exports__["_54"] = fetchActivePayments;
/* harmony export (immutable) */ __webpack_exports__["_55"] = fetchActivePaymentsSucceeded;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CLUB_BOOKING_SESSION_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CLUB_BOOKING_ADD_TO_BASKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CLUB_BOOKING_REMOVE_FROM_BASKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return EXPANDED_CLUB_BOOKING_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CLUB_BOOKINGS_MARK_AS_SEEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return STUDENT_CLUB_BOOKINGS_MARK_AS_SEEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CLUB_BOOKING_GO_TO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CLUB_BOOKING_GO_TO_CLEAR; });
/* harmony export (immutable) */ __webpack_exports__["_95"] = selectClubBookingSession;
/* harmony export (immutable) */ __webpack_exports__["_35"] = addClubBookingToBasket;
/* harmony export (immutable) */ __webpack_exports__["_87"] = removeClubBookingFromBasket;
/* harmony export (immutable) */ __webpack_exports__["_102"] = setExpandedClubBooking;
/* harmony export (immutable) */ __webpack_exports__["_74"] = markClubBookingsAsSeen;
/* harmony export (immutable) */ __webpack_exports__["_78"] = markStudentClubBookingsAsSeen;
/* harmony export (immutable) */ __webpack_exports__["_69"] = goToClubBooking;
/* harmony export (immutable) */ __webpack_exports__["_43"] = clearGoToClubBooking;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return DINNER_BOOKING_OPTION_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return DINNER_BOOKING_ADD_TO_BASKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return DINNER_BOOKING_REMOVE_FROM_BASKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return SET_ALLERGIES_WARNING_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return SET_EXPANDED_DINNER_BOOKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return DINNER_BOOKINGS_MARK_AS_SEEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return STUDENT_DINNER_BOOKINGS_MARK_AS_SEEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return DINNER_BOOKING_GO_TO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return DINNER_BOOKING_GO_TO_CLEAR; });
/* harmony export (immutable) */ __webpack_exports__["_96"] = selectDinnerBookingOption;
/* harmony export (immutable) */ __webpack_exports__["_37"] = addDinnerBookingToBasket;
/* harmony export (immutable) */ __webpack_exports__["_89"] = removeDinnerBookingFromBasket;
/* harmony export (immutable) */ __webpack_exports__["_97"] = setAllergiesWarningStatus;
/* harmony export (immutable) */ __webpack_exports__["_103"] = setExpandedDinnerBooking;
/* harmony export (immutable) */ __webpack_exports__["_75"] = markDinnerBookingsAsSeen;
/* harmony export (immutable) */ __webpack_exports__["_79"] = markStudentDinnerBookingsAsSeen;
/* harmony export (immutable) */ __webpack_exports__["_70"] = goToDinnerBooking;
/* harmony export (immutable) */ __webpack_exports__["_44"] = clearGoToDinnerBooking;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return SET_PAYMENT_INSTALLMENT_SELECTED_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return PAYMENT_INSTALLMENT_ADD_TO_BASKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return PAYMENT_INSTALLMENT_REMOVE_FROM_BASKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return PAYMENT_REMOVE_FROM_BASKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return SET_EXPANDED_PAYMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return PAYMENTS_MARK_AS_SEEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return STUDENT_PAYMENTS_MARK_AS_SEEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return PAYMENT_GO_TO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return PAYMENT_GO_TO_CLEAR; });
/* harmony export (immutable) */ __webpack_exports__["_107"] = setPaymentInstallmentSelectedPrice;
/* harmony export (immutable) */ __webpack_exports__["_38"] = addPaymentInstallmentToBasket;
/* harmony export (immutable) */ __webpack_exports__["_90"] = removePaymentInstallmentFromBasket;
/* unused harmony export removePaymentFromBasket */
/* harmony export (immutable) */ __webpack_exports__["_104"] = setExpandedPayment;
/* harmony export (immutable) */ __webpack_exports__["_76"] = markPaymentsAsSeen;
/* harmony export (immutable) */ __webpack_exports__["_80"] = markStudentPaymentsAsSeen;
/* harmony export (immutable) */ __webpack_exports__["_72"] = goToPayment;
/* harmony export (immutable) */ __webpack_exports__["_45"] = clearGoToPayment;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return SHOP_ITEMS_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return SHOP_ITEMS_FETCH_COMPLETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return SHOP_ITEM_SET_BASKET_QUANTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return SHOP_ITEM_REMOVE_FROM_BASKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return SHOP_ITEMS_MARK_AS_SEEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return STUDENT_SHOP_ITEMS_MARK_AS_SEEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return SHOP_ITEM_GO_TO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return SHOP_ITEM_GO_TO_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return SHOP_ITEM_SET_SEARCH_QUERY; });
/* harmony export (immutable) */ __webpack_exports__["_63"] = fetchShopItems;
/* harmony export (immutable) */ __webpack_exports__["_64"] = fetchShopItemsSucceeded;
/* harmony export (immutable) */ __webpack_exports__["_108"] = setShopItemBasketQuantity;
/* harmony export (immutable) */ __webpack_exports__["_91"] = removeShopItemFromBasket;
/* harmony export (immutable) */ __webpack_exports__["_77"] = markShopItemsAsSeen;
/* harmony export (immutable) */ __webpack_exports__["_81"] = markStudentShopItemsAsSeen;
/* harmony export (immutable) */ __webpack_exports__["_73"] = goToShopItem;
/* harmony export (immutable) */ __webpack_exports__["_46"] = clearGoToShopItem;
/* harmony export (immutable) */ __webpack_exports__["_109"] = setShopItemSearchQuery;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return HISTORY_FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return HISTORY_FETCH_COMPLETED; });
/* harmony export (immutable) */ __webpack_exports__["_57"] = fetchHistory;
/* harmony export (immutable) */ __webpack_exports__["_58"] = fetchHistorySucceeded;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return PARENTAL_CONSENT_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return PARENTAL_CONSENT_UPDATE_SUCCEEDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return PARENTAL_CONSENT_UPDATE_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return PENDING_PARENTAL_CONSENT_ITEMS_CLEAR_SAVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return PENDING_PARENTAL_CONSENT_ITEMS_CLEAR_FAILURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return PARENTAL_CONSENT_ITEM_GO_TO; });
/* harmony export (immutable) */ __webpack_exports__["_112"] = updateParentalConsent;
/* harmony export (immutable) */ __webpack_exports__["_114"] = updateParentalConsentSucceeded;
/* harmony export (immutable) */ __webpack_exports__["_113"] = updateParentalConsentFailed;
/* harmony export (immutable) */ __webpack_exports__["_47"] = clearSavedPendingParentalConsentItems;
/* harmony export (immutable) */ __webpack_exports__["_42"] = clearFailedPendingParentalConsentItems;
/* harmony export (immutable) */ __webpack_exports__["_71"] = goToParentalConsentItem;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CHECKOUT_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CHECKOUT_TRANSACTION_DETAILS_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CHECKOUT_TRANSACTION_PROCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CHECKOUT_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CHECKOUT_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CHECKOUT_ERROR_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CHECKOUT_ERROR_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return ERROR_PAYSAFE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return ERROR_SECURE_TRADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CLEAR_SECURE_TRADING_WALLET_PAY_JWT_STRING; });
/* unused harmony export SECURE_TRADING_REFERENCE_SET */
/* unused harmony export CLEAR_SECURE_TRADING_GOOGLE_PAY_JWT_STRING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CHECKOUT_RESTART; });
/* harmony export (immutable) */ __webpack_exports__["_110"] = startCheckout;
/* harmony export (immutable) */ __webpack_exports__["_101"] = setCheckoutTransactionDetails;
/* harmony export (immutable) */ __webpack_exports__["_84"] = processCheckoutTransaction;
/* harmony export (immutable) */ __webpack_exports__["_51"] = completeCheckout;
/* harmony export (immutable) */ __webpack_exports__["_49"] = closeCheckout;
/* harmony export (immutable) */ __webpack_exports__["_100"] = setCheckoutError;
/* harmony export (immutable) */ __webpack_exports__["_41"] = clearCheckoutError;
/* harmony export (immutable) */ __webpack_exports__["_83"] = paysafeError;
/* harmony export (immutable) */ __webpack_exports__["_94"] = secureTradingError;
/* harmony export (immutable) */ __webpack_exports__["_48"] = clearWalletPayJWTString;
/* harmony export (immutable) */ __webpack_exports__["_39"] = checkoutRestart;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return GUIDE_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return GUIDE_CLOSE; });
/* harmony export (immutable) */ __webpack_exports__["_82"] = openGuide;
/* harmony export (immutable) */ __webpack_exports__["_50"] = closeGuide;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return SAVE_AUDIT; });
/* harmony export (immutable) */ __webpack_exports__["_93"] = saveAudit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_actions__ = __webpack_require__(99);
var FETCH_ALL="SCHOOL_MONEY/FETCH_ALL";function fetchAll(forceSchoolFetch,forceStudentFetch,forceParentFetch,forceActivePaymentFetch,forceShopFetch,forceHistoryFetch){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(FETCH_ALL,false,{forceSchoolFetch:forceSchoolFetch,forceStudentFetch:forceStudentFetch,forceParentFetch:forceParentFetch,forceActivePaymentFetch:forceActivePaymentFetch,forceShopFetch:forceShopFetch,forceHistoryFetch:forceHistoryFetch});}// secure trading
var SECURE_TRADING_PROCESS_TOKEN="SCHOOL_MONEY/SECURE_TRADING_PROCESS_TOKEN";var SECURE_TRADING_PROCESS_TOKEN_COMPLETED="SCHOOL_MONEY/SECURE_TRADING_PROCESS_TOKEN_COMPLETED";var SECURE_TRADING_THREEDS_STATUS_UPDATE="SCHOOL_MONEY/SECURE_TRADING_THREEDS_STATUS_UPDATE";var SECURE_TRADING_RESET="SCHOOL_MONEY/SECURE_TRADING_RESET";var SECURE_TRADING_RESET_COMPLETED="SCHOOL_MONEY/SECURE_TRADING_RESET_COMPLETED";var SECURE_TRADING_THREEDS_RESPONSE="SCHOOL_MONEY/SECURE_TRADING_THREEDS_RESPONSE";var SECURE_TRADING_GET_JWT_STRING="SCHOOL_MONEY/SECURE_TRADING_GET_JWT_STRING";var SECURE_TRADING_PROCESS_PAYMENT_RESPONSE="SCHOOL_MONEY/SECURE_TRADING_PROCESS_PAYMENT_RESPONSE";var SECURE_TRADING_GET_JWT_STRING_COMPLETED="SCHOOL_MONEY/SECURE_TRADING_GET_JWT_STRING_COMPLETED";function processSecureTradingToken(secureTrading){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SECURE_TRADING_PROCESS_TOKEN,false,{secureTrading:secureTrading});}function processSecureTradingTokenSucceeded(secureTrading){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SECURE_TRADING_PROCESS_TOKEN_COMPLETED,false,{secureTrading:secureTrading});}function updateSecureTradingThreeDSStatus(status){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SECURE_TRADING_THREEDS_STATUS_UPDATE,false,{status:status});}function resetSecureTrading(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SECURE_TRADING_RESET,false);}function resetSecureTradingSucceeded(secureTrading){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SECURE_TRADING_RESET_COMPLETED,false,{secureTrading:secureTrading});}function processSecureTrading3DSResponse(transactionID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SECURE_TRADING_THREEDS_RESPONSE,false,{transactionID:transactionID});}function getSecureTradingGetJwtString(cardHolderName){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SECURE_TRADING_GET_JWT_STRING,false,{cardHolderName:cardHolderName});}function getSecureTradingGetJwtStringComplete(jwtString){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SECURE_TRADING_GET_JWT_STRING_COMPLETED,false,{jwtString:jwtString});}function processSecureTradingPaymentResponse(paymentResult){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SECURE_TRADING_PROCESS_PAYMENT_RESPONSE,false,{paymentResult:paymentResult});}// parents
var PARENTS_FETCH="SCHOOL_MONEY/PARENTS_FETCH";var PARENTS_FETCH_COMPLETED="SCHOOL_MONEY/PARENTS_FETCH_COMPLETED";var PARENT_EMAIL_ADDRESS_UPDATE="SCHOOL_MONEY/PARENT_EMAIL_ADDRESS_UPDATE";function fetchParents(forceApiRefresh){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(PARENTS_FETCH,false,{forceApiRefresh:forceApiRefresh});}function fetchParentsSucceeded(parents){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(PARENTS_FETCH_COMPLETED,false,{parents:parents});}function updateParentEmailAddress(emailAddress){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(PARENT_EMAIL_ADDRESS_UPDATE,false,{emailAddress:emailAddress});}// schools
var SCHOOLS_FETCH="SCHOOL_MONEY/SCHOOLS_FETCH";var SCHOOLS_FETCH_COMPLETED="SCHOOL_MONEY/SCHOOLS_FETCH_COMPLETED";function fetchSchools(forceApiRefresh){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SCHOOLS_FETCH,false,{forceApiRefresh:forceApiRefresh});}function fetchSchoolsSucceeded(schools){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SCHOOLS_FETCH_COMPLETED,false,{schools:schools});}// students
var STUDENTS_FETCH="SCHOOL_MONEY/STUDENTS_FETCH";var STUDENTS_FETCH_COMPLETED="SCHOOL_MONEY/STUDENTS_FETCH_COMPLETED";var SET_LAST_STUDENT="SCHOOL_MONEY/SET_LAST_STUDENT";function fetchStudents(forceApiRefresh){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(STUDENTS_FETCH,false,{forceApiRefresh:forceApiRefresh});}function fetchStudentsSucceeded(students){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(STUDENTS_FETCH_COMPLETED,false,{students:students});}function setLastStudent(studentID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SET_LAST_STUDENT,false,{studentID:studentID});}// credits
var CREDITS_FETCH="SCHOOL_MONEY/CREDITS_FETCH";var CREDITS_FETCH_COMPLETED="SCHOOL_MONEY/CREDITS_FETCH_COMPLETED";var CREDIT_TOP_UP_ADD_TO_BASKET="SCHOOL_MONEY/CREDIT_TOP_UP_ADD_TO_BASKET";var CREDIT_TOP_UP_REMOVE_FROM_BASKET="SCHOOL_MONEY/CREDIT_TOP_UP_REMOVE_FROM_BASKET";function fetchCredits(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CREDITS_FETCH);}function fetchCreditsSucceeded(credits){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CREDITS_FETCH_COMPLETED,false,{credits:credits});}function addCreditTopUpToBasket(creditType,studentID,amount){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CREDIT_TOP_UP_ADD_TO_BASKET,false,{creditType:creditType,studentID:studentID,amount:amount});}function removeCreditTopUpFromBasket(creditType,studentID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CREDIT_TOP_UP_REMOVE_FROM_BASKET,false,{creditType:creditType,studentID:studentID});}// basket
var BASKET_ITEM_SET="SCHOOL_MONEY/BASKET_ITEM_SET";var BASKET_ITEM_DELETE="SCHOOL_MONEY/BASKET_ITEM_DELETE";var BASKET_ITEM_DELETE_GROUP="SCHOOL_MONEY/BASKET_ITEM_DELETE_GROUP";var BASKET_ITEMS_CLEAR="SCHOOL_MONEY/BASKET_ITEMS_CLEAR";var BASKET_ITEMS_ISSUES_SET="SCHOOL_MONEY/BASKET_ITEMS_ISSUES_SET";var BASKET_ITEMS_VALIDATE="SCHOOL_MONEY/BASKET_ITEMS_VALIDATE";var BASKET_ITEMS_RESOLVE_ISSUES="SCHOOL_MONEY/BASKET_ITEMS_RESOLVE_ISSUES";var BASKET_ITEMS_ISSUES_MODAL_OPEN="SCHOOL_MONEY/BASKET_ITEMS_ISSUES_MODAL_OPEN";var BASKET_ITEMS_ISSUES_MODAL_CLOSE="SCHOOL_MONEY/BASKET_ITEMS_ISSUES_MODAL_CLOSE";var SET_EXPANDED_SCHOOL_BASKET="SCHOOL_MONEY/SET_EXPANDED_SCHOOL_BASKET";function setBasketItem(type,basketItemID,schoolID,studentID,groupID,price,quantity,payload){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(BASKET_ITEM_SET,false,{type:type,basketItemID:basketItemID,schoolID:schoolID,studentID:studentID,groupID:groupID,price:price,quantity:quantity,payload:payload});}function deleteBasketItem(type,basketItemID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(BASKET_ITEM_DELETE,false,{type:type,basketItemID:basketItemID});}function deleteBasketItemGroup(type,groupID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(BASKET_ITEM_DELETE_GROUP,false,{type:type,groupID:groupID});}function clearBasketItems(schoolID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(BASKET_ITEMS_CLEAR,false,{schoolID:schoolID});}function setBasketItemsIssues(issues){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(BASKET_ITEMS_ISSUES_SET,false,{issues:issues});}function validateBasketItems(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(BASKET_ITEMS_VALIDATE);}function resolveBasketItemsIssues(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(BASKET_ITEMS_RESOLVE_ISSUES);}function openBasketItemsIssuesModal(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(BASKET_ITEMS_ISSUES_MODAL_OPEN);}function closeBasketItemsIssuesModal(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(BASKET_ITEMS_ISSUES_MODAL_CLOSE);}function setExpandedSchoolBasket(schoolID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SET_EXPANDED_SCHOOL_BASKET,false,{schoolID:schoolID});}// all payments
var ACTIVE_PAYMENTS_FETCH="SCHOOL_MONEY/ACTIVE_PAYMENTS_FETCH";var ACTIVE_PAYMENTS_FETCH_COMPLETED="SCHOOL_MONEY/ACTIVE_PAYMENTS_FETCH_COMPLETED";function fetchActivePayments(forceApiRefresh){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(ACTIVE_PAYMENTS_FETCH,false,{forceApiRefresh:forceApiRefresh});}function fetchActivePaymentsSucceeded(clubPayments,dinnerPayments,otherPayments,parentalConsentItems){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(ACTIVE_PAYMENTS_FETCH_COMPLETED,false,{clubPayments:clubPayments,dinnerPayments:dinnerPayments,otherPayments:otherPayments,parentalConsentItems:parentalConsentItems});}// clubs
var CLUB_BOOKING_SESSION_SELECT="SCHOOL_MONEY/CLUB_BOOKING_SESSION_SELECT";var CLUB_BOOKING_ADD_TO_BASKET="SCHOOL_MONEY/CLUB_BOOKING_ADD_TO_BASKET";var CLUB_BOOKING_REMOVE_FROM_BASKET="SCHOOL_MONEY/CLUB_BOOKING_REMOVE_FROM_BASKET";var EXPANDED_CLUB_BOOKING_SET="SCHOOL_MONEY/EXPANDED_CLUB_BOOKING_SET";var CLUB_BOOKINGS_MARK_AS_SEEN="SCHOOL_MONEY/CLUB_BOOKINGS_MARK_AS_SEEN";var STUDENT_CLUB_BOOKINGS_MARK_AS_SEEN="SCHOOL_MONEY/STUDENT_CLUB_BOOKINGS_MARK_AS_SEEN";var CLUB_BOOKING_GO_TO="SCHOOL_MONEY/CLUB_BOOKING_GO_TO";var CLUB_BOOKING_GO_TO_CLEAR="SCHOOL_MONEY/CLUB_BOOKING_GO_TO_CLEAR";function selectClubBookingSession(clubBookingID,weekdayIndex,sessionID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CLUB_BOOKING_SESSION_SELECT,false,{clubBookingID:clubBookingID,weekdayIndex:weekdayIndex,sessionID:sessionID});}function addClubBookingToBasket(clubBookingID){var reserve=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CLUB_BOOKING_ADD_TO_BASKET,false,{clubBookingID:clubBookingID,reserve:reserve});}function removeClubBookingFromBasket(clubBookingID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CLUB_BOOKING_REMOVE_FROM_BASKET,false,{clubBookingID:clubBookingID});}function setExpandedClubBooking(clubBookingID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(EXPANDED_CLUB_BOOKING_SET,false,{clubBookingID:clubBookingID});}function markClubBookingsAsSeen(clubBookingIDs){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CLUB_BOOKINGS_MARK_AS_SEEN,false,{clubBookingIDs:clubBookingIDs});}function markStudentClubBookingsAsSeen(studentID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(STUDENT_CLUB_BOOKINGS_MARK_AS_SEEN,false,{studentID:studentID});}function goToClubBooking(clubBookingID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CLUB_BOOKING_GO_TO,false,{clubBookingID:clubBookingID});}function clearGoToClubBooking(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CLUB_BOOKING_GO_TO_CLEAR);}// dinners
var DINNER_BOOKING_OPTION_SELECT="SCHOOL_MONEY/DINNER_BOOKING_OPTION_SELECT";var DINNER_BOOKING_ADD_TO_BASKET="SCHOOL_MONEY/DINNER_BOOKING_ADD_TO_BASKET";var DINNER_BOOKING_REMOVE_FROM_BASKET="SCHOOL_MONEY/DINNER_BOOKING_REMOVE_FROM_BASKET";var SET_ALLERGIES_WARNING_STATUS="SCHOOL_MONEY/SET_ALLERGIES_WARNING_STATUS";var SET_EXPANDED_DINNER_BOOKING="SCHOOL_MONEY/SET_EXPANDED_DINNER_BOOKING";var DINNER_BOOKINGS_MARK_AS_SEEN="SCHOOL_MONEY/DINNER_BOOKINGS_MARK_AS_SEEN";var STUDENT_DINNER_BOOKINGS_MARK_AS_SEEN="SCHOOL_MONEY/STUDENT_DINNER_BOOKINGS_MARK_AS_SEEN";var DINNER_BOOKING_GO_TO="SCHOOL_MONEY/DINNER_BOOKING_GO_TO";var DINNER_BOOKING_GO_TO_CLEAR="SCHOOL_MONEY/DINNER_BOOKING_GO_TO_CLEAR";function selectDinnerBookingOption(dinnerBookingID,weekdayIndex,optionID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(DINNER_BOOKING_OPTION_SELECT,false,{dinnerBookingID:dinnerBookingID,weekdayIndex:weekdayIndex,optionID:optionID});}function addDinnerBookingToBasket(dinnerBookingID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(DINNER_BOOKING_ADD_TO_BASKET,false,{dinnerBookingID:dinnerBookingID});}function removeDinnerBookingFromBasket(dinnerBookingID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(DINNER_BOOKING_REMOVE_FROM_BASKET,false,{dinnerBookingID:dinnerBookingID});}function setAllergiesWarningStatus(isEnabled){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SET_ALLERGIES_WARNING_STATUS,false,{isEnabled:isEnabled});}function setExpandedDinnerBooking(dinnerBookingID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SET_EXPANDED_DINNER_BOOKING,false,{dinnerBookingID:dinnerBookingID});}function markDinnerBookingsAsSeen(dinnerBookingIDs){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(DINNER_BOOKINGS_MARK_AS_SEEN,false,{dinnerBookingIDs:dinnerBookingIDs});}function markStudentDinnerBookingsAsSeen(studentID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(STUDENT_DINNER_BOOKINGS_MARK_AS_SEEN,false,{studentID:studentID});}function goToDinnerBooking(dinnerBookingID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(DINNER_BOOKING_GO_TO,false,{dinnerBookingID:dinnerBookingID});}function clearGoToDinnerBooking(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(DINNER_BOOKING_GO_TO_CLEAR);}// other payments
var SET_PAYMENT_INSTALLMENT_SELECTED_PRICE="SCHOOL_MONEY/SET_PAYMENT_INSTALLMENT_SELECTED_PRICE";var PAYMENT_INSTALLMENT_ADD_TO_BASKET="SCHOOL_MONEY/PAYMENT_INSTALLMENT_ADD_TO_BASKET";var PAYMENT_INSTALLMENT_REMOVE_FROM_BASKET="SCHOOL_MONEY/PAYMENT_INSTALLMENT_REMOVE_FROM_BASKET";var PAYMENT_REMOVE_FROM_BASKET="SCHOOL_MONEY/PAYMENT_REMOVE_FROM_BASKET";var SET_EXPANDED_PAYMENT="SCHOOL_MONEY/SET_EXPANDED_PAYMENT";var PAYMENTS_MARK_AS_SEEN="SCHOOL_MONEY/PAYMENTS_MARK_AS_SEEN";var STUDENT_PAYMENTS_MARK_AS_SEEN="SCHOOL_MONEY/STUDENT_PAYMENTS_MARK_AS_SEEN";var PAYMENT_GO_TO="SCHOOL_MONEY/PAYMENT_GO_TO";var PAYMENT_GO_TO_CLEAR="SCHOOL_MONEY/PAYMENT_GO_TO_CLEAR";function setPaymentInstallmentSelectedPrice(paymentID,installmentNumber,selectedPrice){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SET_PAYMENT_INSTALLMENT_SELECTED_PRICE,false,{paymentID:paymentID,installmentNumber:installmentNumber,selectedPrice:selectedPrice});}function addPaymentInstallmentToBasket(paymentID,installmentNumber){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(PAYMENT_INSTALLMENT_ADD_TO_BASKET,false,{paymentID:paymentID,installmentNumber:installmentNumber});}function removePaymentInstallmentFromBasket(paymentID,installmentNumber){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(PAYMENT_INSTALLMENT_REMOVE_FROM_BASKET,false,{paymentID:paymentID,installmentNumber:installmentNumber});}function removePaymentFromBasket(paymentID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(PAYMENT_REMOVE_FROM_BASKET,false,{paymentID:paymentID});}function setExpandedPayment(paymentID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SET_EXPANDED_PAYMENT,false,{paymentID:paymentID});}function markPaymentsAsSeen(paymentIDs){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(PAYMENTS_MARK_AS_SEEN,false,{paymentIDs:paymentIDs});}function markStudentPaymentsAsSeen(studentID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(STUDENT_PAYMENTS_MARK_AS_SEEN,false,{studentID:studentID});}function goToPayment(paymentID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(PAYMENT_GO_TO,false,{paymentID:paymentID});}function clearGoToPayment(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(PAYMENT_GO_TO_CLEAR);}// shop
var SHOP_ITEMS_FETCH="SCHOOL_MONEY/SHOP_ITEMS_FETCH";var SHOP_ITEMS_FETCH_COMPLETED="SCHOOL_MONEY/SHOP_ITEMS_FETCH_COMPLETED";var SHOP_ITEM_SET_BASKET_QUANTITY="SCHOOL_MONEY/SHOP_ITEM_SET_BASKET_QUANTITY";var SHOP_ITEM_REMOVE_FROM_BASKET="SCHOOL_MONEY/SHOP_ITEM_REMOVE_FROM_BASKET";var SHOP_ITEMS_MARK_AS_SEEN="SCHOOL_MONEY/SHOP_ITEMS_MARK_AS_SEEN";var STUDENT_SHOP_ITEMS_MARK_AS_SEEN="SCHOOL_MONEY/STUDENT_SHOP_ITEMS_MARK_AS_SEEN";var SHOP_ITEM_GO_TO="SCHOOL_MONEY/SHOP_ITEM_GO_TO";var SHOP_ITEM_GO_TO_CLEAR="SCHOOL_MONEY/SHOP_ITEM_GO_TO_CLEAR";var SHOP_ITEM_SET_SEARCH_QUERY="SCHOOL_MONEY/SHOP_ITEM_SET_SEARCH_QUERY";function fetchShopItems(forceApiRefresh){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SHOP_ITEMS_FETCH,false,{forceApiRefresh:forceApiRefresh});}function fetchShopItemsSucceeded(shopItems){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SHOP_ITEMS_FETCH_COMPLETED,false,{shopItems:shopItems});}function setShopItemBasketQuantity(shopItemID,studentID,quantity){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SHOP_ITEM_SET_BASKET_QUANTITY,false,{shopItemID:shopItemID,studentID:studentID,quantity:quantity});}function removeShopItemFromBasket(shopItemID,studentID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SHOP_ITEM_REMOVE_FROM_BASKET,false,{shopItemID:shopItemID,studentID:studentID});}function markShopItemsAsSeen(shopItemIDs){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SHOP_ITEMS_MARK_AS_SEEN,false,{shopItemIDs:shopItemIDs});}function markStudentShopItemsAsSeen(studentID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(STUDENT_SHOP_ITEMS_MARK_AS_SEEN,false,{studentID:studentID});}function goToShopItem(shopItemID,studentID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SHOP_ITEM_GO_TO,false,{shopItemID:shopItemID,studentID:studentID});}function clearGoToShopItem(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SHOP_ITEM_GO_TO_CLEAR);}function setShopItemSearchQuery(searchQuery){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SHOP_ITEM_SET_SEARCH_QUERY,false,{searchQuery:searchQuery});}// history
var HISTORY_FETCH="SCHOOL_MONEY/HISTORY_FETCH";var HISTORY_FETCH_COMPLETED="SCHOOL_MONEY/HISTORY_FETCH_COMPLETED";function fetchHistory(forceApiRefresh){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(HISTORY_FETCH,false,{forceApiRefresh:forceApiRefresh});}function fetchHistorySucceeded(history){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(HISTORY_FETCH_COMPLETED,false,{history:history});}// parental consent
var PARENTAL_CONSENT_UPDATE="SCHOOL_MONEY/PARENTAL_CONSENT_UPDATE";var PARENTAL_CONSENT_UPDATE_SUCCEEDED="SCHOOL_MONEY/PARENTAL_CONSENT_UPDATE_SUCCEEDED";var PARENTAL_CONSENT_UPDATE_FAILED="SCHOOL_MONEY/PARENTAL_CONSENT_UPDATE_FAILED";var PENDING_PARENTAL_CONSENT_ITEMS_CLEAR_SAVED="SCHOOL_MONEY/PENDING_PARENTAL_CONSENT_ITEMS_CLEAR_SAVED";var PENDING_PARENTAL_CONSENT_ITEMS_CLEAR_FAILURES="SCHOOL_MONEY/PENDING_PARENTAL_CONSENT_ITEMS_CLEAR_FAILURES";var PARENTAL_CONSENT_ITEM_GO_TO="SCHOOL_MONEY/PARENTAL_CONSENT_ITEM_GO_TO";function updateParentalConsent(itemID,status){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(PARENTAL_CONSENT_UPDATE,false,{itemID:itemID,status:status});}function updateParentalConsentSucceeded(itemID,status){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(PARENTAL_CONSENT_UPDATE_SUCCEEDED,false,{itemID:itemID,status:status});}// TODO: handle this error properly
function updateParentalConsentFailed(itemID,error){// this isn't an error because we want to handle it
return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(PARENTAL_CONSENT_UPDATE_FAILED,false,{itemID:itemID,error:error});}function clearSavedPendingParentalConsentItems(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(PENDING_PARENTAL_CONSENT_ITEMS_CLEAR_SAVED);}function clearFailedPendingParentalConsentItems(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(PENDING_PARENTAL_CONSENT_ITEMS_CLEAR_FAILURES);}function goToParentalConsentItem(itemID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(PARENTAL_CONSENT_ITEM_GO_TO,false,{itemID:itemID});}// checkout
var CHECKOUT_START="SCHOOL_MONEY/TRANSACTION_CREATE";var CHECKOUT_TRANSACTION_DETAILS_SET="SCHOOL_MONEY/CHECKOUT_TRANSACTION_DETAILS_SET";var CHECKOUT_TRANSACTION_PROCESS="SCHOOL_MONEY/CHECKOUT_TRANSACTION_PROCESS";var CHECKOUT_COMPLETE="SCHOOL_MONEY/CHECKOUT_COMPLETE";var CHECKOUT_CLOSE="SCHOOL_MONEY/CHECKOUT_CLOSE";var CHECKOUT_ERROR_SET="SCHOOL_MONEY/CHECKOUT_ERROR_SET";var CHECKOUT_ERROR_CLEAR="SCHOOL_MONEY/CHECKOUT_ERROR_CLEAR";var ERROR_PAYSAFE="SCHOOL_MONEY/ERROR_PAYSAFE";var ERROR_SECURE_TRADING="SCHOOL_MONEY/ERROR_SECURE_TRADING";var CLEAR_SECURE_TRADING_WALLET_PAY_JWT_STRING="SCHOOL_MONEY/CLEAR_SECURE_TRADING_WALLET_PAY_JWT_STRING";var SECURE_TRADING_REFERENCE_SET="SCHOOL_MONEY/SECURE_TRADING_REFERENCE_SET";var CLEAR_SECURE_TRADING_GOOGLE_PAY_JWT_STRING="SCHOOL_MONEY/CLEAR_SECURE_TRADING_GOOGLE_PAY_JWT_STRING";var CHECKOUT_RESTART="SCHOOL_MONEY/CHECKOUT_RESTART";function startCheckout(schoolID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CHECKOUT_START,false,{schoolID:schoolID});}function setCheckoutTransactionDetails(transactionID,totalToPay,walletPayJWTString){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CHECKOUT_TRANSACTION_DETAILS_SET,false,{transactionID:transactionID,totalToPay:totalToPay,walletPayJWTString:walletPayJWTString});}function processCheckoutTransaction(paysafeSingleUseToken,cardholderName){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CHECKOUT_TRANSACTION_PROCESS,false,{paysafeSingleUseToken:paysafeSingleUseToken,cardholderName:cardholderName});}function completeCheckout(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CHECKOUT_COMPLETE);}function closeCheckout(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CHECKOUT_CLOSE);}function setCheckoutError(error,errorCode){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CHECKOUT_ERROR_SET,true,{error:error,errorCode:errorCode});}function clearCheckoutError(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CHECKOUT_ERROR_CLEAR);}function paysafeError(error){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(ERROR_PAYSAFE,true,{error:error});}function secureTradingError(error){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(ERROR_SECURE_TRADING,true,{error:error});}function clearWalletPayJWTString(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CLEAR_SECURE_TRADING_WALLET_PAY_JWT_STRING);}function checkoutRestart(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CHECKOUT_RESTART);}// guide
var GUIDE_OPEN="SCHOOL_MONEY/GUIDE_OPEN";var GUIDE_CLOSE="SCHOOL_MONEY/GUIDE_CLOSE";function openGuide(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(GUIDE_OPEN);}function closeGuide(timestamp){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(GUIDE_CLOSE,false,{timestamp:timestamp});}// audit
var SAVE_AUDIT="SCHOOL_MONEY/SAVE_AUDIT";function saveAudit(type){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SAVE_AUDIT,false,{type:type});}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_io__ = __webpack_require__(38);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["j"]; });
/* unused harmony reexport takem */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["b"]; });
/* unused harmony reexport race */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["d"]; });
/* unused harmony reexport apply */
/* unused harmony reexport cps */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["i"]; });
/* unused harmony reexport join */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["h"]; });
/* unused harmony reexport actionChannel */
/* unused harmony reexport cancelled */
/* unused harmony reexport flush */
/* unused harmony reexport getContext */
/* unused harmony reexport setContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_io__["m"]; });


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(287);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Immutable = factory());
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step !== 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
      return emptyMap().withMutations(function(map ) {
        for (var i = 0; i < keyValues.length; i += 2) {
          if (i + 1 >= keyValues.length) {
            throw new Error('Missing value for key: ' + keyValues[i]);
          }
          map.set(keyValues[i], keyValues[i + 1]);
        }
      });
    };

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      if (this._map && !this._map.has(k)) {
        var defaultVal = this._defaultValues[k];
        if (v === defaultVal) {
          return this;
        }
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function(predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function(predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function(searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function() {
      return Range(0, this.size);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAvailableProducts;
/* harmony export (immutable) */ __webpack_exports__["s"] = isMenuOpen;
/* harmony export (immutable) */ __webpack_exports__["q"] = isLoadingAvailableProducts;
/* harmony export (immutable) */ __webpack_exports__["b"] = getClientInitDate;
/* harmony export (immutable) */ __webpack_exports__["d"] = getFatalError;
/* harmony export (immutable) */ __webpack_exports__["o"] = isDownTimeReporterOpen;
/* harmony export (immutable) */ __webpack_exports__["h"] = getLastReadSchoolMoneyCustomerNoticesKey;
/* harmony export (immutable) */ __webpack_exports__["i"] = getLastReadTeachers2ParentsCustomerNoticesKey;
/* harmony export (immutable) */ __webpack_exports__["g"] = getLastReadAppNoticesKey;
/* harmony export (immutable) */ __webpack_exports__["n"] = isCustomerNoticesOpen;
/* harmony export (immutable) */ __webpack_exports__["p"] = isInformationModalOpen;
/* harmony export (immutable) */ __webpack_exports__["e"] = getInformationModalMessage;
/* harmony export (immutable) */ __webpack_exports__["f"] = getInformationModalTitle;
/* harmony export (immutable) */ __webpack_exports__["r"] = isLoadingFrameOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_app_selectors_userIdentity__ = __webpack_require__(316);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1_state_app_selectors_userIdentity__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1_state_app_selectors_userIdentity__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1_state_app_selectors_userIdentity__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1_state_app_selectors_userIdentity__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_1_state_app_selectors_userIdentity__["e"]; });
function getAvailableProducts(state){return state.getIn(["app","availableProducts"],new __WEBPACK_IMPORTED_MODULE_0_immutable__["List"]());}function isMenuOpen(state){return state.getIn(["app","isMenuOpen"]);}function isLoadingAvailableProducts(state){return state.getIn(["app","isLoadingAvailableProducts"]);}function getClientInitDate(state){return state.getIn(["app","clientInitDate"]);}function getFatalError(state){return state.getIn(["app","fatalError"]);}function isDownTimeReporterOpen(state){return state.getIn(["app","isDownTimeReporterOpen"]);}function getLastReadSchoolMoneyCustomerNoticesKey(state){return state.getIn(["app","lastReadSchoolMoneyCustomerNoticesKey"]);}function getLastReadTeachers2ParentsCustomerNoticesKey(state){return state.getIn(["app","lastReadTeachers2ParentsCustomerNoticesKey"]);}function getLastReadAppNoticesKey(state){return state.getIn(["app","lastReadAppNoticesKey"]);}function isCustomerNoticesOpen(state){return state.getIn(["app","isCustomerNoticesOpen"]);}function isInformationModalOpen(state){return state.getIn(["app","isInformationModalOpen"]);}function getInformationModalMessage(state){return state.getIn(["app","informationModalMessage"]);}function getInformationModalTitle(state){return state.getIn(["app","informationModalTitle"]);}function isLoadingFrameOpen(state){return state.getIn(["app","isLoadingFrameOpen"]);}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ERROR_FATAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ERROR_WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return RELOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return MAIN_MENU_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MAIN_MENU_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_USER_IDENTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_AVAILABLE_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_AVAILABLE_PRODUCTS_COMPLETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PRODUCT_SAGAS_ATTACHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return OPEN_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return OPEN_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return OPEN_PHONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FORCE_REGISTRATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return PROCESS_METADATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GO_BACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLOSE_APPLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_CLIENT_INIT_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLOSE_DOWN_TIME_REPORTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return PROCESS_GOOGLE_PAY_RESPONSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLOSE_CUSTOMER_NOTICES_FRAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MARK_CUSTOMER_NOTICE_AS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return OPEN_INFORMATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLOSE_INFORMATION_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return OPEN_LOADING_FRAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLOSE_LOADING_FRAME; });
/* harmony export (immutable) */ __webpack_exports__["V"] = reload;
/* harmony export (immutable) */ __webpack_exports__["G"] = fatalError;
/* unused harmony export warningError */
/* harmony export (immutable) */ __webpack_exports__["M"] = openAppMenu;
/* harmony export (immutable) */ __webpack_exports__["A"] = closeAppMenu;
/* harmony export (immutable) */ __webpack_exports__["H"] = fetchAvailableProducts;
/* harmony export (immutable) */ __webpack_exports__["I"] = fetchAvailableProductsSuccess;
/* unused harmony export fetchAvailableProductsFail */
/* harmony export (immutable) */ __webpack_exports__["U"] = productSagasAttached;
/* harmony export (immutable) */ __webpack_exports__["W"] = setUserIdentity;
/* harmony export (immutable) */ __webpack_exports__["X"] = setUserIdentityFailed;
/* harmony export (immutable) */ __webpack_exports__["N"] = openEmail;
/* harmony export (immutable) */ __webpack_exports__["Q"] = openPhone;
/* harmony export (immutable) */ __webpack_exports__["R"] = openURL;
/* harmony export (immutable) */ __webpack_exports__["J"] = forceRegistration;
/* harmony export (immutable) */ __webpack_exports__["T"] = processMetadata;
/* harmony export (immutable) */ __webpack_exports__["K"] = goBack;
/* harmony export (immutable) */ __webpack_exports__["B"] = closeApplication;
/* harmony export (immutable) */ __webpack_exports__["z"] = clearClientInitDate;
/* harmony export (immutable) */ __webpack_exports__["D"] = closeDownTimeReporter;
/* harmony export (immutable) */ __webpack_exports__["S"] = processGooglePayResponse;
/* harmony export (immutable) */ __webpack_exports__["C"] = closeCustomerNoticeFrame;
/* harmony export (immutable) */ __webpack_exports__["L"] = markCustomerNoticeAsRead;
/* harmony export (immutable) */ __webpack_exports__["O"] = openInformationModal;
/* harmony export (immutable) */ __webpack_exports__["E"] = closeInformationModal;
/* harmony export (immutable) */ __webpack_exports__["P"] = openLoadingFrame;
/* harmony export (immutable) */ __webpack_exports__["F"] = closeLoadingFrame;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_actions___ = __webpack_require__(99);
var ERROR_FATAL="APP/ERROR_FATAL";var ERROR_WARNING="APP/ERROR_WARNING";var RELOAD="APP/RELOAD";var MAIN_MENU_OPEN="APP/MAIN_MENU_OPEN";var MAIN_MENU_CLOSE="APP/MAIN_MENU_CLOSE";var SET_USER_IDENTITY="APP/SET_USER_IDENTITY";// Async actions
var FETCH_AVAILABLE_PRODUCTS="APP/FETCH_AVAILABLE_PRODUCTS";var FETCH_AVAILABLE_PRODUCTS_COMPLETE="APP/FETCH_AVAILABLE_PRODUCTS_COMPLETE";var PRODUCT_SAGAS_ATTACHED="APP/PRODUCT_SAGAS_ATTACHED";var OPEN_URL="APP/OPEN_URL";var OPEN_EMAIL="APP/OPEN_EMAIL";var OPEN_PHONE="APP/OPEN_PHONE";var FORCE_REGISTRATION="APP/FORCE_REGISTRATION";var PROCESS_METADATA="APP/PROCESS_METADATA";var GO_BACK="APP/GO_BACK";var CLOSE_APPLICATION="APP/CLOSE_APPLICATION";var CLEAR_CLIENT_INIT_DATE="APP/UPDATE_CLIENT_INIT_DATE";var CLOSE_DOWN_TIME_REPORTER="APP/CLOSE_DOWN_TIME_REPORTER";var PROCESS_GOOGLE_PAY_RESPONSE="APP/PROCESS_GOOGLE_PAY_RESPONSE";var CLOSE_CUSTOMER_NOTICES_FRAME="APP/CLOSE_CUSTOMER_NOTICES_FRAME";var MARK_CUSTOMER_NOTICE_AS_READ="APP/MARK_CUSTOMER_NOTICE_AS_READ";var OPEN_INFORMATION_MODAL="APP/OPEN_INFORMATION_MODAL";var CLOSE_INFORMATION_MODAL="APP/CLOSE_INFORMATION_MODAL";var OPEN_LOADING_FRAME="APP/OPEN_LOADING_FRAME";var CLOSE_LOADING_FRAME="APP/CLOSE_LOADING_FRAME";// Action Creators
function reload(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(RELOAD);}function fatalError(error){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(ERROR_FATAL,true,{error:error});}function warningError(error){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(ERROR_WARNING,true,{error:error});}function openAppMenu(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(MAIN_MENU_OPEN);}function closeAppMenu(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(MAIN_MENU_CLOSE);}function fetchAvailableProducts(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(FETCH_AVAILABLE_PRODUCTS);}function fetchAvailableProductsSuccess(payload){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(FETCH_AVAILABLE_PRODUCTS_COMPLETE,false,payload);}function fetchAvailableProductsFail(payload){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(FETCH_AVAILABLE_PRODUCTS_COMPLETE,true,payload);}function productSagasAttached(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(PRODUCT_SAGAS_ATTACHED);}function setUserIdentity(userIdentity){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(SET_USER_IDENTITY,false,userIdentity);}function setUserIdentityFailed(userIdentity){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(SET_USER_IDENTITY,true);}function openEmail(emailAddress){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(OPEN_EMAIL,false,{emailAddress:emailAddress});}function openPhone(phoneNumber){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(OPEN_PHONE,false,{phoneNumber:phoneNumber});}function openURL(url){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(OPEN_URL,false,{url:url});}function forceRegistration(userMessage){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(FORCE_REGISTRATION,false,{userMessage:userMessage});}function processMetadata(metadata){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(PROCESS_METADATA,false,{metadata:metadata});}function goBack(location){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(GO_BACK,false,Object.assign({},location));}function closeApplication(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(CLOSE_APPLICATION,false);}function clearClientInitDate(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(CLEAR_CLIENT_INIT_DATE,false);}function closeDownTimeReporter(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(CLOSE_DOWN_TIME_REPORTER,false);}function processGooglePayResponse(response){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(PROCESS_GOOGLE_PAY_RESPONSE,false,{response:response});}function closeCustomerNoticeFrame(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(CLOSE_CUSTOMER_NOTICES_FRAME,false);}function markCustomerNoticeAsRead(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(MARK_CUSTOMER_NOTICE_AS_READ,false);}function openInformationModal(informationDetails){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(OPEN_INFORMATION_MODAL,false,{informationDetails:informationDetails});}function closeInformationModal(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(CLOSE_INFORMATION_MODAL,false);}function openLoadingFrame(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(OPEN_LOADING_FRAME,false);}function closeLoadingFrame(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions___["a" /* createAction */])(CLOSE_LOADING_FRAME,false);}

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = getGuideShownDate;
/* harmony export (immutable) */ __webpack_exports__["w"] = isGuideOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors_schools__ = __webpack_require__(340);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors_schools__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors_schools__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors_schools__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors_schools__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors_schools__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors_schools__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors_schools__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors_schools__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors_schools__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors_schools__["j"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_teachers_selectors_messages__ = __webpack_require__(341);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1_state_teachers_selectors_messages__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1_state_teachers_selectors_messages__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1_state_teachers_selectors_messages__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1_state_teachers_selectors_messages__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_1_state_teachers_selectors_messages__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_1_state_teachers_selectors_messages__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_1_state_teachers_selectors_messages__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_1_state_teachers_selectors_messages__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors_notices__ = __webpack_require__(342);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors_notices__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors_notices__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors_notices__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors_notices__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors_notices__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors_notices__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors_terms__ = __webpack_require__(343);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors_terms__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors_terms__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors_terms__["c"]; });
function getGuideShownDate(state){return state.getIn(["teachers","guideShownDate"]);}function isGuideOpen(state){return state.getIn(["teachers","isGuideOpen"]);}

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_ALL; });
/* harmony export (immutable) */ __webpack_exports__["D"] = fetchAll;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_SCHOOLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_SCHOOLS_COMPLETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_LAST_SCHOOL; });
/* harmony export (immutable) */ __webpack_exports__["I"] = fetchSchools;
/* harmony export (immutable) */ __webpack_exports__["J"] = fetchSchoolsSucceeded;
/* harmony export (immutable) */ __webpack_exports__["V"] = setLastSchool;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_MESSAGES_COMPLETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return MERGE_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_REPLY_DRAFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SEND_REPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_PENDING_REPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RETRY_PENDING_REPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_PENDING_REPLY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MARK_MESSAGES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return MARK_SCHOOL_MESSAGES_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GO_TO_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_GO_TO_MESSAGE; });
/* harmony export (immutable) */ __webpack_exports__["E"] = fetchMessages;
/* harmony export (immutable) */ __webpack_exports__["F"] = fetchMessagesSucceeded;
/* harmony export (immutable) */ __webpack_exports__["Q"] = mergeMessages;
/* harmony export (immutable) */ __webpack_exports__["X"] = setReplyDraft;
/* harmony export (immutable) */ __webpack_exports__["T"] = sendReply;
/* harmony export (immutable) */ __webpack_exports__["z"] = addPendingReply;
/* harmony export (immutable) */ __webpack_exports__["S"] = retryPendingReply;
/* harmony export (immutable) */ __webpack_exports__["W"] = setPendingReplyStatus;
/* harmony export (immutable) */ __webpack_exports__["O"] = markMessagesRead;
/* harmony export (immutable) */ __webpack_exports__["P"] = markSchoolMessagesRead;
/* harmony export (immutable) */ __webpack_exports__["M"] = goToMessage;
/* harmony export (immutable) */ __webpack_exports__["A"] = clearGoToMessage;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_NOTICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_NOTICES_COMPLETED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_EXPANDED_NOTICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GO_TO_NOTICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_GO_TO_NOTICE; });
/* harmony export (immutable) */ __webpack_exports__["G"] = fetchNotices;
/* harmony export (immutable) */ __webpack_exports__["H"] = fetchNoticesSucceeded;
/* harmony export (immutable) */ __webpack_exports__["U"] = setExpandedNotice;
/* harmony export (immutable) */ __webpack_exports__["N"] = goToNotice;
/* harmony export (immutable) */ __webpack_exports__["B"] = clearGoToNotice;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_TERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_TERMS_COMPLETED; });
/* harmony export (immutable) */ __webpack_exports__["K"] = fetchTerms;
/* harmony export (immutable) */ __webpack_exports__["L"] = fetchTermsSucceeded;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return OPEN_GUIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLOSE_GUIDE; });
/* harmony export (immutable) */ __webpack_exports__["R"] = openGuide;
/* harmony export (immutable) */ __webpack_exports__["C"] = closeGuide;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_actions__ = __webpack_require__(99);
var FETCH_ALL="TEACHERS/FETCH_ALL";function fetchAll(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(FETCH_ALL);}// SCHOOLS
var FETCH_SCHOOLS="TEACHERS/FETCH_SCHOOLS";var FETCH_SCHOOLS_COMPLETED="TEACHERS/FETCH_SCHOOLS_COMPLETED";var SET_LAST_SCHOOL="TEACHERS/SET_LAST_SCHOOL";function fetchSchools(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(FETCH_SCHOOLS,false);}function fetchSchoolsSucceeded(schools,migratedSchools){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(FETCH_SCHOOLS_COMPLETED,false,{schools:schools,migratedSchools:migratedSchools});}function setLastSchool(schoolID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SET_LAST_SCHOOL,false,{schoolID:schoolID});}// MESSAGES
var FETCH_MESSAGES="TEACHERS/FETCH_MESSAGES";var FETCH_MESSAGES_COMPLETED="TEACHERS/FETCH_MESSAGES_COMPLETED";var MERGE_MESSAGES="TEACHERS/MERGE_MESSAGES";var SET_REPLY_DRAFT="TEACHERS/SET_REPLY_DRAFT";var SEND_REPLY="TEACHERS/SEND_REPLY";var ADD_PENDING_REPLY="TEACHERS/ADD_PENDING_REPLY";var RETRY_PENDING_REPLY="TEACHERS/RETRY_PENDING_REPLY";var SET_PENDING_REPLY_STATUS="TEACHERS/SET_PENDING_REPLY_STATUS";var MARK_MESSAGES_READ="TEACHERS/MARK_MESSAGES_READ";var MARK_SCHOOL_MESSAGES_READ="TEACHERS/MARK_SCHOOL_MESSAGES_READ";var GO_TO_MESSAGE="TEACHERS/GO_TO_MESSAGE";var CLEAR_GO_TO_MESSAGE="TEACHERS/CLEAR_GO_TO_MESSAGE";function fetchMessages(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(FETCH_MESSAGES,false);}function fetchMessagesSucceeded(messages){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(FETCH_MESSAGES_COMPLETED,false,{messages:messages});}function mergeMessages(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(MERGE_MESSAGES,false);}function setReplyDraft(schoolID,body){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SET_REPLY_DRAFT,false,{schoolID:schoolID,body:body});}function sendReply(schoolID,body){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SEND_REPLY,false,{schoolID:schoolID,body:body});}function addPendingReply(pendingReplyID,pendingReply){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(ADD_PENDING_REPLY,false,{pendingReplyID:pendingReplyID,pendingReply:pendingReply});}function retryPendingReply(pendingReplyID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(RETRY_PENDING_REPLY,false,{pendingReplyID:pendingReplyID});}function setPendingReplyStatus(pendingReplyID,status){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SET_PENDING_REPLY_STATUS,false,{pendingReplyID:pendingReplyID,status:status});}function markMessagesRead(messageIDs){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(MARK_MESSAGES_READ,false,{messageIDs:messageIDs});}function markSchoolMessagesRead(schoolID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(MARK_SCHOOL_MESSAGES_READ,false,{schoolID:schoolID});}function goToMessage(messageID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(GO_TO_MESSAGE,false,{messageID:messageID});}function clearGoToMessage(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CLEAR_GO_TO_MESSAGE);}// NOTICES
var FETCH_NOTICES="TEACHERS/FETCH_NOTICES";var FETCH_NOTICES_COMPLETED="TEACHERS/FETCH_NOTICES_COMPLETED";var SET_EXPANDED_NOTICE="TEACHERS/SET_EXPANDED_NOTICE";var GO_TO_NOTICE="TEACHERS/GO_TO_NOTICE";var CLEAR_GO_TO_NOTICE="TEACHERS/CLEAR_GO_TO_NOTICE";function fetchNotices(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(FETCH_NOTICES,false);}function fetchNoticesSucceeded(notices){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(FETCH_NOTICES_COMPLETED,false,{notices:notices});}function setExpandedNotice(noticeID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(SET_EXPANDED_NOTICE,false,{noticeID:noticeID});}function goToNotice(noticeID){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(GO_TO_NOTICE,false,{noticeID:noticeID});}function clearGoToNotice(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CLEAR_GO_TO_NOTICE);}// TERMS
var FETCH_TERMS="TEACHERS/FETCH_TERMS";var FETCH_TERMS_COMPLETED="TEACHERS/FETCH_TERMS_COMPLETED";function fetchTerms(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(FETCH_TERMS,false);}function fetchTermsSucceeded(terms){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(FETCH_TERMS_COMPLETED,false,{terms:terms});}// APP Guide
var OPEN_GUIDE="TEACHERS/OPEN_GUIDE";var CLOSE_GUIDE="TEACHERS/CLOSE_GUIDE";function openGuide(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(OPEN_GUIDE);}function closeGuide(){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_actions__["a" /* createAction */])(CLOSE_GUIDE);}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button_css__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Button_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Button=function(_React$Component){_inherits(Button,_React$Component);function Button(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Button);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Button.__proto__||Object.getPrototypeOf(Button)).call.apply(_ref,[this].concat(args))),_this),_this.onClick=function(event){if(_this.props.onClick){_this.props.onClick(event);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Button,[{key:"render",value:function render(){var _props=this.props,className=_props.className,children=_props.children,style=_props.style;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style,className:"button "+className,onClick:this.onClick},children);}}]);return Button;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Button.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_money__ = __webpack_require__(17);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Display an amount of money
 *
 * @param {string|number} [amount] optional, defaults to zero
 * @param {string} className will be added to outer element
 * @param {string} [symbol] optional, defaults to "£" (GBP)
 */var Currency=function(_React$Component){_inherits(Currency,_React$Component);function Currency(){_classCallCheck(this,Currency);return _possibleConstructorReturn(this,(Currency.__proto__||Object.getPrototypeOf(Currency)).apply(this,arguments));}_createClass(Currency,[{key:"render",value:function render(){var _props=this.props,amount=_props.amount,className=_props.className,symbol=_props.symbol;var money=Currency.formatMoney(amount);var classNames=["currency"];if(className){classNames.push(className);}// wrap each part separately for fine-grained styling control
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"currency__sign"},money.sign),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"currency__symbol"},symbol),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"currency__unit-amount"},money.unitAmount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"currency__decimal-point"},"."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"currency__fraction-amount"},money.fractionAmount));}}],[{key:"formatMoney",/**
   * Split a monetary amount into its constituent parts as strings
   *
   * @param {number} moneyAmount
   * @returns {Object<String>} { moneyAmount, sign, unitAmount, fractionAmount }
   */value:function formatMoney(moneyAmount){if(Number.isNaN(moneyAmount)){// for NaN, return something pretty but meaningless
return{moneyAmount:moneyAmount,sign:"",unitAmount:"-",fractionAmount:"--"};}else{var amountString=Object(__WEBPACK_IMPORTED_MODULE_2_lib_money__["b" /* moneyToString */])(Math.abs(moneyAmount));var _amountString$split=amountString.split("."),_amountString$split2=_slicedToArray(_amountString$split,2),unitAmount=_amountString$split2[0],fractionAmount=_amountString$split2[1];var isNegative=moneyAmount<0;var sign=isNegative?"-":"";return{moneyAmount:moneyAmount,sign:sign,unitAmount:unitAmount,fractionAmount:fractionAmount};}}}]);return Currency;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Currency.propTypes={amount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,symbol:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Currency.defaultProps={amount:0,symbol:"£"};/* harmony default export */ __webpack_exports__["a"] = (Currency);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sendAvailableProductsRequest;
/* unused harmony export sendDataRequest */
/* harmony export (immutable) */ __webpack_exports__["c"] = sendTeachersDataRequest;
/* harmony export (immutable) */ __webpack_exports__["b"] = sendSchoolMoneyDataRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_native__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_appserver_request__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_demoMode__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_app_actions__ = __webpack_require__(9);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getUserIdentity),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(sendRequest),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(sendAvailableProductsRequest),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(sendDataRequest),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(sendTeachersDataRequest),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(sendSchoolMoneyDataRequest);/**
 * @module state/fetchSagas
 * Utility sagas for API requests to appserver
 * @see {@link module:lib/appserver/request} for actual requests
 */function getUserIdentity(){var mobileNumber,deviceToken;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getUserIdentity$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_app_selectors__["j" /* getMobileNumber */]);case 2:mobileNumber=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_app_selectors__["c" /* getDeviceToken */]);case 5:deviceToken=_context.sent;return _context.abrupt("return",{mobileNumber:mobileNumber,deviceToken:deviceToken});case 7:case"end":return _context.stop();}}},_marked,this);}/**
 * Generic request - wraps a more specific appserver API function
 * Injects mobileNumber and deviceToken arguments
 * Extracts data from response object
 * Handles certain API exceptions, but always re-throws too
 * @param {Function} appserverAPI the actual request function to call
 * @param {...} args arguments to `appserverAPI`
 * @returns {Object} response data (JSend root, i.e. { data, status })
 */function sendRequest(appserverAPI){var _ref,mobileNumber,deviceToken,isDemoMode,apiHandler,_len,args,_key,response,_error$response,config,status,data,_args2=arguments;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function sendRequest$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(getUserIdentity);case 2:_ref=_context2.sent;mobileNumber=_ref.mobileNumber;deviceToken=_ref.deviceToken;// detect demo mode and swap API call for simulation
isDemoMode=mobileNumber===__WEBPACK_IMPORTED_MODULE_2_lib_native__["a" /* DEBUG_MOBILE_NUMBER */];apiHandler=isDemoMode?Object(__WEBPACK_IMPORTED_MODULE_4_state_demoMode__["a" /* getAPISimulator */])(appserverAPI):appserverAPI;_context2.prev=7;for(_len=_args2.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=_args2[_key];}_context2.next=11;return __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */].apply(undefined,[apiHandler,mobileNumber,deviceToken].concat(args));case 11:response=_context2.sent;return _context2.abrupt("return",response.data);case 15:_context2.prev=15;_context2.t0=_context2["catch"](7);if(!(_context2.t0.type===__WEBPACK_IMPORTED_MODULE_3_lib_appserver_request__["a" /* UnknownDeviceError */].type)){_context2.next=20;break;}_context2.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_app_actions__["J" /* forceRegistration */])("This device is no longer registered. Please re-register."));case 20:// add request/response details if possible
if(_context2.t0.response!==undefined){_error$response=_context2.t0.response,config=_error$response.config,status=_error$response.status,data=_error$response.data;_context2.t0.details={request_url:config.url,request_data:config.data,response_status:status,response_body:data};}throw _context2.t0;case 22:case"end":return _context2.stop();}}},_marked2,this,[[7,15]]);}/**
 * GetMyApps() but it's a saga
 * @returns {object} response data
 * @see {@link sendRequest}
 */function sendAvailableProductsRequest(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function sendAvailableProductsRequest$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(sendRequest,__WEBPACK_IMPORTED_MODULE_3_lib_appserver_request__["b" /* availableProductsRequest */]);case 2:return _context3.abrupt("return",_context3.sent);case 3:case"end":return _context3.stop();}}},_marked3,this);}/**
 * ServiceAppServerDataRequest() but it's a saga
 * @param {string} application teachers/school_money
 * @param {string} request_cmd passed to ServiceAppServerDataRequest
 * @param {Object} otherArgs additional arguments to ServiceAppServerDataRequest
 * @returns {object} response data
 * @see {@link sendRequest}
 */function sendDataRequest(application,request_cmd,otherArgs){var args;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function sendDataRequest$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:args=Object.assign({request_cmd:request_cmd},otherArgs);_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(sendRequest,__WEBPACK_IMPORTED_MODULE_3_lib_appserver_request__["c" /* dataRequest */],application,args);case 3:return _context4.abrupt("return",_context4.sent);case 4:case"end":return _context4.stop();}}},_marked4,this);}/**
 * T2P-specific wrapper for sendDataRequest
 * @see {@link sendDataRequest}
 */function sendTeachersDataRequest(requestCmd,args){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function sendTeachersDataRequest$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(sendDataRequest,"teachers",requestCmd,args);case 2:return _context5.abrupt("return",_context5.sent);case 3:case"end":return _context5.stop();}}},_marked5,this);}/**
 * SM-specific wrapper for sendDataRequest
 * @see {@link sendDataRequest}
 */function sendSchoolMoneyDataRequest(requestCmd,args){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function sendSchoolMoneyDataRequest$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(sendDataRequest,"school_money",requestCmd,args);case 2:return _context6.abrupt("return",_context6.sent);case 3:case"end":return _context6.stop();}}},_marked6,this);}

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return history; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history__ = __webpack_require__(129);
/**
 * @module state/history
 * Expose the session history as an importable thing.
 * @see {@link https://github.com/ReactTraining/history}
 */var history=Object(__WEBPACK_IMPORTED_MODULE_0_history__["a" /* createHashHistory */])();

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loglevel__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loglevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_loglevel__);
/**
 * @module lib/log
 * Set up and expose logging functions.
 * Use this instead of calling `console` methods directly.
 * Uses [loglevel]{@link https://github.com/pimterry/loglevel}.
 */// If we're in production, only log errors
if(true){__WEBPACK_IMPORTED_MODULE_0_loglevel__["setLevel"](__WEBPACK_IMPORTED_MODULE_0_loglevel__["levels"].ERROR);}else{logger.setLevel(logger.levels.DEBUG);}// export main logging object for use by app
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_loglevel__);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = floatToMoney;
/* harmony export (immutable) */ __webpack_exports__["c"] = stringToMoney;
/* harmony export (immutable) */ __webpack_exports__["b"] = moneyToString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_exact_math__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_exact_math___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_exact_math__);
/**
 * @module lib/money
 * Utilities for parsing and formatting monetary amounts.
 * NB: The number 1 represents a single unit of the smallest denomination
 * e.g. "£1.23" is stored as 123 and NOT 1.23
 *//**
 * Convert a floating-poitn representation of money
 *   to our integer-based format.
 *
 * @param {number} float amount as float, e.g. 1.23
 * @returns {number} amount as integer, e.g. 123
 */function floatToMoney(float){if(float===undefined||float===null){return null;}return __WEBPACK_IMPORTED_MODULE_0_exact_math___default.a.mul(float,100);}/**
 * Parse a string into an amount of money
 * null value will be passed straight back without parsing
 * Intended for parsing NULL-able fields in API responses
 *
 * @param {string|null} [string]
 * @returns {number|null} may be NaN if parsing failed
 */function stringToMoney(string){if(string===null||string===""){return null;}return floatToMoney(parseFloat(string));}/**
 * Format an amount of money as a string
 *
 * @param {number} money
 * @returns {string} money to string with 2dp, or "NaN"
 */function moneyToString(money){// convert from pence to pounds and round to 2 d.p.
return __WEBPACK_IMPORTED_MODULE_0_exact_math___default.a.div(money,100).toFixed(2);}

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Modal__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Dialog__ = __webpack_require__(432);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalDialog=function(_React$Component){_inherits(ModalDialog,_React$Component);function ModalDialog(){_classCallCheck(this,ModalDialog);return _possibleConstructorReturn(this,(ModalDialog.__proto__||Object.getPrototypeOf(ModalDialog)).apply(this,arguments));}_createClass(ModalDialog,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Modal__["a" /* default */],{isOpen:this.props.isOpen,fitScreen:this.props.fitScreen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Dialog__["a" /* default */],{fitScreen:this.props.fitScreen},this.props.children));}}]);return ModalDialog;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ModalDialog.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,fitScreen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};ModalDialog.defaultProps={fitScreen:false};/* harmony default export */ __webpack_exports__["a"] = (ModalDialog);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export KeyValueListLengthMismatchError */
/* harmony export (immutable) */ __webpack_exports__["b"] = mapArrayToEntity;
/* unused harmony export listToMap */
/* harmony export (immutable) */ __webpack_exports__["a"] = arrayToEntityMap;
/* unused harmony export pruneImmutable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * @module lib/data
 * library functions for transforming data
 */var KeyValueListLengthMismatchError=function(_Error){_inherits(KeyValueListLengthMismatchError,_Error);function KeyValueListLengthMismatchError(keyList,valueList){_classCallCheck(this,KeyValueListLengthMismatchError);var _this=_possibleConstructorReturn(this,(KeyValueListLengthMismatchError.__proto__||Object.getPrototypeOf(KeyValueListLengthMismatchError)).call(this,"Length mismatch on keyList("+keyList.length+")/valueList("+valueList.length+")"));_this.keyList=keyList;_this.valueList=valueList;_this.type=KeyValueListLengthMismatchError.type;return _this;}// TODO: this is duck-typing, because babel is broken
return KeyValueListLengthMismatchError;}(Error);/**
  * mapArrayToEntity - Convert an array to an object by mapping indexes to keys
  *
  * @param  {Array} keyList   maps indeces from valueArray to property names on the returned object e.g. ["id", "name"]
  * @param  {Array} valueList list of values to be mapped ["2632", "Test"]
  * @returns {Object}         entity object
  */KeyValueListLengthMismatchError.type="KeyValueListLengthMismatchError";function mapArrayToEntity(keyList,valueList){if(keyList.length!==valueList.length){throw new KeyValueListLengthMismatchError(keyList,valueList);}// Loop through the key/value lists and map each value in the target object
var targetEntity={};for(var i=0;i<keyList.length;i=i+1){var keyName=keyList[i];var value=valueList[i];targetEntity[keyName]=value;}return targetEntity;}/**
 * Convert a List to an OrderedMap using the given keyMapper function.
 * @param {Function} keyMapper maps a value to its key
 * @param {Immutable~List} list
 * @returns {Immutable~OrderedMap}
 */function listToMap(keyMapper,list){return list.reduce(function(map,listItem,index){var key=keyMapper(listItem,index);return map.set(key,listItem);},new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.OrderedMap());}/**
 * Create a Map from an Array using the gievn entityMapper and keyMapper
 * @param {Function} entityMapper maps list items to entities
 * @param {Function} keyMapper maps a value to its key
 * @param {Array} list
 * @returns {Immutable~OrderedMap}
 */function arrayToEntityMap(entityMapper,keyMapper,list){return listToMap(keyMapper,list.map(entityMapper));}/**
 * pruneImmutable - Delete a key from an immutable collection, and then delete
 *   all of that key's empty ancestors
 *
 * @param {Immutable.Collection} immutable - the immutable object to delete from
 * @param {Array<string>} keyPath - Immutable keyPath of the target key (used for deleteIn)
 * @param {number} [minDepth] - optional, index in keyPath at which to stop traversing
 * @returns {Immutable.Collection} a new immutable collection of the same type
 */function pruneImmutable(immutable,keyPath,minDepth){// copy keyPath so we can pop without side effects
keyPath=keyPath.slice(0);// do..while since we always want to delete the leaf on the first iteration
do{immutable=immutable.deleteIn(keyPath);// move to the parent
keyPath.pop();// if the parent is empty then continue deleting
// exit condition when we reach minDepth
}while(immutable.getIn(keyPath).isEmpty()&&keyPath.length>minDepth);return immutable;}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_format__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Default date component
 * props -
 * date: must be a moment.js-parsable date. String or object is standard!
 *
 */var Date=function(_React$PureComponent){_inherits(Date,_React$PureComponent);function Date(){_classCallCheck(this,Date);return _possibleConstructorReturn(this,(Date.__proto__||Object.getPrototypeOf(Date)).apply(this,arguments));}_createClass(Date,[{key:"render",value:function render(){var formattedDate=Object(__WEBPACK_IMPORTED_MODULE_2_lib_format__["a" /* formatLongDate */])(this.props.date);return formattedDate;}}]);return Date;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);Date.propTypes={date:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Date);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Card_css__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Card_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Card_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CardBody=function(_Component){_inherits(CardBody,_Component);function CardBody(){_classCallCheck(this,CardBody);return _possibleConstructorReturn(this,(CardBody.__proto__||Object.getPrototypeOf(CardBody)).apply(this,arguments));}_createClass(CardBody,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card__body"},this.props.children);}}]);return CardBody;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Card=function(_Component2){_inherits(Card,_Component2);function Card(){_classCallCheck(this,Card);return _possibleConstructorReturn(this,(Card.__proto__||Object.getPrototypeOf(Card)).apply(this,arguments));}_createClass(Card,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card"},this.props.children);}}]);return Card;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Card.Body=CardBody;/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return sym; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TASK; });
/* unused harmony export HELPER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAGA_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELF_CANCELLATION; });
/* unused harmony export konst */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return kTrue; });
/* unused harmony export kFalse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ident; });
/* harmony export (immutable) */ __webpack_exports__["g"] = check;
/* unused harmony export hasOwn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return is; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return object; });
/* harmony export (immutable) */ __webpack_exports__["t"] = remove;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return array; });
/* harmony export (immutable) */ __webpack_exports__["i"] = deferred;
/* unused harmony export arrayOfDeffered */
/* harmony export (immutable) */ __webpack_exports__["j"] = delay;
/* unused harmony export createMockTask */
/* unused harmony export autoInc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return uid; });
/* harmony export (immutable) */ __webpack_exports__["q"] = makeIterator;
/* harmony export (immutable) */ __webpack_exports__["p"] = log;
/* harmony export (immutable) */ __webpack_exports__["k"] = deprecate;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return updateIncentive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return internalErr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createSetContextWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return wrapSagaDispatch; });
/* unused harmony export cloneableGenerator */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var sym = function sym(id) {
  return '@@redux-saga/' + id;
};

var TASK = /*#__PURE__*/sym('TASK');
var HELPER = /*#__PURE__*/sym('HELPER');
var MATCH = /*#__PURE__*/sym('MATCH');
var CANCEL = /*#__PURE__*/sym('CANCEL_PROMISE');
var SAGA_ACTION = /*#__PURE__*/sym('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/sym('SELF_CANCELLATION');
var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue = /*#__PURE__*/konst(true);
var kFalse = /*#__PURE__*/konst(false);
var noop = function noop() {};
var ident = function ident(v) {
  return v;
};

function check(value, predicate, error) {
  if (!predicate(value)) {
    log('error', 'uncaught at check', error);
    throw new Error(error);
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(object, property) {
  return is.notUndef(object) && hasOwnProperty.call(object, property);
}

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  },
  iterator: function iterator(it) {
    return it && is.func(it.next) && is.func(it.throw);
  },
  iterable: function iterable(it) {
    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
  },
  task: function task(t) {
    return t && t[TASK];
  },
  observable: function observable(ob) {
    return ob && is.func(ob.subscribe);
  },
  buffer: function buffer(buf) {
    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
  },
  pattern: function pattern(pat) {
    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
  },
  channel: function channel(ch) {
    return ch && is.func(ch.take) && is.func(ch.close);
  },
  helper: function helper(it) {
    return it && it[HELPER];
  },
  stringableFunc: function stringableFunc(f) {
    return is.func(f) && hasOwn(f, 'toString');
  }
};

var object = {
  assign: function assign(target, source) {
    for (var i in source) {
      if (hasOwn(source, i)) {
        target[i] = source[i];
      }
    }
  }
};

function remove(array, item) {
  var index = array.indexOf(item);
  if (index >= 0) {
    array.splice(index, 1);
  }
}

var array = {
  from: function from(obj) {
    var arr = Array(obj.length);
    for (var i in obj) {
      if (hasOwn(obj, i)) {
        arr[i] = obj[i];
      }
    }
    return arr;
  }
};

function deferred() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var def = _extends({}, props);
  var promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  def.promise = promise;
  return def;
}

function arrayOfDeffered(length) {
  var arr = [];
  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }
  return arr;
}

function delay(ms) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var timeoutId = void 0;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve(val);
    }, ms);
  });

  promise[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return promise;
}

function createMockTask() {
  var _ref;

  var running = true;
  var _result = void 0,
      _error = void 0;

  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
    return running;
  }, _ref.result = function result() {
    return _result;
  }, _ref.error = function error() {
    return _error;
  }, _ref.setRunning = function setRunning(b) {
    return running = b;
  }, _ref.setResult = function setResult(r) {
    return _result = r;
  }, _ref.setError = function setError(e) {
    return _error = e;
  }, _ref;
}

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

var uid = /*#__PURE__*/autoInc();

var kThrow = function kThrow(err) {
  throw err;
};
var kReturn = function kReturn(value) {
  return { value: value, done: true };
};
function makeIterator(next) {
  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var isHelper = arguments[3];

  var iterator = { name: name, next: next, throw: thro, return: kReturn };

  if (isHelper) {
    iterator[HELPER] = true;
  }
  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }
  return iterator;
}

/**
  Print error in a useful way whether in a browser environment
  (with expandable error stack traces), or in a node.js environment
  (text-only log output)
 **/
function log(level, message) {
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  /*eslint-disable no-console*/
  if (typeof window === 'undefined') {
    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
  } else {
    console[level](message, error);
  }
}

function deprecate(fn, deprecationWarning) {
  return function () {
    if (false) log('warn', deprecationWarning);
    return fn.apply(undefined, arguments);
  };
}

var updateIncentive = function updateIncentive(deprecated, preferred) {
  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
};

var internalErr = function internalErr(err) {
  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
};

var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
};

var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
  };
};

var cloneableGenerator = function cloneableGenerator(generatorFunc) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var history = [];
    var gen = generatorFunc.apply(undefined, args);
    return {
      next: function next(arg) {
        history.push(arg);
        return gen.next(arg);
      },
      clone: function clone() {
        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
        history.forEach(function (arg) {
          return clonedGen.next(arg);
        });
        return clonedGen;
      },
      return: function _return(value) {
        return gen.return(value);
      },
      throw: function _throw(exception) {
        return gen.throw(exception);
      }
    };
  };
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(152);
var isBuffer = __webpack_require__(292);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = isStringEmpty;
/* harmony export (immutable) */ __webpack_exports__["a"] = doStringsMatch;
/* harmony export (immutable) */ __webpack_exports__["e"] = isProductAvailable;
/* harmony export (immutable) */ __webpack_exports__["c"] = isAppserverOnline;
/* harmony export (immutable) */ __webpack_exports__["d"] = isLogoPathValid;
/* harmony export (immutable) */ __webpack_exports__["b"] = hasTimePassed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/**
 * @module lib/validate
 * Utils for basic input validation.
 *//**
 * Check if the given string is empty.
 * Whitespace counst as empty.
 */function isStringEmpty(string){return string.trim().length===0;}/**
 * Check if two strings are the same.
 * Ignores case and leading/trailing whitespace.
 */function doStringsMatch(string1,string2){return string1.trim().toLowerCase()===string2.trim().toLowerCase();}/**
 * Check if given product is going through maintainenace/downtime
 */function isProductAvailable(product){var currentDateTime=new __WEBPACK_IMPORTED_MODULE_0_moment___default.a();if(product==="school_money"){if(currentDateTime>=new __WEBPACK_IMPORTED_MODULE_0_moment___default.a("2023-11-13 17:50")&&currentDateTime<=new __WEBPACK_IMPORTED_MODULE_0_moment___default.a("2023-11-13 18:40")){return false;}}else if(product==="teachers"){if(currentDateTime>=new __WEBPACK_IMPORTED_MODULE_0_moment___default.a("2021-12-08 10:10")&&currentDateTime<=new __WEBPACK_IMPORTED_MODULE_0_moment___default.a("2021-12-08 11:00")){return false;}}return true;}/**
 * Check if appserver is available
 */function isAppserverOnline(){var currentDateTime=new __WEBPACK_IMPORTED_MODULE_0_moment___default.a();if(currentDateTime>=new __WEBPACK_IMPORTED_MODULE_0_moment___default.a("2025-12-18 10:30")&&currentDateTime<=new __WEBPACK_IMPORTED_MODULE_0_moment___default.a("2025-12-18 11:00")){return false;}return true;}/**
 * Checks if given path has one of valid extentions
 */function isLogoPathValid(path){var validExtentionList=[".jpg",".jpeg",".gif",".png"];return validExtentionList.some(function(element){return path.endsWith(element);});};/**
 * Check if the given time is past the current time
 */function hasTimePassed(giveDate){var currentDateTime=new __WEBPACK_IMPORTED_MODULE_0_moment___default.a();if(currentDateTime>new __WEBPACK_IMPORTED_MODULE_0_moment___default.a(giveDate)){return true;}return false;}

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export now */
/* harmony export (immutable) */ __webpack_exports__["c"] = nowString;
/* unused harmony export addDays */
/* unused harmony export getDayDiff */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WEEKDAYS; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isDatePast;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/**
 * @module lib/date
 * Utilities for working with dates.
 * Heavily relies on [Moment.js]{@link https://momentjs.com/}.
 */function now(){return new __WEBPACK_IMPORTED_MODULE_0_moment___default.a();}function nowString(){return now().unix();}/**
 * Work out the date n days after the given date
 *
 * @param {moment-compatible-date} startDate
 * @param {number} dayCount
 * @returns {Date}
 */function addDays(startDate,dayCount){return __WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate).add(dayCount,"days").toDate();}/**
 * Work out the number of days between two dates
 
 * @param {moment-compatible-date} firstDate
 * @param {moment-compatible-date} secondDate
 * @returns {number}
 */function getDayDiff(firstDate,secondDate){return __WEBPACK_IMPORTED_MODULE_0_moment___default()(firstDate).diff(secondDate,"days");}/**
 * Array of the days of the week (convenient for iterating over)
 */var WEEKDAYS=["Monday","Tuesday","Wednesday","Thursday","Friday"];/**
 * Check if the given date is earlier than today
 *
 * @param {moment-compatible-date} date
 * @returns {boolean}
 */function isDatePast(date){return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).isBefore(__WEBPACK_IMPORTED_MODULE_0_moment___default()(),"day");}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Gate=function(_React$Component){_inherits(Gate,_React$Component);function Gate(){_classCallCheck(this,Gate);return _possibleConstructorReturn(this,(Gate.__proto__||Object.getPrototypeOf(Gate)).apply(this,arguments));}_createClass(Gate,[{key:"render",value:function render(){if(this.props.isOpen){return this.props.children;}else{return this.props.placeholder;}}}]);return Gate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Gate.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};Gate.defaultProps={placeholder:null};/* harmony default export */ __webpack_exports__["a"] = (Gate);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(124);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(127);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(93);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(70);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(131);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__matchPath__ = __webpack_require__(72);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withRouter__ = __webpack_require__(133);
/* unused harmony reexport withRouter */



















/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(436);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(438);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(170);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(440);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(441);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(442);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(443);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(171);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(102);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(444);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(445);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(446);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(447);
/* unused harmony reexport withRouter */



























/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_animate_height__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_animate_height___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_animate_height__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ExpandingBox_css__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ExpandingBox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ExpandingBox_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// in milliseconds
var ANIMATION_DURATION=200;/**
 * Two reasons for these components:
 * - We can search props.children for these component types
 * - We can control the onClick behaviour of the header and body separately
 */var ExpandingBoxHeader=function(_Component){_inherits(ExpandingBoxHeader,_Component);function ExpandingBoxHeader(){_classCallCheck(this,ExpandingBoxHeader);return _possibleConstructorReturn(this,(ExpandingBoxHeader.__proto__||Object.getPrototypeOf(ExpandingBoxHeader)).apply(this,arguments));}_createClass(ExpandingBoxHeader,[{key:"render",value:function render(){var _props=this.props,toggleOnClick=_props.toggleOnClick,onClick=_props.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{onClick:toggleOnClick?onClick:undefined},this.props.children);}}]);return ExpandingBoxHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ExpandingBoxHeader.propTypes={toggleOnClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool// don't validate the onClick prop since it's not "public"
};ExpandingBoxHeader.defaultProps={toggleOnClick:true};var ExpandingBoxBody=function(_Component2){_inherits(ExpandingBoxBody,_Component2);function ExpandingBoxBody(){_classCallCheck(this,ExpandingBoxBody);return _possibleConstructorReturn(this,(ExpandingBoxBody.__proto__||Object.getPrototypeOf(ExpandingBoxBody)).apply(this,arguments));}_createClass(ExpandingBoxBody,[{key:"render",value:function render(){var _props2=this.props,toggleOnClick=_props2.toggleOnClick,onClick=_props2.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{onClick:toggleOnClick?onClick:undefined},this.props.children);}}]);return ExpandingBoxBody;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/**
 * Wraps a header and a body, and allows toggling the body in and out
 * Props override state, so if you are controlling the expansion externally, use the expanded prop
 * Otherwise, it can track its own state.
 */ExpandingBoxBody.propTypes={toggleOnClick:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};ExpandingBoxBody.defaultProps={toggleOnClick:false};var ExpandingBox=function(_Component3){_inherits(ExpandingBox,_Component3);function ExpandingBox(){var _ref;var _temp,_this3,_ret;_classCallCheck(this,ExpandingBox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this3=_possibleConstructorReturn(this,(_ref=ExpandingBox.__proto__||Object.getPrototypeOf(ExpandingBox)).call.apply(_ref,[this].concat(args))),_this3),_this3.state={expanded:false},_this3.expand=function(){_this3.setState({expanded:true});_this3.props.onExpand();},_this3.collapse=function(){_this3.setState({expanded:false});_this3.props.onCollapse();},_temp),_possibleConstructorReturn(_this3,_ret);}_createClass(ExpandingBox,[{key:"render",value:function render(){var _props3=this.props,cssModifier=_props3.cssModifier,children=_props3.children;var expanded=this.state.expanded;var currentStatus=expanded?"expanded":"collapsed";var bodyHeight=expanded?"auto":"0";var onClick=expanded?this.collapse:this.expand;// Find the Header and Body sub-components from the children
var header=children.filter(function(child){return child.type===ExpandingBoxHeader;})[0];var body=children.filter(function(child){return child.type===ExpandingBoxBody;})[0];// Combine default classes with custom modifiers
var classNames=["expanding-box","expanding-box--"+currentStatus];if(cssModifier!==undefined){classNames.push("expanding-box--"+cssModifier);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Card__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Card__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(header,{onClick:onClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_animate_height___default.a,{duration:ANIMATION_DURATION,height:bodyHeight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(body,{onClick:onClick}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"expanding-box__expander",onClick:onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"expanding-box__arrow"}))));}}],[{key:"getDerivedStateFromProps",/**
   * Allow props.expanded to override state.expanded
   * If no `expanded` prop was provided then we leave the state alone
   * This prevents cases where a re-render would cause the box to collapse even
   *   when the `expanded` prop was not being used
   */value:function getDerivedStateFromProps(nextProps){var expanded=nextProps.expanded;if(expanded!==undefined){return{expanded:expanded};}return null;}}]);return ExpandingBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ExpandingBox.Header=ExpandingBoxHeader;ExpandingBox.Body=ExpandingBoxBody;ExpandingBox.propTypes={children:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,onExpand:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,onCollapse:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,cssModifier:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,expanded:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool};ExpandingBox.defaultProps={onExpand:function onExpand(){return undefined;},onCollapse:function onCollapse(){return undefined;}};/* harmony default export */ __webpack_exports__["a"] = (ExpandingBox);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__List_css__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__List_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__List_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Display a list of children, or a placeholder if the list is empty.
 * Also allows for reversing the display order of the children.
 */var List=function(_React$Component){_inherits(List,_React$Component);function List(){_classCallCheck(this,List);return _possibleConstructorReturn(this,(List.__proto__||Object.getPrototypeOf(List)).apply(this,arguments));}_createClass(List,[{key:"hasChildren",value:function hasChildren(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(this.props.children)>0;}},{key:"getClassNames",value:function getClassNames(){var _this2=this;var classNames=["list"];if(this.props.className!==undefined){classNames.push(this.props.className);}return classNames.reduce(function(classNames,className){classNames.push(className);classNames.push(_this2.hasChildren()?className+"--non-empty":className+"--empty");classNames.push(_this2.props.reversed?className+"--reversed":className+"--non-reversed");return classNames;},[]);}},{key:"render",value:function render(){var _props=this.props,children=_props.children,placeholder=_props.placeholder;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:this.getClassNames().join(" ")},this.hasChildren()?children:placeholder);}}]);return List;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);List.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node)]).isRequired,/**
     * Will be displayed if no children are passed.
     */placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,/**
     * If true, children will be shown in reverse order.
     * Scrolling will also start from the bottom rather than the top.
     */reversed:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};List.defaultProps={placeholder:null,reversed:false};/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = saveSchoolMoneyLocalStoreData;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSchoolMoneyLocalStoreData;
/* harmony export (immutable) */ __webpack_exports__["b"] = getLocalStoreMobileNumber;
/* harmony export (immutable) */ __webpack_exports__["a"] = clearData;
/* harmony export (immutable) */ __webpack_exports__["e"] = validateLocalStoreStructure;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_log__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lz_string__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lz_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lz_string__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var API_DATA_LOCALSTORAGE_KEY_NAME="app_data";var LOCALSTORAGE_TEMPLATE={"school_money":{"school":null,"student":null,"parent":null,"active_payment":null,"shop":null},"last_fetch_date":{"school_money":{"school":null,"student":null,"parent":null,"active_payment":null,"shop":null}},"user_details":{"mobile_number":getMobileNumber()}};function createLocalStore(){try{var storeData=Object(__WEBPACK_IMPORTED_MODULE_3_lz_string__["compressToUTF16"])(JSON.stringify(LOCALSTORAGE_TEMPLATE));localStorage.setItem(API_DATA_LOCALSTORAGE_KEY_NAME,storeData);}catch(error){__WEBPACK_IMPORTED_MODULE_0_lib_log__["a" /* default */].error("Unable to save state to local storage:",error);}}function getMobileNumber(){var urlArgs=__WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(window.location.search);// Get mobile number from local env if url args doesnt have mobile number
return urlArgs.mobile_number===undefined?Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_KEY":"teachers_1","REACT_APP_CUSTOMER_NOTICES_END_TIME":"2025-12-18 12:19:59","REACT_APP_EDUSPOT_DOWN_TIME_START":"2025-12-18 10:30","REACT_APP_SCHOOLMONEY_DOWN_TIME_END":"2023-11-13 18:40","REACT_APP_SECURE_TRADING_XPRESSIONS_APPLE_PAY_MERCHANT_ID":"merchant.com.groupcall.emerge.parental.req","REACT_APP_SECURE_TRADING_GOOGLE_PAY_MERCHANT_ID":"BCR2DN4T7DZYVHSW","REACT_APP_TEACHERS2PARENTS_APP_REFERRER":"teachers","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_CUSTOMER_NOTICES_KEY":"app_2","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_START":"2021-12-08 10:10","REACT_APP_SECURE_TRADING_INITIATOR":"public","REACT_APP_XPRESSIONS_APP_REFERRER":"xpressions","REACT_APP_EDUSPOT_DOWN_TIME_END":"2025-12-18 11:00","REACT_APP_PAYSAFE_ENVIRONMENT":"LIVE","REACT_APP_SECURE_TRADING_3DS_LIVESTATUS":"0","REACT_APP_SECURE_TRADING_PAYMENT_MODE":"TEST","REACT_APP_SECURE_TRADING_3DS_TERMURL":"/public/appserver/product_resources/school_money/secure_trading/sm_app_threeds_response.html","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_KEY":"schoolmoney_1","REACT_APP_EDUSPOT_LOCAL_HOSTNAME":"uat-appserver.teachers2parents.co.uk","REACT_APP_PAYSAFE_API_KEY":"T1QtOTMyMTpCLXAxLTAtNWIwNDFiN2QtMC0zMDJjMDIxNDRkZGY4N2YwNDM4ZWRlY2YzYWMzYzYzNTlhYjQ2YmE5NDlkYmU4Y2EwMjE0MGJiOTJiNGQxNjU4ZTdmZWFmOGQ2ZGFiYjcxNmIyMTY1MmZhMDVmMQ==","REACT_APP_PARENTAPPS_APP_REFERRER":"parentapps","REACT_APP_SCHOOLMONEY_APP_NAME":"schoolmoney","REACT_APP_SECURE_TRADING_SECRET_TOKEN":"app","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_END":"2021-12-08 11:00","REACT_APP_SCHOOLMONEY_DOWN_TIME_START":"2023-11-13 17:50","REACT_APP_TEACHERS2PARENTS_LOCAL_HOSTNAME":"edspapitesting.teachers2parents.co.uk","REACT_APP_SECURE_TRADING_SITE_REFERENCE":"test_smartthreedtwo83732","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_EDUSPOT_APP_NAME":"eduspot","REACT_APP_PACKAGE_VERSION":"2.82.0","REACT_APP_SECURE_TRADING_SCHOOL_MONEY_APPLE_PAY_MERCHANT_ID":"merchant.schoolmoney.dev"}).REACT_APP_MOBILE_NUMBER:urlArgs.mobile_number;}function getLocalStoreData(){return localStorage.getItem(API_DATA_LOCALSTORAGE_KEY_NAME);}function getData(productKey,dataKey){var localStoreData=getLocalStoreData();// Check if we have data in local storage
if(localStoreData===null){return undefined;}try{var storeData=JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_3_lz_string__["decompressFromUTF16"])(localStoreData));if(storeData[productKey]===undefined){return undefined;}if(storeData[productKey][dataKey]===undefined){return undefined;}return storeData[productKey][dataKey];}catch(error){__WEBPACK_IMPORTED_MODULE_0_lib_log__["a" /* default */].error("Unable to get state local store data:",error);return undefined;}}function saveLocalStoreData(productKey,dataKey,data){// Check if we have data in local storage
if(getLocalStoreData()===null){createLocalStore();}var localStoreData=getLocalStoreData();localStoreData=JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_3_lz_string__["decompressFromUTF16"])(localStoreData));localStoreData[productKey][dataKey]=data;localStoreData["last_fetch_date"][productKey][dataKey]=__WEBPACK_IMPORTED_MODULE_1_moment___default()().format();localStorage.setItem(API_DATA_LOCALSTORAGE_KEY_NAME,Object(__WEBPACK_IMPORTED_MODULE_3_lz_string__["compressToUTF16"])(JSON.stringify(localStoreData)));}function getLastFetchDate(productKey,dataKey){// Check if we have data in local storage
if(getLocalStoreData()===null){return null;}var localStoreData=JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_3_lz_string__["decompressFromUTF16"])(getLocalStoreData()));return localStoreData["last_fetch_date"][productKey][dataKey];}function getSchoolMoneyLastFecthDate(dataKey){return getLastFetchDate("school_money",dataKey);}function saveSchoolMoneyLocalStoreData(dataKey,data){saveLocalStoreData("school_money",dataKey,data);}function getSchoolMoneyLocalStoreData(dataKey){var lastFetchDate=getSchoolMoneyLastFecthDate(dataKey);if(lastFetchDate===null){return undefined;}switch(dataKey){case"school":return getSchoolLocalStoreData("school_money",dataKey,lastFetchDate);case"student":return getStudentLocalStoreData("school_money",dataKey,lastFetchDate);case"parent":return getParentLocalStoreData("school_money",dataKey,lastFetchDate);case"active_payment":return getActivePaymentLocalStoreData("school_money",dataKey,lastFetchDate);case"shop":return getShopLocalStoreData("school_money",dataKey,lastFetchDate);default:return undefined;}}function getSchoolLocalStoreData(productKey,dataKey,lastFetchDate){// School data should refresh once a day
if(__WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(lastFetchDate,"days")>=1){return undefined;}return getData(productKey,dataKey);}function getStudentLocalStoreData(productKey,dataKey,lastFetchDate){// Student data should refresh instantly
if(__WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(lastFetchDate,"seconds")>=1){return undefined;}return getData(productKey,dataKey);}function getParentLocalStoreData(productKey,dataKey,lastFetchDate){// Parent email address data should be updated once a week
if(__WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(lastFetchDate,"days")>=7){return undefined;}return getData(productKey,dataKey);}function getActivePaymentLocalStoreData(productKey,dataKey,lastFetchDate){// Payment data should be refreshed instantly
if(__WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(lastFetchDate,"seconds")>=1){return undefined;}return getData(productKey,dataKey);}function getShopLocalStoreData(productKey,dataKey,lastFetchDate){// Shop data should be refreshed instantly
if(__WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(lastFetchDate,"seconds")>=1){return undefined;}return getData(productKey,dataKey);}function getUserDetails(dataKey){try{if(getLocalStoreData()===null){return undefined;}var localStoreData=JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_3_lz_string__["decompressFromUTF16"])(getLocalStoreData()));var createNewStore=false;// Check if we have data in local storage
if(localStoreData===null||localStoreData["user_details"]===undefined){createNewStore=true;}if(!createNewStore&&localStoreData["user_details"][dataKey]===undefined){createNewStore=true;}if(createNewStore){clearData();createLocalStore();localStoreData=JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_3_lz_string__["decompressFromUTF16"])(getLocalStoreData()));}return localStoreData["user_details"][dataKey];}catch(error){__WEBPACK_IMPORTED_MODULE_0_lib_log__["a" /* default */].error("Unable to get state local store data:",error);return undefined;}}function getLocalStoreMobileNumber(){return getUserDetails("mobile_number");}function clearData(){localStorage.removeItem(API_DATA_LOCALSTORAGE_KEY_NAME);}// Recreate the local store if the structure has changed
function validateLocalStoreStructure(){// Clear the old unused key in local store
localStorage.removeItem("t2p_app_data");// Do nothing if local store is empty
if(getLocalStoreData()===null){return;}var localStoreData=JSON.parse(Object(__WEBPACK_IMPORTED_MODULE_3_lz_string__["decompressFromUTF16"])(getLocalStoreData()));var localStoreTemplateKeys=Object.keys(LOCALSTORAGE_TEMPLATE).sort();var localStoreDatateKeys=Object.keys(localStoreData).sort();// If the keys don't match then clear the local store
if(!doesObjectStructureMatch(LOCALSTORAGE_TEMPLATE,localStoreData)){clearData();return;}parentLoop:for(var i=0;i<localStoreTemplateKeys.length;i=i+1){var templateChildKeys=Object.keys(LOCALSTORAGE_TEMPLATE[localStoreTemplateKeys[i]]).sort();var dataChildKeys=Object.keys(localStoreData[localStoreDatateKeys[i]]).sort();for(var j=0;j<templateChildKeys.length;j=j+1){if(LOCALSTORAGE_TEMPLATE[localStoreTemplateKeys[i]][templateChildKeys[j]]!==null&&_typeof(LOCALSTORAGE_TEMPLATE[localStoreTemplateKeys[i]][templateChildKeys[j]])==="object"){if(!doesObjectStructureMatch(LOCALSTORAGE_TEMPLATE[localStoreTemplateKeys[i]][templateChildKeys[j]],localStoreData[localStoreDatateKeys[i]][dataChildKeys[j]])){clearData();break parentLoop;}}}}}function doesObjectStructureMatch(localStoreTemplate,localStoreData){var dataKeys=Object.keys(localStoreData).sort();var templateChildKeys=Object.keys(localStoreTemplate).sort();if(dataKeys.join("")!==templateChildKeys.join("")){return false;}return true;}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return globalLocale;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
        else {
            if ((typeof console !==  'undefined') && console.warn) {
                //warn user if arguments are passed but the locale could not be set
                console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
            }
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var locale, parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                locale = loadLocale(config.parentLocale);
                if (locale != null) {
                    parentConfig = locale._config;
                } else {
                    if (!localeFamilies[config.parentLocale]) {
                        localeFamilies[config.parentLocale] = [];
                    }
                    localeFamilies[config.parentLocale].push({
                        name: name,
                        config: config
                    });
                    return null;
                }
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, expectedWeekday, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString(keepOffset) {
    if (!this.isValid()) {
        return null;
    }
    var utc = keepOffset !== true;
    var m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        if (utc) {
            return this.toDate().toISOString();
        } else {
            return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
    }
    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;
proto.quarter = proto.quarters = getSetQuarter;
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;
proto.hour = proto.hours = getSetHour;
proto.minute = proto.minutes = getSetMinute;
proto.second = proto.seconds = getSetSecond;
proto.millisecond = proto.milliseconds = getSetMillisecond;
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports

hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.21.0';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

// currently HTML5 input type only supports 24-hour formats
hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',                             // <input type="date" />
    TIME: 'HH:mm',                                  // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
    MONTH: 'YYYY-MM'                                // <input type="month" />
};

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(314)(module)))

/***/ }),
/* 36 */
/***/ (function(module, exports) {

var exactMath = {
	add: function(){
		return mathFunctions.addSubDiv(arguments,0);
	},
	sub: function(){
		return mathFunctions.addSubDiv(arguments,1);
	},
	mul: function(){
		return mathFunctions.mul(arguments);
	},
	div: function(){
		return mathFunctions.addSubDiv(arguments,3);
	}
};

var mathFunctions = {
	addSubDiv: function(argArray,oper){
		var args = this.countDecimals(this.validMe(argArray));
		var hComma = this.biggestComma(args);
		var shifted = oper !== 3 ? hComma:0;
		var res = this.shiftComma(this.countResult(this.toExponent(args,hComma),oper),shifted);
		this.isSafeInteger(res);
		return res;
	},
	mul: function(argArray){
		var args = this.countDecimals(this.validMe(argArray));
		var intArr = [];
		var commaSum = 0;
		for (var i in args){
			commaSum += args[i].comma;
			intArr.push(args[i].integer);
		}
		return this.shiftComma(this.countResult(intArr,2),commaSum);
	},
	isSafeInteger: function(result){
		if(result<=-(Math.pow(2,53)-1)||result>=(Math.pow(2,53)-1)) throw "The result is not a safe integer.";
	},
	shiftComma: function(result,commaPos){
		return this.toExponent(this.countDecimals([result]),-commaPos)[0];
	},
	countResult: function(nums,operation){
		var result = nums[0];
		for(var i=1;i<nums.length;i++){
			switch(operation){
				case 0:
					result += nums[i];
					break;
				case 1:
					result -= nums[i];
					break;
				case 2:
					result *= nums[i];
					break;
				case 3:
					result /= nums[i];
					break;
			}
		}
		return result;
	},
	toExponent: function(args,commaPos){
		var returned = [];
		for(var i in args){
			args[i].comma -= commaPos;
			var sign = args[i].comma>=0 ? "+":"";
			returned.push(Number(args[i].integer.toString()+"e"+sign+args[i].comma));
		}
		return returned;
	},
	biggestComma: function(args){
		var commaAr = [];
		for(var i in args){
			commaAr.push(args[i].comma);
		}
		return Math.min.apply(null,commaAr);
	},
	validMe: function(args){
		if(args.length<2) throw "Set at least two numerical values.";
		for(var i in args){
			args[i] = parseFloat(args[i]);
			if(typeof args[i] !== "number" || isNaN(args[i])) throw "Every smMath argument must be of type number.";
			if(args[i] === Number.POSITIVE_INFINITY || args[i] === Number.NEGATIVE_INFINITY) throw "Every smMath argument must be a numerical value between positive and negative Infinity.";
		}
		return args;
	},
	countDecimals: function(args){
		var decimals = [];
		for(var i in args){
			var partDec = 0;
			var splitted = args[i].toString().split("e");
			var commaPos = splitted[0].indexOf(".");
			partDec -= commaPos !== -1 ? splitted[0].length - 1 - commaPos:0;
			partDec += isNaN(Number(splitted[1])) ? 0:Number(splitted[1]);
			splitted[0] = Number(splitted[0].replace(".",""));
			decimals.push({integer:splitted[0],comma:partDec});
		}
		return decimals;
	}
};

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports) {
  module.exports = exactMath;
}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Gate__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_LoadingPage__ = __webpack_require__(59);
var ConnectedPreloader=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_108" /* isSchoolsReady */])(state)&&Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_111" /* isStudentsReady */])(state)&&ownProps.isPageReady(state)};})(__WEBPACK_IMPORTED_MODULE_4_components_Gate__["a" /* default */]);ConnectedPreloader.defaultProps={isPageReady:function isPageReady(state){return true;},placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_LoadingPage__["a" /* default */],null)};ConnectedPreloader.PropTypes={isPageReady:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,placeholder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (ConnectedPreloader);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export detach */
/* harmony export (immutable) */ __webpack_exports__["j"] = take;
/* unused harmony export takem */
/* harmony export (immutable) */ __webpack_exports__["g"] = put;
/* harmony export (immutable) */ __webpack_exports__["b"] = all;
/* unused harmony export race */
/* harmony export (immutable) */ __webpack_exports__["d"] = call;
/* unused harmony export apply */
/* unused harmony export cps */
/* harmony export (immutable) */ __webpack_exports__["f"] = fork;
/* harmony export (immutable) */ __webpack_exports__["i"] = spawn;
/* unused harmony export join */
/* harmony export (immutable) */ __webpack_exports__["e"] = cancel;
/* harmony export (immutable) */ __webpack_exports__["h"] = select;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionChannel;
/* unused harmony export cancelled */
/* unused harmony export flush */
/* unused harmony export getContext */
/* unused harmony export setContext */
/* harmony export (immutable) */ __webpack_exports__["k"] = takeEvery;
/* harmony export (immutable) */ __webpack_exports__["l"] = takeLatest;
/* harmony export (immutable) */ __webpack_exports__["m"] = throttle;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return asEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sagaHelpers__ = __webpack_require__(149);



var IO = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["u" /* sym */])('IO');
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';

var effect = function effect(type, payload) {
  var _ref;

  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
};

var detach = function detach(eff) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(asEffect.fork(eff), __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, 'detach(eff): argument must be a fork effect');
  eff[FORK].detached = true;
  return eff;
};

function take() {
  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';

  if (arguments.length) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(arguments[0], __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].pattern(patternOrChannel)) {
    return effect(TAKE, { pattern: patternOrChannel });
  }
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return effect(TAKE, { channel: patternOrChannel });
  }
  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
}

take.maybe = function () {
  var eff = take.apply(undefined, arguments);
  eff[TAKE].maybe = true;
  return eff;
};

var takem = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(take.maybe, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('takem', 'take.maybe'));

function put(channel, action) {
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument channel is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(action, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(channel, action): argument action is undefined');
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'put(action): argument action is undefined');
    action = channel;
    channel = null;
  }
  return effect(PUT, { channel: channel, action: action });
}

put.resolve = function () {
  var eff = put.apply(undefined, arguments);
  eff[PUT].resolve = true;
  return eff;
};

put.sync = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(put.resolve, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])('put.sync', 'put.resolve'));

function all(effects) {
  return effect(ALL, effects);
}

function race(effects) {
  return effect(RACE, effects);
}

function getFnCallDesc(meth, fn, args) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, meth + ': argument fn is undefined');

  var context = null;
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(fn)) {
    var _fn = fn;
    context = _fn[0];
    fn = _fn[1];
  } else if (fn.fn) {
    var _fn2 = fn;
    context = _fn2.context;
    fn = _fn2.fn;
  }
  if (context && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string(fn) && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(context[fn])) {
    fn = context[fn];
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(fn, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, meth + ': argument ' + fn + ' is not a function');

  return { context: context, fn: fn, args: args };
}

function call(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return effect(CALL, getFnCallDesc('call', fn, args));
}

function apply(context, fn) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
}

function cps(fn) {
  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return effect(CPS, getFnCallDesc('cps', fn, args));
}

function fork(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return effect(FORK, getFnCallDesc('fork', fn, args));
}

function spawn(fn) {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(undefined, [fn].concat(args)));
}

function join() {
  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    tasks[_key5] = arguments[_key5];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return join(t);
    }));
  }
  var task = tasks[0];
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'join(task): argument task is undefined');
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  return effect(JOIN, task);
}

function cancel() {
  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    tasks[_key6] = arguments[_key6];
  }

  if (tasks.length > 1) {
    return all(tasks.map(function (t) {
      return cancel(t);
    }));
  }
  var task = tasks[0];
  if (tasks.length === 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'cancel(task): argument task is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(task, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
  }
  return effect(CANCEL, task || __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]);
}

function select(selector) {
  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  if (arguments.length === 0) {
    selector = __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */];
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'select(selector,[...]): argument selector is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(selector, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'select(selector,[...]): argument ' + selector + ' is not a function');
  }
  return effect(SELECT, { selector: selector, args: args });
}

/**
  channel(pattern, [buffer])    => creates an event channel for store actions
**/
function actionChannel(pattern, buffer) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(pattern, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
  if (arguments.length > 1) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
  }
  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
}

function cancelled() {
  return effect(CANCELLED, {});
}

function flush(channel) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(channel, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel, 'flush(channel): argument ' + channel + ' is not valid channel');
  return effect(FLUSH, channel);
}

function getContext(prop) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(prop, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].string, 'getContext(prop): argument ' + prop + ' is not a string');
  return effect(GET_CONTEXT, prop);
}

function setContext(props) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])(null, props));
  return effect(SET_CONTEXT, props);
}

function takeEvery(patternOrChannel, worker) {
  for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
    args[_key8 - 2] = arguments[_key8];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["a" /* takeEveryHelper */], patternOrChannel, worker].concat(args));
}

function takeLatest(patternOrChannel, worker) {
  for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
    args[_key9 - 2] = arguments[_key9];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["b" /* takeLatestHelper */], patternOrChannel, worker].concat(args));
}

function throttle(ms, pattern, worker) {
  for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
    args[_key10 - 3] = arguments[_key10];
  }

  return fork.apply(undefined, [__WEBPACK_IMPORTED_MODULE_1__sagaHelpers__["c" /* throttleHelper */], ms, pattern, worker].concat(args));
}

var createAsEffectType = function createAsEffectType(type) {
  return function (effect) {
    return effect && effect[IO] && effect[type];
  };
};

var asEffect = {
  take: /*#__PURE__*/createAsEffectType(TAKE),
  put: /*#__PURE__*/createAsEffectType(PUT),
  all: /*#__PURE__*/createAsEffectType(ALL),
  race: /*#__PURE__*/createAsEffectType(RACE),
  call: /*#__PURE__*/createAsEffectType(CALL),
  cps: /*#__PURE__*/createAsEffectType(CPS),
  fork: /*#__PURE__*/createAsEffectType(FORK),
  join: /*#__PURE__*/createAsEffectType(JOIN),
  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
  select: /*#__PURE__*/createAsEffectType(SELECT),
  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
  flush: /*#__PURE__*/createAsEffectType(FLUSH),
  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
};

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = aggregateSchoolID;
/* harmony export (immutable) */ __webpack_exports__["e"] = deconstructSchoolID;
/* harmony export (immutable) */ __webpack_exports__["c"] = aggregateStudentID;
/* harmony export (immutable) */ __webpack_exports__["f"] = deconstructStudentID;
/* harmony export (immutable) */ __webpack_exports__["a"] = aggregateEntityID;
/* harmony export (immutable) */ __webpack_exports__["d"] = deconstructEntityID;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_id__ = __webpack_require__(40);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/**
* @module lib/appserver/aggregate
* Construct and deconstruct globbaly unique IDs for entities
*//**
 * @param {Object} entity
 * @param {string} entity.serverID
 * @param {string} entity.remoteSchoolID
 * @returns {string} schoolID (serverID + remoteSchoolID)
 * Get the aggregated schoolID for the given entity
 */function aggregateSchoolID(_ref){var serverID=_ref.serverID,remoteSchoolID=_ref.remoteSchoolID;return Object(__WEBPACK_IMPORTED_MODULE_0_lib_id__["a" /* aggregateID */])(serverID,remoteSchoolID);}/**
 * @param {string} schoolID
 * @returns {Object} { serverID, remoteSchoolID }
 * Get the serverID and remoteSchoolID from the given aggregated schoolID
 */function deconstructSchoolID(schoolID){var _deconstructID=Object(__WEBPACK_IMPORTED_MODULE_0_lib_id__["b" /* deconstructID */])(schoolID),_deconstructID2=_slicedToArray(_deconstructID,2),serverID=_deconstructID2[0],remoteSchoolID=_deconstructID2[1];return{serverID:serverID,remoteSchoolID:remoteSchoolID};}/**
 * @param {Object} entity
 * @param {string} entity.serverID
 * @param {string} entity.remoteSchoolID
 * @returns {string} studentID (serverID + remoteStudentID)
 * Get the aggregated studentID for the given entity
 */function aggregateStudentID(_ref2){var serverID=_ref2.serverID,remoteStudentID=_ref2.remoteStudentID;return Object(__WEBPACK_IMPORTED_MODULE_0_lib_id__["a" /* aggregateID */])(serverID,remoteStudentID);}/**
 * @param {string} studentID
 * @returns {Object} { serverID, remoteStudentID }
 * Get the serverID and remoteStudentID from the given aggregated studentID
 */function deconstructStudentID(studentID){var _deconstructID3=Object(__WEBPACK_IMPORTED_MODULE_0_lib_id__["b" /* deconstructID */])(studentID),_deconstructID4=_slicedToArray(_deconstructID3,2),serverID=_deconstructID4[0],remoteStudentID=_deconstructID4[1];return{serverID:serverID,remoteStudentID:remoteStudentID};}/**
 * @param {Object} entity
 * @param {string} entity.serverID
 * @param {string} entity.remoteID
 * @returns {string} entityID
 * Get the aggregated ID for the given entity
 */function aggregateEntityID(_ref3){var serverID=_ref3.serverID,remoteID=_ref3.remoteID;return Object(__WEBPACK_IMPORTED_MODULE_0_lib_id__["a" /* aggregateID */])(serverID,remoteID);}/**
 * @param {string} entityID
 * @returns {Object} { serverID, remoteID }
 * Get the serverID and remoteID from the given aggregated entityID
 */function deconstructEntityID(entityID){var _deconstructID5=Object(__WEBPACK_IMPORTED_MODULE_0_lib_id__["b" /* deconstructID */])(entityID),_deconstructID6=_slicedToArray(_deconstructID5,2),serverID=_deconstructID6[0],remoteID=_deconstructID6[1];return{serverID:serverID,remoteID:remoteID};}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = aggregateID;
/* harmony export (immutable) */ __webpack_exports__["b"] = deconstructID;
/**
 * @module lib/id
 * Tools for aggregating and desconstructing entity IDs.
 *//*
 * We need escaping so that aggregation can be nested, and so that
 *   IDs which already contain our delimiter don't cause problems.
 */var DELIMITER=":";var REGEX_DELIMITER="\\:";var ESCAPE="~";var REGEX_ESCAPE="\\~";function escapeDelimiter(string){return string.toString().replace(new RegExp(REGEX_ESCAPE),ESCAPE+ESCAPE).replace(new RegExp(REGEX_DELIMITER),DELIMITER+ESCAPE);}function unescapeDelimiter(string){return string.replace(new RegExp(REGEX_ESCAPE+REGEX_ESCAPE),ESCAPE).replace(new RegExp(REGEX_DELIMITER+REGEX_ESCAPE),DELIMITER);}/**
 * Combine multiple constituent IDs into a single aggregated ID.
 * @param {...string} constituents
 * @returns {string} aggregated ID
 */function aggregateID(){for(var _len=arguments.length,constituents=Array(_len),_key=0;_key<_len;_key++){constituents[_key]=arguments[_key];}return constituents.map(escapeDelimiter).join(":");}/**
 * Break an aggregated ID down into its constituent parts.
 * @param {string} id aggregated ID
 * @returns {Array<string>} constituents
 */function deconstructID(id){var pattern=new RegExp(REGEX_DELIMITER+"(?!"+REGEX_ESCAPE+")");return id.split(pattern).map(unescapeDelimiter);}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultProperties; });
/* harmony export (immutable) */ __webpack_exports__["a"] = appserverAdapter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_appserver_aggregate__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_appserver_entityHeaders_schoolLinked__ = __webpack_require__(58);
/**
 * @module lib/appserver/entityHeaders/studentLinked
 * Common interface for all student-linked entities.
 * These entities are also implicitly school-linked.
 */var defaultProperties=Object.assign({},__WEBPACK_IMPORTED_MODULE_1_lib_appserver_entityHeaders_schoolLinked__["b" /* defaultProperties */],{remoteStudentID:undefined,studentID:undefined});function appserverAdapter(rawEntity){var props=__WEBPACK_IMPORTED_MODULE_1_lib_appserver_entityHeaders_schoolLinked__["a" /* appserverAdapter */](rawEntity);props.remoteStudentID=rawEntity.student_fk;props.studentID=Object(__WEBPACK_IMPORTED_MODULE_0_lib_appserver_aggregate__["c" /* aggregateStudentID */])(props);return props;}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This is a straight rip-off of the React.js ReactPropTypes.js proptype validators,
 * modified to make it possible to validate Immutable.js data.
 *     ImmutableTypes.listOf is patterned after React.PropTypes.arrayOf, but for Immutable.List
 *     ImmutableTypes.shape  is based on React.PropTypes.shape, but for any Immutable.Iterable
 */


var Immutable = __webpack_require__(7);

var ANONYMOUS = "<<anonymous>>";

var ImmutablePropTypes = {
  listOf: createListOfTypeChecker,
  mapOf: createMapOfTypeChecker,
  orderedMapOf: createOrderedMapOfTypeChecker,
  setOf: createSetOfTypeChecker,
  orderedSetOf: createOrderedSetOfTypeChecker,
  stackOf: createStackOfTypeChecker,
  iterableOf: createIterableOfTypeChecker,
  recordOf: createRecordOfTypeChecker,
  shape: createShapeChecker,
  contains: createShapeChecker,
  mapContains: createMapContainsChecker,
  // Primitive Types
  list: createImmutableTypeChecker("List", Immutable.List.isList),
  map: createImmutableTypeChecker("Map", Immutable.Map.isMap),
  orderedMap: createImmutableTypeChecker("OrderedMap", Immutable.OrderedMap.isOrderedMap),
  set: createImmutableTypeChecker("Set", Immutable.Set.isSet),
  orderedSet: createImmutableTypeChecker("OrderedSet", Immutable.OrderedSet.isOrderedSet),
  stack: createImmutableTypeChecker("Stack", Immutable.Stack.isStack),
  seq: createImmutableTypeChecker("Seq", Immutable.Seq.isSeq),
  record: createImmutableTypeChecker("Record", function (isRecord) {
    return isRecord instanceof Immutable.Record;
  }),
  iterable: createImmutableTypeChecker("Iterable", Immutable.Iterable.isIterable)
};

function getPropType(propValue) {
  var propType = typeof propValue;
  if (Array.isArray(propValue)) {
    return "array";
  }
  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
  }
  if (propValue instanceof Immutable.Iterable) {
    return "Immutable." + propValue.toSource().split(" ")[0];
  }
  return propType;
}

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      rest[_key - 6] = arguments[_key];
    }

    propFullName = propFullName || propName;
    componentName = componentName || ANONYMOUS;
    if (props[propName] == null) {
      var locationName = location;
      if (isRequired) {
        return new Error("Required " + locationName + " `" + propFullName + "` was not specified in " + ("`" + componentName + "`."));
      }
    } else {
      return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

function createImmutableTypeChecker(immutableClassName, immutableClassTypeValidator) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var propType = getPropType(propValue);
      return new Error("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `" + immutableClassName + "`."));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createIterableTypeChecker(typeChecker, immutableClassName, immutableClassTypeValidator) {

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var locationName = location;
      var propType = getPropType(propValue);
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
    }

    if (typeof typeChecker !== "function") {
      return new Error("Invalid typeChecker supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
    }

    var propValues = propValue.toArray();
    for (var i = 0, len = propValues.length; i < len; i++) {
      var error = typeChecker.apply(undefined, [propValues, i, componentName, location, "" + propFullName + "[" + i + "]"].concat(rest));
      if (error instanceof Error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createKeysTypeChecker(typeChecker) {

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (typeof typeChecker !== "function") {
      return new Error("Invalid keysTypeChecker (optional second argument) supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
    }

    var keys = propValue.keySeq().toArray();
    for (var i = 0, len = keys.length; i < len; i++) {
      var error = typeChecker.apply(undefined, [keys, i, componentName, location, "" + propFullName + " -> key(" + keys[i] + ")"].concat(rest));
      if (error instanceof Error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createListOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "List", Immutable.List.isList);
}

function createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, immutableClassName, immutableClassTypeValidator) {
  function validate() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return createIterableTypeChecker(valuesTypeChecker, immutableClassName, immutableClassTypeValidator).apply(undefined, args) || keysTypeChecker && createKeysTypeChecker(keysTypeChecker).apply(undefined, args);
  }

  return createChainableTypeChecker(validate);
}

function createMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "Map", Immutable.Map.isMap);
}

function createOrderedMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "OrderedMap", Immutable.OrderedMap.isOrderedMap);
}

function createSetOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Set", Immutable.Set.isSet);
}

function createOrderedSetOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "OrderedSet", Immutable.OrderedSet.isOrderedSet);
}

function createStackOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Stack", Immutable.Stack.isStack);
}

function createIterableOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Iterable", Immutable.Iterable.isIterable);
}

function createRecordOfTypeChecker(recordKeys) {
  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!(propValue instanceof Immutable.Record)) {
      var propType = getPropType(propValue);
      var locationName = location;
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js Record."));
    }
    for (var key in recordKeys) {
      var checker = recordKeys[key];
      if (!checker) {
        continue;
      }
      var mutablePropValue = propValue.toObject();
      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
      if (error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

// there is some irony in the fact that shapeTypes is a standard hash and not an immutable collection
function createShapeTypeChecker(shapeTypes) {
  var immutableClassName = arguments[1] === undefined ? "Iterable" : arguments[1];
  var immutableClassTypeValidator = arguments[2] === undefined ? Immutable.Iterable.isIterable : arguments[2];

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var propType = getPropType(propValue);
      var locationName = location;
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
    }
    var mutablePropValue = propValue.toObject();
    for (var key in shapeTypes) {
      var checker = shapeTypes[key];
      if (!checker) {
        continue;
      }
      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
      if (error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createShapeChecker(shapeTypes) {
  return createShapeTypeChecker(shapeTypes);
}

function createMapContainsChecker(shapeTypes) {
  return createShapeTypeChecker(shapeTypes, "Map", Immutable.Map.isMap);
}

module.exports = ImmutablePropTypes;

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isEnd; });
/* harmony export (immutable) */ __webpack_exports__["b"] = emitter;
/* unused harmony export INVALID_BUFFER */
/* unused harmony export UNDEFINED_INPUT_ERROR */
/* unused harmony export channel */
/* harmony export (immutable) */ __webpack_exports__["c"] = eventChannel;
/* harmony export (immutable) */ __webpack_exports__["e"] = stdChannel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buffers__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler__ = __webpack_require__(146);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
var END = { type: CHANNEL_END_TYPE };
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};

function emitter() {
  var subscribers = [];

  function subscribe(sub) {
    subscribers.push(sub);
    return function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(subscribers, sub);
    };
  }

  function emit(item) {
    var arr = subscribers.slice();
    for (var i = 0, len = arr.length; i < len; i++) {
      arr[i](item);
    }
  }

  return {
    subscribe: subscribe,
    emit: emit
  };
}

var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';

if (false) {
  UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
}

function channel() {
  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].fixed();

  var closed = false;
  var takers = [];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(buffer, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].buffer, INVALID_BUFFER);

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have a closed channel with pending takers');
    }
    if (takers.length && !buffer.isEmpty()) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__utils__["m" /* internalErr */])('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(input, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].notUndef, UNDEFINED_INPUT_ERROR);
    if (closed) {
      return;
    }
    if (!takers.length) {
      return buffer.put(input);
    }
    for (var i = 0; i < takers.length; i++) {
      var cb = takers[i];
      if (!cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] || cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]](input)) {
        takers.splice(i, 1);
        return cb(input);
      }
    }
  }

  function take(cb) {
    checkForbiddenStates();
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's callback must be a function");

    if (closed && buffer.isEmpty()) {
      cb(END);
    } else if (!buffer.isEmpty()) {
      cb(buffer.take());
    } else {
      takers.push(cb);
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(takers, cb);
      };
    }
  }

  function flush(cb) {
    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(cb, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.flush' callback must be a function");
    if (closed && buffer.isEmpty()) {
      cb(END);
      return;
    }
    cb(buffer.flush());
  }

  function close() {
    checkForbiddenStates();
    if (!closed) {
      closed = true;
      if (takers.length) {
        var arr = takers;
        takers = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          arr[i](END);
        }
      }
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close,
    get __takers__() {
      return takers;
    },
    get __closed__() {
      return closed;
    }
  };
}

function eventChannel(subscribe) {
  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__buffers__["a" /* buffers */].none();
  var matcher = arguments[2];

  /**
    should be if(typeof matcher !== undefined) instead?
    see PR #273 for a background discussion
  **/
  if (arguments.length > 2) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, 'Invalid match function passed to eventChannel');
  }

  var chan = channel(buffer);
  var close = function close() {
    if (!chan.__closed__) {
      if (unsubscribe) {
        unsubscribe();
      }
      chan.close();
    }
  };
  var unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }
    if (matcher && !matcher(input)) {
      return;
    }
    chan.put(input);
  });
  if (chan.__closed__) {
    unsubscribe();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(unsubscribe)) {
    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}

function stdChannel(subscribe) {
  var chan = eventChannel(function (cb) {
    return subscribe(function (input) {
      if (input[__WEBPACK_IMPORTED_MODULE_0__utils__["c" /* SAGA_ACTION */]]) {
        cb(input);
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__scheduler__["a" /* asap */])(function () {
        return cb(input);
      });
    });
  });

  return _extends({}, chan, {
    take: function take(cb, matcher) {
      if (arguments.length > 1) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(matcher, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, "channel.take's matcher argument must be a function");
        cb[__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* MATCH */]] = matcher;
      }
      chan.take(cb);
    }
  });
}

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEBUG_MOBILE_NUMBER; });
/* harmony export (immutable) */ __webpack_exports__["f"] = openURL;
/* harmony export (immutable) */ __webpack_exports__["d"] = openEmail;
/* harmony export (immutable) */ __webpack_exports__["e"] = openPhone;
/* harmony export (immutable) */ __webpack_exports__["c"] = forceRegistration;
/* harmony export (immutable) */ __webpack_exports__["b"] = closeApplication;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_log__ = __webpack_require__(16);
/**
 * @module lib/native
 * Provide interfaces for interacting with the native client container.
 * Relies on APIs exposed by the native client.
 *//**
 * Ofcom fictional number: 07700900827
 * https://www.ofcom.org.uk/phones-telecoms-and-internet/information-for-industry/numbering/numbers-for-drama
 * T9: 8(T) 2(2) 7(P)
 *
 * The native client recognises this and allows the user to skip verification.
 * When we detect it, we serve sample data locally instead of fetching from appserver.
 */var DEBUG_MOBILE_NUMBER="+447700900827";// This needs to match the platform strings in userIdentity
var PLATFORM={ANDROID:"android",IPHONE:"iphone"};function openURL(platform,url){switch(platform){case PLATFORM.ANDROID:window.android.openURL(url);break;case PLATFORM.IPHONE:window.webkit.messageHandlers.openUrlHandler.postMessage(url);break;// Browser actions for debugging only
default:window.location.href=url;break;}}function openEmail(platform,email){switch(platform){case PLATFORM.ANDROID:window.android.openEmail(email);break;case PLATFORM.IPHONE:window.webkit.messageHandlers.openEmailHandler.postMessage(email);break;default:break;}}function openPhone(platform,phoneNumber){switch(platform){case PLATFORM.ANDROID:window.android.openPhoneNumber(phoneNumber);break;case PLATFORM.IPHONE:window.webkit.messageHandlers.diallerHandler.postMessage(phoneNumber);break;default:break;}}function forceRegistration(platform,alertMessage){switch(platform){case PLATFORM.ANDROID:window.android.forceRegistration(alertMessage);break;case PLATFORM.IPHONE:window.webkit.messageHandlers.forceRegistrationHandler.postMessage(alertMessage);break;default:break;}}// ANDROID ONLY API
function closeApplication(platform){switch(platform){case PLATFORM.ANDROID:window.android.closeApplication();break;default:__WEBPACK_IMPORTED_MODULE_0_lib_log__["a" /* default */].warn("lib/native/closeApplication is not compatible with platform \""+platform+"\", ignoring...");break;}}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner_css__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Spinner_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Spinner=function(_React$Component){_inherits(Spinner,_React$Component);function Spinner(){_classCallCheck(this,Spinner);return _possibleConstructorReturn(this,(Spinner.__proto__||Object.getPrototypeOf(Spinner)).apply(this,arguments));}_createClass(Spinner,[{key:"render",value:function render(){var _props=this.props,color=_props.color,size=_props.size;var classNames=["spinner","spinner--color-"+color+" spinner--size-"+size];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"spinner__wheel"}));}}]);return Spinner;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Spinner.propTypes={color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,size:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Spinner.defaultProps={color:"default",size:"text"};/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_detect_browser__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_detect_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_detect_browser__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var browser=Object(__WEBPACK_IMPORTED_MODULE_2_detect_browser__["detect"])();/**
 * Scrollable list of elements.
 * Specific elements can be scrolled to using refs and the scrollTargetID prop.
 * The key to this component is that it keeps a hash of refs to its children.
 * To ref children, pass a function as the `children` prop. That funciton takes a
 *   single argument which is a ref function. The ref function takes two arguments,
 *   a child element and an ID.
 */var ScrollableList=function(_React$Component){_inherits(ScrollableList,_React$Component);function ScrollableList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ScrollableList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ScrollableList.__proto__||Object.getPrototypeOf(ScrollableList)).call.apply(_ref,[this].concat(args))),_this),_this.container=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef(),_this.childRefMap={},_this.refChild=function(child,childID){_this.childRefMap[childID]=child;},_this.onScroll=function(){var messagesList=_this.container.current.childNodes[0];if(_this.props.infiniteScroll){// As scrollTop value gets reversed because of using `flex-direction: column-reverse` handle safari separately
if(browser.name==="safari"||browser.name.indexOf("ios")>-1){if(messagesList.scrollHeight-messagesList.offsetHeight===-messagesList.scrollTop){_this.props.loadMore();}}else{if(_this.props.infiniteScroll&&messagesList.scrollTop===0){_this.props.loadMore();}}}},_temp),_possibleConstructorReturn(_this,_ret);}/**
   * Map child IDs to their refs.
   * Populated by `refChild`.
   *//**
   * Store a ref to a child.
   * @param {node} child
   * @param {string} childID
   */_createClass(ScrollableList,[{key:"scrollToChild",/**
   * Scroll to the child with the given ID.
   */value:function scrollToChild(childID){var container=this.container.current;var child=this.childRefMap[childID];if(container&&child){if(this.props.alignToBottom){container.scrollTop=container.scrollHeight+child.offsetTop+child.offsetHeight-container.clientHeight*2;}else{container.scrollTop=child.offsetTop;}}}/**
   * Scroll to the child specified by the `scrollTargetID` prop.
   * Do `requestAnimationFrame` to our `onScroll` callback (this ensures that
   *   the element has actually been displayed before we fire).
   */},{key:"scrollToTarget",value:function scrollToTarget(){var _this2=this;var scrollTargetID=this.props.scrollTargetID;if(scrollTargetID){this.scrollToChild(scrollTargetID);window.requestAnimationFrame(function(){_this2.props.onScroll();});}}/**
   * Get children from node or func.
   */},{key:"getChildren",value:function getChildren(){var children=this.props.children;if(typeof children==="function"){children=children(this.refChild);}children=__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(children);return children;}},{key:"componentDidMount",value:function componentDidMount(){this.scrollToTarget();}},{key:"componentDidUpdate",value:function componentDidUpdate(){this.scrollToTarget();// Reset the scrolltop for safari
if(!this.props.alignToBottom&&(browser.name==="safari"||browser.name.indexOf("ios")>-1)){var messagesList=this.container.current.childNodes[0];messagesList.scrollTop=-(messagesList.scrollHeight-messagesList.offsetHeight)+5;}}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:this.props.className,ref:this.container,onScroll:this.onScroll},this.getChildren());}}]);return ScrollableList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ScrollableList.propTypes={/**
     * Should the scrollTo'd elements be align to the bottom
     *   of the container instead of the top?
     */alignToBottom:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,/**
     * The ID of the child element to scroll to.
     */scrollTargetID:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,/**
     * Behaves normally when passed a node (element/array/etc.).
     * When passed a function, uses FAC pattern called with a single arg
     *   which is a ref function taking (childElement, childID).
     */children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,/**
      * Should the component load more data on end of scroll
    */infiniteScroll:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,/**
      * Function to run on end of scroll
    */loadMore:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};ScrollableList.defaultProps={reversed:false};/* harmony default export */ __webpack_exports__["a"] = (ScrollableList);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Highlight_css__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Highlight_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Highlight_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Add a highlighting effect to a block.
 * Wrap a block in this element, and pass `isHighlighted={true}` and the
 *   block will be highlighted with an animation.
 */var Highlight=function(_React$Component){_inherits(Highlight,_React$Component);function Highlight(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Highlight);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Highlight.__proto__||Object.getPrototypeOf(Highlight)).call.apply(_ref,[this].concat(args))),_this),_this.state={isHighlighting:false},_this.onAnimationEnd=function(){_this.setState({isHighlighting:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Highlight,[{key:"render",value:function render(){var cssModifier=this.props.cssModifier;var isHighlighting=this.state.isHighlighting;var classNames=["highlight"];if(isHighlighting){classNames.push("highlight--active");}else{classNames.push("highlight--inactive");}if(cssModifier!==undefined){classNames.push("highlight--"+cssModifier);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" "),onAnimationEnd:this.onAnimationEnd},this.props.children);}}],[{key:"getDerivedStateFromProps",value:function getDerivedStateFromProps(nextProps){if(nextProps.isHighlighted){return{isHighlighting:true};}return null;}}]);return Highlight;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Highlight.propTypes={/**
     * Control the theme of the highlighting applied.
     * Valid options are defined in the CSS.
     */cssModifier:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,/**
     * Pass `true` to highlight the element.
     * You may immediately revert to `false`, but the animation
     *   will continue until it ends.
     */isHighlighted:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Highlight);

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_IconButton__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_assets_images_school_money_item_remove_svg__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_assets_images_school_money_item_remove_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_assets_images_school_money_item_remove_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RemoveButton=function(_React$Component){_inherits(RemoveButton,_React$Component);function RemoveButton(){_classCallCheck(this,RemoveButton);return _possibleConstructorReturn(this,(RemoveButton.__proto__||Object.getPrototypeOf(RemoveButton)).apply(this,arguments));}_createClass(RemoveButton,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_IconButton__["a" /* default */],Object.assign({src:__WEBPACK_IMPORTED_MODULE_2_components_assets_images_school_money_item_remove_svg___default.a},this.props));}}]);return RemoveButton;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (RemoveButton);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Gate__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MaintainValidStudentID=function(_React$Component){_inherits(MaintainValidStudentID,_React$Component);function MaintainValidStudentID(){_classCallCheck(this,MaintainValidStudentID);return _possibleConstructorReturn(this,(MaintainValidStudentID.__proto__||Object.getPrototypeOf(MaintainValidStudentID)).apply(this,arguments));}_createClass(MaintainValidStudentID,[{key:"updateLastStudent",value:function updateLastStudent(){var _props=this.props,currentStudentID=_props.currentStudentID,isCurrentStudentIDValid=_props.isCurrentStudentIDValid,lastStudentID=_props.lastStudentID;if(isCurrentStudentIDValid&&currentStudentID!==lastStudentID){this.props.setLastStudent(currentStudentID);}}},{key:"componentDidMount",value:function componentDidMount(){this.updateLastStudent();}},{key:"componentDidUpdate",value:function componentDidUpdate(){this.updateLastStudent();}},{key:"render",value:function render(){var _props2=this.props,isCurrentStudentIDValid=_props2.isCurrentStudentIDValid,lastStudentID=_props2.lastStudentID;var redirect=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* Redirect */],{to:this.props.generatePath(lastStudentID)});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Gate__["a" /* default */],{isOpen:isCurrentStudentIDValid,placeholder:redirect},this.props.children);}}]);return MaintainValidStudentID;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);MaintainValidStudentID.propTypes={currentStudentID:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,generatePath:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state,ownProps){var currentStudentID=ownProps.currentStudentID;var isCurrentStudentIDDefined=currentStudentID!==undefined;return{isCurrentStudentIDValid:isCurrentStudentIDDefined&&Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["o" /* doesStudentExist */])(state,currentStudentID),lastStudentID:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_11" /* getLastStudentID */])(state)};},{setLastStudent:__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_106" /* setLastStudent */]})(MaintainValidStudentID));

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_EntitySelector__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_school_money_StudentName__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StudentSelector_css__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StudentSelector_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__StudentSelector_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StudentSelector=function(_React$Component){_inherits(StudentSelector,_React$Component);function StudentSelector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StudentSelector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StudentSelector.__proto__||Object.getPrototypeOf(StudentSelector)).call.apply(_ref,[this].concat(args))),_this),_this.changeStudent=function(studentID){__WEBPACK_IMPORTED_MODULE_2_state_history__["a" /* history */].push(_this.props.generatePath(studentID));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StudentSelector,[{key:"render",value:function render(){var _props=this.props,studentIDList=_props.studentIDList,selectedStudentID=_props.selectedStudentID;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_EntitySelector__["a" /* default */],{cssBlockName:"student-selector",entityIDList:studentIDList,selectedEntityID:selectedStudentID,loop:false,onSelectEntity:this.changeStudent},function(studentID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_school_money_StudentName__["a" /* default */],{studentID:studentID});});}}]);return StudentSelector;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{studentIDList:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_52" /* getStudentIDList */])(state)};})(StudentSelector));

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_EntityCarousel__ = __webpack_require__(186);
/**
 * Allow swiping between students' pages.
 *//* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function(state,ownProps){return{entityIDList:Object(__WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors__["_52" /* getStudentIDList */])(state),activeEntityID:ownProps.activeStudentID};})(__WEBPACK_IMPORTED_MODULE_2_components_EntityCarousel__["a" /* default */]));

/***/ }),
/* 52 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultProperties; });
/* harmony export (immutable) */ __webpack_exports__["a"] = appserverAdapter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_appserver_aggregate__ = __webpack_require__(39);
/**
 * @module lib/appserver/entityHeaders/common
 * Common interface for all entities in the app.
 */var defaultProperties={appserverReferenceType:undefined,appserverReferenceEntityID:undefined,serverID:undefined,serverHostname:undefined,remoteSchoolID:undefined,schoolID:undefined,remoteID:undefined,id:undefined};function appserverAdapter(rawEntity){var props={appserverReferenceType:rawEntity.appserver_reference_type,appserverReferenceEntityID:rawEntity.appserver_remote_entity_id,serverID:rawEntity.appserver_server_id,serverHostname:rawEntity.appserver_server_hostname,remoteSchoolID:rawEntity.appserver_remote_school_id,remoteID:rawEntity.id};props.schoolID=Object(__WEBPACK_IMPORTED_MODULE_0_lib_appserver_aggregate__["b" /* aggregateSchoolID */])(props);props.id=Object(__WEBPACK_IMPORTED_MODULE_0_lib_appserver_aggregate__["a" /* aggregateEntityID */])(props);return props;}

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return status; });
/* unused harmony export Checkout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
var status={CLOSED:"closed",PREPARING:"preparing",PENDING:"pending",PROCESSING:"processing",COMPLETED:"completed"};var Checkout=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record({status:status.CLOSED,schoolID:null,transactionID:null,totalToPay:null,error:null,errorCode:null},"Checkout");Checkout.status=status;/* harmony default export */ __webpack_exports__["a"] = (Checkout);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultProperties; });
/* harmony export (immutable) */ __webpack_exports__["a"] = appserverAdapter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_appserver_aggregate__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_appserver_entityHeaders_common__ = __webpack_require__(56);
/**
 * @module lib/appserver/entityHeaders/schoolLinked
 * Common interface for all entities which link to schools.
 * These entties will have their IDs scoped by their schoolID.
 */var defaultProperties=Object.assign({},__WEBPACK_IMPORTED_MODULE_1_lib_appserver_entityHeaders_common__["b" /* defaultProperties */]);function appserverAdapter(rawEntity){var props=__WEBPACK_IMPORTED_MODULE_1_lib_appserver_entityHeaders_common__["a" /* appserverAdapter */](rawEntity);props.id=Object(__WEBPACK_IMPORTED_MODULE_0_lib_appserver_aggregate__["a" /* aggregateEntityID */])(props);return props;}

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoadingPage_css__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoadingPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LoadingPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoadingPage=function(_Component){_inherits(LoadingPage,_Component);function LoadingPage(){_classCallCheck(this,LoadingPage);return _possibleConstructorReturn(this,(LoadingPage.__proto__||Object.getPrototypeOf(LoadingPage)).apply(this,arguments));}_createClass(LoadingPage,[{key:"render",value:function render(){// TODO: replace text with a throbber or something
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"loading-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"throbber"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce3"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"loading-page__text"},"Loading..."));}}]);return LoadingPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LoadingPage);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_Gate__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Preloader_css__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Preloader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Preloader_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Display a placeholder while loading
 * Sepcifically styled for the Home Page
 */var Preloader=function(_React$Component){_inherits(Preloader,_React$Component);function Preloader(){_classCallCheck(this,Preloader);return _possibleConstructorReturn(this,(Preloader.__proto__||Object.getPrototypeOf(Preloader)).apply(this,arguments));}_createClass(Preloader,[{key:"render",value:function render(){var _props=this.props,isLoading=_props.isLoading,children=_props.children;var placeholder=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"home-section-placeholder"},"Loading...");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_Gate__["a" /* default */],{isOpen:!isLoading,placeholder:placeholder},children);}}]);return Preloader;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Preloader);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card_css__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Card_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * HomePage uses a condensed version of the standard Card component
 */var Card=function(_React$Component){_inherits(Card,_React$Component);function Card(){_classCallCheck(this,Card);return _possibleConstructorReturn(this,(Card.__proto__||Object.getPrototypeOf(Card)).apply(this,arguments));}_createClass(Card,[{key:"render",value:function render(){var _props=this.props,className=_props.className,children=_props.children;var classNames=["home-card"];if(className!==undefined){classNames.push(className);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},children);}}]);return Card;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Card.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (Card);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BulletItem_css__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BulletItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__BulletItem_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BulletItem=function(_React$Component){_inherits(BulletItem,_React$Component);function BulletItem(){_classCallCheck(this,BulletItem);return _possibleConstructorReturn(this,(BulletItem.__proto__||Object.getPrototypeOf(BulletItem)).apply(this,arguments));}_createClass(BulletItem,[{key:"render",value:function render(){var _props=this.props,className=_props.className,cssModifier=_props.cssModifier,children=_props.children;var classNames=["home-bullet-item"];if(className!==undefined){classNames.push(className);}if(cssModifier!==undefined){classNames.push("home-bullet-item--"+cssModifier);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"home-bullet-item__bullet"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"home-bullet-item__body"},children));}}]);return BulletItem;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BulletItem);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = nl2br;
/* unused harmony export pluralise */
/* harmony export (immutable) */ __webpack_exports__["d"] = timeAgo;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLongDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = formatShortDate;
/* unused harmony export studentFullName */
/* unused harmony export flagToBoolean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/**
 * @module lib/format
 * Utilities for formatting text.
 *//**
 * nl2br - replaces \n with jsx br tags, for formatting and display
 *
 * @param  {String} nlstring string containing newlines
 * @returns {Array}
 */function nl2br(nlstring){// use the capture groups in split to return both the split segments and the newlines themselves
var newlineRegex=/(\r\n|\r|\n)/g;// Now loop over the segments and replace the newlines with jsx <br />
return nlstring.split(newlineRegex).map(function(line,index){if(line.match(newlineRegex)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",{key:index});}return line;});};/**
 * pluralise - pluralises a word based on a value
 * pluralise(2, "chicken") == "chickens"
 * pluralise(252, "goose", "geese") == "geese"
 *
 * @param  {Number} value                unit value
 * @param  {String} base_unit            singular word for your unit e.g. hour, day
 * @param  {String} base_unit_pluralised optional plural form of unit (override)
 * @returns {String}                     formatted plural word
 */function pluralise(value,base_unit){var base_unit_pluralised=arguments.length>2&&arguments[2]!==undefined?arguments[2]:base_unit+"s";if(value>1){return base_unit_pluralised;}else{return base_unit;}}/**
 * formatTimeAgo - format a moment date according to the time from now (past)
 * returns strings like "Now", "5 minutes ago", "12:00, Yesterday"
 *
 * @param  {type} date date as moment
 * @returns {String}     formatted timeAgo string
 */function timeAgo(inputDate){var timezoneOffset=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"+00:00";// concatenate inputDate and timezone to form complete date:
// TODO: consider seperating into utils  - one that accepts a moment, other accepts string
var date=__WEBPACK_IMPORTED_MODULE_1_moment___default()(inputDate+timezoneOffset);if(__WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(date,"seconds")<60){return"Now";}// 1 minute ago, 59 minutes ago
var minuteDelta=__WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(date,"minutes");if(minuteDelta<60){return minuteDelta+" "+pluralise(minuteDelta,"minute")+" ago";}// If this was yesterday, this takes precedence
// e.g 12 hours before 1am should say "13:00, Yesterday", not "12 hours ago"
var dayDelta=__WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(date,"days");if(dayDelta===1){return date.format("HH:mm[, Yesterday]");}// Otherwise we use the hour delta
// 1 Hour ago, 3 Hours ago
var hourDelta=__WEBPACK_IMPORTED_MODULE_1_moment___default()().diff(date,"hours");if(hourDelta<24){return hourDelta+" "+pluralise(hourDelta,"hour")+" ago";}// Date within a week(exclusive, starting today)
// 13:25, Wednesday
if(dayDelta<7){return date.format("HH:mm, dddd");}// Otherwise, default to full date display
return date.format("HH:mm, DD MMMM YYYY");}/**
 * format a date with weekday, day of month, month, and year
 * weekday name and month name are abbreviated to three letters
 *
 * @param {date} inputDate - can be in any format compatible with moment.js
 * @returns {String} formatted date string
 */function formatLongDate(inputDate){return __WEBPACK_IMPORTED_MODULE_1_moment___default()(inputDate).format("ddd Do MMM YYYY");}/**
 * format a date numerical day, month and year: DD/MM/YY
 *
 * @param {date} inputDate - can be in any format compatible with moment.js
 * @returns {String} formatted date string
 */function formatShortDate(inputDate){return __WEBPACK_IMPORTED_MODULE_1_moment___default()(inputDate).format("DD/MM/YY");}/**
 * studentFullName - format a student's full name by combining their first and
 *   last names
 *
 * @param {string} firstName
 * @param {string} lastName
 * @returns {string} the student's full name
 */function studentFullName(firstName,lastName){return firstName+" "+lastName;}/**
 * Map a Y/N to a true/false
 * @param {string} flag
 */function flagToBoolean(flag){return flag.toUpperCase()==="Y";}

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PlaceholderCard_css__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PlaceholderCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PlaceholderCard_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PlaceholderCard=function(_React$Component){_inherits(PlaceholderCard,_React$Component);function PlaceholderCard(){_classCallCheck(this,PlaceholderCard);return _possibleConstructorReturn(this,(PlaceholderCard.__proto__||Object.getPrototypeOf(PlaceholderCard)).apply(this,arguments));}_createClass(PlaceholderCard,[{key:"render",value:function render(){var schoolName=this.props.school.get("name");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Card__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Card__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"placeholder-card"},this.props.message!==""&&this.props.message!==undefined?""+this.props.message:schoolName+" has no "+this.props.objectName+" to display.")));}}]);return PlaceholderCard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);PlaceholderCard.propTypes={school:__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.shape({name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}).isRequired,objectName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,message:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (PlaceholderCard);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_IconButton__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_assets_images_school_money_item_add_svg__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_assets_images_school_money_item_add_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_assets_images_school_money_item_add_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddButton=function(_React$Component){_inherits(AddButton,_React$Component);function AddButton(){_classCallCheck(this,AddButton);return _possibleConstructorReturn(this,(AddButton.__proto__||Object.getPrototypeOf(AddButton)).apply(this,arguments));}_createClass(AddButton,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_IconButton__["a" /* default */],Object.assign({src:__WEBPACK_IMPORTED_MODULE_2_components_assets_images_school_money_item_add_svg___default.a},this.props));}}]);return AddButton;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AddButton);

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(207);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 68 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__ = __webpack_require__(241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__(250);
/* unused harmony reexport getLocation */
/* unused harmony reexport createMatchSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__reducer__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(136);
/* unused harmony reexport CALL_HISTORY_METHOD */
/* unused harmony reexport push */
/* unused harmony reexport replace */
/* unused harmony reexport go */
/* unused harmony reexport goBack */
/* unused harmony reexport goForward */
/* unused harmony reexport routerActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middleware__ = __webpack_require__(251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__middleware__["a"]; });









/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(55);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUFFER_OVERFLOW */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buffers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(25);


var BUFFER_OVERFLOW = "Channel's Buffer overflow!";

var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;

var zeroBuffer = { isEmpty: __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */], put: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */], take: __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */] };

function ringBuffer() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var overflowAction = arguments[1];

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];
    while (length) {
      items.push(take());
    }
    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit = void 0;
        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);
          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;
          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;

            arr = flush();

            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;

            arr.length = doubledLimit;
            limit = doubledLimit;

            push(it);
            break;
          default:
          // DROP
        }
      }
    },
    take: take,
    flush: flush
  };
}

var buffers = {
  none: function none() {
    return zeroBuffer;
  },
  fixed: function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
  },
  dropping: function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
  },
  sliding: function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
  },
  expanding: function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
  }
};

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export request */
/* harmony export (immutable) */ __webpack_exports__["b"] = availableProductsRequest;
/* harmony export (immutable) */ __webpack_exports__["c"] = dataRequest;
/* harmony export (immutable) */ __webpack_exports__["d"] = errorReport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_ocean__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_responseExceptions_UnexpectedAPIResponseFormatError__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_appserver_responseExceptions_UnrecognisedResponseCodeError__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_appserver_responseExceptions_RemoteServerCompleteFailureError__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_appserver_responseExceptions_UnknownDeviceError__ = __webpack_require__(159);
/* unused harmony reexport UnexpectedAPIResponseFormatError */
/* unused harmony reexport UnrecognisedResponseCodeError */
/* unused harmony reexport RemoteServerCompleteFailureError */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5_lib_appserver_responseExceptions_UnknownDeviceError__["a"]; });
/**
 * @module lib/appserver/request
 * Utilities for communicating with appserver
 * @see {@link module:state/fetchSagas} for using these APIs in sagas
 */// re-export exception classes for convenience
// In order to get appReferrer data from store, lib needs exposure to Redux and saga which is time consuming
// So it is easier to get it from the url args passed by the native app
var APP_REFERRER=__WEBPACK_IMPORTED_MODULE_1_query_string___default.a.parse(window.location.search).app_referrer;var HOSTNAME=APP_REFERRER==="xpressions"?"uat-appserver.teachers2parents.co.uk":"edspapitesting.teachers2parents.co.uk";var ERROR_API_ENDPOINT="https://"+HOSTNAME+"/public/appserver/api/log/error.api";/**
 * Generic appserver request.
 * This is where our error translation lives.
 * We check the JSend response for problems and throw exceptions.
 * NOTE: these exceptions are thrown inside the promise, so they
 *   can be caught using promise.catch().
 */function request(jspCmd,jspArgs,requestOptions){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_ocean__["b" /* jspCmdRequest */])(HOSTNAME,jspCmd,jspArgs,requestOptions).then(function(response){// check response looks like JSend
var responseData=response.data;if(!responseData.hasOwnProperty("status")){// wtf is this format!?
throw new __WEBPACK_IMPORTED_MODULE_2_lib_appserver_responseExceptions_UnexpectedAPIResponseFormatError__["a" /* default */](response);}// check for error response
if(responseData.status!=="success"){// we can recognise which some errors which may have special handling
var responseCode=responseData.code;switch(responseCode){case __WEBPACK_IMPORTED_MODULE_5_lib_appserver_responseExceptions_UnknownDeviceError__["a" /* default */].responseCode:throw new __WEBPACK_IMPORTED_MODULE_5_lib_appserver_responseExceptions_UnknownDeviceError__["a" /* default */](response);case __WEBPACK_IMPORTED_MODULE_4_lib_appserver_responseExceptions_RemoteServerCompleteFailureError__["a" /* default */].responseCode:throw new __WEBPACK_IMPORTED_MODULE_4_lib_appserver_responseExceptions_RemoteServerCompleteFailureError__["a" /* default */](response);default:// unrecognised code - generic exception
throw new __WEBPACK_IMPORTED_MODULE_3_lib_appserver_responseExceptions_UnrecognisedResponseCodeError__["a" /* default */](response);}}// nothing thrown - pass through
return response;});}/**
 * getAvailableProducts - getAvailableProducts/GetMyApps API
 *
 * @param  {String} mobileNumber
 * @param  {String} deviceToken
 * @returns {Promise}
 */function availableProductsRequest(mobileNumber,deviceToken){return request("GetMyApps()",{mobile_number:mobileNumber,device_token:deviceToken});}/**
 * dataRequest - ServiceDataRequest() API
 *
 * @param  {String} mobileNumber
 * @param  {String} deviceToken
 * @param  {String} application  "teachers"/ "school_money"
 * @param  {Object} args = {}    dataRequest arguments
 * @returns {Promise}
 */function dataRequest(mobileNumber,deviceToken,application){var args=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};return request("ServiceDataRequest()",Object.assign({},args,{// Override userIdentity (so there's no way to override in args)
application:application,mobile_number:mobileNumber,device_token:deviceToken}));}/**
 * errorReport - send an error report to appserver's error logging
 *   endpoint, which will then be reported to BigBrother.
 *
 * @param {Object} details key-value pairs of error details
 * -- error details --
 * @param {string} details.type e.g. "UnknownDeviceError"
 * @param {string} details.message e.g. "This device was not recognised by appserver.""
 * @param {string} [details.payload] any additional info to log
 * @param {string} [details.stacktrace]
 * -- environment details --
 * @param {string} details.native_version native client version number
 * @param {string} details.web_version web client version number
 * @param {string} details.os device operating system name
 * @param {string} details.os_version device operating system version
 * @param {string} details.device_type
 */function errorReport(details){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_ocean__["a" /* apiRequest */])(ERROR_API_ENDPOINT,details);}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(310);
var objectAssign = __webpack_require__(66);
var decodeComponent = __webpack_require__(311);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: this.parse(this.extract(str), opts)
	};
};


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * RemoteServerCompleteFailureError
 * Thrown when we get a REMOTE_FAIL_COMPLETE form appserver
 */var RemoteServerCompleteFailureError=function(_Error){_inherits(RemoteServerCompleteFailureError,_Error);// TODO: this is duck-typing, because babel is broken
function RemoteServerCompleteFailureError(response){_classCallCheck(this,RemoteServerCompleteFailureError);var _this=_possibleConstructorReturn(this,(RemoteServerCompleteFailureError.__proto__||Object.getPrototypeOf(RemoteServerCompleteFailureError)).call(this,"Appserver failed to communicate with any remote servers."));_this.response=response;_this.type=RemoteServerCompleteFailureError.type;return _this;}return RemoteServerCompleteFailureError;}(Error);RemoteServerCompleteFailureError.type="RemoteServerCompleteFailureError";RemoteServerCompleteFailureError.responseCode="REMOTE_FAIL_COMPLETE";/* harmony default export */ __webpack_exports__["a"] = (RemoteServerCompleteFailureError);

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
var BasketItemIssue=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record({itemType:undefined,basketItemID:undefined,studentID:undefined,reason:undefined},"Basket Item Issue");function buildBaksetItemIssueFromBasketItem(_ref,reason){var basketItemID=_ref.basketItemID,studentID=_ref.studentID,type=_ref.type;return BasketItemIssue({basketItemID:basketItemID,studentID:studentID,itemType:type,reason:reason});}BasketItemIssue.fromBasketItem=buildBaksetItemIssueFromBasketItem;/* harmony default export */ __webpack_exports__["a"] = (BasketItemIssue);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STATE_HYDRATE; });
/* unused harmony export LOCALSTORAGE_KEY_NAME */
/* harmony export (immutable) */ __webpack_exports__["b"] = attachPersistence;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_log__ = __webpack_require__(16);
/**
 * @module state/persist
 * Handles persistence of state to and from localStorage.
 *
 * On every action that passes through the store, the state
 *   is dehydrated and written to localStorage.
 * On every page load, the saved state is loaded from
 *   localStorage and used to rehydrate the current state.
 *
 * Dehydration is handled by {@link module:state/rootDehydrate}.
 * Hydration is handled by reducing the `STATE_HYDRATE` action.
 */var STATE_HYDRATE="@@persist/HYDRATE_STATE";var LOCALSTORAGE_KEY_NAME="state";/**
 * hydrateState - returns action for the hydrate state action
 */function hydrateState(state){return{type:STATE_HYDRATE,error:false,payload:{state:state}};}/**
 * saveState - serialize a state to a string for localStorage save
 */function saveState(state){try{var serialisedState=JSON.stringify(state);localStorage.setItem(LOCALSTORAGE_KEY_NAME,serialisedState);// localstorage not available, write error
}catch(error){__WEBPACK_IMPORTED_MODULE_1_lib_log__["a" /* default */].error("Unable to save state to local storage:",error);}}/**
 * loadState - attempt to load and parse the serialized state
 *
 * @returns {Object}
 */function loadState(){// Load state from localStorage
__WEBPACK_IMPORTED_MODULE_1_lib_log__["a" /* default */].debug("Checking for persisted state...");var rawState=void 0;try{rawState=localStorage.getItem(LOCALSTORAGE_KEY_NAME);// Key not set - return undefined as if not available
if(rawState===null){__WEBPACK_IMPORTED_MODULE_1_lib_log__["a" /* default */].debug("No persisted state could be found. ignoring...");return undefined;}}catch(error){__WEBPACK_IMPORTED_MODULE_1_lib_log__["a" /* default */].error("Error retrieving state from localStorage:",error);return undefined;}__WEBPACK_IMPORTED_MODULE_1_lib_log__["a" /* default */].debug("Found persisted state. parsing... (length:"+rawState.length+")");try{return JSON.parse(rawState);}catch(error){__WEBPACK_IMPORTED_MODULE_1_lib_log__["a" /* default */].error("Unable to load state from localStorage: ",error);return undefined;}}/**
 * attachPersistence - attach the persistence features to a given store object
 */function attachPersistence(store){var transformState=arguments.length>1&&arguments[1]!==undefined?arguments[1]:function(state){return state;};// Grab the persisted state from localstorage
// if we have data, fire the hydrate action, leaving the reducers to merge state
var persistedState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(loadState());if(persistedState!==undefined){store.dispatch(hydrateState(persistedState));}// Listen for changes on the store and serialize each time
store.subscribe(function(){saveState(transformState(store.getState()));});}

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * @param {boolean} first = true - should show first name?
 * @param {boolean} last = true - should show last name?
 */var StudentName=function(_React$Component){_inherits(StudentName,_React$Component);function StudentName(){_classCallCheck(this,StudentName);return _possibleConstructorReturn(this,(StudentName.__proto__||Object.getPrototypeOf(StudentName)).apply(this,arguments));}_createClass(StudentName,[{key:"render",value:function render(){var _props=this.props,student=_props.student,first=_props.first,last=_props.last;var firstName=student.firstName,lastName=student.lastName;if(first&&last){return firstName+" "+lastName;}if(first){return firstName;}if(last){return lastName;}return null;}}]);return StudentName;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);StudentName.propTypes={first:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,last:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};StudentName.defaultProps={first:true,last:true};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state,_ref){var studentID=_ref.studentID;return{student:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_48" /* getStudentByID */])(state,studentID)};})(StudentName));

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_validate__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_assets_images_school_money_school_money_logo_new_svg__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_assets_images_school_money_school_money_logo_new_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_assets_images_school_money_school_money_logo_new_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_SchoolLogo__ = __webpack_require__(180);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SchoolLogo=function(_React$Component){_inherits(SchoolLogo,_React$Component);function SchoolLogo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SchoolLogo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SchoolLogo.__proto__||Object.getPrototypeOf(SchoolLogo)).call.apply(_ref,[this].concat(args))),_this),_this.getLogoURL=function(){var _this$props$school$to=_this.props.school.toJS(),logoFilePath=_this$props$school$to.logoFilePath;if(logoFilePath===""||!Object(__WEBPACK_IMPORTED_MODULE_2_lib_validate__["d" /* isLogoPathValid */])(logoFilePath)){return __WEBPACK_IMPORTED_MODULE_4_components_assets_images_school_money_school_money_logo_new_svg___default.a;}return logoFilePath;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SchoolLogo,[{key:"render",value:function render(){var _props=this.props,school=_props.school,cssBlockName=_props.cssBlockName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_SchoolLogo__["a" /* default */],{logoURL:this.getLogoURL(),schoolName:school.get("name"),cssBlockName:cssBlockName,cssModifier:"school_money"});}}]);return SchoolLogo;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);SchoolLogo.propTypes={school:__WEBPACK_IMPORTED_MODULE_3_react_immutable_proptypes___default.a.shape({logoFilePath:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}).isRequired,cssBlockName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (SchoolLogo);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Gate__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_LoadingPage__ = __webpack_require__(59);
var ConnectedPreloader=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors__["B" /* isSchoolsReady */])(state)&&ownProps.isPageReady(state)};})(__WEBPACK_IMPORTED_MODULE_4_components_Gate__["a" /* default */]);ConnectedPreloader.defaultProps={isPageReady:function isPageReady(state){return true;},placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_LoadingPage__["a" /* default */],null)};ConnectedPreloader.PropTypes={isPageReady:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,placeholder:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (ConnectedPreloader);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NewIndicator_css__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NewIndicator_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__NewIndicator_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewIndicator=function(_React$Component){_inherits(NewIndicator,_React$Component);function NewIndicator(){_classCallCheck(this,NewIndicator);return _possibleConstructorReturn(this,(NewIndicator.__proto__||Object.getPrototypeOf(NewIndicator)).apply(this,arguments));}_createClass(NewIndicator,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"new-indicator "+this.props.className},"New!");}}]);return NewIndicator;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (NewIndicator);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(216);
var createDesc = __webpack_require__(221);
module.exports = __webpack_require__(87) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(119)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 88 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(225);
var defined = __webpack_require__(227);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(125);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(126);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(72);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(264);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qEnd; });
/* harmony export (immutable) */ __webpack_exports__["c"] = safeName;
/* harmony export (immutable) */ __webpack_exports__["a"] = fsmIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(25);


var done = { done: true, value: undefined };
var qEnd = {};

function safeName(patternOrChannel) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].channel(patternOrChannel)) {
    return 'channel';
  } else if (Array.isArray(patternOrChannel)) {
    return String(patternOrChannel.map(function (entry) {
      return String(entry);
    }));
  } else {
    return String(patternOrChannel);
  }
}

function fsmIterator(fsm, q0) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';

  var updateState = void 0,
      qNext = q0;

  function next(arg, error) {
    if (qNext === qEnd) {
      return done;
    }

    if (error) {
      qNext = qEnd;
      throw error;
    } else {
      updateState && updateState(arg);

      var _fsm$qNext = fsm[qNext](),
          q = _fsm$qNext[0],
          output = _fsm$qNext[1],
          _updateState = _fsm$qNext[2];

      qNext = q;
      updateState = _updateState;
      return qNext === qEnd ? done : output;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(next, function (error) {
    return next(null, error);
  }, name, true);
}

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(26);
var normalizeHeaderName = __webpack_require__(294);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(153);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(153);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(97)))

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAction;
/**
 * @module lib/actions
 * Utilities for [Flux Standard Actions]{@link https://github.com/redux-utilities/flux-standard-action}.
 *//**
 * Create a FSA.
 * @param {string} type
 * @param {boolean} [error]
 * @param {any} [payload]
 * @param {any} [meta]
 */function createAction(type,error,payload,meta){if(error!==true){error=false;}return{type:type,error:error,payload:payload,meta:meta};}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = search;
/* harmony export (immutable) */ __webpack_exports__["a"] = convertSmartQuotes;
/* harmony export (immutable) */ __webpack_exports__["b"] = isValidTextMessage;
/**
 * @module lib/text
 * Utilities for dealing with text.
 * TODO: this can probably be dissolved into lib/format and lib/validate.
 *//**
 * Search for the given query text within the given content text
 * Performs a case-insensitive search
 *
 * @param {string} content the string to search through
 * @param {string} query the substring to search for
 * @returns {boolean}
 */function search(content,query){return content.toLowerCase().includes(query.toLowerCase());}/**
 * Convert smart quotes to nnormal quotes in the given string
 *
 * @returns {string}
 */function convertSmartQuotes(inputString){return inputString// replace smart single quotes
.replace(/[\u2018\u2019]/g,"'")// replace smart double quotes
.replace(/[\u201C\u201D]/g,'"');}/**
 * Check if the given string is able to be sent as a text message
 * The regex here is the same one as used in the t2p desktop site
 *
 * @returns {boolean}
 */function isValidTextMessage(inputString){var invalidCharacterRegex=/[^0-9A-Z!"$%^?&*=_#/\\()-.'+\u00A3\u0040\u003A\u003B \n\r\s]/gi;var containsInvalidCharacters=invalidCharacterRegex.test(inputString);return!containsInvalidCharacters;}

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Overlay is just a wrapper for a RecatPortal.
 * Anything which needs to display on top of the rest of the app
 *   should be wrapped in an Overlay.
 * More accurately, anything which needs to break out of its container.
 * If you need to prevent user interaction behind the Overlay, consider
 *   using Modal instead.
 */var Overlay=function(_React$Component){_inherits(Overlay,_React$Component);function Overlay(){_classCallCheck(this,Overlay);return _possibleConstructorReturn(this,(Overlay.__proto__||Object.getPrototypeOf(Overlay)).apply(this,arguments));}_createClass(Overlay,[{key:"render",value:function render(){var overlayRoot=document.getElementById("overlay_root");if(!overlayRoot)return null;// Prevent crash in tests or SSR
return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["createPortal"])(this.props.children,overlayRoot);}}]);return Overlay;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Overlay.propTypes={children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(70);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/school_money-logo--text-right.8ba3d6da.svg";

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Gate__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MaintainValidSchoolID=function(_React$Component){_inherits(MaintainValidSchoolID,_React$Component);function MaintainValidSchoolID(){_classCallCheck(this,MaintainValidSchoolID);return _possibleConstructorReturn(this,(MaintainValidSchoolID.__proto__||Object.getPrototypeOf(MaintainValidSchoolID)).apply(this,arguments));}_createClass(MaintainValidSchoolID,[{key:"updateLastSchool",value:function updateLastSchool(){var _props=this.props,currentSchoolID=_props.currentSchoolID,isCurrentSchoolIDValid=_props.isCurrentSchoolIDValid,lastSchoolID=_props.lastSchoolID;if(isCurrentSchoolIDValid&&currentSchoolID!==lastSchoolID){this.props.setLastSchool(currentSchoolID);}}},{key:"componentDidMount",value:function componentDidMount(){this.updateLastSchool();}},{key:"componentDidUpdate",value:function componentDidUpdate(){this.updateLastSchool();}},{key:"render",value:function render(){var _props2=this.props,isCurrentSchoolIDValid=_props2.isCurrentSchoolIDValid,lastSchoolID=_props2.lastSchoolID;var redirect=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router__["a" /* Redirect */],{to:this.props.generatePath(lastSchoolID)});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Gate__["a" /* default */],{isOpen:isCurrentSchoolIDValid,placeholder:redirect},this.props.children);}}]);return MaintainValidSchoolID;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);MaintainValidSchoolID.propTypes={currentSchoolID:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,generatePath:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state,ownProps){var currentSchoolID=ownProps.currentSchoolID;var isCurrentSchoolIDDefined=currentSchoolID!==undefined;return{isCurrentSchoolIDValid:isCurrentSchoolIDDefined&&Object(__WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors__["a" /* doesSchoolExist */])(state,currentSchoolID),lastSchoolID:Object(__WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors__["e" /* getLastSchoolID */])(state)};},{setLastSchool:__WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__["V" /* setLastSchool */]})(MaintainValidSchoolID));

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_EntitySelector__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_teachers_SchoolName__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SchoolSelector_css__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SchoolSelector_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SchoolSelector_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SchoolSelector=function(_React$Component){_inherits(SchoolSelector,_React$Component);function SchoolSelector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SchoolSelector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SchoolSelector.__proto__||Object.getPrototypeOf(SchoolSelector)).call.apply(_ref,[this].concat(args))),_this),_this.changeSchool=function(schoolID){__WEBPACK_IMPORTED_MODULE_2_state_history__["a" /* history */].push(_this.props.generatePath(schoolID));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SchoolSelector,[{key:"render",value:function render(){var _props=this.props,schoolIDList=_props.schoolIDList,selectedSchoolID=_props.selectedSchoolID;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_EntitySelector__["a" /* default */],{cssBlockName:"school-selector",entityIDList:schoolIDList,selectedEntityID:selectedSchoolID,loop:false,onSelectEntity:this.changeSchool},function(schoolID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_teachers_SchoolName__["a" /* default */],{schoolID:schoolID});});}}]);return SchoolSelector;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{schoolIDList:Object(__WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors__["l" /* getSchoolIDList */])(state)};})(SchoolSelector));

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_EntityCarousel__ = __webpack_require__(186);
/**
 * Allow swiping between schools' pages.
 *//* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function(state,_ref){var activeSchoolID=_ref.activeSchoolID;return{entityIDList:Object(__WEBPACK_IMPORTED_MODULE_1_state_teachers_selectors__["l" /* getSchoolIDList */])(state),activeEntityID:activeSchoolID};})(__WEBPACK_IMPORTED_MODULE_2_components_EntityCarousel__["a" /* default */]));

/***/ }),
/* 107 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */

module.exports = function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Card__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PlaceholderCard=function(_React$Component){_inherits(PlaceholderCard,_React$Component);function PlaceholderCard(){_classCallCheck(this,PlaceholderCard);return _possibleConstructorReturn(this,(PlaceholderCard.__proto__||Object.getPrototypeOf(PlaceholderCard)).apply(this,arguments));}_createClass(PlaceholderCard,[{key:"render",value:function render(){var schoolName=this.props.school.get("name");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Card__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Card__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message-list__placeholder"},schoolName+" has no "+this.props.objectName+" to display.")));}}]);return PlaceholderCard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);PlaceholderCard.propTypes={school:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,objectName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (PlaceholderCard);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ORIGIN={TOP:"TOP",BOTTOM:"BOTTOM"};/**
 * ScrollableContainer - Generic component for displaying a list of entities as components
 * Provide your component as a child of the list
 */var ScrollableContainer=function(_React$Component){_inherits(ScrollableContainer,_React$Component);function ScrollableContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ScrollableContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ScrollableContainer.__proto__||Object.getPrototypeOf(ScrollableContainer)).call.apply(_ref,[this].concat(args))),_this),_this.refContainer=function(container){_this.container=container;},_this.scrollToOrigin=function(){switch(_this.props.origin){case ORIGIN.BOTTOM:_this.container.scrollTop=_this.container.scrollHeight;break;// default to top-down
case ORIGIN.TOP:default:_this.container.scrollTop=0;break;}},_this.restoreScrollTop=function(){var _this2=_this,scrollWasAtOrigin=_this2.scrollWasAtOrigin,storedScrollTop=_this2.storedScrollTop;if(scrollWasAtOrigin){_this.scrollToOrigin();}else{_this.container.scrollTop=storedScrollTop;}},_temp),_possibleConstructorReturn(_this,_ret);}/**
   * ref methods for storing internal elements
   *//**
   * scroll to the top or bottom of the page, depending on the origin
   *//**
   * Restore the scroll position from the state
   * If the scroll was at the origin before, then restore it to the new origin
   */_createClass(ScrollableContainer,[{key:"componentDidMount",/**
   * Scroll to origin immediately on mount
   */value:function componentDidMount(){this.scrollToOrigin();}// TODO: use getSnapshotBeforeUpdate instead of UNSAFE_componentWillUpdate
/**
   * If the component is about to update, stash the scrollTop
   * This isn't being stored in state because it doesn't affect the render
   * Also remember whether the scroll was at the origin
   */},{key:"componentWillUpdate",value:function componentWillUpdate(nextProps,nextState){var TOP=ORIGIN.TOP,BOTTOM=ORIGIN.BOTTOM;var origin=this.props.origin;var _container=this.container,scrollTop=_container.scrollTop,scrollHeight=_container.scrollHeight,clientHeight=_container.clientHeight;var maxScrollTop=scrollHeight-clientHeight;this.scrollWasAtOrigin=origin===TOP&&scrollTop===0||origin===BOTTOM&&scrollTop===maxScrollTop;this.storedScrollTop=scrollTop;}/**
   * After a re-render, check whther we should reset or restore scroll position
   */},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){// If the domain has changed, reset the scroll
if(prevProps.scrollKey!==this.props.scrollKey){this.scrollToOrigin();// Otherwise, restore the stashed scroll
}else{this.restoreScrollTop();}}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:this.props.className,ref:this.refContainer},this.props.children);}}]);return ScrollableContainer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ScrollableContainer.ORIGIN=ORIGIN;ScrollableContainer.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,origin:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.keys(ORIGIN)),scrollKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any};ScrollableContainer.defaultProps={scrollKey:null,origin:ORIGIN.TOP,placeholder:null};/* harmony default export */ __webpack_exports__["a"] = (ScrollableContainer);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IconButton=function(_React$Component){_inherits(IconButton,_React$Component);function IconButton(){_classCallCheck(this,IconButton);return _possibleConstructorReturn(this,(IconButton.__proto__||Object.getPrototypeOf(IconButton)).apply(this,arguments));}_createClass(IconButton,[{key:"render",value:function render(){var _props=this.props,className=_props.className,onClick=_props.onClick,src=_props.src;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"icon-button "+className,onClick:onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"icon-button__img",src:src,alt:"add"}));}}]);return IconButton;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);IconButton.propTypes={onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,src:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (IconButton);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StudentCreditBalance_css__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StudentCreditBalance_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__StudentCreditBalance_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StudentCreditBalance=function(_React$Component){_inherits(StudentCreditBalance,_React$Component);function StudentCreditBalance(props){_classCallCheck(this,StudentCreditBalance);// Set default global class property.
var _this=_possibleConstructorReturn(this,(StudentCreditBalance.__proto__||Object.getPrototypeOf(StudentCreditBalance)).call(this,props));_this.creditAmount=0;_this.isCredit=false;_this.isArrears=false;_this.balanceLabel="";return _this;}_createClass(StudentCreditBalance,[{key:"setCreditInformation",// Set credit information based on internal cashless student.
value:function setCreditInformation(){// Get/Set credit information.
var creditAmount=Number(this.props.creditAmount);this.isCredit=creditAmount>0;this.isArrears=creditAmount<0;this.balanceLabel=this.isArrears?"Arrears":"Credit";this.creditAmount=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Currency__["a" /* default */],{amount:creditAmount});// Overwrite with external cashless balance information, if an external cashless student.
this.setExternalCashlessBalanceInformation();}// Set balance information based on external cashless student.
},{key:"setExternalCashlessBalanceInformation",value:function setExternalCashlessBalanceInformation(){// Ignore this is not dinner money.
// We only need external dinner balance for dinner money topups.
if(this.props.type!=="dinner_money"){return;}// Check is this an external cashless student, no then ignore.
if(!this.props.isExternalCashlessStudent){return;}// Get/Set credit information.
var creditAmount=Number(this.props.externalCashlessBalance);this.isCredit=creditAmount>0;this.isArrears=creditAmount<0;this.balanceLabel="Dinner Balance";this.creditAmount=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Currency__["a" /* default */],{amount:creditAmount});// External cashless catering is inactive show message instead of balance.
if(!this.props.isExternalCashlessActive){this.creditAmount="Unavailable";}}// Create css class string for credit label.
},{key:"getCreditLabelClass",value:function getCreditLabelClass(){// Set class to classNames
var classNames=["student-credit-balance"];// Depending on balance set class to change color.
switch(true){case this.isCredit:classNames.push("student-credit-balance--credit");break;case this.isArrears:classNames.push("student-credit-balance--arrears");break;default:classNames.push("student-credit-balance--neutral");break;}// Combine array into string and return.
return classNames.join(" ");}},{key:"render",value:function render(){// Set credit information in class global properties.
this.setCreditInformation();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:this.getCreditLabelClass()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"student-credit-balance__label"},this.balanceLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"student-credit-balance__amount"},this.creditAmount));}}]);return StudentCreditBalance;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);StudentCreditBalance.propTypes={studentID:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(state,ownProps){return{creditAmount:Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_58" /* getStudentTotalCreditAmount */])(state,ownProps.studentID,ownProps.type),externalCashlessBalance:Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_51" /* getStudentExternalDinnerBalance */])(state,ownProps.studentID),isExternalCashlessStudent:Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["q" /* doesStudentUseExternalCashless */])(state,ownProps.studentID),isExternalCashlessActive:Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_112" /* isXodActive */])(state,Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_56" /* getStudentSchoolID */])(state,ownProps.studentID))};})(StudentCreditBalance));

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var weekdays=["Mon","Tue","Wed","Thu","Fri"];/**
 * Display a table where each row corresponds to a day of the week (Mon..Fri)
 * Takes a single child and clones it for each row, passing props: weekdayName, weekdayIndex
 * @param {Array<String>} [headings] optional list of column headings
 * @param {function} children (weekdayIndex, weekdayName) render callback for each weekday
 */var WeekdayTable=function(_React$Component){_inherits(WeekdayTable,_React$Component);function WeekdayTable(){_classCallCheck(this,WeekdayTable);return _possibleConstructorReturn(this,(WeekdayTable.__proto__||Object.getPrototypeOf(WeekdayTable)).apply(this,arguments));}_createClass(WeekdayTable,[{key:"render",value:function render(){var _this2=this;var _props=this.props,header=_props.header,cssBlockName=_props.cssBlockName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:cssBlockName},header,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,weekdays.map(function(name,index){return _this2.props.children(index,name);})));}}]);return WeekdayTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);WeekdayTable.propTypes={cssBlockName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,header:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (WeekdayTable);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Checkbox_css__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Checkbox_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * @param {function} onChange ( checked: boolean )
 * @param {boolean} checked
 */var Checkbox=function(_React$Component){_inherits(Checkbox,_React$Component);function Checkbox(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Checkbox);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Checkbox.__proto__||Object.getPrototypeOf(Checkbox)).call.apply(_ref,[this].concat(args))),_this),_this.onClick=function(){var _this$props=_this.props,checked=_this$props.checked,disabled=_this$props.disabled,onChange=_this$props.onChange;if(!disabled&&onChange!==undefined){_this.props.onChange(!checked);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Checkbox,[{key:"render",value:function render(){var _props=this.props,checked=_props.checked,disabled=_props.disabled,cssModifier=_props.cssModifier;var classNames=["checkbox"];if(checked){classNames.push("checkbox--checked");}else{classNames.push("checkbox--unchecked");}if(disabled){classNames.push("checkbox--disabled");}if(cssModifier){classNames.push("checkbox--"+cssModifier);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:classNames.join(" "),onClick:this.onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"checkbox__mark"}));}}]);return Checkbox;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Checkbox.propTypes={checked:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,cssModifier:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Checkbox.defaultProps={checked:false,disabled:false};/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BasketModificationModal_css__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BasketModificationModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BasketModificationModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BasketModificationModal=function(_React$Component){_inherits(BasketModificationModal,_React$Component);function BasketModificationModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BasketModificationModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BasketModificationModal.__proto__||Object.getPrototypeOf(BasketModificationModal)).call.apply(_ref,[this].concat(args))),_this),_this.cancel=function(){_this.props.onClose(false);},_this.remove=function(){_this.props.onClose(true);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BasketModificationModal,[{key:"render",value:function render(){var _props=this.props,isOpen=_props.isOpen,itemName=_props.itemName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ModalDialog__["a" /* default */],{isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-modification-modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-modification-modal__heading"},"Attention"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-modification-modal__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"This ",itemName," has already been added to the basket. Making changes to this ",itemName," will remove it from the basket."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Are you sure you wish to continue?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-modification-modal__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Button__["a" /* default */],{className:"basket-modification-modal__cancel-button",onClick:this.cancel},"Cancel"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Button__["a" /* default */],{className:"basket-modification-modal__remove-button",onClick:this.remove},"Remove"))));}}]);return BasketModificationModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);BasketModificationModal.propTypes={onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,itemName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};BasketModificationModal.defaultProps={itemName:"item"};/* harmony default export */ __webpack_exports__["a"] = (BasketModificationModal);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_school_money_AddButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_school_money_RemoveButton__ = __webpack_require__(48);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Displays either an add or a remove button, depending on the value is
 *   the isAdded prop
 */var AddOrRemoveButton=function(_React$Component){_inherits(AddOrRemoveButton,_React$Component);function AddOrRemoveButton(){_classCallCheck(this,AddOrRemoveButton);return _possibleConstructorReturn(this,(AddOrRemoveButton.__proto__||Object.getPrototypeOf(AddOrRemoveButton)).apply(this,arguments));}_createClass(AddOrRemoveButton,[{key:"render",value:function render(){var _props=this.props,cssBlockName=_props.cssBlockName,isAdded=_props.isAdded,onAdd=_props.onAdd,onRemove=_props.onRemove;if(isAdded){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_school_money_RemoveButton__["a" /* default */],{className:cssBlockName+"__remove-button",onClick:onRemove});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_school_money_AddButton__["a" /* default */],{className:cssBlockName+"__add-button",onClick:onAdd});}}]);return AddOrRemoveButton;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);AddOrRemoveButton.propTypes={cssBlockName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,isAdded:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,onAdd:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onRemove:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (AddOrRemoveButton);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(202);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(53);
var core = __webpack_require__(68);
var hide = __webpack_require__(85);
var redefine = __webpack_require__(222);
var ctx = __webpack_require__(223);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(89);
var toLength = __webpack_require__(228);
var toAbsoluteIndex = __webpack_require__(229);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(53);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(70);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(129);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(245);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__createHashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(247);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(71);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(55);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(70);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(72);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(93);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCATION_CHANGE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = routerReducer;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  location: null

  /**
   * This reducer will update the state with the most recent location history
   * has transitioned to. This may not be in sync with the router, particularly
   * if you have asynchronously-loaded routes, so reading from and relying on
   * this state is discouraged.
   */
};function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { location: payload });
  }

  return state;
}

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALL_HISTORY_METHOD; });
/* unused harmony export push */
/* unused harmony export replace */
/* unused harmony export go */
/* unused harmony export goBack */
/* unused harmony export goForward */
/* unused harmony export routerActions */

/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = updateLocation('push');
var replace = updateLocation('replace');
var go = updateLocation('go');
var goBack = updateLocation('goBack');
var goForward = updateLocation('goForward');

var routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(137);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(265);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(258);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(144);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(94);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_middleware__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_runSaga__ = __webpack_require__(147);
/* unused harmony reexport runSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_channel__ = __webpack_require__(43);
/* unused harmony reexport END */
/* unused harmony reexport eventChannel */
/* unused harmony reexport channel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_buffers__ = __webpack_require__(73);
/* unused harmony reexport buffers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_sagaHelpers__ = __webpack_require__(149);
/* unused harmony reexport takeEvery */
/* unused harmony reexport takeLatest */
/* unused harmony reexport throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_utils__ = __webpack_require__(25);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__internal_utils__["j"]; });
/* unused harmony reexport CANCEL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_io__ = __webpack_require__(38);
/* unused harmony reexport detach */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(150);
/* unused harmony reexport effects */
/* unused harmony reexport utils */

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__internal_middleware__["a" /* default */]);













/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = asap;
/* harmony export (immutable) */ __webpack_exports__["c"] = suspend;
/* harmony export (immutable) */ __webpack_exports__["b"] = flush;
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/
var semaphore = 0;

/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/
function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}

/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/
function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}

/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/
function suspend() {
  semaphore++;
}

/**
  Puts the scheduler in a `released` state.
**/
function release() {
  semaphore--;
}

/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/
function flush() {
  release();

  var task = void 0;
  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = runSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__proc__ = __webpack_require__(148);



var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';

function runSaga(storeInterface, saga) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator = void 0;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(storeInterface)) {
    if (false) {
      log('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
    }
    iterator = storeInterface;
    storeInterface = saga;
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(saga, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func, NON_GENERATOR_ERR);
    iterator = saga.apply(undefined, args);
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NON_GENERATOR_ERR);
  }

  var _storeInterface = storeInterface,
      subscribe = _storeInterface.subscribe,
      dispatch = _storeInterface.dispatch,
      getState = _storeInterface.getState,
      context = _storeInterface.context,
      sagaMonitor = _storeInterface.sagaMonitor,
      logger = _storeInterface.logger,
      onError = _storeInterface.onError;


  var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
  }

  var task = Object(__WEBPACK_IMPORTED_MODULE_1__proc__["a" /* default */])(iterator, subscribe, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["x" /* wrapSagaDispatch */])(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);

  if (sagaMonitor) {
    sagaMonitor.effectResolved(effectId, task);
  }

  return task;
}

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NOT_ITERATOR_ERROR */
/* unused harmony export CHANNEL_END */
/* unused harmony export TASK_CANCEL */
/* harmony export (immutable) */ __webpack_exports__["a"] = proc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__io__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__channel__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buffers__ = __webpack_require__(73);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }







var NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';

var CHANNEL_END = {
  toString: function toString() {
    return '@@redux-saga/CHANNEL_END';
  }
};
var TASK_CANCEL = {
  toString: function toString() {
    return '@@redux-saga/TASK_CANCEL';
  }
};

var matchers = {
  wildcard: function wildcard() {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["o" /* kTrue */];
  },
  default: function _default(pattern) {
    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
      return input.type === pattern;
    } : function (input) {
      return input.type === String(pattern);
    };
  },
  array: function array(patterns) {
    return function (input) {
      return patterns.some(function (p) {
        return matcher(p)(input);
      });
    };
  },
  predicate: function predicate(_predicate) {
    return function (input) {
      return _predicate(input);
    };
  }
};

function matcher(pattern) {
  // prettier-ignore
  return (pattern === '*' ? matchers.wildcard : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(pattern) ? matchers.array : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].stringableFunc(pattern) ? matchers.default : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(pattern) ? matchers.predicate : matchers.default)(pattern);
}

/**
  Used to track a parent task and its forks
  In the new fork model, forked tasks are attached by default to their parent
  We model this using the concept of Parent task && main Task
  main task is the main flow of the current Generator, the parent tasks is the
  aggregation of the main tasks + all its forked tasks.
  Thus the whole model represents an execution tree with multiple branches (vs the
  linear execution tree in sequential (non parallel) programming)

  A parent tasks has the following semantics
  - It completes if all its forks either complete or all cancelled
  - If it's cancelled, all forks are cancelled as well
  - It aborts if any uncaught error bubbles up from forks
  - If it completes, the return value is the one returned by the main task
**/
function forkQueue(name, mainTask, cb) {
  var tasks = [],
      result = void 0,
      completed = false;
  addTask(mainTask);

  function abort(err) {
    cancelAll();
    cb(err, true);
  }

  function addTask(task) {
    tasks.push(task);
    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(tasks, task);
      task.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }
        if (!tasks.length) {
          completed = true;
          cb(result);
        }
      }
    };
    // task.cont.cancel = task.cancel
  }

  function cancelAll() {
    if (completed) {
      return;
    }
    completed = true;
    tasks.forEach(function (t) {
      t.cont = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: function getTasks() {
      return tasks;
    },
    taskNames: function taskNames() {
      return tasks.map(function (t) {
        return t.name;
      });
    }
  };
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(fn)) {
    return fn;
  }

  // catch synchronous failures; see #152 and #441
  var result = void 0,
      error = void 0;
  try {
    result = fn.apply(context, args);
  } catch (err) {
    error = err;
  }

  // i.e. a generator function returns an iterator
  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result)) {
    return result;
  }

  // do not bubble up synchronous failures for detached forks
  // instead create a failed task. See #152 and #441
  return error ? Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    throw error;
  }) : Object(__WEBPACK_IMPORTED_MODULE_0__utils__["q" /* makeIterator */])(function () {
    var pc = void 0;
    var eff = { done: false, value: result };
    var ret = function ret(value) {
      return { done: true, value: value };
    };
    return function (arg) {
      if (!pc) {
        pc = true;
        return eff;
      } else {
        return ret(arg);
      }
    };
  }());
}

var wrapHelper = function wrapHelper(helper) {
  return { fn: helper };
};

function proc(iterator) {
  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  };
  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
  var cont = arguments[8];

  Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(iterator, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator, NOT_ITERATOR_ERROR);

  var effectsString = '[...effects]';
  var runParallelEffect = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["k" /* deprecate */])(runAllEffect, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["w" /* updateIncentive */])(effectsString, 'all(' + effectsString + ')'));

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;

  var log = logger || __WEBPACK_IMPORTED_MODULE_0__utils__["p" /* log */];
  var logError = function logError(err) {
    var message = err.sagaStack;

    if (!message && err.stack) {
      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
    }

    log('error', 'uncaught at ' + name, message || err.message || err);
  };
  var stdChannel = Object(__WEBPACK_IMPORTED_MODULE_3__channel__["e" /* stdChannel */])(subscribe);
  var taskContext = Object.create(parentContext);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/
  next.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

  /**
    Creates a new task descriptor for this generator, We'll also create a main task
    to track the main flow (besides other forked tasks)
  **/
  var task = newTask(parentEffectId, name, iterator, cont);
  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
  var taskQueue = forkQueue(name, mainTask, end);

  /**
    cancellation of the main task. We'll simply resume the Generator with a Cancel
  **/
  function cancelMain() {
    if (mainTask.isRunning && !mainTask.isCancelled) {
      mainTask.isCancelled = true;
      next(TASK_CANCEL);
    }
  }

  /**
    This may be called by a parent generator to trigger/propagate cancellation
    cancel all pending tasks (including the main task), then end the current task.
     Cancellation propagates down to the whole execution tree holded by this Parent task
    It's also propagated to all joiners of this task and their execution tree/joiners
     Cancellation is noop for terminated/Cancelled tasks tasks
  **/
  function cancel() {
    /**
      We need to check both Running and Cancelled status
      Tasks can be Cancelled but still Running
    **/
    if (iterator._isRunning && !iterator._isCancelled) {
      iterator._isCancelled = true;
      taskQueue.cancelAll();
      /**
        Ending with a Never result will propagate the Cancellation to all joiners
      **/
      end(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/
  cont && (cont.cancel = cancel);

  // tracks the running status
  iterator._isRunning = true;

  // kicks up the generator
  next();

  // then return the task descriptor to the caller
  return task;

  /**
    This is the generator driver
    It's a recursive async/continuation function which calls itself
    until the generator terminates or throws
  **/
  function next(arg, isErr) {
    // Preventive measure. If we end up here, then there is really something wrong
    if (!mainTask.isRunning) {
      throw new Error('Trying to resume an already finished generator');
    }

    try {
      var result = void 0;
      if (isErr) {
        result = iterator.throw(arg);
      } else if (arg === TASK_CANCEL) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.isCancelled = true;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/
        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
      } else if (arg === CHANNEL_END) {
        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(iterator.return) ? iterator.return() : { done: true };
      } else {
        result = iterator.next(arg);
      }

      if (!result.done) {
        runEffect(result.value, parentEffectId, '', next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        mainTask.isMainRunning = false;
        mainTask.cont && mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.isCancelled) {
        logError(error);
      }
      mainTask.isMainRunning = false;
      mainTask.cont(error, true);
    }
  }

  function end(result, isErr) {
    iterator._isRunning = false;
    stdChannel.close();
    if (!isErr) {
      iterator._result = result;
      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
    } else {
      if (result instanceof Error) {
        Object.defineProperty(result, 'sagaStack', {
          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
          configurable: true
        });
      }
      if (!task.cont) {
        if (result instanceof Error && onError) {
          onError(result);
        } else {
          logError(result);
        }
      }
      iterator._error = result;
      iterator._isAborted = true;
      iterator._deferredEnd && iterator._deferredEnd.reject(result);
    }
    task.cont && task.cont(result, isErr);
    task.joiners.forEach(function (j) {
      return j.cb(result, isErr);
    });
    task.joiners = null;
  }

  function runEffect(effect, parentEffectId) {
    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var cb = arguments[3];

    var effectId = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["v" /* uid */])();
    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });

    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/
    var effectSettled = void 0;

    // Completion callback passed to the appropriate effect runner
    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure
      if (sagaMonitor) {
        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
      }
      cb(res, isErr);
    }
    // tracks down the current cancel
    currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];

    // setup cancellation logic on the parent cb
    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      /**
        propagates cancel downward
        catch uncaught cancellations errors; since we can no longer call the completion
        callback, log errors raised during cancellations into the console
      **/
      try {
        currCb.cancel();
      } catch (err) {
        logError(err);
      }
      currCb.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]; // defensive measure

      sagaMonitor && sagaMonitor.effectCancelled(effectId);
    };

    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      for completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    var data = void 0;
    // prettier-ignore
    return (
      // Non declarative effect
      __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(effect) ? resolvePromise(effect, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(effect) ? resolveIterator(effect, effectId, name, currCb)

      // declarative effects
      : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].take(effect)) ? runTakeEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].put(effect)) ? runPutEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].all(effect)) ? runAllEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].call(effect)) ? runCallEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cps(effect)) ? runCPSEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].join(effect)) ? runJoinEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cancel(effect)) ? runCancelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].select(effect)) ? runSelectEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].flush(effect)) ? runFlushEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].getContext(effect)) ? runGetContextEffect(data, currCb) : (data = __WEBPACK_IMPORTED_MODULE_2__io__["c" /* asEffect */].setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
    );
  }

  function resolvePromise(promise, cb) {
    var cancelPromise = promise[__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* CANCEL */]];
    if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(cancelPromise)) {
      cb.cancel = cancelPromise;
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(promise.abort)) {
      cb.cancel = function () {
        return promise.abort();
      };
      // TODO: add support for the fetch API, whenever they get around to
      // adding cancel support
    }
    promise.then(cb, function (error) {
      return cb(error, true);
    });
  }

  function resolveIterator(iterator, effectId, name, cb) {
    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
  }

  function runTakeEffect(_ref2, cb) {
    var channel = _ref2.channel,
        pattern = _ref2.pattern,
        maybe = _ref2.maybe;

    channel = channel || stdChannel;
    var takeCb = function takeCb(inp) {
      return inp instanceof Error ? cb(inp, true) : Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
    };
    try {
      channel.take(takeCb, matcher(pattern));
    } catch (err) {
      return cb(err, true);
    }
    cb.cancel = takeCb.cancel;
  }

  function runPutEffect(_ref3, cb) {
    var channel = _ref3.channel,
        action = _ref3.action,
        resolve = _ref3.resolve;

    /**
      Schedule the put in case another saga is holding a lock.
      The put will be executed atomically. ie nested puts will execute after
      this put has terminated.
    **/
    Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["a" /* asap */])(function () {
      var result = void 0;
      try {
        result = (channel ? channel.put : dispatch)(action);
      } catch (error) {
        // If we have a channel or `put.resolve` was used then bubble up the error.
        if (channel || resolve) return cb(error, true);
        logError(error);
      }

      if (resolve && __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result)) {
        resolvePromise(result, cb);
      } else {
        return cb(result);
      }
    });
    // Put effects are non cancellables
  }

  function runCallEffect(_ref4, effectId, cb) {
    var context = _ref4.context,
        fn = _ref4.fn,
        args = _ref4.args;

    var result = void 0;
    // catch synchronous failures; see #152
    try {
      result = fn.apply(context, args);
    } catch (error) {
      return cb(error, true);
    }
    return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].promise(result) ? resolvePromise(result, cb) : __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
  }

  function runCPSEffect(_ref5, cb) {
    var context = _ref5.context,
        fn = _ref5.fn,
        args = _ref5.args;

    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb

    // catch synchronous failures; see #152
    try {
      var cpsCb = function cpsCb(err, res) {
        return __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].undef(err) ? cb(res) : cb(err, true);
      };
      fn.apply(context, args.concat(cpsCb));
      if (cpsCb.cancel) {
        cb.cancel = function () {
          return cpsCb.cancel();
        };
      }
    } catch (error) {
      return cb(error, true);
    }
  }

  function runForkEffect(_ref6, effectId, cb) {
    var context = _ref6.context,
        fn = _ref6.fn,
        args = _ref6.args,
        detached = _ref6.detached;

    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });

    try {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["c" /* suspend */])();
      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */]);

      if (detached) {
        cb(_task);
      } else {
        if (taskIterator._isRunning) {
          taskQueue.addTask(_task);
          cb(_task);
        } else if (taskIterator._error) {
          taskQueue.abort(taskIterator._error);
        } else {
          cb(_task);
        }
      }
    } finally {
      Object(__WEBPACK_IMPORTED_MODULE_1__scheduler__["b" /* flush */])();
    }
    // Fork effects are non cancellables
  }

  function runJoinEffect(t, cb) {
    if (t.isRunning()) {
      var joiner = { task: task, cb: cb };
      cb.cancel = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["t" /* remove */])(t.joiners, joiner);
      };
      t.joiners.push(joiner);
    } else {
      t.isAborted() ? cb(t.error(), true) : cb(t.result());
    }
  }

  function runCancelEffect(taskToCancel, cb) {
    if (taskToCancel === __WEBPACK_IMPORTED_MODULE_0__utils__["d" /* SELF_CANCELLATION */]) {
      taskToCancel = task;
    }
    if (taskToCancel.isRunning()) {
      taskToCancel.cancel();
    }
    cb();
    // cancel effects are non cancellables
  }

  function runAllEffect(effects, effectId, cb) {
    var keys = Object.keys(effects);

    if (!keys.length) {
      return cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [] : {});
    }

    var completedCount = 0;
    var completed = void 0;
    var results = {};
    var childCbs = {};

    function checkEffectEnd() {
      if (completedCount === keys.length) {
        completed = true;
        cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? __WEBPACK_IMPORTED_MODULE_0__utils__["f" /* array */].from(_extends({}, results, { length: keys.length })) : results);
      }
    }

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }
        if (isErr || Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) || res === CHANNEL_END || res === TASK_CANCEL) {
          cb.cancel();
          cb(res, isErr);
        } else {
          results[key] = res;
          completedCount++;
          checkEffectEnd();
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };

    keys.forEach(function (key) {
      return runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runRaceEffect(effects, effectId, cb) {
    var completed = void 0;
    var keys = Object.keys(effects);
    var childCbs = {};

    keys.forEach(function (key) {
      var chCbAtKey = function chCbAtKey(res, isErr) {
        if (completed) {
          return;
        }

        if (isErr) {
          // Race Auto cancellation
          cb.cancel();
          cb(res, true);
        } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__channel__["d" /* isEnd */])(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
          var _response;

          cb.cancel();
          completed = true;
          var response = (_response = {}, _response[key] = res, _response);
          cb(__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
        }
      };
      chCbAtKey.cancel = __WEBPACK_IMPORTED_MODULE_0__utils__["r" /* noop */];
      childCbs[key] = chCbAtKey;
    });

    cb.cancel = function () {
      // prevents unnecessary cancellation
      if (!completed) {
        completed = true;
        keys.forEach(function (key) {
          return childCbs[key].cancel();
        });
      }
    };
    keys.forEach(function (key) {
      if (completed) {
        return;
      }
      runEffect(effects[key], effectId, key, childCbs[key]);
    });
  }

  function runSelectEffect(_ref7, cb) {
    var selector = _ref7.selector,
        args = _ref7.args;

    try {
      var state = selector.apply(undefined, [getState()].concat(args));
      cb(state);
    } catch (error) {
      cb(error, true);
    }
  }

  function runChannelEffect(_ref8, cb) {
    var pattern = _ref8.pattern,
        buffer = _ref8.buffer;

    var match = matcher(pattern);
    match.pattern = pattern;
    cb(Object(__WEBPACK_IMPORTED_MODULE_3__channel__["c" /* eventChannel */])(subscribe, buffer || __WEBPACK_IMPORTED_MODULE_4__buffers__["a" /* buffers */].fixed(), match));
  }

  function runCancelledEffect(data, cb) {
    cb(!!mainTask.isCancelled);
  }

  function runFlushEffect(channel, cb) {
    channel.flush(cb);
  }

  function runGetContextEffect(prop, cb) {
    cb(taskContext[prop]);
  }

  function runSetContextEffect(props, cb) {
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    cb();
  }

  function newTask(id, name, iterator, cont) {
    var _done, _ref9, _mutatorMap;

    iterator._deferredEnd = null;
    return _ref9 = {}, _ref9[__WEBPACK_IMPORTED_MODULE_0__utils__["e" /* TASK */]] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
      if (iterator._deferredEnd) {
        return iterator._deferredEnd.promise;
      } else {
        var def = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["i" /* deferred */])();
        iterator._deferredEnd = def;
        if (!iterator._isRunning) {
          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
        }
        return def.promise;
      }
    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
      return iterator._isRunning;
    }, _ref9.isCancelled = function isCancelled() {
      return iterator._isCancelled;
    }, _ref9.isAborted = function isAborted() {
      return iterator._isAborted;
    }, _ref9.result = function result() {
      return iterator._result;
    }, _ref9.error = function error() {
      return iterator._error;
    }, _ref9.setContext = function setContext(props) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('task', props));
      __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(taskContext, props);
    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
  }
}

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export takeEvery */
/* unused harmony export takeLatest */
/* unused harmony export throttle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__takeEvery__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__takeLatest__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__throttle__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(25);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__takeEvery__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__takeLatest__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__throttle__["a"]; });






var deprecationWarning = function deprecationWarning(helperName) {
  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
};

var takeEvery = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_0__takeEvery__["a" /* default */], /*#__PURE__*/deprecationWarning('takeEvery'));
var takeLatest = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_1__takeLatest__["a" /* default */], /*#__PURE__*/deprecationWarning('takeLatest'));
var throttle = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__utils__["k" /* deprecate */])(__WEBPACK_IMPORTED_MODULE_2__throttle__["a" /* default */], /*#__PURE__*/deprecationWarning('throttle'));



/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(25);
/* unused harmony reexport TASK */
/* unused harmony reexport SAGA_ACTION */
/* unused harmony reexport noop */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__internal_utils__["n"]; });
/* unused harmony reexport deferred */
/* unused harmony reexport arrayOfDeffered */
/* unused harmony reexport createMockTask */
/* unused harmony reexport cloneableGenerator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_io__ = __webpack_require__(38);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__internal_io__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_proc__ = __webpack_require__(148);
/* unused harmony reexport CHANNEL_END */




/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(291);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);
var settle = __webpack_require__(295);
var buildURL = __webpack_require__(297);
var parseHeaders = __webpack_require__(298);
var isURLSameOrigin = __webpack_require__(299);
var createError = __webpack_require__(154);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(300);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(301);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(296);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * UnexpectedAPIResponseFormatError
 * Used when the API fails a basic schema check
 */var UnexpectedAPIResponseFormatError=function(_Error){_inherits(UnexpectedAPIResponseFormatError,_Error);function UnexpectedAPIResponseFormatError(response){_classCallCheck(this,UnexpectedAPIResponseFormatError);var _this=_possibleConstructorReturn(this,(UnexpectedAPIResponseFormatError.__proto__||Object.getPrototypeOf(UnexpectedAPIResponseFormatError)).call(this,"Response data is not in the correct format."));_this.response=response;_this.type=UnexpectedAPIResponseFormatError.type;return _this;}// TODO: this is duck-typing, because babel is broken
return UnexpectedAPIResponseFormatError;}(Error);UnexpectedAPIResponseFormatError.type="UnexpectedAPIResponseFormatError";/* harmony default export */ __webpack_exports__["a"] = (UnexpectedAPIResponseFormatError);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * ResponseStatusError
 * used when response status is error but we didn't recognise the error code
 */var UnrecognisedResponseCodeError=function(_Error){_inherits(UnrecognisedResponseCodeError,_Error);function UnrecognisedResponseCodeError(response){_classCallCheck(this,UnrecognisedResponseCodeError);var _response$data=response.data,code=_response$data.code,message=_response$data.message;var _this=_possibleConstructorReturn(this,(UnrecognisedResponseCodeError.__proto__||Object.getPrototypeOf(UnrecognisedResponseCodeError)).call(this,"Unknown response code: "+code+": "+message));_this.response=response;_this.type=UnrecognisedResponseCodeError.type;return _this;}// TODO: this is duck-typing, because babel is broken
return UnrecognisedResponseCodeError;}(Error);UnrecognisedResponseCodeError.type="UnrecognisedResponseCodeError";/* harmony default export */ __webpack_exports__["a"] = (UnrecognisedResponseCodeError);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * UnknownDeviceError
 * Thrown when we get UNKNOWN_DEVICE from appserver.
 */var UnknownDeviceError=function(_Error){_inherits(UnknownDeviceError,_Error);// TODO: this is duck-typing, because babel is broken
function UnknownDeviceError(response){_classCallCheck(this,UnknownDeviceError);var _this=_possibleConstructorReturn(this,(UnknownDeviceError.__proto__||Object.getPrototypeOf(UnknownDeviceError)).call(this,"This device was not recognised by appserver."));_this.response=response;_this.type=UnknownDeviceError.type;return _this;}return UnknownDeviceError;}(Error);UnknownDeviceError.type="UnknownDeviceError";UnknownDeviceError.responseCode="UNKNOWN_DEVICE";/* harmony default export */ __webpack_exports__["a"] = (UnknownDeviceError);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getErrorCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_appserver_responseExceptions_RemoteServerCompleteFailureError__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_appserver_responseExceptions_UnexpectedAPIResponseFormatError__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_responseExceptions_UnknownDeviceError__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_appserver_responseExceptions_UnrecognisedResponseCodeError__ = __webpack_require__(158);
function getErrorCode(error){if(error.type!==undefined){if(error.type===__WEBPACK_IMPORTED_MODULE_0_lib_appserver_responseExceptions_RemoteServerCompleteFailureError__["a" /* default */].type){return"API_ERROR - APP_001";}else if(error.type===__WEBPACK_IMPORTED_MODULE_1_lib_appserver_responseExceptions_UnexpectedAPIResponseFormatError__["a" /* default */].type||error.type===__WEBPACK_IMPORTED_MODULE_3_lib_appserver_responseExceptions_UnrecognisedResponseCodeError__["a" /* default */].type){return"API_DATA_ERROR - APP_002";}else if(error.type===__WEBPACK_IMPORTED_MODULE_2_lib_appserver_responseExceptions_UnknownDeviceError__["a" /* default */].type){return"UNKNOWN_DEVICE - APP_003";}}// If this is a React error then then name will be Error
if(error.name==="Error"){return"INTERNAL_ERROR - APP_004";}return"UNKNOWN_ERROR - APP_005";}

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_money__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_common__ = __webpack_require__(56);
/**
 * Max quantity of each shop item allowed in basket per student.
 * May be unreachable if shop item quantity available is lower.
 */var MAX_BASKET_QUANTITY=100;var ShopItem=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record(Object.assign({},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_common__["b" /* defaultProperties */],{name:undefined,price:undefined,quantity:undefined}),"ShopItem");function buildShopItemFromAppserver(rawShopItem){return ShopItem(Object.assign({name:rawShopItem.name,price:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawShopItem.price),quantity:rawShopItem.quantity},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_common__["a" /* appserverAdapter */](rawShopItem)));}ShopItem.MAX_BASKET_QUANTITY=MAX_BASKET_QUANTITY;ShopItem.fromAppserver=buildShopItemFromAppserver;/* harmony default export */ __webpack_exports__["a"] = (ShopItem);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ClubBooking */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_money__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_studentLinked__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_entities_ClubBooking_ClubSession__ = __webpack_require__(371);
/* unused harmony reexport ClubSession */
var ClubBooking=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record(Object.assign({},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_studentLinked__["b" /* defaultProperties */],{remotePaymentID:undefined,remoteInstallmentID:undefined,description:undefined,startDate:undefined,endDate:undefined,lastModifiedDate:undefined,paidAmount:undefined,outstandingAmount:undefined,isReservationsEnabled:undefined,requiresParentalConsent:undefined,isParentalConsentGiven:undefined,hasLimitedPlaces:undefined,dailyPlacesLimit:undefined,placesLimitReached:undefined,sessions:undefined,bookedSessionIDs:undefined,selectedSessionIDs:undefined,dates:undefined,holidays:undefined,expired:undefined,forceSessionBooking:undefined}),"ClubBooking");function buildClubBookingFromAppserver(rawPayment){var rawClubBooking=rawPayment.payload;// TODO: fix on server end (hopefully?)
rawPayment.student_fk=rawClubBooking.student_fk;var props=Object.assign({},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_studentLinked__["a" /* appserverAdapter */](rawPayment),{remotePaymentID:rawClubBooking.payment_fk,remoteInstallmentID:rawClubBooking.installment_fk,description:rawClubBooking.description,startDate:rawClubBooking.club_start_date,endDate:rawClubBooking.club_end_date,lastModifiedDate:rawClubBooking.last_modified_date_time,paidAmount:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawClubBooking.previous_amount),outstandingAmount:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawClubBooking.outstanding),isReservationsEnabled:rawClubBooking.enable_reservations,requiresParentalConsent:rawClubBooking.requires_parental_consent,isParentalConsentGiven:rawClubBooking.consent_date!=="",hasLimitedPlaces:rawClubBooking.daily_places_limit!==-1,placesLimitReached:buildPlacesLimitReachedFromAppserver(rawClubBooking),sessions:buildSessionsFromAppserver(rawClubBooking),bookedSessionIDs:buildBookedSessionIDsFromAppserver(rawClubBooking),dates:buildDatesFromAppserver(rawClubBooking),holidays:buildHolidaysFromAppserver(rawClubBooking),expired:buildExpiredFromAppserver(rawClubBooking),dailyPlacesLimit:rawClubBooking.daily_places_limit,forceSessionBooking:rawClubBooking.force_session_booking});props.selectedSessionIDs=props.bookedSessionIDs;props.placesTotal=props.hasLimitedPlaces?rawClubBooking.daily_places_limit:null;return ClubBooking(props);}function buildSessionsFromAppserver(rawClubBooking){var sessionList=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.List(Object.values(rawClubBooking.club_sessions)).filter(function(rawClubSession){return rawClubSession.price!==-1;}).map(__WEBPACK_IMPORTED_MODULE_3_state_school_money_entities_ClubBooking_ClubSession__["a" /* default */].fromAppserver);return new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map(sessionList.map(function(session){return[session.id,session];}));}function buildBookedSessionIDsFromAppserver(rawClubBooking){return getBookingsFromAppserver(rawClubBooking).map(function(rawBookedSession){if(rawBookedSession.status==="Y"){return rawBookedSession.session_booked.id;}return null;});}function buildPlacesLimitReachedFromAppserver(rawClubBooking){return getBookingsFromAppserver(rawClubBooking).map(function(rawBookedSession){return rawBookedSession.places_available<=0;});}function buildDatesFromAppserver(rawClubBooking){return getBookingsFromAppserver(rawClubBooking).map(function(_ref){var club_date=_ref.club_date;return club_date;});}function buildHolidaysFromAppserver(rawClubBooking){return getBookingsFromAppserver(rawClubBooking).map(function(rawBookedSession){return rawBookedSession.status==="HOLIDAY";});}function buildExpiredFromAppserver(rawClubBooking){return getBookingsFromAppserver(rawClubBooking).map(function(rawBookedSession){return rawBookedSession.expired;});}function getBookingsFromAppserver(rawClubBooking){return new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.List([rawClubBooking.monday_booking,rawClubBooking.tuesday_booking,rawClubBooking.wednesday_booking,rawClubBooking.thursday_booking,rawClubBooking.friday_booking]);}ClubBooking.ClubSession=__WEBPACK_IMPORTED_MODULE_3_state_school_money_entities_ClubBooking_ClubSession__["a" /* default */];ClubBooking.fromAppserver=buildClubBookingFromAppserver;/* harmony default export */ __webpack_exports__["a"] = (ClubBooking);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DinnerBooking */
/* harmony export (immutable) */ __webpack_exports__["b"] = isCashless;
/* unused harmony export isHoliday */
/* unused harmony export isFSMEligible */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_exact_math__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_exact_math___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_exact_math__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_date__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_money__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_appserver_entityHeaders_studentLinked__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_DinnerBooking_DinnerItem__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_DinnerBooking_BookedOption__ = __webpack_require__(372);
/* unused harmony reexport DinnerItem */
/* unused harmony reexport BookedOption */
var DinnerBooking=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record(Object.assign({},__WEBPACK_IMPORTED_MODULE_4_lib_appserver_entityHeaders_studentLinked__["b" /* defaultProperties */],{remotePaymentID:undefined,remoteInstallmentID:undefined,type:undefined,description:undefined,startDate:undefined,endDate:undefined,isCashless:undefined,availableOptions:undefined,fsmEligibility:undefined,fsmLimitPerDay:undefined,lastModifiedDate:undefined,bookedPrice:undefined,bookedOptions:undefined,selectedOptionIDs:undefined,dates:undefined,holidays:undefined,expired:undefined,totalPaid:undefined}),"Dinner Booking");function buildDinnerBookingFromAppserver(rawPayment){var rawDinnerBooking=rawPayment.payload;// TODO: fix on server end (hopefully?)
rawPayment.student_fk=rawDinnerBooking.student_fk;var props=Object.assign({},__WEBPACK_IMPORTED_MODULE_4_lib_appserver_entityHeaders_studentLinked__["a" /* appserverAdapter */](rawPayment),{remotePaymentID:rawDinnerBooking.payment_fk,remoteInstallmentID:rawDinnerBooking.installment_fk,type:rawDinnerBooking.dinner_type,description:rawDinnerBooking.description,startDate:rawDinnerBooking.dinner_start_date,endDate:rawDinnerBooking.dinner_end_date,isCashless:isCashless(rawDinnerBooking),availableOptions:buildAvailableOptionsFromAppserver(rawDinnerBooking),fsmEligibility:getFSMEligibility(rawDinnerBooking),fsmLimitPerDay:Object(__WEBPACK_IMPORTED_MODULE_3_lib_money__["a" /* floatToMoney */])(rawDinnerBooking.fsm_limit_per_day),lastModifiedDate:rawDinnerBooking.last_modified_date_time,bookedPrice:Object(__WEBPACK_IMPORTED_MODULE_3_lib_money__["a" /* floatToMoney */])(rawDinnerBooking.previous_amount),bookedOptions:buildBookedOptionsFromAppserver(rawDinnerBooking),dates:buildDatesFromAppserver(rawDinnerBooking),holidays:buildHolidaysFromAppserver(rawDinnerBooking),expired:buildExpiredFromAppserver(rawDinnerBooking),totalPaid:Object(__WEBPACK_IMPORTED_MODULE_3_lib_money__["a" /* floatToMoney */])(rawDinnerBooking.total_paid)});props.selectedOptionIDs=props.bookedOptions.map(function(option){return option.id;});return DinnerBooking(props);}function buildAvailableOptionsFromAppserver(rawDinnerBooking){var availableOptions=void 0;if(isCashless(rawDinnerBooking)){availableOptions=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.List(rawDinnerBooking.dinner_items.map(__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_DinnerBooking_DinnerItem__["a" /* default */].fromAppserverCashless));}else{if(rawDinnerBooking.dinner_type==="MEATVEG"){availableOptions=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.List([__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_DinnerBooking_DinnerItem__["a" /* default */].fromAppserverNonCashless(rawDinnerBooking,"NONE"),__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_DinnerBooking_DinnerItem__["a" /* default */].fromAppserverNonCashless(rawDinnerBooking,"MEAT"),__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_DinnerBooking_DinnerItem__["a" /* default */].fromAppserverNonCashless(rawDinnerBooking,"VEG"),__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_DinnerBooking_DinnerItem__["a" /* default */].fromAppserverNonCashless(rawDinnerBooking,"SANDWICH")]);}else{availableOptions=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.List([__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_DinnerBooking_DinnerItem__["a" /* default */].fromAppserverNonCashless(rawDinnerBooking,"NONE"),__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_DinnerBooking_DinnerItem__["a" /* default */].fromAppserverNonCashless(rawDinnerBooking,"MEAL"),__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_DinnerBooking_DinnerItem__["a" /* default */].fromAppserverNonCashless(rawDinnerBooking,"SANDWICH")]);}}return new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.List(__WEBPACK_IMPORTED_MODULE_2_lib_date__["a" /* WEEKDAYS */]).map(function(weekdayname,weekdayIndex){return availableOptions.filter(function(option){return option.availability.get(weekdayIndex);}).map(function(option){var price=option.price;var isFSMEligible=getFSMEligibility(rawDinnerBooking).get(weekdayIndex);if(isFSMEligible&&option.allowFSMPurchase){var fsmLimit=Object(__WEBPACK_IMPORTED_MODULE_3_lib_money__["a" /* floatToMoney */])(rawDinnerBooking.fsm_limit_per_day);if(fsmLimit===null||!isCashless(rawDinnerBooking)){// FSM eligible and non-cashless or unlimited - item is free
price=0;}else{// FSM eligible, cashless with limit - limit is subtracted from price
price=Math.max(0,__WEBPACK_IMPORTED_MODULE_1_exact_math___default.a.sub(price,fsmLimit));}}return option.set("price",price);});});}function buildBookedOptionsFromAppserver(rawDinnerBooking){var fsmStatuses=getFSMEligibility(rawDinnerBooking);var rawBookedOptions=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.List([rawDinnerBooking.monday_booking,rawDinnerBooking.tuesday_booking,rawDinnerBooking.wednesday_booking,rawDinnerBooking.thursday_booking,rawDinnerBooking.friday_booking]);return rawBookedOptions.map(function(rawBookedOption,weekdayIndex){if(isHoliday(rawBookedOption)){return Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_DinnerBooking_BookedOption__["a" /* default */])();}return __WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_DinnerBooking_BookedOption__["a" /* default */].fromAppserver(rawDinnerBooking,rawBookedOption,fsmStatuses.get(weekdayIndex));});}function buildDatesFromAppserver(rawDinnerBooking){return getBookingDays(rawDinnerBooking).map(function(_ref){var dinner_date=_ref.dinner_date;return dinner_date;});}function buildHolidaysFromAppserver(rawDinnerBooking){return getBookingDays(rawDinnerBooking).map(isHoliday);}function buildExpiredFromAppserver(rawDinnerBooking){return getBookingDays(rawDinnerBooking).map(function(_ref2){var expired=_ref2.expired;return expired;});}function isCashless(rawDinnerBooking){return rawDinnerBooking.dinner_type==="CASHLESS";}function isHoliday(rawBookingDay){return rawBookingDay.status==="HOLIDAY";}function isFSMEligible(status){return status!=="PAID";}function getBookingDays(rawDinnerBooking){return new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.List([rawDinnerBooking.monday_booking,rawDinnerBooking.tuesday_booking,rawDinnerBooking.wednesday_booking,rawDinnerBooking.thursday_booking,rawDinnerBooking.friday_booking]);}function getFSMEligibility(rawDinnerBooking){return new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.List([rawDinnerBooking.monday_fsm_status,rawDinnerBooking.tuesday_fsm_status,rawDinnerBooking.wednesday_fsm_status,rawDinnerBooking.thursday_fsm_status,rawDinnerBooking.friday_fsm_status]).map(isFSMEligible);}DinnerBooking.DinnerItem=__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_DinnerBooking_DinnerItem__["a" /* default */];DinnerBooking.BookedOption=__WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_DinnerBooking_BookedOption__["a" /* default */];DinnerBooking.fromAppserver=buildDinnerBookingFromAppserver;/* harmony default export */ __webpack_exports__["a"] = (DinnerBooking);

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DinnerItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_money__ = __webpack_require__(17);
var DinnerItem=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record({id:undefined,name:undefined,price:undefined,availability:undefined,allowFSMPurchase:undefined,allergyInformation:undefined},"Dinner Item");var staticOptions={NONE:{name:"None",isFree:true},MEAL:{name:"Meal",isFree:false},MEAT:{name:"Meat",isFree:false},VEG:{name:"Veg",isFree:false},SANDWICH:{name:"Packed",isFree:true}};function buildDinnerItemFromAppserverCashless(rawDinnerItem){return DinnerItem({id:rawDinnerItem.dinner_item_fk,name:rawDinnerItem.name,price:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawDinnerItem.cost),availability:new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.List([rawDinnerItem.available_monday,rawDinnerItem.available_tuesday,rawDinnerItem.available_wednesday,rawDinnerItem.available_thursday,rawDinnerItem.available_friday]),allowFSMPurchase:!rawDinnerItem.prevent_fsm_purchase,allergyInformation:rawDinnerItem.allergy_information});}function buildDinnerItemFromAppserverNonCashless(rawDinnerBooking,status){var _staticOptions$status=staticOptions[status],name=_staticOptions$status.name,isFree=_staticOptions$status.isFree;return DinnerItem({id:status,name:name,price:isFree?0:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawDinnerBooking.cost_per_dinner),availability:new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.List([true,true,true,true,true]),allowFSMPurchase:true,allergyInformation:""});}DinnerItem.staticOptions=staticOptions;DinnerItem.fromAppserverCashless=buildDinnerItemFromAppserverCashless;DinnerItem.fromAppserverNonCashless=buildDinnerItemFromAppserverNonCashless;/* harmony default export */ __webpack_exports__["a"] = (DinnerItem);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OtherPayment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_appserver_entityHeaders_studentLinked__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_entities_OtherPayment_Installment__ = __webpack_require__(373);
/* unused harmony reexport Installment */
var OtherPayment=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record(Object.assign({},__WEBPACK_IMPORTED_MODULE_1_lib_appserver_entityHeaders_studentLinked__["b" /* defaultProperties */],{remotePaymentID:undefined,remoteInstallmentID:undefined,description:undefined,isPartial:undefined,isVoluntary:undefined,isOfflineOnly:undefined,requiresParentalConsent:undefined,isParentalConsentGiven:undefined,hasLimitedPlaces:undefined,placesTotal:undefined,placesAvailable:undefined,isPlaceReserved:undefined,installments:undefined}),"Other Payment");function buildOtherPaymentFromAppserver(rawPayment){var rawOtherPayment=rawPayment.payload;// TODO: fix on server end (hopefully?)
rawPayment.student_fk=rawOtherPayment.student_fk;var props=Object.assign({},__WEBPACK_IMPORTED_MODULE_1_lib_appserver_entityHeaders_studentLinked__["a" /* appserverAdapter */](rawPayment),{remotePaymentID:rawOtherPayment.payment_fk,remoteInstallmentID:rawOtherPayment.installment_fk,description:rawOtherPayment.description,isPartial:rawOtherPayment.partial_payment,isVoluntary:rawOtherPayment.voluntary_payment,isOfflineOnly:rawOtherPayment.offline_only,requiresParentalConsent:rawOtherPayment.requires_parental_consent,isParentalConsentGiven:rawOtherPayment.consent_date!=="",hasLimitedPlaces:rawOtherPayment.total_places!==-1,isPlaceReserved:rawOtherPayment.is_place_reserved,installments:buildInstallmentsFromAppserver(rawOtherPayment)});props.placesTotal=props.hasLimitedPlaces?rawOtherPayment.total_places:null;props.placesAvailable=props.hasLimitedPlaces?props.placesTotal-rawOtherPayment.places_taken:null;return OtherPayment(props);}function buildInstallmentsFromAppserver(rawOtherPayment){return new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map(rawOtherPayment.installments).map(__WEBPACK_IMPORTED_MODULE_2_state_school_money_entities_OtherPayment_Installment__["a" /* default */].fromAppserver);}OtherPayment.Installment=__WEBPACK_IMPORTED_MODULE_2_state_school_money_entities_OtherPayment_Installment__["a" /* default */];OtherPayment.fromAppserver=buildOtherPaymentFromAppserver;/* harmony default export */ __webpack_exports__["a"] = (OtherPayment);

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(167),
    getRawTag = __webpack_require__(414),
    objectToString = __webpack_require__(415);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(412);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(93);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = __webpack_require__(451);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _ReplaceTransition = __webpack_require__(455);

var _ReplaceTransition2 = _interopRequireDefault(_ReplaceTransition);

var _TransitionGroup = __webpack_require__(176);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Transition = __webpack_require__(174);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  ReplaceTransition: _ReplaceTransition2.default,
  CSSTransition: _CSSTransition2.default
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(3);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(67);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = __webpack_require__(175);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null }; // allows for nested Transitions
  };

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _ref = this.pendingState || this.state,
        status = _ref.status;

    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var nextStatus = this.nextStatus;

    if (nextStatus !== null) {
      this.nextStatus = null;
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    var _this4 = this;

    // We need to track pending updates for instances where a cWRP fires quickly
    // after cDM and before the state flushes, which would double trigger a
    // transition
    this.pendingState = nextState;

    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, function () {
      _this4.pendingState = null;
      callback();
    });
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this5 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this5.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = Transition;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ChildMapping = __webpack_require__(456);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
    * A convenience prop that enables or disables exit animations
    * for all children. Note that specifying this will override any defaults set
    * on individual children Transitions.
    */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};

/**
 * The `<TransitionGroup>` component manages a set of `<Transition>` components
 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
 * state machine for managing the mounting and unmounting of components over
 * time.
 *
 * Consider the example below using the `Fade` CSS transition from before.
 * As items are removed or added to the TodoList the `in` prop is toggled
 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
 * component in a `<TransitionGroup>`, not just css.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual `<Transition>`
 * components. This means you can mix and match animations across different
 * list items.
 */

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    // Initial children should all be entering, dependent on appear
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
        return (0, _react.cloneElement)(child, {
          onExited: _this.handleExited.bind(_this, child),
          in: true,
          appear: _this.getProp(child, 'appear'),
          enter: _this.getProp(child, 'enter'),
          exit: _this.getProp(child, 'exit')
        });
      })
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };
  // use child config unless explictly set by the Group


  TransitionGroup.prototype.getProp = function getProp(child, prop) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;

    return props[prop] != null ? props[prop] : child.props[prop];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var prevChildMapping = this.state.children;
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);

    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);

    Object.keys(children).forEach(function (key) {
      var child = children[key];

      if (!(0, _react.isValidElement)(child)) return;

      var hasPrev = key in prevChildMapping;
      var hasNext = key in nextChildMapping;

      var prevChild = prevChildMapping[key];
      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

      // item is new (entering)
      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
          onExited: _this2.handleExited.bind(_this2, child),
          in: true,
          exit: _this2.getProp(child, 'exit', nextProps),
          enter: _this2.getProp(child, 'enter', nextProps)
        });
      }
      // item is old (exiting)
      else if (!hasNext && hasPrev && !isLeaving) {
          // console.log('leaving', key)
          children[key] = (0, _react.cloneElement)(child, { in: false });
        }
        // item hasn't changed transition states
        // copy over the last transition props;
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
            // console.log('unchanged', key)
            children[key] = (0, _react.cloneElement)(child, {
              onExited: _this2.handleExited.bind(_this2, child),
              in: prevChild.props.in,
              exit: _this2.getProp(child, 'exit', nextProps),
              enter: _this2.getProp(child, 'enter', nextProps)
            });
          }
    });

    this.setState({ children: children });
  };

  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);

    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return { children: children };
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = values(this.state.children).map(childFactory);

    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Truncate = function (_Component) {
    _inherits(Truncate, _Component);

    function Truncate() {
        var _ref;

        _classCallCheck(this, Truncate);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = _possibleConstructorReturn(this, (_ref = Truncate.__proto__ || Object.getPrototypeOf(Truncate)).call.apply(_ref, [this].concat(args)));

        _this.state = {};
        _this.styles = {
            ellipsis: {
                position: 'fixed',
                visibility: 'hidden',
                top: 0,
                left: 0
            }
        };


        _this.elements = {};

        _this.onResize = _this.onResize.bind(_this);
        _this.onTruncate = _this.onTruncate.bind(_this);
        _this.calcTargetWidth = _this.calcTargetWidth.bind(_this);
        _this.measureWidth = _this.measureWidth.bind(_this);
        _this.getLines = _this.getLines.bind(_this);
        _this.renderLine = _this.renderLine.bind(_this);
        return _this;
    }

    _createClass(Truncate, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var text = this.elements.text,
                calcTargetWidth = this.calcTargetWidth,
                onResize = this.onResize;


            var canvas = document.createElement('canvas');
            this.canvasContext = canvas.getContext('2d');

            calcTargetWidth(function () {
                // Node not needed in document tree to read its content
                if (text) {
                    text.parentNode.removeChild(text);
                }
            });

            window.addEventListener('resize', onResize);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            // Render was based on outdated refs and needs to be rerun
            if (this.props.children !== prevProps.children) {
                this.forceUpdate();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var ellipsis = this.elements.ellipsis,
                onResize = this.onResize,
                timeout = this.timeout;


            ellipsis.parentNode.removeChild(ellipsis);

            window.removeEventListener('resize', onResize);

            window.cancelAnimationFrame(timeout);
        }

        // Shim innerText to consistently break lines at <br/> but not at \n

    }, {
        key: 'innerText',
        value: function innerText(node) {
            var div = document.createElement('div');
            var contentKey = 'innerText' in window.HTMLElement.prototype ? 'innerText' : 'textContent';

            div.innerHTML = node.innerHTML.replace(/\r\n|\r|\n/g, ' ');

            var text = div[contentKey];

            var test = document.createElement('div');
            test.innerHTML = 'foo<br/>bar';

            if (test[contentKey].replace(/\r\n|\r/g, '\n') !== 'foo\nbar') {
                div.innerHTML = div.innerHTML.replace(/<br.*?[\/]?>/gi, '\n');
                text = div[contentKey];
            }

            return text;
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            this.calcTargetWidth();
        }
    }, {
        key: 'onTruncate',
        value: function onTruncate(didTruncate) {
            var onTruncate = this.props.onTruncate;


            if (typeof onTruncate === 'function') {
                this.timeout = window.requestAnimationFrame(function () {
                    onTruncate(didTruncate);
                });
            }
        }
    }, {
        key: 'calcTargetWidth',
        value: function calcTargetWidth(callback) {
            var target = this.elements.target,
                calcTargetWidth = this.calcTargetWidth,
                canvasContext = this.canvasContext;

            // Calculation is no longer relevant, since node has been removed

            if (!target) {
                return;
            }

            // Floor the result to deal with browser subpixel precision
            var targetWidth = Math.floor(target.parentNode.getBoundingClientRect().width);

            // Delay calculation until parent node is inserted to the document
            // Mounting order in React is ChildComponent, ParentComponent
            if (!targetWidth) {
                return window.requestAnimationFrame(function () {
                    return calcTargetWidth(callback);
                });
            }

            var style = window.getComputedStyle(target);

            var font = [style['font-weight'], style['font-style'], style['font-size'], style['font-family']].join(' ');

            canvasContext.font = font;

            this.setState({
                targetWidth: targetWidth
            }, callback);
        }
    }, {
        key: 'measureWidth',
        value: function measureWidth(text) {
            return this.canvasContext.measureText(text).width;
        }
    }, {
        key: 'ellipsisWidth',
        value: function ellipsisWidth(node) {
            return node.offsetWidth;
        }
    }, {
        key: 'trimRight',
        value: function trimRight(text) {
            return text.replace(/\s+$/, '');
        }
    }, {
        key: 'getLines',
        value: function getLines() {
            var elements = this.elements,
                _props = this.props,
                numLines = _props.lines,
                ellipsis = _props.ellipsis,
                trimWhitespace = _props.trimWhitespace,
                targetWidth = this.state.targetWidth,
                innerText = this.innerText,
                measureWidth = this.measureWidth,
                onTruncate = this.onTruncate,
                trimRight = this.trimRight;


            var lines = [];
            var text = innerText(elements.text);
            var textLines = text.split('\n').map(function (line) {
                return line.split(' ');
            });
            var didTruncate = true;
            var ellipsisWidth = this.ellipsisWidth(this.elements.ellipsis);

            for (var line = 1; line <= numLines; line++) {
                var textWords = textLines[0];

                // Handle newline
                if (textWords.length === 0) {
                    lines.push();
                    textLines.shift();
                    line--;
                    continue;
                }

                var resultLine = textWords.join(' ');

                if (measureWidth(resultLine) <= targetWidth) {
                    if (textLines.length === 1) {
                        // Line is end of text and fits without truncating
                        didTruncate = false;

                        lines.push(resultLine);
                        break;
                    }
                }

                if (line === numLines) {
                    // Binary search determining the longest possible line inluding truncate string
                    var textRest = textWords.join(' ');

                    var lower = 0;
                    var upper = textRest.length - 1;

                    while (lower <= upper) {
                        var middle = Math.floor((lower + upper) / 2);

                        var testLine = textRest.slice(0, middle + 1);

                        if (measureWidth(testLine) + ellipsisWidth <= targetWidth) {
                            lower = middle + 1;
                        } else {
                            upper = middle - 1;
                        }
                    }

                    var lastLineText = textRest.slice(0, lower);

                    if (trimWhitespace) {
                        lastLineText = trimRight(lastLineText);

                        // Remove blank lines from the end of text
                        while (!lastLineText.length && lines.length) {
                            var prevLine = lines.pop();

                            lastLineText = trimRight(prevLine);
                        }
                    }

                    resultLine = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        null,
                        lastLineText,
                        ellipsis
                    );
                } else {
                    // Binary search determining when the line breaks
                    var _lower = 0;
                    var _upper = textWords.length - 1;

                    while (_lower <= _upper) {
                        var _middle = Math.floor((_lower + _upper) / 2);

                        var _testLine = textWords.slice(0, _middle + 1).join(' ');

                        if (measureWidth(_testLine) <= targetWidth) {
                            _lower = _middle + 1;
                        } else {
                            _upper = _middle - 1;
                        }
                    }

                    // The first word of this line is too long to fit it
                    if (_lower === 0) {
                        // Jump to processing of last line
                        line = numLines - 1;
                        continue;
                    }

                    resultLine = textWords.slice(0, _lower).join(' ');
                    textLines[0].splice(0, _lower);
                }

                lines.push(resultLine);
            }

            onTruncate(didTruncate);

            return lines;
        }
    }, {
        key: 'renderLine',
        value: function renderLine(line, i, arr) {
            if (i === arr.length - 1) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { key: i },
                    line
                );
            } else {
                var br = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', { key: i + 'br' });

                if (line) {
                    return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { key: i },
                        line
                    ), br];
                } else {
                    return br;
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var target = this.elements.target,
                _props2 = this.props,
                children = _props2.children,
                ellipsis = _props2.ellipsis,
                lines = _props2.lines,
                spanProps = _objectWithoutProperties(_props2, ['children', 'ellipsis', 'lines']),
                targetWidth = this.state.targetWidth,
                getLines = this.getLines,
                renderLine = this.renderLine,
                onTruncate = this.onTruncate;

            var text = void 0;

            var mounted = !!(target && targetWidth);

            if (typeof window !== 'undefined' && mounted) {
                if (lines > 0) {
                    text = getLines().map(renderLine);
                } else {
                    text = children;

                    onTruncate(false);
                }
            }

            delete spanProps.onTruncate;
            delete spanProps.trimWhitespace;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                _extends({}, spanProps, { ref: function ref(targetEl) {
                        _this2.elements.target = targetEl;
                    } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    null,
                    text
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { ref: function ref(textEl) {
                            _this2.elements.text = textEl;
                        } },
                    children
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { ref: function ref(ellipsisEl) {
                            _this2.elements.ellipsis = ellipsisEl;
                        }, style: this.styles.ellipsis },
                    ellipsis
                )
            );
        }
    }]);

    return Truncate;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Truncate.propTypes = {
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    ellipsis: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
    lines: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([false]), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
    trimWhitespace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
    onTruncate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
Truncate.defaultProps = {
    children: '',
    ellipsis: '…',
    lines: 1,
    trimWhitespace: false
};
/* harmony default export */ __webpack_exports__["a"] = (Truncate);
;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(486);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ANIMATION_STATE_CLASSES = {
  animating: 'rah-animating',
  animatingUp: 'rah-animating--up',
  animatingDown: 'rah-animating--down',
  animatingToHeightZero: 'rah-animating--to-height-zero',
  animatingToHeightAuto: 'rah-animating--to-height-auto',
  animatingToHeightSpecific: 'rah-animating--to-height-specific',
  static: 'rah-static',
  staticHeightZero: 'rah-static--height-zero',
  staticHeightAuto: 'rah-static--height-auto',
  staticHeightSpecific: 'rah-static--height-specific'
};

function omit(obj) {
  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  if (!keys.length) {
    return obj;
  }

  var res = {};
  var objectKeys = Object.keys(obj);

  for (var i = 0; i < objectKeys.length; i++) {
    var key = objectKeys[i];

    if (keys.indexOf(key) === -1) {
      res[key] = obj[key];
    }
  }

  return res;
}

// Start animation helper using nested requestAnimationFrames
function startAnimationHelper(callback) {
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      callback();
    });
  });
}

var AnimateHeight = function (_React$Component) {
  _inherits(AnimateHeight, _React$Component);

  function AnimateHeight(props) {
    _classCallCheck(this, AnimateHeight);

    var _this = _possibleConstructorReturn(this, (AnimateHeight.__proto__ || Object.getPrototypeOf(AnimateHeight)).call(this, props));

    var height = 'auto';
    var overflow = 'visible';

    if (_this.isNumber(props.height)) {
      height = props.height < 0 ? 0 : props.height;
      overflow = 'hidden';
    } else if (
    // Percentage height
    typeof props.height === 'string' && props.height.search('%') === props.height.length - 1 && _this.isNumber(props.height.substr(0, props.height.length - 1))) {
      height = props.height;
      overflow = 'hidden';
    }

    _this.animationStateClasses = _extends({}, ANIMATION_STATE_CLASSES, props.animationStateClasses);

    var animationStateClasses = _this.getStaticStateClasses(height);

    _this.state = {
      animationStateClasses: animationStateClasses,
      height: height,
      overflow: overflow,
      shouldUseTransitions: false
    };
    return _this;
  }

  _createClass(AnimateHeight, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var height = this.state.height;

      // Hide content if height is 0 (to prevent tabbing into it)
      // Check for contentElement is added cause this would fail in tests (react-test-renderer)
      // Read more here: https://github.com/Stanko/react-animate-height/issues/17

      if (this.contentElement && this.contentElement.style) {
        this.hideContent(height);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var height = this.props.height;

      // Check if 'height' prop has changed

      if (this.contentElement && nextProps.height !== height) {
        var _cx;

        // Remove display: none from the content div
        // if it was hidden to prevent tabbing into it
        this.showContent();

        // Cache content height
        this.contentElement.style.overflow = 'hidden';
        var contentHeight = this.contentElement.offsetHeight;
        this.contentElement.style.overflow = '';

        var newHeight = null;
        var timeoutState = {
          height: null, // it will be always set to either 'auto' or specific number
          overflow: 'hidden'
        };
        var isCurrentHeightAuto = this.state.height === 'auto';

        if (this.isNumber(nextProps.height)) {
          // If new height is a number
          newHeight = nextProps.height < 0 ? 0 : nextProps.height;
          timeoutState.height = newHeight;
        } else if (
        // Percentage height
        typeof nextProps.height === 'string' && nextProps.height.search('%') === nextProps.height.length - 1 && this.isNumber(nextProps.height.substr(0, nextProps.height.length - 1))) {
          newHeight = nextProps.height;
          timeoutState.height = newHeight;
        } else {
          // If not, animate to content height
          // and then reset to auto
          newHeight = contentHeight;
          timeoutState.height = 'auto';
          timeoutState.overflow = null;
        }

        if (isCurrentHeightAuto) {
          // This is the height to be animated to
          timeoutState.height = newHeight;

          // If previous height was 'auto'
          // set starting height explicitly to be able to use transition
          newHeight = contentHeight;
        }

        // Animation classes
        var animationStateClasses = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, this.animationStateClasses.animating, true), _defineProperty(_cx, this.animationStateClasses.animatingUp, height === 'auto' || nextProps.height < height), _defineProperty(_cx, this.animationStateClasses.animatingDown, nextProps.height === 'auto' || nextProps.height > height), _defineProperty(_cx, this.animationStateClasses.animatingToHeightZero, timeoutState.height === 0), _defineProperty(_cx, this.animationStateClasses.animatingToHeightAuto, timeoutState.height === 'auto'), _defineProperty(_cx, this.animationStateClasses.animatingToHeightSpecific, timeoutState.height > 0), _cx));

        // Animation classes to be put after animation is complete
        var timeoutAnimationStateClasses = this.getStaticStateClasses(timeoutState.height);

        // Set starting height and animating classes
        this.setState({
          animationStateClasses: animationStateClasses,
          height: newHeight,
          overflow: 'hidden',
          // When animating from 'auto' we first need to set fixed height
          // that change should be animated
          shouldUseTransitions: !isCurrentHeightAuto
        });

        // Clear timeouts
        clearTimeout(this.timeoutID);
        clearTimeout(this.animationClassesTimeoutID);

        if (isCurrentHeightAuto) {
          // When animating from 'auto' we use a short timeout to start animation
          // after setting fixed height above
          timeoutState.shouldUseTransitions = true;

          startAnimationHelper(function () {
            _this2.setState(timeoutState);

            // ANIMATION STARTS, run a callback if it exists
            _this2.runCallback(nextProps.onAnimationStart);
          });

          // Set static classes and remove transitions when animation ends
          this.animationClassesTimeoutID = setTimeout(function () {
            _this2.setState({
              animationStateClasses: timeoutAnimationStateClasses,
              shouldUseTransitions: false
            });

            // ANIMATION ENDS
            // Hide content if height is 0 (to prevent tabbing into it)
            _this2.hideContent(timeoutState.height);
            // Run a callback if it exists
            _this2.runCallback(nextProps.onAnimationEnd);
          }, nextProps.duration);
        } else {
          // ANIMATION STARTS, run a callback if it exists
          this.runCallback(nextProps.onAnimationStart);

          // Set end height, classes and remove transitions when animation is complete
          this.timeoutID = setTimeout(function () {
            timeoutState.animationStateClasses = timeoutAnimationStateClasses;
            timeoutState.shouldUseTransitions = false;

            _this2.setState(timeoutState);

            // ANIMATION ENDS
            // Hide content if height is 0 (to prevent tabbing into it)
            _this2.hideContent(newHeight);
            // Run a callback if it exists
            _this2.runCallback(nextProps.onAnimationEnd);
          }, nextProps.duration);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutID);
      clearTimeout(this.animationClassesTimeoutID);
      this.timeoutID = null;
      this.animationClassesTimeoutID = null;
      this.animationStateClasses = null;
    }
  }, {
    key: 'isNumber',
    value: function isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
  }, {
    key: 'runCallback',
    value: function runCallback(callback) {
      if (callback && typeof callback === 'function') {
        callback();
      }
    }
  }, {
    key: 'showContent',
    value: function showContent() {
      if (this.state.height === 0) {
        this.contentElement.style.display = '';
      }
    }
  }, {
    key: 'hideContent',
    value: function hideContent(newHeight) {
      if (newHeight === 0) {
        this.contentElement.style.display = 'none';
      }
    }
  }, {
    key: 'getStaticStateClasses',
    value: function getStaticStateClasses(height) {
      var _cx2;

      return (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, this.animationStateClasses.static, true), _defineProperty(_cx2, this.animationStateClasses.staticHeightZero, height === 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightSpecific, height > 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightAuto, height === 'auto'), _cx2));
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx3,
          _this3 = this;

      var _props = this.props,
          applyInlineTransitions = _props.applyInlineTransitions,
          children = _props.children,
          className = _props.className,
          contentClassName = _props.contentClassName,
          duration = _props.duration,
          easing = _props.easing,
          style = _props.style;
      var _state = this.state,
          height = _state.height,
          overflow = _state.overflow,
          animationStateClasses = _state.animationStateClasses,
          shouldUseTransitions = _state.shouldUseTransitions;

      // Include transition passed through styles

      var userTransition = style.transition ? style.transition + ',' : '';
      var transitionString = userTransition + ' height ' + duration + 'ms ' + easing + ' ';

      var componentStyle = _extends({}, style, {
        height: height,
        overflow: overflow || style.overflow
      });

      if (shouldUseTransitions && applyInlineTransitions) {
        componentStyle.WebkitTransition = transitionString;
        componentStyle.MozTransition = transitionString;
        componentStyle.OTransition = transitionString;
        componentStyle.msTransition = transitionString;
        componentStyle.transition = transitionString;
      }

      var componentClasses = (0, _classnames2.default)((_cx3 = {}, _defineProperty(_cx3, animationStateClasses, true), _defineProperty(_cx3, className, className), _cx3));

      var propsToOmit = ['height', 'duration', 'easing', 'contentClassName', 'animationStateClasses', 'applyInlineTransitions'];

      return _react2.default.createElement(
        'div',
        _extends({}, omit.apply(undefined, [this.props].concat(propsToOmit)), {
          'aria-hidden': height === 0,
          className: componentClasses,
          style: componentStyle
        }),
        _react2.default.createElement(
          'div',
          {
            className: contentClassName,
            ref: function ref(el) {
              return _this3.contentElement = el;
            }
          },
          children
        )
      );
    }
  }]);

  return AnimateHeight;
}(_react2.default.Component);

AnimateHeight.propTypes = {
  animationStateClasses: _propTypes2.default.object,
  applyInlineTransitions: _propTypes2.default.bool,
  children: _propTypes2.default.any.isRequired,
  className: _propTypes2.default.string,
  contentClassName: _propTypes2.default.string,
  duration: _propTypes2.default.number.isRequired,
  easing: _propTypes2.default.string.isRequired,
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  onAnimationEnd: _propTypes2.default.func, // eslint-disable-line react/no-unused-prop-types
  onAnimationStart: _propTypes2.default.func, // eslint-disable-line react/no-unused-prop-types
  style: _propTypes2.default.object
};

AnimateHeight.defaultProps = {
  duration: 250,
  easing: 'ease',
  style: {},
  animationStateClasses: ANIMATION_STATE_CLASSES,
  applyInlineTransitions: true
};

exports.default = AnimateHeight;

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_selectors__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserIdentityReport=function(_React$Component){_inherits(UserIdentityReport,_React$Component);function UserIdentityReport(){_classCallCheck(this,UserIdentityReport);return _possibleConstructorReturn(this,(UserIdentityReport.__proto__||Object.getPrototypeOf(UserIdentityReport)).apply(this,arguments));}_createClass(UserIdentityReport,[{key:'render',value:function render(){var appInfoTableData=UserIdentityReport.getAppInfoTableData(this.props.userIdentity);var cssBlockName=this.props.cssBlockName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:cssBlockName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,appInfoTableData.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:cssBlockName+'__title'},item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:cssBlockName+'__value'},item.value));})));}}],[{key:'getAppInfoTableData',value:function getAppInfoTableData(userIdentity){return[{title:"App Version",value:userIdentity.appVersion+' / '+"2.82.0"},{title:"OS",value:userIdentity.os+' / '+userIdentity.osVersion},{title:"Platform",value:userIdentity.platform},{title:"Device",value:userIdentity.device}];}}]);return UserIdentityReport;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){return{userIdentity:Object(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["k" /* getUserIdentity */])(state).toJS()};})(UserIdentityReport));

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SchoolLogo_css__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SchoolLogo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SchoolLogo_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SchoolLogo=function(_React$Component){_inherits(SchoolLogo,_React$Component);function SchoolLogo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SchoolLogo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SchoolLogo.__proto__||Object.getPrototypeOf(SchoolLogo)).call.apply(_ref,[this].concat(args))),_this),_this.state={hasImageLoadFailed:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SchoolLogo,[{key:"render",value:function render(){var _props=this.props,schoolName=_props.schoolName,logoURL=_props.logoURL,cssBlockName=_props.cssBlockName,cssModifier=_props.cssModifier;var classNames=["school-logo"];if(cssBlockName){classNames.push(cssBlockName+"__school-logo");}if(cssModifier){classNames.push("school-logo--"+cssModifier);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"school-logo__img",src:logoURL,alt:schoolName}));}}]);return SchoolLogo;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);SchoolLogo.propTypes={logoURL:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,schoolName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,cssBlockName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,cssModifier:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (SchoolLogo);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ExpandingBox__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Gate__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SchoolInfo_css__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SchoolInfo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SchoolInfo_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SchoolInfo=function(_React$Component){_inherits(SchoolInfo,_React$Component);function SchoolInfo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SchoolInfo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SchoolInfo.__proto__||Object.getPrototypeOf(SchoolInfo)).call.apply(_ref,[this].concat(args))),_this),_this.openSchoolPhoneNumber=function(clickEvent){clickEvent.stopPropagation();_this.props.openPhone(_this.props.phoneNumber);},_this.openSchoolEmail=function(clickEvent){clickEvent.stopPropagation();_this.props.openEmail(_this.props.emailAddress);},_this.openSchoolWebsite=function(clickEvent){clickEvent.stopPropagation();var url=_this.props.websiteURL;// if the website doesnt start with a protocol
if(!url.startsWith("http://")&&!url.startsWith("https://")){_this.props.openURL("http://"+url);// Otherwise, looks like a link - open it.
}else{_this.props.openURL(url);}_this.props.openURL(url);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SchoolInfo,[{key:"render",value:function render(){var _props=this.props,product=_props.product,name=_props.name,phoneNumber=_props.phoneNumber,emailAddress=_props.emailAddress,websiteURL=_props.websiteURL,logo=_props.logo;var hasPhone=phoneNumber!=="";var hasEmail=emailAddress!=="";var hasWebsite=websiteURL!=="";var placeholder=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-info__item school-info__item--no-content"},"This school hasn't provided any additional information.");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-info school-info--"+product},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_ExpandingBox__["a" /* default */],{cssModifier:product+"-school-info"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_ExpandingBox__["a" /* default */].Header,{toggleOnClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-info__header"},logo,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-info__name"},name))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_ExpandingBox__["a" /* default */].Body,{toggleOnClick:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Gate__["a" /* default */],{isOpen:hasPhone||hasEmail||hasWebsite,placeholder:placeholder},hasPhone?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-info__item school-info__item--phone"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"hyperlink",onClick:this.openSchoolPhoneNumber},phoneNumber)):null,hasEmail?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-info__item school-info__item--email"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"hyperlink",onClick:this.openSchoolEmail},emailAddress)):null,hasWebsite?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-info__item school-info__item--website"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"hyperlink",onClick:this.openSchoolWebsite},websiteURL)):null))));}}]);return SchoolInfo;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);SchoolInfo.propTypes={product:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,phoneNumber:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,emailAddress:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,websiteURL:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,logo:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(undefined,{openURL:__WEBPACK_IMPORTED_MODULE_4_state_app_actions__["R" /* openURL */],openEmail:__WEBPACK_IMPORTED_MODULE_4_state_app_actions__["N" /* openEmail */],openPhone:__WEBPACK_IMPORTED_MODULE_4_state_app_actions__["Q" /* openPhone */]})(SchoolInfo));

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/teachers-logo--text-right.9b28d87e.svg";

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_assets_images_search_light_svg__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_assets_images_search_light_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_assets_images_search_light_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_assets_images_close_light_svg__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_assets_images_close_light_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_assets_images_close_light_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchBar_css__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchBar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SearchBar_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchBar=function(_React$Component){_inherits(SearchBar,_React$Component);function SearchBar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SearchBar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SearchBar.__proto__||Object.getPrototypeOf(SearchBar)).call.apply(_ref,[this].concat(args))),_this),_this.clearQuery=function(){_this.props.onSearch("");},_this.onChange=function(changeEvent){var value=_this.textInput.value;_this.props.onSearch(value);},_this.refTextInput=function(textInput){_this.textInput=textInput;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SearchBar,[{key:"render",value:function render(){var query=this.props.query;var hasQuery=query!=="";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"search-bar-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Card__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Card__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"search-bar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"search-bar__input",value:query,ref:this.refTextInput,onChange:this.onChange,placeholder:"Search"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"search-bar__action"},hasQuery?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{onClick:this.clearQuery},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_4_components_assets_images_close_light_svg___default.a,alt:"clear"})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3_components_assets_images_search_light_svg___default.a,alt:"search"}))))));}}]);return SearchBar;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);SearchBar.propTypes={query:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onSearch:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};SearchBar.defaultProps={query:""};/* harmony default export */ __webpack_exports__["a"] = (SearchBar);

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/close--light.e3317369.svg";

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Display a list of components (representing entities) and allow switching between them
 */var EntitySelector=function(_React$Component){_inherits(EntitySelector,_React$Component);function EntitySelector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EntitySelector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EntitySelector.__proto__||Object.getPrototypeOf(EntitySelector)).call.apply(_ref,[this].concat(args))),_this),_this.selectPreviousEntity=function(){if(_this.canSelectPrevious()){var _this$props=_this.props,entityIDList=_this$props.entityIDList,selectedEntityID=_this$props.selectedEntityID;var previousEntityVirtualIndex=_this.getEntityIndex(selectedEntityID)-1;var previousEntityRealIndex=previousEntityVirtualIndex%_this.getEntityCount();var previousEntityID=entityIDList.get(previousEntityRealIndex);_this.props.onSelectEntity(previousEntityID);}},_this.selectNextEntity=function(){if(_this.canSelectNext()){var _this$props2=_this.props,entityIDList=_this$props2.entityIDList,selectedEntityID=_this$props2.selectedEntityID;var nextEntityVirtualIndex=_this.getEntityIndex(selectedEntityID)+1;var nextEntityRealIndex=nextEntityVirtualIndex%_this.getEntityCount();var nextEntityID=entityIDList.get(nextEntityRealIndex);_this.props.onSelectEntity(nextEntityID);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EntitySelector,[{key:"getEntityCount",value:function getEntityCount(){return this.props.entityIDList.size;}/**
   * @returns {number} index of the entity with the given ID
   */},{key:"getEntityIndex",value:function getEntityIndex(entityID){return this.props.entityIDList.indexOf(entityID);}/**
   * @returns {boolean}
   */},{key:"canSelectPrevious",value:function canSelectPrevious(){var hasMultipleEntities=this.getEntityCount()>1;var canLoop=this.props.loop;var isFirstEntity=this.getEntityIndex(this.props.selectedEntityID)===0;return hasMultipleEntities&&(canLoop||!isFirstEntity);}/**
   * @returns {boolean}
   */},{key:"canSelectNext",value:function canSelectNext(){var entityCount=this.getEntityCount();var hasMultipleEntities=entityCount>1;var canLoop=this.props.loop;var isLastEntity=this.getEntityIndex(this.props.selectedEntityID)===entityCount-1;return hasMultipleEntities&&(canLoop||!isLastEntity);}},{key:"render",value:function render(){var _this2=this;var _props=this.props,entityIDList=_props.entityIDList,selectedEntityID=_props.selectedEntityID,cssBlockName=_props.cssBlockName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssBlockName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssBlockName+"__button-container"},this.canSelectPrevious()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssBlockName+"__previous",onClick:this.selectPreviousEntity}):null),entityIDList.map(function(entityID){var isSelected=entityID===selectedEntityID;var cssElementName=cssBlockName+"__item";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EntitySelectorItem,{key:entityID,isSelected:isSelected,cssElementName:cssElementName},_this2.props.children(entityID));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssBlockName+"__button-container"},this.canSelectNext()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssBlockName+"__next",onClick:this.selectNextEntity}):null));}}]);return EntitySelector;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/**
 * Wrap rendered entities in CSS classes for selected or unselected
 */EntitySelector.propTypes={entityIDList:__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.list.isRequired,selectedEntityID:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired,onSelectEntity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,cssBlockName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,loop:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};EntitySelector.defaultProps={loop:true};/* harmony default export */ __webpack_exports__["a"] = (EntitySelector);var EntitySelectorItem=function(_React$Component2){_inherits(EntitySelectorItem,_React$Component2);function EntitySelectorItem(){_classCallCheck(this,EntitySelectorItem);return _possibleConstructorReturn(this,(EntitySelectorItem.__proto__||Object.getPrototypeOf(EntitySelectorItem)).apply(this,arguments));}_createClass(EntitySelectorItem,[{key:"render",value:function render(){var _props2=this.props,cssElementName=_props2.cssElementName,isSelected=_props2.isSelected,children=_props2.children;var classNames=[cssElementName];if(isSelected){classNames.push(cssElementName+"--selected");}else{classNames.push(cssElementName+"--unselected");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},children);}}]);return EntitySelectorItem;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);EntitySelectorItem.propTypes={isSelected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,cssElementName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired};

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debounce__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_log__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Carousel__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EntityCarousel_css__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EntityCarousel_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__EntityCarousel_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// debounce period of resize event hanlder in ms
var RESIZE_DEBOUNCE_DELAY=200;/**
 * Manually set the CSS height of every swiper slide.
 * This is legacy support for older versions of iOS which have
 *   trouble shrinking the slides down to the height of the container.
 * We attach this to swiper's "resize" event, as well as "init" so
 *   that it runs at least once.
 */function setSwiperSlideHeight(){var containerHeight=this.el.clientHeight;this.slides.each(function(_,slide){slide.style.height=containerHeight+"px";});}/**
 * Allow swiping between schools'/students' pages.
 */var EntityCarousel=function(_React$Component){_inherits(EntityCarousel,_React$Component);function EntityCarousel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EntityCarousel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EntityCarousel.__proto__||Object.getPrototypeOf(EntityCarousel)).call.apply(_ref,[this].concat(args))),_this),_this.state={entityIDList:null,renderedChildren:null},_this.changeEntity=function(activeIndex,prevActiveIndex){var entityID=_this.props.entityIDList.get(activeIndex);__WEBPACK_IMPORTED_MODULE_5_state_history__["a" /* history */].push(_this.props.generatePath(entityID));if(_this.props.onChange!==undefined){var prevEntityID=_this.props.entityIDList.get(prevActiveIndex);_this.props.onChange(entityID,prevEntityID);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EntityCarousel,[{key:"getActiveIndex",value:function getActiveIndex(){return this.props.entityIDList.indexOf(this.props.activeEntityID);}},{key:"getSwiperOptions",value:function getSwiperOptions(){return{// disable swiper when there is only a single slide
watchOverflow:true,// default to active entity
initialSlide:this.getActiveIndex(),// support vertical scrolling on older iOS
on:{init:setSwiperSlideHeight,resize:__WEBPACK_IMPORTED_MODULE_3_debounce___default()(setSwiperSlideHeight,RESIZE_DEBOUNCE_DELAY)}};}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Carousel__["a" /* default */],{cssBlockName:"entity-carousel",swiperOptions:this.getSwiperOptions(),activeIndex:this.getActiveIndex(),onAfterChange:this.changeEntity},this.state.renderedChildren);}}],[{key:"getDerivedStateFromProps",value:function getDerivedStateFromProps(nextProps,state){if(!nextProps.entityIDList.equals(state.entityIDList)){__WEBPACK_IMPORTED_MODULE_4_lib_log__["a" /* default */].debug("EntityCarousel: entityIDList has updated, re-rendering...");return{entityIDList:nextProps.entityIDList,renderedChildren:EntityCarousel.renderChildren(nextProps)};}else{return null;}}},{key:"renderChildren",value:function renderChildren(props){return props.entityIDList.map(function(entityID){return props.children(entityID);}).toArray();}}]);return EntityCarousel;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);EntityCarousel.propTypes={entityIDList:__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any).isRequired,generatePath:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,activeEntityID:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};/* harmony default export */ __webpack_exports__["a"] = (EntityCarousel);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Swiper__ = __webpack_require__(537);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultOptions={speed:200,easing:'ease-out',slidesPerView:1,initialSlide:0,resistanceRatio:0.5/**
 * Wrapper for Swiper component (which is itself a wrapper for the swiper library).
 * Sets some sensible default options and provides a convenient onChange callback hook.
 * Also applies BEM-y classNames to the swiper DOM structure.
 * Forwards the swiper instance ref if required.
 */};var Carousel=function(_React$Component){_inherits(Carousel,_React$Component);function Carousel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Carousel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Carousel.__proto__||Object.getPrototypeOf(Carousel)).call.apply(_ref,[this].concat(args))),_this),_this.lastActiveIndexProp=null,_this.prevSwiperActiveIndex=0,_this.onChange=function(){if(_this.props.onChange){_this.props.onChange(_this.swiper.activeIndex,_this.prevSwiperActiveIndex);}},_this.onAfterChange=function(){if(_this.props.onAfterChange){_this.props.onAfterChange(_this.swiper.activeIndex,_this.prevSwiperActiveIndex);}_this.prevSwiperActiveIndex=_this.swiper.activeIndex;},_this.refSwiper=function(swiper){_this.swiper=swiper;_this.swiper.on("slideChange",_this.onChange);// onAfterChange is important because it fires on slideChangeTransitionEnd, not slideChange
// if a re-render is triggered on slideChange then the trasition will be interrupted
_this.swiper.on("slideChangeTransitionEnd",_this.onAfterChange);if(_this.props.refSwiper){_this.props.refSwiper(swiper);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Carousel,[{key:"getClassNames",value:function getClassNames(){var cssBlockName=this.props.cssBlockName;var classNames={container:"carousel",wrapper:"carousel__wrapper",slide:"carousel__slide"};if(cssBlockName!==undefined){classNames.container+=" "+cssBlockName+"__carousel";classNames.wrapper+=" "+cssBlockName+"__carousel-wrapper";classNames.slide+=" "+cssBlockName+"__slide";}return classNames;}},{key:"getOptions",value:function getOptions(){return Object.assign({},defaultOptions,this.props.swiperOptions);}/**
     * After props change, sync swiper to activeIndex prop.
     * This allows the active slide to be controlled from outside.
     */},{key:"componentDidUpdate",value:function componentDidUpdate(){var activeIndex=this.props.activeIndex;if(activeIndex!==undefined&&activeIndex!==this.lastActiveIndexProp){this.swiper.slideTo(activeIndex);this.lastActiveIndexProp=activeIndex;}}/**
     * Destroy swiper instance on component unmount.
     * Mainly so that all event listeners are cleaned up.
     */},{key:"componentWillUnmount",value:function componentWillUnmount(){var destroyInstance=true;var cleanStyles=false;this.swiper.destroy(destroyInstance,cleanStyles);}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Swiper__["a" /* default */],{classNames:this.getClassNames(),options:this.getOptions(),refSwiper:this.refSwiper},this.props.children);}}]);return Carousel;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Carousel.propTypes={cssBlockName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,swiperOptions:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,refSwiper:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onAfterChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,activeIndex:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};/* harmony default export */ __webpack_exports__["a"] = (Carousel);

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkify = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _linkifyIt = __webpack_require__(545);

var _linkifyIt2 = _interopRequireDefault(_linkifyIt);

var _tlds = __webpack_require__(551);

var _tlds2 = _interopRequireDefault(_tlds);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var linkify = exports.linkify = new _linkifyIt2.default();
linkify.tlds(_tlds2.default);

var Linkify = function (_React$Component) {
  _inherits(Linkify, _React$Component);

  function Linkify() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Linkify);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Linkify.__proto__ || Object.getPrototypeOf(Linkify)).call.apply(_ref, [this].concat(args))), _this), _this.parseCounter = 0, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Linkify, [{
    key: 'getMatches',
    value: function getMatches(string) {
      return linkify.match(string);
    }
  }, {
    key: 'parseString',
    value: function parseString(string) {
      var _this2 = this;

      var elements = [];
      if (string === '') {
        return elements;
      }

      var matches = this.getMatches(string);
      if (!matches) {
        return string;
      }

      var lastIndex = 0;
      matches.forEach(function (match, idx) {
        // Push the preceding text if there is any
        if (match.index > lastIndex) {
          elements.push(string.substring(lastIndex, match.index));
        }
        // Shallow update values that specified the match
        var props = { href: match.url, key: 'parse' + _this2.parseCounter + 'match' + idx };
        for (var key in _this2.props.properties) {
          var val = _this2.props.properties[key];
          if (val === Linkify.MATCH) {
            val = match.url;
          }

          props[key] = val;
        }
        elements.push(_react2.default.createElement(_this2.props.component, props, match.text));
        lastIndex = match.lastIndex;
      });

      if (lastIndex < string.length) {
        elements.push(string.substring(lastIndex));
      }

      return elements.length === 1 ? elements[0] : elements;
    }
  }, {
    key: 'parse',
    value: function parse(children) {
      var _this3 = this;

      var parsed = children;

      if (typeof children === 'string') {
        parsed = this.parseString(children);
      } else if (_react2.default.isValidElement(children) && children.type !== 'a' && children.type !== 'button') {
        parsed = _react2.default.cloneElement(children, { key: 'parse' + ++this.parseCounter }, this.parse(children.props.children));
      } else if (children instanceof Array) {
        parsed = children.map(function (child) {
          return _this3.parse(child);
        });
      }

      return parsed;
    }
  }, {
    key: 'render',
    value: function render() {
      this.parseCounter = 0;
      var parsedChildren = this.parse(this.props.children);

      return _react2.default.createElement(
        'span',
        { className: this.props.className },
        parsedChildren
      );
    }
  }]);

  return Linkify;
}(_react2.default.Component);

Linkify.MATCH = 'LINKIFY_MATCH';
Linkify.propTypes = {
  className: _propTypes2.default.string,
  component: _propTypes2.default.any,
  properties: _propTypes2.default.object,
  urlRegex: _propTypes2.default.object,
  emailRegex: _propTypes2.default.object
};
Linkify.defaultProps = {
  className: 'Linkify',
  component: 'a',
  properties: {}
};
exports.default = Linkify;


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_format__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// default updateInterval is 1 min
var DEFAULT_UPDATE_INTERVAL=60000;/**
 * A date display component that updates on a set interval
 * uses lib/format/formatTimeAgo
 */var LiveDate=function(_React$Component){_inherits(LiveDate,_React$Component);function LiveDate(props){_classCallCheck(this,LiveDate);var _this=_possibleConstructorReturn(this,(LiveDate.__proto__||Object.getPrototypeOf(LiveDate)).call(this,props));if(_this.props.updateInterval===undefined){_this.updateInterval=DEFAULT_UPDATE_INTERVAL;}return _this;}_createClass(LiveDate,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;// Create a "tick" method, that re-calculates the time
// force an update every tick (because the delta has always changed)
this.tick=setInterval(function(){_this2.forceUpdate();},this.updateInterval);}// Remove the timer
},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.tick);}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"live-date"},Object(__WEBPACK_IMPORTED_MODULE_1_lib_format__["d" /* timeAgo */])(this.props.date,this.props.timezoneOffset));}}]);return LiveDate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (LiveDate);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Overlay__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Carousel__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WelcomeGuide_css__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WelcomeGuide_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__WelcomeGuide_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var swiperOptions={spaceBetween:50,/** @see {@link http://idangero.us/swiper/api/#pagination} */pagination:{el:".welcome-guide__pagination",bulletClass:"welcome-guide__pagination-bullet",bulletActiveClass:"welcome-guide__pagination-bullet--active"}/**
 * Basis for T2P and SM welcome guides.
 */};var WelcomeGuide=function(_React$Component){_inherits(WelcomeGuide,_React$Component);function WelcomeGuide(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WelcomeGuide);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WelcomeGuide.__proto__||Object.getPrototypeOf(WelcomeGuide)).call.apply(_ref,[this].concat(args))),_this),_this.state={currentSlideIndex:0},_this.onSlideChange=function(currentSlideIndex){_this.setState({currentSlideIndex:currentSlideIndex});},_this.onNextClick=function(){_this.setState({currentSlideIndex:_this.state.currentSlideIndex+1});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WelcomeGuide,[{key:"render",value:function render(){var _props=this.props,cssModifier=_props.cssModifier,logoPath=_props.logoPath,isOpen=_props.isOpen,onClose=_props.onClose,children=_props.children;var currentSlideIndex=this.state.currentSlideIndex;var isLastSlide=currentSlideIndex===children.length-1;if(!isOpen){return null;}var classNames=["welcome-guide"];if(cssModifier){classNames.push("welcome-guide--"+cssModifier);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Overlay__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"welcome-guide__logo"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:logoPath,alt:"product logo"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Carousel__["a" /* default */],{cssBlockName:"welcome-guide",swiperOptions:swiperOptions,activeIndex:currentSlideIndex,onChange:this.onSlideChange},children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"welcome-guide__controls"},isLastSlide?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"welcome-guide__skip-button",onClick:onClose},"Skip"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"welcome-guide__pagination"}),isLastSlide?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"welcome-guide__done-button",onClick:onClose},"Got it!"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"welcome-guide__next-button",onClick:this.onNextClick},"Next"))));}}]);return WelcomeGuide;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);WelcomeGuide.propTypes={cssModifier:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,logoPath:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (WelcomeGuide);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_MoneyInput__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_AddButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreditTopUp_css__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CreditTopUp_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CreditTopUp_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreditTopUp=function(_React$Component){_inherits(CreditTopUp,_React$Component);function CreditTopUp(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CreditTopUp);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CreditTopUp.__proto__||Object.getPrototypeOf(CreditTopUp)).call.apply(_ref,[this].concat(args))),_this),_this.state={amount:undefined,isInputValid:true},_this.validateInput=function(amount){return amount>0;},_this.onChange=function(amount){_this.setState({amount:amount});},_this.onInputValidityChange=function(isInputValid){_this.setState({isInputValid:isInputValid});},_this.onAddToBasket=function(){if(_this.state.isInputValid){_this.props.onAddToBasket(_this.state.amount);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CreditTopUp,[{key:"render",value:function render(){var _props=this.props,defaultAmount=_props.defaultAmount,label=_props.label;var classNames=["credit-top-up"];if(!this.state.isInputValid){classNames.push("credit-top-up--invalid");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Card__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Card__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"credit-top-up__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_MoneyInput__["a" /* default */],{className:"credit-top-up__input",initialAmount:defaultAmount,defaultAmount:defaultAmount,amount:this.state.amount,onChange:this.onChange,validateInput:this.validateInput,onValidityChange:this.onInputValidityChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"credit-top-up__label"},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_AddButton__["a" /* default */],{className:"credit-top-up__add-button",onClick:this.onAddToBasket})))));}}],[{key:"getDerivedStateFromProps",value:function getDerivedStateFromProps(nextProps,prevState){if(prevState.amount===undefined){return{amount:nextProps.defaultAmount};}return null;}}]);return CreditTopUp;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);CreditTopUp.propTypes={defaultAmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,onAddToBasket:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (CreditTopUp);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_money__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * MoneyInput - allow the user to input an amount of money
 * Uses <input type="money" /> for two reasons:
 * - On mobile, the number keyboard will be shown instead of text keyboard
 * - The browser restricts the input to numbers, preventing letters
 * If the input loses focus when it is empty, the `defaulAmount` will
 *   be inserted.
 *
 * @param {number} defaultAmount fallback value to use when the input is left empty
 * @param {Function} [validateInput] called on every inpu to decide whether it is valid
 * @param {Function} onChange will only ever be called with valid money amounts
 */var MoneyInput=function(_React$Component){_inherits(MoneyInput,_React$Component);function MoneyInput(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MoneyInput);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MoneyInput.__proto__||Object.getPrototypeOf(MoneyInput)).call.apply(_ref,[this].concat(args))),_this),_this.state={inputValue:undefined,isValid:true},_this.onChange=function(){// track raw value in state always
var inputValue=_this.input.value;_this.setState({inputValue:inputValue});// only update global state if input is valid money
var inputMoney=void 0;try{inputMoney=Object(__WEBPACK_IMPORTED_MODULE_2_lib_money__["c" /* stringToMoney */])(inputValue);}catch(error){_this.setValidity(false);return;}if(_this.props.validateInput(inputMoney)){_this.setValidity(true);_this.props.onChange(inputMoney);}else{_this.setValidity(false);}},_this.onClick=function(){if(_this.props.readOnly&&_this.props.onReadOnlyClick!==undefined){_this.props.onReadOnlyClick();}},_this.onBlur=function(){// replace blank input with default amount
if(_this.state.inputValue.trim().length===0){_this.setState({inputValue:Object(__WEBPACK_IMPORTED_MODULE_2_lib_money__["b" /* moneyToString */])(_this.props.defaultAmount)});_this.props.onChange(_this.props.defaultAmount);_this.setValidity(true);}// normalise input
if(_this.state.isValid){_this.setState({inputValue:Object(__WEBPACK_IMPORTED_MODULE_2_lib_money__["b" /* moneyToString */])(Object(__WEBPACK_IMPORTED_MODULE_2_lib_money__["c" /* stringToMoney */])(_this.state.inputValue))});}},_this.refInput=function(input){_this.input=input;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MoneyInput,[{key:"setValidity",value:function setValidity(isValid){this.setState({isValid:isValid});if(this.props.onValidityChange){this.props.onValidityChange(isValid);}}/**
   * When input changes, update state.
   * Also, iff input is valid money, call onChange.
   *//**
   * Fire a callback if the input is clicked while it is read-only
   *//**
   * When focus leaves the input, that is our opportunity to mangle it.
   * If the user left the input balnk, then we re-fill with the `defaultAmount`.
   */},{key:"render",value:function render(){var _props=this.props,className=_props.className,readOnly=_props.readOnly;var classNames=["money-input"];if(className){classNames.push(className);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"money-input__label"},"\xA3"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"money-input__field",type:"number",ref:this.refInput,value:this.state.inputValue,onChange:this.onChange,onBlur:this.onBlur,readOnly:readOnly,onClick:this.onClick}));}}],[{key:"getDerivedStateFromProps",/**
   * Initialise input value to `defaultAmount` prop.
   */value:function getDerivedStateFromProps(nextProps,prevState){if(prevState.inputValue===undefined){return{inputValue:Object(__WEBPACK_IMPORTED_MODULE_2_lib_money__["b" /* moneyToString */])(nextProps.initialAmount)};}return null;}}]);return MoneyInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);MoneyInput.propTypes={initialAmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,defaultAmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,validateInput:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onValidityChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onReadOnlyClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};MoneyInput.defaultProps={validateInput:function validateInput(){return true;},readOnly:false};/* harmony default export */ __webpack_exports__["a"] = (MoneyInput);

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_format__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShortDate=function(_React$Component){_inherits(ShortDate,_React$Component);function ShortDate(){_classCallCheck(this,ShortDate);return _possibleConstructorReturn(this,(ShortDate.__proto__||Object.getPrototypeOf(ShortDate)).apply(this,arguments));}_createClass(ShortDate,[{key:"render",value:function render(){return Object(__WEBPACK_IMPORTED_MODULE_2_lib_format__["b" /* formatShortDate */])(this.props.date);}}]);return ShortDate;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ShortDate.propTypes={date:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (ShortDate);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dropdown_css__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Dropdown_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Components representing a dorpdown list of options.
 * Controlled component (no internal state)
 * @param {Array<object>} options { id, label }
 * @param {function} onChange ( selectedOptionID )
 * @param {string} selectedOptionID must be a non-empty string or `null`
 * @param {string} [placeholder]
 */var Dropdown=function(_React$Component){_inherits(Dropdown,_React$Component);function Dropdown(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Dropdown);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Dropdown.__proto__||Object.getPrototypeOf(Dropdown)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(event){var _this$props=_this.props,disabled=_this$props.disabled,readOnly=_this$props.readOnly;if(!disabled&&!readOnly){// reverse the substitution of `null` we did in `render`
var value=event.target.value;var isPlaceholder=value==="";var id=isPlaceholder?null:value;_this.props.onChange(id);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Dropdown,[{key:"render",value:function render(){var options=this.props.options;var _props=this.props,selectedOptionID=_props.selectedOptionID,placeholder=_props.placeholder,disabled=_props.disabled,readOnly=_props.readOnly,cssModifier=_props.cssModifier;// internally we can't use `null` as a value, so we have to substitute it
var isNullSelected=selectedOptionID===null;var selectedOptionValue=isNullSelected?"":selectedOptionID;// If a placeholder was supplied, add an option to the list
if(placeholder){options=options.unshift(Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])({id:"",name:placeholder}));}var classNames=["dropdown"];if(cssModifier){classNames.push("dropdown--"+cssModifier);}if(disabled){classNames.push("dropdown--disabled");}if(readOnly){classNames.push("dropdown--read-only");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select",{className:classNames.join(" "),value:selectedOptionValue,onChange:this.onChange,disabled:disabled},options.map(function(option){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:option.get("id"),value:option.get("id")},option.get("name"));}));}}]);return Dropdown;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Dropdown.propTypes={options:__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.contains({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired})).isRequired,selectedOptionID:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,cssModifier:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};Dropdown.defaultProps={disabled:false,readOnly:false};/* harmony default export */ __webpack_exports__["a"] = (Dropdown);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_WeekdayTable__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Checkbox__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_assets_images_close_light_svg__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_assets_images_close_light_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_assets_images_close_light_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AllergiesModal_css__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AllergiesModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__AllergiesModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AllergiesModal=function(_React$Component){_inherits(AllergiesModal,_React$Component);function AllergiesModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AllergiesModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AllergiesModal.__proto__||Object.getPrototypeOf(AllergiesModal)).call.apply(_ref,[this].concat(args))),_this),_this.setAllergiesWarningStatus=function(isEnabled){_this.props.setAllergiesWarningStatus(isEnabled);},_this.closePositive=function(){_this.props.onClose(true);},_this.closeNegative=function(){_this.props.onClose(false);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AllergiesModal,[{key:"render",value:function render(){var _props=this.props,allergyInformationList=_props.allergyInformationList,isOpen=_props.isOpen,isAllergiesWarningEnabled=_props.isAllergiesWarningEnabled,isWarning=_props.isWarning;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ModalDialog__["a" /* default */],{isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"allergy-information-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"allergy-information"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"allergy-information__heading"},isWarning?"Allergies Warning!":"Allergies"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"allergy-information__details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_WeekdayTable__["a" /* default */],{cssBlockName:"allergy-information__weekday-table"},function(weekdayIndex,weekdayName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AllergyInformationRow,{key:weekdayIndex,weekdayIndex:weekdayIndex,weekdayName:weekdayName,allergyInformationList:allergyInformationList});})),isWarning?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"allergy-information__prompt-text"},"Do you want to add this week to basket?"):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"allergy-information__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Button__["a" /* default */],{className:"allergy-information__button"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{onClick:this.closePositive},isWarning?"Yes":"OK")),isWarning?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Button__["a" /* default */],{className:"allergy-information__button"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{onClick:this.closeNegative},"No")):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"allergy-information__warning-toggle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"allergy-information__warning-toggle-label"},"Show Allergy Warnings"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Checkbox__["a" /* default */],{cssModifier:"school_money",checked:isAllergiesWarningEnabled,onChange:this.setAllergiesWarningStatus}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"allergy-information__close-button",onClick:this.closeNegative},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_9_components_assets_images_close_light_svg___default.a,alt:"close"}))));}}]);return AllergiesModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);AllergiesModal.propTypes={dinnerBookingID:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,isWarning:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,onClose:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state,ownProps){return{isAllergiesWarningEnabled:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_64" /* isAllergiesWarningEnabled */])(state),allergyInformationList:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["T" /* getDinnerBookingAllergyInformation */])(state,ownProps.dinnerBookingID)};},{setAllergiesWarningStatus:__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_97" /* setAllergiesWarningStatus */]})(AllergiesModal));/**
 * A single row in the allergy details modal table - corresponding to a weekday
 */var AllergyInformationRow=function(_React$Component2){_inherits(AllergyInformationRow,_React$Component2);function AllergyInformationRow(){_classCallCheck(this,AllergyInformationRow);return _possibleConstructorReturn(this,(AllergyInformationRow.__proto__||Object.getPrototypeOf(AllergyInformationRow)).apply(this,arguments));}_createClass(AllergyInformationRow,[{key:"render",value:function render(){var _props2=this.props,weekdayName=_props2.weekdayName,weekdayIndex=_props2.weekdayIndex,allergyInformationList=_props2.allergyInformationList;var allergyDetail=allergyInformationList[weekdayIndex];if(allergyDetail===""){allergyDetail="None";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:weekdayIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"allergy-information__weekday-cell"},weekdayName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"allergy-information__detail-cell"},allergyDetail));}}]);return AllergyInformationRow;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StatusIndicator_css__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StatusIndicator_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StatusIndicator_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StatusIndicator=function(_React$Component){_inherits(StatusIndicator,_React$Component);function StatusIndicator(){_classCallCheck(this,StatusIndicator);return _possibleConstructorReturn(this,(StatusIndicator.__proto__||Object.getPrototypeOf(StatusIndicator)).apply(this,arguments));}_createClass(StatusIndicator,[{key:"render",value:function render(){var _props=this.props,color=_props.color,label=_props.label,iconContent=_props.iconContent;var hasIconContent=iconContent!==undefined;var iconStyle={backgroundColor:hasIconContent?undefined:color,borderColor:color};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"status-indicator"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"status-indicator__icon",style:iconStyle},iconContent),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"status-indicator__label"},label));}}]);return StatusIndicator;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);StatusIndicator.propTypes={color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,iconContent:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node};/* harmony default export */ __webpack_exports__["a"] = (StatusIndicator);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddToBasketConfirmationModal_css__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddToBasketConfirmationModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AddToBasketConfirmationModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddToBasketConfirmationModal=function(_React$Component){_inherits(AddToBasketConfirmationModal,_React$Component);function AddToBasketConfirmationModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddToBasketConfirmationModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddToBasketConfirmationModal.__proto__||Object.getPrototypeOf(AddToBasketConfirmationModal)).call.apply(_ref,[this].concat(args))),_this),_this.onCancelClick=function(){_this.props.onClose(false);},_this.onOKClick=function(){_this.props.onClose(true);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddToBasketConfirmationModal,[{key:"renderParentalConsentSection",value:function renderParentalConsentSection(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"consent-and-limited-places-modal__title"},"Consent Required"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"consent-and-limited-places-modal__consent-message"},"Parental permission is required. Your consent will be granted when you check out."));}},{key:"renderLimitedPlacesSection",value:function renderLimitedPlacesSection(){var _props=this.props,limitedPlaces=_props.limitedPlaces,type=_props.type;var isClub=type==="club";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"consent-and-limited-places-modal__title"},"Limited Places"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"consent-and-limited-places-modal__places"},isClub?limitedPlaces.total+" Places per Day":limitedPlaces.available+"\xA0/\xA0"+limitedPlaces.total+" Places Available"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"consent-and-limited-places-modal__places-message"},"Your place will be confirmed when you check out."));}},{key:"renderLimitedPlacesConfirmedSection",value:function renderLimitedPlacesConfirmedSection(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"consent-and-limited-places-modal__title"},"Limited Places"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"consent-and-limited-places-modal__places-message"},"Your place was already confirmed by an earlier payment. This payment will contribute towards paying off remaining amount."));}},{key:"render",value:function render(){var _props2=this.props,isOpen=_props2.isOpen,consentRequired=_props2.consentRequired,limitedPlaces=_props2.limitedPlaces;var hasLimitedPlaces=limitedPlaces.enabled&&!limitedPlaces.isPlaceReserved;var isPlaceReserved=limitedPlaces.enabled&&limitedPlaces.isPlaceReserved;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ModalDialog__["a" /* default */],{isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"consent-limited-places-modal"},consentRequired?this.renderParentalConsentSection():null,hasLimitedPlaces?this.renderLimitedPlacesSection():null,isPlaceReserved?this.renderLimitedPlacesConfirmedSection():null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"consent-and-limited-places-modal__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Button__["a" /* default */],{className:"consent-and-limited-places-modal__cancel-button",onClick:this.onCancelClick},"Cancel"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Button__["a" /* default */],{className:"consent-and-limited-places-modal__ok-button",onClick:this.onOKClick},"OK"))));}}]);return AddToBasketConfirmationModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);AddToBasketConfirmationModal.propTypes={type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["club","payment"]).isRequired,isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,consentRequired:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,limitedPlaces:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({enabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,total:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,available:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,isPlaceReserved:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool}).isRequired};AddToBasketConfirmationModal.defaultProps={isOpen:true};/* harmony default export */ __webpack_exports__["a"] = (AddToBasketConfirmationModal);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_log__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_AddOrRemoveButton__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_AddToBasketConfirmationModal__ = __webpack_require__(197);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentBasketButton=function(_React$Component){_inherits(PaymentBasketButton,_React$Component);function PaymentBasketButton(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PaymentBasketButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PaymentBasketButton.__proto__||Object.getPrototypeOf(PaymentBasketButton)).call.apply(_ref,[this].concat(args))),_this),_this.state={isConfirmationModalOpen:false},_this.addToBasket=function(event){event.stopPropagation();var _this$props=_this.props,isPendingParentalConsent=_this$props.isPendingParentalConsent,limitedPlaces=_this$props.limitedPlaces,canAddToBasket=_this$props.canAddToBasket,isPaymentInBasket=_this$props.isPaymentInBasket;if(!canAddToBasket){__WEBPACK_IMPORTED_MODULE_3_lib_log__["a" /* default */].debug("This item can't be added to the basket, ignoring...");return;}// If payment is already in basket then no need to show limited places pop up again
if(isPendingParentalConsent||!isPaymentInBasket&&limitedPlaces.enabled){_this.setState({isConfirmationModalOpen:true});}else{_this.props.addToBasket();}},_this.removeFromBasket=function(event){event.stopPropagation();_this.props.removeFromBasket();},_this.onModalClose=function(result){if(result){_this.props.addToBasket();}_this.setState({isConfirmationModalOpen:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PaymentBasketButton,[{key:"render",value:function render(){var _props=this.props,cssBlockName=_props.cssBlockName,isInBasket=_props.isInBasket,isPendingParentalConsent=_props.isPendingParentalConsent,limitedPlaces=_props.limitedPlaces;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_AddToBasketConfirmationModal__["a" /* default */],{type:"payment",isOpen:this.state.isConfirmationModalOpen,consentRequired:isPendingParentalConsent,limitedPlaces:limitedPlaces,onClose:this.onModalClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_AddOrRemoveButton__["a" /* default */],{cssBlockName:cssBlockName,isAdded:isInBasket,onAdd:this.addToBasket,onRemove:this.removeFromBasket}));}}]);return PaymentBasketButton;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);PaymentBasketButton.defaultProps={canAddToBasket:true};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref2){var paymentID=_ref2.paymentID,installmentNumber=_ref2.installmentNumber;return{isInBasket:Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_100" /* isPaymentInstallmentInBasket */])(state,paymentID,installmentNumber),isPaymentInBasket:Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_99" /* isPaymentInBasket */])(state,paymentID),isPendingParentalConsent:Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_104" /* isPaymentPendingParentalConsent */])(state,paymentID),limitedPlaces:Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_25" /* getPaymentLimitedPlacesDetails */])(state,paymentID)};},function(dispatch,_ref3){var paymentID=_ref3.paymentID,installmentNumber=_ref3.installmentNumber;return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({addToBasket:function addToBasket(){return Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_38" /* addPaymentInstallmentToBasket */])(paymentID,installmentNumber);},removeFromBasket:function removeFromBasket(){return Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_90" /* removePaymentInstallmentFromBasket */])(paymentID,installmentNumber);}},dispatch);})(PaymentBasketButton));

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(200);
module.exports = __webpack_require__(205);


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(201).enable();
  window.Promise = __webpack_require__(203);
}

// fetch() polyfill for making API calls.
__webpack_require__(204);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(66);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(116);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(116);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 204 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_includes__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_fn_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_object_values__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_fn_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_fn_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_App__ = __webpack_require__(240);
// This is the root-level index React thingy
// PLEASE DON'T ADD ANYTHING HERE
// My goal is to encapsulate into the App component, for the purposes of running tests
// -------------------------------
// Enables caching and such (part of CRA default)
// https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API
// import registerServiceWorker from "./registerServiceWorker";
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_App__["a" /* default */],null),document.getElementById("root"));// Because the user is in a captive webview, the user cannot initiate a page refresh,
// so the usefulness of this module is reduced.
//
// Additionally, this doesn't work on iOS devices, which cuts out like 50% of our targets.
// For consistency, disable the service worker
// registerServiceWorker();

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(66),n=__webpack_require__(83),p=__webpack_require__(117),q=__webpack_require__(84),r="function"===typeof Symbol&&Symbol["for"],t=r?Symbol["for"]("react.element"):60103,u=r?Symbol["for"]("react.portal"):60106,v=r?Symbol["for"]("react.fragment"):60107,w=r?Symbol["for"]("react.strict_mode"):60108,x=r?Symbol["for"]("react.provider"):60109,y=r?Symbol["for"]("react.context"):60110,z=r?Symbol["for"]("react.async_mode"):60111,A=r?Symbol["for"]("react.forward_ref"):
60112,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b=arguments.length-1,e="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};
function E(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?C("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}var H=G.prototype=new F;
H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
function L(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:I.current}}
function M(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var N=/\/+/g,O=[];function P(a,b,e,c){if(O.length){var d=O.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function Q(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>O.length&&O.push(a)}
function R(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+S(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+S(d,h);g+=R(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+S(d,h++),g+=R(d,f,e,c);else"object"===d&&(e=""+a,C("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function S(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function T(a,b){a.func.call(a.context,b,a.count++)}
function U(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,e,q.thatReturnsArgument):null!=a&&(M(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(N,"$\x26/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function V(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(N,"$\x26/")+"/");b=P(b,g,c,d);null==a||R(a,"",U,b);Q(b)}
var W={Children:{map:function(a,b,e){if(null==a)return a;var c=[];V(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=P(null,null,b,e);null==a||R(a,"",T,b);Q(b)},count:function(a){return null==a?0:R(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];V(a,b,null,q.thatReturnsArgument);return b},only:function(a){M(a)?void 0:C("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:y,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:x,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:A,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:z,createElement:L,cloneElement:function(a,b,e){null===a||void 0===a?C("267",a):void 0;var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&
(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:M,version:"16.3.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,assign:m}},X=Object.freeze({default:W}),
Y=X&&W||X;module.exports=Y["default"]?Y["default"]:Y;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var ba=__webpack_require__(83),ea=__webpack_require__(0),m=__webpack_require__(208),A=__webpack_require__(66),C=__webpack_require__(84),fa=__webpack_require__(209),ha=__webpack_require__(210),ja=__webpack_require__(211),ka=__webpack_require__(117);
function D(a){for(var b=arguments.length-1,c="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ea?void 0:D("227");
function ma(a,b,c,d,e,f,h,g,k){this._hasCaughtError=!1;this._caughtError=null;var v=Array.prototype.slice.call(arguments,3);try{b.apply(c,v)}catch(l){this._caughtError=l,this._hasCaughtError=!0}}
var E={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,h,g,k){ma.apply(E,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,h,g,k){E.invokeGuardedCallback.apply(this,arguments);if(E.hasCaughtError()){var v=E.clearCaughtError();E._hasRethrowError||(E._hasRethrowError=!0,E._rethrowError=v)}},rethrowCaughtError:function(){return na.apply(E,arguments)},hasCaughtError:function(){return E._hasCaughtError},clearCaughtError:function(){if(E._hasCaughtError){var a=
E._caughtError;E._caughtError=null;E._hasCaughtError=!1;return a}D("198")}};function na(){if(E._hasRethrowError){var a=E._rethrowError;E._rethrowError=null;E._hasRethrowError=!1;throw a;}}var oa=null,pa={};
function qa(){if(oa)for(var a in pa){var b=pa[a],c=oa.indexOf(a);-1<c?void 0:D("96",a);if(!ra[c]){b.extractEvents?void 0:D("97",a);ra[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;sa.hasOwnProperty(g)?D("99",g):void 0;sa[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ta(k[e],h,g);e=!0}else f.registrationName?(ta(f.registrationName,h,g),e=!0):e=!1;e?void 0:D("98",d,a)}}}}
function ta(a,b,c){ua[a]?D("100",a):void 0;ua[a]=b;va[a]=b.eventTypes[c].dependencies}var ra=[],sa={},ua={},va={};function wa(a){oa?D("101"):void 0;oa=Array.prototype.slice.call(a);qa()}function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];pa.hasOwnProperty(c)&&pa[c]===d||(pa[c]?D("102",c):void 0,pa[c]=d,b=!0)}b&&qa()}
var Ca=Object.freeze({plugins:ra,eventNameDispatchConfigs:sa,registrationNameModules:ua,registrationNameDependencies:va,possibleRegistrationNames:null,injectEventPluginOrder:wa,injectEventPluginsByName:xa}),Da=null,Ea=null,Fa=null;function Ga(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Fa(d);E.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Ha(a,b){null==b?D("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ia(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ja=null;
function Ka(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Ga(a,b,c[e],d[e]);else c&&Ga(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function La(a){return Ka(a,!0)}function Ma(a){return Ka(a,!1)}var Na={injectEventPluginOrder:wa,injectEventPluginsByName:xa};
function Oa(a,b){var c=a.stateNode;if(!c)return null;var d=Da(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?D("231",b,typeof c):void 0;
return c}function Pa(a,b){null!==a&&(Ja=Ha(Ja,a));a=Ja;Ja=null;a&&(b?Ia(a,La):Ia(a,Ma),Ja?D("95"):void 0,E.rethrowCaughtError())}function Qa(a,b,c,d){for(var e=null,f=0;f<ra.length;f++){var h=ra[f];h&&(h=h.extractEvents(a,b,c,d))&&(e=Ha(e,h))}Pa(e,!1)}var Ra=Object.freeze({injection:Na,getListener:Oa,runEventsInBatch:Pa,runExtractedEventsInBatch:Qa}),Sa=Math.random().toString(36).slice(2),F="__reactInternalInstance$"+Sa,Ta="__reactEventHandlers$"+Sa;
function Ua(a){if(a[F])return a[F];for(;!a[F];)if(a.parentNode)a=a.parentNode;else return null;a=a[F];return 5===a.tag||6===a.tag?a:null}function Va(a){if(5===a.tag||6===a.tag)return a.stateNode;D("33")}function Xa(a){return a[Ta]||null}var bb=Object.freeze({precacheFiberNode:function(a,b){b[F]=a},getClosestInstanceFromNode:Ua,getInstanceFromNode:function(a){a=a[F];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Va,getFiberCurrentPropsFromNode:Xa,updateFiberProps:function(a,b){a[Ta]=b}});
function L(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function cb(a,b,c){for(var d=[];a;)d.push(a),a=L(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function db(a,b,c){if(b=Oa(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a)}function eb(a){a&&a.dispatchConfig.phasedRegistrationNames&&cb(a._targetInst,db,a)}
function fb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?L(b):null;cb(b,db,a)}}function gb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Oa(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a))}function hb(a){a&&a.dispatchConfig.registrationName&&gb(a._targetInst,null,a)}function ib(a){Ia(a,eb)}
function jb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,h=0,g=e;g;g=L(g))h++;g=0;for(var k=f;k;k=L(k))g++;for(;0<h-g;)e=L(e),h--;for(;0<g-h;)f=L(f),g--;for(;h--;){if(e===f||e===f.alternate)break a;e=L(e);f=L(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){h=c.alternate;if(null!==h&&h===f)break;e.push(c);c=L(c)}for(c=[];d&&d!==f;){h=d.alternate;if(null!==h&&h===f)break;c.push(d);d=L(d)}for(d=0;d<e.length;d++)gb(e[d],"bubbled",a);for(a=c.length;0<a--;)gb(c[a],"captured",b)}
var kb=Object.freeze({accumulateTwoPhaseDispatches:ib,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ia(a,fb)},accumulateEnterLeaveDispatches:jb,accumulateDirectDispatches:function(a){Ia(a,hb)}}),lb=null;function mb(){!lb&&m.canUseDOM&&(lb="textContent"in document.documentElement?"textContent":"innerText");return lb}var M={_root:null,_startText:null,_fallbackText:null};
function nb(){if(M._fallbackText)return M._fallbackText;var a,b=M._startText,c=b.length,d,e=ob(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);M._fallbackText=e.slice(a,1<d?1-d:void 0);return M._fallbackText}function ob(){return"value"in M._root?M._root.value:M._root[mb()]}
var pb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),qb={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function N(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
A(N.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<pb.length;a++)this[pb[a]]=null}});N.Interface=qb;N.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;A(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=A({},d.Interface,a);c.extend=d.extend;rb(c);return c};rb(N);
function sb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function tb(a){a instanceof this?void 0:D("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function rb(a){a.eventPool=[];a.getPooled=sb;a.release=tb}var ub=N.extend({data:null}),vb=N.extend({data:null}),wb=[9,13,27,32],xb=m.canUseDOM&&"CompositionEvent"in window,yb=null;m.canUseDOM&&"documentMode"in document&&(yb=document.documentMode);
var zb=m.canUseDOM&&"TextEvent"in window&&!yb,Ab=m.canUseDOM&&(!xb||yb&&8<yb&&11>=yb),Bb=String.fromCharCode(32),Kb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},Lb=!1;
function Mb(a,b){switch(a){case "topKeyUp":return-1!==wb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function Nb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Ob=!1;function Pb(a,b){switch(a){case "topCompositionEnd":return Nb(b);case "topKeyPress":if(32!==b.which)return null;Lb=!0;return Bb;case "topTextInput":return a=b.data,a===Bb&&Lb?null:a;default:return null}}
function Qb(a,b){if(Ob)return"topCompositionEnd"===a||!xb&&Mb(a,b)?(a=nb(),M._root=null,M._startText=null,M._fallbackText=null,Ob=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return Ab?null:b.data;default:return null}}
var Rb={eventTypes:Kb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(xb)b:{switch(a){case "topCompositionStart":e=Kb.compositionStart;break b;case "topCompositionEnd":e=Kb.compositionEnd;break b;case "topCompositionUpdate":e=Kb.compositionUpdate;break b}e=void 0}else Ob?Mb(a,c)&&(e=Kb.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(e=Kb.compositionStart);e?(Ab&&(Ob||e!==Kb.compositionStart?e===Kb.compositionEnd&&Ob&&(f=nb()):(M._root=d,M._startText=ob(),Ob=!0)),e=ub.getPooled(e,
b,c,d),f?e.data=f:(f=Nb(c),null!==f&&(e.data=f)),ib(e),f=e):f=null;(a=zb?Pb(a,c):Qb(a,c))?(b=vb.getPooled(Kb.beforeInput,b,c,d),b.data=a,ib(b)):b=null;return null===f?b:null===b?f:[f,b]}},Sb=null,Tb={injectFiberControlledHostComponent:function(a){Sb=a}},Ub=null,Vb=null;function Wb(a){if(a=Ea(a)){Sb&&"function"===typeof Sb.restoreControlledState?void 0:D("194");var b=Da(a.stateNode);Sb.restoreControlledState(a.stateNode,a.type,b)}}function Xb(a){Ub?Vb?Vb.push(a):Vb=[a]:Ub=a}
function Yb(){return null!==Ub||null!==Vb}function Zb(){if(Ub){var a=Ub,b=Vb;Vb=Ub=null;Wb(a);if(b)for(a=0;a<b.length;a++)Wb(b[a])}}var $b=Object.freeze({injection:Tb,enqueueStateRestore:Xb,needsStateRestore:Yb,restoreStateIfNeeded:Zb});function ac(a,b){return a(b)}function bc(a,b,c){return a(b,c)}function cc(){}var dc=!1;function ec(a,b){if(dc)return a(b);dc=!0;try{return ac(a,b)}finally{dc=!1,Yb()&&(cc(),Zb())}}
var fc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function gc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!fc[a.type]:"textarea"===b?!0:!1}function hc(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function ic(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function jc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function kc(a){var b=jc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),Object.defineProperty(a,b,{enumerable:c.enumerable}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function lc(a){a._valueTracker||(a._valueTracker=kc(a))}function mc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=jc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var nc=ea.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,O="function"===typeof Symbol&&Symbol["for"],oc=O?Symbol["for"]("react.element"):60103,pc=O?Symbol["for"]("react.call"):60104,qc=O?Symbol["for"]("react.return"):60105,rc=O?Symbol["for"]("react.portal"):60106,sc=O?Symbol["for"]("react.fragment"):60107,tc=O?Symbol["for"]("react.strict_mode"):60108,uc=O?Symbol["for"]("react.provider"):60109,vc=O?Symbol["for"]("react.context"):60110,wc=O?Symbol["for"]("react.async_mode"):60111,
xc=O?Symbol["for"]("react.forward_ref"):60112,yc="function"===typeof Symbol&&Symbol.iterator;function zc(a){if(null===a||"undefined"===typeof a)return null;a=yc&&a[yc]||a["@@iterator"];return"function"===typeof a?a:null}
function Ac(a){a=a.type;if("function"===typeof a)return a.displayName||a.name;if("string"===typeof a)return a;switch(a){case sc:return"ReactFragment";case rc:return"ReactPortal";case pc:return"ReactCall";case qc:return"ReactReturn"}if("object"===typeof a&&null!==a)switch(a.$$typeof){case xc:return a=a.render.displayName||a.render.name||"",""!==a?"ForwardRef("+a+")":"ForwardRef"}return null}
function Bc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=Ac(a);var f=null;c&&(f=Ac(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a["return"]}while(a);return b}
var Cc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Dc={},Ec={};function Fc(a){if(Ec.hasOwnProperty(a))return!0;if(Dc.hasOwnProperty(a))return!1;if(Cc.test(a))return Ec[a]=!0;Dc[a]=!0;return!1}
function Gc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Hc(a,b,c,d){if(null===b||"undefined"===typeof b||Gc(a,b,c,d))return!0;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function U(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var V={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){V[a]=new U(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];V[b]=new U(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){V[a]=new U(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){V[a]=new U(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){V[a]=new U(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){V[a]=new U(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){V[a]=new U(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){V[a]=new U(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){V[a]=new U(a,5,!1,a.toLowerCase(),null)});var Sc=/[\-:]([a-z])/g;function Tc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Sc,
Tc);V[b]=new U(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});V.tabIndex=new U("tabIndex",1,!1,"tabindex",null);
function Uc(a,b,c,d){var e=V.hasOwnProperty(b)?V[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Hc(b,c,e,d)&&(c=null),d||null===e?Fc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Vc(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Xc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Yc(a,b){b=b.checked;null!=b&&Uc(a,"checked",b,!1)}
function Zc(a,b){Yc(a,b);var c=Xc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?$c(a,b.type,c):b.hasOwnProperty("defaultValue")&&$c(a,b.type,Xc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function ad(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function $c(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Xc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var bd={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function cd(a,b,c){a=N.getPooled(bd.change,a,b,c);a.type="change";Xb(c);ib(a);return a}var dd=null,ed=null;function fd(a){Pa(a,!1)}
function gd(a){var b=Va(a);if(mc(b))return a}function hd(a,b){if("topChange"===a)return b}var id=!1;m.canUseDOM&&(id=ic("input")&&(!document.documentMode||9<document.documentMode));function jd(){dd&&(dd.detachEvent("onpropertychange",kd),ed=dd=null)}function kd(a){"value"===a.propertyName&&gd(ed)&&(a=cd(ed,a,hc(a)),ec(fd,a))}function ld(a,b,c){"topFocus"===a?(jd(),dd=b,ed=c,dd.attachEvent("onpropertychange",kd)):"topBlur"===a&&jd()}
function md(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return gd(ed)}function nd(a,b){if("topClick"===a)return gd(b)}function od(a,b){if("topInput"===a||"topChange"===a)return gd(b)}
var pd={eventTypes:bd,_isInputEventSupported:id,extractEvents:function(a,b,c,d){var e=b?Va(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=hd:gc(e)?id?f=od:(f=md,h=ld):(g=e.nodeName)&&"input"===g.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=nd);if(f&&(f=f(a,b)))return cd(f,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&$c(e,"number",e.value)}},qd=N.extend({view:null,
detail:null}),rd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function sd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=rd[a])?!!b[a]:!1}function td(){return sd}
var ud=qd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:td,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),vd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},wd={eventTypes:vd,extractEvents:function(a,
b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?Ua(b):null):a=null;if(a===b)return null;var f=null==a?e:Va(a);e=null==b?e:Va(b);var h=ud.getPooled(vd.mouseLeave,a,c,d);h.type="mouseleave";h.target=f;h.relatedTarget=e;c=ud.getPooled(vd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=
f;jb(h,c,a,b);return[h,c]}};function xd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function yd(a){return(a=a._reactInternalFiber)?2===xd(a):!1}function zd(a){2!==xd(a)?D("188"):void 0}
function Ad(a){var b=a.alternate;if(!b)return b=xd(a),3===b?D("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var h=e.child;h;){if(h===c)return zd(e),a;if(h===d)return zd(e),b;h=h.sibling}D("188")}if(c["return"]!==d["return"])c=e,d=f;else{h=!1;for(var g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}h?
void 0:D("189")}}c.alternate!==d?D("190"):void 0}3!==c.tag?D("188"):void 0;return c.stateNode.current===c?a:b}function Bd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function Cd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var Dd=N.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Ed=N.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Fd=qd.extend({relatedTarget:null});
function Gd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var Hd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Id={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Jd=qd.extend({key:function(a){if(a.key){var b=Hd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Gd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Id[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:td,charCode:function(a){return"keypress"===
a.type?Gd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Gd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Kd=ud.extend({dataTransfer:null}),Ld=qd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:td}),Md=N.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Nd=ud.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Od={},Pd={};function Qd(a,b){var c=a[0].toUpperCase()+a.slice(1),d="on"+c;c="top"+c;b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Od[a]=b;Pd[c]=b}
"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function(a){Qd(a,!0)});
"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function(a){Qd(a,!1)});
var Rd={eventTypes:Od,isInteractiveTopLevelEventType:function(a){a=Pd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Pd[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Gd(c))return null;case "topKeyDown":case "topKeyUp":a=Jd;break;case "topBlur":case "topFocus":a=Fd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=
ud;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=Kd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=Ld;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Dd;break;case "topTransitionEnd":a=Md;break;case "topScroll":a=qd;break;case "topWheel":a=Nd;break;case "topCopy":case "topCut":case "topPaste":a=Ed;break;default:a=
N}b=a.getPooled(e,b,c,d);ib(b);return b}},Sd=Rd.isInteractiveTopLevelEventType,Td=[];function Ud(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Ua(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Qa(a.topLevelType,b,a.nativeEvent,hc(a.nativeEvent))}var Vd=!0;function Wd(a){Vd=!!a}
function W(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!1)}function Zd(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!0)}function Xd(a,b){bc(Yd,a,b)}
function Yd(a,b){if(Vd){var c=hc(b);c=Ua(c);null!==c&&"number"===typeof c.tag&&2!==xd(c)&&(c=null);if(Td.length){var d=Td.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{ec(Ud,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Td.length&&Td.push(a)}}}
var $d=Object.freeze({get _enabled(){return Vd},setEnabled:Wd,isEnabled:function(){return Vd},trapBubbledEvent:W,trapCapturedEvent:Zd,dispatchEvent:Yd});function ae(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var be={animationend:ae("Animation","AnimationEnd"),animationiteration:ae("Animation","AnimationIteration"),animationstart:ae("Animation","AnimationStart"),transitionend:ae("Transition","TransitionEnd")},ce={},de={};m.canUseDOM&&(de=document.createElement("div").style,"AnimationEvent"in window||(delete be.animationend.animation,delete be.animationiteration.animation,delete be.animationstart.animation),"TransitionEvent"in window||delete be.transitionend.transition);
function ee(a){if(ce[a])return ce[a];if(!be[a])return a;var b=be[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in de)return ce[a]=b[c];return a}
var fe={topAnimationEnd:ee("animationend"),topAnimationIteration:ee("animationiteration"),topAnimationStart:ee("animationstart"),topBlur:"blur",topCancel:"cancel",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",
topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoad:"load",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topScroll:"scroll",topSelectionChange:"selectionchange",topTextInput:"textInput",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:ee("transitionend"),topWheel:"wheel"},ge={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",
topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},he={},ie=0,je="_reactListenersID"+(""+Math.random()).slice(2);function ke(a){Object.prototype.hasOwnProperty.call(a,je)||(a[je]=ie++,he[a[je]]={});return he[a[je]]}function le(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function me(a,b){var c=le(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=le(c)}}function ne(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var oe=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,pe={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},qe=null,re=null,se=null,te=!1;
function ue(a,b){if(te||null==qe||qe!==fa())return null;var c=qe;"selectionStart"in c&&ne(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return se&&ha(se,c)?null:(se=c,a=N.getPooled(pe.select,re,a,b),a.type="select",a.target=qe,ib(a),a)}
var ve={eventTypes:pe,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=ke(e);f=va.onSelect;for(var h=0;h<f.length;h++){var g=f[h];if(!e.hasOwnProperty(g)||!e[g]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Va(b):window;switch(a){case "topFocus":if(gc(e)||"true"===e.contentEditable)qe=e,re=b,se=null;break;case "topBlur":se=re=qe=null;break;case "topMouseDown":te=!0;break;case "topContextMenu":case "topMouseUp":return te=!1,ue(c,d);case "topSelectionChange":if(oe)break;
case "topKeyDown":case "topKeyUp":return ue(c,d)}return null}};Na.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Da=bb.getFiberCurrentPropsFromNode;Ea=bb.getInstanceFromNode;Fa=bb.getNodeFromInstance;Na.injectEventPluginsByName({SimpleEventPlugin:Rd,EnterLeaveEventPlugin:wd,ChangeEventPlugin:pd,SelectEventPlugin:ve,BeforeInputEventPlugin:Rb});
function xe(a,b,c,d){this.tag=a;this.key=c;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function ze(a,b,c){var d=a.alternate;null===d?(d=new xe(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Ae(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case sc:return Be(a.children,b,c,e);case wc:f=11;b|=3;break;case tc:f=11;b|=2;break;case pc:f=7;break;case qc:f=9;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case uc:f=13;break;case vc:f=12;break;case xc:f=14;break;default:if("number"===typeof d.tag)return b=d,b.pendingProps=a,b.expirationTime=c,
b;D("130",null==d?d:typeof d,"")}else D("130",null==d?d:typeof d,"")}b=new xe(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Be(a,b,c,d){a=new xe(10,a,d,b);a.expirationTime=c;return a}function Ce(a,b,c){a=new xe(6,a,null,b);a.expirationTime=c;return a}function De(a,b,c){b=new xe(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var Ee=null,Fe=null;
function Ge(a){return function(b){try{return a(b)}catch(c){}}}function He(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ee=Ge(function(a){return b.onCommitFiberRoot(c,a)});Fe=Ge(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ie(a){"function"===typeof Ee&&Ee(a)}function Je(a){"function"===typeof Fe&&Fe(a)}new Set;
function Ke(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1,capturedValues:null}}function Le(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}var Me=void 0,Ne=void 0;
function Oe(a){Me=Ne=null;var b=a.alternate,c=a.updateQueue;null===c&&(c=a.updateQueue=Ke(null));null!==b?(a=b.updateQueue,null===a&&(a=b.updateQueue=Ke(null))):a=null;Me=c;Ne=a!==c?a:null}function Pe(a,b){Oe(a);a=Me;var c=Ne;null===c?Le(a,b):null===a.last||null===c.last?(Le(a,b),Le(c,b)):(Le(a,b),c.last=b)}function Qe(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Re(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,capturedValues:c.capturedValues,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var h=!0,g=c.first,k=!1;null!==g;){var v=g.expirationTime;if(v>f){var l=c.expirationTime;if(0===l||l>v)c.expirationTime=v;k||(k=!0,c.baseState=a)}else{k||
(c.first=g.next,null===c.first&&(c.last=null));if(g.isReplace)a=Qe(g,d,a,e),h=!0;else if(v=Qe(g,d,a,e))a=h?A({},a,v):A(a,v),h=!1;g.isForced&&(c.hasForceUpdate=!0);null!==g.callback&&(v=c.callbackList,null===v&&(v=c.callbackList=[]),v.push(g));null!==g.capturedValue&&(v=c.capturedValues,null===v?c.capturedValues=[g.capturedValue]:v.push(g.capturedValue))}g=g.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||null!==c.capturedValues||(b.updateQueue=null);k||(c.baseState=a);
return a}function Se(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?D("191",e):void 0;e.call(b)}}
function Te(a,b,c,d,e){function f(a,b,c,d,e,f){if(null===b||null!==a.updateQueue&&a.updateQueue.hasForceUpdate)return!0;var n=a.stateNode;a=a.type;return"function"===typeof n.shouldComponentUpdate?n.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ha(b,c)||!ha(d,e):!0}function h(a,b){b.updater=r;a.stateNode=b;b._reactInternalFiber=a}function g(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&
b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&r.enqueueReplaceState(b,b.state,null)}function k(a,b,c,d){a=a.type;if("function"===typeof a.getDerivedStateFromProps)return a.getDerivedStateFromProps.call(null,c,d)}var v=a.cacheContext,l=a.getMaskedContext,p=a.getUnmaskedContext,z=a.isContextConsumer,B=a.hasContextChanged,r={isMounted:yd,enqueueSetState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!1,isForced:!1,
capturedValue:null,next:null});b(a,f)},enqueueReplaceState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!0,isForced:!1,capturedValue:null,next:null});b(a,f)},enqueueForceUpdate:function(a,d){a=a._reactInternalFiber;d=void 0===d?null:d;var e=c(a);Pe(a,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,capturedValue:null,next:null});b(a,e)}};return{adoptClassInstance:h,callGetDerivedStateFromProps:k,
constructClassInstance:function(a,b){var c=a.type,d=p(a),e=z(a),f=e?l(a,d):ka;c=new c(b,f);var n=null!==c.state&&void 0!==c.state?c.state:null;h(a,c);a.memoizedState=n;b=k(a,c,b,n);null!==b&&void 0!==b&&(a.memoizedState=A({},a.memoizedState,b));e&&v(a,d,f);return c},mountClassInstance:function(a,b){var c=a.type,d=a.alternate,e=a.stateNode,f=a.pendingProps,n=p(a);e.props=f;e.state=a.memoizedState;e.refs=ka;e.context=l(a,n);"function"===typeof c.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||
"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(c=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),c!==e.state&&r.enqueueReplaceState(e,e.state,null),c=a.updateQueue,null!==c&&(e.state=Re(d,a,c,e,f,b)));"function"===typeof e.componentDidMount&&(a.effectTag|=4)},resumeMountClassInstance:function(a,b){var c=a.type,n=a.stateNode;n.props=a.memoizedProps;n.state=
a.memoizedState;var h=a.memoizedProps,r=a.pendingProps,z=n.context,q=p(a);q=l(a,q);(c="function"===typeof c.getDerivedStateFromProps||"function"===typeof n.getSnapshotBeforeUpdate)||"function"!==typeof n.UNSAFE_componentWillReceiveProps&&"function"!==typeof n.componentWillReceiveProps||(h!==r||z!==q)&&g(a,n,r,q);z=a.memoizedState;b=null!==a.updateQueue?Re(null,a,a.updateQueue,n,r,b):z;var u=void 0;h!==r&&(u=k(a,n,r,b));if(null!==u&&void 0!==u){b=null===b||void 0===b?u:A({},b,u);var t=a.updateQueue;
null!==t&&(t.baseState=A({},t.baseState,u))}if(!(h!==r||z!==b||B()||null!==a.updateQueue&&a.updateQueue.hasForceUpdate))return"function"===typeof n.componentDidMount&&(a.effectTag|=4),!1;(h=f(a,h,r,z,b,q))?(c||"function"!==typeof n.UNSAFE_componentWillMount&&"function"!==typeof n.componentWillMount||("function"===typeof n.componentWillMount&&n.componentWillMount(),"function"===typeof n.UNSAFE_componentWillMount&&n.UNSAFE_componentWillMount()),"function"===typeof n.componentDidMount&&(a.effectTag|=
4)):("function"===typeof n.componentDidMount&&(a.effectTag|=4),d(a,r),e(a,b));n.props=r;n.state=b;n.context=q;return h},updateClassInstance:function(a,b,c){var n=b.type,x=b.stateNode;x.props=b.memoizedProps;x.state=b.memoizedState;var h=b.memoizedProps,r=b.pendingProps,q=x.context,u=p(b);u=l(b,u);(n="function"===typeof n.getDerivedStateFromProps||"function"===typeof x.getSnapshotBeforeUpdate)||"function"!==typeof x.UNSAFE_componentWillReceiveProps&&"function"!==typeof x.componentWillReceiveProps||
(h!==r||q!==u)&&g(b,x,r,u);q=b.memoizedState;c=null!==b.updateQueue?Re(a,b,b.updateQueue,x,r,c):q;var t=void 0;h!==r&&(t=k(b,x,r,c));if(null!==t&&void 0!==t){c=null===c||void 0===c?t:A({},c,t);var y=b.updateQueue;null!==y&&(y.baseState=A({},y.baseState,t))}if(!(h!==r||q!==c||B()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=2048),!1;(t=f(b,h,r,q,c,u))?(n||"function"!==typeof x.UNSAFE_componentWillUpdate&&"function"!==typeof x.componentWillUpdate||("function"===typeof x.componentWillUpdate&&x.componentWillUpdate(r,c,u),"function"===typeof x.UNSAFE_componentWillUpdate&&x.UNSAFE_componentWillUpdate(r,c,u)),"function"===typeof x.componentDidUpdate&&(b.effectTag|=4),"function"===typeof x.getSnapshotBeforeUpdate&&(b.effectTag|=2048)):("function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=2048),d(b,r),e(b,c));x.props=r;x.state=c;x.context=u;return t}}}var Ue=Array.isArray;
function Ve(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?D("110"):void 0,d=c.stateNode);d?void 0:D("147",a);var e=""+a;if(null!==b&&null!==b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ka?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?D("148"):void 0;c._owner?void 0:D("254",a)}return a}
function We(a,b){"textarea"!==a.type&&D("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Xe(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ze(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=Ce(c,a.mode,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ve(a,b,c),d["return"]=a,d;d=Ae(c,a.mode,d);d.ref=Ve(a,b,c);d["return"]=a;return d}function v(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
De(c,a.mode,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function l(a,b,c,d,f){if(null===b||10!==b.tag)return b=Be(c,a.mode,d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ce(""+b,a.mode,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case oc:return c=Ae(b,a.mode,c),c.ref=Ve(a,null,b),c["return"]=a,c;case rc:return b=De(b,a.mode,c),b["return"]=a,b}if(Ue(b)||zc(b))return b=Be(b,
a.mode,c,null),b["return"]=a,b;We(a,b)}return null}function z(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case oc:return c.key===e?c.type===sc?l(a,b,c.props.children,d,e):k(a,b,c,d):null;case rc:return c.key===e?v(a,b,c,d):null}if(Ue(c)||zc(c))return null!==e?null:l(a,b,c,d,null);We(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case oc:return a=a.get(null===d.key?c:d.key)||null,d.type===sc?l(b,a,d.props.children,e,d.key):k(b,a,d,e);case rc:return a=a.get(null===d.key?c:d.key)||null,v(b,a,d,e)}if(Ue(d)||zc(d))return a=a.get(c)||null,l(b,a,d,e,null);We(b,d)}return null}function r(e,l,g,h){for(var r=null,k=null,q=l,u=l=0,t=null;null!==q&&u<g.length;u++){q.index>u?(t=q,q=null):t=q.sibling;var n=z(e,q,g[u],h);if(null===n){null===q&&(q=t);break}a&&q&&null===
n.alternate&&b(e,q);l=f(n,l,u);null===k?r=n:k.sibling=n;k=n;q=t}if(u===g.length)return c(e,q),r;if(null===q){for(;u<g.length;u++)if(q=p(e,g[u],h))l=f(q,l,u),null===k?r=q:k.sibling=q,k=q;return r}for(q=d(e,q);u<g.length;u++)if(t=B(q,e,u,g[u],h)){if(a&&null!==t.alternate)q["delete"](null===t.key?u:t.key);l=f(t,l,u);null===k?r=t:k.sibling=t;k=t}a&&q.forEach(function(a){return b(e,a)});return r}function Q(e,l,g,h){var r=zc(g);"function"!==typeof r?D("150"):void 0;g=r.call(g);null==g?D("151"):void 0;for(var k=
r=null,q=l,u=l=0,t=null,n=g.next();null!==q&&!n.done;u++,n=g.next()){q.index>u?(t=q,q=null):t=q.sibling;var H=z(e,q,n.value,h);if(null===H){q||(q=t);break}a&&q&&null===H.alternate&&b(e,q);l=f(H,l,u);null===k?r=H:k.sibling=H;k=H;q=t}if(n.done)return c(e,q),r;if(null===q){for(;!n.done;u++,n=g.next())n=p(e,n.value,h),null!==n&&(l=f(n,l,u),null===k?r=n:k.sibling=n,k=n);return r}for(q=d(e,q);!n.done;u++,n=g.next())if(n=B(q,e,u,n.value,h),null!==n){if(a&&null!==n.alternate)q["delete"](null===n.key?u:n.key);
l=f(n,l,u);null===k?r=n:k.sibling=n;k=n}a&&q.forEach(function(a){return b(e,a)});return r}return function(a,d,f,l){"object"===typeof f&&null!==f&&f.type===sc&&null===f.key&&(f=f.props.children);var g="object"===typeof f&&null!==f;if(g)switch(f.$$typeof){case oc:a:{var k=f.key;for(g=d;null!==g;){if(g.key===k)if(10===g.tag?f.type===sc:g.type===f.type){c(a,g.sibling);d=e(g,f.type===sc?f.props.children:f.props,l);d.ref=Ve(a,g,f);d["return"]=a;a=d;break a}else{c(a,g);break}else b(a,g);g=g.sibling}f.type===
sc?(d=Be(f.props.children,a.mode,l,f.key),d["return"]=a,a=d):(l=Ae(f,a.mode,l),l.ref=Ve(a,d,f),l["return"]=a,a=l)}return h(a);case rc:a:{for(g=f.key;null!==d;){if(d.key===g)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],l);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=De(f,a.mode,l);d["return"]=a;a=d}return h(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&
6===d.tag?(c(a,d.sibling),d=e(d,f,l),d["return"]=a,a=d):(c(a,d),d=Ce(f,a.mode,l),d["return"]=a,a=d),h(a);if(Ue(f))return r(a,d,f,l);if(zc(f))return Q(a,d,f,l);g&&We(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:l=a.type,D("152",l.displayName||l.name||"Component")}return c(a,d)}}var Ye=Xe(!0),Ze=Xe(!1);
function $e(a,b,c,d,e,f,h){function g(a,b,c){k(a,b,c,b.expirationTime)}function k(a,b,c,d){b.child=null===a?Ze(b,null,c,d):Ye(b,a.child,c,d)}function v(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function l(a,b,c,d,e,f){v(a,b);if(!c&&!e)return d&&y(b,!1),r(a,b);c=b.stateNode;nc.current=b;var l=e?null:c.render();b.effectTag|=1;e&&(k(a,b,null,f),b.child=null);k(a,b,l,f);b.memoizedState=c.state;b.memoizedProps=c.props;d&&y(b,!0);return b.child}function p(a){var b=a.stateNode;
b.pendingContext?t(a,b.pendingContext,b.pendingContext!==b.context):b.context&&t(a,b.context,!1);Y(a,b.containerInfo)}function z(a,b,c,d){var e=a.child;for(null!==e&&(e["return"]=a);null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var l=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==l&&(0===l.expirationTime||l.expirationTime>d)&&(l.expirationTime=d);else if(null!==l&&(0===l.expirationTime||l.expirationTime>d))l.expirationTime=
d;else break;f=f["return"]}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=e.child}if(null!==f)f["return"]=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){f=e;break}f=f["return"]}e=f}}function B(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps;if(!q()&&f===e)return b.stateNode=0,G(b),r(a,b);var l=e.value;b.memoizedProps=e;if(null===f)l=1073741823;else if(f.value===e.value){if(f.children===e.children)return b.stateNode=0,G(b),
r(a,b);l=0}else{var h=f.value;if(h===l&&(0!==h||1/h===1/l)||h!==h&&l!==l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b);l=0}else if(l="function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,l):1073741823,l|=0,0===l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b)}else z(b,d,l,c)}b.stateNode=l;G(b);g(a,b,e.children);return b.child}function r(a,b){null!==a&&b.child!==a.child?D("153"):void 0;if(null!==b.child){a=b.child;var c=ze(a,a.pendingProps,a.expirationTime);
b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ze(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}var Q=a.shouldSetTextContent,n=a.shouldDeprioritizeSubtree,x=b.pushHostContext,Y=b.pushHostContainer,G=d.pushProvider,R=c.getMaskedContext,S=c.getUnmaskedContext,q=c.hasContextChanged,u=c.pushContextProvider,t=c.pushTopLevelContextObject,y=c.invalidateContextProvider,H=e.enterHydrationState,Wa=e.resetHydrationState,Cb=e.tryToClaimNextHydratableInstance;
a=Te(c,f,h,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var Jc=a.adoptClassInstance,Kc=a.callGetDerivedStateFromProps,Lc=a.constructClassInstance,Db=a.mountClassInstance,Mc=a.resumeMountClassInstance,Eb=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:p(b);break;case 2:u(b);break;case 4:Y(b,b.stateNode.containerInfo);break;case 13:G(b)}return null}switch(b.tag){case 0:null!==a?D("155"):void 0;var d=b.type,
e=b.pendingProps,f=S(b);f=R(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,"function"===typeof f.getDerivedStateFromProps&&(e=Kc(b,d,e,b.memoizedState),null!==e&&void 0!==e&&(b.memoizedState=A({},b.memoizedState,e))),e=u(b),Jc(b,d),Db(b,c),a=l(a,b,!0,e,!1,c)):(b.tag=1,g(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,q()||
b.memoizedProps!==c?(d=S(b),d=R(b,d),e=e(c,d),b.effectTag|=1,g(a,b,e),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 2:e=u(b);null===a?null===b.stateNode?(Lc(b,b.pendingProps),Db(b,c),d=!0):d=Mc(b,c):d=Eb(a,b,c);f=!1;var h=b.updateQueue;null!==h&&null!==h.capturedValues&&(f=d=!0);return l(a,b,d,e,f,c);case 3:a:if(p(b),d=b.updateQueue,null!==d){f=b.memoizedState;e=Re(a,b,d,null,null,c);b.memoizedState=e;d=b.updateQueue;if(null!==d&&null!==d.capturedValues)d=null;else if(f===e){Wa();a=r(a,b);break a}else d=
e.element;f=b.stateNode;(null===a||null===a.child)&&f.hydrate&&H(b)?(b.effectTag|=2,b.child=Ze(b,null,d,c)):(Wa(),g(a,b,d));b.memoizedState=e;a=b.child}else Wa(),a=r(a,b);return a;case 5:a:{x(b);null===a&&Cb(b);e=b.type;h=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!q()&&h===d){if(h=b.mode&1&&n(e,d))b.expirationTime=1073741823;if(!h||1073741823!==c){a=r(a,b);break a}}h=d.children;Q(e,d)?h=null:f&&Q(e,f)&&(b.effectTag|=16);v(a,b);1073741823!==c&&b.mode&1&&n(e,d)?(b.expirationTime=
1073741823,b.memoizedProps=d,a=null):(g(a,b,h),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Cb(b),b.memoizedProps=b.pendingProps,null;case 8:b.tag=7;case 7:return e=b.pendingProps,q()||b.memoizedProps!==e||(e=b.memoizedProps),d=e.children,b.stateNode=null===a?Ze(b,b.stateNode,d,c):Ye(b,a.stateNode,d,c),b.memoizedProps=e,b.stateNode;case 9:return null;case 4:return Y(b,b.stateNode.containerInfo),e=b.pendingProps,q()||b.memoizedProps!==e?(null===a?b.child=Ye(b,null,e,c):g(a,b,e),b.memoizedProps=
e,a=b.child):a=r(a,b),a;case 14:return c=b.type.render,c=c(b.pendingProps,b.ref),g(a,b,c),b.memoizedProps=c,b.child;case 10:return c=b.pendingProps,q()||b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 11:return c=b.pendingProps.children,q()||null!==c&&b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 13:return B(a,b,c);case 12:a:{d=b.type;f=b.pendingProps;h=b.memoizedProps;e=d._currentValue;var t=d._changedBits;if(q()||0!==t||h!==f){b.memoizedProps=
f;var k=f.unstable_observedBits;if(void 0===k||null===k)k=1073741823;b.stateNode=k;if(0!==(t&k))z(b,d,t,c);else if(h===f){a=r(a,b);break a}c=f.children;c=c(e);g(a,b,c);a=b.child}else a=r(a,b)}return a;default:D("156")}}}}
function af(a,b,c,d,e){function f(a){a.effectTag|=4}var h=a.createInstance,g=a.createTextInstance,k=a.appendInitialChild,v=a.finalizeInitialChildren,l=a.prepareUpdate,p=a.persistence,z=b.getRootHostContainer,B=b.popHostContext,r=b.getHostContext,Q=b.popHostContainer,n=c.popContextProvider,x=c.popTopLevelContextObject,Y=d.popProvider,G=e.prepareToHydrateHostInstance,R=e.prepareToHydrateHostTextInstance,S=e.popHydrationState,q=void 0,u=void 0,t=void 0;a.mutation?(q=function(){},u=function(a,b,c){(b.updateQueue=
c)&&f(b)},t=function(a,b,c,d){c!==d&&f(b)}):p?D("235"):D("236");return{completeWork:function(a,b,c){var d=b.pendingProps;switch(b.tag){case 1:return null;case 2:return n(b),a=b.stateNode,d=b.updateQueue,null!==d&&null!==d.capturedValues&&(b.effectTag&=-65,"function"===typeof a.componentDidCatch?b.effectTag|=256:d.capturedValues=null),null;case 3:Q(b);x(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)S(b),b.effectTag&=-3;q(b);a=b.updateQueue;
null!==a&&null!==a.capturedValues&&(b.effectTag|=256);return null;case 5:B(b);c=z();var e=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,H=b.stateNode,y=r();H=l(H,e,p,d,c,y);u(a,b,H,e,p,d,c,y);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!d)return null===b.stateNode?D("166"):void 0,null;a=r();if(S(b))G(b,c,a)&&f(b);else{p=h(e,d,c,a,b);a:for(y=b.child;null!==y;){if(5===y.tag||6===y.tag)k(p,y.stateNode);else if(4!==y.tag&&null!==y.child){y.child["return"]=y;y=y.child;continue}if(y===b)break;
for(;null===y.sibling;){if(null===y["return"]||y["return"]===b)break a;y=y["return"]}y.sibling["return"]=y["return"];y=y.sibling}v(p,e,d,c,a)&&f(b);b.stateNode=p}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)t(a,b,a.memoizedProps,d);else{if("string"!==typeof d)return null===b.stateNode?D("166"):void 0,null;a=z();c=r();S(b)?R(b)&&f(b):b.stateNode=g(d,a,c,b)}return null;case 7:(d=b.memoizedProps)?void 0:D("165");b.tag=8;e=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==
p;){if(5===p.tag||6===p.tag||4===p.tag)D("247");else if(9===p.tag)e.push(p.pendingProps.value);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=d.handler;d=p(d.props,e);b.child=Ye(b,null!==a?a.child:null,d,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 14:return null;case 10:return null;case 11:return null;case 4:return Q(b),q(b),null;
case 13:return Y(b),null;case 12:return null;case 0:D("167");default:D("156")}}}}
function bf(a,b,c,d,e){var f=a.popHostContainer,h=a.popHostContext,g=b.popContextProvider,k=b.popTopLevelContextObject,v=c.popProvider;return{throwException:function(a,b,c){b.effectTag|=512;b.firstEffect=b.lastEffect=null;b={value:c,source:b,stack:Bc(b)};do{switch(a.tag){case 3:Oe(a);a.updateQueue.capturedValues=[b];a.effectTag|=1024;return;case 2:if(c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&!e(c)){Oe(a);c=a.updateQueue;var d=c.capturedValues;null===d?
c.capturedValues=[b]:d.push(b);a.effectTag|=1024;return}}a=a["return"]}while(null!==a)},unwindWork:function(a){switch(a.tag){case 2:g(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return f(a),k(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return h(a),null;case 4:return f(a),null;case 13:return v(a),null;default:return null}},unwindInterruptedWork:function(a){switch(a.tag){case 2:g(a);break;case 3:f(a);k(a);break;case 5:h(a);break;case 4:f(a);break;case 13:v(a)}}}}
function cf(a,b){var c=b.source;null===b.stack&&Bc(c);null!==c&&Ac(c);b=b.value;null!==a&&2===a.tag&&Ac(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}
function df(a,b,c,d,e){function f(a){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(t){b(a,t)}else c.current=null}function h(a){"function"===typeof Je&&Je(a);switch(a.tag){case 2:f(a);var c=a.stateNode;if("function"===typeof c.componentWillUnmount)try{c.props=a.memoizedProps,c.state=a.memoizedState,c.componentWillUnmount()}catch(t){b(a,t)}break;case 5:f(a);break;case 7:g(a.stateNode);break;case 4:p&&v(a)}}function g(a){for(var b=a;;)if(h(b),null===b.child||p&&4===b.tag){if(b===
a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function k(a){return 5===a.tag||3===a.tag||4===a.tag}function v(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?D("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c["return"]}c=!0}if(5===
b.tag||6===b.tag)g(b),e?S(d,b.stateNode):R(d,b.stateNode);else if(4===b.tag?d=b.stateNode.containerInfo:h(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var l=a.getPublicInstance,p=a.mutation;a=a.persistence;p||(a?D("235"):D("236"));var z=p.commitMount,B=p.commitUpdate,r=p.resetTextContent,Q=p.commitTextUpdate,n=p.appendChild,
x=p.appendChildToContainer,Y=p.insertBefore,G=p.insertInContainerBefore,R=p.removeChild,S=p.removeChildFromContainer;return{commitBeforeMutationLifeCycles:function(a,b){switch(b.tag){case 2:if(b.effectTag&2048&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;a.props=b.memoizedProps;a.state=b.memoizedState;b=a.getSnapshotBeforeUpdate(c,d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:break;default:D("163")}},commitResetTextContent:function(a){r(a.stateNode)},
commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(k(b)){var c=b;break a}b=b["return"]}D("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:D("161")}c.effectTag&16&&(r(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||k(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==
c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?G(b,e.stateNode,c):Y(b,e.stateNode,c):d?x(b,e.stateNode):n(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){v(a);
a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&B(c,f,e,a,d,b)}break;case 6:null===b.stateNode?D("162"):void 0;c=b.memoizedProps;Q(b.stateNode,null!==a?a.memoizedProps:c,c);break;case 3:break;default:D("163")}},commitLifeCycles:function(a,b,c){switch(c.tag){case 2:a=
c.stateNode;if(c.effectTag&4)if(null===b)a.props=c.memoizedProps,a.state=c.memoizedState,a.componentDidMount();else{var d=b.memoizedProps;b=b.memoizedState;a.props=c.memoizedProps;a.state=c.memoizedState;a.componentDidUpdate(d,b,a.__reactInternalSnapshotBeforeUpdate)}c=c.updateQueue;null!==c&&Se(c,a);break;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=l(c.child.stateNode);break;case 2:a=c.child.stateNode}Se(b,a)}break;case 5:a=c.stateNode;null===b&&c.effectTag&
4&&z(a,c.type,c.memoizedProps,c);break;case 6:break;case 4:break;default:D("163")}},commitErrorLogging:function(a,b){switch(a.tag){case 2:var c=a.type;b=a.stateNode;var d=a.updateQueue;null===d||null===d.capturedValues?D("264"):void 0;var f=d.capturedValues;d.capturedValues=null;"function"!==typeof c.getDerivedStateFromCatch&&e(b);b.props=a.memoizedProps;b.state=a.memoizedState;for(c=0;c<f.length;c++){d=f[c];var l=d.value,g=d.stack;cf(a,d);b.componentDidCatch(l,{componentStack:null!==g?g:""})}break;
case 3:c=a.updateQueue;null===c||null===c.capturedValues?D("264"):void 0;f=c.capturedValues;c.capturedValues=null;for(c=0;c<f.length;c++)d=f[c],cf(a,d),b(d.value);break;default:D("265")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=l(c);break;default:a=c}"function"===typeof b?b(a):b.current=a}},commitDetachRef:function(a){a=a.ref;null!==a&&("function"===typeof a?a(null):a.current=null)}}}var ef={};
function ff(a,b){function c(a){a===ef?D("174"):void 0;return a}var d=a.getChildHostContext,e=a.getRootHostContext;a=b.createCursor;var f=b.push,h=b.pop,g=a(ef),k=a(ef),v=a(ef);return{getHostContext:function(){return c(g.current)},getRootHostContainer:function(){return c(v.current)},popHostContainer:function(a){h(g,a);h(k,a);h(v,a)},popHostContext:function(a){k.current===a&&(h(g,a),h(k,a))},pushHostContainer:function(a,b){f(v,b,a);f(k,a,a);f(g,ef,a);b=e(b);h(g,a);f(g,b,a)},pushHostContext:function(a){var b=
c(v.current),e=c(g.current);b=d(e,a.type,b);e!==b&&(f(k,a,a),f(g,b,a))}}}
function gf(a){function b(a,b){var c=new xe(5,null,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=h(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];p=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){D("175")},prepareToHydrateHostTextInstance:function(){D("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,h=a.canHydrateTextInstance,g=a.getNextHydratableSibling,k=a.getFirstHydratableChild,v=a.hydrateInstance,l=a.hydrateTextInstance,p=null,z=null,B=!1;return{enterHydrationState:function(a){z=
k(a.stateNode.containerInfo);p=a;return B=!0},resetHydrationState:function(){z=p=null;B=!1},tryToClaimNextHydratableInstance:function(a){if(B){var d=z;if(d){if(!c(a,d)){d=g(d);if(!d||!c(a,d)){a.effectTag|=2;B=!1;p=a;return}b(p,z)}p=a;z=k(d)}else a.effectTag|=2,B=!1,p=a}},prepareToHydrateHostInstance:function(a,b,c){b=v(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return l(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
p)return!1;if(!B)return d(a),B=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=z;c;)b(a,c),c=g(c);d(a);z=p?g(a.stateNode):null;return!0}}}
function hf(a){function b(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function c(a){return 2===a.tag&&null!=a.type.childContextTypes}function d(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:D("108",Ac(a)||"Unknown",e);return A({},b,c)}var e=a.createCursor,f=a.push,h=a.pop,g=e(ka),k=e(!1),v=ka;return{getUnmaskedContext:function(a){return c(a)?
v:g.current},cacheContext:b,getMaskedContext:function(a,c){var d=a.type.contextTypes;if(!d)return ka;var e=a.stateNode;if(e&&e.__reactInternalMemoizedUnmaskedChildContext===c)return e.__reactInternalMemoizedMaskedChildContext;var f={},g;for(g in d)f[g]=c[g];e&&b(a,c,f);return f},hasContextChanged:function(){return k.current},isContextConsumer:function(a){return 2===a.tag&&null!=a.type.contextTypes},isContextProvider:c,popContextProvider:function(a){c(a)&&(h(k,a),h(g,a))},popTopLevelContextObject:function(a){h(k,
a);h(g,a)},pushTopLevelContextObject:function(a,b,c){null!=g.cursor?D("168"):void 0;f(g,b,a);f(k,c,a)},processChildContext:d,pushContextProvider:function(a){if(!c(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ka;v=g.current;f(g,b,a);f(k,k.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:D("169");if(b){var e=d(a,v);c.__reactInternalMemoizedMergedChildContext=e;h(k,a);h(g,a);f(g,e,a)}else h(k,a);f(k,b,a)},findCurrentUnmaskedContext:function(a){for(2!==
xd(a)||2!==a.tag?D("170"):void 0;3!==a.tag;){if(c(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:D("171")}return a.stateNode.context}}}
function jf(a){var b=a.createCursor,c=a.push,d=a.pop,e=b(null),f=b(null),h=b(0);return{pushProvider:function(a){var b=a.type._context;c(h,b._changedBits,a);c(f,b._currentValue,a);c(e,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode},popProvider:function(a){var b=h.current,c=f.current;d(e,a);d(f,a);d(h,a);a=a.type._context;a._currentValue=c;a._changedBits=b}}}
function kf(){var a=[],b=-1;return{createCursor:function(a){return{current:a}},isEmpty:function(){return-1===b},pop:function(c){0>b||(c.current=a[b],a[b]=null,b--)},push:function(c,d){b++;a[b]=c.current;c.current=d},checkThatStackIsEmpty:function(){},resetStackAfterFatalErrorInDev:function(){}}}
function lf(a){function b(){if(null!==I)for(var a=I["return"];null!==a;)Lc(a),a=a["return"];Ya=null;Z=0;I=null;Nc=!1}function c(a){return null!==ya&&ya.has(a)}function d(a){for(;;){var b=a.alternate,c=a["return"],d=a.sibling;if(0===(a.effectTag&512)){b=Cb(b,a,Z);var e=a;if(1073741823===Z||1073741823!==e.expirationTime){b:switch(e.tag){case 3:case 2:var f=e.updateQueue;f=null===f?0:f.expirationTime;break b;default:f=0}for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=
g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{Nc=!0;break}}else{a=Kc(a);if(null!==a)return a.effectTag&=2559,a;null!==c&&(c.firstEffect=c.lastEffect=
null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}function e(a){var b=Wa(a.alternate,a,Z);null===b&&(b=d(a));nc.current=null;return b}function f(a,c,f){ca?D("243"):void 0;ca=!0;if(c!==Z||a!==Ya||null===I)b(),Ya=a,Z=c,I=ze(Ya.current,null,Z),a.pendingCommitExpirationTime=0;var g=!1;do{try{if(f)for(;null!==I&&!S();)I=e(I);else for(;null!==I;)I=e(I)}catch(Oc){if(null===I){g=!0;q(Oc);break}f=I;var h=f["return"];if(null===h){g=!0;q(Oc);break}Jc(h,f,Oc);I=d(f)}break}while(1);
ca=!1;if(g||null!==I)return null;if(Nc)return a.pendingCommitExpirationTime=c,a.current.alternate;D("262")}function h(a,b,c,d){a={value:c,source:a,stack:Bc(a)};Pe(b,{expirationTime:d,partialState:null,callback:null,isReplace:!1,isForced:!1,capturedValue:a,next:null});v(b,d)}function g(a,b){a:{ca&&!Za?D("263"):void 0;for(var d=a["return"];null!==d;){switch(d.tag){case 2:var e=d.stateNode;if("function"===typeof d.type.getDerivedStateFromCatch||"function"===typeof e.componentDidCatch&&!c(e)){h(a,d,b,
1);a=void 0;break a}break;case 3:h(a,d,b,1);a=void 0;break a}d=d["return"]}3===a.tag&&h(a,a,b,1);a=void 0}return a}function k(a){a=0!==ia?ia:ca?Za?1:Z:a.mode&1?za?10*(((l()+15)/10|0)+1):25*(((l()+500)/25|0)+1):1;za&&(0===da||a>da)&&(da=a);return a}function v(a,c){a:{for(;null!==a;){if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>c)&&(a.alternate.expirationTime=c);if(null===a["return"])if(3===a.tag){var d=
a.stateNode;!ca&&0!==Z&&c<Z&&b();ca&&!Za&&Ya===d||B(d,c);Fb>xg&&D("185")}else{c=void 0;break a}a=a["return"]}c=void 0}return c}function l(){ye=Ic()-Pc;return yg=(ye/10|0)+2}function p(a,b,c,d,e){var f=ia;ia=1;try{return a(b,c,d,e)}finally{ia=f}}function z(a){if(0!==Gb){if(a>Gb)return;mg(Qc)}var b=Ic()-Pc;Gb=a;Qc=lg(Q,{timeout:10*(a-2)-b})}function B(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===K?(la=K=a,a.nextScheduledRoot=a):(K=K.nextScheduledRoot=a,K.nextScheduledRoot=la);
else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}T||(J?Hb&&(aa=a,P=1,G(a,1,!1)):1===b?n():z(b))}function r(){var a=0,b=null;if(null!==K)for(var c=K,d=la;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===K?D("244"):void 0;if(d===d.nextScheduledRoot){la=K=d.nextScheduledRoot=null;break}else if(d===la)la=e=d.nextScheduledRoot,K.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===K){K=c;K.nextScheduledRoot=la;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=
d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===K)break;c=d;d=d.nextScheduledRoot}}c=aa;null!==c&&c===b&&1===a?Fb++:Fb=0;aa=b;P=a}function Q(a){x(0,!0,a)}function n(){x(1,!1,null)}function x(a,b,c){$a=c;r();if(b)for(;null!==aa&&0!==P&&(0===a||a>=P)&&(!Ib||l()>=P);)G(aa,P,!Ib),r();else for(;null!==aa&&0!==P&&(0===a||a>=P);)G(aa,P,!1),r();null!==$a&&(Gb=0,Qc=-1);0!==P&&z(P);$a=null;Ib=!1;Y()}function Y(){Fb=0;if(null!==Aa){var a=Aa;Aa=null;for(var b=
0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(wg){Ba||(Ba=!0,Jb=wg)}}}if(Ba)throw a=Jb,Jb=null,Ba=!1,a;}function G(a,b,c){T?D("245"):void 0;T=!0;c?(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!0),null!==c&&(S()?a.finishedWork=c:R(a,c,b)))):(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!1),null!==c&&R(a,c,b)));T=!1}function R(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Aa?Aa=[d]:Aa.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=
0;return}a.finishedWork=null;Za=ca=!0;c=b.stateNode;c.current===b?D("177"):void 0;d=c.pendingCommitExpirationTime;0===d?D("261"):void 0;c.pendingCommitExpirationTime=0;var e=l();nc.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var f=b.firstEffect}else f=b;else f=b.firstEffect;zg(c.containerInfo);for(w=f;null!==w;){var h=!1,k=void 0;try{for(;null!==w;)w.effectTag&2048&&Db(w.alternate,w),w=w.nextEffect}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==
w&&(w=w.nextEffect))}for(w=f;null!==w;){h=!1;k=void 0;try{for(;null!==w;){var p=w.effectTag;p&16&&Mc(w);if(p&128){var n=w.alternate;null!==n&&kg(n)}switch(p&14){case 2:Eb(w);w.effectTag&=-3;break;case 6:Eb(w);w.effectTag&=-3;we(w.alternate,w);break;case 4:we(w.alternate,w);break;case 8:gg(w)}w=w.nextEffect}}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==w&&(w=w.nextEffect))}Ag(c.containerInfo);c.current=b;for(w=f;null!==w;){p=!1;n=void 0;try{for(f=c,h=e,k=d;null!==w;){var r=w.effectTag;
r&36&&hg(f,w.alternate,w,h,k);r&256&&ig(w,q);r&128&&jg(w);var t=w.nextEffect;w.nextEffect=null;w=t}}catch(ab){p=!0,n=ab}p&&(null===w?D("178"):void 0,g(w,n),null!==w&&(w=w.nextEffect))}ca=Za=!1;"function"===typeof Ie&&Ie(b.stateNode);b=c.current.expirationTime;0===b&&(ya=null);a.remainingExpirationTime=b}function S(){return null===$a||$a.timeRemaining()>Bg?!1:Ib=!0}function q(a){null===aa?D("246"):void 0;aa.remainingExpirationTime=0;Ba||(Ba=!0,Jb=a)}var u=kf(),t=ff(a,u),y=hf(u);u=jf(u);var H=gf(a),
Wa=$e(a,t,y,u,H,v,k).beginWork,Cb=af(a,t,y,u,H).completeWork;t=bf(t,y,u,v,c);var Jc=t.throwException,Kc=t.unwindWork,Lc=t.unwindInterruptedWork;t=df(a,g,v,k,function(a){null===ya?ya=new Set([a]):ya.add(a)},l);var Db=t.commitBeforeMutationLifeCycles,Mc=t.commitResetTextContent,Eb=t.commitPlacement,gg=t.commitDeletion,we=t.commitWork,hg=t.commitLifeCycles,ig=t.commitErrorLogging,jg=t.commitAttachRef,kg=t.commitDetachRef,Ic=a.now,lg=a.scheduleDeferredCallback,mg=a.cancelDeferredCallback,zg=a.prepareForCommit,
Ag=a.resetAfterCommit,Pc=Ic(),yg=2,ye=Pc,Rc=0,ia=0,ca=!1,I=null,Ya=null,Z=0,w=null,Za=!1,Nc=!1,ya=null,la=null,K=null,Gb=0,Qc=-1,T=!1,aa=null,P=0,da=0,Ib=!1,Ba=!1,Jb=null,$a=null,J=!1,Hb=!1,za=!1,Aa=null,xg=1E3,Fb=0,Bg=1;return{recalculateCurrentTime:l,computeExpirationForFiber:k,scheduleWork:v,requestWork:B,flushRoot:function(a,b){T?D("253"):void 0;aa=a;P=b;G(a,b,!1);n();Y()},batchedUpdates:function(a,b){var c=J;J=!0;try{return a(b)}finally{(J=c)||T||n()}},unbatchedUpdates:function(a,b){if(J&&!Hb){Hb=
!0;try{return a(b)}finally{Hb=!1}}return a(b)},flushSync:function(a,b){T?D("187"):void 0;var c=J;J=!0;try{return p(a,b)}finally{J=c,n()}},flushControlled:function(a){var b=J;J=!0;try{p(a)}finally{(J=b)||T||x(1,!1,null)}},deferredUpdates:function(a){var b=ia;ia=25*(((l()+500)/25|0)+1);try{return a()}finally{ia=b}},syncUpdates:p,interactiveUpdates:function(a,b,c){if(za)return a(b,c);J||T||0===da||(x(da,!1,null),da=0);var d=za,e=J;J=za=!0;try{return a(b,c)}finally{za=d,(J=e)||T||n()}},flushInteractiveUpdates:function(){T||
0===da||(x(da,!1,null),da=0)},computeUniqueAsyncExpiration:function(){var a=25*(((l()+500)/25|0)+1);a<=Rc&&(a=Rc+1);return Rc=a},legacyContext:y}}
function mf(a){function b(a,b,c,d,e,h){d=b.current;if(c){c=c._reactInternalFiber;var l=g(c);c=k(c)?v(c,l):l}else c=ka;null===b.context?b.context=c:b.pendingContext=c;b=h;Pe(d,{expirationTime:e,partialState:{element:a},callback:void 0===b?null:b,isReplace:!1,isForced:!1,capturedValue:null,next:null});f(d,e);return e}var c=a.getPublicInstance;a=lf(a);var d=a.recalculateCurrentTime,e=a.computeExpirationForFiber,f=a.scheduleWork,h=a.legacyContext,g=h.findCurrentUnmaskedContext,k=h.isContextProvider,v=
h.processChildContext;return{createContainer:function(a,b,c){b=new xe(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a},updateContainer:function(a,c,f,h){var g=c.current,k=d();g=e(g);return b(a,c,f,k,g,h)},updateContainerAtExpirationTime:function(a,c,e,f,g){var h=d();return b(a,c,e,h,f,g)},flushRoot:a.flushRoot,
requestWork:a.requestWork,computeUniqueAsyncExpiration:a.computeUniqueAsyncExpiration,batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,syncUpdates:a.syncUpdates,interactiveUpdates:a.interactiveUpdates,flushInteractiveUpdates:a.flushInteractiveUpdates,flushControlled:a.flushControlled,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},
findHostInstance:function(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?D("188"):D("268",Object.keys(a)));a=Bd(b);return null===a?null:a.stateNode},findHostInstanceWithNoPortals:function(a){a=Cd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return He(A({},a,{findHostInstanceByFiber:function(a){a=Bd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}}}
var nf=Object.freeze({default:mf}),of=nf&&mf||nf,pf=of["default"]?of["default"]:of;function qf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:rc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var rf="object"===typeof performance&&"function"===typeof performance.now,sf=void 0;sf=rf?function(){return performance.now()}:function(){return Date.now()};var tf=void 0,uf=void 0;
if(m.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var vf=null,wf=!1,xf=-1,yf=!1,zf=0,Af=33,Bf=33,Cf=void 0;Cf=rf?{didTimeout:!1,timeRemaining:function(){var a=zf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=zf-Date.now();return 0<a?a:0}};var Df="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Df){wf=!1;a=sf();if(0>=zf-a)if(-1!==
xf&&xf<=a)Cf.didTimeout=!0;else{yf||(yf=!0,requestAnimationFrame(Ef));return}else Cf.didTimeout=!1;xf=-1;a=vf;vf=null;null!==a&&a(Cf)}},!1);var Ef=function(a){yf=!1;var b=a-zf+Bf;b<Bf&&Af<Bf?(8>b&&(b=8),Bf=b<Af?Af:b):Af=b;zf=a+Bf;wf||(wf=!0,window.postMessage(Df,"*"))};tf=function(a,b){vf=a;null!=b&&"number"===typeof b.timeout&&(xf=sf()+b.timeout);yf||(yf=!0,requestAnimationFrame(Ef));return 0};uf=function(){vf=null;wf=!1;xf=-1}}else tf=window.requestIdleCallback,uf=window.cancelIdleCallback;else tf=
function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})})},uf=function(a){clearTimeout(a)};function Ff(a){var b="";ea.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function Gf(a,b){a=A({children:void 0},b);if(b=Ff(b.children))a.children=b;return a}
function Hf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function If(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Jf(a,b){null!=b.dangerouslySetInnerHTML?D("91"):void 0;return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Kf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?D("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:D("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Lf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Mf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Nf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Of(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Pf(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Of(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Qf=void 0,Rf=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Nf.svg||"innerHTML"in a)a.innerHTML=b;else{Qf=Qf||document.createElement("div");Qf.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=Qf.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Sf(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Tf={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Uf=["Webkit","ms","Moz","O"];Object.keys(Tf).forEach(function(a){Uf.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Tf[b]=Tf[a]})});
function Vf(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Tf.hasOwnProperty(e)&&Tf[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Wf=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Xf(a,b,c){b&&(Wf[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?D("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?D("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:D("61")),null!=b.style&&"object"!==typeof b.style?D("62",c()):void 0)}
function Yf(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Zf=C.thatReturns("");
function $f(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=ke(a);b=va[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?Zd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(Zd("topFocus","focus",a),Zd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(ic("cancel",!0)&&Zd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(ic("close",!0)&&Zd("topClose","close",a),c.topClose=!0):fe.hasOwnProperty(e)&&W(e,fe[e],a),c[e]=!0)}}
function ag(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Nf.html&&(d=Of(a));d===Nf.html?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function bg(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function cg(a,b,c,d){var e=Yf(b,c);switch(b){case "iframe":case "object":W("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);f=c;break;case "source":W("topError","error",a);f=c;break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);f=c;break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);f=c;break;case "details":W("topToggle","toggle",a);f=c;break;case "input":Wc(a,c);f=Vc(a,c);W("topInvalid",
"invalid",a);$f(d,"onChange");break;case "option":f=Gf(a,c);break;case "select":If(a,c);f=A({},c,{value:void 0});W("topInvalid","invalid",a);$f(d,"onChange");break;case "textarea":Kf(a,c);f=Jf(a,c);W("topInvalid","invalid",a);$f(d,"onChange");break;default:f=c}Xf(b,f,Zf);var h=f,g;for(g in h)if(h.hasOwnProperty(g)){var k=h[g];"style"===g?Vf(a,k,Zf):"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,null!=k&&Rf(a,k)):"children"===g?"string"===typeof k?("textarea"!==b||""!==k)&&Sf(a,k):"number"===typeof k&&
Sf(a,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(ua.hasOwnProperty(g)?null!=k&&$f(d,g):null!=k&&Uc(a,g,k,e))}switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Hf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Hf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=C)}}
function dg(a,b,c,d,e){var f=null;switch(b){case "input":c=Vc(a,c);d=Vc(a,d);f=[];break;case "option":c=Gf(a,c);d=Gf(a,d);f=[];break;case "select":c=A({},c,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":c=Jf(a,c);d=Jf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}Xf(b,d,Zf);b=a=void 0;var h=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var g=c[a];for(b in g)g.hasOwnProperty(b)&&(h||
(h={}),h[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ua.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];g=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==g&&(null!=k||null!=g))if("style"===a)if(g){for(b in g)!g.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(h||(h={}),h[b]="");for(b in k)k.hasOwnProperty(b)&&g[b]!==k[b]&&(h||(h={}),h[b]=k[b])}else h||(f||(f=[]),f.push(a,h)),
h=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,g=g?g.__html:void 0,null!=k&&g!==k&&(f=f||[]).push(a,""+k)):"children"===a?g===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ua.hasOwnProperty(a)?(null!=k&&$f(e,a),f||g===k||(f=[])):(f=f||[]).push(a,k))}h&&(f=f||[]).push("style",h);return f}
function eg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Yc(a,e);Yf(c,d);d=Yf(c,e);for(var f=0;f<b.length;f+=2){var h=b[f],g=b[f+1];"style"===h?Vf(a,g,Zf):"dangerouslySetInnerHTML"===h?Rf(a,g):"children"===h?Sf(a,g):Uc(a,h,g,d)}switch(c){case "input":Zc(a,e);break;case "textarea":Lf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Hf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Hf(a,!!e.multiple,e.defaultValue,!0):Hf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function fg(a,b,c,d,e){switch(b){case "iframe":case "object":W("topLoad","load",a);break;case "video":case "audio":for(var f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);break;case "source":W("topError","error",a);break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);break;case "details":W("topToggle","toggle",a);break;case "input":Wc(a,c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "select":If(a,
c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "textarea":Kf(a,c),W("topInvalid","invalid",a),$f(e,"onChange")}Xf(b,c,Zf);d=null;for(var h in c)c.hasOwnProperty(h)&&(f=c[h],"children"===h?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):ua.hasOwnProperty(h)&&null!=f&&$f(e,h));switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function ng(a,b){return a.nodeValue!==b}
var og=Object.freeze({createElement:ag,createTextNode:bg,setInitialProperties:cg,diffProperties:dg,updateProperties:eg,diffHydratedProperties:fg,diffHydratedText:ng,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Zc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Xa(d);e?void 0:D("90");mc(d);Zc(d,e)}}}break;case "textarea":Lf(a,c);break;case "select":b=c.value,null!=b&&Hf(a,!!c.multiple,b,!1)}}});Tb.injectFiberControlledHostComponent(og);var pg=null,qg=null;
function rg(a){this._expirationTime=X.computeUniqueAsyncExpiration();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}rg.prototype.render=function(a){this._defer?void 0:D("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new sg;X.updateContainerAtExpirationTime(a,b,null,c,d._onCommit);return d};
rg.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
rg.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:D("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?D("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;X.flushRoot(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};rg.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function sg(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}sg.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
sg.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?D("191",c):void 0;c()}}};function tg(a,b,c){this._internalRoot=X.createContainer(a,b,c)}tg.prototype.render=function(a,b){var c=this._internalRoot,d=new sg;b=void 0===b?null:b;null!==b&&d.then(b);X.updateContainer(a,c,null,d._onCommit);return d};
tg.prototype.unmount=function(a){var b=this._internalRoot,c=new sg;a=void 0===a?null:a;null!==a&&c.then(a);X.updateContainer(null,b,null,c._onCommit);return c};tg.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new sg;c=void 0===c?null:c;null!==c&&e.then(c);X.updateContainer(b,d,a,e._onCommit);return e};
tg.prototype.createBatch=function(){var a=new rg(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ug(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function vg(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
var X=pf({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:Pf(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=Pf(a,b)}return a},getChildHostContext:function(a,b){return Pf(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){pg=Vd;var a=fa();if(ne(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(B){b=null;break a}var f=0,h=-1,g=-1,k=0,v=0,l=a,p=null;b:for(;;){for(var z;;){l!==b||0!==d&&3!==l.nodeType||(h=f+d);l!==e||0!==c&&3!==l.nodeType||(g=f+c);3===l.nodeType&&(f+=l.nodeValue.length);if(null===(z=l.firstChild))break;p=l;l=z}for(;;){if(l===a)break b;p===b&&++k===d&&(h=f);p===e&&++v===c&&(g=f);if(null!==(z=l.nextSibling))break;l=p;p=l.parentNode}l=z}b=-1===h||-1===g?null:
{start:h,end:g}}else b=null}b=b||{start:0,end:0}}else b=null;qg={focusedElem:a,selectionRange:b};Wd(!1)},resetAfterCommit:function(){var a=qg,b=fa(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&ja(document.documentElement,c)){if(ne(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[mb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=me(c,a);var f=me(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var h=document.createRange();h.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(h),b.extend(f.node,f.offset)):(h.setEnd(f.node,f.offset),b.addRange(h))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,
a.element.scrollTop=a.top}qg=null;Wd(pg);pg=null},createInstance:function(a,b,c,d,e){a=ag(a,b,c,d);a[F]=e;a[Ta]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){cg(a,b,c,d);return vg(b,c)},prepareUpdate:function(a,b,c,d,e){return dg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===
typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=bg(a,b);a[F]=d;return a},now:sf,mutation:{commitMount:function(a,b,c){vg(b,c)&&a.focus()},commitUpdate:function(a,b,c,d,e){a[Ta]=e;eg(a,b,c,d,e)},resetTextContent:function(a){Sf(a,"")},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},
insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=
a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[F]=f;a[Ta]=c;return fg(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[F]=c;return ng(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},
didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:tf,cancelDeferredCallback:uf}),Cg=X;ac=Cg.batchedUpdates;bc=Cg.interactiveUpdates;cc=Cg.flushInteractiveUpdates;
function Dg(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new tg(a,!1,b)}
function Eg(a,b,c,d,e){ug(c)?void 0:D("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var h=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);h.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Dg(c,d);if("function"===typeof e){var g=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);g.call(a)}}X.unbatchedUpdates(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return X.getPublicRootInstance(f._internalRoot)}
function Fg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ug(b)?void 0:D("200");return qf(a,b,null,c)}
var Gg={createPortal:Fg,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:X.findHostInstance(a)},hydrate:function(a,b,c){return Eg(null,a,b,!0,c)},render:function(a,b,c){return Eg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?D("38"):void 0;return Eg(a,b,c,!1,d)},unmountComponentAtNode:function(a){ug(a)?void 0:D("40");return a._reactRootContainer?(X.unbatchedUpdates(function(){Eg(null,null,a,!1,function(){a._reactRootContainer=
null})}),!0):!1},unstable_createPortal:function(){return Fg.apply(void 0,arguments)},unstable_batchedUpdates:X.batchedUpdates,unstable_deferredUpdates:X.deferredUpdates,flushSync:X.flushSync,unstable_flushControlled:X.flushControlled,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ra,EventPluginRegistry:Ca,EventPropagators:kb,ReactControlledComponent:$b,ReactDOMComponentTree:bb,ReactDOMEventListener:$d},unstable_createRoot:function(a,b){return new tg(a,!0,null!=b&&!0===b.hydrate)}};
X.injectIntoDevTools({findFiberByHostInstance:Ua,bundleType:0,version:"16.3.2",rendererPackageName:"react-dom"});var Hg=Object.freeze({default:Gg}),Ig=Hg&&Gg||Hg;module.exports=Ig["default"]?Ig["default"]:Ig;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(212);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(213);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(215);
module.exports = __webpack_require__(68).Array.includes;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(118);
var $includes = __webpack_require__(121)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(230)('includes');


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(217);
var IE8_DOM_DEFINE = __webpack_require__(218);
var toPrimitive = __webpack_require__(220);
var dP = Object.defineProperty;

exports.f = __webpack_require__(87) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(86);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(87) && !__webpack_require__(119)(function () {
  return Object.defineProperty(__webpack_require__(219)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(86);
var document = __webpack_require__(53).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(86);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(53);
var hide = __webpack_require__(85);
var has = __webpack_require__(120);
var SRC = __webpack_require__(88)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(68).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(224);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(226);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 226 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 227 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(122);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(122);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(231)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(85)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(123)('wks');
var uid = __webpack_require__(88);
var Symbol = __webpack_require__(53).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(233);
module.exports = __webpack_require__(68).Object.values;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(118);
var $values = __webpack_require__(234)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(235);
var toIObject = __webpack_require__(89);
var isEnum = __webpack_require__(239).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(236);
var enumBugKeys = __webpack_require__(238);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(120);
var toIObject = __webpack_require__(89);
var arrayIndexOf = __webpack_require__(121)(false);
var IE_PROTO = __webpack_require__(237)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(123)('keys');
var uid = __webpack_require__(88);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 238 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 239 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_createStore__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_RootPage__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_reset_css__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_reset_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_reset_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_App_css__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_App_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Everything in this folder and below should export a component
var App=function(_React$Component){_inherits(App,_React$Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_4_state_createStore__["a" /* store */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["a" /* ConnectedRouter */],{history:__WEBPACK_IMPORTED_MODULE_3_state_history__["a" /* history */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_RootPage__["a" /* default */],null)));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(135);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ConnectedRouter = function (_Component) {
  _inherits(ConnectedRouter, _Component);

  function ConnectedRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, ConnectedRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocationChange = function (location) {
      _this.store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* LOCATION_CHANGE */],
        payload: location
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        propsStore = _props.store,
        history = _props.history,
        isSSR = _props.isSSR;

    this.store = propsStore || this.context.store;
    this.handleLocationChange(history.location);

    if (!isSSR) this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
  };

  ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
  };

  ConnectedRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Router */], this.props);
  };

  return ConnectedRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ConnectedRouter.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  isSSR: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ConnectedRouter.contextTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (ConnectedRouter);

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(84);
var invariant = __webpack_require__(83);
var ReactPropTypesSecret = __webpack_require__(243);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(54);

var _LocationUtils = __webpack_require__(90);

var _createTransitionManager = __webpack_require__(91);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(130);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(130);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(92);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(249)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getLocation */
/* unused harmony export createMatchSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(30);


var getLocation = function getLocation(state) {
  return state.router.location;
};

var createMatchSelector = function createMatchSelector(path) {
  var lastPathname = null;
  var lastMatch = null;
  return function (state) {
    var _ref = getLocation(state) || {},
        pathname = _ref.pathname;

    if (pathname === lastPathname) {
      return lastMatch;
    }
    lastPathname = pathname;
    var match = Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* matchPath */])(pathname, path);
    if (!match || !lastMatch || match.url !== lastMatch.url) {
      lastMatch = match;
    }
    return lastMatch;
  };
};

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = routerMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(136);


/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* CALL_HISTORY_METHOD */]) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, args);
      };
    };
  };
}

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(94);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(273);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(143);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(261);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(259);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(52)))

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(140);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(263);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(267);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(52), __webpack_require__(266)(module)))

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(141);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(142);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(143);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(144);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(274);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(94);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sagaMiddleware */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_devtools_extension__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_devtools_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_saga__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_saga_monitor__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_log__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_rootSaga__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_rootReducer__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_rootDehydrate__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_persist__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_state_school_money_actions__ = __webpack_require__(4);
/**
 * @module state/createStore
 * Set up the Redux store, and attach debuggers, top-level window
 * This should only be used by `src/index.js` (or possibly tests).
 */// create the store, and other state-related things
// export saga middleware, history and store
var sagaMiddleware=Object(__WEBPACK_IMPORTED_MODULE_3_redux_saga__["a" /* default */])({sagaMonitor:Object(__WEBPACK_IMPORTED_MODULE_4_lib_saga_monitor__["a" /* default */])()});var store=Object(__WEBPACK_IMPORTED_MODULE_1_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_8_state_rootReducer__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_0_redux_devtools_extension__["composeWithDevTools"])(Object(__WEBPACK_IMPORTED_MODULE_1_redux__["applyMiddleware"])(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["c" /* routerMiddleware */])(__WEBPACK_IMPORTED_MODULE_6_state_history__["a" /* history */]),// for dispatching history actions
sagaMiddleware)));// Attach persistence to store
// dispatches STATE_HYDRATE action if persisted state found
// subscribes to store to serialize upon each update
Object(__WEBPACK_IMPORTED_MODULE_10_state_persist__["b" /* attachPersistence */])(store,__WEBPACK_IMPORTED_MODULE_9_state_rootDehydrate__["a" /* default */]);// Expose app API
window.app={process_metadata:function process_metadata(metadata){return store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_state_app_actions__["T" /* processMetadata */])(metadata));},back:function back(){return store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_state_app_actions__["K" /* goBack */])(__WEBPACK_IMPORTED_MODULE_6_state_history__["a" /* history */].location));},process_google_pay_response:function process_google_pay_response(response){return processGooglePayResponseFromNativeApp(response);},// Expose debug tools namespace for remote debugging
// It is very important this is NEVER USED in application code - only debug/inspect
debug:{store:store,logger:__WEBPACK_IMPORTED_MODULE_5_lib_log__["a" /* default */],logSagas:__WEBPACK_IMPORTED_MODULE_4_lib_saga_monitor__["b" /* logSagas */]}// Callback function used by native android app to complete Google pay process
};function processGooglePayResponseFromNativeApp(response){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12_state_school_money_actions__["_93" /* saveAudit */])("Google pay response from native: "+JSON.stringify(response)));store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_11_state_app_actions__["S" /* processGooglePayResponse */])(response));return"true";}// Finally, run the root saga
sagaMiddleware.run(__WEBPACK_IMPORTED_MODULE_7_state_rootSaga__["a" /* default */]);

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(20).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sagaMiddlewareFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__channel__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__runSaga__ = __webpack_require__(147);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






function sagaMiddlewareFactory() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      options = _objectWithoutProperties(_ref, ['context']);

  var sagaMonitor = options.sagaMonitor,
      logger = options.logger,
      onError = options.onError;


  if (__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options)) {
    if (true) {
      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
    } else {
      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
    }
  }

  if (logger && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(logger)) {
    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
  }

  if (false) {
    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
  }

  if (onError && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(onError)) {
    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
  }

  if (options.emitter && !__WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].func(options.emitter)) {
    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
  }

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;

    var sagaEmitter = Object(__WEBPACK_IMPORTED_MODULE_1__channel__["b" /* emitter */])();
    sagaEmitter.emit = (options.emitter || __WEBPACK_IMPORTED_MODULE_0__utils__["l" /* ident */])(sagaEmitter.emit);

    sagaMiddleware.run = __WEBPACK_IMPORTED_MODULE_2__runSaga__["a" /* runSaga */].bind(null, {
      context: context,
      subscribe: sagaEmitter.subscribe,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor,
      logger: logger,
      onError: onError
    });

    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }
        var result = next(action); // hit reducers
        sagaEmitter.emit(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
  };

  sagaMiddleware.setContext = function (props) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils__["g" /* check */])(props, __WEBPACK_IMPORTED_MODULE_0__utils__["n" /* is */].object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["h" /* createSetContextWarning */])('sagaMiddleware', props));
    __WEBPACK_IMPORTED_MODULE_0__utils__["s" /* object */].assign(context, props);
  };

  return sagaMiddleware;
}

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeEvery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(43);




function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["j" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };

  var action = void 0,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q1', yFork(action)];
    }
  }, 'q1', 'takeEvery(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = takeLatest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(43);




function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["j" /* take */])(patternOrChannel) };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yCancel = function yCancel(task) {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["e" /* cancel */])(task) };
  };

  var task = void 0,
      action = void 0;
  var setTask = function setTask(t) {
    return task = t;
  };
  var setAction = function setAction(ac) {
    return action = ac;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yTake, setAction];
    },
    q2: function q2() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
    },
    q3: function q3() {
      return ['q1', yFork(action), setTask];
    }
  }, 'q1', 'takeLatest(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(patternOrChannel) + ', ' + worker.name + ')');
}

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throttle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fsmIterator__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__io__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__channel__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__buffers__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(25);






function throttle(delayLength, pattern, worker) {
  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action = void 0,
      channel = void 0;

  var yActionChannel = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["a" /* actionChannel */])(pattern, __WEBPACK_IMPORTED_MODULE_3__buffers__["a" /* buffers */].sliding(1)) };
  var yTake = function yTake() {
    return { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["j" /* take */])(channel) };
  };
  var yFork = function yFork(ac) {
    return { done: false, value: __WEBPACK_IMPORTED_MODULE_1__io__["f" /* fork */].apply(undefined, [worker].concat(args, [ac])) };
  };
  var yDelay = { done: false, value: Object(__WEBPACK_IMPORTED_MODULE_1__io__["d" /* call */])(__WEBPACK_IMPORTED_MODULE_4__utils__["j" /* delay */], delayLength) };

  var setAction = function setAction(ac) {
    return action = ac;
  };
  var setChannel = function setChannel(ch) {
    return channel = ch;
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["a" /* default */])({
    q1: function q1() {
      return ['q2', yActionChannel, setChannel];
    },
    q2: function q2() {
      return ['q3', yTake(), setAction];
    },
    q3: function q3() {
      return action === __WEBPACK_IMPORTED_MODULE_2__channel__["a" /* END */] ? [__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["b" /* qEnd */]] : ['q4', yFork(action)];
    },
    q4: function q4() {
      return ['q2', yDelay];
    }
  }, 'q1', 'throttle(' + Object(__WEBPACK_IMPORTED_MODULE_0__fsmIterator__["c" /* safeName */])(pattern) + ', ' + worker.name + ')');
}

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return logSagas; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_saga_utils__ = __webpack_require__(150);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/**
 * Forked from https://github.com/clarketm/saga-monitor
 * removed global namespace functions and related debug/verbose related properties
 *
 * @license MIT
 *
 * Copyright (c) 2017 Travis Clarke
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */var PENDING='PENDING';var RESOLVED='RESOLVED';var REJECTED='REJECTED';var CANCELLED='CANCELLED';var DEFAULT_STYLE='color: darkgrey';var LABEL_STYLE='font-weight: bold';var EFFECT_TYPE_STYLE='color: lightblue';var ERROR_STYLE='color: red';var CANCEL_STYLE='color: #ccc';var IS_BROWSER=typeof window!=='undefined'&&window.document;var defaultConfig={level:'debug',color:'#03A9F4',effectTrigger:false,effectResolve:false,effectReject:false,effectCancel:false,actionDispatch:false};function time(){if(typeof performance!=='undefined'&&performance.now){return performance.now();}else{return Date.now();}}var effectsById={};var rootEffects=[];function createSagaMonitor(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var config=Object.assign({},defaultConfig,options);var level=config.level,color=config.color,effectTrigger=config.effectTrigger,effectResolve=config.effectResolve,effectReject=config.effectReject,effectCancel=config.effectCancel,actionDispatch=config.actionDispatch;var styles=['color: '+color,'font-weight: bold'].join(';');function effectTriggered(desc){if(effectTrigger){console[level]('%c effectTriggered   ',styles,desc);}effectsById[desc.effectId]=Object.assign({},desc,{status:PENDING,start:time()});if(desc.root){rootEffects.push(desc.effectId);}}function effectResolved(effectId,result){if(effectResolve){console[level]('%c effectResolved    ',styles,effectId,result);}resolveEffect(effectId,result);}function effectRejected(effectId,error){if(effectReject){console[level]('%c effectRejected    ',styles,effectId,error);}rejectEffect(effectId,error);}function effectCancelled(effectId){if(effectCancel){console[level]('%c effectCancelled   ',styles,effectId);}cancelEffect(effectId);}function actionDispatched(action){if(actionDispatch){console[level]('%c actionDispatched  ',styles,action);}}return{effectTriggered:effectTriggered,effectResolved:effectResolved,effectRejected:effectRejected,effectCancelled:effectCancelled,actionDispatched:actionDispatched};}function computeEffectDur(effect){var now=time();Object.assign(effect,{end:now,duration:now-effect.start});}function resolveEffect(effectId,result){var effect=effectsById[effectId];if(__WEBPACK_IMPORTED_MODULE_0_redux_saga_utils__["b" /* is */].task(result)){result.done.then(function(taskResult){if(result.isCancelled()){cancelEffect(effectId);}else{resolveEffect(effectId,taskResult);}},function(taskError){return rejectEffect(effectId,taskError);});}else{computeEffectDur(effect);effect.status=RESOLVED;effect.result=result;if(effect&&__WEBPACK_IMPORTED_MODULE_0_redux_saga_utils__["a" /* asEffect */].race(effect.effect)){setRaceWinner(effectId,result);}}}function rejectEffect(effectId,error){var effect=effectsById[effectId];computeEffectDur(effect);effect.status=REJECTED;effect.error=error;if(effect&&__WEBPACK_IMPORTED_MODULE_0_redux_saga_utils__["a" /* asEffect */].race(effect.effect)){setRaceWinner(effectId,error);}}function cancelEffect(effectId){var effect=effectsById[effectId];computeEffectDur(effect);effect.status=CANCELLED;}function setRaceWinner(raceEffectId,result){var winnerLabel=Object.keys(result)[0];var children=getChildEffects(raceEffectId);for(var i=0;i<children.length;i++){var childEffect=effectsById[children[i]];if(childEffect.label===winnerLabel){childEffect.winner=true;}}}function getChildEffects(parentEffectId){return Object.keys(effectsById).filter(function(effectId){return effectsById[effectId].parentEffectId===parentEffectId;}).map(function(effectId){return+effectId;});}// Poor man's `console.group` and `console.groupEnd` for Node.
// Can be overridden by the `console-group` polyfill.
// The poor man's groups look nice, too, so whether to use
// the polyfilled methods or the hand-made ones can be made a preference.
var groupPrefix='';var GROUP_SHIFT='   ';var GROUP_ARROW='▼';function consoleGroup(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}if(console.group){var _console;(_console=console).group.apply(_console,args);}else{var _console2;console.log('');(_console2=console).log.apply(_console2,[groupPrefix+GROUP_ARROW].concat(args));groupPrefix+=GROUP_SHIFT;}}function consoleGroupEnd(){if(console.groupEnd){console.groupEnd();}else{groupPrefix=groupPrefix.substr(0,groupPrefix.length-GROUP_SHIFT.length);}}function logEffects(topEffects){topEffects.forEach(logEffectTree);}function logEffectTree(effectId){var effect=effectsById[effectId];var childEffects=getChildEffects(effectId);if(!childEffects.length){logSimpleEffect(effect);}else{var _getEffectLog=getEffectLog(effect),formatter=_getEffectLog.formatter;consoleGroup.apply(undefined,_toConsumableArray(formatter.getLog()));childEffects.forEach(logEffectTree);consoleGroupEnd();}}function logSimpleEffect(effect){var _console3;var _getEffectLog2=getEffectLog(effect),method=_getEffectLog2.method,formatter=_getEffectLog2.formatter;(_console3=console)[method].apply(_console3,_toConsumableArray(formatter.getLog()));}/* eslint-disable no-cond-assign */function getEffectLog(effect){var data=void 0,log=void 0;if(effect.root){data=effect.effect;log=getLogPrefix('run',effect);log.formatter.addCall(data.saga.name,data.args);logResult(effect,log.formatter);}else if(data=__WEBPACK_IMPORTED_MODULE_0_redux_saga_utils__["a" /* asEffect */].take(effect.effect)){log=getLogPrefix('take',effect);log.formatter.addValue(data);logResult(effect,log.formatter);}else if(data=__WEBPACK_IMPORTED_MODULE_0_redux_saga_utils__["a" /* asEffect */].put(effect.effect)){log=getLogPrefix('put',effect);logResult(Object.assign({},effect,{result:data}),log.formatter);}else if(data=__WEBPACK_IMPORTED_MODULE_0_redux_saga_utils__["a" /* asEffect */].call(effect.effect)){log=getLogPrefix('call',effect);log.formatter.addCall(data.fn.name,data.args);logResult(effect,log.formatter);}else if(data=__WEBPACK_IMPORTED_MODULE_0_redux_saga_utils__["a" /* asEffect */].cps(effect.effect)){log=getLogPrefix('cps',effect);log.formatter.addCall(data.fn.name,data.args);logResult(effect,log.formatter);}else if(data=__WEBPACK_IMPORTED_MODULE_0_redux_saga_utils__["a" /* asEffect */].fork(effect.effect)){if(!data.detached){log=getLogPrefix('fork',effect);}else{log=getLogPrefix('spawn',effect);}log.formatter.addCall(data.fn.name,data.args);logResult(effect,log.formatter);}else if(data=__WEBPACK_IMPORTED_MODULE_0_redux_saga_utils__["a" /* asEffect */].join(effect.effect)){log=getLogPrefix('join',effect);logResult(effect,log.formatter);}else if(data=__WEBPACK_IMPORTED_MODULE_0_redux_saga_utils__["a" /* asEffect */].race(effect.effect)){log=getLogPrefix('race',effect);logResult(effect,log.formatter,true);}else if(data=__WEBPACK_IMPORTED_MODULE_0_redux_saga_utils__["a" /* asEffect */].cancel(effect.effect)){log=getLogPrefix('cancel',effect);log.formatter.appendData(data.name);}else if(data=__WEBPACK_IMPORTED_MODULE_0_redux_saga_utils__["a" /* asEffect */].select(effect.effect)){log=getLogPrefix('select',effect);log.formatter.addCall(data.selector.name,data.args);logResult(effect,log.formatter);}else if(__WEBPACK_IMPORTED_MODULE_0_redux_saga_utils__["b" /* is */].array(effect.effect)){log=getLogPrefix('parallel',effect);logResult(effect,log.formatter,true);}else if(__WEBPACK_IMPORTED_MODULE_0_redux_saga_utils__["b" /* is */].iterator(effect.effect)){log=getLogPrefix('',effect);log.formatter.addValue(effect.effect.name);logResult(effect,log.formatter,true);}else{log=getLogPrefix('unkown',effect);logResult(effect,log.formatter);}return log;}function getLogPrefix(type,effect){var isCancel=effect.status===CANCELLED;var isError=effect.status===REJECTED;var method=isError?'error':'log';var winnerInd=effect&&effect.winner?isError?'✘':'✓':'';var style=function style(s){return isCancel?CANCEL_STYLE:isError?ERROR_STYLE:s;};var formatter=logFormatter();if(winnerInd){formatter.add('%c '+winnerInd,style(LABEL_STYLE));}if(effect&&effect.label){formatter.add('%c '+effect.label+': ',style(LABEL_STYLE));}if(type){formatter.add('%c '+type+' ',style(EFFECT_TYPE_STYLE));}formatter.add('%c',style(DEFAULT_STYLE));return{method:method,formatter:formatter};}function argToString(arg){return typeof arg==='function'?''+arg.name:typeof arg==='string'?'\''+arg+'\'':arg;}function logResult(_ref,formatter,ignoreResult){var status=_ref.status,result=_ref.result,error=_ref.error,duration=_ref.duration;if(status===RESOLVED&&!ignoreResult){if(__WEBPACK_IMPORTED_MODULE_0_redux_saga_utils__["b" /* is */].array(result)){formatter.addValue(' → ');formatter.addValue(result);}else{formatter.appendData('→',result);}}else if(status===REJECTED){formatter.appendData('→ ⚠',error);}else if(status===PENDING){formatter.appendData('⌛');}else if(status===CANCELLED){formatter.appendData('→ Cancelled!');}if(status!==PENDING){formatter.appendData('('+duration.toFixed(2)+'ms)');}}function isPrimitive(val){return typeof val==='string'||typeof val==='number'||typeof val==='boolean'||(typeof val==='undefined'?'undefined':_typeof(val))==='symbol'||val===null||val===undefined;}function logFormatter(){var logs=[];var suffix=[];function add(msg){for(var _len2=arguments.length,args=Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){args[_key2-1]=arguments[_key2];}// Remove the `%c` CSS styling that is not supported by the Node console.
if(!IS_BROWSER&&typeof msg==='string'){var prevMsg=msg;msg=msg.replace(/^%c\s*/,'');if(msg!==prevMsg){// Remove the first argument which is the CSS style string.
args.shift();}}logs.push({msg:msg,args:args});}function appendData(){for(var _len3=arguments.length,data=Array(_len3),_key3=0;_key3<_len3;_key3++){data[_key3]=arguments[_key3];}suffix=suffix.concat(data);}function addValue(value){if(isPrimitive(value)){add(value);}else{// The browser console supports `%O`, the Node console does not.
if(IS_BROWSER){add('%O',value);}else{add('%s',__webpack_require__(282).inspect(value));}}}function addCall(name,args){if(!args.length){add(name+'()');}else{add(name);add('(');args.forEach(function(arg,i){addValue(argToString(arg));addValue(i===args.length-1?')':', ');});}}function getLog(){var msgs=[];var msgsArgs=[];for(var i=0;i<logs.length;i++){msgs.push(logs[i].msg);msgsArgs=msgsArgs.concat(logs[i].args);}return[msgs.join('')].concat(msgsArgs).concat(suffix);}return{add:add,addValue:addValue,addCall:addCall,appendData:appendData,getLog:getLog};}var logSagas=function logSagas(){for(var _len4=arguments.length,topEffects=Array(_len4),_key4=0;_key4<_len4;_key4++){topEffects[_key4]=arguments[_key4];}if(!topEffects.length){topEffects=rootEffects;}if(!rootEffects.length){console.log(groupPrefix,'No effects to log');}console.log('');console.log('Saga monitor:',Date.now(),new Date().toISOString());logEffects(topEffects);console.log('');};// Export the snapshot-logging function for arbitrary use by external code.
// Export the `sagaMonitor` to pass to the middleware.
/* harmony default export */ __webpack_exports__["a"] = (createSagaMonitor);

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_KEY":"teachers_1","REACT_APP_CUSTOMER_NOTICES_END_TIME":"2025-12-18 12:19:59","REACT_APP_EDUSPOT_DOWN_TIME_START":"2025-12-18 10:30","REACT_APP_SCHOOLMONEY_DOWN_TIME_END":"2023-11-13 18:40","REACT_APP_SECURE_TRADING_XPRESSIONS_APPLE_PAY_MERCHANT_ID":"merchant.com.groupcall.emerge.parental.req","REACT_APP_SECURE_TRADING_GOOGLE_PAY_MERCHANT_ID":"BCR2DN4T7DZYVHSW","REACT_APP_TEACHERS2PARENTS_APP_REFERRER":"teachers","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_CUSTOMER_NOTICES_KEY":"app_2","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_START":"2021-12-08 10:10","REACT_APP_SECURE_TRADING_INITIATOR":"public","REACT_APP_XPRESSIONS_APP_REFERRER":"xpressions","REACT_APP_EDUSPOT_DOWN_TIME_END":"2025-12-18 11:00","REACT_APP_PAYSAFE_ENVIRONMENT":"LIVE","REACT_APP_SECURE_TRADING_3DS_LIVESTATUS":"0","REACT_APP_SECURE_TRADING_PAYMENT_MODE":"TEST","REACT_APP_SECURE_TRADING_3DS_TERMURL":"/public/appserver/product_resources/school_money/secure_trading/sm_app_threeds_response.html","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_KEY":"schoolmoney_1","REACT_APP_EDUSPOT_LOCAL_HOSTNAME":"uat-appserver.teachers2parents.co.uk","REACT_APP_PAYSAFE_API_KEY":"T1QtOTMyMTpCLXAxLTAtNWIwNDFiN2QtMC0zMDJjMDIxNDRkZGY4N2YwNDM4ZWRlY2YzYWMzYzYzNTlhYjQ2YmE5NDlkYmU4Y2EwMjE0MGJiOTJiNGQxNjU4ZTdmZWFmOGQ2ZGFiYjcxNmIyMTY1MmZhMDVmMQ==","REACT_APP_PARENTAPPS_APP_REFERRER":"parentapps","REACT_APP_SCHOOLMONEY_APP_NAME":"schoolmoney","REACT_APP_SECURE_TRADING_SECRET_TOKEN":"app","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_END":"2021-12-08 11:00","REACT_APP_SCHOOLMONEY_DOWN_TIME_START":"2023-11-13 17:50","REACT_APP_TEACHERS2PARENTS_LOCAL_HOSTNAME":"edspapitesting.teachers2parents.co.uk","REACT_APP_SECURE_TRADING_SITE_REFERENCE":"test_smartthreedtwo83732","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_EDUSPOT_APP_NAME":"eduspot","REACT_APP_PACKAGE_VERSION":"2.82.0","REACT_APP_SECURE_TRADING_SCHOOL_MONEY_APPLE_PAY_MERCHANT_ID":"merchant.schoolmoney.dev"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(283);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(284);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52), __webpack_require__(97)))

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 284 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/
(function (root, definition) {
    "use strict";
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = definition();
    } else {
        root.log = definition();
    }
}(this, function () {
    "use strict";

    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";

    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];

    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') {
            return method.bind(obj);
        } else {
            try {
                return Function.prototype.bind.call(method, obj);
            } catch (e) {
                // Missing bind shim or IE8 + Modernizr, fallback to wrapping
                return function() {
                    return Function.prototype.apply.apply(method, [obj, arguments]);
                };
            }
        }
    }

    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') {
            methodName = 'log';
        }

        if (typeof console === undefinedType) {
            return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        } else if (console[methodName] !== undefined) {
            return bindMethod(console, methodName);
        } else if (console.log !== undefined) {
            return bindMethod(console, 'log');
        } else {
            return noop;
        }
    }

    // These private functions always need `this` to be set properly

    function replaceLoggingMethods(level, loggerName) {
        /*jshint validthis:true */
        for (var i = 0; i < logMethods.length; i++) {
            var methodName = logMethods[i];
            this[methodName] = (i < level) ?
                noop :
                this.methodFactory(methodName, level, loggerName);
        }

        // Define log.log as an alias for log.debug
        this.log = this.debug;
    }

    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
        return function () {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this, level, loggerName);
                this[methodName].apply(this, arguments);
            }
        };
    }

    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, level, loggerName) {
        /*jshint validthis:true */
        return realMethod(methodName) ||
               enableLoggingWhenConsoleArrives.apply(this, arguments);
    }

    function Logger(name, defaultLevel, factory) {
      var self = this;
      var currentLevel;
      var storageKey = "loglevel";
      if (name) {
        storageKey += ":" + name;
      }

      function persistLevelIfPossible(levelNum) {
          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();

          if (typeof window === undefinedType) return;

          // Use localStorage if available
          try {
              window.localStorage[storageKey] = levelName;
              return;
          } catch (ignore) {}

          // Use session cookie as fallback
          try {
              window.document.cookie =
                encodeURIComponent(storageKey) + "=" + levelName + ";";
          } catch (ignore) {}
      }

      function getPersistedLevel() {
          var storedLevel;

          if (typeof window === undefinedType) return;

          try {
              storedLevel = window.localStorage[storageKey];
          } catch (ignore) {}

          // Fallback to cookies if local storage gives us nothing
          if (typeof storedLevel === undefinedType) {
              try {
                  var cookie = window.document.cookie;
                  var location = cookie.indexOf(
                      encodeURIComponent(storageKey) + "=");
                  if (location !== -1) {
                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
                  }
              } catch (ignore) {}
          }

          // If the stored level is not valid, treat it as if nothing was stored.
          if (self.levels[storedLevel] === undefined) {
              storedLevel = undefined;
          }

          return storedLevel;
      }

      /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */

      self.name = name;

      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
          "ERROR": 4, "SILENT": 5};

      self.methodFactory = factory || defaultMethodFactory;

      self.getLevel = function () {
          return currentLevel;
      };

      self.setLevel = function (level, persist) {
          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
              level = self.levels[level.toUpperCase()];
          }
          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
              currentLevel = level;
              if (persist !== false) {  // defaults to true
                  persistLevelIfPossible(level);
              }
              replaceLoggingMethods.call(self, level, name);
              if (typeof console === undefinedType && level < self.levels.SILENT) {
                  return "No console available for logging";
              }
          } else {
              throw "log.setLevel() called with invalid level: " + level;
          }
      };

      self.setDefaultLevel = function (level) {
          if (!getPersistedLevel()) {
              self.setLevel(level, false);
          }
      };

      self.enableAll = function(persist) {
          self.setLevel(self.levels.TRACE, persist);
      };

      self.disableAll = function(persist) {
          self.setLevel(self.levels.SILENT, persist);
      };

      // Initialize with the right level
      var initialLevel = getPersistedLevel();
      if (initialLevel == null) {
          initialLevel = defaultLevel == null ? "WARN" : defaultLevel;
      }
      self.setLevel(initialLevel, false);
    }

    /*
     *
     * Top-level API
     *
     */

    var defaultLogger = new Logger();

    var _loggersByName = {};
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "string" || name === "") {
          throw new TypeError("You must supply a name when creating a logger.");
        }

        var logger = _loggersByName[name];
        if (!logger) {
          logger = _loggersByName[name] = new Logger(
            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
        }
        return logger;
    };

    // Grab the current global log variable in case of overwrite
    var _log = (typeof window !== undefinedType) ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType &&
               window.log === defaultLogger) {
            window.log = _log;
        }

        return defaultLogger;
    };

    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };

    return defaultLogger;
}));


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rootSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_log__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_appserver_request__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_failsafeSaga__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_app_sagas___ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_query_string__);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(rootSaga);/**
 * @module state/rootSaga
 * Root saga for the Redux store's saga middleware.
 *//**
 * Handle the initial userIdentity setup, attach
 *   error handling, and then hand off to `appSaga`.
 */function rootSaga(){var urlArgs,userIdentity,urlUserIdentity,overrideUserIdentity;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function rootSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* spawn */])(__WEBPACK_IMPORTED_MODULE_5_state_failsafeSaga__["a" /* default */]);case 3:urlArgs=__WEBPACK_IMPORTED_MODULE_7_query_string___default.a.parse(window.location.search);userIdentity=void 0;urlUserIdentity={mobileNumber:urlArgs.mobile_number,deviceToken:urlArgs.device_token,appReferrer:urlArgs.app_referrer,metadata:urlArgs.metadata,platform:urlArgs.platform,appVersion:urlArgs.app_version,os:urlArgs.os,osVersion:urlArgs.os_version,device:urlArgs.device};overrideUserIdentity={mobileNumber:Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_KEY":"teachers_1","REACT_APP_CUSTOMER_NOTICES_END_TIME":"2025-12-18 12:19:59","REACT_APP_EDUSPOT_DOWN_TIME_START":"2025-12-18 10:30","REACT_APP_SCHOOLMONEY_DOWN_TIME_END":"2023-11-13 18:40","REACT_APP_SECURE_TRADING_XPRESSIONS_APPLE_PAY_MERCHANT_ID":"merchant.com.groupcall.emerge.parental.req","REACT_APP_SECURE_TRADING_GOOGLE_PAY_MERCHANT_ID":"BCR2DN4T7DZYVHSW","REACT_APP_TEACHERS2PARENTS_APP_REFERRER":"teachers","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_CUSTOMER_NOTICES_KEY":"app_2","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_START":"2021-12-08 10:10","REACT_APP_SECURE_TRADING_INITIATOR":"public","REACT_APP_XPRESSIONS_APP_REFERRER":"xpressions","REACT_APP_EDUSPOT_DOWN_TIME_END":"2025-12-18 11:00","REACT_APP_PAYSAFE_ENVIRONMENT":"LIVE","REACT_APP_SECURE_TRADING_3DS_LIVESTATUS":"0","REACT_APP_SECURE_TRADING_PAYMENT_MODE":"TEST","REACT_APP_SECURE_TRADING_3DS_TERMURL":"/public/appserver/product_resources/school_money/secure_trading/sm_app_threeds_response.html","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_KEY":"schoolmoney_1","REACT_APP_EDUSPOT_LOCAL_HOSTNAME":"uat-appserver.teachers2parents.co.uk","REACT_APP_PAYSAFE_API_KEY":"T1QtOTMyMTpCLXAxLTAtNWIwNDFiN2QtMC0zMDJjMDIxNDRkZGY4N2YwNDM4ZWRlY2YzYWMzYzYzNTlhYjQ2YmE5NDlkYmU4Y2EwMjE0MGJiOTJiNGQxNjU4ZTdmZWFmOGQ2ZGFiYjcxNmIyMTY1MmZhMDVmMQ==","REACT_APP_PARENTAPPS_APP_REFERRER":"parentapps","REACT_APP_SCHOOLMONEY_APP_NAME":"schoolmoney","REACT_APP_SECURE_TRADING_SECRET_TOKEN":"app","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_END":"2021-12-08 11:00","REACT_APP_SCHOOLMONEY_DOWN_TIME_START":"2023-11-13 17:50","REACT_APP_TEACHERS2PARENTS_LOCAL_HOSTNAME":"edspapitesting.teachers2parents.co.uk","REACT_APP_SECURE_TRADING_SITE_REFERENCE":"test_smartthreedtwo83732","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_EDUSPOT_APP_NAME":"eduspot","REACT_APP_PACKAGE_VERSION":"2.82.0","REACT_APP_SECURE_TRADING_SCHOOL_MONEY_APPLE_PAY_MERCHANT_ID":"merchant.schoolmoney.dev"}).REACT_APP_MOBILE_NUMBER,deviceToken:Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_KEY":"teachers_1","REACT_APP_CUSTOMER_NOTICES_END_TIME":"2025-12-18 12:19:59","REACT_APP_EDUSPOT_DOWN_TIME_START":"2025-12-18 10:30","REACT_APP_SCHOOLMONEY_DOWN_TIME_END":"2023-11-13 18:40","REACT_APP_SECURE_TRADING_XPRESSIONS_APPLE_PAY_MERCHANT_ID":"merchant.com.groupcall.emerge.parental.req","REACT_APP_SECURE_TRADING_GOOGLE_PAY_MERCHANT_ID":"BCR2DN4T7DZYVHSW","REACT_APP_TEACHERS2PARENTS_APP_REFERRER":"teachers","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_CUSTOMER_NOTICES_KEY":"app_2","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_START":"2021-12-08 10:10","REACT_APP_SECURE_TRADING_INITIATOR":"public","REACT_APP_XPRESSIONS_APP_REFERRER":"xpressions","REACT_APP_EDUSPOT_DOWN_TIME_END":"2025-12-18 11:00","REACT_APP_PAYSAFE_ENVIRONMENT":"LIVE","REACT_APP_SECURE_TRADING_3DS_LIVESTATUS":"0","REACT_APP_SECURE_TRADING_PAYMENT_MODE":"TEST","REACT_APP_SECURE_TRADING_3DS_TERMURL":"/public/appserver/product_resources/school_money/secure_trading/sm_app_threeds_response.html","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_KEY":"schoolmoney_1","REACT_APP_EDUSPOT_LOCAL_HOSTNAME":"uat-appserver.teachers2parents.co.uk","REACT_APP_PAYSAFE_API_KEY":"T1QtOTMyMTpCLXAxLTAtNWIwNDFiN2QtMC0zMDJjMDIxNDRkZGY4N2YwNDM4ZWRlY2YzYWMzYzYzNTlhYjQ2YmE5NDlkYmU4Y2EwMjE0MGJiOTJiNGQxNjU4ZTdmZWFmOGQ2ZGFiYjcxNmIyMTY1MmZhMDVmMQ==","REACT_APP_PARENTAPPS_APP_REFERRER":"parentapps","REACT_APP_SCHOOLMONEY_APP_NAME":"schoolmoney","REACT_APP_SECURE_TRADING_SECRET_TOKEN":"app","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_END":"2021-12-08 11:00","REACT_APP_SCHOOLMONEY_DOWN_TIME_START":"2023-11-13 17:50","REACT_APP_TEACHERS2PARENTS_LOCAL_HOSTNAME":"edspapitesting.teachers2parents.co.uk","REACT_APP_SECURE_TRADING_SITE_REFERENCE":"test_smartthreedtwo83732","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_EDUSPOT_APP_NAME":"eduspot","REACT_APP_PACKAGE_VERSION":"2.82.0","REACT_APP_SECURE_TRADING_SCHOOL_MONEY_APPLE_PAY_MERCHANT_ID":"merchant.schoolmoney.dev"}).REACT_APP_DEVICE_TOKEN,appReferrer:Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_KEY":"teachers_1","REACT_APP_CUSTOMER_NOTICES_END_TIME":"2025-12-18 12:19:59","REACT_APP_EDUSPOT_DOWN_TIME_START":"2025-12-18 10:30","REACT_APP_SCHOOLMONEY_DOWN_TIME_END":"2023-11-13 18:40","REACT_APP_SECURE_TRADING_XPRESSIONS_APPLE_PAY_MERCHANT_ID":"merchant.com.groupcall.emerge.parental.req","REACT_APP_SECURE_TRADING_GOOGLE_PAY_MERCHANT_ID":"BCR2DN4T7DZYVHSW","REACT_APP_TEACHERS2PARENTS_APP_REFERRER":"teachers","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_CUSTOMER_NOTICES_KEY":"app_2","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_START":"2021-12-08 10:10","REACT_APP_SECURE_TRADING_INITIATOR":"public","REACT_APP_XPRESSIONS_APP_REFERRER":"xpressions","REACT_APP_EDUSPOT_DOWN_TIME_END":"2025-12-18 11:00","REACT_APP_PAYSAFE_ENVIRONMENT":"LIVE","REACT_APP_SECURE_TRADING_3DS_LIVESTATUS":"0","REACT_APP_SECURE_TRADING_PAYMENT_MODE":"TEST","REACT_APP_SECURE_TRADING_3DS_TERMURL":"/public/appserver/product_resources/school_money/secure_trading/sm_app_threeds_response.html","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_KEY":"schoolmoney_1","REACT_APP_EDUSPOT_LOCAL_HOSTNAME":"uat-appserver.teachers2parents.co.uk","REACT_APP_PAYSAFE_API_KEY":"T1QtOTMyMTpCLXAxLTAtNWIwNDFiN2QtMC0zMDJjMDIxNDRkZGY4N2YwNDM4ZWRlY2YzYWMzYzYzNTlhYjQ2YmE5NDlkYmU4Y2EwMjE0MGJiOTJiNGQxNjU4ZTdmZWFmOGQ2ZGFiYjcxNmIyMTY1MmZhMDVmMQ==","REACT_APP_PARENTAPPS_APP_REFERRER":"parentapps","REACT_APP_SCHOOLMONEY_APP_NAME":"schoolmoney","REACT_APP_SECURE_TRADING_SECRET_TOKEN":"app","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_END":"2021-12-08 11:00","REACT_APP_SCHOOLMONEY_DOWN_TIME_START":"2023-11-13 17:50","REACT_APP_TEACHERS2PARENTS_LOCAL_HOSTNAME":"edspapitesting.teachers2parents.co.uk","REACT_APP_SECURE_TRADING_SITE_REFERENCE":"test_smartthreedtwo83732","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_EDUSPOT_APP_NAME":"eduspot","REACT_APP_PACKAGE_VERSION":"2.82.0","REACT_APP_SECURE_TRADING_SCHOOL_MONEY_APPLE_PAY_MERCHANT_ID":"merchant.schoolmoney.dev"}).REACT_APP_APP_REFERRER,metadata:Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_KEY":"teachers_1","REACT_APP_CUSTOMER_NOTICES_END_TIME":"2025-12-18 12:19:59","REACT_APP_EDUSPOT_DOWN_TIME_START":"2025-12-18 10:30","REACT_APP_SCHOOLMONEY_DOWN_TIME_END":"2023-11-13 18:40","REACT_APP_SECURE_TRADING_XPRESSIONS_APPLE_PAY_MERCHANT_ID":"merchant.com.groupcall.emerge.parental.req","REACT_APP_SECURE_TRADING_GOOGLE_PAY_MERCHANT_ID":"BCR2DN4T7DZYVHSW","REACT_APP_TEACHERS2PARENTS_APP_REFERRER":"teachers","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_CUSTOMER_NOTICES_KEY":"app_2","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_START":"2021-12-08 10:10","REACT_APP_SECURE_TRADING_INITIATOR":"public","REACT_APP_XPRESSIONS_APP_REFERRER":"xpressions","REACT_APP_EDUSPOT_DOWN_TIME_END":"2025-12-18 11:00","REACT_APP_PAYSAFE_ENVIRONMENT":"LIVE","REACT_APP_SECURE_TRADING_3DS_LIVESTATUS":"0","REACT_APP_SECURE_TRADING_PAYMENT_MODE":"TEST","REACT_APP_SECURE_TRADING_3DS_TERMURL":"/public/appserver/product_resources/school_money/secure_trading/sm_app_threeds_response.html","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_KEY":"schoolmoney_1","REACT_APP_EDUSPOT_LOCAL_HOSTNAME":"uat-appserver.teachers2parents.co.uk","REACT_APP_PAYSAFE_API_KEY":"T1QtOTMyMTpCLXAxLTAtNWIwNDFiN2QtMC0zMDJjMDIxNDRkZGY4N2YwNDM4ZWRlY2YzYWMzYzYzNTlhYjQ2YmE5NDlkYmU4Y2EwMjE0MGJiOTJiNGQxNjU4ZTdmZWFmOGQ2ZGFiYjcxNmIyMTY1MmZhMDVmMQ==","REACT_APP_PARENTAPPS_APP_REFERRER":"parentapps","REACT_APP_SCHOOLMONEY_APP_NAME":"schoolmoney","REACT_APP_SECURE_TRADING_SECRET_TOKEN":"app","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_END":"2021-12-08 11:00","REACT_APP_SCHOOLMONEY_DOWN_TIME_START":"2023-11-13 17:50","REACT_APP_TEACHERS2PARENTS_LOCAL_HOSTNAME":"edspapitesting.teachers2parents.co.uk","REACT_APP_SECURE_TRADING_SITE_REFERENCE":"test_smartthreedtwo83732","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_EDUSPOT_APP_NAME":"eduspot","REACT_APP_PACKAGE_VERSION":"2.82.0","REACT_APP_SECURE_TRADING_SCHOOL_MONEY_APPLE_PAY_MERCHANT_ID":"merchant.schoolmoney.dev"}).REACT_APP_METADATA,platform:Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_KEY":"teachers_1","REACT_APP_CUSTOMER_NOTICES_END_TIME":"2025-12-18 12:19:59","REACT_APP_EDUSPOT_DOWN_TIME_START":"2025-12-18 10:30","REACT_APP_SCHOOLMONEY_DOWN_TIME_END":"2023-11-13 18:40","REACT_APP_SECURE_TRADING_XPRESSIONS_APPLE_PAY_MERCHANT_ID":"merchant.com.groupcall.emerge.parental.req","REACT_APP_SECURE_TRADING_GOOGLE_PAY_MERCHANT_ID":"BCR2DN4T7DZYVHSW","REACT_APP_TEACHERS2PARENTS_APP_REFERRER":"teachers","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_CUSTOMER_NOTICES_KEY":"app_2","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_START":"2021-12-08 10:10","REACT_APP_SECURE_TRADING_INITIATOR":"public","REACT_APP_XPRESSIONS_APP_REFERRER":"xpressions","REACT_APP_EDUSPOT_DOWN_TIME_END":"2025-12-18 11:00","REACT_APP_PAYSAFE_ENVIRONMENT":"LIVE","REACT_APP_SECURE_TRADING_3DS_LIVESTATUS":"0","REACT_APP_SECURE_TRADING_PAYMENT_MODE":"TEST","REACT_APP_SECURE_TRADING_3DS_TERMURL":"/public/appserver/product_resources/school_money/secure_trading/sm_app_threeds_response.html","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_KEY":"schoolmoney_1","REACT_APP_EDUSPOT_LOCAL_HOSTNAME":"uat-appserver.teachers2parents.co.uk","REACT_APP_PAYSAFE_API_KEY":"T1QtOTMyMTpCLXAxLTAtNWIwNDFiN2QtMC0zMDJjMDIxNDRkZGY4N2YwNDM4ZWRlY2YzYWMzYzYzNTlhYjQ2YmE5NDlkYmU4Y2EwMjE0MGJiOTJiNGQxNjU4ZTdmZWFmOGQ2ZGFiYjcxNmIyMTY1MmZhMDVmMQ==","REACT_APP_PARENTAPPS_APP_REFERRER":"parentapps","REACT_APP_SCHOOLMONEY_APP_NAME":"schoolmoney","REACT_APP_SECURE_TRADING_SECRET_TOKEN":"app","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_END":"2021-12-08 11:00","REACT_APP_SCHOOLMONEY_DOWN_TIME_START":"2023-11-13 17:50","REACT_APP_TEACHERS2PARENTS_LOCAL_HOSTNAME":"edspapitesting.teachers2parents.co.uk","REACT_APP_SECURE_TRADING_SITE_REFERENCE":"test_smartthreedtwo83732","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_EDUSPOT_APP_NAME":"eduspot","REACT_APP_PACKAGE_VERSION":"2.82.0","REACT_APP_SECURE_TRADING_SCHOOL_MONEY_APPLE_PAY_MERCHANT_ID":"merchant.schoolmoney.dev"}).REACT_APP_PLATFORM,appVersion:Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_KEY":"teachers_1","REACT_APP_CUSTOMER_NOTICES_END_TIME":"2025-12-18 12:19:59","REACT_APP_EDUSPOT_DOWN_TIME_START":"2025-12-18 10:30","REACT_APP_SCHOOLMONEY_DOWN_TIME_END":"2023-11-13 18:40","REACT_APP_SECURE_TRADING_XPRESSIONS_APPLE_PAY_MERCHANT_ID":"merchant.com.groupcall.emerge.parental.req","REACT_APP_SECURE_TRADING_GOOGLE_PAY_MERCHANT_ID":"BCR2DN4T7DZYVHSW","REACT_APP_TEACHERS2PARENTS_APP_REFERRER":"teachers","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_CUSTOMER_NOTICES_KEY":"app_2","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_START":"2021-12-08 10:10","REACT_APP_SECURE_TRADING_INITIATOR":"public","REACT_APP_XPRESSIONS_APP_REFERRER":"xpressions","REACT_APP_EDUSPOT_DOWN_TIME_END":"2025-12-18 11:00","REACT_APP_PAYSAFE_ENVIRONMENT":"LIVE","REACT_APP_SECURE_TRADING_3DS_LIVESTATUS":"0","REACT_APP_SECURE_TRADING_PAYMENT_MODE":"TEST","REACT_APP_SECURE_TRADING_3DS_TERMURL":"/public/appserver/product_resources/school_money/secure_trading/sm_app_threeds_response.html","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_KEY":"schoolmoney_1","REACT_APP_EDUSPOT_LOCAL_HOSTNAME":"uat-appserver.teachers2parents.co.uk","REACT_APP_PAYSAFE_API_KEY":"T1QtOTMyMTpCLXAxLTAtNWIwNDFiN2QtMC0zMDJjMDIxNDRkZGY4N2YwNDM4ZWRlY2YzYWMzYzYzNTlhYjQ2YmE5NDlkYmU4Y2EwMjE0MGJiOTJiNGQxNjU4ZTdmZWFmOGQ2ZGFiYjcxNmIyMTY1MmZhMDVmMQ==","REACT_APP_PARENTAPPS_APP_REFERRER":"parentapps","REACT_APP_SCHOOLMONEY_APP_NAME":"schoolmoney","REACT_APP_SECURE_TRADING_SECRET_TOKEN":"app","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_END":"2021-12-08 11:00","REACT_APP_SCHOOLMONEY_DOWN_TIME_START":"2023-11-13 17:50","REACT_APP_TEACHERS2PARENTS_LOCAL_HOSTNAME":"edspapitesting.teachers2parents.co.uk","REACT_APP_SECURE_TRADING_SITE_REFERENCE":"test_smartthreedtwo83732","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_EDUSPOT_APP_NAME":"eduspot","REACT_APP_PACKAGE_VERSION":"2.82.0","REACT_APP_SECURE_TRADING_SCHOOL_MONEY_APPLE_PAY_MERCHANT_ID":"merchant.schoolmoney.dev"}).REACT_APP_APP_VERSION,os:Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_KEY":"teachers_1","REACT_APP_CUSTOMER_NOTICES_END_TIME":"2025-12-18 12:19:59","REACT_APP_EDUSPOT_DOWN_TIME_START":"2025-12-18 10:30","REACT_APP_SCHOOLMONEY_DOWN_TIME_END":"2023-11-13 18:40","REACT_APP_SECURE_TRADING_XPRESSIONS_APPLE_PAY_MERCHANT_ID":"merchant.com.groupcall.emerge.parental.req","REACT_APP_SECURE_TRADING_GOOGLE_PAY_MERCHANT_ID":"BCR2DN4T7DZYVHSW","REACT_APP_TEACHERS2PARENTS_APP_REFERRER":"teachers","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_CUSTOMER_NOTICES_KEY":"app_2","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_START":"2021-12-08 10:10","REACT_APP_SECURE_TRADING_INITIATOR":"public","REACT_APP_XPRESSIONS_APP_REFERRER":"xpressions","REACT_APP_EDUSPOT_DOWN_TIME_END":"2025-12-18 11:00","REACT_APP_PAYSAFE_ENVIRONMENT":"LIVE","REACT_APP_SECURE_TRADING_3DS_LIVESTATUS":"0","REACT_APP_SECURE_TRADING_PAYMENT_MODE":"TEST","REACT_APP_SECURE_TRADING_3DS_TERMURL":"/public/appserver/product_resources/school_money/secure_trading/sm_app_threeds_response.html","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_KEY":"schoolmoney_1","REACT_APP_EDUSPOT_LOCAL_HOSTNAME":"uat-appserver.teachers2parents.co.uk","REACT_APP_PAYSAFE_API_KEY":"T1QtOTMyMTpCLXAxLTAtNWIwNDFiN2QtMC0zMDJjMDIxNDRkZGY4N2YwNDM4ZWRlY2YzYWMzYzYzNTlhYjQ2YmE5NDlkYmU4Y2EwMjE0MGJiOTJiNGQxNjU4ZTdmZWFmOGQ2ZGFiYjcxNmIyMTY1MmZhMDVmMQ==","REACT_APP_PARENTAPPS_APP_REFERRER":"parentapps","REACT_APP_SCHOOLMONEY_APP_NAME":"schoolmoney","REACT_APP_SECURE_TRADING_SECRET_TOKEN":"app","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_END":"2021-12-08 11:00","REACT_APP_SCHOOLMONEY_DOWN_TIME_START":"2023-11-13 17:50","REACT_APP_TEACHERS2PARENTS_LOCAL_HOSTNAME":"edspapitesting.teachers2parents.co.uk","REACT_APP_SECURE_TRADING_SITE_REFERENCE":"test_smartthreedtwo83732","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_EDUSPOT_APP_NAME":"eduspot","REACT_APP_PACKAGE_VERSION":"2.82.0","REACT_APP_SECURE_TRADING_SCHOOL_MONEY_APPLE_PAY_MERCHANT_ID":"merchant.schoolmoney.dev"}).REACT_APP_OS,osVersion:Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_KEY":"teachers_1","REACT_APP_CUSTOMER_NOTICES_END_TIME":"2025-12-18 12:19:59","REACT_APP_EDUSPOT_DOWN_TIME_START":"2025-12-18 10:30","REACT_APP_SCHOOLMONEY_DOWN_TIME_END":"2023-11-13 18:40","REACT_APP_SECURE_TRADING_XPRESSIONS_APPLE_PAY_MERCHANT_ID":"merchant.com.groupcall.emerge.parental.req","REACT_APP_SECURE_TRADING_GOOGLE_PAY_MERCHANT_ID":"BCR2DN4T7DZYVHSW","REACT_APP_TEACHERS2PARENTS_APP_REFERRER":"teachers","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_CUSTOMER_NOTICES_KEY":"app_2","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_START":"2021-12-08 10:10","REACT_APP_SECURE_TRADING_INITIATOR":"public","REACT_APP_XPRESSIONS_APP_REFERRER":"xpressions","REACT_APP_EDUSPOT_DOWN_TIME_END":"2025-12-18 11:00","REACT_APP_PAYSAFE_ENVIRONMENT":"LIVE","REACT_APP_SECURE_TRADING_3DS_LIVESTATUS":"0","REACT_APP_SECURE_TRADING_PAYMENT_MODE":"TEST","REACT_APP_SECURE_TRADING_3DS_TERMURL":"/public/appserver/product_resources/school_money/secure_trading/sm_app_threeds_response.html","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_KEY":"schoolmoney_1","REACT_APP_EDUSPOT_LOCAL_HOSTNAME":"uat-appserver.teachers2parents.co.uk","REACT_APP_PAYSAFE_API_KEY":"T1QtOTMyMTpCLXAxLTAtNWIwNDFiN2QtMC0zMDJjMDIxNDRkZGY4N2YwNDM4ZWRlY2YzYWMzYzYzNTlhYjQ2YmE5NDlkYmU4Y2EwMjE0MGJiOTJiNGQxNjU4ZTdmZWFmOGQ2ZGFiYjcxNmIyMTY1MmZhMDVmMQ==","REACT_APP_PARENTAPPS_APP_REFERRER":"parentapps","REACT_APP_SCHOOLMONEY_APP_NAME":"schoolmoney","REACT_APP_SECURE_TRADING_SECRET_TOKEN":"app","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_END":"2021-12-08 11:00","REACT_APP_SCHOOLMONEY_DOWN_TIME_START":"2023-11-13 17:50","REACT_APP_TEACHERS2PARENTS_LOCAL_HOSTNAME":"edspapitesting.teachers2parents.co.uk","REACT_APP_SECURE_TRADING_SITE_REFERENCE":"test_smartthreedtwo83732","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_EDUSPOT_APP_NAME":"eduspot","REACT_APP_PACKAGE_VERSION":"2.82.0","REACT_APP_SECURE_TRADING_SCHOOL_MONEY_APPLE_PAY_MERCHANT_ID":"merchant.schoolmoney.dev"}).REACT_APP_OS_VERSION,device:Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_KEY":"teachers_1","REACT_APP_CUSTOMER_NOTICES_END_TIME":"2025-12-18 12:19:59","REACT_APP_EDUSPOT_DOWN_TIME_START":"2025-12-18 10:30","REACT_APP_SCHOOLMONEY_DOWN_TIME_END":"2023-11-13 18:40","REACT_APP_SECURE_TRADING_XPRESSIONS_APPLE_PAY_MERCHANT_ID":"merchant.com.groupcall.emerge.parental.req","REACT_APP_SECURE_TRADING_GOOGLE_PAY_MERCHANT_ID":"BCR2DN4T7DZYVHSW","REACT_APP_TEACHERS2PARENTS_APP_REFERRER":"teachers","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_CUSTOMER_NOTICES_KEY":"app_2","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_START":"2021-12-08 10:10","REACT_APP_SECURE_TRADING_INITIATOR":"public","REACT_APP_XPRESSIONS_APP_REFERRER":"xpressions","REACT_APP_EDUSPOT_DOWN_TIME_END":"2025-12-18 11:00","REACT_APP_PAYSAFE_ENVIRONMENT":"LIVE","REACT_APP_SECURE_TRADING_3DS_LIVESTATUS":"0","REACT_APP_SECURE_TRADING_PAYMENT_MODE":"TEST","REACT_APP_SECURE_TRADING_3DS_TERMURL":"/public/appserver/product_resources/school_money/secure_trading/sm_app_threeds_response.html","REACT_APP_SCHOOLMONEY_CUSTOMER_NOTICES_KEY":"schoolmoney_1","REACT_APP_EDUSPOT_LOCAL_HOSTNAME":"uat-appserver.teachers2parents.co.uk","REACT_APP_PAYSAFE_API_KEY":"T1QtOTMyMTpCLXAxLTAtNWIwNDFiN2QtMC0zMDJjMDIxNDRkZGY4N2YwNDM4ZWRlY2YzYWMzYzYzNTlhYjQ2YmE5NDlkYmU4Y2EwMjE0MGJiOTJiNGQxNjU4ZTdmZWFmOGQ2ZGFiYjcxNmIyMTY1MmZhMDVmMQ==","REACT_APP_PARENTAPPS_APP_REFERRER":"parentapps","REACT_APP_SCHOOLMONEY_APP_NAME":"schoolmoney","REACT_APP_SECURE_TRADING_SECRET_TOKEN":"app","REACT_APP_TEACHERS2PARENTS_DOWN_TIME_END":"2021-12-08 11:00","REACT_APP_SCHOOLMONEY_DOWN_TIME_START":"2023-11-13 17:50","REACT_APP_TEACHERS2PARENTS_LOCAL_HOSTNAME":"edspapitesting.teachers2parents.co.uk","REACT_APP_SECURE_TRADING_SITE_REFERENCE":"test_smartthreedtwo83732","REACT_APP_TEACHERS2PARENTS_CUSTOMER_NOTICES_END_TIME":"2025-12-18 14:00:59","REACT_APP_EDUSPOT_APP_NAME":"eduspot","REACT_APP_PACKAGE_VERSION":"2.82.0","REACT_APP_SECURE_TRADING_SCHOOL_MONEY_APPLE_PAY_MERCHANT_ID":"merchant.schoolmoney.dev"}).REACT_APP_DEVICE// Log parent apps urlargs or
};if(urlUserIdentity.deviceToken!==undefined&&urlUserIdentity.deviceToken.startsWith("parentapps:")){__WEBPACK_IMPORTED_MODULE_3_lib_appserver_request__["d" /* errorReport */]({stacktrace:JSON.stringify(urlArgs)});}// Check for urlArg identity
if(!(urlUserIdentity.mobileNumber!==undefined&&urlUserIdentity.deviceToken!==undefined)){_context.next=12;break;}userIdentity=urlUserIdentity;// No useful urlArgs, check for .env overrides
_context.next=20;break;case 12:if(!(overrideUserIdentity.mobileNumber!==undefined&&overrideUserIdentity.deviceToken!==undefined)){_context.next=17;break;}__WEBPACK_IMPORTED_MODULE_2_lib_log__["a" /* default */].debug("User Identity: No URL args found, using .env identity: "+overrideUserIdentity.mobileNumber+"/"+overrideUserIdentity.deviceToken);userIdentity=overrideUserIdentity;// No identity provided, kick user
_context.next=20;break;case 17:_context.next=19;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_app_actions__["X" /* setUserIdentityFailed */])());case 19:return _context.abrupt("return");case 20:_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_app_actions__["W" /* setUserIdentity */])(userIdentity));case 22:_context.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_6_state_app_sagas___["a" /* default */],urlArgs.metadata);case 24:_context.next=30;break;case 26:_context.prev=26;_context.t0=_context["catch"](0);_context.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_app_actions__["G" /* fatalError */])(_context.t0));case 30:case"end":return _context.stop();}}},_marked,this,[[0,26]]);}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(288);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 288 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = jspCmdRequest;
/* harmony export (immutable) */ __webpack_exports__["a"] = apiRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_ajax__ = __webpack_require__(290);
/**
 * @module lib/ocean
 * Utilities for communicating with Ocean servers
 * You probably don't want to use these functions directly
 * @see {@link module:lib/appserver/request} for appserver API utilities
 *//**
 * Make an ajax request to a ocean/longiframe_ajax api. oceanExecute wannabe!
 * NOTE: all requests are public, so these request strings need to be whitelisted in config
 *
 * @param {string} hostname hostname of target server
 * @param  {Object} jspCmd
 * @param  {Object} [jspArgs]
 * @param {Object} [requestOptions] passed to {@link module:lib/ajax~request}
 * @returns {Promise}
 */function jspCmdRequest(hostname,jspCmd){var jspArgs=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var requestOptions=arguments[3];var data=buildQueryString({jspCmd:jspCmd,jspArgs:buildQueryString(jspArgs)});return __WEBPACK_IMPORTED_MODULE_0_lib_ajax__["b" /* request */]("https://"+hostname+"/system/clientJSP/longiframe_ajax.html.nc",data,requestOptions);}/**
 * Make an AJAX request to an API endpoint.
 * NOTE: all requests are public, so these request strings need to be whitelisted in config
 *
 * @param  {Object} url full URL of target endpoint, including hostname and path
 * @param  {Object} [args] key-value pairs to pass as query string params
 * @param {Object} [requestOptions] passed to {@link module:lib/ajax~request}
 * @returns {Promise}
 */function apiRequest(url,args,requestOptions){return __WEBPACK_IMPORTED_MODULE_0_lib_ajax__["b" /* request */](url,buildQueryString(args),requestOptions);}/**
 * Encode a string for use in a URL
 * Differs from encodeURIComponent by using ASCII instead of UTF-8 encoding
 * This is required since the backend doesn't properly decode UTF-8
 *
 * @returns {string}
 */function encodeQueryStringComponent(inputString){return encodeURIComponent(inputString);}/**
 * Wrap lib/ajax's buildQueryString to pass in our
 *   ocean-specific encoding.
 */function buildQueryString(queryArgs){return __WEBPACK_IMPORTED_MODULE_0_lib_ajax__["a" /* buildQueryString */](queryArgs,encodeQueryStringComponent);}

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildQueryString;
/* harmony export (immutable) */ __webpack_exports__["b"] = request;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_ajax_retry__ = __webpack_require__(309);
/**
 * @module lib/ajax
 * Utilities for sending AJAX requests
 * You probably don't want to use this library directly
 * @see {@link module:lib/appserver/request} for appserver API methods
 */// Create axios client specifically for lib/ajax. This enhances seperation between us and the 'global' instance
var client=__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({});// Hold reference to our retryInterceptor, but don't do anything with it
// If we ever need to detach from the client, this will make more sense
// eslint-disable-next-line no-unused-vars
var retryInterceptor=new __WEBPACK_IMPORTED_MODULE_1_lib_ajax_retry__["a" /* default */](client);/**
 * buildQueryString - Builds a query string, escaping the key and value pairs
 *
 * @param  {Object} queryArgs  Key/Value Pairs of arguments
 * @param {Function} [encoder] function to encode URI components
 * @returns {String}           "foo=2&bar=5&a%20space=%2B447432713336"
 */function buildQueryString(queryArgs){var encoder=arguments.length>1&&arguments[1]!==undefined?arguments[1]:encodeURIComponent;var queryArgPairs=[];// loop through the keys and build them into a list of pairs ["foo=2","bar=5"]
for(var key in queryArgs){if(queryArgs.hasOwnProperty(key)){var argValue=queryArgs[key];queryArgPairs.push(encoder(key)+"="+encoder(argValue));}}// Now join to add the ampersands
// "foo=2&bar=5"
return queryArgPairs.join("&");}/**
 * remoteAPIRequest - make a simple request to a remote api (POST/x-www-form-urlencoded)
 *
 * @param  {type} url description
 * @returns {type}     description
 */function request(url,data,options){return client(Object.assign({method:"post",url:url,headers:{'content-type':'application/x-www-form-urlencoded'},data:data},options));}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);
var bind = __webpack_require__(152);
var Axios = __webpack_require__(293);
var defaults = __webpack_require__(98);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(156);
axios.CancelToken = __webpack_require__(307);
axios.isCancel = __webpack_require__(155);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(308);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 292 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(98);
var utils = __webpack_require__(26);
var InterceptorManager = __webpack_require__(302);
var dispatchRequest = __webpack_require__(303);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(154);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);
var transformData = __webpack_require__(304);
var isCancel = __webpack_require__(155);
var defaults = __webpack_require__(98);
var isAbsoluteURL = __webpack_require__(305);
var combineURLs = __webpack_require__(306);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(26);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(156);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Thrown when user passes a value to retryType that doesn't belong to the enum
 */var UnrecognisedRetryTypeError=function(_Error){_inherits(UnrecognisedRetryTypeError,_Error);function UnrecognisedRetryTypeError(retryType){_classCallCheck(this,UnrecognisedRetryTypeError);return _possibleConstructorReturn(this,(UnrecognisedRetryTypeError.__proto__||Object.getPrototypeOf(UnrecognisedRetryTypeError)).call(this,"Unrecognised retryType \""+retryType+"\""));}return UnrecognisedRetryTypeError;}(Error);/**
 * getDelayedPromise - returns a promise that resolves after delayTimeout
 *
 * @param  {Number} delayTimeout
 * @returns {Promise}
 */function getDelayedPromise(delayTimeout){return new Promise(function(resolve,reject){setTimeout(function(){resolve();},delayTimeout);});}/**
 * AxiosRetryInterceptor -
 */var AxiosRetryInterceptor=function(){_createClass(AxiosRetryInterceptor,null,[{key:"getDefaultConfig",/**
   * @static getDefaultConfig - get default config object for merging over
   *
   * @returns {Object}
   */value:function getDefaultConfig(){return{maxRetries:3,retryType:AxiosRetryInterceptor.retryType.EXPONENTIAL,retryValue:null,retryHTTPStatusRanges:[[100,199],[429,429],[500,599]],onBeforeRetry:function onBeforeRetry(error){},onRetry:function onRetry(error){}};}/**
   * Enum for special retryTypes
   */},{key:"errorHasHTTPResponse",value:function errorHasHTTPResponse(error){return error.response!==undefined&&error.response.status!==undefined;}},{key:"getRetryConfig",value:function getRetryConfig(error){if(error.config!==undefined&&error.config.retryConfig!==undefined){return error.config.retryConfig;}return false;}/**
   * @static getNextRetryIndex
   *
   * @param  {Object} retryConfig
   * @returns {Number}
   */},{key:"getNextRetryIndex",value:function getNextRetryIndex(retryConfig){return retryConfig.currentRetryIndex+1||1;}},{key:"getNextRetryDelay",value:function getNextRetryDelay(retryConfig){var nextRetryIndex=AxiosRetryInterceptor.getNextRetryIndex(retryConfig);switch(retryConfig.retryType){// return exp backoff timeout
case AxiosRetryInterceptor.retryType.EXPONENTIAL:return(Math.pow(3,nextRetryIndex)-1)/2*1000;case AxiosRetryInterceptor.retryType.LINEAR:return nextRetryIndex*retryConfig.retryValue;case AxiosRetryInterceptor.retryType.STATIC:return retryConfig.retryValue;default:throw new UnrecognisedRetryTypeError(retryConfig.retryType);}}},{key:"isStatusInRanges",value:function isStatusInRanges(statusCode,validRanges){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=validRanges[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var range=_step.value;var _range=_slicedToArray(range,2),min=_range[0],max=_range[1];if(statusCode>=min&&statusCode<=max){return true;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}},{key:"shouldRetryError",value:function shouldRetryError(error){var retryConfig=AxiosRetryInterceptor.getRetryConfig(error);if(retryConfig===false){return false;}// If the error has a response, and the response has a status code, and that status code is permanent, no retry
if(AxiosRetryInterceptor.errorHasHTTPResponse(error)){if(AxiosRetryInterceptor.isStatusInRanges(error.response.status,retryConfig.retryHTTPStatusRanges)){return false;}}// If the next retry index would leave us over our maxRetries, no retry
if(AxiosRetryInterceptor.getNextRetryIndex(retryConfig)>retryConfig.maxRetries){return false;}// Otherwise, assume retryable.
return true;}// take the instanceDefaults and merge the specific request's config over it
}]);function AxiosRetryInterceptor(){var _this2=this;var axiosInstance=arguments.length>0&&arguments[0]!==undefined?arguments[0]:__WEBPACK_IMPORTED_MODULE_0_axios___default.a;_classCallCheck(this,AxiosRetryInterceptor);this.onError=function(error){// No Retries allowed, reject
if(AxiosRetryInterceptor.shouldRetryError(error)===false){return Promise.reject(error);}var nextRetryDelay=AxiosRetryInterceptor.getNextRetryDelay(error.config.retryConfig);error.config.retryConfig=Object.assign({},error.config.retryConfig,{currentRetryIndex:AxiosRetryInterceptor.getNextRetryIndex(error.config.retryConfig),currentWaitTimeout:nextRetryDelay,totalWaitTimeout:error.config.retryConfig.totalWaitTimeout+nextRetryDelay});error.config.retryConfig.onBeforeRetry(error);// After nextRetryDelay, resolve the promise with another promise of the next retry axios promise
return getDelayedPromise(nextRetryDelay).then(function(){// Call user Handler (after wait timeout)
error.config.retryConfig.onRetry(error);return _this2.axiosInstance(error.config);});};this.onRequest=function(requestConfig){var nextRequestConfig=Object.assign({},requestConfig,{retryConfig:Object.assign({},AxiosRetryInterceptor.getDefaultConfig(),{// Initialise counter values
currentRetryIndex:0,currentWaitTimeout:0,totalWaitTimeout:0},requestConfig.retryConfig)});requestConfig.retryConfig={};return nextRequestConfig;};this.detatch=function(){_this2.axiosInstance.interceptors.request.eject(_this2.requestInterceptorID);_this2.axiosInstance.interceptors.response.eject(_this2.responseInterceptorID);};this.axiosInstance=axiosInstance;this.requestInterceptorID=axiosInstance.interceptors.request.use(this.onRequest);this.responseInterceptorID=axiosInstance.interceptors.response.use(null,this.onError);}return AxiosRetryInterceptor;}();AxiosRetryInterceptor.retryType={EXPONENTIAL:"retryType/EXPONENTIAL",LINEAR:"retryType/LINEAR",STATIC:"retryType/STATIC"};/* harmony default export */ __webpack_exports__["a"] = (AxiosRetryInterceptor);

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = failsafeSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_log__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_reportErrorSaga__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_app_actions__ = __webpack_require__(9);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(failsafeSaga);/**
 * @module state/failsafeSaga
 *//**
 * Failsafe Saga - if all else fails, this saga should survive.
 * Deals with top-level error logging and possibly recovery.
 */function failsafeSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function failsafeSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])([__WEBPACK_IMPORTED_MODULE_4_state_app_actions__["g" /* ERROR_FATAL */],__WEBPACK_IMPORTED_MODULE_4_state_app_actions__["h" /* ERROR_WARNING */]],__WEBPACK_IMPORTED_MODULE_3_state_reportErrorSaga__["a" /* default */]);case 2:_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4_state_app_actions__["x" /* RELOAD */],reloadApp);case 4:case"end":return _context.stop();}}},_marked,this);}function reloadApp(){// this is only likely to throw in some weird environment,
// e.g. a unit test
try{window.location.reload();}catch(error){__WEBPACK_IMPORTED_MODULE_2_lib_log__["a" /* default */].error("FailsafeSaga: reloadApp: ",error);}}

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reportErrorSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_log__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_appserver_request__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_localStore__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lib_error_details__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_app_selectors__ = __webpack_require__(8);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(reportErrorSaga);/**
 * @module state/reportError
 * Send an error report.
 *//**
 * Log error locally and send report to appserver (BigBrother).
 */function reportErrorSaga(action){var error,payload,userIdentity;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function reportErrorSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:error=action.payload.error;Object(__WEBPACK_IMPORTED_MODULE_5_state_localStore__["a" /* clearData */])();__WEBPACK_IMPORTED_MODULE_3_lib_log__["a" /* default */].error(error);__WEBPACK_IMPORTED_MODULE_3_lib_log__["a" /* default */].log("ReportError: Sending error report...");// get payload from error details
payload=void 0;try{payload=JSON.stringify(error.details,undefined,2);}catch(error){__WEBPACK_IMPORTED_MODULE_3_lib_log__["a" /* default */].warn("ReportError: Failed to stringify error details:",error);payload="[ failed to stringify error details ]";}userIdentity=void 0;_context.prev=7;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_7_state_app_selectors__["k" /* getUserIdentity */]);case 10:userIdentity=_context.sent;_context.next=17;break;case 13:_context.prev=13;_context.t0=_context["catch"](7);__WEBPACK_IMPORTED_MODULE_3_lib_log__["a" /* default */].warn("ReportError: Could not get user identity from state:",_context.t0);userIdentity=new __WEBPACK_IMPORTED_MODULE_1_immutable___default.a.Map();case 17:return _context.abrupt("return",__WEBPACK_IMPORTED_MODULE_4_lib_appserver_request__["d" /* errorReport */]({type:error&&(error.type||error.name)||"UnknownError",error_code:Object(__WEBPACK_IMPORTED_MODULE_6_lib_error_details__["a" /* getErrorCode */])(error),message:error?error.message:"Unknown",payload:payload,stacktrace:error?error.stack:"Unknown",web_version:"2.82.0",native_version:userIdentity.get("appVersion"),os:userIdentity.get("os"),os_version:userIdentity.get("osVersion"),device_type:userIdentity.get("device"),mobile_number:userIdentity.get("mobileNumber")}).then(function(response){__WEBPACK_IMPORTED_MODULE_3_lib_log__["a" /* default */].log("ReportError: Sent error report. (response: %s)",response.data);return response;}));case 18:case"end":return _context.stop();}}},_marked,this,[[7,13]]);}

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = (function() {

// private property
var f = String.fromCharCode;
var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
var baseReverseDic = {};

function getBaseValue(alphabet, character) {
  if (!baseReverseDic[alphabet]) {
    baseReverseDic[alphabet] = {};
    for (var i=0 ; i<alphabet.length ; i++) {
      baseReverseDic[alphabet][alphabet.charAt(i)] = i;
    }
  }
  return baseReverseDic[alphabet][character];
}

var LZString = {
  compressToBase64 : function (input) {
    if (input == null) return "";
    var res = LZString._compress(input, 6, function(a){return keyStrBase64.charAt(a);});
    switch (res.length % 4) { // To produce valid Base64
    default: // When could this happen ?
    case 0 : return res;
    case 1 : return res+"===";
    case 2 : return res+"==";
    case 3 : return res+"=";
    }
  },

  decompressFromBase64 : function (input) {
    if (input == null) return "";
    if (input == "") return null;
    return LZString._decompress(input.length, 32, function(index) { return getBaseValue(keyStrBase64, input.charAt(index)); });
  },

  compressToUTF16 : function (input) {
    if (input == null) return "";
    return LZString._compress(input, 15, function(a){return f(a+32);}) + " ";
  },

  decompressFromUTF16: function (compressed) {
    if (compressed == null) return "";
    if (compressed == "") return null;
    return LZString._decompress(compressed.length, 16384, function(index) { return compressed.charCodeAt(index) - 32; });
  },

  //compress into uint8array (UCS-2 big endian format)
  compressToUint8Array: function (uncompressed) {
    var compressed = LZString.compress(uncompressed);
    var buf=new Uint8Array(compressed.length*2); // 2 bytes per character

    for (var i=0, TotalLen=compressed.length; i<TotalLen; i++) {
      var current_value = compressed.charCodeAt(i);
      buf[i*2] = current_value >>> 8;
      buf[i*2+1] = current_value % 256;
    }
    return buf;
  },

  //decompress from uint8array (UCS-2 big endian format)
  decompressFromUint8Array:function (compressed) {
    if (compressed===null || compressed===undefined){
        return LZString.decompress(compressed);
    } else {
        var buf=new Array(compressed.length/2); // 2 bytes per character
        for (var i=0, TotalLen=buf.length; i<TotalLen; i++) {
          buf[i]=compressed[i*2]*256+compressed[i*2+1];
        }

        var result = [];
        buf.forEach(function (c) {
          result.push(f(c));
        });
        return LZString.decompress(result.join(''));

    }

  },


  //compress into a string that is already URI encoded
  compressToEncodedURIComponent: function (input) {
    if (input == null) return "";
    return LZString._compress(input, 6, function(a){return keyStrUriSafe.charAt(a);});
  },

  //decompress from an output of compressToEncodedURIComponent
  decompressFromEncodedURIComponent:function (input) {
    if (input == null) return "";
    if (input == "") return null;
    input = input.replace(/ /g, "+");
    return LZString._decompress(input.length, 32, function(index) { return getBaseValue(keyStrUriSafe, input.charAt(index)); });
  },

  compress: function (uncompressed) {
    return LZString._compress(uncompressed, 16, function(a){return f(a);});
  },
  _compress: function (uncompressed, bitsPerChar, getCharFromInt) {
    if (uncompressed == null) return "";
    var i, value,
        context_dictionary= {},
        context_dictionaryToCreate= {},
        context_c="",
        context_wc="",
        context_w="",
        context_enlargeIn= 2, // Compensate for the first entry which should not count
        context_dictSize= 3,
        context_numBits= 2,
        context_data=[],
        context_data_val=0,
        context_data_position=0,
        ii;

    for (ii = 0; ii < uncompressed.length; ii += 1) {
      context_c = uncompressed.charAt(ii);
      if (!Object.prototype.hasOwnProperty.call(context_dictionary,context_c)) {
        context_dictionary[context_c] = context_dictSize++;
        context_dictionaryToCreate[context_c] = true;
      }

      context_wc = context_w + context_c;
      if (Object.prototype.hasOwnProperty.call(context_dictionary,context_wc)) {
        context_w = context_wc;
      } else {
        if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate,context_w)) {
          if (context_w.charCodeAt(0)<256) {
            for (i=0 ; i<context_numBits ; i++) {
              context_data_val = (context_data_val << 1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
            }
            value = context_w.charCodeAt(0);
            for (i=0 ; i<8 ; i++) {
              context_data_val = (context_data_val << 1) | (value&1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = value >> 1;
            }
          } else {
            value = 1;
            for (i=0 ; i<context_numBits ; i++) {
              context_data_val = (context_data_val << 1) | value;
              if (context_data_position ==bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = 0;
            }
            value = context_w.charCodeAt(0);
            for (i=0 ; i<16 ; i++) {
              context_data_val = (context_data_val << 1) | (value&1);
              if (context_data_position == bitsPerChar-1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = value >> 1;
            }
          }
          context_enlargeIn--;
          if (context_enlargeIn == 0) {
            context_enlargeIn = Math.pow(2, context_numBits);
            context_numBits++;
          }
          delete context_dictionaryToCreate[context_w];
        } else {
          value = context_dictionary[context_w];
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }


        }
        context_enlargeIn--;
        if (context_enlargeIn == 0) {
          context_enlargeIn = Math.pow(2, context_numBits);
          context_numBits++;
        }
        // Add wc to the dictionary.
        context_dictionary[context_wc] = context_dictSize++;
        context_w = String(context_c);
      }
    }

    // Output the code for w.
    if (context_w !== "") {
      if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate,context_w)) {
        if (context_w.charCodeAt(0)<256) {
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
          }
          value = context_w.charCodeAt(0);
          for (i=0 ; i<8 ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }
        } else {
          value = 1;
          for (i=0 ; i<context_numBits ; i++) {
            context_data_val = (context_data_val << 1) | value;
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = 0;
          }
          value = context_w.charCodeAt(0);
          for (i=0 ; i<16 ; i++) {
            context_data_val = (context_data_val << 1) | (value&1);
            if (context_data_position == bitsPerChar-1) {
              context_data_position = 0;
              context_data.push(getCharFromInt(context_data_val));
              context_data_val = 0;
            } else {
              context_data_position++;
            }
            value = value >> 1;
          }
        }
        context_enlargeIn--;
        if (context_enlargeIn == 0) {
          context_enlargeIn = Math.pow(2, context_numBits);
          context_numBits++;
        }
        delete context_dictionaryToCreate[context_w];
      } else {
        value = context_dictionary[context_w];
        for (i=0 ; i<context_numBits ; i++) {
          context_data_val = (context_data_val << 1) | (value&1);
          if (context_data_position == bitsPerChar-1) {
            context_data_position = 0;
            context_data.push(getCharFromInt(context_data_val));
            context_data_val = 0;
          } else {
            context_data_position++;
          }
          value = value >> 1;
        }


      }
      context_enlargeIn--;
      if (context_enlargeIn == 0) {
        context_enlargeIn = Math.pow(2, context_numBits);
        context_numBits++;
      }
    }

    // Mark the end of the stream
    value = 2;
    for (i=0 ; i<context_numBits ; i++) {
      context_data_val = (context_data_val << 1) | (value&1);
      if (context_data_position == bitsPerChar-1) {
        context_data_position = 0;
        context_data.push(getCharFromInt(context_data_val));
        context_data_val = 0;
      } else {
        context_data_position++;
      }
      value = value >> 1;
    }

    // Flush the last char
    while (true) {
      context_data_val = (context_data_val << 1);
      if (context_data_position == bitsPerChar-1) {
        context_data.push(getCharFromInt(context_data_val));
        break;
      }
      else context_data_position++;
    }
    return context_data.join('');
  },

  decompress: function (compressed) {
    if (compressed == null) return "";
    if (compressed == "") return null;
    return LZString._decompress(compressed.length, 32768, function(index) { return compressed.charCodeAt(index); });
  },

  _decompress: function (length, resetValue, getNextValue) {
    var dictionary = [],
        next,
        enlargeIn = 4,
        dictSize = 4,
        numBits = 3,
        entry = "",
        result = [],
        i,
        w,
        bits, resb, maxpower, power,
        c,
        data = {val:getNextValue(0), position:resetValue, index:1};

    for (i = 0; i < 3; i += 1) {
      dictionary[i] = i;
    }

    bits = 0;
    maxpower = Math.pow(2,2);
    power=1;
    while (power!=maxpower) {
      resb = data.val & data.position;
      data.position >>= 1;
      if (data.position == 0) {
        data.position = resetValue;
        data.val = getNextValue(data.index++);
      }
      bits |= (resb>0 ? 1 : 0) * power;
      power <<= 1;
    }

    switch (next = bits) {
      case 0:
          bits = 0;
          maxpower = Math.pow(2,8);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
        c = f(bits);
        break;
      case 1:
          bits = 0;
          maxpower = Math.pow(2,16);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
        c = f(bits);
        break;
      case 2:
        return "";
    }
    dictionary[3] = c;
    w = c;
    result.push(c);
    while (true) {
      if (data.index > length) {
        return "";
      }

      bits = 0;
      maxpower = Math.pow(2,numBits);
      power=1;
      while (power!=maxpower) {
        resb = data.val & data.position;
        data.position >>= 1;
        if (data.position == 0) {
          data.position = resetValue;
          data.val = getNextValue(data.index++);
        }
        bits |= (resb>0 ? 1 : 0) * power;
        power <<= 1;
      }

      switch (c = bits) {
        case 0:
          bits = 0;
          maxpower = Math.pow(2,8);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }

          dictionary[dictSize++] = f(bits);
          c = dictSize-1;
          enlargeIn--;
          break;
        case 1:
          bits = 0;
          maxpower = Math.pow(2,16);
          power=1;
          while (power!=maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb>0 ? 1 : 0) * power;
            power <<= 1;
          }
          dictionary[dictSize++] = f(bits);
          c = dictSize-1;
          enlargeIn--;
          break;
        case 2:
          return result.join('');
      }

      if (enlargeIn == 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits++;
      }

      if (dictionary[c]) {
        entry = dictionary[c];
      } else {
        if (c === dictSize) {
          entry = w + w.charAt(0);
        } else {
          return null;
        }
      }
      result.push(entry);

      // Add w+entry[0] to the dictionary.
      dictionary[dictSize++] = w + entry.charAt(0);
      enlargeIn--;

      w = entry;

      if (enlargeIn == 0) {
        enlargeIn = Math.pow(2, numBits);
        numBits++;
      }

    }
  }
};
  return LZString;
})();

if (true) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return LZString; }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if( typeof module !== 'undefined' && module != null ) {
  module.exports = LZString
} else if( typeof angular !== 'undefined' && angular != null ) {
  angular.module('LZString', [])
  .factory('LZString', function () {
    return LZString;
  });
}


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getMobileNumber;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDeviceToken;
/* harmony export (immutable) */ __webpack_exports__["e"] = getUserIdentityStatus;
/* harmony export (immutable) */ __webpack_exports__["c"] = getUserIdentity;
/* harmony export (immutable) */ __webpack_exports__["d"] = getUserIdentityAppReferrer;
function getMobileNumber(state){return state.getIn(["app","userIdentity","mobileNumber"]);}function getDeviceToken(state){return state.getIn(["app","userIdentity","deviceToken"]);}function getUserIdentityStatus(state){return state.getIn(["app","userIdentity","status"]);}function getUserIdentity(state){return state.getIn(["app","userIdentity"]);}function getUserIdentityAppReferrer(state){return state.getIn(["app","userIdentity","appReferrer"]);}

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = appRootSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_sagas_fetchAvailableProducts__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_validate__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_app_sagas_openURL__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_app_sagas_openEmail__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_app_sagas_openPhone__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_app_sagas_forceRegistration__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_app_sagas_processMetadata__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_app_sagas_closeApplication__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_app_sagas_goBack__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_state_app_sagas_attachProductsSaga__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_state_localStore__ = __webpack_require__(34);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(appRootSaga);// app/rootSaga
function appRootSaga(metadata){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function appRootSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_13_state_localStore__["e" /* validateLocalStoreStructure */]);case 2:_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_12_state_app_actions__["i" /* FETCH_AVAILABLE_PRODUCTS */],__WEBPACK_IMPORTED_MODULE_2_state_app_sagas_fetchAvailableProducts__["a" /* default */]);case 4:_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_12_state_app_actions__["t" /* OPEN_URL */],__WEBPACK_IMPORTED_MODULE_4_state_app_sagas_openURL__["a" /* default */]);case 6:_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_12_state_app_actions__["p" /* OPEN_EMAIL */],__WEBPACK_IMPORTED_MODULE_5_state_app_sagas_openEmail__["a" /* default */]);case 8:_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_12_state_app_actions__["s" /* OPEN_PHONE */],__WEBPACK_IMPORTED_MODULE_6_state_app_sagas_openPhone__["a" /* default */]);case 10:_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_12_state_app_actions__["v" /* PROCESS_METADATA */],__WEBPACK_IMPORTED_MODULE_8_state_app_sagas_processMetadata__["a" /* default */]);case 12:_context.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_12_state_app_actions__["l" /* GO_BACK */],__WEBPACK_IMPORTED_MODULE_10_state_app_sagas_goBack__["a" /* default */]);case 14:_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_12_state_app_actions__["b" /* CLOSE_APPLICATION */],__WEBPACK_IMPORTED_MODULE_9_state_app_sagas_closeApplication__["a" /* default */]);case 16:_context.next=18;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["k" /* throttle */])(1500,__WEBPACK_IMPORTED_MODULE_12_state_app_actions__["k" /* FORCE_REGISTRATION */],__WEBPACK_IMPORTED_MODULE_7_state_app_sagas_forceRegistration__["a" /* default */]);case 18:_context.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(__WEBPACK_IMPORTED_MODULE_11_state_app_sagas_attachProductsSaga__["a" /* default */]);case 20:if(!Object(__WEBPACK_IMPORTED_MODULE_3_lib_validate__["c" /* isAppserverOnline */])()){_context.next=23;break;}_context.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_12_state_app_actions__["H" /* fetchAvailableProducts */]());case 23:_context.next=25;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_12_state_app_actions__["w" /* PRODUCT_SAGAS_ATTACHED */]);case 25:if(!(metadata!==undefined)){_context.next=28;break;}_context.next=28;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_12_state_app_actions__["T" /* processMetadata */](metadata));case 28:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchAvailableProductsSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_app_actions__ = __webpack_require__(9);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchAvailableProductsSaga);// Main Worker Saga
// started on FETCH_AVAILABLE_PRODUCTS (see ./index.js)
// also fired on first load by root saga to figure out what products we need to attach
function fetchAvailableProductsSaga(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchAvailableProductsSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_state_fetchSagas__["a" /* sendAvailableProductsRequest */]);case 2:response=_context.sent;if(!(response.data.length===0)){_context.next=8;break;}_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_3_state_app_actions__["J" /* forceRegistration */]("This device is no longer registered. Please re-register."));case 6:_context.next=10;break;case 8:_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_3_state_app_actions__["I" /* fetchAvailableProductsSuccess */](response.data));case 10:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export simulateAvailableProductsRequest */
/* unused harmony export simulateDataRequest */
/* harmony export (immutable) */ __webpack_exports__["a"] = getAPISimulator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_appserver_request__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_sampleData__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_sampleData___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_state_sampleData__);
/**
 * Provide a library of functions that act like appserver API
 *   requests but don't actually contact appserver.
 * This is intended for "demo mode" which will be used by Apple
 *   App Store reviewers to verify the app's functionality.
 * These fake API calls return sample data after a short tmeout.
 *//**
 * Time in ms to wait before returning data.
 */var SIMULATED_REQUEST_DELAY=500;/**
 * Simulate a data request by returning a promise that will
 *   resolve with the given data after a delay.
 */function simulateRequest(responseData){return new Promise(function(resolve){window.setTimeout(function(){resolve({data:{status:"success",data:responseData}});},SIMULATED_REQUEST_DELAY);});}/**
 * Simulate appserver's GetMyApps() API.
 */function simulateAvailableProductsRequest(mobileNumber,deviceToken){return simulateRequest(__WEBPACK_IMPORTED_MODULE_1_state_sampleData___default.a.available_products);}/**
 * Simulate appserver's ServiceAppServerDataRequest() API.
 */function simulateDataRequest(mobileNumber,deviceToken,application,_ref){var request_cmd=_ref.request_cmd;return simulateRequest(__WEBPACK_IMPORTED_MODULE_1_state_sampleData___default.a[application][request_cmd]);}/**
 * Simulate the given appserver API.
 * @param {Function} appserverAPI availableProductsRequest || dataRequest
 * @param {Object} args same as args to appserver APIs
 * @returns {Promise}
 */function getAPISimulator(appserverAPI){switch(appserverAPI){case __WEBPACK_IMPORTED_MODULE_0_lib_appserver_request__["b" /* availableProductsRequest */]:return simulateAvailableProductsRequest;case __WEBPACK_IMPORTED_MODULE_0_lib_appserver_request__["c" /* dataRequest */]:return simulateDataRequest;default:throw new Error("Cannot simulate appserver API: %s",appserverAPI.name);}}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports = {"available_products":["teachers"],"teachers":{"get_my_schools":[["SAMPLE_DATA","-1","1","1","Nansen Primary","","07700900789","http://www.nansen.co.uk","nansen.primary@example.com","N","+00:00"],["SAMPLE_DATA","-1","2","2","Hodge Clough Primary","","07700900456","http://www.hodgecloughprimary.co.uk","hodge.clough@example.com","N","+00:00"],["SAMPLE_DATA","-1","3","3","Chetwynde School","","07700900123","http://www.chetwyndeschool.co.uk","chetwynde@example.com","Y","+00:00"],["SAMPLE_DATA_MIGRATED","-1","4","4","Nansen Primary","","07700900789","http://www.nansen.co.uk","nansen.primary@example.com","N","+00:00","1"]],"get_my_messages":[["SAMPLE_DATA","-1","2","2","A:1","Can all parents please use the newly allocated drop-off area across from the playground. Thankyou!","2017-09-25 15:34:00.0","school"],["SAMPLE_DATA","-1","2","2","S:1","Friday will become new Milk Day can parents please return the forms issued to their children if they want them to take part.","2017-09-27 11:34:00.0","school"],["SAMPLE_DATA","-1","2","2","S:2","Reminder to all parents that Own Clothes Day will be on Friday 6th October.","2017-09-29 14:02:00.0","school"],["SAMPLE_DATA","-1","3","3","A:2","Good morning, this year's McMillan Charity Bake Sale will take place on Friday 29th September, please can any parents who wish to bake please bring in their creations Friday morning by 09:30 at the latest. Thankyou!","2017-09-14 10:58:00.0","school"],["SAMPLE_DATA","-1","3","3","S:3","Congratulations John has been voted Year 5 class representative!","2017-09-17 12:41:00.0","school"],["SAMPLE_DATA","-1","3","3","S:4","Good morning, this year's McMillan Charity Bake Sale will take place on Friday 29th.","2017-09-18 12:58:00.0","school"],["SAMPLE_DATA","-1","3","3","R:1","Morning Chetwynde! That's amazing news, we are so proud!","2017-09-17 12:55:00.0","parent"],["SAMPLE_DATA","-1","1","1","S:5","THIS IS A MESSAGE FROM OUR ORIGINAL ACCOUNT","2024-06-05 12:55:00.0","school"],["SAMPLE_DATA_MIGRATED","-1","4","4","S:6","THIS IS A MESSAGE FROM OUR MIGRATED ACCOUNT","2024-06-06 12:55:00.0","school"]],"get_my_notices":[["SAMPLE_DATA","-1","1","1","1","All School Sports Day","All School Sports Day will be held on the 16th September at 10:30 am. Please can all parents provide their child with PE kit for the day. Each child have a total of four guests.","2017-09-06 12:51:00.0","football.svg"],["SAMPLE_DATA","-1","1","1","2","Year 5 & 6 Music Day","Year 5 & 6 Music Day on the 20th September, will last the entirety of the day. Students will have the option to try out new and exciting instruments. Can all parents please give the forms to reception by the 17th September.","2017-09-04 13:33:00.0","music.svg"],["SAMPLE_DATA","-1","1","1","3","Year 3 & 4 History Trip","On the 19th September the Year 3 & 4 Students will be taking a day trip to the National History Museum. Lunches will be provided and the trip time will finish by the end of a normal school day. Can parents pick up their child as usual. Please see the forms provided to your children to be given to reception by the 15th September. Thankyou.","2017-09-02 09:41:00.0","map.svg"],["SAMPLE_DATA","-1","3","3","1","PTA Meeting","This Month's PTA meeting will take place in the village hall at 16:00 pm.","2017-09-23 09:58:00.0","arts.svg"],["SAMPLE_DATA","-1","3","3","2","Year 6 Football Match","The first football match of the season will take place at our school's football pitch on the 02 October at 10:30 am. We will be playing Stonehill Primary our rivals from last season. Everyone bring something warm to wear and we hope to hear lots of encouragement!","2017-09-20 09:20:00.0","football.svg"],["SAMPLE_DATA","-1","3","3","3","Year 3 Music Day","Year 3 Music Day on the 25th September will last as long as a normal school day. Students will have the chance to try new instruments before they decide which they would like to pursue this year!","2017-09-18 12:33:00.0","music.svg"]],"get_my_terms":[["SAMPLE_DATA","-1","1","1","1","Autumn 2017","2017-09-04","2017-12-20","2017-10-24","2017-10-27"],["SAMPLE_DATA","-1","1","1","2","Spring 2018","2018-01-07","2018-03-30","2018-02-11","2018-02-16"],["SAMPLE_DATA","-1","1","1","3","Summer 2018","2018-04-16","2018-07-26","2018-05-28","2018-06-01"],["SAMPLE_DATA","-1","2","2","1","Autumn 2017","2017-09-28","2017-12-08","2017-10-22","2017-10-27"],["SAMPLE_DATA","-1","2","2","2","Spring 2018","2018-01-03","2018-03-26","2018-02-09","2018-02-16"],["SAMPLE_DATA","-1","2","2","3","Summer 2018","2018-04-09","2018-07-26","2018-05-28","2018-06-01"]]}}

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = openURLSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_native__ = __webpack_require__(44);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(openURLSaga);function openURLSaga(action){var userIdentity;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function openURLSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["k" /* getUserIdentity */]);case 2:userIdentity=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_lib_native__["f" /* openURL */],userIdentity.get("platform"),action.payload.url);case 5:return _context.abrupt("return",_context.sent);case 6:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = openEmailSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_native__ = __webpack_require__(44);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(openEmailSaga);function openEmailSaga(action){var userIdentity;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function openEmailSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["k" /* getUserIdentity */]);case 2:userIdentity=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_lib_native__["d" /* openEmail */],userIdentity.get("platform"),action.payload.emailAddress);case 5:return _context.abrupt("return",_context.sent);case 6:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = openPhoneSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_native__ = __webpack_require__(44);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(openPhoneSaga);function openPhoneSaga(action){var userIdentity;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function openPhoneSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["k" /* getUserIdentity */]);case 2:userIdentity=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_lib_native__["e" /* openPhone */],userIdentity.get("platform"),action.payload.phoneNumber);case 5:return _context.abrupt("return",_context.sent);case 6:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = forceRegistrationSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_native__ = __webpack_require__(44);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(forceRegistrationSaga);function forceRegistrationSaga(action){var userIdentity;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function forceRegistrationSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["k" /* getUserIdentity */]);case 2:userIdentity=_context.sent;// user is being kicked here, so we need to clear any local storage we had
// In future, the native client should clear the local storage/cache here,
// but for now we can do it manually
localStorage.clear();_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_lib_native__["c" /* forceRegistration */],userIdentity.get("platform"),action.payload.userMessage);case 6:return _context.abrupt("return",_context.sent);case 7:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = processMetadataSaga;
/* unused harmony export processGooglePayResponseSaga */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_log__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_school_money_actions__ = __webpack_require__(4);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(waitForCheckoutWindowToClose),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(processMetadataSaga),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(processGooglePayResponseSaga);/**
*   const urlUserIdentity = {
    mobileNumber: urlArgs.mobile_number,
    deviceToken:  urlArgs.device_token,

    appReferrer:  urlArgs.app_referrer,
    metadata:     urlArgs.metadata,
    platform:     urlArgs.platform,
    appVersion:   urlArgs.app_version,
    os:           urlArgs.os,
    osVersion:    urlArgs.os_version,
    device:       urlArgs.device
  }
*/function buildTargetURLfromUserIdentity(stateUserIdentity){var queryArgs={};var userIdentity=stateUserIdentity.toJS();// Blank the metadata, as that only applies to the first load
// Delete status as that's an internal property
delete userIdentity.metadata;delete userIdentity.status;// Translate the arguments back to url args
// map only the camelcased versions that need translating
for(var keyName in userIdentity){if(userIdentity.hasOwnProperty(keyName)){switch(keyName){case"mobileNumber":queryArgs.mobile_number=userIdentity[keyName];break;case"deviceToken":queryArgs.device_token=userIdentity[keyName];break;case"appReferrer":queryArgs.app_referrer=userIdentity[keyName];break;case"appVersion":queryArgs.app_version=userIdentity[keyName];break;case"osVersion":queryArgs.os_version=userIdentity[keyName];break;default:break;}}}// build the query string from the translated args
var targetQueryString=__WEBPACK_IMPORTED_MODULE_3_query_string___default.a.stringify(queryArgs);return ""+"/?"+targetQueryString+window.location.hash;}// Prevents app refresh if CheckoutWindow is open
function waitForCheckoutWindowToClose(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function waitForCheckoutWindowToClose$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors__["_71" /* isCheckoutWindowOpen */]);case 2:if(!_context.sent){_context.next=7;break;}_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* take */])();case 5:_context.next=0;break;case 7:case"end":return _context.stop();}}},_marked,this);}// Pushes user to specific parts of app depending on notification payload
function processMetadataSaga(action){var clientInitDateString,clientInitDate,userIdentity,targetURLHref;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function processMetadataSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:__WEBPACK_IMPORTED_MODULE_4_lib_log__["a" /* default */].debug("Process Metadata: got metadata: "+action.payload.metadata);// Check for empty metadata passed from native
if(!(action.payload.metadata==="")){_context2.next=3;break;}return _context2.abrupt("return");case 3:_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_6_state_app_selectors__["b" /* getClientInitDate */]);case 5:clientInitDateString=_context2.sent;clientInitDate=__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(clientInitDateString);_context2.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(waitForCheckoutWindowToClose);case 9:if(!(__WEBPACK_IMPORTED_MODULE_2_moment___default()().diff(clientInitDate,"days")>0)){_context2.next=18;break;}__WEBPACK_IMPORTED_MODULE_4_lib_log__["a" /* default */].debug("Process Metadata: client is stale, refreshing...");_context2.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_5_state_app_actions__["z" /* clearClientInitDate */]());case 13:_context2.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_6_state_app_selectors__["k" /* getUserIdentity */]);case 15:userIdentity=_context2.sent;targetURLHref=buildTargetURLfromUserIdentity(userIdentity);window.location.href=targetURLHref;case 18:if(!(action.payload.metadata==="refresh"||action.payload.metadata===undefined)){_context2.next=21;break;}_context2.next=21;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_5_state_app_actions__["H" /* fetchAvailableProducts */]());case 21:_context2.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_5_state_app_actions__["P" /* openLoadingFrame */]());case 23:case"end":return _context2.stop();}}},_marked2,this);}function processGooglePayResponseSaga(paymentResponse){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function processGooglePayResponseSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:paymentResponse=JSON.parse(paymentResponse.payload.response);_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_8_state_school_money_actions__["_85" /* processSecureTradingPaymentResponse */])({errorcode:paymentResponse.paymentResponse==="success"?"0":paymentResponse.errorDescription,errormessage:"",jwt:paymentResponse.jwt}));case 3:case"end":return _context3.stop();}}},_marked3,this);}

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = getSchoolByID;
/* harmony export (immutable) */ __webpack_exports__["f"] = getSchoolByStudentID;
/* harmony export (immutable) */ __webpack_exports__["r"] = paymentProvider;
/* harmony export (immutable) */ __webpack_exports__["m"] = isDinnersEnabled;
/* harmony export (immutable) */ __webpack_exports__["k"] = isClubTopUpsEnabled;
/* harmony export (immutable) */ __webpack_exports__["a"] = getClubTopUpDefaultAmount;
/* harmony export (immutable) */ __webpack_exports__["l"] = isDinnerTopUpsEnabled;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDinnerTopUpDefaultAmount;
/* harmony export (immutable) */ __webpack_exports__["g"] = getSchoolIDList;
/* harmony export (immutable) */ __webpack_exports__["h"] = getSchoolList;
/* harmony export (immutable) */ __webpack_exports__["p"] = isSchoolsReady;
/* harmony export (immutable) */ __webpack_exports__["i"] = getSchoolSortByKey;
/* harmony export (immutable) */ __webpack_exports__["c"] = getExternalCashlessName;
/* harmony export (immutable) */ __webpack_exports__["q"] = isXodActive;
/* harmony export (immutable) */ __webpack_exports__["n"] = isExternalTopUpEnabled;
/* harmony export (immutable) */ __webpack_exports__["d"] = getMinimumPaymentAmount;
/* harmony export (immutable) */ __webpack_exports__["j"] = isApplePayEnabledForSchool;
/* harmony export (immutable) */ __webpack_exports__["o"] = isGooglePayEnabledForSchool;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors__ = __webpack_require__(2);
/**
 * @returns {Immutable.Map}
 */function getSchoolByID(state,schoolID){return state.getIn(["school_money","schools",schoolID]);}/**
 * @returns {Immutable.Map}
 */function getSchoolByStudentID(state,studentID){return getSchoolByID(state,Object(__WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors__["_56" /* getStudentSchoolID */])(state,studentID));}/**
 * Get the payment provider that we will use (ps - paysafe | st - secure trading)
 * @returns {char(2)}
 */function paymentProvider(state,schoolID){return getSchoolByID(state,schoolID).paymentProvider;}/**
 * @returns {boolean}
 */function isDinnersEnabled(state,schoolID){return getSchoolByID(state,schoolID).isDinnersEnabled;}/**
 * @returns {boolean}
 */function isClubTopUpsEnabled(state,schoolID){return getSchoolByID(state,schoolID).isClubTopUpsEnabled;}/**
 * @returns {money}
 */function getClubTopUpDefaultAmount(state,schoolID){return getSchoolByID(state,schoolID).defaultClubTopUpAmount;}/**
 * @returns {boolean}
 */function isDinnerTopUpsEnabled(state,schoolID){return getSchoolByID(state,schoolID).isDinnerTopUpsEnabled;}/**
 * @returns {money}
 */function getDinnerTopUpDefaultAmount(state,schoolID){return getSchoolByID(state,schoolID).get("defaultDinnerTopUpAmount");}/**
 * @returns {Immutable.List}
 */function getSchoolIDList(state){return state.getIn(["school_money","schools"]).keySeq().toList();}/**
 * @returns {Immutable.List}
 */function getSchoolList(state){return state.getIn(["school_money","schools"]).sortBy(function(school){return school.get("name");}).toList();}/**
 * @returns {boolean}
 */function isSchoolsReady(state){return!state.getIn(["school_money","isSchoolsLoading"]);}/**
 * Get the key by which we should sort schools.
 * @returns {string}
 */function getSchoolSortByKey(state,schoolID){var school=getSchoolByID(state,schoolID);if(school){return school.name;}}/**
 * @returns {string}
 */function getExternalCashlessName(state,schoolID){return getSchoolByID(state,schoolID).get("externalCashlessName");}/**
 * @returns {boolean}
 */function isXodActive(state,schoolID){return getSchoolByID(state,schoolID).get("isXodActive");}/**
 * @returns {boolean}
 */function isExternalTopUpEnabled(state,schoolID){return getSchoolByID(state,schoolID).get("isExternalTopUpEnabled");}/**
 * @returns {money}
 */function getMinimumPaymentAmount(state,schoolID){return getSchoolByID(state,schoolID).get("minimumPaymentAmount");}/**
 * @returns {boolean}
 */function isApplePayEnabledForSchool(state,schoolID){return getSchoolByID(state,schoolID).get("isApplePayEnabled");}/**
 * @returns {boolean}
 */function isGooglePayEnabledForSchool(state,schoolID){return getSchoolByID(state,schoolID).get("isGooglePayEnabled");}

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = getStudentByID;
/* harmony export (immutable) */ __webpack_exports__["m"] = getStudentSchoolID;
/* unused harmony export getStudentList */
/* harmony export (immutable) */ __webpack_exports__["k"] = getStudentIDList;
/* harmony export (immutable) */ __webpack_exports__["g"] = getSchoolStudentIDList;
/* harmony export (immutable) */ __webpack_exports__["c"] = doesStudentExist;
/* unused harmony export getStudentCurrentCreditAmount */
/* harmony export (immutable) */ __webpack_exports__["p"] = getStudentTotalCreditAmountToPay;
/* harmony export (immutable) */ __webpack_exports__["o"] = getStudentTotalCreditAmount;
/* harmony export (immutable) */ __webpack_exports__["f"] = getLastStudentID;
/* harmony export (immutable) */ __webpack_exports__["q"] = isStudentsReady;
/* harmony export (immutable) */ __webpack_exports__["l"] = getStudentRemoteParentID;
/* harmony export (immutable) */ __webpack_exports__["n"] = getStudentSortByKey;
/* unused harmony export getStudentTopUp */
/* harmony export (immutable) */ __webpack_exports__["b"] = canStudentDoDinnerTopUp;
/* harmony export (immutable) */ __webpack_exports__["a"] = canStudentDoClubTopUp;
/* unused harmony export getStudentExternalCashless */
/* harmony export (immutable) */ __webpack_exports__["j"] = getStudentExternalDinnerBalance;
/* harmony export (immutable) */ __webpack_exports__["e"] = doesStudentUseExternalCashless;
/* harmony export (immutable) */ __webpack_exports__["d"] = doesStudentHasMisId;
/* harmony export (immutable) */ __webpack_exports__["h"] = getServerIDForStudent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_money__ = __webpack_require__(17);
/**
 * @returns {Immutable.Map}
 */function getStudentByID(state,studentID){return state.getIn(["school_money","students",studentID]);}/**
 * @returns {string}
 */function getStudentSchoolID(state,studentID){return getStudentByID(state,studentID).get("schoolID");}/**
 * @returns {Immutable.List}
 */function getStudentList(state){return state.getIn(["school_money","students"]).toList()// sort primarily by school, then by student name within that
// (counter-intuitive that we have to do the second part first)
.sortBy(function(student){return getStudentSortByKey(state,student.id);}).sortBy(function(student){return Object(__WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors__["_33" /* getSchoolSortByKey */])(state,student.schoolID);});}/**
 * @returns {Immutable.List}
 */function getStudentIDList(state){var studentList=getStudentList(state);return studentList.map(function(student){return student.get("id");});}/**
 * @returns {Immutable.List}
 */function getSchoolStudentIDList(state,schoolID){var studentList=getStudentList(state);return studentList.filter(function(student){return student.get("schoolID")===schoolID;}).map(function(student){return student.get("id");});}/**
 * @returns {boolean}
 */function doesStudentExist(state,studentID){return state.getIn(["school_money","students"]).has(studentID);}/**
 * @returns {number}
 */function getStudentCurrentCreditAmount(state,studentID,type){// if there is no credit for the gievn record it's probably because they don't have any
return getStudentByID(state,studentID).get("credits").get(type,0);}/**
 * @returns {number}
 */function getStudentTotalCreditAmountToPay(state,studentID,type){var overdueType=type==="dinner_money"?"dinner_money_overdue":"club_extended_services_overdue";return getStudentCurrentCreditAmount(state,studentID,type)+getStudentCurrentCreditAmount(state,studentID,overdueType);}/**
 * @returns {number}
 */function getStudentTotalCreditAmount(state,studentID,type){var offlineClubExtendedServicesOverdue=type==="club_extended_services"?getStudentByID(state,studentID).get("credits").get("offline_club_extended_services_overdue",0):0;return getStudentByID(state,studentID).get("credits").get(type,0)+offlineClubExtendedServicesOverdue;}/**
 * @returns {string}
 */function getLastStudentID(state){var studentIDList=getStudentIDList(state);var lastStudentID=state.getIn(["school_money","lastStudentID"]);// fall back to the first student if lastStudentID is not set
return lastStudentID||studentIDList.first();}/**
 * @returns {boolean}
 */function isStudentsReady(state){return!state.getIn(["school_money","isStudentsLoading"]);}/**
 * @returns {number}
 */function getStudentRemoteParentID(state,studentID){var student=getStudentByID(state,studentID);return student.appserverReferenceEntityID;}/**
 * Get the key by which we should sort students.
 * @returns {string}
 */function getStudentSortByKey(state,studentID){var student=getStudentByID(state,studentID);if(student){return student.firstName+" "+student.lastName;}}/**
  * @returns {boolean}
*/function getStudentTopUp(state,studentID,type){return getStudentByID(state,studentID).get("top_up").get(type,0);}/**
  * @returns {boolean}
*/function canStudentDoDinnerTopUp(state,studentID){return getStudentTopUp(state,studentID,"enable_dinner_top_up");}/**
  * @returns {boolean}
*/function canStudentDoClubTopUp(state,studentID){return getStudentTopUp(state,studentID,"enable_club_top_up");}/**
  * @returns {Immutable.Map}
*/function getStudentExternalCashless(state,studentID,type){return getStudentByID(state,studentID).get("external_cashless").get(type,0);}/**
   @returns {number}
*/function getStudentExternalDinnerBalance(state,studentID){var externalCashlessBalance=getStudentExternalCashless(state,studentID,"dinner_balance");return Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(externalCashlessBalance);}/**
   @returns {boolean}
*/function doesStudentUseExternalCashless(state,studentID){return getStudentExternalCashless(state,studentID,"is_external");}/**
 * @returns {boolean}
 */function doesStudentHasMisId(state,studentID){var studentMisId=getStudentByID(state,studentID).get("misId");return studentMisId!==undefined&&studentMisId!=="";}/**
 * @returns {string}
 */function getServerIDForStudent(state,studentID){var students=getStudentList(state);var student=students&&students.find(function(student){return student.get("remoteID")===Number(studentID);});return student?String(student.get("serverID")):undefined;}

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = getBasketItemsOfType;
/* harmony export (immutable) */ __webpack_exports__["f"] = getBasketItems;
/* harmony export (immutable) */ __webpack_exports__["n"] = getSchoolBasketItems;
/* unused harmony export getStudentBasketItems */
/* unused harmony export getCollatedBasketItemList */
/* harmony export (immutable) */ __webpack_exports__["e"] = getBasketItemGroupList;
/* harmony export (immutable) */ __webpack_exports__["d"] = getBasketItemByID;
/* harmony export (immutable) */ __webpack_exports__["b"] = doesBasketItemExist;
/* harmony export (immutable) */ __webpack_exports__["c"] = doesBasketItemGroupExist;
/* harmony export (immutable) */ __webpack_exports__["q"] = getStudentsHavingBasketItems;
/* harmony export (immutable) */ __webpack_exports__["p"] = getSchoolsHavingBasketItems;
/* harmony export (immutable) */ __webpack_exports__["r"] = isBasketEmpty;
/* harmony export (immutable) */ __webpack_exports__["k"] = getBasketTotalQuantity;
/* unused harmony export getBasketItemPrice */
/* harmony export (immutable) */ __webpack_exports__["j"] = getBasketTotalPrice;
/* harmony export (immutable) */ __webpack_exports__["o"] = getSchoolBasketTotalToPay;
/* unused harmony export getBasketTotalToPay */
/* harmony export (immutable) */ __webpack_exports__["m"] = getCreditUsedInBasket;
/* harmony export (immutable) */ __webpack_exports__["l"] = getCreditTopUpAmount;
/* harmony export (immutable) */ __webpack_exports__["u"] = isSchoolBasketExpanded;
/* harmony export (immutable) */ __webpack_exports__["g"] = getBasketItemsIssuesByItemType;
/* unused harmony export getBasketItemsIssuesByReason */
/* harmony export (immutable) */ __webpack_exports__["t"] = isBasketItemsValidating;
/* harmony export (immutable) */ __webpack_exports__["s"] = isBasketItemsValid;
/* harmony export (immutable) */ __webpack_exports__["h"] = getBasketItemsIssuesByStudentAndReason;
/* harmony export (immutable) */ __webpack_exports__["a"] = basketHasDinnerBookingWithArrear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_exact_math__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_exact_math___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_exact_math__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/**
 * @returns {Immutable.Set}
 */function getBasketItemsOfType(state,itemType){return state.getIn(["school_money","basketItems",itemType],__WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map()).toSet();}/**
 * @returns {Immutable.Set}
 */function getBasketItems(state){return state.getIn(["school_money","basketItems"]).map(function(basketItemsByType){return basketItemsByType.toSet();}).flatten(1).toSet();}/**
 * @returns {Immutable.Set}
 */function getSchoolBasketItems(state,schoolID){var basketItems=getBasketItems(state);return basketItems.filter(function(basketItem){return basketItem.get("schoolID")===schoolID;});}/**
 * @returns {Immutable.Set}
 */function getStudentBasketItems(state,studentID){var basketItems=getBasketItems(state);return basketItems.filter(function(basketItem){return basketItem.get("studentID")===studentID;});}/**
 * @returns {Immutable.List}
 */function getCollatedBasketItemList(state,studentID){return state.getIn(["school_money","basketItems"]).map(function(basketItems){return basketItems.filter(function(basketItem){return basketItem.get("studentID")===studentID;}).groupBy(function(basketItem){return basketItem.get("groupID");});}).flatten(1).toList();}/**
 * basketItemGroup {
 *   type,
 *   schoolID,
 *   studentID,
 *   groupID,
 *   items: [ basketItem ],
 *   totalPrice
 * }
 *
 * @returns {Immutable.List}
 */function getBasketItemGroupList(state,studentID){var basketItemGroups=getCollatedBasketItemList(state,studentID);return basketItemGroups.map(function(basketItemGroup){var _basketItemGroup$firs=basketItemGroup.first().toObject(),type=_basketItemGroup$firs.type,groupID=_basketItemGroup$firs.groupID,schoolID=_basketItemGroup$firs.schoolID,studentID=_basketItemGroup$firs.studentID;var totalPrice=basketItemGroup.map(function(_,basketItemID){return getBasketItemPrice(state,type,basketItemID);}).reduce(function(totalPrice,itemPrice){return __WEBPACK_IMPORTED_MODULE_1_exact_math___default.a.add(totalPrice,itemPrice);},0);return __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map({type:type,groupID:groupID,schoolID:schoolID,studentID:studentID,items:basketItemGroup.toSet(),totalPrice:totalPrice});});}/**
 * @returns {Immutable.Map}
 */function getBasketItemByID(state,type,basketItemID){return state.getIn(["school_money","basketItems",type,basketItemID]);}/**
 * @returns {boolean}
 */function doesBasketItemExist(state,type,basketItemID){return getBasketItemByID(state,type,basketItemID)!==undefined;}/**
 * @return {boolean}
 */function doesBasketItemGroupExist(state,type,groupID){var basketItems=getBasketItemsOfType(state,type);return basketItems.some(function(basketItem){return basketItem.get("groupID")===groupID;});}/**
 * @returns {Immutable.Set}
 */function getStudentsHavingBasketItems(state,schoolID){var basketItems=getBasketItems(state);return basketItems.filter(function(basketItem){return basketItem.get("schoolID")===schoolID;}).map(function(basketItem){return basketItem.get("studentID");}).sortBy(function(studentID){return Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_57" /* getStudentSortByKey */])(state,studentID);});}/**
 * @returns {Immutable.Set}
 */function getSchoolsHavingBasketItems(state){var basketItems=getBasketItems(state);return basketItems.map(function(basketItem){return basketItem.get("schoolID");}).sortBy(function(schoolID){return Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_33" /* getSchoolSortByKey */])(state,schoolID);});}/**
 * @returns {boolean}
 */function isBasketEmpty(state){var basketItems=getBasketItems(state);return basketItems.size===0;}/**
 * @returns {number}
 */function getBasketTotalQuantity(state){var basketItems=getBasketItems(state);return basketItems.toList().map(function(basketItem){return basketItem.get("quantity");}).reduce(function(totalQuantity,quantity){return totalQuantity+quantity;},0);}/**
 * @returns {number}
 */function getBasketItemPrice(state,type,basketItemID){var basketItem=getBasketItemByID(state,type,basketItemID);return basketItem.get("price");}/**
 * Calculate total basket price for given student, not considering credit
 * @returns {number}
 */function getStudentBasketTotalPrice(state,studentID){var basketItems=getStudentBasketItems(state,studentID);return basketItems.toList().map(function(basketItem){return getBasketItemPrice(state,basketItem.get("type"),basketItem.get("basketItemID"));}).reduce(function(totalPrice,itemPrice){return __WEBPACK_IMPORTED_MODULE_1_exact_math___default.a.add(totalPrice,itemPrice);},0);}/**
 * Calculate total basket price for given school, not considering credit
 * @returns {number}
 */function getSchoolBasketTotalPrice(state,schoolID){var studentIDs=getStudentsHavingBasketItems(state,schoolID);return studentIDs.toList().map(function(studentID){return getStudentBasketTotalPrice(state,studentID);}).reduce(function(totalPrice,studentPrice){return __WEBPACK_IMPORTED_MODULE_1_exact_math___default.a.add(totalPrice,studentPrice);},0);}/**
 * Calculate total basket price for all schools, not considering credit
 * @returns {number}
 */function getBasketTotalPrice(state){var schoolIDs=getSchoolsHavingBasketItems(state);return schoolIDs.toList().map(function(schoolID){return getSchoolBasketTotalPrice(state,schoolID);}).reduce(function(totalPrice,schoolPrice){return __WEBPACK_IMPORTED_MODULE_1_exact_math___default.a.add(totalPrice,schoolPrice);},0);}/**
 * Calculate total price of the basket for a school, minus credit
 * @returns {number}
 */function getSchoolBasketTotalToPay(state,schoolID){var totalPrice=getSchoolBasketTotalPrice(state,schoolID);var creditUsed=getCreditUsedInBasket(state,schoolID);// subtract each credit used amount from the total price
var totalToPay=Object.values(creditUsed).reduce(function(totalPrice,creditAmount){return __WEBPACK_IMPORTED_MODULE_1_exact_math___default.a.sub(totalPrice,creditAmount);},totalPrice);return totalToPay;}/**
 * Calculate total basket price across all schools, minus credit
 * @returns {number}
 */function getBasketTotalToPay(state){var schoolIDs=getSchoolsHavingBasketItems(state);return schoolIDs.map(function(schoolID){return getSchoolBasketTotalToPay(state,schoolID);}).reduce(function(totalPrice,schoolPrice){return __WEBPACK_IMPORTED_MODULE_1_exact_math___default.a.add(totalPrice,schoolPrice);},0);}/**
 * Get the credit used in the basket by the given student for the given payment type
 *
 * @param {string} paymentType "dinners" | "clubs"
 * @returns {number}
 */function getCreditUsedInBasketForType(state,schoolID,basketItemType,creditType){var studentIDs=getStudentsHavingBasketItems(state,schoolID);// get total price of basket items of the given type per student
var basketPriceByStudent=__WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map(studentIDs.map(function(studentID){var basketPrice=getStudentBasketItems(state,studentID).filter(function(basketItem){return basketItem.get("type")===basketItemType;}).map(function(basketItem){return getBasketItemPrice(state,basketItem.get("type"),basketItem.get("basketItemID"));}).reduce(function(totalPrice,itemPrice){return __WEBPACK_IMPORTED_MODULE_1_exact_math___default.a.add(totalPrice,itemPrice);},0);return[studentID,basketPrice];}));// get credit amount per student
var creditByStudent=__WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map(studentIDs.map(function(studentID){return[studentID,Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_59" /* getStudentTotalCreditAmountToPay */])(state,studentID,creditType)];}));// calculate credit used per student
var creditUsedByStudent=basketPriceByStudent.map(function(basketPrice,studentID){var studentCredit=creditByStudent.get(studentID);// used credit is basket price capped at available credit
// treat negative credit amounts as 0
return Math.min(basketPrice,Math.max(0,studentCredit));});// sum the student totals
return creditUsedByStudent.reduce(function(totalAmount,studentAmount){return __WEBPACK_IMPORTED_MODULE_1_exact_math___default.a.add(totalAmount,studentAmount);},0);}/**
 * @returns {Object<string,number>} map of payment type to credit used
 */function getCreditUsedInBasket(state,schoolID){return{dinners:getCreditUsedInBasketForType(state,schoolID,"dinnerBooking","dinner_money"),clubs:getCreditUsedInBasketForType(state,schoolID,"clubBooking","club_extended_services"),external_top_up:getCreditUsedInBasketForType(state,schoolID,"dinnerBooking","external_top_up")};}/**
 * @returns {number}
 */function getCreditTopUpAmount(state,studentID,creditType){var basketItems=getBasketItemsOfType(state,"creditTopUp");var basketItem=basketItems.find(function(basketItem){var payload=basketItem.get("payload").toObject();return payload.studentID===studentID&&payload.creditType===creditType;});if(basketItem===undefined){return 0;}return basketItem.get("price");}/**
 * @returns {boolean}
 */function isSchoolBasketExpanded(state,schoolID){return state.getIn(["school_money","expandedSchoolBasketID"])===schoolID;}/**
 * @returns {Immutable.List}
 */function getBasketItemsIssuesByItemType(state){return state.getIn(["school_money","basketItemsIssues"]).groupBy(function(issue){return issue.get("itemType");});}/**
 * @returns {Immutable.List}
 */function getBasketItemsIssuesByReason(state){return state.getIn(["school_money","basketItemsIssues"]).groupBy(function(issue){return issue.get("reason");});}/**
 * @returns {boolean}
 */function isBasketItemsValidating(state){return state.getIn(["school_money","basketItemsIssues"])===null;}/**
 * @returns {boolean}
 */function isBasketItemsValid(state){var isValidating=isBasketItemsValidating(state);var basketItemsIssues=state.getIn(["school_money","basketItemsIssues"]);return!isValidating&&basketItemsIssues.size===0;}function getBasketItemsIssuesByStudentAndReason(state){return state.getIn(["school_money","basketItemsIssues"]).groupBy(function(issue){var _issue$toObject=issue.toObject(),itemType=_issue$toObject.itemType,basketItemID=_issue$toObject.basketItemID;var basketItem=getBasketItemByID(state,itemType,basketItemID);return basketItem.get("studentID");}).map(function(group){return group.groupBy(function(issue){return issue.get("reason");});});}/**
 * @returns {boolean}
 */function basketHasDinnerBookingWithArrear(state,schoolID){var basketItems=getBasketItems(state);return basketItems.filter(function(basketItem){return basketItem.get("schoolID")===schoolID;}).filter(function(basketItem){return basketItem.get("type")==="dinnerBooking";}).filter(function(basketItem){return Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_58" /* getStudentTotalCreditAmount */])(state,basketItem.get("studentID"),"dinner_money")<0;}).toList().size>0;}

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = getDinnerBookingIDList;
/* harmony export (immutable) */ __webpack_exports__["a"] = doesDinnerBookingExist;
/* unused harmony export getSchoolDinnerBookingIDList */
/* harmony export (immutable) */ __webpack_exports__["p"] = getStudentDinnerBookingIDList;
/* harmony export (immutable) */ __webpack_exports__["f"] = getDinnerBookingByID;
/* harmony export (immutable) */ __webpack_exports__["s"] = isDinnerBookingCashless;
/* unused harmony export getDinnerBookingTotalPaid */
/* unused harmony export getDinnerBookingBookedOption */
/* harmony export (immutable) */ __webpack_exports__["i"] = getDinnerBookingOptionList;
/* unused harmony export getDinnerBookingOption */
/* harmony export (immutable) */ __webpack_exports__["l"] = getDinnerBookingSelectedOptionIDList;
/* harmony export (immutable) */ __webpack_exports__["k"] = getDinnerBookingSelectedOptionID;
/* harmony export (immutable) */ __webpack_exports__["j"] = getDinnerBookingSelectedOption;
/* harmony export (immutable) */ __webpack_exports__["m"] = getDinnerBookingTotalPrice;
/* harmony export (immutable) */ __webpack_exports__["e"] = getDinnerBookingBasketPrice;
/* harmony export (immutable) */ __webpack_exports__["d"] = getDinnerBookingAllergyInformation;
/* unused harmony export doesDinnerBookingHaveAllergyInformation */
/* unused harmony export isDinnerBookingDayFSMEligible */
/* harmony export (immutable) */ __webpack_exports__["c"] = doesDinnerBookingHaveFSMEligibility;
/* harmony export (immutable) */ __webpack_exports__["u"] = isDinnerBookingDayHoliday;
/* harmony export (immutable) */ __webpack_exports__["q"] = hasDinnerBookingBeenModified;
/* harmony export (immutable) */ __webpack_exports__["y"] = isDinnersReady;
/* harmony export (immutable) */ __webpack_exports__["r"] = isAllergiesWarningEnabled;
/* harmony export (immutable) */ __webpack_exports__["v"] = isDinnerBookingExpanded;
/* harmony export (immutable) */ __webpack_exports__["w"] = isDinnerBookingInBasket;
/* harmony export (immutable) */ __webpack_exports__["x"] = isDinnerBookingSeen;
/* harmony export (immutable) */ __webpack_exports__["o"] = getNewDinnerBookingCount;
/* harmony export (immutable) */ __webpack_exports__["n"] = getGoToDinnerBookingID;
/* harmony export (immutable) */ __webpack_exports__["g"] = getDinnerBookingDayDate;
/* harmony export (immutable) */ __webpack_exports__["t"] = isDinnerBookingDayExpired;
/* harmony export (immutable) */ __webpack_exports__["b"] = doesDinnerBookingHaveBookings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_exact_math__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_exact_math___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_exact_math__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_date__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/**
 * @returns {Immutable.List}
 */function getDinnerBookingIDList(state){return state.getIn(["school_money","dinnerBookings"]).keySeq().toList();}/**
 * @returns {boolean}
 */function doesDinnerBookingExist(state,dinnerBookingID){return getDinnerBookingIDList(state).includes(dinnerBookingID);}/**
 * @returns {Immutable.List}
 */function getSchoolDinnerBookingIDList(state,schoolID){return state.getIn(["school_money","dinnerBookings"]).filter(function(dinnerBooking){return dinnerBooking.get("schoolID")===schoolID;}).sortBy(function(dinnerBooking){return dinnerBooking.get("startDate");}).keySeq().toList();}/**
 * @returns {Immutable.List}
 */function getStudentDinnerBookingIDList(state,studentID){return state.getIn(["school_money","dinnerBookings"]).filter(function(dinnerBooking){return dinnerBooking.get("studentID")===studentID;}).sortBy(function(dinnerBooking){return dinnerBooking.get("startDate");}).keySeq().toList();}/**
 * @returns {Immutable.Map}
 */function getDinnerBookingByID(state,dinnerBookingID){return state.getIn(["school_money","dinnerBookings",dinnerBookingID]);}/**
 * @returns {boolean}
 */function isDinnerBookingCashless(state,dinnerBookingID){var dinnerBooking=getDinnerBookingByID(state,dinnerBookingID);return dinnerBooking.get("isCashless");}/**
 * @returns {number}
 */function getDinnerBookingTotalPaid(state,dinnerBookingID){var dinnerBooking=getDinnerBookingByID(state,dinnerBookingID);return dinnerBooking.get("totalPaid");}/**
 * @returns {Immutable.Map}
 */function getDinnerBookingBookedOption(state,dinnerBookingID,weekdayIndex){var dinnerBooking=getDinnerBookingByID(state,dinnerBookingID);return dinnerBooking.getIn(["bookedOptions",weekdayIndex]);}/**
 * Get the list of options available for a dinner booking day
 * @returns {Immutable.List}
 */function getDinnerBookingOptionList(state,dinnerBookingID,weekdayIndex){var dinnerBooking=getDinnerBookingByID(state,dinnerBookingID);var availableOptions=dinnerBooking.getIn(["availableOptions",weekdayIndex]);var bookedOption=getDinnerBookingBookedOption(state,dinnerBookingID,weekdayIndex);// if an optionis already booked, use the version that was booked
// this ensure that price changes do not affect existing bookings
return availableOptions.map(function(option){var isBooked=option.get("id")===bookedOption.get("id");return isBooked?bookedOption:option;});}/**
 * Get the details of the dinner option with the given ID for a dinner booking day
 * @returns {(Immutable.Map|null)}
 */function getDinnerBookingOption(state,dinnerBookingID,weekdayIndex,optionID){var optionList=getDinnerBookingOptionList(state,dinnerBookingID,weekdayIndex);var option=optionList.find(function(option){return option.id===optionID;});return option||null;}/**
 * @returns {Immutable.List}
 */function getDinnerBookingSelectedOptionIDList(state,dinnerBookingID,weekdayIndex){var isInBasket=isDinnerBookingInBasket(state,dinnerBookingID);if(isInBasket){var basketItem=Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["t" /* getBasketItemByID */])(state,"dinnerBooking",dinnerBookingID);return basketItem.payload.get("optionIDs");}else{var dinnerBooking=getDinnerBookingByID(state,dinnerBookingID);return dinnerBooking.selectedOptionIDs;}}/**
 * @returns {string}
 */function getDinnerBookingSelectedOptionID(state,dinnerBookingID,weekdayIndex){var optionIDs=getDinnerBookingSelectedOptionIDList(state,dinnerBookingID);return optionIDs.get(weekdayIndex);}/**
 * Get the selected option for a dinner booking day
 * @returns {Immutable.Map}
 */function getDinnerBookingSelectedOption(state,dinnerBookingID,weekdayIndex){var selectedOptionID=getDinnerBookingSelectedOptionID(state,dinnerBookingID,weekdayIndex);return getDinnerBookingOption(state,dinnerBookingID,weekdayIndex,selectedOptionID);}/**
 * Get a list of the options selected per day for a dinner booking
 * @returns {Array<Immutable.Map>}
 */function getDinnerBookingSelectedOptions(state,dinnerBookingID){return __WEBPACK_IMPORTED_MODULE_1_lib_date__["a" /* WEEKDAYS */].map(function(_,weekdayIndex){return getDinnerBookingSelectedOption(state,dinnerBookingID,weekdayIndex);});}/**
 * Get the total price of all selections in a dinner booking
 * @returns {number}
 */function getDinnerBookingTotalPrice(state,dinnerBookingID){return getDinnerBookingSelectedOptions(state,dinnerBookingID).filter(function(option){return option!==null;}).map(function(option){return option.price;}).reduce(function(totalPrice,optionPrice){return __WEBPACK_IMPORTED_MODULE_0_exact_math___default.a.add(totalPrice,optionPrice);},0);}/**
 * Get the "to pay" price of a dinner booking
 * This is basically the total price minus anything already paid
 * @returns {number}
 */function getDinnerBookingBasketPrice(state,dinnerBookingID){var totalPrice=getDinnerBookingTotalPrice(state,dinnerBookingID);var totalPaid=getDinnerBookingTotalPaid(state,dinnerBookingID);return Math.max(0,__WEBPACK_IMPORTED_MODULE_0_exact_math___default.a.sub(totalPrice,totalPaid));}/**
 * Get the per-day allergy information for the selected options in a dinner booking
 * @returns {Array<string>}
 */function getDinnerBookingAllergyInformation(state,dinnerBookingID){return getDinnerBookingSelectedOptions(state,dinnerBookingID).map(function(option){if(option===null){return"";}return option.get("allergyInformation","");});}/**
 * @returns {boolean}
 */function doesDinnerBookingHaveAllergyInformation(state,dinnerBookingID){return getDinnerBookingAllergyInformation(state,dinnerBookingID).some(function(allergyInformation){return allergyInformation!=="";});}/**
 * @returns {boolean}
 */function isDinnerBookingDayFSMEligible(state,dinnerBookingID,weekdayIndex){var dinnerBooking=getDinnerBookingByID(state,dinnerBookingID);return dinnerBooking.fsmEligibility.get(weekdayIndex);}/**
 * @returns {boolean}
 */function doesDinnerBookingHaveFSMEligibility(state,dinnerBookingID){return __WEBPACK_IMPORTED_MODULE_1_lib_date__["a" /* WEEKDAYS */].some(function(_,weekdayIndex){return isDinnerBookingDayFSMEligible(state,dinnerBookingID,weekdayIndex);});}/**
 * @returns {boolean}
 */function isDinnerBookingDayHoliday(state,dinnerBookingID,weekdayIndex){var dinnerBooking=getDinnerBookingByID(state,dinnerBookingID);return dinnerBooking.getIn(["holidays",weekdayIndex]);}/**
 * Has the dinner booking had it's selections changed from what is on the server?
 * @returns {boolean}
 */function hasDinnerBookingBeenModified(state,dinnerBookingID){return __WEBPACK_IMPORTED_MODULE_1_lib_date__["a" /* WEEKDAYS */].some(function(_,weekdayIndex){var selectedOptionID=getDinnerBookingSelectedOptionID(state,dinnerBookingID,weekdayIndex);var bookedOption=getDinnerBookingBookedOption(state,dinnerBookingID,weekdayIndex);return selectedOptionID!==bookedOption.get("id");});}/**
 * @returns {boolean}
 */function isDinnersReady(state){return!state.getIn(["school_money","isActivePaymentsLoading"]);}/**
 * @returns {boolean}
 */function isAllergiesWarningEnabled(state){return state.getIn(["school_money","isAllergiesWarningEnabled"]);}/**
 * @returns {boolean}
 */function isDinnerBookingExpanded(state,dinnerBookingID){return state.getIn(["school_money","expandedDinnerBookingID"])===dinnerBookingID;}/**
 * @returns {boolean}
 */function isDinnerBookingInBasket(state,dinnerBookingID){return Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["e" /* doesBasketItemExist */])(state,"dinnerBooking",dinnerBookingID);}/**
 * @returns {boolean}
 */function isDinnerBookingSeen(state,dinnerBookingID){return state.getIn(["school_money","seenDinnerBookingIDs"]).includes(dinnerBookingID);}/**
 * @returns {number}
 */function getNewDinnerBookingCount(state){// filter out schools that don't use dinner bookings
var schoolIDList=Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_31" /* getSchoolIDList */])(state).filter(function(schoolID){return Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_89" /* isDinnersEnabled */])(state,schoolID);}).filterNot(function(schoolID){return Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_88" /* isDinnerTopUpsEnabled */])(state,schoolID);});return schoolIDList.map(function(schoolID){return getSchoolDinnerBookingIDList(state,schoolID);}).flatten(1).filterNot(function(dinnerBookingID){return isDinnerBookingSeen(state,dinnerBookingID);}).count();}/**
 * @returns {string}
 */function getGoToDinnerBookingID(state){return state.getIn(["school_money","goToDinnerBookingID"]);}/**
 * @returns {date}
 */function getDinnerBookingDayDate(state,dinnerBookingID,weekdayIndex){var dinnerBooking=getDinnerBookingByID(state,dinnerBookingID);return dinnerBooking.dates.get(weekdayIndex);}/**
 * @returns {boolean}
 */function isDinnerBookingDayExpired(state,dinnerBookingID,weekdayIndex){var dinnerBooking=getDinnerBookingByID(state,dinnerBookingID);return dinnerBooking.expired.get(weekdayIndex);}/**
 * @returns {boolean}
 */function doesDinnerBookingHaveBookings(state,dinnerBookingID){var dinnerBooking=getDinnerBookingByID(state,dinnerBookingID);return dinnerBooking.bookedOptions.some(function(_ref){var id=_ref.id;return id!==-1&&id!=="NONE"&&id!=="";});}

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = getShopItemIDList;
/* harmony export (immutable) */ __webpack_exports__["a"] = doesShopItemExist;
/* harmony export (immutable) */ __webpack_exports__["f"] = getShopItemByID;
/* harmony export (immutable) */ __webpack_exports__["i"] = getShopItemSearchQuery;
/* harmony export (immutable) */ __webpack_exports__["b"] = getFilteredShopItemIDList;
/* unused harmony export getShopItemBasketItem */
/* harmony export (immutable) */ __webpack_exports__["e"] = getShopItemBasketQuantity;
/* harmony export (immutable) */ __webpack_exports__["h"] = getShopItemMaxBasketQuantity;
/* harmony export (immutable) */ __webpack_exports__["j"] = isShopItemSeen;
/* harmony export (immutable) */ __webpack_exports__["d"] = getNewShopItems;
/* harmony export (immutable) */ __webpack_exports__["k"] = isShopReady;
/* harmony export (immutable) */ __webpack_exports__["c"] = getGoToShopItemID;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_text__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_school_money_entities_ShopItem__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
function getShopItemIDList(state){return state.getIn(["school_money","shopItems"]).keySeq().toList();}/**
 * @returns {boolean}
 */function doesShopItemExist(state,shopItemID){return getShopItemIDList(state).includes(shopItemID);}function getShopItemByID(state,shopItemID){return state.getIn(["school_money","shopItems",shopItemID]);}function getShopItemSearchQuery(state){return state.getIn(["school_money","shopItemSearchQuery"]);}function getFilteredShopItemIDList(state,studentID){var schoolID=Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_48" /* getStudentByID */])(state,studentID).get("schoolID");var searchQuery=getShopItemSearchQuery(state);return state.getIn(["school_money","shopItems"]).filter(function(shopItem){return shopItem.get("schoolID")===schoolID;}).filter(function(shopItem){return Object(__WEBPACK_IMPORTED_MODULE_0_lib_text__["c" /* search */])(shopItem.get("name"),searchQuery);}).filter(function(shopItem){return shopItem.get("quantity")>0;}).sortBy(function(shopItem){return shopItem.get("name");}).keySeq().toList();}function getShopItemBasketItem(state,shopItemID,studentID){var basketItems=Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["y" /* getBasketItemsOfType */])(state,"shopItem");return basketItems.find(function(basketItem){var payload=basketItem.get("payload").toObject();return payload.studentID===studentID&&payload.shopItemID===shopItemID;});}function getShopItemBasketQuantity(state,shopItemID,studentID){var basketItem=getShopItemBasketItem(state,shopItemID,studentID);if(basketItem===undefined){return 0;}return basketItem.getIn(["payload","quantity"],0);}function getShopItemMaxBasketQuantity(state,shopItemID){var shopItem=getShopItemByID(state,shopItemID);return Math.min(shopItem.quantity,__WEBPACK_IMPORTED_MODULE_1_state_school_money_entities_ShopItem__["a" /* default */].MAX_BASKET_QUANTITY);}function isShopItemSeen(state,shopItemID){return state.getIn(["school_money","seenShopItemIDs"]).includes(shopItemID);}/**
 * Get shop items that haven't yet been seen (for home page)
 * @returns {Immutable.List}
 */function getNewShopItems(state,count){var shopItemIDList=getShopItemIDList(state);return shopItemIDList.filterNot(function(shopItemID){return isShopItemSeen(state,shopItemID);}).map(function(shopItemID){return getShopItemByID(state,shopItemID);}).filter(function(shopItem){return shopItem.get("quantity")>0;}).take(count);}function isShopReady(state){return!state.getIn(["school_money","isShopLoading"]);}function getGoToShopItemID(state){return state.getIn(["school_money","goToShopItemID"]);}

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAllHistoryItems;
/* unused harmony export getHistoryItemsByType */
/* unused harmony export getHistoryItemList */
/* harmony export (immutable) */ __webpack_exports__["b"] = isHistoryReady;
function getAllHistoryItems(state){return state.getIn(["school_money","history"]);}function getHistoryItemsByType(state,type){return state.getIn(["school_money","history",type]);}function getSortByFieldByHistoryType(historyType){switch(historyType){case"payment":return"paidDate";case"dinner":return"startDate";case"club":return"startDate";case"meal":return"date";default:return"id";}}/**
 * @returns {Immutable.List}
 */function getHistoryItemList(state,type,studentID){// we sort on a different property for each history type
var sortByField=getSortByFieldByHistoryType(type);return state.getIn(["school_money","history",type]).filter(function(historyItem){return historyItem.get("studentID")===studentID;}).sortBy(function(historyItem){return historyItem.get(sortByField);}).valueSeq().toList();}/**
 * @returns {boolean}
 */function isHistoryReady(state,studentID){return!state.getIn(["school_money","isHistoryLoading"]);}

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = getClubBookingIDList;
/* harmony export (immutable) */ __webpack_exports__["a"] = doesClubBookingExist;
/* harmony export (immutable) */ __webpack_exports__["o"] = getStudentClubBookingIDList;
/* harmony export (immutable) */ __webpack_exports__["e"] = getClubBookingByID;
/* harmony export (immutable) */ __webpack_exports__["k"] = getClubBookingSessionList;
/* unused harmony export getClubBookingBookedSessionID */
/* harmony export (immutable) */ __webpack_exports__["q"] = isClubBookingDayBooked;
/* harmony export (immutable) */ __webpack_exports__["j"] = getClubBookingSelectedSessionIDList;
/* unused harmony export getClubBookingSelectedSessionID */
/* unused harmony export getClubBookingSession */
/* harmony export (immutable) */ __webpack_exports__["i"] = getClubBookingSelectedSession;
/* harmony export (immutable) */ __webpack_exports__["l"] = getClubBookingTotalPrice;
/* harmony export (immutable) */ __webpack_exports__["d"] = getClubBookingBasketPrice;
/* harmony export (immutable) */ __webpack_exports__["p"] = hasClubBookingBeenModified;
/* harmony export (immutable) */ __webpack_exports__["v"] = isClubBookingInBasket;
/* harmony export (immutable) */ __webpack_exports__["t"] = isClubBookingDayHoliday;
/* unused harmony export doesClubBookingHaveLimitedPlaces */
/* harmony export (immutable) */ __webpack_exports__["s"] = isClubBookingDayFull;
/* harmony export (immutable) */ __webpack_exports__["u"] = isClubBookingExpanded;
/* harmony export (immutable) */ __webpack_exports__["x"] = isClubBookingSeen;
/* harmony export (immutable) */ __webpack_exports__["n"] = getNewClubBookingCount;
/* harmony export (immutable) */ __webpack_exports__["y"] = isClubsReady;
/* harmony export (immutable) */ __webpack_exports__["m"] = getGoToClubBookingID;
/* harmony export (immutable) */ __webpack_exports__["f"] = getClubBookingDayDate;
/* harmony export (immutable) */ __webpack_exports__["r"] = isClubBookingDayExpired;
/* harmony export (immutable) */ __webpack_exports__["h"] = getClubBookingLimitedPlacesDetails;
/* harmony export (immutable) */ __webpack_exports__["b"] = doesClubBookingHaveBookings;
/* harmony export (immutable) */ __webpack_exports__["w"] = isClubBookingReserved;
/* harmony export (immutable) */ __webpack_exports__["c"] = forceClubBookingForStudent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_exact_math__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_exact_math___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_exact_math__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_date__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/**
 * @returns {Immutable.List}
 */function getClubBookingIDList(state){return state.getIn(["school_money","clubBookings"]).keySeq().toList();}/**
 * @returns {boolean}
 */function doesClubBookingExist(state,clubBookingID){return getClubBookingIDList(state).includes(clubBookingID);}/**
 * @returns {Immutable.List}
 */function getStudentClubBookingIDList(state,studentID){return state.getIn(["school_money","clubBookings"]).filter(function(clubBooking){return clubBooking.placesLimitReached;}).filter(function(clubBooking){return clubBooking.studentID===studentID;}).sortBy(function(clubBooking){return clubBooking.startDate;}).keySeq().toList();}/**
 * @returns {Immutable.Map}
 */function getClubBookingByID(state,clubBookingID){return state.getIn(["school_money","clubBookings",clubBookingID]);}/**
 * @returns {Immutable.List}
 */function getClubBookingSessionList(state,clubBookingID){var clubBooking=getClubBookingByID(state,clubBookingID);return clubBooking.get("sessions").valueSeq().toList().map(function(session){return __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.fromJS({id:session.get("id"),name:session.get("id")+" - "+session.get("description"),price:session.get("price")});});}/**
 * @returns {string}
 */function getClubBookingBookedSessionID(state,clubBookingID,weekdayIndex){var clubBooking=getClubBookingByID(state,clubBookingID);return clubBooking.getIn(["bookedSessionIDs",weekdayIndex]);}/**
 * @returns {boolean}
 */function isClubBookingDayBooked(state,clubBookingID,weekdayIndex){var bookedSessionID=getClubBookingBookedSessionID(state,clubBookingID,weekdayIndex);return bookedSessionID!==null;}/**
 * @returns {Immutable.List}
 */function getClubBookingSelectedSessionIDList(state,clubBookingID){var isInBasket=isClubBookingInBasket(state,clubBookingID);if(isInBasket){var basketItem=Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["t" /* getBasketItemByID */])(state,"clubBooking",clubBookingID);return basketItem.payload.get("sessionIDs");}else{var clubBooking=getClubBookingByID(state,clubBookingID);return clubBooking.selectedSessionIDs;}}/**
 * @returns {string}
 */function getClubBookingSelectedSessionID(state,clubBookingID,weekdayIndex){var sessionIDList=getClubBookingSelectedSessionIDList(state,clubBookingID);return sessionIDList.get(weekdayIndex);}/**
 * @returns {Immutable.Map}
 */function getClubBookingSession(state,clubBookingID,sessionID){var clubBooking=getClubBookingByID(state,clubBookingID);return clubBooking.getIn(["sessions",sessionID]);}/**
 * @returns {Immutable.Map}
 */function getClubBookingSelectedSession(state,clubBookingID,weekdayIndex){var sessionID=getClubBookingSelectedSessionID(state,clubBookingID,weekdayIndex);return getClubBookingSession(state,clubBookingID,sessionID);}/**
 * @returns {number}
 */function getClubBookingTotalPrice(state,clubBookingID){return __WEBPACK_IMPORTED_MODULE_2_lib_date__["a" /* WEEKDAYS */].map(function(_,weekdayIndex){return getClubBookingSelectedSessionID(state,clubBookingID,weekdayIndex);}).filter(function(sessionID){return sessionID!==null;}).map(function(sessionID){return getClubBookingSession(state,clubBookingID,sessionID);}).map(function(session){return session.get("price");}).reduce(function(totalPrice,sessionPrice){return __WEBPACK_IMPORTED_MODULE_1_exact_math___default.a.add(totalPrice,sessionPrice);},0);}/**
 * Work out the price that needs to be paid towards this club booking.
 * Calculated as the difference between the total price of all selections,
 *   and the price of all selections that were already booked.
 * Then the outstanding amount is added on, to account for unpaid reservations.
 * Negative numbers are clipped to zero, and will be settled as credit by SM.
 * @returns {number}
 */function getClubBookingBasketPrice(state,clubBookingID){var _getClubBookingByID=getClubBookingByID(state,clubBookingID),outstandingAmount=_getClubBookingByID.outstandingAmount;var totalPrice=getClubBookingTotalPrice(state,clubBookingID);var bookedPrice=__WEBPACK_IMPORTED_MODULE_2_lib_date__["a" /* WEEKDAYS */].map(function(_,weekdayIndex){return getClubBookingBookedSessionID(state,clubBookingID,weekdayIndex);}).filter(function(sessionID){return sessionID!==null;}).map(function(sessionID){return getClubBookingSession(state,clubBookingID,sessionID);}).map(function(session){return session.get("price");}).reduce(function(totalPrice,sessionPrice){return __WEBPACK_IMPORTED_MODULE_1_exact_math___default.a.add(totalPrice,sessionPrice);},0);var basketPrice=__WEBPACK_IMPORTED_MODULE_1_exact_math___default.a.add(__WEBPACK_IMPORTED_MODULE_1_exact_math___default.a.sub(totalPrice,bookedPrice),outstandingAmount);return Math.max(0,basketPrice);}/**
 * @returns {boolean}
 */function hasClubBookingBeenModified(state,clubBookingID){return __WEBPACK_IMPORTED_MODULE_2_lib_date__["a" /* WEEKDAYS */].some(function(_,weekdayIndex){var bookedSessionID=getClubBookingBookedSessionID(state,clubBookingID,weekdayIndex);var selectedSessionID=getClubBookingSelectedSessionID(state,clubBookingID,weekdayIndex);return bookedSessionID!==selectedSessionID;});}/**
 * @returns {boolean}
 */function isClubBookingInBasket(state,clubBookingID){return Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["e" /* doesBasketItemExist */])(state,"clubBooking",clubBookingID);}/**
 * @returns {boolean}
 */function isClubBookingDayHoliday(state,clubBookingID,weekdayIndex){var clubBooking=getClubBookingByID(state,clubBookingID);return clubBooking.getIn(["holidays",weekdayIndex]);}/**
 * @returns {boolean}
 */function doesClubBookingHaveLimitedPlaces(state,clubBookingID){var clubBooking=getClubBookingByID(state,clubBookingID);return clubBooking.get("hasLimitedPlaces");}/**
 * @returns {boolean}
 */function isClubBookingDayFull(state,clubBookingID,weekdayIndex){if(!doesClubBookingHaveLimitedPlaces(state,clubBookingID)){return false;}var clubBooking=getClubBookingByID(state,clubBookingID);return clubBooking.getIn(["placesLimitReached",weekdayIndex]);}/**
 * @returns {boolean}
 */function isClubBookingExpanded(state,clubBookingID){return state.getIn(["school_money","expandedClubBookingID"])===clubBookingID;}/**
 * @returns {boolean}
 */function isClubBookingSeen(state,clubBookingID){return state.getIn(["school_money","seenClubBookingIDs"]).includes(clubBookingID);}/**
 * @returns {number}
 */function getNewClubBookingCount(state){var clubBookingIDList=getClubBookingIDList(state);return clubBookingIDList.filterNot(function(clubBookingID){return isClubBookingSeen(state,clubBookingID);}).count();}/**
 * @returns {boolean}
 */function isClubsReady(state){return!state.getIn(["school_money","isActivePaymentsLoading"]);}/**
 * @returns {string}
 */function getGoToClubBookingID(state){return state.getIn(["school_money","goToClubBookingID"]);}/**
 * @returns {date}
 */function getClubBookingDayDate(state,clubBookingID,weekdayIndex){var clubBooking=getClubBookingByID(state,clubBookingID);return clubBooking.dates.get(weekdayIndex);}/**
 * @returns {boolean}
 */function isClubBookingDayExpired(state,clubBookingID,weekdayIndex){var clubBooking=getClubBookingByID(state,clubBookingID);return clubBooking.expired.get(weekdayIndex);}function getClubBookingLimitedPlacesDetails(state,clubBookingID){var clubBooking=getClubBookingByID(state,clubBookingID);return{enabled:clubBooking.hasLimitedPlaces,total:clubBooking.dailyPlacesLimit};}/**
 * @returns {boolean}
 */function doesClubBookingHaveBookings(state,clubBookingID){var clubBooking=getClubBookingByID(state,clubBookingID);return clubBooking.bookedSessionIDs.some(function(sessionID){return sessionID!==null;});}/**
 * @returns {boolean}
 */function isClubBookingReserved(state,clubBookingID){var isBooked=doesClubBookingHaveBookings(state,clubBookingID);var _getClubBookingByID2=getClubBookingByID(state,clubBookingID),outstandingAmount=_getClubBookingByID2.outstandingAmount;return isBooked&&outstandingAmount>0;}/**
  * @returns {boolean}
*/function forceClubBookingForStudent(state,studentID){return state.getIn(["school_money","clubBookings"]).filter(function(clubBooking){return clubBooking.forceSessionBooking===true;}).filter(function(clubBooking){return clubBooking.studentID===studentID;}).keySeq().toList().size>0;}

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = getPaymentIDList;
/* unused harmony export isPaymentVisible */
/* unused harmony export getVisiblePaymentIDList */
/* harmony export (immutable) */ __webpack_exports__["a"] = doesPaymentExist;
/* harmony export (immutable) */ __webpack_exports__["k"] = getStudentPaymentIDList;
/* harmony export (immutable) */ __webpack_exports__["e"] = getPaymentByID;
/* harmony export (immutable) */ __webpack_exports__["j"] = getPaymentTotalOutstandingPrice;
/* harmony export (immutable) */ __webpack_exports__["g"] = getPaymentInstallment;
/* harmony export (immutable) */ __webpack_exports__["h"] = getPaymentInstallmentSelectedPrice;
/* harmony export (immutable) */ __webpack_exports__["o"] = isPaymentInstallmentOverdue;
/* harmony export (immutable) */ __webpack_exports__["q"] = isPaymentOverdue;
/* harmony export (immutable) */ __webpack_exports__["n"] = isPaymentInstallmentInBasket;
/* harmony export (immutable) */ __webpack_exports__["m"] = isPaymentInBasket;
/* harmony export (immutable) */ __webpack_exports__["l"] = isPaymentExpanded;
/* harmony export (immutable) */ __webpack_exports__["s"] = isPaymentSeen;
/* harmony export (immutable) */ __webpack_exports__["c"] = getNewPaymentCount;
/* harmony export (immutable) */ __webpack_exports__["t"] = isPaymentsReady;
/* harmony export (immutable) */ __webpack_exports__["d"] = getOverduePayments;
/* harmony export (immutable) */ __webpack_exports__["p"] = isPaymentOutOfPlaces;
/* harmony export (immutable) */ __webpack_exports__["r"] = isPaymentPendingParentalConsent;
/* harmony export (immutable) */ __webpack_exports__["i"] = getPaymentLimitedPlacesDetails;
/* harmony export (immutable) */ __webpack_exports__["b"] = getGoToPaymentID;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_exact_math__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_exact_math___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_exact_math__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_date__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_id__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__ = __webpack_require__(2);
/**
 * @returns {Immutable.List}
 */function getPaymentIDList(state){return state.getIn(["school_money","otherPayments"]).keySeq().toList();}/**
 * @returns {boolean}
 */function isPaymentVisible(state,paymentID){return!isPaymentOutOfPlaces(state,paymentID);}/**
 * @returns {Immutable.List}
 */function getVisiblePaymentIDList(state){return getPaymentIDList(state).filter(function(paymentID){return isPaymentVisible(state,paymentID);});}/**
 * @returns {boolean}
 */function doesPaymentExist(state,paymentID){if(!paymentID){return false;}var payments=getPaymentIDList(state);return payments.includes(paymentID);}/**
 * @returns {Immutable.List}
 */function getStudentPaymentIDList(state,studentID){return state.getIn(["school_money","otherPayments"]).filter(function(payment){return payment.get("studentID")===studentID;}).keySeq().toList().filter(function(paymentID){return isPaymentVisible(state,paymentID);});}/**
 * @returns {Immutable.Map}
 */function getPaymentByID(state,paymentID){return state.getIn(["school_money","otherPayments",paymentID]);}/**
 * @returns {number}
 */function getPaymentTotalOutstandingPrice(state,paymentID){var payment=getPaymentByID(state,paymentID);return payment.installments.map(function(installment){return installment.outstandingPrice;}).reduce(function(totalPrice,installmentPrice){return __WEBPACK_IMPORTED_MODULE_1_exact_math___default.a.add(totalPrice,installmentPrice);},0);}/**
 * @returns {Immutable.Map}
 */function getPaymentInstallment(state,paymentID,installmentNumber){var payment=getPaymentByID(state,paymentID);return payment.get("installments").get(installmentNumber);}/**
 * @returns {number}
 */function getPaymentInstallmentSelectedPrice(state,paymentID,installmentNumber){var isInBasket=isPaymentInstallmentInBasket(state,paymentID,installmentNumber);if(isInBasket){var basketItem=Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["t" /* getBasketItemByID */])(state,"payment",Object(__WEBPACK_IMPORTED_MODULE_3_lib_id__["a" /* aggregateID */])(paymentID,installmentNumber));return basketItem.price;}else{var installment=getPaymentInstallment(state,paymentID,installmentNumber);return installment.selectedPrice;}}/**
 * @returns {boolean}
 */function isPaymentInstallmentOverdue(state,paymentID,installmentNumber){var installment=getPaymentInstallment(state,paymentID,installmentNumber);return Object(__WEBPACK_IMPORTED_MODULE_2_lib_date__["b" /* isDatePast */])(installment.get("dueDate"));}/**
 * @returns {boolean}
 */function isPaymentOverdue(state,paymentID){var payment=getPaymentByID(state,paymentID);var installments=payment.get("installments");return installments.some(function(installment){return Object(__WEBPACK_IMPORTED_MODULE_2_lib_date__["b" /* isDatePast */])(installment.get("dueDate"));});}/**
 * @returns {boolean}
 */function isPaymentInstallmentInBasket(state,paymentID,installmentNumber){return Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["e" /* doesBasketItemExist */])(state,"payment",Object(__WEBPACK_IMPORTED_MODULE_3_lib_id__["a" /* aggregateID */])(paymentID,installmentNumber));}/**
 * @returns {boolean}
 */function isPaymentInBasket(state,paymentID){return Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["f" /* doesBasketItemGroupExist */])(state,"payment",paymentID);}/**
 * @returns {boolean}
 */function isPaymentExpanded(state,paymentID){return state.getIn(["school_money","expandedPaymentID"])===paymentID;}/**
 * @returns {boolean}
 */function isPaymentSeen(state,paymentID){return state.getIn(["school_money","seenOtherPaymentIDs"]).includes(paymentID);}/**
 * @returns {number}
 */function getNewPaymentCount(state){var paymentIDList=getPaymentIDList(state);return paymentIDList.filterNot(function(paymentID){return isPaymentSeen(state,paymentID);}).filter(function(paymentID){return!isPaymentOutOfPlaces(state,paymentID);}).count();}/**
 * @returns {boolean}
 */function isPaymentsReady(state){return!state.getIn(["school_money","isActivePaymentsLoading"]);}/**
 * @returns {Immutable.List}
 */function getOverduePayments(state){var paymentIDList=getVisiblePaymentIDList(state);return paymentIDList.filter(function(paymentID){return isPaymentOverdue(state,paymentID);}).map(function(paymentID){return getPaymentByID(state,paymentID);}).map(function(payment){return __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map({paymentID:payment.get("id"),studentID:payment.get("studentID"),description:payment.get("description"),dueDate:payment.get("installments").map(function(installment){return installment.get("dueDate");}).sort().first()});}).sortBy(function(overduePayment){return overduePayment.get("dueDate");});}/**
 * Returns true if a limited places payment has been filled
 *   and the student is not occupying one of the places.
 * @returns {boolean}
 */function isPaymentOutOfPlaces(state,paymentID){var _getPaymentByID=getPaymentByID(state,paymentID),hasLimitedPlaces=_getPaymentByID.hasLimitedPlaces,placesAvailable=_getPaymentByID.placesAvailable,isPlaceReserved=_getPaymentByID.isPlaceReserved;var isFull=placesAvailable<=0;return hasLimitedPlaces&&isFull&&!isPlaceReserved;}/**
 * True if the given payment requires parental consent
 *   and it is not yet given.
 * If a payment is in basket, that counts as consent
 *   given (even though db is not updated yet).
 * @returns {boolean}
 */function isPaymentPendingParentalConsent(state,paymentID){var _getPaymentByID2=getPaymentByID(state,paymentID),requiresParentalConsent=_getPaymentByID2.requiresParentalConsent,isParentalConsentGiven=_getPaymentByID2.isParentalConsentGiven;var isInBasket=isPaymentInBasket(state,paymentID);return requiresParentalConsent&&!isParentalConsentGiven&&!isInBasket;}/**
 * @returns {Object} { enabled, total, taken }
 */function getPaymentLimitedPlacesDetails(state,paymentID){var payment=getPaymentByID(state,paymentID);// Get list of students who have has this payment in basket
var studentsWithBooking=Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["y" /* getBasketItemsOfType */])(state,"payment").filter(function(basketPayment){return basketPayment.getIn(["payload","payment","remotePaymentID"])===payment.remotePaymentID;}).map(function(basketItem){return basketItem.getIn(["payload","payment","remoteStudentID"]);});return{enabled:payment.hasLimitedPlaces,total:payment.placesTotal,available:payment.placesAvailable-studentsWithBooking.size,isPlaceReserved:payment.isPlaceReserved};}/**
 * @returns {string}
 */function getGoToPaymentID(state){return state.getIn(["school_money","goToPaymentID"]);}

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = isParentalConsentReady;
/* harmony export (immutable) */ __webpack_exports__["c"] = getStudentParentConsentIDList;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParentalConsentItemByID;
/* harmony export (immutable) */ __webpack_exports__["g"] = isParentalConsentSaving;
/* harmony export (immutable) */ __webpack_exports__["d"] = isAnyPendingParentalConsentItemFailed;
/* harmony export (immutable) */ __webpack_exports__["e"] = isAnyPendingParentalConsentItemSaved;
/* harmony export (immutable) */ __webpack_exports__["a"] = doesParentalConsentItemExist;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors__ = __webpack_require__(2);
/**
 * @returns {boolean}
 */function isParentalConsentReady(state,studentID){return!Object(__WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors__["_63" /* isActivePaymentsLoading */])(state);}/**
 * @returns {Immutable.List}
 */function getStudentParentConsentIDList(state,studentID){return state.getIn(["school_money","parentalConsentItems"]).filter(function(item){return item.studentID===studentID;}).keySeq().toList();}function getParentalConsentItemByID(state,itemID){return state.getIn(["school_money","parentalConsentItems",itemID]);}/**
 * @returns {boolean}
 */function isParentalConsentSaving(state,itemID){return state.getIn(["school_money","pendingParentalConsentItems",itemID])==="saving";}/**
 * @returns {boolean}
 */function isAnyPendingParentalConsentItemFailed(state){return state.getIn(["school_money","pendingParentalConsentItems"]).some(function(status){return status==="failed";});}/**
 * @returns {boolean}
 */function isAnyPendingParentalConsentItemSaved(state){return state.getIn(["school_money","pendingParentalConsentItems"]).some(function(status){return status==="saved";});}/**
 * @returns {boolean}
 */function doesParentalConsentItemExist(state,itemID){return state.getIn(["school_money","parentalConsentItems"]).has(itemID);}

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = areAllParentEmailAddressesSet;
/* harmony export (immutable) */ __webpack_exports__["c"] = getParentsLackingEmailAddresses;
/* harmony export (immutable) */ __webpack_exports__["d"] = getSchoolsLackingParentEmailAddresses;
/* harmony export (immutable) */ __webpack_exports__["e"] = isParentsReady;
/* unused harmony export getParentInSchool */
/* harmony export (immutable) */ __webpack_exports__["b"] = getParentEmailAddress;
/* unused harmony export getParentFirstName */
/* unused harmony export getParentLastName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors__ = __webpack_require__(2);
function getParents(state){return state.getIn(["school_money","parents"]);}/**
 * @returns {boolean}
 */function areAllParentEmailAddressesSet(state){if(!isParentsReady(state)){return false;}var parents=getParents(state);return parents.every(function(parent){return parent.emailAddress!=="";});}/**
 * @returns {Immutable.List}
 */function getParentsLackingEmailAddresses(state){var parents=getParents(state);return parents.filter(function(parent){return parent.emailAddress==="";}).toList();}/**
 * @returns {Immutable.List}
 */function getSchoolsLackingParentEmailAddresses(state){var parents=getParentsLackingEmailAddresses(state);return parents.map(function(parent){return Object(__WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors__["_29" /* getSchoolByID */])(state,parent.schoolID);});}/**
 * @returns {boolean}
 */function isParentsReady(state){if(!Object(__WEBPACK_IMPORTED_MODULE_0_state_school_money_selectors__["_108" /* isSchoolsReady */])(state)){return false;}return!state.getIn(["school_money","isParentsLoading"]);}/**
  * @returns {list}
  */function getParentInSchool(state,schoolID){return getParents(state).filter(function(parent){return parent.schoolID===schoolID;}).toList();}/**
  * @returns {string}
  */function getParentEmailAddress(state,schoolID){var parents=getParentInSchool(state,schoolID);return parents.first().emailAddress;}/**
  * @returns {string}
  */function getParentFirstName(state,schoolID){var parents=getParentInSchool(state,schoolID);return parents.first().firstName;}/**
  * @returns {string}
  */function getParentLastName(state,schoolID){var parents=getParentInSchool(state,schoolID);return parents.first().lastName;}

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getCheckout */
/* harmony export (immutable) */ __webpack_exports__["d"] = getCheckoutStatus;
/* harmony export (immutable) */ __webpack_exports__["g"] = isCheckoutWindowOpen;
/* unused harmony export isCheckoutReadyForPayment */
/* harmony export (immutable) */ __webpack_exports__["c"] = getCheckoutSchoolID;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCheckoutTotalToPay;
/* harmony export (immutable) */ __webpack_exports__["f"] = getCheckoutTransactionID;
/* harmony export (immutable) */ __webpack_exports__["a"] = getCheckoutError;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCheckoutErrorCode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_school_money_entities_Checkout__ = __webpack_require__(57);
function getCheckout(state){return state.getIn(["school_money","checkout"]);}/**
 * @returns {string}
 */function getCheckoutStatus(state){return getCheckout(state).status;}/**
 * @returns {boolean}
 */function isCheckoutWindowOpen(state){return getCheckoutStatus(state)!==__WEBPACK_IMPORTED_MODULE_0_state_school_money_entities_Checkout__["b" /* status */].CLOSED;}/**
 * @returns {boolean}
 */function isCheckoutReadyForPayment(state){switch(getCheckoutStatus(state)){case __WEBPACK_IMPORTED_MODULE_0_state_school_money_entities_Checkout__["b" /* status */].PENDING:case __WEBPACK_IMPORTED_MODULE_0_state_school_money_entities_Checkout__["b" /* status */].PROCESSING:return true;default:return false;}}/**
 * @returns {string}
 */function getCheckoutSchoolID(state){return getCheckout(state).schoolID;}/**
 * @returns {number} money
 */function getCheckoutTotalToPay(state){return getCheckout(state).totalToPay;}/**
 * @returns {number}
 */function getCheckoutTransactionID(state){return getCheckout(state).transactionID;}/**
 * @returns {string}
 */function getCheckoutError(state){return getCheckout(state).error;}/**
 * @returns {string}
 */function getCheckoutErrorCode(state){return getCheckout(state).errorCode;}

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSecureTradingDetails */
/* unused harmony export getSecureTradingStatus */
/* unused harmony export getSecureTradingMessage */
/* unused harmony export getSecureTradingCode */
/* unused harmony export getSecureTradingThreeDS */
/* harmony export (immutable) */ __webpack_exports__["a"] = getSecureTradingCardHolderName;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSecureTradingCardPayJWTString;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSecureTradingPSD2ErrorCode;
/* harmony export (immutable) */ __webpack_exports__["d"] = getSecureTradingPSD2ErrorMessage;
/* unused harmony export getSecureTradingPSD2ProcessedJWT */
/* harmony export (immutable) */ __webpack_exports__["e"] = getSecureTradingWalletPayJWTString;
/**
 * @returns {Immutable.Map}
 */function getSecureTradingDetails(state){return state.getIn(["school_money","secureTrading"]);}/**
 * Get secure trading status on API response.
 */function getSecureTradingStatus(state){return getSecureTradingDetails(state).status;}/**
 * Get secure trading error message on API response.
 */function getSecureTradingMessage(state){return getSecureTradingDetails(state).message;}/**
 * Get secure trading error code on API response.
 */function getSecureTradingCode(state){return getSecureTradingDetails(state).code;}/**
 * Get secure trading threeDS on API response.
 */function getSecureTradingThreeDS(state){var threeds={};threeds.status=getSecureTradingDetails(state).threeds_status;threeds.enrolled=getSecureTradingDetails(state).threeds_enrolled;threeds.acsurl=getSecureTradingDetails(state).threeds_acsurl;threeds.pareq=getSecureTradingDetails(state).threeds_pareq;threeds.termurl=getSecureTradingDetails(state).threeds_termurl;threeds.md=getSecureTradingDetails(state).threeds_md;return threeds;}/**
 * Get cardholder name for psd2 payment
 */function getSecureTradingCardHolderName(state){return getSecureTradingDetails(state).card_holder_name;}/**
 * Get secure trading jwt string
 */function getSecureTradingCardPayJWTString(state){return getSecureTradingDetails(state).payment_request_jwt_string;}function getSecureTradingPSD2ErrorCode(state){return getSecureTradingDetails(state).error_code;}function getSecureTradingPSD2ErrorMessage(state){return getSecureTradingDetails(state).error_message;}function getSecureTradingPSD2ProcessedJWT(state){return getSecureTradingDetails(state).payment_response_jwt_string;}function getSecureTradingWalletPayJWTString(state){return getSecureTradingDetails(state).wallet_pay_jwt_string;}

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = closeApplicationSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_native__ = __webpack_require__(44);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(closeApplicationSaga);function closeApplicationSaga(action){var userIdentity;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function closeApplicationSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["k" /* getUserIdentity */]);case 2:userIdentity=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_lib_native__["b" /* closeApplication */],userIdentity.get("platform"));case 5:return _context.abrupt("return",_context.sent);case 6:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = goBackSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_log__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_app_actions__ = __webpack_require__(9);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(goBackSaga);// candiate for implementing delegate goBack sagas in state/teachers/sagas etc
function goBackSaga(action){var teachersPathMatch,schoolMoneyPathMatch,appPathMatch,isGuideOpen,_isGuideOpen,isCheckoutWindowOpen,previousLocation;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function goBackSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:teachersPathMatch=Object(__WEBPACK_IMPORTED_MODULE_3_react_router__["e" /* matchPath */])(action.payload.pathname,{path:"/teachers/",exact:false});schoolMoneyPathMatch=Object(__WEBPACK_IMPORTED_MODULE_3_react_router__["e" /* matchPath */])(action.payload.pathname,{path:"/school_money/",exact:false});appPathMatch=Object(__WEBPACK_IMPORTED_MODULE_3_react_router__["e" /* matchPath */])(action.payload.pathname,{path:"/",exact:false});if(!(teachersPathMatch!==null)){_context.next=14;break;}_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_7_state_teachers_selectors__["w" /* isGuideOpen */]);case 6:isGuideOpen=_context.sent;if(!isGuideOpen){_context.next=12;break;}__WEBPACK_IMPORTED_MODULE_5_lib_log__["a" /* default */].info("goBack: T2P/guide is open, closing...");_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_6_state_teachers_actions__["C" /* closeGuide */]());case 11:return _context.abrupt('return');case 12:_context.next=34;break;case 14:if(!(schoolMoneyPathMatch!==null)){_context.next=33;break;}_context.next=17;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_9_state_school_money_selectors__["_93" /* isGuideOpen */]);case 17:_isGuideOpen=_context.sent;if(!_isGuideOpen){_context.next=23;break;}__WEBPACK_IMPORTED_MODULE_5_lib_log__["a" /* default */].info("goBack: SM/guide is open, closing...");_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_8_state_school_money_actions__["_50" /* closeGuide */]());case 22:return _context.abrupt('return');case 23:_context.next=25;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_9_state_school_money_selectors__["_71" /* isCheckoutWindowOpen */]);case 25:isCheckoutWindowOpen=_context.sent;if(!isCheckoutWindowOpen){_context.next=31;break;}__WEBPACK_IMPORTED_MODULE_5_lib_log__["a" /* default */].info("goBack: SM/isCheckoutOpen is open, closing...");_context.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_8_state_school_money_actions__["_49" /* closeCheckout */]());case 30:return _context.abrupt('return');case 31:_context.next=34;break;case 33:if(appPathMatch!==null){}// do app back actions
// Unmatched, or no action
// We should attempt to push the user back by one history step
// There's no way of determining whether it worked or didnt, so we have to do a timed-best-guess
case 34:previousLocation=window.location.href;__WEBPACK_IMPORTED_MODULE_4_state_history__["a" /* history */].goBack();// Wait in the hope that history will resolve
_context.next=38;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga__["b" /* delay */])(100);case 38:if(!(window.location.href===previousLocation)){_context.next=44;break;}_context.next=41;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_10_state_app_actions__["B" /* closeApplication */]());case 41:return _context.abrupt('return');case 44:case'end':return _context.stop();}}},_marked,this);}

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getSchoolByID;
/* harmony export (immutable) */ __webpack_exports__["i"] = getServerID;
/* harmony export (immutable) */ __webpack_exports__["g"] = getSchoolName;
/* harmony export (immutable) */ __webpack_exports__["b"] = getLastSchoolID;
/* unused harmony export getSchoolCount */
/* harmony export (immutable) */ __webpack_exports__["a"] = doesSchoolExist;
/* harmony export (immutable) */ __webpack_exports__["e"] = getSchoolIDList;
/* harmony export (immutable) */ __webpack_exports__["f"] = getSchoolList;
/* harmony export (immutable) */ __webpack_exports__["h"] = getSchoolTimezoneOffset;
/* unused harmony export isRepliesEnabledForSchool */
/* unused harmony export isSchoolsLoading */
/* harmony export (immutable) */ __webpack_exports__["j"] = isSchoolsReady;
/* harmony export (immutable) */ __webpack_exports__["d"] = getSchoolIDFromRemoteSchoolID;
/**
 * Get the school object with the given ID
 * @returns {object} school
 */function getSchoolByID(state,schoolID){return state.getIn(["teachers","schools",schoolID]);}/**
 * Get the server id of the school with the given ID
 * @returns {string}
 */function getServerID(state,schoolID){return state.getIn(["teachers","schools",schoolID,"serverId"]);}/**
 * Get the name of the school with the given ID
 * @returns {string}
 */function getSchoolName(state,schoolID){return state.getIn(["teachers","schools",schoolID,"name"]);}/**
 * Get the ID of the last visited school
 * @returns {number}
 */function getLastSchoolID(state){return state.getIn(["teachers","lastSchoolID"]);}/**
 * Get the number of available schools
 * @returns {number}
 */function getSchoolCount(state){return state.getIn(['teachers','schools']).size;}/**
 * Check if there is a school with the given ID
 * @returns {boolean}
 */function doesSchoolExist(state,schoolID){return getSchoolIDList(state).includes(schoolID);}/**
 * Get a list of the available schools ordered alphabetically
 * @returns {Immutable.Seq}
 */function getSchoolIDList(state){return getSchoolList(state).map(function(school){return school.get("id");});}/**
 * Get a list of the available schools ordered alphabetically
 * @returns {Immutable.Seq}
 */function getSchoolList(state){return state.getIn(['teachers','schools']).valueSeq().toList().sortBy(function(school){return school.get("name");});}/**
 * Get the timezoneOffset of the school with the given ID
 * @returns {string}
 */function getSchoolTimezoneOffset(state,schoolID){return state.getIn(["teachers","schools",schoolID,"timezoneOffset"]);}/**
 * Get the repliesEnabled property for the school with the given ID
 * @returns {boolean}
 */function isRepliesEnabledForSchool(state,schoolID){return state.getIn(["teachers","schools",schoolID,"repliesEnabled"]);}/**
 * @returns {boolean}
 */function isSchoolsLoading(state){return state.getIn(["teachers","isSchoolsLoading"]);}/**
 * Return true if schools have loaded and we have an activeSchoolID
 * @returns {boolean}
 */function isSchoolsReady(state){return!isSchoolsLoading(state);}/**
 * Return the schoolid for the given remoteschoolID
 * @returns {string}
 */function getSchoolIDFromRemoteSchoolID(state,remoteSchoolID){var schoolList=getSchoolList(state);return schoolList.filter(function(school){return school.get("remoteSchoolID")===remoteSchoolID;}).toObject()[0].schoolID;}

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getMessageByID;
/* unused harmony export hasMessagesForSchool */
/* harmony export (immutable) */ __webpack_exports__["d"] = getSchoolMessageIDList;
/* unused harmony export getSchoolPendingReplyIDs */
/* unused harmony export getSchoolPendingReplies */
/* harmony export (immutable) */ __webpack_exports__["f"] = getSchoolReplyDraft;
/* unused harmony export getReadMessageIDs */
/* harmony export (immutable) */ __webpack_exports__["g"] = isMessagesLoading;
/* harmony export (immutable) */ __webpack_exports__["h"] = isMessagesReady;
/* harmony export (immutable) */ __webpack_exports__["c"] = getRecentMessages;
/* harmony export (immutable) */ __webpack_exports__["a"] = getGoToMessageID;
/* harmony export (immutable) */ __webpack_exports__["e"] = getSchoolReceivedMessageIDList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors__ = __webpack_require__(10);
/**
 * PRIVATE
 * Inject some computed properties into messages
 * @returns {Immutable.Map}
 */function buildMessage(state,message,isPending){message=message.toMap().set("pending",isPending);if(!isPending){var readMessageIDs=state.getIn(["teachers","readMessageIDs"]);var isMessageUnread=message.get("sender")==="school"&&!readMessageIDs.includes(message.get("id"));var timezoneOffset=Object(__WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors__["t" /* getSchoolTimezoneOffset */])(state,message.get("schoolID"));message=message.set("unread",isMessageUnread).set("timezoneOffset",timezoneOffset);}return message;}/**
 * Get properties of the message (or pending reply) with the given ID
 * @returns {Immutable.Map}
 */function getMessageByID(state,messageID){var pendingReplyIDRegex=/\d+:P:\d+/;var isPending=pendingReplyIDRegex.test(messageID);var message=void 0;if(isPending){message=state.getIn(["teachers","pendingReplies",messageID]);}else{message=state.getIn(['teachers','messages',messageID]);}return buildMessage(state,message,isPending);}/**
 * Determine if there are messages (excl. pending replies) for the given school
 * @returns {boolean}
 */function hasMessagesForSchool(state,schoolID){var messageList=state.getIn(["teachers","messages"]).filter(function(message){return message.get("schoolID")===schoolID;});return messageList.size>0;}/**
 * Get IDs of all messages (incl. pending) for the given school, sorted by sentDate
 * @returns {Immutable.Seq}
 */function getSchoolMessageIDList(state,schoolID){// Get messages retreived from server
var messages=state.getIn(['teachers','messages'])// filter for given school
.filter(function(message){return message.get("schoolID")===schoolID;})// sort by timestamp
.sortBy(function(message){return message.get("sentDate");});// Get messages not yet on server
var pendingReplies=getSchoolPendingReplies(state,schoolID);// Append pending messages to the main list
return messages.keySeq().concat(pendingReplies.keySeq()).reverse();}/**
 * Get IDs of pending replies for the given school
 * @returns {Immutable.Seq}
 */function getSchoolPendingReplyIDs(state,schoolID){return getSchoolPendingReplies(state,schoolID).keySeq();}/**
 * Get pending replies for the given school
 * @returns {Immutable.Map}
 */function getSchoolPendingReplies(state,schoolID){return state.getIn(["teachers","pendingReplies"]).filter(function(pendingReply){return pendingReply.get("schoolID")===schoolID;});}/**
 * Get the saved replyDraft for the given school
 * @returns {string}
 */function getSchoolReplyDraft(state,schoolID){return state.getIn(["teachers","replyDrafts",schoolID],"");}/**
 * Get IDs of given school's messages that have been read before
 * @returns {Immutable.List}
 */function getReadMessageIDs(state,schoolID){return state.getIn(["teachers","readMessageIDs"]);}/**
 * @returns {boolean}
 */function isMessagesLoading(state){return state.getIn(["teachers","isMessagesLoading"]);}/**
 * isMessagesReady - returns true if notices are loaded and ready
 * @returns {boolean}
 */function isMessagesReady(state,schoolID){var hasMessages=hasMessagesForSchool(state,schoolID);var canDisplayMessages=hasMessages||!isMessagesLoading(state);return Object(__WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors__["B" /* isSchoolsReady */])(state)&&canDisplayMessages;}/**
 * used by home page "Recent Messages" section
 * @returns {Immutable.List}
 */function getRecentMessages(state,count){return state.getIn(["teachers","messages"]).filter(function(message){return message.get("sender")==="school";}).sortBy(function(message){return message.get("sentDate");}).takeLast(count).reverse().toList();}/**
 * Get the current "going to" messageID.
 * @returns {string}
 */function getGoToMessageID(state){return state.getIn(["teachers","goToMessageID"]);}/**
 * Get the received messages for the given school.
 * @returns {Immutable.List}
 */function getSchoolReceivedMessageIDList(state,schoolID){return state.getIn(['teachers','messages']).filter(function(message){return message.schoolID===schoolID;}).filter(function(message){return message.sender==="school";}).sortBy(function(message){return message.sentDate;}).keySeq().toList();}

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getNoticeByID;
/* harmony export (immutable) */ __webpack_exports__["d"] = getSchoolNoticeIDList;
/* harmony export (immutable) */ __webpack_exports__["e"] = isNoticesLoading;
/* harmony export (immutable) */ __webpack_exports__["f"] = isNoticesReady;
/* harmony export (immutable) */ __webpack_exports__["c"] = getRecentNotices;
/* harmony export (immutable) */ __webpack_exports__["a"] = getGoToNoticeID;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors__ = __webpack_require__(10);
/**
 * Inject some computed properties into notices
 * @returns {Immutable.Map}
 */function buildNotice(state,notice){var timezoneOffset=Object(__WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors__["t" /* getSchoolTimezoneOffset */])(state,notice.get("schoolID"));var expandedNoticeID=state.getIn(["teachers","expandedNoticeID"]);var expanded=notice.get("id")===expandedNoticeID;return notice.toMap().set("timezoneOffset",timezoneOffset).set("expanded",expanded);}/**
 * Get properties of the notice with the given ID
 * @returns {Immutable.Map}
 */function getNoticeByID(state,noticeID){var notice=state.getIn(['teachers','notices',noticeID]);return buildNotice(state,notice);}/**
 * Get IDs of all notices for the given school, sorted by postedDate
 * @returns {Immutable.Seq}
 */function getSchoolNoticeIDList(state,schoolID){return state.getIn(['teachers','notices']).valueSeq()// filter for given school
.filter(function(notice){return notice.get("schoolID")===schoolID;})// sort by timestamp (DESCending)
.sortBy(function(notice){return notice.get("postedDate");}).reverse().map(function(notice){return notice.get("id");});}/**
 * @returns {boolean}
 */function isNoticesLoading(state){return state.getIn(["teachers","isNoticesLoading"]);}/**
 * Return true if schools and notices are loaded
 * @returns {boolean}
 */function isNoticesReady(state){return Object(__WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors__["B" /* isSchoolsReady */])(state)&&!isNoticesLoading(state);}/**
 * @returns {Immutable.List}
 */function getRecentNotices(state,count){return state.getIn(["teachers","notices"]).sortBy(function(notice){return notice.get("postedDate");}).takeLast(count).reverse().toList();}/**
 * @returns {string}
 */function getGoToNoticeID(state){return state.getIn(["teachers","goToNoticeID"]);}

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getTermByID;
/* harmony export (immutable) */ __webpack_exports__["a"] = getSchoolTermIDList;
/* unused harmony export isTermsLoading */
/* harmony export (immutable) */ __webpack_exports__["c"] = isTermsReady;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors__ = __webpack_require__(10);
/**
 * Get properties of the term with the given ID
 * @returns {Immutable.Map}
 */function getTermByID(state,termID){return state.getIn(['teachers','terms',termID]);}/**
 * Get IDs of all terms for the given school, sorted by startDate
 * @returns {Immutable.Seq}
 */function getSchoolTermIDList(state,schoolID){return state.getIn(['teachers','terms']).valueSeq()// filter for given school
.filter(function(term){return term.get("schoolID")===schoolID;})// sort by term start date
.sortBy(function(term){return term.get("startDate");}).map(function(term){return term.get("id");});}/**
 * @returns {boolean}
 */function isTermsLoading(state){return state.getIn(["teachers","isTermsLoading"]);}/**
 * isMessagesReady - returns true if terms are loaded and ready
 * @returns {boolean}
 */function isTermsReady(state){return Object(__WEBPACK_IMPORTED_MODULE_0_state_teachers_selectors__["B" /* isSchoolsReady */])(state)&&!isTermsLoading(state);}

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = attachProductsSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_validate__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_teachers_sagas__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_school_money_sagas__ = __webpack_require__(361);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(attachProductsSaga);var productSagas=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.Map({teachers:__WEBPACK_IMPORTED_MODULE_6_state_teachers_sagas__["a" /* default */],school_money:__WEBPACK_IMPORTED_MODULE_7_state_school_money_sagas__["a" /* default */]});/**
 * Each time availableProducts is refreshed, attach or detach
 *   product sagas so that we always have the right set running.
 */function attachProductsSaga(){var runningProducts,availableProductList,availableProducts,previousAvailableProducts,joiningProducts,leavingProducts,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,product,productTask,_iteratorNormalCompletion2,_didIteratorError2,_iteratorError2,_iterator2,_step2,_product,productSaga,_productTask,_productTask2;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function attachProductsSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:// this is why we are using a while..take loop instead of a takeEvery
// we need to maintain a record of what sagas are running
// so we can add/remove as appropriate
runningProducts=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.Map();case 1:if(false){_context.next=80;break;}_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_4_state_app_actions__["j" /* FETCH_AVAILABLE_PRODUCTS_COMPLETE */]);case 4:_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_app_selectors__["a" /* getAvailableProducts */]);case 6:availableProductList=_context.sent;availableProducts=availableProductList.toSet();previousAvailableProducts=runningProducts.keySeq().toSet();// joining: products that weren't available before but are now
joiningProducts=availableProducts.subtract(previousAvailableProducts);// leaving: products that were available before but aren't now
leavingProducts=previousAvailableProducts.subtract(availableProducts);// cancel sagas of leaving products
// NOTE: if these sagas spawned (not forked) others, those will
//   not be cancelled unless explicitly (in a finally block)
_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context.prev=14;_iterator=leavingProducts[Symbol.iterator]();case 16:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context.next=25;break;}product=_step.value;productTask=runningProducts.get(product);_context.next=21;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["c" /* cancel */])(productTask);case 21:runningProducts=runningProducts.delete(product);case 22:_iteratorNormalCompletion=true;_context.next=16;break;case 25:_context.next=31;break;case 27:_context.prev=27;_context.t0=_context["catch"](14);_didIteratorError=true;_iteratorError=_context.t0;case 31:_context.prev=31;_context.prev=32;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 34:_context.prev=34;if(!_didIteratorError){_context.next=37;break;}throw _iteratorError;case 37:return _context.finish(34);case 38:return _context.finish(31);case 39:// attach sagas of joining products
_iteratorNormalCompletion2=true;_didIteratorError2=false;_iteratorError2=undefined;_context.prev=42;_iterator2=joiningProducts[Symbol.iterator]();case 44:if(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done){_context.next=62;break;}_product=_step2.value;if(!Object(__WEBPACK_IMPORTED_MODULE_3_lib_validate__["e" /* isProductAvailable */])(_product)){_context.next=54;break;}productSaga=productSagas.get(_product);_context.next=50;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["d" /* fork */])(productSaga);case 50:_productTask=_context.sent;runningProducts=runningProducts.set(_product,_productTask);_context.next=59;break;case 54:if(!runningProducts.contains(_product)){_context.next=59;break;}_productTask2=runningProducts.get(_product);_context.next=58;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["c" /* cancel */])(_productTask2);case 58:runningProducts=runningProducts.delete(_product);case 59:_iteratorNormalCompletion2=true;_context.next=44;break;case 62:_context.next=68;break;case 64:_context.prev=64;_context.t1=_context["catch"](42);_didIteratorError2=true;_iteratorError2=_context.t1;case 68:_context.prev=68;_context.prev=69;if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}case 71:_context.prev=71;if(!_didIteratorError2){_context.next=74;break;}throw _iteratorError2;case 74:return _context.finish(71);case 75:return _context.finish(68);case 76:_context.next=78;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_app_actions__["U" /* productSagasAttached */])());case 78:_context.next=1;break;case 80:case"end":return _context.stop();}}},_marked,this,[[14,27,31,39],[32,,34,38],[42,64,68,76],[69,,71,75]]);}

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = teachersRootSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_teachers_sagas_fetchAll__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_teachers_sagas_fetchSchools__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_teachers_sagas_fetchMessages__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_teachers_sagas_mergeMessages__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_teachers_sagas_fetchNotices__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_teachers_sagas_fetchTerms__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_state_teachers_sagas_sendReply__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_state_teachers_sagas_processMetadataSaga__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_state_teachers_sagas_goToMessageSaga__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_state_teachers_sagas_goToNoticeSaga__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_state_teachers_sagas_markMessagesReadSaga__ = __webpack_require__(360);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(teachersRootSaga);function teachersRootSaga(){var guideShownDate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function teachersRootSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["e" /* FETCH_ALL */],__WEBPACK_IMPORTED_MODULE_5_state_teachers_sagas_fetchAll__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["j" /* FETCH_SCHOOLS */],__WEBPACK_IMPORTED_MODULE_6_state_teachers_sagas_fetchSchools__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["f" /* FETCH_MESSAGES */],__WEBPACK_IMPORTED_MODULE_7_state_teachers_sagas_fetchMessages__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["k" /* FETCH_SCHOOLS_COMPLETED */],__WEBPACK_IMPORTED_MODULE_8_state_teachers_sagas_mergeMessages__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["g" /* FETCH_MESSAGES_COMPLETED */],__WEBPACK_IMPORTED_MODULE_8_state_teachers_sagas_mergeMessages__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["h" /* FETCH_NOTICES */],__WEBPACK_IMPORTED_MODULE_9_state_teachers_sagas_fetchNotices__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["l" /* FETCH_TERMS */],__WEBPACK_IMPORTED_MODULE_10_state_teachers_sagas_fetchTerms__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["u" /* SEND_REPLY */],__WEBPACK_IMPORTED_MODULE_11_state_teachers_sagas_sendReply__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_4_state_app_actions__["v" /* PROCESS_METADATA */],__WEBPACK_IMPORTED_MODULE_12_state_teachers_sagas_processMetadataSaga__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["n" /* GO_TO_MESSAGE */],__WEBPACK_IMPORTED_MODULE_13_state_teachers_sagas_goToMessageSaga__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["o" /* GO_TO_NOTICE */],__WEBPACK_IMPORTED_MODULE_14_state_teachers_sagas_goToNoticeSaga__["a" /* default */]),Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["q" /* MARK_SCHOOL_MESSAGES_READ */],__WEBPACK_IMPORTED_MODULE_15_state_teachers_sagas_markMessagesReadSaga__["a" /* default */])]);case 2:_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["D" /* fetchAll */]());case 4:_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["d" /* getGuideShownDate */]);case 6:guideShownDate=_context.sent;if(!(guideShownDate===undefined)){_context.next=10;break;}_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["R" /* openGuide */]());case 10:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchAllSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_teachers_actions__ = __webpack_require__(11);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchAllSaga);/**
 * Run all fetch APIs at once.
 */function fetchAllSaga(){var fetchActions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchAllSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:fetchActions=[Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_actions__["E" /* fetchMessages */])(),Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_actions__["G" /* fetchNotices */])(),Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_actions__["I" /* fetchSchools */])(),Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_actions__["K" /* fetchTerms */])()];_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* all */])(fetchActions.map(function(action){return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(action);}));case 3:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchSchools;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_data__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_teachers_entities_School__ = __webpack_require__(348);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchSchools);function fetchSchools(action){var response,schoolsByID,neoSchools,migratedSchools,distinctSchools;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchSchools$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__["c" /* sendTeachersDataRequest */],"get_my_schools");case 2:response=_context.sent;schoolsByID=Object(__WEBPACK_IMPORTED_MODULE_2_lib_data__["a" /* arrayToEntityMap */])(__WEBPACK_IMPORTED_MODULE_5_state_teachers_entities_School__["a" /* default */].fromAppserverValueList,function(school){return school.id;},response.data);// Neo schools that come from classic will pass an additional "classicId" parameter to indicate which classic T2P account they were migrated from.
neoSchools=schoolsByID.filter(function(s){return s.classicId!=null;});// Update the migrated schools classic accounts with their corresponding Neo ID.
migratedSchools=schoolsByID.filter(function(s){return neoSchools.some(function(n){return n.classicId===s.remoteSchoolID;});}).map(function(s){return s.set("neoId",neoSchools.find(function(n){return n.classicId===s.remoteSchoolID;}).schoolID);});// Remove any schools whose "schoolID" matches a migrated school.
distinctSchools=schoolsByID.filter(function(s){return!migratedSchools.some(function(m){return m.schoolID===s.schoolID;});});_context.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__["J" /* fetchSchoolsSucceeded */])(distinctSchools,migratedSchools));case 9:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_data__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_common__ = __webpack_require__(56);
var School=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record(Object.assign({},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_common__["b" /* defaultProperties */],{name:undefined,logoFileName:undefined,phoneNumber:undefined,emailAddress:undefined,websiteURL:undefined,repliesEnabled:undefined,timezoneOffset:undefined,serverId:undefined,classicId:undefined,neoId:undefined}),"School");/* harmony default export */ __webpack_exports__["a"] = (School);School.fromAppserver=function buildSchool(rawSchool){return School(Object.assign({name:rawSchool.name,logoFileName:rawSchool.logo_file_name,phoneNumber:rawSchool.phone_number,emailAddress:rawSchool.email_address,websiteURL:rawSchool.website_url,repliesEnabled:rawSchool.replies_enabled==="Y",timezoneOffset:rawSchool.timezone_offset,serverId:rawSchool.appserver_server_id,classicId:rawSchool.classic_id,neoId:null},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_common__["a" /* appserverAdapter */](rawSchool)));};School.fromAppserverValueList=function buildSchool(valueList){if(valueList.length<12){// Value for "classic_id" is only passed on data originating from Neo
valueList.push(null);}var rawSchool=Object(__WEBPACK_IMPORTED_MODULE_1_lib_data__["b" /* mapArrayToEntity */])(["appserver_server_hostname","appserver_server_id","appserver_remote_school_id","appserver_remote_entity_id","name","logo_file_name","phone_number","website_url","email_address","replies_enabled","timezone_offset","classic_id"],valueList);// special case for schools, their id is their school id
rawSchool.id=rawSchool.appserver_remote_school_id;return School.fromAppserver(rawSchool);};

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchMessages;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_data__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_teachers_entities_Message__ = __webpack_require__(350);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchMessages);function fetchMessages(action){var response,messagesByID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchMessages$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__["c" /* sendTeachersDataRequest */],"get_my_messages");case 2:response=_context.sent;messagesByID=Object(__WEBPACK_IMPORTED_MODULE_2_lib_data__["a" /* arrayToEntityMap */])(__WEBPACK_IMPORTED_MODULE_5_state_teachers_entities_Message__["a" /* default */].fromAppserverValueList,function(message){return message.id;},response.data);_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__["F" /* fetchMessagesSucceeded */])(messagesByID));case 6:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_data__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_schoolLinked__ = __webpack_require__(58);
var Message=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record(Object.assign({},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_schoolLinked__["b" /* defaultProperties */],{body:undefined,sentDate:undefined,sender:undefined}),"Message");/* harmony default export */ __webpack_exports__["a"] = (Message);Message.fromAppserver=function buildMessage(rawMessage){return Message(Object.assign({body:rawMessage.body,sentDate:rawMessage.sent_date,sender:rawMessage.sender},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_schoolLinked__["a" /* appserverAdapter */](rawMessage)));};Message.fromAppserverValueList=function buildMessage(valueList){var rawMessage=Object(__WEBPACK_IMPORTED_MODULE_1_lib_data__["b" /* mapArrayToEntity */])(["appserver_server_hostname","appserver_server_id","appserver_remote_school_id","appserver_remote_entity_id","id","body","sent_date","sender"],valueList);return Message.fromAppserver(rawMessage);};

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchMessages;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_teachers_actions__ = __webpack_require__(11);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchMessages);function fetchMessages(action){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchMessages$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_actions__["Q" /* mergeMessages */])());case 2:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchNotices;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_data__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_teachers_entities_Notice__ = __webpack_require__(353);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchNotices);function fetchNotices(action){var response,noticesByID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchNotices$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__["c" /* sendTeachersDataRequest */],"get_my_notices");case 2:response=_context.sent;noticesByID=Object(__WEBPACK_IMPORTED_MODULE_2_lib_data__["a" /* arrayToEntityMap */])(__WEBPACK_IMPORTED_MODULE_5_state_teachers_entities_Notice__["a" /* default */].fromAppserverValueList,function(notice){return notice.id;},response.data);_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__["H" /* fetchNoticesSucceeded */])(noticesByID));case 6:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_data__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_schoolLinked__ = __webpack_require__(58);
var Notice=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record(Object.assign({},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_schoolLinked__["b" /* defaultProperties */],{subject:undefined,description:undefined,postedDate:undefined,icon:undefined}),"Notice");/* harmony default export */ __webpack_exports__["a"] = (Notice);Notice.fromAppserver=function buildNotice(rawNotice){return Notice(Object.assign({subject:rawNotice.subject,description:rawNotice.description,postedDate:rawNotice.posted_date,icon:rawNotice.icon},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_schoolLinked__["a" /* appserverAdapter */](rawNotice)));};Notice.fromAppserverValueList=function buildNotice(valueList){var rawNotice=Object(__WEBPACK_IMPORTED_MODULE_1_lib_data__["b" /* mapArrayToEntity */])(["appserver_server_hostname","appserver_server_id","appserver_remote_school_id","appserver_remote_entity_id","id","subject","description","posted_date","icon"],valueList);return Notice.fromAppserver(rawNotice);};

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchTerms;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_data__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_teachers_entities_Term__ = __webpack_require__(355);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchTerms);function fetchTerms(action){var response,termsByID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchTerms$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__["c" /* sendTeachersDataRequest */],"get_my_terms");case 2:response=_context.sent;termsByID=Object(__WEBPACK_IMPORTED_MODULE_2_lib_data__["a" /* arrayToEntityMap */])(__WEBPACK_IMPORTED_MODULE_5_state_teachers_entities_Term__["a" /* default */].fromAppserverValueList,function(term){return term.id;},response.data);_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__["L" /* fetchTermsSucceeded */])(termsByID));case 6:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_data__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_schoolLinked__ = __webpack_require__(58);
var Term=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record(Object.assign({},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_schoolLinked__["b" /* defaultProperties */],{name:undefined,startDate:undefined,endDate:undefined,breakStartDate:undefined,breakEndDate:undefined}),"Term");/* harmony default export */ __webpack_exports__["a"] = (Term);Term.fromAppserver=function buildTerm(rawTerm){return Term(Object.assign({name:rawTerm.name,startDate:rawTerm.start_date,endDate:rawTerm.end_date,breakStartDate:rawTerm.break_start_date,breakEndDate:rawTerm.break_end_date},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_schoolLinked__["a" /* appserverAdapter */](rawTerm)));};Term.fromAppserverValueList=function buildTerm(valueList){var rawTerm=Object(__WEBPACK_IMPORTED_MODULE_1_lib_data__["b" /* mapArrayToEntity */])(["appserver_server_hostname","appserver_server_id","appserver_remote_school_id","appserver_remote_entity_id","id","name","start_date","end_date","break_start_date","break_end_date"],valueList);return Term.fromAppserver(rawTerm);};

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sendReply;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_fetchSagas__ = __webpack_require__(14);
var _marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(sendReply);// Timeout for axios request before aborting (milliseconds)
var REQUEST_TIMEOUT=60000;// Matches the relevant line from the full response
function getGeneratedID(){return+new Date();}function sendReply(action){var _marked,_action$payload,schoolID,body,paramMap,MessageReply;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function sendReply$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:MessageReply=function MessageReply(paramMap){var response,messageReplyResult;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function MessageReply$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5_state_fetchSagas__["c" /* sendTeachersDataRequest */],"send_my_message_reply",paramMap.requestArgs,paramMap.requestOptions);case 2:response=_context.sent;if(!(response.status==="error")){_context.next=6;break;}console.error("Send reply error: "+response.message);throw new Error();case 6:// Catch endpoint script error.
messageReplyResult=JSON.parse(response.data[0][4]);if(messageReplyResult.isProcessed){_context.next=10;break;}console.error("Send reply endpoint error: "+messageReplyResult.errorMessage);throw new Error();case 10:case"end":return _context.stop();}}},_marked,this);};_marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(MessageReply);// Generate an ID for the new pendingReply
_action$payload=action.payload,schoolID=_action$payload.schoolID,body=_action$payload.body;// Create parameter map.
paramMap={};paramMap.generatedID=getGeneratedID();paramMap.pendingReplyID=schoolID+":P:"+paramMap.generatedID;paramMap.requestOptions={timeout:REQUEST_TIMEOUT};_context2.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors__["u" /* getServerID */],schoolID);case 9:paramMap.serverId=_context2.sent;_context2.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["j" /* getMobileNumber */]);case 12:paramMap.mobileNumber=_context2.sent;_context2.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors__["j" /* getSchoolByID */],schoolID);case 15:paramMap.school=_context2.sent;paramMap.requestArgs={message:body,originator:paramMap.mobileNumber,school_id:paramMap.school.get("remoteID"),server_id:paramMap.serverId};paramMap.pendingReply={id:paramMap.pendingReplyID,schoolID:schoolID,body:body,status:"sending"};// Add the new pendingReply to state
_context2.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__["z" /* addPendingReply */])(paramMap.pendingReplyID,paramMap.pendingReply));case 20:_context2.prev=20;_context2.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(MessageReply,paramMap);case 23:_context2.next=25;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__["W" /* setPendingReplyStatus */])(paramMap.pendingReplyID,"sent"));case 25:_context2.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__["E" /* fetchMessages */])());case 27:_context2.next=33;break;case 29:_context2.prev=29;_context2.t0=_context2["catch"](20);_context2.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__["W" /* setPendingReplyStatus */])(paramMap.pendingReplyID,"failed"));case 33:case"end":return _context2.stop();}}},_marked2,this,[[20,29]]);}

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = processMetadataSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_teachers_selectors__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(waitForCheckoutWindowToClose),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(processMetadataSaga);// Prevents app refresh if CheckoutWindow is open
function waitForCheckoutWindowToClose(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function waitForCheckoutWindowToClose$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_71" /* isCheckoutWindowOpen */]);case 2:if(!_context.sent){_context.next=7;break;}_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* take */])();case 5:_context.next=0;break;case 7:case"end":return _context.stop();}}},_marked,this);}/**
 * Called when we are responding to a notification being clicked
 *   (or some similar event from the native client)
 */function processMetadataSaga(action){var notificationType,schoolID,metadata,remoteSchoolID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function processMetadataSaga$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:notificationType=void 0;schoolID="";metadata=void 0;remoteSchoolID=void 0;_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(waitForCheckoutWindowToClose);case 6:if(!(action.payload.metadata==="")){_context2.next=8;break;}return _context2.abrupt("return");case 8:if(!(action.payload.metadata==="refresh")){_context2.next=14;break;}_context2.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__["D" /* fetchAll */])());case 11:_context2.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_app_actions__["F" /* closeLoadingFrame */])());case 13:return _context2.abrupt("return");case 14:_context2.prev=14;metadata=JSON.parse(action.payload.metadata);notificationType=metadata.type;remoteSchoolID=metadata.school_id;// Get the school id for app using the remote schoolid, and add / to the end
_context2.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_6_state_teachers_selectors__["k" /* getSchoolIDFromRemoteSchoolID */],remoteSchoolID);case 20:schoolID=_context2.sent;schoolID=schoolID+"/";_context2.next=27;break;case 24:_context2.prev=24;_context2.t0=_context2["catch"](14);notificationType=action.payload.metadata;case 27:if(!(metadata!==undefined&&metadata.application!=="teachers")){_context2.next=31;break;}_context2.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_app_actions__["F" /* closeLoadingFrame */])());case 30:return _context2.abrupt("return");case 31:_context2.t1=notificationType;_context2.next=_context2.t1==="notice"?34:_context2.t1==="message"?38:42;break;case 34:__WEBPACK_IMPORTED_MODULE_2_state_history__["a" /* history */].push("/teachers/noticeboard/"+schoolID);_context2.next=37;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__["D" /* fetchAll */])());case 37:return _context2.abrupt("break",43);case 38:__WEBPACK_IMPORTED_MODULE_2_state_history__["a" /* history */].push("/teachers/messages/"+schoolID);_context2.next=41;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_teachers_actions__["D" /* fetchAll */])());case 41:return _context2.abrupt("break",43);case 42:return _context2.abrupt("break",43);case 43:_context2.next=45;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_app_actions__["F" /* closeLoadingFrame */])());case 45:case"end":return _context2.stop();}}},_marked2,this,[[14,24]]);}

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = goToMessageSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(goToMessageSaga);function goToMessageSaga(action){var messageID,message,_message$toObject,schoolID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function goToMessageSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:messageID=action.payload.messageID;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors__["f" /* getMessageByID */],messageID);case 3:message=_context.sent;_message$toObject=message.toObject(),schoolID=_message$toObject.schoolID;__WEBPACK_IMPORTED_MODULE_2_state_history__["a" /* history */].push("/teachers/messages/"+schoolID+"/");case 6:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = goToNoticeSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors__ = __webpack_require__(10);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(goToNoticeSaga);function goToNoticeSaga(action){var noticeID,notice,_notice$toObject,schoolID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function goToNoticeSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:noticeID=action.payload.noticeID;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_teachers_selectors__["g" /* getNoticeByID */],noticeID);case 3:notice=_context.sent;_notice$toObject=notice.toObject(),schoolID=_notice$toObject.schoolID;__WEBPACK_IMPORTED_MODULE_2_state_history__["a" /* history */].push("/teachers/noticeboard/"+schoolID+"/");case 6:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = markMessagesReadSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__ = __webpack_require__(11);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(markMessagesReadSaga);/**
 * Mark all received messages for the given school as read.
 */function markMessagesReadSaga(action){var schoolID,messageIDList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function markMessagesReadSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:schoolID=action.payload.schoolID;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["q" /* getSchoolReceivedMessageIDList */],schoolID);case 3:messageIDList=_context.sent;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["O" /* markMessagesRead */])(messageIDList));case 6:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = schoolMoneySaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_localStore__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_school_money_sagas_fetchParentsSaga__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_school_money_sagas_awaitParentsSaga__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_school_money_sagas_fetchAllSaga__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_school_money_sagas_fetchSchoolsSaga__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_state_school_money_sagas_fetchStudentsSaga__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_state_school_money_sagas_fetchActivePaymentsSaga__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_state_school_money_sagas_fetchShopItemsSaga__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_state_school_money_sagas_fetchHistorySaga__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_state_school_money_sagas_updateParentEmailAddressSaga__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_state_school_money_sagas_basketSaga__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_state_school_money_sagas_createTransactionSaga__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_state_school_money_sagas_confirmTransactionSaga__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_state_school_money_sagas_completeCheckoutSaga__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_state_school_money_sagas_handlePaysafeErrorSaga__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_state_school_money_sagas_handleSecureTradingErrorSaga__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_state_school_money_sagas_processMetadataSaga__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_state_school_money_sagas_goToClubBookingSaga__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_state_school_money_sagas_goToDinnerBookingSaga__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_state_school_money_sagas_goToPaymentSaga__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_state_school_money_sagas_goToShopItemSaga__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_state_school_money_sagas_goToParentalConsentItemSaga__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_state_school_money_sagas_updateParentalConsentSaga__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_state_school_money_sagas_markAsSeenSaga__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_state_school_money_sagas_secureTradingSaga__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_state_school_money_sagas_saveAudit__ = __webpack_require__(407);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(schoolMoneySaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(localStoreCleanUp);/**
 * Root saga for school_money.
 * Attaches watchers and dispatches initial actions.
 */function schoolMoneySaga(){var guideShownDate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function schoolMoneySaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["U" /* PARENTS_FETCH */],__WEBPACK_IMPORTED_MODULE_7_state_school_money_sagas_fetchParentsSaga__["a" /* default */]);case 2:_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["L" /* FETCH_ALL */],__WEBPACK_IMPORTED_MODULE_9_state_school_money_sagas_fetchAllSaga__["a" /* default */]);case 4:_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_6" /* SCHOOLS_FETCH */],__WEBPACK_IMPORTED_MODULE_10_state_school_money_sagas_fetchSchoolsSaga__["a" /* default */]);case 6:_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_29" /* STUDENTS_FETCH */],__WEBPACK_IMPORTED_MODULE_11_state_school_money_sagas_fetchStudentsSaga__["a" /* default */]);case 8:_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["a" /* ACTIVE_PAYMENTS_FETCH */],__WEBPACK_IMPORTED_MODULE_12_state_school_money_sagas_fetchActivePaymentsSaga__["a" /* default */]);case 10:_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_21" /* SHOP_ITEMS_FETCH */],__WEBPACK_IMPORTED_MODULE_13_state_school_money_sagas_fetchShopItemsSaga__["a" /* default */]);case 12:_context.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["O" /* HISTORY_FETCH */],__WEBPACK_IMPORTED_MODULE_14_state_school_money_sagas_fetchHistorySaga__["a" /* default */]);case 14:_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["W" /* PARENT_EMAIL_ADDRESS_UPDATE */],__WEBPACK_IMPORTED_MODULE_15_state_school_money_sagas_updateParentEmailAddressSaga__["a" /* default */]);case 16:_context.next=18;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["R" /* PARENTAL_CONSENT_UPDATE */],__WEBPACK_IMPORTED_MODULE_28_state_school_money_sagas_updateParentalConsentSaga__["a" /* default */]);case 18:_context.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["q" /* CHECKOUT_START */],__WEBPACK_IMPORTED_MODULE_17_state_school_money_sagas_createTransactionSaga__["a" /* default */]);case 20:_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["s" /* CHECKOUT_TRANSACTION_PROCESS */],__WEBPACK_IMPORTED_MODULE_18_state_school_money_sagas_confirmTransactionSaga__["a" /* default */]);case 22:_context.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["m" /* CHECKOUT_COMPLETE */],__WEBPACK_IMPORTED_MODULE_19_state_school_money_sagas_completeCheckoutSaga__["a" /* default */]);case 24:_context.next=26;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["I" /* ERROR_PAYSAFE */],__WEBPACK_IMPORTED_MODULE_20_state_school_money_sagas_handlePaysafeErrorSaga__["a" /* default */]);case 26:_context.next=28;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["J" /* ERROR_SECURE_TRADING */],__WEBPACK_IMPORTED_MODULE_21_state_school_money_sagas_handleSecureTradingErrorSaga__["a" /* default */]);case 28:_context.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_6_state_app_actions__["v" /* PROCESS_METADATA */],__WEBPACK_IMPORTED_MODULE_22_state_school_money_sagas_processMetadataSaga__["a" /* default */]);case 30:_context.next=32;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["w" /* CLUB_BOOKING_GO_TO */],__WEBPACK_IMPORTED_MODULE_23_state_school_money_sagas_goToClubBookingSaga__["a" /* default */]);case 32:_context.next=34;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["E" /* DINNER_BOOKING_GO_TO */],__WEBPACK_IMPORTED_MODULE_24_state_school_money_sagas_goToDinnerBookingSaga__["a" /* default */]);case 34:_context.next=36;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["Y" /* PAYMENT_GO_TO */],__WEBPACK_IMPORTED_MODULE_25_state_school_money_sagas_goToPaymentSaga__["a" /* default */]);case 36:_context.next=38;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_24" /* SHOP_ITEM_GO_TO */],__WEBPACK_IMPORTED_MODULE_26_state_school_money_sagas_goToShopItemSaga__["a" /* default */]);case 38:_context.next=40;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["Q" /* PARENTAL_CONSENT_ITEM_GO_TO */],__WEBPACK_IMPORTED_MODULE_27_state_school_money_sagas_goToParentalConsentItemSaga__["a" /* default */]);case 40:_context.next=42;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_8" /* SECURE_TRADING_GET_JWT_STRING */],__WEBPACK_IMPORTED_MODULE_30_state_school_money_sagas_secureTradingSaga__["b" /* secureTradingGetJWTString */]);case 42:_context.next=44;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_10" /* SECURE_TRADING_PROCESS_PAYMENT_RESPONSE */],__WEBPACK_IMPORTED_MODULE_30_state_school_money_sagas_secureTradingSaga__["c" /* secureTradingProcessPSD2Response */]);case 44:_context.next=46;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_5" /* SAVE_AUDIT */],__WEBPACK_IMPORTED_MODULE_31_state_school_money_sagas_saveAudit__["a" /* default */]);case 46:_context.next=48;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_6_state_app_actions__["u" /* PROCESS_GOOGLE_PAY_RESPONSE */],__WEBPACK_IMPORTED_MODULE_30_state_school_money_sagas_secureTradingSaga__["a" /* processGooglePayResponseSaga */]);case 48:_context.next=50;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(__WEBPACK_IMPORTED_MODULE_16_state_school_money_sagas_basketSaga__["a" /* default */]);case 50:_context.next=52;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* fork */])(__WEBPACK_IMPORTED_MODULE_29_state_school_money_sagas_markAsSeenSaga__["a" /* default */]);case 52:return _context.delegateYield(localStoreCleanUp(),"t0",53);case 53:_context.next=55;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_59" /* fetchParents */](false));case 55:_context.next=57;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_61" /* fetchSchools */](false));case 57:_context.next=59;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_8_state_school_money_sagas_awaitParentsSaga__["a" /* default */]);case 59:_context.next=61;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_56" /* fetchAll */](false,false,false,false,false,false));case 61:_context.next=63;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_115" /* validateBasketItems */]());case 63:_context.next=65;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_10" /* getGuideShownDate */]);case 65:guideShownDate=_context.sent;if(!(guideShownDate===null)){_context.next=69;break;}_context.next=69;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_82" /* openGuide */]());case 69:case"end":return _context.stop();}}},_marked,this);}// Clear out the local store if mobile number changed
function localStoreCleanUp(){var currentMobileNumber,localStoreMobileNumber;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function localStoreCleanUp$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_app_selectors__["j" /* getMobileNumber */]);case 2:currentMobileNumber=_context2.sent;localStoreMobileNumber=Object(__WEBPACK_IMPORTED_MODULE_4_state_localStore__["b" /* getLocalStoreMobileNumber */])();if(localStoreMobileNumber!==undefined&&currentMobileNumber!==localStoreMobileNumber){Object(__WEBPACK_IMPORTED_MODULE_4_state_localStore__["a" /* clearData */])();}case 5:case"end":return _context2.stop();}}},_marked2,this);}

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchParentsSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_data__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_localStore__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_Parent__ = __webpack_require__(363);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchParentsSaga);function fetchParentsSaga(action){var forceApiRefresh,parentsData,response,parentsByID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchParentsSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:forceApiRefresh=action.payload.forceApiRefresh;parentsData=void 0;if(!forceApiRefresh){parentsData=Object(__WEBPACK_IMPORTED_MODULE_4_state_localStore__["c" /* getSchoolMoneyLocalStoreData */])("parent");}if(!(parentsData===undefined)){_context.next=9;break;}_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__["b" /* sendSchoolMoneyDataRequest */],"get_parents");case 6:response=_context.sent;parentsData=response.data.parents;Object(__WEBPACK_IMPORTED_MODULE_4_state_localStore__["d" /* saveSchoolMoneyLocalStoreData */])("parent",parentsData);case 9:parentsByID=Object(__WEBPACK_IMPORTED_MODULE_2_lib_data__["a" /* arrayToEntityMap */])(__WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_Parent__["a" /* default */].fromAppserver,function(parent){return parent.id;},parentsData);_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_60" /* fetchParentsSucceeded */])(parentsByID));case 12:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Parent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_appserver_entityHeaders_common__ = __webpack_require__(56);
var Parent=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record(Object.assign({},__WEBPACK_IMPORTED_MODULE_1_lib_appserver_entityHeaders_common__["b" /* defaultProperties */],{firstName:undefined,lastName:undefined,emailAddress:undefined}),"Parent");function buildParentFromAppserver(rawParent){// special case for parents since they are their own linked entity
rawParent.id=rawParent.appserver_remote_entity_id;return Parent(Object.assign({},__WEBPACK_IMPORTED_MODULE_1_lib_appserver_entityHeaders_common__["a" /* appserverAdapter */](rawParent),{firstName:rawParent.parent.first_name,lastName:rawParent.parent.last_name,emailAddress:rawParent.parent.email_address}));}Parent.fromAppserver=buildParentFromAppserver;/* harmony default export */ __webpack_exports__["a"] = (Parent);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = awaitParentsSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(awaitParentsSaga);/**
 * Block saga until parent email address is set in state
 */function awaitParentsSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function awaitParentsSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["a" /* areAllParentEmailAddressesSet */]);case 2:if(_context.sent){_context.next=7;break;}_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* take */])([__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["V" /* PARENTS_FETCH_COMPLETED */],__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_7" /* SCHOOLS_FETCH_COMPLETED */]]);case 5:_context.next=0;break;case 7:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchAllSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__ = __webpack_require__(4);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchAllSaga);/**
 * Fire all our fetch APIs at once
 */function fetchAllSaga(action){var forceSchoolFetch,forceStudentFetch,forceParentFetch,forceActivePaymentFetch,forceShopFetch,forceHistoryFetch,fetchActions;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchAllSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:forceSchoolFetch=action.payload.forceSchoolFetch;forceStudentFetch=action.payload.forceStudentFetch;forceParentFetch=action.payload.forceParentFetch;forceActivePaymentFetch=action.payload.forceActivePaymentFetch;forceShopFetch=action.payload.forceShopFetch;forceHistoryFetch=action.payload.forceHistoryFetch;fetchActions=[Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_54" /* fetchActivePayments */])(forceActivePaymentFetch),Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_61" /* fetchSchools */])(forceSchoolFetch),Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_63" /* fetchShopItems */])(forceShopFetch),Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_65" /* fetchStudents */])(forceStudentFetch),Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_59" /* fetchParents */])(forceParentFetch)];// History is heaviest data so fetch only if there is a request
if(forceHistoryFetch){fetchActions.push(Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_57" /* fetchHistory */])(forceHistoryFetch));}_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* all */])(fetchActions.map(function(action){return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(action);}));case 10:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchSchoolsSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_data__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_localStore__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_School__ = __webpack_require__(367);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchSchoolsSaga);function fetchSchoolsSaga(action){var forceApiRefresh,schoolsData,response,schoolsByID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchSchoolsSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:forceApiRefresh=action.payload.forceApiRefresh;schoolsData=void 0;if(!forceApiRefresh){schoolsData=Object(__WEBPACK_IMPORTED_MODULE_4_state_localStore__["c" /* getSchoolMoneyLocalStoreData */])("school");}if(!(schoolsData===undefined)){_context.next=9;break;}_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__["b" /* sendSchoolMoneyDataRequest */],"get_schools");case 6:response=_context.sent;schoolsData=response.data.schools;Object(__WEBPACK_IMPORTED_MODULE_4_state_localStore__["d" /* saveSchoolMoneyLocalStoreData */])("school",schoolsData);case 9:schoolsByID=Object(__WEBPACK_IMPORTED_MODULE_2_lib_data__["a" /* arrayToEntityMap */])(__WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_School__["a" /* default */].fromAppserver,function(school){return school.id;},schoolsData);_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_62" /* fetchSchoolsSucceeded */])(schoolsByID));case 12:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_money__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_common__ = __webpack_require__(56);
var School=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record(Object.assign({},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_common__["b" /* defaultProperties */],{name:undefined,emailAddress:undefined,websiteURL:undefined,phoneNumber:undefined,logoFilePath:undefined,isCashless:undefined,showVegPreference:undefined,isDinnersEnabled:undefined,isDinnerTopUpsEnabled:undefined,isClubTopUpsEnabled:undefined,defaultDinnerTopUpAmount:undefined,defaultClubTopUpAmount:undefined,paysafeAccountNumber:undefined,paymentProvider:undefined,externalCashlessName:undefined,isXodActive:undefined,isExternalTopUpEnabled:undefined,minimumPaymentAmount:undefined,isApplePayEnabled:undefined,isGooglePayEnabled:undefined}),"School");function buildSchoolFromAppserver(rawSchool){return School(Object.assign({},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_common__["a" /* appserverAdapter */](rawSchool),{name:rawSchool.name,emailAddress:rawSchool.email_address,websiteURL:rawSchool.website_url,phoneNumber:rawSchool.phone_number,logoFilePath:rawSchool.logo_file_path,isCashless:rawSchool.enable_cashless_catering,showVegPreference:rawSchool.show_veg_meal_preference,isDinnersEnabled:!rawSchool.hide_dinner_top_ups,isDinnerTopUpsEnabled:!rawSchool.force_dinner_booking,isClubTopUpsEnabled:!rawSchool.hide_club_top_ups,defaultDinnerTopUpAmount:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawSchool.default_dinner_topup_amount),defaultClubTopUpAmount:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawSchool.default_club_topup_amount),paysafeAccountNumber:rawSchool.paysafe_account_number,paymentProvider:rawSchool.payment_provider,externalCashlessName:rawSchool.external_cashless_name,isXodActive:rawSchool.is_xod_active,isExternalTopUpEnabled:rawSchool.is_external_topup_enabled,minimumPaymentAmount:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawSchool.minimum_online_amount),isApplePayEnabled:rawSchool.enable_apple_pay,isGooglePayEnabled:rawSchool.enable_google_pay}));}School.fromAppserver=buildSchoolFromAppserver;/* harmony default export */ __webpack_exports__["a"] = (School);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchStudentsSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_data__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_localStore__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_Student__ = __webpack_require__(369);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchStudentsSaga);function fetchStudentsSaga(action){var forceApiRefresh,studentData,response,studentsByID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchStudentsSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:forceApiRefresh=action.payload.forceApiRefresh;studentData=void 0;if(!forceApiRefresh){studentData=Object(__WEBPACK_IMPORTED_MODULE_4_state_localStore__["c" /* getSchoolMoneyLocalStoreData */])("student");}if(!(studentData===undefined)){_context.next=9;break;}_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__["b" /* sendSchoolMoneyDataRequest */],"get_students");case 6:response=_context.sent;studentData=response.data.students;Object(__WEBPACK_IMPORTED_MODULE_4_state_localStore__["d" /* saveSchoolMoneyLocalStoreData */])("student",studentData);case 9:studentsByID=Object(__WEBPACK_IMPORTED_MODULE_2_lib_data__["a" /* arrayToEntityMap */])(__WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_Student__["a" /* default */].fromAppserver,function(student){return student.id;},studentData);_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_66" /* fetchStudentsSucceeded */])(studentsByID));case 12:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Student */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_money__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_schoolLinked__ = __webpack_require__(58);
var Student=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record(Object.assign({},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_schoolLinked__["b" /* defaultProperties */],{firstName:undefined,lastName:undefined,misId:undefined,credits:undefined,top_up:undefined,external_cashless:undefined}),"Student");function buildStudentFromAppserver(rawStudent){return Student(Object.assign({},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_schoolLinked__["a" /* appserverAdapter */](rawStudent),{firstName:rawStudent.first_name,lastName:rawStudent.last_name,misId:rawStudent.mis_id,credits:buildCreditsFromAppserver(rawStudent),top_up:buildTopupsFromAppserver(rawStudent),external_cashless:buildExternalCashlessFromAppserver(rawStudent)}));}function buildCreditsFromAppserver(rawStudent){return new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map(rawStudent.credits).map(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */]);}function buildTopupsFromAppserver(rawStudent){return new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map(rawStudent.top_up);}function buildExternalCashlessFromAppserver(rawStudent){return new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map(rawStudent.external_cashless);}Student.fromAppserver=buildStudentFromAppserver;/* harmony default export */ __webpack_exports__["a"] = (Student);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchActivePaymentsSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_data__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_localStore__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_school_money_entities_ClubBooking__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_school_money_entities_DinnerBooking__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_school_money_entities_OtherPayment__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_state_school_money_entities_ParentalConsentItem__ = __webpack_require__(374);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchActivePaymentsSaga);function fetchActivePaymentsSaga(action){var forceApiRefresh,activePaymentData,response,activePaymentList,activePaymentsByType,clubBookingList,clubBookingsByID,dinnerBookingList,dinnerBookingsByID,otherPaymentList,otherPaymentsByID,parentalConsentItems;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchActivePaymentsSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:forceApiRefresh=action.payload.forceApiRefresh;activePaymentData=void 0;if(!forceApiRefresh){activePaymentData=Object(__WEBPACK_IMPORTED_MODULE_4_state_localStore__["c" /* getSchoolMoneyLocalStoreData */])("active_payment");}if(!(activePaymentData===undefined)){_context.next=9;break;}_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5_state_fetchSagas__["b" /* sendSchoolMoneyDataRequest */],"get_active_payments");case 6:response=_context.sent;activePaymentData=response.data.active_payments;Object(__WEBPACK_IMPORTED_MODULE_4_state_localStore__["d" /* saveSchoolMoneyLocalStoreData */])("active_payment",activePaymentData);case 9:// collect payments by their type
activePaymentList=new __WEBPACK_IMPORTED_MODULE_1_immutable___default.a.List(activePaymentData);activePaymentsByType=activePaymentList.groupBy(function(payment){return payment.type;});clubBookingList=activePaymentsByType.get("club",[]);clubBookingsByID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_data__["a" /* arrayToEntityMap */])(__WEBPACK_IMPORTED_MODULE_7_state_school_money_entities_ClubBooking__["a" /* default */].fromAppserver,function(clubBooking){return clubBooking.id;},clubBookingList);dinnerBookingList=activePaymentsByType.get("dinner",[]);dinnerBookingsByID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_data__["a" /* arrayToEntityMap */])(__WEBPACK_IMPORTED_MODULE_8_state_school_money_entities_DinnerBooking__["a" /* default */].fromAppserver,function(dinnerBooking){return dinnerBooking.id;},dinnerBookingList);otherPaymentList=activePaymentsByType.get("payment",[]);otherPaymentsByID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_data__["a" /* arrayToEntityMap */])(__WEBPACK_IMPORTED_MODULE_9_state_school_money_entities_OtherPayment__["a" /* default */].fromAppserver,function(otherPayment){return otherPayment.id;},otherPaymentList);parentalConsentItems=filterParentalConsentItems(clubBookingsByID,otherPaymentsByID).map(__WEBPACK_IMPORTED_MODULE_10_state_school_money_entities_ParentalConsentItem__["a" /* default */].fromActivePayment);_context.next=20;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_55" /* fetchActivePaymentsSucceeded */])(clubBookingsByID,dinnerBookingsByID,otherPaymentsByID,parentalConsentItems));case 20:case"end":return _context.stop();}}},_marked,this);}function filterParentalConsentItems(clubBookings,otherPayments){var filteredClubBookings=clubBookings.filter(function(clubBooking){return clubBooking.requiresParentalConsent;});var filteredOtherPayments=otherPayments.filter(function(otherPayment){return otherPayment.requiresParentalConsent;});return filteredClubBookings.concat(filteredOtherPayments);}

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ClubSession */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_money__ = __webpack_require__(17);
var ClubSession=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record({id:undefined,description:undefined,price:undefined},"Club Session");function buildClubSessionFromAppserver(rawClubSession){return ClubSession({id:rawClubSession.id,description:rawClubSession.description,price:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawClubSession.price)});}ClubSession.fromAppserver=buildClubSessionFromAppserver;/* harmony default export */ __webpack_exports__["a"] = (ClubSession);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BookedOption */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_money__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_entities_DinnerBooking__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_entities_DinnerBooking_DinnerItem__ = __webpack_require__(164);
var BookedOption=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record({id:"",name:"",price:0,allergyInformation:""},"Booked Dinner Option");function buildBookedOptionFromAppserver(rawDinnerBooking,rawBookedOption,isFSMEligible){var allergyInformation=rawDinnerBooking.dinner_items.map(function(dinnerItem){if(dinnerItem.dinner_item_fk===rawBookedOption.item.id||dinnerItem.dinner_item_fk===rawBookedOption.status){return dinnerItem.allergy_information;}else{return undefined;}});if(Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_entities_DinnerBooking__["b" /* isCashless */])(rawDinnerBooking)){var hasSelection=rawBookedOption.status==="MEAL"||rawBookedOption.status==="SANDWICH";if(!hasSelection){return BookedOption();}return BookedOption({id:rawBookedOption.item.id,name:rawBookedOption.item.name,price:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawBookedOption.item.price),allergyInformation:allergyInformation});}else{var _staticOptions$rawBoo=__WEBPACK_IMPORTED_MODULE_3_state_school_money_entities_DinnerBooking_DinnerItem__["b" /* staticOptions */][rawBookedOption.status],name=_staticOptions$rawBoo.name,isFree=_staticOptions$rawBoo.isFree;return BookedOption({id:rawBookedOption.status,name:name,price:isFree||isFSMEligible?0:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawDinnerBooking.cost_per_dinner),allergyInformation:allergyInformation});}}BookedOption.fromAppserver=buildBookedOptionFromAppserver;/* harmony default export */ __webpack_exports__["a"] = (BookedOption);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Installment */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_money__ = __webpack_require__(17);
var Installment=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record({number:undefined,price:undefined,paidPrice:undefined,outstandingPrice:undefined,selectedPrice:undefined,dueDate:undefined},"Installment");function buildInstallmentFromAppserver(rawInstallment,installmentNumber){return Installment({number:installmentNumber,price:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawInstallment.total_amount),paidPrice:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawInstallment.paid_amount),outstandingPrice:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawInstallment.amount_outstanding),selectedPrice:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawInstallment.amount_outstanding),dueDate:rawInstallment.due_date});}Installment.fromAppserver=buildInstallmentFromAppserver;/* harmony default export */ __webpack_exports__["a"] = (Installment);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ParentalConsentItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_school_money_entities_ClubBooking__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_entities_OtherPayment__ = __webpack_require__(165);
var ParentalConsentItem=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record({id:undefined,serverID:undefined,remoteSchoolID:undefined,schoolID:undefined,studentID:undefined,remoteParentID:undefined,remoteInstallmentID:undefined,type:undefined,description:undefined,dueDate:undefined,isGiven:undefined});function buildParentalConsentItemFromActivePayment(activePayment){if(activePayment instanceof __WEBPACK_IMPORTED_MODULE_1_state_school_money_entities_ClubBooking__["a" /* default */]){return buildParentalConsentItemFromClubBooking(activePayment);}else if(activePayment instanceof __WEBPACK_IMPORTED_MODULE_2_state_school_money_entities_OtherPayment__["a" /* default */]){return buildParentalConsentItemFromOtherPayment(activePayment);}}function buildParentalConsentItemFromClubBooking(clubBooking){return ParentalConsentItem(Object.assign({},getHeaders(clubBooking),{type:"clubBooking",description:clubBooking.description,dueDate:clubBooking.startDate,isGiven:clubBooking.isParentalConsentGiven}));}function buildParentalConsentItemFromOtherPayment(otherPayment){return ParentalConsentItem(Object.assign({},getHeaders(otherPayment),{type:"otherPayment",description:otherPayment.description,dueDate:otherPayment.installments.first().dueDate,isGiven:otherPayment.isParentalConsentGiven}));}function getHeaders(activePayment){return{id:activePayment.id,serverID:activePayment.serverID,remoteSchoolID:activePayment.remoteSchoolID,schoolID:activePayment.schoolID,studentID:activePayment.studentID,remoteParentID:activePayment.appserverReferenceEntityID,remoteInstallmentID:activePayment.remoteInstallmentID};}ParentalConsentItem.fromActivePayment=buildParentalConsentItemFromActivePayment;/* harmony default export */ __webpack_exports__["a"] = (ParentalConsentItem);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchShopItemsSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_data__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_localStore__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_ShopItem__ = __webpack_require__(161);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchShopItemsSaga);function fetchShopItemsSaga(action){var forceApiRefresh,shopData,response,shopItemsByID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchShopItemsSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:forceApiRefresh=action.payload.forceApiRefresh;shopData=void 0;if(!forceApiRefresh){shopData=Object(__WEBPACK_IMPORTED_MODULE_4_state_localStore__["c" /* getSchoolMoneyLocalStoreData */])("shop");}if(!(shopData===undefined)){_context.next=9;break;}_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__["b" /* sendSchoolMoneyDataRequest */],"get_shop_items");case 6:response=_context.sent;shopData=response.data.shop_items;Object(__WEBPACK_IMPORTED_MODULE_4_state_localStore__["d" /* saveSchoolMoneyLocalStoreData */])("shop",shopData);case 9:shopItemsByID=Object(__WEBPACK_IMPORTED_MODULE_2_lib_data__["a" /* arrayToEntityMap */])(__WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_ShopItem__["a" /* default */].fromAppserver,function(shopItem){return shopItem.id;},shopData);_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_64" /* fetchShopItemsSucceeded */])(shopItemsByID));case 12:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchHistorySaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_data__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_ClubHistoryItem__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_school_money_entities_DinnerHistoryItem__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_school_money_entities_MealHistoryItem__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_school_money_entities_PaymentHistoryItem__ = __webpack_require__(380);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(fetchHistorySaga);function fetchHistorySaga(){var response,historyList,historyByType,clubHistoryList,clubHistoryByID,dinnerHistoryList,dinnerHistoryByID,mealHistoryList,mealHistoryByID,paymentHistoryList,paymentHistoryByID,allHistory;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function fetchHistorySaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_4_state_fetchSagas__["b" /* sendSchoolMoneyDataRequest */],"get_history");case 2:response=_context.sent;historyList=new __WEBPACK_IMPORTED_MODULE_1_immutable___default.a.List(response.data.history);historyByType=historyList.groupBy(function(rawHistoryItem){return rawHistoryItem.type;});clubHistoryList=historyByType.get("club",[]);clubHistoryByID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_data__["a" /* arrayToEntityMap */])(__WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_ClubHistoryItem__["a" /* default */].fromAppserver,function(item){return item.id;},clubHistoryList);dinnerHistoryList=historyByType.get("dinner",[]);dinnerHistoryByID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_data__["a" /* arrayToEntityMap */])(__WEBPACK_IMPORTED_MODULE_7_state_school_money_entities_DinnerHistoryItem__["a" /* default */].fromAppserver,function(item){return item.id;},dinnerHistoryList);mealHistoryList=historyByType.get("meal",[]);mealHistoryByID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_data__["a" /* arrayToEntityMap */])(__WEBPACK_IMPORTED_MODULE_8_state_school_money_entities_MealHistoryItem__["a" /* default */].fromAppserver,function(item){return item.id;},mealHistoryList);paymentHistoryList=historyByType.get("payment",[]);paymentHistoryByID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_data__["a" /* arrayToEntityMap */])(__WEBPACK_IMPORTED_MODULE_9_state_school_money_entities_PaymentHistoryItem__["a" /* default */].fromAppserver,function(item){return item.id;},paymentHistoryList);allHistory=new __WEBPACK_IMPORTED_MODULE_1_immutable___default.a.Map({club:clubHistoryByID,dinner:dinnerHistoryByID,meal:mealHistoryByID,payment:paymentHistoryByID});_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_58" /* fetchHistorySucceeded */])(allHistory));case 16:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_money__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_studentLinked__ = __webpack_require__(41);
var ClubHistoryItem=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record(Object.assign({description:undefined,startDate:undefined,endDate:undefined,booking:undefined,weeklyTotalAmount:undefined,paidAmount:undefined,dueAmount:undefined},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_studentLinked__["b" /* defaultProperties */]),"Club History Item");function buildClubHistoryItemFromAppserver(rawHistoryItem){var rawClubHistoryItem=rawHistoryItem.payload;// TODO: fix this on the server end (hopefully?)
rawHistoryItem.student_fk=rawClubHistoryItem.student_fk;return ClubHistoryItem(Object.assign({description:rawClubHistoryItem.payment_description,startDate:rawClubHistoryItem.club_start_date,endDate:rawClubHistoryItem.club_end_date,booking:buildBookingfromAppserver(rawClubHistoryItem),weeklyTotalAmount:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawClubHistoryItem.weekly_total),paidAmount:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawClubHistoryItem.amount_paid),dueAmount:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawClubHistoryItem.amount_due)},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_studentLinked__["a" /* appserverAdapter */](rawHistoryItem)));}function buildBookingfromAppserver(rawClubHistoryItem){var bookings=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.List([rawClubHistoryItem.monday_booking,rawClubHistoryItem.tuesday_booking,rawClubHistoryItem.wednesday_booking,rawClubHistoryItem.thursday_booking,rawClubHistoryItem.friday_booking]);return bookings.map(function(booking){return{status:formatClubBookingStatus(booking.status),sessionNumber:booking.session_booked?booking.booked_session_id:null};});}function formatClubBookingStatus(status){switch(status){case"Y":return"ATTENDED";case"N":return"NOT_ATTENDED";case"H":return"HOLIDAY";default:return"";}}ClubHistoryItem.fromAppserver=buildClubHistoryItemFromAppserver;/* harmony default export */ __webpack_exports__["a"] = (ClubHistoryItem);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_money__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_studentLinked__ = __webpack_require__(41);
var DinnerHistoryItem=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record(Object.assign({description:undefined,startDate:undefined,endDate:undefined,booking:undefined,totalPrice:undefined},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_studentLinked__["b" /* defaultProperties */]),"Dinner History Item");function buildDinnerHistoryItemFromAppserver(rawHistoryItem){var rawDinnerHistoryItem=rawHistoryItem.payload;// TODO: fix this on the server end (hopefully?)
rawHistoryItem.student_fk=rawDinnerHistoryItem.student_fk;return DinnerHistoryItem(Object.assign({description:rawDinnerHistoryItem.payment_description,startDate:rawDinnerHistoryItem.dinner_start_date,endDate:rawDinnerHistoryItem.dinner_end_date,totalPrice:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawDinnerHistoryItem.weekly_total),booking:buildBookingfromAppserver(rawDinnerHistoryItem)},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_studentLinked__["a" /* appserverAdapter */](rawHistoryItem)));}function buildBookingfromAppserver(rawDinnerHistoryItem){var bookings=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.List([rawDinnerHistoryItem.monday_booking,rawDinnerHistoryItem.tuesday_booking,rawDinnerHistoryItem.wednesday_booking,rawDinnerHistoryItem.thursday_booking,rawDinnerHistoryItem.friday_booking]);// TODO more processing needed here?
return bookings;}DinnerHistoryItem.fromAppserver=buildDinnerHistoryItemFromAppserver;/* harmony default export */ __webpack_exports__["a"] = (DinnerHistoryItem);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_money__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_studentLinked__ = __webpack_require__(41);
var MealHistoryItem=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record(Object.assign({date:undefined,selections:undefined,totalPrice:undefined},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_studentLinked__["b" /* defaultProperties */]),"Meal History Item");function buildMealHistoryItemFromAppserver(rawHistoryItem){var rawMealHistoryItem=rawHistoryItem.payload;// TODO: fix this on the server end (hopefully?)
rawHistoryItem.student_fk=rawMealHistoryItem.student_fk;return MealHistoryItem(Object.assign({date:rawMealHistoryItem.dinner_date,selections:buildSelectionsFromAppserver(rawMealHistoryItem),totalPrice:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawMealHistoryItem.total_cost)},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_studentLinked__["a" /* appserverAdapter */](rawHistoryItem)));}function buildSelectionsFromAppserver(rawMealHistoryItem){return rawMealHistoryItem.meals_selected.map(function(selection){return{name:selection.name,price:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(selection.price)};});}MealHistoryItem.fromAppserver=buildMealHistoryItemFromAppserver;/* harmony default export */ __webpack_exports__["a"] = (MealHistoryItem);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_money__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_studentLinked__ = __webpack_require__(41);
var PaymentHistoryItem=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record(Object.assign({description:undefined,installmentNumber:undefined,paidAmount:undefined,paidDate:undefined,refundedAmount:undefined,paymentMethod:undefined},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_studentLinked__["b" /* defaultProperties */]),"Payment History Item");function buildPaymentHistoryItemFromAppserver(rawHistoryItem){var rawPaymentHistoryItem=rawHistoryItem.payload;// TODO: fix this on the server end (hopefully?)
rawHistoryItem.student_fk=rawPaymentHistoryItem.student_fk;return PaymentHistoryItem(Object.assign({description:rawPaymentHistoryItem.payment_description,installmentNumber:rawPaymentHistoryItem.installment_number,paidAmount:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawPaymentHistoryItem.paid_amount),paidDate:rawPaymentHistoryItem.paid_date,refundedAmount:Object(__WEBPACK_IMPORTED_MODULE_1_lib_money__["a" /* floatToMoney */])(rawPaymentHistoryItem.refunded_amount),paymentMethod:rawPaymentHistoryItem.payment_method},__WEBPACK_IMPORTED_MODULE_2_lib_appserver_entityHeaders_studentLinked__["a" /* appserverAdapter */](rawHistoryItem)));}PaymentHistoryItem.fromAppserver=buildPaymentHistoryItemFromAppserver;/* harmony default export */ __webpack_exports__["a"] = (PaymentHistoryItem);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateParentEmailAddressSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateParentEmailAddressSaga);function updateParentEmailAddressSaga(action){var emailAddress,parents,apiCallEffects,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,parent,serverID,remoteSchoolID,remoteID,callEffect;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateParentEmailAddressSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:emailAddress=action.payload.emailAddress;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_20" /* getParentsLackingEmailAddresses */]);case 3:parents=_context.sent;apiCallEffects=[];_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context.prev=8;for(_iterator=parents[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){parent=_step.value;serverID=parent.serverID,remoteSchoolID=parent.remoteSchoolID,remoteID=parent.remoteID;callEffect=Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_state_fetchSagas__["b" /* sendSchoolMoneyDataRequest */],"update_parent_email",{server_id:serverID,remote_school_id:remoteSchoolID,remote_parent_id:remoteID,parent_email:emailAddress});apiCallEffects.push(callEffect);}_context.next=16;break;case 12:_context.prev=12;_context.t0=_context["catch"](8);_didIteratorError=true;_iteratorError=_context.t0;case 16:_context.prev=16;_context.prev=17;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 19:_context.prev=19;if(!_didIteratorError){_context.next=22;break;}throw _iteratorError;case 22:return _context.finish(19);case 23:return _context.finish(16);case 24:_context.next=26;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["a" /* all */])(apiCallEffects);case 26:_context.next=28;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_59" /* fetchParents */])(true));case 28:case"end":return _context.stop();}}},_marked,this,[[8,12,16,24],[17,,19,23]]);}

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basketSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_sagas_basketSaga_clubBooking__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_sagas_basketSaga_dinnerBooking__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_school_money_sagas_basketSaga_payment__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_school_money_sagas_basketSaga_shopItem__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_school_money_sagas_basketSaga_creditTopUp__ = __webpack_require__(391);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(basketSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(clearBasketItems),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(validateBasketItems),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(resolveBasketItemsIssues);/**
 * Root saga - Attach the action listeners
 */function basketSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function basketSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["v" /* CLUB_BOOKING_ADD_TO_BASKET */],__WEBPACK_IMPORTED_MODULE_5_state_school_money_sagas_basketSaga_clubBooking__["a" /* addToBasket */]),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["y" /* CLUB_BOOKING_REMOVE_FROM_BASKET */],__WEBPACK_IMPORTED_MODULE_5_state_school_money_sagas_basketSaga_clubBooking__["c" /* removeFromBasket */]),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["D" /* DINNER_BOOKING_ADD_TO_BASKET */],__WEBPACK_IMPORTED_MODULE_6_state_school_money_sagas_basketSaga_dinnerBooking__["a" /* addToBasket */]),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["H" /* DINNER_BOOKING_REMOVE_FROM_BASKET */],__WEBPACK_IMPORTED_MODULE_6_state_school_money_sagas_basketSaga_dinnerBooking__["c" /* removeFromBasket */]),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_0" /* PAYMENT_INSTALLMENT_ADD_TO_BASKET */],__WEBPACK_IMPORTED_MODULE_7_state_school_money_sagas_basketSaga_payment__["a" /* addInstallmentToBasket */]),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_1" /* PAYMENT_INSTALLMENT_REMOVE_FROM_BASKET */],__WEBPACK_IMPORTED_MODULE_7_state_school_money_sagas_basketSaga_payment__["d" /* removeInstallmentFromBasket */]),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_2" /* PAYMENT_REMOVE_FROM_BASKET */],__WEBPACK_IMPORTED_MODULE_7_state_school_money_sagas_basketSaga_payment__["c" /* removeFromBasket */]),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_27" /* SHOP_ITEM_SET_BASKET_QUANTITY */],__WEBPACK_IMPORTED_MODULE_8_state_school_money_sagas_basketSaga_shopItem__["d" /* setBasketQuantity */]),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_26" /* SHOP_ITEM_REMOVE_FROM_BASKET */],__WEBPACK_IMPORTED_MODULE_8_state_school_money_sagas_basketSaga_shopItem__["b" /* removeFromBasket */]),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["A" /* CREDIT_TOP_UP_ADD_TO_BASKET */],__WEBPACK_IMPORTED_MODULE_9_state_school_money_sagas_basketSaga_creditTopUp__["a" /* addToBasket */]),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["B" /* CREDIT_TOP_UP_REMOVE_FROM_BASKET */],__WEBPACK_IMPORTED_MODULE_9_state_school_money_sagas_basketSaga_creditTopUp__["b" /* removeFromBasket */]),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["c" /* BASKET_ITEMS_CLEAR */],clearBasketItems),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["h" /* BASKET_ITEMS_VALIDATE */],validateBasketItems),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["j" /* takeLatest */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["g" /* BASKET_ITEMS_RESOLVE_ISSUES */],resolveBasketItemsIssues)]);case 2:case"end":return _context.stop();}}},_marked,this);}/**
 * Clear all basket items for the given school.
 */function clearBasketItems(action){var schoolID,items,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,item;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function clearBasketItems$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:schoolID=action.payload.schoolID;_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_27" /* getSchoolBasketItems */],schoolID);case 3:items=_context2.sent;_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context2.prev=7;_iterator=items[Symbol.iterator]();case 9:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context2.next=16;break;}item=_step.value;_context2.next=13;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_52" /* deleteBasketItem */](item.type,item.basketItemID));case 13:_iteratorNormalCompletion=true;_context2.next=9;break;case 16:_context2.next=22;break;case 18:_context2.prev=18;_context2.t0=_context2["catch"](7);_didIteratorError=true;_iteratorError=_context2.t0;case 22:_context2.prev=22;_context2.prev=23;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 25:_context2.prev=25;if(!_didIteratorError){_context2.next=28;break;}throw _iteratorError;case 28:return _context2.finish(25);case 29:return _context2.finish(22);case 30:case"end":return _context2.stop();}}},_marked2,this,[[7,18,22,30],[23,,25,29]]);}/**
 * Check that all basket items are valid with the current entities in state
 * Will wait for entities to finish fetching before checking
 */function validateBasketItems(){var studentIDList,basketItems,_iteratorNormalCompletion2,_didIteratorError2,_iteratorError2,_iterator2,_step2,basketItem,issuesByItemType,allIssues;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function validateBasketItems$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_99" /* setBasketItemsIssues */](null));case 2:_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_111" /* isStudentsReady */]);case 4:if(_context3.sent){_context3.next=9;break;}_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])();case 7:_context3.next=2;break;case 9:_context3.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_52" /* getStudentIDList */]);case 11:studentIDList=_context3.sent;_context3.next=14;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["v" /* getBasketItems */]);case 14:basketItems=_context3.sent;_iteratorNormalCompletion2=true;_didIteratorError2=false;_iteratorError2=undefined;_context3.prev=18;_iterator2=basketItems[Symbol.iterator]();case 20:if(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done){_context3.next=28;break;}basketItem=_step2.value;if(studentIDList.includes(basketItem.studentID)){_context3.next=25;break;}_context3.next=25;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_52" /* deleteBasketItem */](basketItem.type,basketItem.basketItemID));case 25:_iteratorNormalCompletion2=true;_context3.next=20;break;case 28:_context3.next=34;break;case 30:_context3.prev=30;_context3.t0=_context3["catch"](18);_didIteratorError2=true;_iteratorError2=_context3.t0;case 34:_context3.prev=34;_context3.prev=35;if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}case 37:_context3.prev=37;if(!_didIteratorError2){_context3.next=40;break;}throw _iteratorError2;case 40:return _context3.finish(37);case 41:return _context3.finish(34);case 42:_context3.next=44;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_sagas_basketSaga_clubBooking__["b" /* detectBasketItemsIssues */]),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_6_state_school_money_sagas_basketSaga_dinnerBooking__["b" /* detectBasketItemsIssues */]),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_7_state_school_money_sagas_basketSaga_payment__["b" /* detectBasketItemsIssues */]),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_8_state_school_money_sagas_basketSaga_shopItem__["a" /* detectBasketItemsIssues */])]);case 44:issuesByItemType=_context3.sent;// flatten the issues list
allIssues=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.List(issuesByItemType).flatten(1);// save to state
_context3.next=48;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_99" /* setBasketItemsIssues */](allIssues));case 48:case"end":return _context3.stop();}}},_marked3,this,[[18,30,34,42],[35,,37,41]]);}/**
 * Fix conflicts between basket items and entities in state
 * Re-runs validation after resolution
 */function resolveBasketItemsIssues(){var issuesByItemType;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function resolveBasketItemsIssues$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["w" /* getBasketItemsIssuesByItemType */]);case 2:issuesByItemType=_context4.sent;_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["a" /* all */])([Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_sagas_basketSaga_clubBooking__["d" /* resolveBasketItemsIssues */],issuesByItemType.get("clubBooking")),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_6_state_school_money_sagas_basketSaga_dinnerBooking__["d" /* resolveBasketItemsIssues */],issuesByItemType.get("dinnerBooking")),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_7_state_school_money_sagas_basketSaga_payment__["e" /* resolveBasketItemsIssues */],issuesByItemType.get("payment")),Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_8_state_school_money_sagas_basketSaga_shopItem__["c" /* resolveBasketItemsIssues */],issuesByItemType.get("shopItem"))]);case 5:_context4.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_115" /* validateBasketItems */]());case 7:case"end":return _context4.stop();}}},_marked4,this);}

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addToBasket;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeFromBasket;
/* harmony export (immutable) */ __webpack_exports__["b"] = detectBasketItemsIssues;
/* harmony export (immutable) */ __webpack_exports__["d"] = resolveBasketItemsIssues;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_sagas_basketSaga_clubBooking_validateBasketItem__ = __webpack_require__(384);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(addToBasket),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(removeFromBasket),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(detectBasketItemsIssues),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(resolveBasketItemsIssues);/**
 * Add a club booking to the basket
 */function addToBasket(action){var _action$payload,clubBookingID,reserve,clubBooking,_clubBooking$toObject,schoolID,studentID,price,sessionIDs,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addToBasket$(_context){while(1){switch(_context.prev=_context.next){case 0:_action$payload=action.payload,clubBookingID=_action$payload.clubBookingID,reserve=_action$payload.reserve;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["I" /* getClubBookingByID */],clubBookingID);case 3:clubBooking=_context.sent;_clubBooking$toObject=clubBooking.toObject(),schoolID=_clubBooking$toObject.schoolID,studentID=_clubBooking$toObject.studentID;if(!reserve){_context.next=9;break;}_context.t0=0;_context.next=12;break;case 9:_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["H" /* getClubBookingBasketPrice */],clubBookingID);case 11:_context.t0=_context.sent;case 12:price=_context.t0;_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["N" /* getClubBookingSelectedSessionIDList */],clubBookingID);case 15:sessionIDs=_context.sent;payload={clubBookingID:clubBookingID,reserve:reserve,sessionIDs:sessionIDs,clubBooking:clubBooking};_context.next=19;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_98" /* setBasketItem */])("clubBooking",clubBookingID,schoolID,studentID,clubBookingID,price,1,payload));case 19:case"end":return _context.stop();}}},_marked,this);}/**
 * Remove a club booking from the basket
 */function removeFromBasket(action){var clubBookingID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function removeFromBasket$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:clubBookingID=action.payload.clubBookingID;_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_52" /* deleteBasketItem */])("clubBooking",clubBookingID));case 3:case"end":return _context2.stop();}}},_marked2,this);}/**
 * Return a list of issues with any club bookings which are currently
 *   in the basket.
 * @returns {Immutable.List}
 */function detectBasketItemsIssues(){var basketItems,issues,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,basketItem,issue;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function detectBasketItemsIssues$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_81" /* isClubsReady */]);case 2:if(_context3.sent){_context3.next=7;break;}_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])();case 5:_context3.next=0;break;case 7:_context3.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["y" /* getBasketItemsOfType */],"clubBooking");case 9:basketItems=_context3.sent;// build up a list of issues
issues=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.List();_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context3.prev=14;_iterator=basketItems[Symbol.iterator]();case 16:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context3.next=25;break;}basketItem=_step.value;_context3.next=20;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_sagas_basketSaga_clubBooking_validateBasketItem__["a" /* default */],basketItem);case 20:issue=_context3.sent;if(issue){issues=issues.push(issue);}case 22:_iteratorNormalCompletion=true;_context3.next=16;break;case 25:_context3.next=31;break;case 27:_context3.prev=27;_context3.t0=_context3["catch"](14);_didIteratorError=true;_iteratorError=_context3.t0;case 31:_context3.prev=31;_context3.prev=32;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 34:_context3.prev=34;if(!_didIteratorError){_context3.next=37;break;}throw _iteratorError;case 37:return _context3.finish(34);case 38:return _context3.finish(31);case 39:return _context3.abrupt("return",issues);case 40:case"end":return _context3.stop();}}},_marked3,this,[[14,27,31,39],[32,,34,38]]);}/**
 * Given a list of basket item issues, udate the basket items
 *   in sch a way that all of the issues will be resolved.
 */function resolveBasketItemsIssues(issues){var _iteratorNormalCompletion2,_didIteratorError2,_iteratorError2,_iterator2,_step2,issue;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function resolveBasketItemsIssues$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(!(issues===undefined)){_context4.next=2;break;}return _context4.abrupt("return");case 2:// delete basket items that caused issues
_iteratorNormalCompletion2=true;_didIteratorError2=false;_iteratorError2=undefined;_context4.prev=5;_iterator2=issues[Symbol.iterator]();case 7:if(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done){_context4.next=14;break;}issue=_step2.value;_context4.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_52" /* deleteBasketItem */])("clubBooking",issue.get("basketItemID")));case 11:_iteratorNormalCompletion2=true;_context4.next=7;break;case 14:_context4.next=20;break;case 16:_context4.prev=16;_context4.t0=_context4["catch"](5);_didIteratorError2=true;_iteratorError2=_context4.t0;case 20:_context4.prev=20;_context4.prev=21;if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}case 23:_context4.prev=23;if(!_didIteratorError2){_context4.next=26;break;}throw _iteratorError2;case 26:return _context4.finish(23);case 27:return _context4.finish(20);case 28:case"end":return _context4.stop();}}},_marked4,this,[[5,16,20,28],[21,,23,27]]);}

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateBasketItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_log__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_date__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_BasketItemIssue__ = __webpack_require__(77);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(validateBasketItem),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(isExpired);/**
 * Check for issues with the given basket item.
 * Returns zero or one issues.
 *
 * @param {BasketItem} basketItem
 * @returns {BasketItemIssue | undefined}
 */function validateBasketItem(basketItem){var clubBookingID,newClubBooking,oldClubBooking;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function validateBasketItem$(_context){while(1){switch(_context.prev=_context.next){case 0:clubBookingID=basketItem.payload.get("clubBookingID");_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(isExpired,clubBookingID);case 3:if(!_context.sent){_context.next=5;break;}return _context.abrupt("return",__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_BasketItemIssue__["a" /* default */].fromBasketItem(basketItem,"expired"));case 5:_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["I" /* getClubBookingByID */],clubBookingID);case 7:newClubBooking=_context.sent;oldClubBooking=basketItem.getIn(["payload","clubBooking"]);if(!areDaysExpired(newClubBooking,oldClubBooking)){_context.next=11;break;}return _context.abrupt("return",__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_BasketItemIssue__["a" /* default */].fromBasketItem(basketItem,"expired"));case 11:if(!haveBookingsChanged(newClubBooking,oldClubBooking)){_context.next=13;break;}return _context.abrupt("return",__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_BasketItemIssue__["a" /* default */].fromBasketItem(basketItem,"bookings_changed"));case 13:case"end":return _context.stop();}}},_marked,this);}/**
 * Has this club booking disappeared from state?
 * @returns {boolean}
 */function isExpired(clubBookingID){var clubBookingIDList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function isExpired$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["K" /* getClubBookingIDList */]);case 2:clubBookingIDList=_context2.sent;return _context2.abrupt("return",!clubBookingIDList.includes(clubBookingID));case 4:case"end":return _context2.stop();}}},_marked2,this);}/**
 * Have any of the days in this club booking expired since it was added?
 * @returns {boolean}
 */function areDaysExpired(newClubBooking,oldClubBooking){// check weekdays individually
for(var i=0;i<__WEBPACK_IMPORTED_MODULE_3_lib_date__["a" /* WEEKDAYS */].length;i++){// get old and new values for whether this day is expired
var newIsExpired=newClubBooking.expired.get(i);var oldIsExpired=oldClubBooking.getIn(["expired",i]);if(newIsExpired&&!oldIsExpired){return true;}}return false;}/**
 * Have any of the bookings in this club booking changed since it was added?
 * @returns {boolean}
 */function haveBookingsChanged(newClubBooking,oldClubBooking){// check weekdays individually
for(var i=0;i<__WEBPACK_IMPORTED_MODULE_3_lib_date__["a" /* WEEKDAYS */].length;i++){// get booked session IDs first so we can check for null
var newBookedSessionID=newClubBooking.bookedSessionIDs.get(i);var oldBookedSessionID=oldClubBooking.getIn(["bookedSessionIDs",i]);// if neither session is booked then that's fine
if(newBookedSessionID===null&&oldBookedSessionID===null){continue;}// OR if either has been unbooked, they can't be the same
if(newBookedSessionID===null||oldBookedSessionID===null){return true;}// now get the sessions themselves
var newBookedSession=newClubBooking.sessions.get(newBookedSessionID);// toString() here is because the old club booking has come from JSON so
//   numeric IDs have been converted to strings
__WEBPACK_IMPORTED_MODULE_1_lib_log__["a" /* default */].debug(oldBookedSessionID);var oldBookedSession=oldClubBooking.getIn(["sessions",oldBookedSessionID.toString()]);// if the new booked session doesn't exist - problem
if(!newBookedSession){return true;}// if the sessions aren't identical - problem
if(!newBookedSession.equals(oldBookedSession)){return true;}}return false;}

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addToBasket;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeFromBasket;
/* harmony export (immutable) */ __webpack_exports__["b"] = detectBasketItemsIssues;
/* harmony export (immutable) */ __webpack_exports__["d"] = resolveBasketItemsIssues;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_sagas_basketSaga_dinnerBooking_validateBasketItem__ = __webpack_require__(386);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(addToBasket),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(removeFromBasket),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(detectBasketItemsIssues),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(resolveBasketItemsIssues);function addToBasket(action){var dinnerBookingID,dinnerBooking,_dinnerBooking$toObje,schoolID,studentID,price,optionIDs,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addToBasket$(_context){while(1){switch(_context.prev=_context.next){case 0:dinnerBookingID=action.payload.dinnerBookingID;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["V" /* getDinnerBookingByID */],dinnerBookingID);case 3:dinnerBooking=_context.sent;_dinnerBooking$toObje=dinnerBooking.toObject(),schoolID=_dinnerBooking$toObje.schoolID,studentID=_dinnerBooking$toObje.studentID;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["U" /* getDinnerBookingBasketPrice */],dinnerBookingID);case 7:price=_context.sent;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_1" /* getDinnerBookingSelectedOptionIDList */],dinnerBookingID);case 10:optionIDs=_context.sent;payload={dinnerBookingID:dinnerBookingID,dinnerBooking:dinnerBooking,optionIDs:optionIDs};_context.next=14;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_98" /* setBasketItem */])("dinnerBooking",dinnerBookingID,schoolID,studentID,dinnerBookingID,price,1,payload));case 14:case"end":return _context.stop();}}},_marked,this);}function removeFromBasket(action){var dinnerBookingID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function removeFromBasket$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dinnerBookingID=action.payload.dinnerBookingID;_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_52" /* deleteBasketItem */])("dinnerBooking",dinnerBookingID));case 3:case"end":return _context2.stop();}}},_marked2,this);}function detectBasketItemsIssues(){var basketItems,issues,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,basketItem,issue;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function detectBasketItemsIssues$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_90" /* isDinnersReady */]);case 2:if(_context3.sent){_context3.next=7;break;}_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])();case 5:_context3.next=0;break;case 7:_context3.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["y" /* getBasketItemsOfType */],"dinnerBooking");case 9:basketItems=_context3.sent;// build up a list of issues
issues=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.List();_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context3.prev=14;_iterator=basketItems[Symbol.iterator]();case 16:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context3.next=25;break;}basketItem=_step.value;_context3.next=20;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_sagas_basketSaga_dinnerBooking_validateBasketItem__["a" /* default */],basketItem);case 20:issue=_context3.sent;if(issue){issues=issues.push(issue);}case 22:_iteratorNormalCompletion=true;_context3.next=16;break;case 25:_context3.next=31;break;case 27:_context3.prev=27;_context3.t0=_context3["catch"](14);_didIteratorError=true;_iteratorError=_context3.t0;case 31:_context3.prev=31;_context3.prev=32;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 34:_context3.prev=34;if(!_didIteratorError){_context3.next=37;break;}throw _iteratorError;case 37:return _context3.finish(34);case 38:return _context3.finish(31);case 39:return _context3.abrupt("return",issues);case 40:case"end":return _context3.stop();}}},_marked3,this,[[14,27,31,39],[32,,34,38]]);}function resolveBasketItemsIssues(issues){var _iteratorNormalCompletion2,_didIteratorError2,_iteratorError2,_iterator2,_step2,issue;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function resolveBasketItemsIssues$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(!(issues===undefined)){_context4.next=2;break;}return _context4.abrupt("return");case 2:// delete basket items that caused issues
_iteratorNormalCompletion2=true;_didIteratorError2=false;_iteratorError2=undefined;_context4.prev=5;_iterator2=issues[Symbol.iterator]();case 7:if(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done){_context4.next=14;break;}issue=_step2.value;_context4.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_52" /* deleteBasketItem */])("dinnerBooking",issue.get("basketItemID")));case 11:_iteratorNormalCompletion2=true;_context4.next=7;break;case 14:_context4.next=20;break;case 16:_context4.prev=16;_context4.t0=_context4["catch"](5);_didIteratorError2=true;_iteratorError2=_context4.t0;case 20:_context4.prev=20;_context4.prev=21;if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}case 23:_context4.prev=23;if(!_didIteratorError2){_context4.next=26;break;}throw _iteratorError2;case 26:return _context4.finish(23);case 27:return _context4.finish(20);case 28:case"end":return _context4.stop();}}},_marked4,this,[[5,16,20,28],[21,,23,27]]);}

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateBasketItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_date__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_entities_BasketItemIssue__ = __webpack_require__(77);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(validateBasketItem),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(isExpired);/**
 * Check for issues with the given basket item.
 * Returns zero or one issues.
 *
 * @param {BasketItem} basketItem
 * @returns {BasketItemIssue | undefined}
 */function validateBasketItem(basketItem){var dinnerBookingID,newDinnerBooking,oldDinnerBooking;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function validateBasketItem$(_context){while(1){switch(_context.prev=_context.next){case 0:dinnerBookingID=basketItem.payload.get("dinnerBookingID");_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(isExpired,dinnerBookingID);case 3:if(!_context.sent){_context.next=5;break;}return _context.abrupt("return",__WEBPACK_IMPORTED_MODULE_4_state_school_money_entities_BasketItemIssue__["a" /* default */].fromBasketItem(basketItem,"expired"));case 5:_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["V" /* getDinnerBookingByID */],dinnerBookingID);case 7:newDinnerBooking=_context.sent;oldDinnerBooking=basketItem.getIn(["payload","dinnerBooking"]);if(!areDaysExpired(newDinnerBooking,oldDinnerBooking)){_context.next=11;break;}return _context.abrupt("return",__WEBPACK_IMPORTED_MODULE_4_state_school_money_entities_BasketItemIssue__["a" /* default */].fromBasketItem(basketItem,"expired"));case 11:if(!haveBookingsChanged(newDinnerBooking,oldDinnerBooking)){_context.next=13;break;}return _context.abrupt("return",__WEBPACK_IMPORTED_MODULE_4_state_school_money_entities_BasketItemIssue__["a" /* default */].fromBasketItem(basketItem,"bookings_changed"));case 13:case"end":return _context.stop();}}},_marked,this);}/**
 * Has the dinner booking disappeared form state?
 * @returns {boolean}
 */function isExpired(dinnerBookingID){var dinnerBookingIDList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function isExpired$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["X" /* getDinnerBookingIDList */]);case 2:dinnerBookingIDList=_context2.sent;return _context2.abrupt("return",!dinnerBookingIDList.includes(dinnerBookingID));case 4:case"end":return _context2.stop();}}},_marked2,this);}/**
 * Have any of the days in this dinner booking expired since it was added?
 * @returns {boolean}
 */function areDaysExpired(newDinnerBooking,oldDinnerBooking){// check weekdays individually
for(var i=0;i<__WEBPACK_IMPORTED_MODULE_2_lib_date__["a" /* WEEKDAYS */].length;i++){// get old and new values for whether this day is expired
var newIsExpired=newDinnerBooking.expired.get(i);var oldIsExpired=oldDinnerBooking.getIn(["expired",i]);if(newIsExpired&&!oldIsExpired){return true;}}return false;}/**
 * Have any of the bookings in this dinner changed since it was added?
 * @returns {boolean}
 */function haveBookingsChanged(newDinnerBooking,oldDinnerBooking){for(var i=0;i<__WEBPACK_IMPORTED_MODULE_2_lib_date__["a" /* WEEKDAYS */].length;i++){var newBookedOption=newDinnerBooking.bookedOptions.get(i);var oldBookedOption=oldDinnerBooking.getIn(["bookedOptions",i]);if(!newBookedOption||!newBookedOption.equals(oldBookedOption)){return true;}}return false;}

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addInstallmentToBasket;
/* harmony export (immutable) */ __webpack_exports__["d"] = removeInstallmentFromBasket;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeFromBasket;
/* harmony export (immutable) */ __webpack_exports__["b"] = detectBasketItemsIssues;
/* harmony export (immutable) */ __webpack_exports__["e"] = resolveBasketItemsIssues;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_id__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_sagas_basketSaga_payment_validateBasketItem__ = __webpack_require__(388);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(addInstallmentToBasket),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(removeInstallmentFromBasket),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(removeFromBasket),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(detectBasketItemsIssues),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(resolveBasketItemsIssues);function addInstallmentToBasket(action){var _action$payload,paymentID,installmentNumber,payment,_payment$toObject,schoolID,studentID,basketItemID,price,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addInstallmentToBasket$(_context){while(1){switch(_context.prev=_context.next){case 0:_action$payload=action.payload,paymentID=_action$payload.paymentID,installmentNumber=_action$payload.installmentNumber;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_21" /* getPaymentByID */],paymentID);case 3:payment=_context.sent;_payment$toObject=payment.toObject(),schoolID=_payment$toObject.schoolID,studentID=_payment$toObject.studentID;basketItemID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_id__["a" /* aggregateID */])(paymentID,installmentNumber);_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_24" /* getPaymentInstallmentSelectedPrice */],paymentID,installmentNumber);case 8:price=_context.sent;payload={paymentID:paymentID,installmentNumber:installmentNumber,payment:payment};_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_98" /* setBasketItem */])("payment",basketItemID,schoolID,studentID,paymentID,price,1,payload));case 12:case"end":return _context.stop();}}},_marked,this);}function removeInstallmentFromBasket(action){var _action$payload2,paymentID,installmentNumber;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function removeInstallmentFromBasket$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_action$payload2=action.payload,paymentID=_action$payload2.paymentID,installmentNumber=_action$payload2.installmentNumber;_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_52" /* deleteBasketItem */])("payment",Object(__WEBPACK_IMPORTED_MODULE_3_lib_id__["a" /* aggregateID */])(paymentID,installmentNumber)));case 3:case"end":return _context2.stop();}}},_marked2,this);}function removeFromBasket(action){var paymentID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function removeFromBasket$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:paymentID=action.payload.paymentID;_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_53" /* deleteBasketItemGroup */])("payment",paymentID));case 3:case"end":return _context3.stop();}}},_marked3,this);}function detectBasketItemsIssues(){var basketItems,issues,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,basketItem,issue;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function detectBasketItemsIssues$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_106" /* isPaymentsReady */]);case 2:if(_context4.sent){_context4.next=7;break;}_context4.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])();case 5:_context4.next=0;break;case 7:_context4.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["y" /* getBasketItemsOfType */],"payment");case 9:basketItems=_context4.sent;// build up a list of issues
issues=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.List();_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context4.prev=14;_iterator=basketItems[Symbol.iterator]();case 16:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context4.next=25;break;}basketItem=_step.value;_context4.next=20;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_6_state_school_money_sagas_basketSaga_payment_validateBasketItem__["a" /* default */],basketItem);case 20:issue=_context4.sent;if(issue){issues=issues.push(issue);}case 22:_iteratorNormalCompletion=true;_context4.next=16;break;case 25:_context4.next=31;break;case 27:_context4.prev=27;_context4.t0=_context4["catch"](14);_didIteratorError=true;_iteratorError=_context4.t0;case 31:_context4.prev=31;_context4.prev=32;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 34:_context4.prev=34;if(!_didIteratorError){_context4.next=37;break;}throw _iteratorError;case 37:return _context4.finish(34);case 38:return _context4.finish(31);case 39:return _context4.abrupt("return",issues);case 40:case"end":return _context4.stop();}}},_marked4,this,[[14,27,31,39],[32,,34,38]]);}function resolveBasketItemsIssues(issues){var _iteratorNormalCompletion2,_didIteratorError2,_iteratorError2,_iterator2,_step2,issue;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function resolveBasketItemsIssues$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:if(!(issues===undefined)){_context5.next=2;break;}return _context5.abrupt("return");case 2:// delete basket items that caused issues
_iteratorNormalCompletion2=true;_didIteratorError2=false;_iteratorError2=undefined;_context5.prev=5;_iterator2=issues[Symbol.iterator]();case 7:if(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done){_context5.next=14;break;}issue=_step2.value;_context5.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_52" /* deleteBasketItem */])("payment",issue.get("basketItemID")));case 11:_iteratorNormalCompletion2=true;_context5.next=7;break;case 14:_context5.next=20;break;case 16:_context5.prev=16;_context5.t0=_context5["catch"](5);_didIteratorError2=true;_iteratorError2=_context5.t0;case 20:_context5.prev=20;_context5.prev=21;if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}case 23:_context5.prev=23;if(!_didIteratorError2){_context5.next=26;break;}throw _iteratorError2;case 26:return _context5.finish(23);case 27:return _context5.finish(20);case 28:case"end":return _context5.stop();}}},_marked5,this,[[5,16,20,28],[21,,23,27]]);}

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateBasketItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_entities_BasketItemIssue__ = __webpack_require__(77);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(validateBasketItem),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(isExpired),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(isLimitedPlacesFull);/**
 * Check for issues with the given basket item.
 * Returns zero or one issues.
 *
 * @param {BasketItem} basketItem
 * @returns {BasketItemIssue | undefined}
 */function validateBasketItem(basketItem){var _basketItem$payload$t,paymentID,installmentNumber;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function validateBasketItem$(_context){while(1){switch(_context.prev=_context.next){case 0:_basketItem$payload$t=basketItem.payload.toObject(),paymentID=_basketItem$payload$t.paymentID,installmentNumber=_basketItem$payload$t.installmentNumber;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(isExpired,paymentID,installmentNumber);case 3:if(!_context.sent){_context.next=5;break;}return _context.abrupt("return",__WEBPACK_IMPORTED_MODULE_3_state_school_money_entities_BasketItemIssue__["a" /* default */].fromBasketItem(basketItem,"expired"));case 5:_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(isLimitedPlacesFull,paymentID);case 7:if(!_context.sent){_context.next=9;break;}return _context.abrupt("return",__WEBPACK_IMPORTED_MODULE_3_state_school_money_entities_BasketItemIssue__["a" /* default */].fromBasketItem(basketItem,"limited_places"));case 9:case"end":return _context.stop();}}},_marked,this);}/**
 * Has the payment or installment disappeared from state?
 * @returns {boolean}
 */function isExpired(paymentID,installmentNumber){var paymentIDList,payment;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function isExpired$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_22" /* getPaymentIDList */]);case 2:paymentIDList=_context2.sent;if(paymentIDList.includes(paymentID)){_context2.next=5;break;}return _context2.abrupt("return",true);case 5:_context2.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_21" /* getPaymentByID */],paymentID);case 7:payment=_context2.sent;return _context2.abrupt("return",!payment.installments.has(installmentNumber));case 9:case"end":return _context2.stop();}}},_marked2,this);}/**
 * Have the limited places on this payment been filled?
 * @returns {boolean}
 */function isLimitedPlacesFull(paymentID){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function isLimitedPlacesFull$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_102" /* isPaymentOutOfPlaces */],paymentID);case 2:return _context3.abrupt("return",_context3.sent);case 3:case"end":return _context3.stop();}}},_marked3,this);}

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = setBasketQuantity;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeFromBasket;
/* harmony export (immutable) */ __webpack_exports__["a"] = detectBasketItemsIssues;
/* harmony export (immutable) */ __webpack_exports__["c"] = resolveBasketItemsIssues;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_exact_math__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_exact_math___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_exact_math__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_sagas_basketSaga_shopItem_validateBasketItem__ = __webpack_require__(390);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(setBasketQuantity),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(removeFromBasket),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(detectBasketItemsIssues),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(resolveBasketItemsIssues);function formatBasketItemID(studentID,shopItemID){return studentID+":"+shopItemID;}function setBasketQuantity(action){var _action$payload,shopItemID,studentID,quantity,shopItem,schoolID,basketItemID,payload,price;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function setBasketQuantity$(_context){while(1){switch(_context.prev=_context.next){case 0:_action$payload=action.payload,shopItemID=_action$payload.shopItemID,studentID=_action$payload.studentID,quantity=_action$payload.quantity;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_44" /* getShopItemByID */],shopItemID);case 3:shopItem=_context.sent;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_56" /* getStudentSchoolID */],studentID);case 6:schoolID=_context.sent;basketItemID=formatBasketItemID(studentID,shopItemID);payload={shopItemID:shopItemID,studentID:studentID,quantity:quantity,shopItem:shopItem};price=__WEBPACK_IMPORTED_MODULE_3_exact_math___default.a.mul(quantity,shopItem.get("price"));_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_98" /* setBasketItem */])("shopItem",basketItemID,schoolID,studentID,basketItemID,price,quantity,payload));case 12:case"end":return _context.stop();}}},_marked,this);}function removeFromBasket(action){var _action$payload2,shopItemID,studentID,basketItemID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function removeFromBasket$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_action$payload2=action.payload,shopItemID=_action$payload2.shopItemID,studentID=_action$payload2.studentID;basketItemID=formatBasketItemID(studentID,shopItemID);_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_52" /* deleteBasketItem */])("shopItem",basketItemID));case 4:case"end":return _context2.stop();}}},_marked2,this);}function detectBasketItemsIssues(){var basketItems,issues,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,basketItem,issue;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function detectBasketItemsIssues$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_110" /* isShopReady */]);case 2:if(_context3.sent){_context3.next=7;break;}_context3.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])();case 5:_context3.next=0;break;case 7:_context3.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["y" /* getBasketItemsOfType */],"shopItem");case 9:basketItems=_context3.sent;// build up a list of issues
issues=__WEBPACK_IMPORTED_MODULE_1_immutable___default.a.List();_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context3.prev=14;_iterator=basketItems[Symbol.iterator]();case 16:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context3.next=25;break;}basketItem=_step.value;_context3.next=20;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_6_state_school_money_sagas_basketSaga_shopItem_validateBasketItem__["a" /* default */],basketItem);case 20:issue=_context3.sent;if(issue){issues=issues.push(issue);}case 22:_iteratorNormalCompletion=true;_context3.next=16;break;case 25:_context3.next=31;break;case 27:_context3.prev=27;_context3.t0=_context3["catch"](14);_didIteratorError=true;_iteratorError=_context3.t0;case 31:_context3.prev=31;_context3.prev=32;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 34:_context3.prev=34;if(!_didIteratorError){_context3.next=37;break;}throw _iteratorError;case 37:return _context3.finish(34);case 38:return _context3.finish(31);case 39:return _context3.abrupt("return",issues);case 40:case"end":return _context3.stop();}}},_marked3,this,[[14,27,31,39],[32,,34,38]]);}function resolveBasketItemsIssues(issues){var _iteratorNormalCompletion2,_didIteratorError2,_iteratorError2,_iterator2,_step2,issue,_issue$toObject,basketItemID,reason,basketItem,shopItemID,shopItem,_basketItem$toObject,studentID,_shopItem$toObject,quantity;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function resolveBasketItemsIssues$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(!(issues===undefined)){_context4.next=2;break;}return _context4.abrupt("return");case 2:_iteratorNormalCompletion2=true;_didIteratorError2=false;_iteratorError2=undefined;_context4.prev=5;_iterator2=issues[Symbol.iterator]();case 7:if(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done){_context4.next=29;break;}issue=_step2.value;_issue$toObject=issue.toObject(),basketItemID=_issue$toObject.basketItemID,reason=_issue$toObject.reason;// if insufficient stock then amend the quantity in basket
if(!(reason==="insufficient_stock")){_context4.next=24;break;}_context4.next=13;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["t" /* getBasketItemByID */],"shopItem",basketItemID);case 13:basketItem=_context4.sent;shopItemID=basketItem.getIn(["payload","shopItemID"]);_context4.next=17;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_44" /* getShopItemByID */],shopItemID);case 17:shopItem=_context4.sent;_basketItem$toObject=basketItem.toObject(),studentID=_basketItem$toObject.studentID;_shopItem$toObject=shopItem.toObject(),quantity=_shopItem$toObject.quantity;_context4.next=22;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_108" /* setShopItemBasketQuantity */])(shopItemID,studentID,quantity));case 22:_context4.next=26;break;case 24:_context4.next=26;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_52" /* deleteBasketItem */])("shopItem",basketItemID));case 26:_iteratorNormalCompletion2=true;_context4.next=7;break;case 29:_context4.next=35;break;case 31:_context4.prev=31;_context4.t0=_context4["catch"](5);_didIteratorError2=true;_iteratorError2=_context4.t0;case 35:_context4.prev=35;_context4.prev=36;if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}case 38:_context4.prev=38;if(!_didIteratorError2){_context4.next=41;break;}throw _iteratorError2;case 41:return _context4.finish(38);case 42:return _context4.finish(35);case 43:case"end":return _context4.stop();}}},_marked4,this,[[5,31,35,43],[36,,38,42]]);}

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateBasketItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_entities_BasketItemIssue__ = __webpack_require__(77);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(validateBasketItem),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(isExpired);/**
 * Check for issues with the given basket item.
 * Returns zero or one issues.
 *
 * @param {BasketItem} basketItem
 * @returns {BasketItemIssue | undefined}
 */function validateBasketItem(basketItem){var shopItemID,shopItem;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function validateBasketItem$(_context){while(1){switch(_context.prev=_context.next){case 0:shopItemID=basketItem.payload.get("shopItemID");_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(isExpired,shopItemID);case 3:if(!_context.sent){_context.next=5;break;}return _context.abrupt("return",__WEBPACK_IMPORTED_MODULE_3_state_school_money_entities_BasketItemIssue__["a" /* default */].fromBasketItem(basketItem,"expired"));case 5:_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_44" /* getShopItemByID */],shopItemID);case 7:shopItem=_context.sent;if(!isOutOfStock(shopItem)){_context.next=10;break;}return _context.abrupt("return",__WEBPACK_IMPORTED_MODULE_3_state_school_money_entities_BasketItemIssue__["a" /* default */].fromBasketItem(basketItem,"out_of_stock"));case 10:if(!hasInsufficientStock(basketItem,shopItem)){_context.next=12;break;}return _context.abrupt("return",__WEBPACK_IMPORTED_MODULE_3_state_school_money_entities_BasketItemIssue__["a" /* default */].fromBasketItem(basketItem,"insufficient_stock"));case 12:case"end":return _context.stop();}}},_marked,this);}/**
 * Has the shop item disappeared from state?
 * @returns {boolean}
 */function isExpired(shopItemID){var shopItemIDList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function isExpired$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_45" /* getShopItemIDList */]);case 2:shopItemIDList=_context2.sent;return _context2.abrupt("return",!shopItemIDList.includes(shopItemID));case 4:case"end":return _context2.stop();}}},_marked2,this);}/**
 * Has this shop item gone out of stock?
 * @returns {boolean}
 */function isOutOfStock(shopItem){return shopItem.get("quantity")===0;}/**
 * Does this shop item have less stock than the user has added to their basket?
 * @returns {boolean}
 */function hasInsufficientStock(basketItem,shopItem){return shopItem.get("quantity")<basketItem.payload.get("quantity");}

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addToBasket;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeFromBasket;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_exact_math__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_exact_math___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_exact_math__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(addToBasket),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(removeFromBasket);function formatBasketItemID(studentID,creditType){return studentID+":"+creditType;}function addToBasket(action){var _action$payload,studentID,creditType,amount,previousAmount,schoolID,basketItemID,payload,price;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function addToBasket$(_context){while(1){switch(_context.prev=_context.next){case 0:_action$payload=action.payload,studentID=_action$payload.studentID,creditType=_action$payload.creditType,amount=_action$payload.amount;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["R" /* getCreditTopUpAmount */],studentID,creditType);case 3:previousAmount=_context.sent;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_56" /* getStudentSchoolID */],studentID);case 6:schoolID=_context.sent;basketItemID=formatBasketItemID(studentID,creditType);payload={studentID:studentID,creditType:creditType};price=__WEBPACK_IMPORTED_MODULE_2_exact_math___default.a.add(amount,previousAmount);_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_98" /* setBasketItem */])("creditTopUp",basketItemID,schoolID,studentID,basketItemID,price,1,payload));case 12:case"end":return _context.stop();}}},_marked,this);}function removeFromBasket(action){var _action$payload2,studentID,creditType,basketItemID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function removeFromBasket$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_action$payload2=action.payload,studentID=_action$payload2.studentID,creditType=_action$payload2.creditType;basketItemID=formatBasketItemID(studentID,creditType);_context2.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_52" /* deleteBasketItem */])("creditTopUp",basketItemID));case 4:case"end":return _context2.stop();}}},_marked2,this);}

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransactionSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_date__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_appserver_aggregate__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_app_selectors__ = __webpack_require__(8);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(createTransactionSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getApplePayJWT),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getGooglePayJWT),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(formatBasketItem),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(formatClubBasketItem),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(formatDinnerBasketItem),_marked7=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(formatPaymentBasketItem),_marked8=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(formatShopItemBasketItem),_marked9=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(formatCreditTopUpBasketItem);/**
 * Saga to call the create_transaction API.
 * This sets up a pending transaction on SM's database which we can later
 *   complete using confirm_transaction API.
 * It will also validate our basket items and give us a finalised total.
 */function createTransactionSaga(action){var schoolID,userIdentity,_deconstructSchoolID,serverID,remoteSchoolID,basketItems,isApplePayEnabled,isGooglePayEnabled,items,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,basketItem,response,walletPayJWTString,transaction;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function createTransactionSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:// transactions are per-school, so our action will specify which one
schoolID=action.payload.schoolID;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_7_state_app_selectors__["k" /* getUserIdentity */]);case 3:userIdentity=_context.sent;_deconstructSchoolID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_appserver_aggregate__["e" /* deconstructSchoolID */])(schoolID),serverID=_deconstructSchoolID.serverID,remoteSchoolID=_deconstructSchoolID.remoteSchoolID;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_27" /* getSchoolBasketItems */],schoolID);case 7:basketItems=_context.sent;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_67" /* isApplePayEnabledForSchool */],schoolID);case 10:isApplePayEnabled=_context.sent;_context.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_92" /* isGooglePayEnabledForSchool */],schoolID);case 13:isGooglePayEnabled=_context.sent;// build the list of items
// this looks like we should be using `basketItems.map()` but we can't
//   because we need to use `yield` (not possible in nested functions)
items=[];_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context.prev=18;_iterator=basketItems[Symbol.iterator]();case 20:if(_iteratorNormalCompletion=(_step=_iterator.next()).done){_context.next=29;break;}basketItem=_step.value;_context.t0=items;return _context.delegateYield(formatBasketItem(basketItem),"t1",24);case 24:_context.t2=_context.t1;_context.t0.push.call(_context.t0,_context.t2);case 26:_iteratorNormalCompletion=true;_context.next=20;break;case 29:_context.next=35;break;case 31:_context.prev=31;_context.t3=_context["catch"](18);_didIteratorError=true;_iteratorError=_context.t3;case 35:_context.prev=35;_context.prev=36;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 38:_context.prev=38;if(!_didIteratorError){_context.next=41;break;}throw _iteratorError;case 41:return _context.finish(38);case 42:return _context.finish(35);case 43:_context.next=45;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_4_state_fetchSagas__["b" /* sendSchoolMoneyDataRequest */],"create_transaction",{server_id:serverID,remote_school_id:remoteSchoolID,items:JSON.stringify(items)});case 45:response=_context.sent;walletPayJWTString=undefined;transaction=response.data.transaction;if(!(transaction.total===0)){_context.next=53;break;}_context.next=51;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_51" /* completeCheckout */])());case 51:_context.next=64;break;case 53:if(!(userIdentity.get("appReferrer")!=="parentapps")){_context.next=62;break;}if(!(isApplePayEnabled&&userIdentity.get("platform")==="iphone"&&parseInt(userIdentity.get("osVersion"),10)>=13)){_context.next=59;break;}return _context.delegateYield(getApplePayJWT(serverID,remoteSchoolID,transaction),"t4",56);case 56:walletPayJWTString=_context.t4;_context.next=62;break;case 59:if(!(isGooglePayEnabled&&userIdentity.get("platform")==="android"&&parseInt(userIdentity.get("osVersion"),10)>5)){_context.next=62;break;}return _context.delegateYield(getGooglePayJWT(serverID,remoteSchoolID,transaction),"t5",61);case 61:walletPayJWTString=_context.t5;case 62:_context.next=64;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_101" /* setCheckoutTransactionDetails */])(transaction.id,transaction.total,walletPayJWTString));case 64:case"end":return _context.stop();}}},_marked,this,[[18,31,35,43],[36,,38,42]]);}/**
 * Get jwt string to use for apple pay
 */function getApplePayJWT(serverID,remoteSchoolID,transaction){var jwtResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getApplePayJWT$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.t0=__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */];_context2.t1=__WEBPACK_IMPORTED_MODULE_4_state_fetchSagas__["b" /* sendSchoolMoneyDataRequest */];_context2.t2=serverID;_context2.t3=remoteSchoolID;_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_7_state_app_selectors__["j" /* getMobileNumber */]);case 6:_context2.t4=_context2.sent;_context2.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_7_state_app_selectors__["c" /* getDeviceToken */]);case 9:_context2.t5=_context2.sent;_context2.t6=transaction.total;_context2.t7=transaction.id;_context2.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_7_state_app_selectors__["l" /* getUserIdentityAppReferrer */]);case 14:_context2.t8=_context2.sent;_context2.t9={server_id:_context2.t2,remote_school_id:_context2.t3,mobile_number:_context2.t4,device_token:_context2.t5,amount:_context2.t6,transaction_id:_context2.t7,product:_context2.t8};_context2.next=18;return(0,_context2.t0)(_context2.t1,"get_st_apple_pay_jwt",_context2.t9);case 18:jwtResponse=_context2.sent;if(!(jwtResponse.status==="error")){_context2.next=23;break;}_context2.next=22;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_94" /* secureTradingError */])({code:jwtResponse.code,description:jwtResponse.message}));case 22:return _context2.abrupt("return");case 23:return _context2.abrupt("return",jwtResponse.data.jwt);case 24:case"end":return _context2.stop();}}},_marked2,this);}/**
 * Get jwt string to use for google pay
 */function getGooglePayJWT(serverID,remoteSchoolID,transaction){var jwtResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getGooglePayJWT$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.t0=__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */];_context3.t1=__WEBPACK_IMPORTED_MODULE_4_state_fetchSagas__["b" /* sendSchoolMoneyDataRequest */];_context3.t2=serverID;_context3.t3=remoteSchoolID;_context3.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_7_state_app_selectors__["j" /* getMobileNumber */]);case 6:_context3.t4=_context3.sent;_context3.next=9;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_7_state_app_selectors__["c" /* getDeviceToken */]);case 9:_context3.t5=_context3.sent;_context3.t6=transaction.total;_context3.t7=transaction.id;_context3.t8={server_id:_context3.t2,remote_school_id:_context3.t3,mobile_number:_context3.t4,device_token:_context3.t5,amount:_context3.t6,transaction_id:_context3.t7};_context3.next=15;return(0,_context3.t0)(_context3.t1,"get_st_google_pay_jwt",_context3.t8);case 15:jwtResponse=_context3.sent;if(!(jwtResponse.status==="error")){_context3.next=20;break;}_context3.next=19;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_94" /* secureTradingError */])({code:jwtResponse.code,description:jwtResponse.message}));case 19:return _context3.abrupt("return");case 20:return _context3.abrupt("return",jwtResponse.data.jwt);case 21:case"end":return _context3.stop();}}},_marked3,this);}/**
 * Delegate to payload formatting functions for each item type.
 */function formatBasketItem(basketItem){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function formatBasketItem$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.t0=basketItem.type;_context4.next=_context4.t0==="clubBooking"?3:_context4.t0==="dinnerBooking"?5:_context4.t0==="payment"?7:_context4.t0==="shopItem"?9:_context4.t0==="creditTopUp"?11:13;break;case 3:return _context4.delegateYield(formatClubBasketItem(basketItem),"t1",4);case 4:return _context4.abrupt("return",_context4.t1);case 5:return _context4.delegateYield(formatDinnerBasketItem(basketItem),"t2",6);case 6:return _context4.abrupt("return",_context4.t2);case 7:return _context4.delegateYield(formatPaymentBasketItem(basketItem),"t3",8);case 8:return _context4.abrupt("return",_context4.t3);case 9:return _context4.delegateYield(formatShopItemBasketItem(basketItem),"t4",10);case 10:return _context4.abrupt("return",_context4.t4);case 11:return _context4.delegateYield(formatCreditTopUpBasketItem(basketItem),"t5",12);case 12:return _context4.abrupt("return",_context4.t5);case 13:return _context4.abrupt("return",undefined);case 14:case"end":return _context4.stop();}}},_marked4,this);}function formatClubBasketItem(_ref){var studentID=_ref.studentID,price=_ref.price,payload=_ref.payload;var clubBookingID,clubBooking,remoteStudentID,remoteInstallmentID,remoteID,remoteParentID,bookings,weekdayIndex,selectedSession,date,id,_price,description;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function formatClubBasketItem$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:clubBookingID=payload.get("clubBookingID");_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["I" /* getClubBookingByID */],clubBookingID);case 3:clubBooking=_context5.sent;remoteStudentID=clubBooking.remoteStudentID,remoteInstallmentID=clubBooking.remoteInstallmentID,remoteID=clubBooking.remoteID;_context5.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_55" /* getStudentRemoteParentID */],studentID);case 7:remoteParentID=_context5.sent;bookings=[];weekdayIndex=0;case 10:if(!(weekdayIndex<__WEBPACK_IMPORTED_MODULE_2_lib_date__["a" /* WEEKDAYS */].length)){_context5.next=21;break;}_context5.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["M" /* getClubBookingSelectedSession */],clubBookingID,weekdayIndex);case 13:selectedSession=_context5.sent;_context5.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["J" /* getClubBookingDayDate */],clubBookingID,weekdayIndex);case 16:date=_context5.sent;// only add session details if a session is booked
if(selectedSession===undefined){bookings.push({club_date:date,status:"N"});}else{id=selectedSession.id,_price=selectedSession.price,description=selectedSession.description;bookings.push({club_date:date,status:"Y",session_booked:{id:id,price:_price,description:description}});}case 18:weekdayIndex++;_context5.next=10;break;case 21:return _context5.abrupt("return",{id:remoteID,type:"club",payload:{student_fk:remoteStudentID,parent_fk:remoteParentID,installment_fk:remoteInstallmentID,amount:price,monday_booking:bookings[0],tuesday_booking:bookings[1],wednesday_booking:bookings[2],thursday_booking:bookings[3],friday_booking:bookings[4]}});case 22:case"end":return _context5.stop();}}},_marked5,this);}function formatDinnerBasketItem(_ref2){var studentID=_ref2.studentID,price=_ref2.price,payload=_ref2.payload;var dinnerBookingID,dinnerBooking,remoteStudentID,remoteInstallmentID,remoteID,type,isCashless,remoteParentID,bookings,weekdayIndex,selectedOption,date,isSelected,booking,id,name,_price2;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function formatDinnerBasketItem$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dinnerBookingID=payload.get("dinnerBookingID");_context6.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["V" /* getDinnerBookingByID */],dinnerBookingID);case 3:dinnerBooking=_context6.sent;remoteStudentID=dinnerBooking.remoteStudentID,remoteInstallmentID=dinnerBooking.remoteInstallmentID,remoteID=dinnerBooking.remoteID,type=dinnerBooking.type,isCashless=dinnerBooking.isCashless;_context6.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_55" /* getStudentRemoteParentID */],studentID);case 7:remoteParentID=_context6.sent;bookings=[];weekdayIndex=0;case 10:if(!(weekdayIndex<__WEBPACK_IMPORTED_MODULE_2_lib_date__["a" /* WEEKDAYS */].length)){_context6.next=22;break;}_context6.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["Z" /* getDinnerBookingSelectedOption */],dinnerBookingID,weekdayIndex);case 13:selectedOption=_context6.sent;_context6.next=16;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["W" /* getDinnerBookingDayDate */],dinnerBookingID,weekdayIndex);case 16:date=_context6.sent;isSelected=selectedOption!==null;if(isCashless){// cashless dinners require the item object if status == "MEAL"
booking={dinner_date:date};booking.status=isSelected?"MEAL":"NONE";if(isSelected){id=selectedOption.id,name=selectedOption.name,_price2=selectedOption.price;booking.item={id:id,name:name,price:_price2};}bookings.push(booking);}else{// noncashless/meat-veg requires only the status
bookings.push({dinner_date:date,status:isSelected?selectedOption.id:"NONE"});}case 19:weekdayIndex++;_context6.next=10;break;case 22:return _context6.abrupt("return",{id:remoteID,type:"dinner",payload:{student_fk:remoteStudentID,parent_fk:remoteParentID,installment_fk:remoteInstallmentID,amount:price,dinner_type:type,monday_booking:bookings[0],tuesday_booking:bookings[1],wednesday_booking:bookings[2],thursday_booking:bookings[3],friday_booking:bookings[4]}});case 23:case"end":return _context6.stop();}}},_marked6,this);}function formatPaymentBasketItem(_ref3){var studentID=_ref3.studentID,price=_ref3.price,payload=_ref3.payload;var _payload$toObject,paymentID,installmentNumber,payment,remoteStudentID,remoteInstallmentID,remoteID,remoteParentID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function formatPaymentBasketItem$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_payload$toObject=payload.toObject(),paymentID=_payload$toObject.paymentID,installmentNumber=_payload$toObject.installmentNumber;_context7.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_21" /* getPaymentByID */],paymentID);case 3:payment=_context7.sent;remoteStudentID=payment.remoteStudentID,remoteInstallmentID=payment.remoteInstallmentID,remoteID=payment.remoteID;_context7.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_55" /* getStudentRemoteParentID */],studentID);case 7:remoteParentID=_context7.sent;return _context7.abrupt("return",{id:remoteID,type:"payment",payload:{student_fk:remoteStudentID,parent_fk:remoteParentID,installment_fk:remoteInstallmentID,installment_number:installmentNumber,amount:price}});case 9:case"end":return _context7.stop();}}},_marked7,this);}function formatShopItemBasketItem(_ref4){var studentID=_ref4.studentID,price=_ref4.price,payload=_ref4.payload;var _deconstructStudentID,remoteStudentID,_payload$toObject2,shopItemID,quantity,_deconstructEntityID,remoteID,remoteParentID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function formatShopItemBasketItem$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_deconstructStudentID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_appserver_aggregate__["f" /* deconstructStudentID */])(studentID),remoteStudentID=_deconstructStudentID.remoteStudentID;_payload$toObject2=payload.toObject(),shopItemID=_payload$toObject2.shopItemID,quantity=_payload$toObject2.quantity;_deconstructEntityID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_appserver_aggregate__["d" /* deconstructEntityID */])(shopItemID),remoteID=_deconstructEntityID.remoteID;_context8.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_55" /* getStudentRemoteParentID */],studentID);case 5:remoteParentID=_context8.sent;return _context8.abrupt("return",{id:remoteID,type:"shop_item",payload:{student_fk:remoteStudentID,parent_fk:remoteParentID,amount:price,quantity:quantity}});case 7:case"end":return _context8.stop();}}},_marked8,this);}function formatCreditTopUpBasketItem(_ref5){var studentID=_ref5.studentID,price=_ref5.price,payload=_ref5.payload;var _deconstructStudentID2,remoteStudentID,_payload$toObject3,creditType,remoteParentID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function formatCreditTopUpBasketItem$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_deconstructStudentID2=Object(__WEBPACK_IMPORTED_MODULE_3_lib_appserver_aggregate__["f" /* deconstructStudentID */])(studentID),remoteStudentID=_deconstructStudentID2.remoteStudentID;_payload$toObject3=payload.toObject(),creditType=_payload$toObject3.creditType;_context9.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_55" /* getStudentRemoteParentID */],studentID);case 4:remoteParentID=_context9.sent;return _context9.abrupt("return",{id:creditType,type:"top_up",payload:{student_fk:remoteStudentID,parent_fk:remoteParentID,amount:price}});case 6:case"end":return _context9.stop();}}},_marked9,this);}

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = confirmTransactionSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_aggregate__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_appserver_responseExceptions_RemoteServerCompleteFailureError__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__ = __webpack_require__(4);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(confirmTransactionSaga);function confirmTransactionSaga(action){var _action$payload,paysafeSingleUseToken,cardholderName,transactionID,schoolID,_deconstructSchoolID,serverID,remoteSchoolID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function confirmTransactionSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_action$payload=action.payload,paysafeSingleUseToken=_action$payload.paysafeSingleUseToken,cardholderName=_action$payload.cardholderName;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["G" /* getCheckoutTransactionID */]);case 3:transactionID=_context.sent;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["D" /* getCheckoutSchoolID */]);case 6:schoolID=_context.sent;_deconstructSchoolID=Object(__WEBPACK_IMPORTED_MODULE_2_lib_appserver_aggregate__["e" /* deconstructSchoolID */])(schoolID),serverID=_deconstructSchoolID.serverID,remoteSchoolID=_deconstructSchoolID.remoteSchoolID;_context.prev=8;_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_4_state_fetchSagas__["b" /* sendSchoolMoneyDataRequest */],"confirm_transaction",{server_id:serverID,remote_school_id:remoteSchoolID,transaction_id:transactionID,single_use_token:paysafeSingleUseToken,cardholder_name:cardholderName});case 11:_context.next=22;break;case 13:_context.prev=13;_context.t0=_context["catch"](8);if(!(_context.t0.type===__WEBPACK_IMPORTED_MODULE_3_lib_appserver_responseExceptions_RemoteServerCompleteFailureError__["a" /* default */].type)){_context.next=21;break;}_context.next=18;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_100" /* setCheckoutError */])("ERROR_REMOTE_SERVER_FAIL"));case 18:return _context.abrupt("return");case 21:throw _context.t0;case 22:_context.next=24;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_51" /* completeCheckout */])());case 24:case"end":return _context.stop();}}},_marked,this,[[8,13]]);}

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = completeCheckoutSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(completeCheckoutSaga);/**
 * When we have completed a transaction, clear out all the
 *   basket items for that school and do a full data refresh.
 */function completeCheckoutSaga(){var schoolID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function completeCheckoutSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["D" /* getCheckoutSchoolID */]);case 2:schoolID=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_40" /* clearBasketItems */])(schoolID));case 5:_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_56" /* fetchAll */])(true,true,true,true,true,true));case 7:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handlePaysafeErrorSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_log__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(handlePaysafeErrorSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(recover);/**
 * When we get a paysafe error, log the details and recover or die.
 */function handlePaysafeErrorSaga(action){var error,isRecovering;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function handlePaysafeErrorSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:error=action.payload.error;__WEBPACK_IMPORTED_MODULE_2_lib_log__["a" /* default */].warn("Paysafe API error",error.originalError);return _context.delegateYield(recover(error),"t0",3);case 3:isRecovering=_context.t0;if(isRecovering){_context.next=7;break;}_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_app_actions__["G" /* fatalError */])(error));case 7:case"end":return _context.stop();}}},_marked,this);}/**
 * Detect non-fatal errors and dispatch actions that may allow
 *   them to be handled gracefully.
 * @returns {boolean} `true` if error is recoverable, `false` otherwise
 */function recover(_ref){var stage=_ref.stage,originalError=_ref.originalError;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function recover$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.t0=originalError.code;_context2.next=_context2.t0==="9001"?3:_context2.t0==="9002"?3:_context2.t0==="9003"?6:_context2.t0==="9037"?9:_context2.t0==="9039"?12:_context2.t0==="9040"?12:_context2.t0==="9042"?12:15;break;case 3:_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_100" /* setCheckoutError */])("ERROR_CONNECTION"));case 5:return _context2.abrupt("return",true);case 6:_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_100" /* setCheckoutError */])("ERROR_INVALID_FIELDS"));case 8:return _context2.abrupt("return",true);case 9:_context2.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_100" /* setCheckoutError */])("ERROR_3DS_CONNECTION"));case 11:return _context2.abrupt("return",true);case 12:_context2.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_100" /* setCheckoutError */])("ERROR_3DS_FAILED"));case 14:return _context2.abrupt("return",true);case 15:return _context2.abrupt("return",false);case 16:case"end":return _context2.stop();}}},_marked2,this);}

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleSecureTradingErrorSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_log__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(handleSecureTradingErrorSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(errMessages);// When we get a Secure Trading error, log the details and recover or die.
function handleSecureTradingErrorSaga(action){var error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function handleSecureTradingErrorSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:error=action.payload.error;return _context.delegateYield(errMessages(error),"t0",2);case 2:__WEBPACK_IMPORTED_MODULE_2_lib_log__["a" /* default */].warn("Secure Trading API error",error.description+"(code: "+error.code+")");case 3:case"end":return _context.stop();}}},_marked,this);}// Detect and use predefined message, if code doesn't match use the error message
// from Secure Trading.
function errMessages(error){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function errMessages$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.t0=error.code;_context2.next=_context2.t0==="SM001"?3:_context2.t0==="10003"?6:_context2.t0==="50003"?9:_context2.t0==="60010"?12:_context2.t0==="70000"?15:_context2.t0==="60022"?18:_context2.t0==="00000"?21:_context2.t0==="30000"?24:_context2.t0==="DUPLICATE_TRANSACTION"?25:_context2.t0==="INVALID_AMOUNT"?28:_context2.t0==="SERVER_ERROR"?31:_context2.t0==="INVALID_RESPONSE"?34:_context2.t0==="API_ERROR"?37:_context2.t0==="INIT_FAIL"?40:_context2.t0==="BUYER_ACCOUNT_ERROR"?43:_context2.t0==="MERCHANT_ACCOUNT_ERROR"?46:_context2.t0==="GOOGLE_PAY_INVALID_CARD_DETAILS"?49:52;break;case 3:_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("PROGRAMMING_ERROR"));case 5:return _context2.abrupt("return");case 6:_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("ERROR_CARD_DETAILS_INCORRECT",error.code));case 8:return _context2.abrupt("return");case 9:_context2.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("ERROR_PROCESS_PAYMENT",error.code));case 11:return _context2.abrupt("return");case 12:_context2.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("ISSUING_BANK_SYSTEM_ERROR",error.code));case 14:return _context2.abrupt("return");case 15:_context2.next=17;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("ERROR_ISSUING_BANK_DECLINED_PAYMENT",error.code));case 17:return _context2.abrupt("return");case 18:_context2.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("ERROR_AUTHORISE_PAYMENT",error.code));case 20:return _context2.abrupt("return");case 21:_context2.next=23;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("UNKNOWN_ERROR",error.code));case 23:return _context2.abrupt("return");case 24:return _context2.abrupt("return");case 25:_context2.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("DUPLICATE_TRANSACTION"));case 27:return _context2.abrupt("return");case 28:_context2.next=30;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("INVALID_AMOUNT"));case 30:return _context2.abrupt("return");case 31:_context2.next=33;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("SERVER_ERROR"));case 33:return _context2.abrupt("return");case 34:_context2.next=36;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("INVALID_RESPONSE"));case 36:return _context2.abrupt("return");case 37:_context2.next=39;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("API_ERROR"));case 39:return _context2.abrupt("return");case 40:_context2.next=42;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("INIT_FAIL"));case 42:return _context2.abrupt("return");case 43:_context2.next=45;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("BUYER_ACCOUNT_ERROR"));case 45:return _context2.abrupt("return");case 46:_context2.next=48;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("MERCHANT_ACCOUNT_ERROR"));case 48:return _context2.abrupt("return");case 49:_context2.next=51;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("GOOGLE_PAY_INVALID_CARD_DETAILS"));case 51:return _context2.abrupt("return");case 52:_context2.next=54;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_100" /* setCheckoutError */])("ERROR_UNABLE_TO_PROCESS_PAYMENT"));case 54:return _context2.abrupt("return");case 55:case"end":return _context2.stop();}}},_marked2,this);}

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = processMetadataSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_log__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_sagas_processMetadataSaga_metadataSagas__ = __webpack_require__(398);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(refresh),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(waitForCheckoutWindowToClose),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(processMetadataSaga);var NOTIFICATION_TYPES=["payment","club_booking","dinner_booking","shop_item","overdue","consent","shop_collection_reminder"];/**
 * Refresh all APIs
 */function refresh(forceSchoolFetch,forceStudentFetch,forceParentFetch,forceActivePaymentFetch,forceShopFetch,forceHistoryFetch){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function refresh$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_56" /* fetchAll */])(forceSchoolFetch,forceStudentFetch,forceParentFetch,forceActivePaymentFetch,forceShopFetch,forceHistoryFetch));case 2:case"end":return _context.stop();}}},_marked,this);}// Prevents app refresh if CheckoutWindow is open
function waitForCheckoutWindowToClose(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function waitForCheckoutWindowToClose$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_71" /* isCheckoutWindowOpen */]);case 2:if(!_context2.sent){_context2.next=7;break;}_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])();case 5:_context2.next=0;break;case 7:case"end":return _context2.stop();}}},_marked2,this);}function processMetadataSaga(action){var metadata;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function processMetadataSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(waitForCheckoutWindowToClose);case 2:if(!(action.payload.metadata==="")){_context3.next=4;break;}return _context3.abrupt("return");case 4:if(!(action.payload.metadata==="refresh")){_context3.next=10;break;}_context3.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(refresh,false,false,false,false,false,false);case 7:_context3.next=9;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_app_actions__["F" /* closeLoadingFrame */])());case 9:return _context3.abrupt("return");case 10:metadata=void 0;_context3.prev=11;metadata=JSON.parse(action.payload.metadata);_context3.next=20;break;case 15:_context3.prev=15;_context3.t0=_context3["catch"](11);_context3.next=19;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_app_actions__["F" /* closeLoadingFrame */])());case 19:return _context3.abrupt("return");case 20:if(!(metadata.student_idaas_id!==undefined)){_context3.next=24;break;}_context3.next=23;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_app_actions__["F" /* closeLoadingFrame */])());case 23:return _context3.abrupt("return");case 24:// If the metadata is coming from eduspot timeline then it won't have additional details from appserver like serverID, application
// So we need to check and add this for now until we can update Eduspot to send formatted data similar to appserver
// All the metadata from SM has studentID and type
if(metadata.application===undefined){if(NOTIFICATION_TYPES.includes(metadata.type)&&metadata.hasOwnProperty("payload")&&metadata.payload.hasOwnProperty("studentID")){metadata.application="school_money";}}// check if we need to handle this
if(!(metadata.application!=="school_money")){_context3.next=27;break;}return _context3.abrupt("return");case 27:_context3.next=29;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(refresh,false,true,false,true,true,false);case 29:_context3.next=31;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_30" /* STUDENTS_FETCH_COMPLETED */]);case 31:_context3.next=33;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["h" /* take */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["b" /* ACTIVE_PAYMENTS_FETCH_COMPLETED */]);case 33:if(!(metadata.serverID===undefined)){_context3.next=37;break;}_context3.next=36;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_42" /* getServerIDForStudent */],metadata.payload.studentID);case 36:metadata.serverID=_context3.sent;case 37:_context3.t1=metadata.type;_context3.next=_context3.t1==="payment"?40:_context3.t1==="club_booking"?43:_context3.t1==="dinner_booking"?46:_context3.t1==="shop_item"?49:_context3.t1==="overdue"?52:_context3.t1==="consent"?55:_context3.t1==="shop_collection_reminder"?58:60;break;case 40:_context3.next=42;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_6_state_school_money_sagas_processMetadataSaga_metadataSagas__["e" /* payment */],metadata);case 42:return _context3.abrupt("break",62);case 43:_context3.next=45;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_6_state_school_money_sagas_processMetadataSaga_metadataSagas__["a" /* clubBooking */],metadata);case 45:return _context3.abrupt("break",62);case 46:_context3.next=48;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_6_state_school_money_sagas_processMetadataSaga_metadataSagas__["c" /* dinnerBooking */],metadata);case 48:return _context3.abrupt("break",62);case 49:_context3.next=51;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_6_state_school_money_sagas_processMetadataSaga_metadataSagas__["f" /* shopItem */],metadata);case 51:return _context3.abrupt("break",62);case 52:_context3.next=54;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_6_state_school_money_sagas_processMetadataSaga_metadataSagas__["d" /* overdue */],metadata);case 54:return _context3.abrupt("break",62);case 55:_context3.next=57;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_6_state_school_money_sagas_processMetadataSaga_metadataSagas__["b" /* consent */],metadata);case 57:return _context3.abrupt("break",62);case 58:__WEBPACK_IMPORTED_MODULE_1_lib_log__["a" /* default */].log("Process Metadata: school_money: got \"shop_collection_reminder\", taking no action.");return _context3.abrupt("break",62);case 60:__WEBPACK_IMPORTED_MODULE_1_lib_log__["a" /* default */].warn("Process Metadata: school_money: unrecognised metadata type: "+metadata.type);return _context3.abrupt("break",62);case 62:_context3.next=64;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_app_actions__["F" /* closeLoadingFrame */])());case 64:case"end":return _context3.stop();}}},_marked3,this,[[11,15]]);}

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = payment;
/* harmony export (immutable) */ __webpack_exports__["a"] = clubBooking;
/* harmony export (immutable) */ __webpack_exports__["c"] = dinnerBooking;
/* harmony export (immutable) */ __webpack_exports__["f"] = shopItem;
/* harmony export (immutable) */ __webpack_exports__["d"] = overdue;
/* harmony export (immutable) */ __webpack_exports__["b"] = consent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_log__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_id__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_history__ = __webpack_require__(15);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(payment),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(clubBooking),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(dinnerBooking),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(shopItem),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(overdue),_marked6=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(consent);var MISSING_PAYMENT_MESSAGE="The payment you are looking for no longer exists.";var MISSING_DINNER_MESSAGE="The dinner item you are looking for no longer exists.";var MISSING_CLUB_MESSAGE="The club you are looking for no longer exists.";var MISSING_CONSENT_MESSAGE="The consent item you are looking for no longer exists.";var MISSING_STUDENT_MESSAGE="The student you are looking for no longer exist or the identity of the student has changed. Please contact our support team if you can't find the student you are looking for.";/**
 * Go to payment
 */function payment(_ref){var serverID=_ref.serverID,payload=_ref.payload;var paymentID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function payment$(_context){while(1){switch(_context.prev=_context.next){case 0:paymentID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_id__["a" /* aggregateID */])(serverID,payload.installmentID);_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["m" /* doesPaymentExist */],paymentID);case 3:if(!_context.sent){_context.next=8;break;}_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_72" /* goToPayment */])(paymentID));case 6:_context.next=12;break;case 8:__WEBPACK_IMPORTED_MODULE_7_state_history__["a" /* history */].push("/school_money/payments/");_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_app_actions__["O" /* openInformationModal */])({title:"Alert",message:MISSING_PAYMENT_MESSAGE}));case 11:__WEBPACK_IMPORTED_MODULE_1_lib_log__["a" /* default */].warn("Process Metadata: school_money: invalid paymentID: "+paymentID);case 12:case"end":return _context.stop();}}},_marked,this);}/**
 * Go to club booking
 */function clubBooking(_ref2){var serverID=_ref2.serverID,payload=_ref2.payload;var clubBookingID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function clubBooking$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:clubBookingID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_id__["a" /* aggregateID */])(serverID,payload.installmentID);_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["g" /* doesClubBookingExist */],clubBookingID);case 3:if(!_context2.sent){_context2.next=8;break;}_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_69" /* goToClubBooking */])(clubBookingID));case 6:_context2.next=12;break;case 8:__WEBPACK_IMPORTED_MODULE_7_state_history__["a" /* history */].push("/school_money/clubs/");_context2.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_app_actions__["O" /* openInformationModal */])({title:"Alert",message:MISSING_CLUB_MESSAGE}));case 11:__WEBPACK_IMPORTED_MODULE_1_lib_log__["a" /* default */].warn("Process Metadata: school_money: invalid clubBookingID: "+clubBookingID);case 12:case"end":return _context2.stop();}}},_marked2,this);}/**
 * Go to dinner booking
 */function dinnerBooking(_ref3){var serverID=_ref3.serverID,payload=_ref3.payload;var studentID,dinnerBookingID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function dinnerBooking$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(payload.installmentID===undefined)){_context3.next=11;break;}studentID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_id__["a" /* aggregateID */])(serverID,payload.studentID);_context3.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["o" /* doesStudentExist */],studentID);case 4:if(!_context3.sent){_context3.next=8;break;}__WEBPACK_IMPORTED_MODULE_7_state_history__["a" /* history */].push("/school_money/dinners/"+studentID+"/");_context3.next=10;break;case 8:_context3.next=10;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_app_actions__["O" /* openInformationModal */])({title:"Alert",message:MISSING_STUDENT_MESSAGE}));case 10:return _context3.abrupt("return");case 11:dinnerBookingID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_id__["a" /* aggregateID */])(serverID,payload.installmentID);_context3.next=14;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["i" /* doesDinnerBookingExist */],dinnerBookingID);case 14:if(!_context3.sent){_context3.next=19;break;}_context3.next=17;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_70" /* goToDinnerBooking */])(dinnerBookingID));case 17:_context3.next=23;break;case 19:__WEBPACK_IMPORTED_MODULE_7_state_history__["a" /* history */].push("/school_money/dinners/");_context3.next=22;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_app_actions__["O" /* openInformationModal */])({title:"Alert",message:MISSING_DINNER_MESSAGE}));case 22:__WEBPACK_IMPORTED_MODULE_1_lib_log__["a" /* default */].warn("Process Metadata: school_money: invalid dinnerBookingID: "+dinnerBookingID);case 23:case"end":return _context3.stop();}}},_marked3,this);}/**
 * Go to shop item
 */function shopItem(_ref4){var serverID=_ref4.serverID,payload=_ref4.payload;var shopItemID,studentID,shopItemExists,studentExists;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function shopItem$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:shopItemID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_id__["a" /* aggregateID */])(serverID,payload.shopItemID);studentID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_id__["a" /* aggregateID */])(serverID,payload.studentID);_context4.next=4;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["n" /* doesShopItemExist */],shopItemID);case 4:shopItemExists=_context4.sent;_context4.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["o" /* doesStudentExist */],studentID);case 7:studentExists=_context4.sent;if(!(shopItemExists&&studentExists)){_context4.next=13;break;}_context4.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_73" /* goToShopItem */])(shopItemID,studentID));case 11:_context4.next=15;break;case 13:if(!shopItemExists){__WEBPACK_IMPORTED_MODULE_1_lib_log__["a" /* default */].warn("Process Metadata: school_money: invalid shopItemID: "+shopItemID);}if(!studentExists){__WEBPACK_IMPORTED_MODULE_1_lib_log__["a" /* default */].warn("Process Metadata: school_money: invalid studentID: "+studentID);}case 15:case"end":return _context4.stop();}}},_marked4,this);}/**
 * User has overdue payments - can be a mix of payment,
 *   club booking and dinner booking.
 * We just take them to the student's Payments page,
 *   since they can pay everything off there.
 */function overdue(_ref5){var serverID=_ref5.serverID,payload=_ref5.payload;var studentID,studentExists;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function overdue$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:studentID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_id__["a" /* aggregateID */])(serverID,payload.studentID);_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["o" /* doesStudentExist */],studentID);case 3:studentExists=_context5.sent;if(!studentExists){_context5.next=8;break;}// no specific payment to go to, so just use history API to get to the page
__WEBPACK_IMPORTED_MODULE_7_state_history__["a" /* history */].push("/school_money/payments/"+studentID+"/");_context5.next=12;break;case 8:__WEBPACK_IMPORTED_MODULE_7_state_history__["a" /* history */].push("/school_money/payments/");_context5.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_app_actions__["O" /* openInformationModal */])({title:"Alert",message:MISSING_STUDENT_MESSAGE}));case 11:__WEBPACK_IMPORTED_MODULE_1_lib_log__["a" /* default */].warn("Process metadata: school_money: invalid studentID: "+studentID);case 12:case"end":return _context5.stop();}}},_marked5,this);}/**
 * Go to parental consent
 */function consent(_ref6){var serverID=_ref6.serverID,payload=_ref6.payload;var consentItemID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function consent$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:consentItemID=Object(__WEBPACK_IMPORTED_MODULE_3_lib_id__["a" /* aggregateID */])(serverID,payload.installmentID);_context6.next=3;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["l" /* doesParentalConsentItemExist */],consentItemID);case 3:if(!_context6.sent){_context6.next=8;break;}_context6.next=6;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_71" /* goToParentalConsentItem */])(consentItemID));case 6:_context6.next=12;break;case 8:__WEBPACK_IMPORTED_MODULE_7_state_history__["a" /* history */].push("/school_money/parental_consent/");_context6.next=11;return Object(__WEBPACK_IMPORTED_MODULE_2_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_app_actions__["O" /* openInformationModal */])({title:"Alert",message:MISSING_CONSENT_MESSAGE}));case 11:__WEBPACK_IMPORTED_MODULE_1_lib_log__["a" /* default */].warn("Process Metadata: school_money: invalid parentalConsentItemID: "+consentItemID);case 12:case"end":return _context6.stop();}}},_marked6,this);}

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = goToClubBookingSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(goToClubBookingSaga);function goToClubBookingSaga(action){var clubBookingID,clubBooking,studentID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function goToClubBookingSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:clubBookingID=action.payload.clubBookingID;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["I" /* getClubBookingByID */],clubBookingID);case 3:clubBooking=_context.sent;studentID=clubBooking.get("studentID");__WEBPACK_IMPORTED_MODULE_2_state_history__["a" /* history */].push("/school_money/clubs/"+studentID+"/");case 6:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = goToDinnerBookingSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(goToDinnerBookingSaga);function goToDinnerBookingSaga(action){var dinnerBookingID,dinnerBooking,studentID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function goToDinnerBookingSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:dinnerBookingID=action.payload.dinnerBookingID;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["V" /* getDinnerBookingByID */],dinnerBookingID);case 3:dinnerBooking=_context.sent;studentID=dinnerBooking.get("studentID");__WEBPACK_IMPORTED_MODULE_2_state_history__["a" /* history */].push("/school_money/dinners/"+studentID+"/");case 6:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = goToPaymentSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(goToPaymentSaga);function goToPaymentSaga(action){var paymentID,payment,studentID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function goToPaymentSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:paymentID=action.payload.paymentID;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_21" /* getPaymentByID */],paymentID);case 3:payment=_context.sent;studentID=payment.get("studentID");__WEBPACK_IMPORTED_MODULE_2_state_history__["a" /* history */].push("/school_money/payments/"+studentID+"/");case 6:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = goToShopItemSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_history__ = __webpack_require__(15);
function goToShopItemSaga(action){__WEBPACK_IMPORTED_MODULE_0_state_history__["a" /* history */].push("/school_money/shop/"+action.payload.studentID+"/");}

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = goToParentalConsentItemSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(goToParentalConsentItemSaga);function goToParentalConsentItemSaga(action){var _ref,studentID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function goToParentalConsentItemSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_19" /* getParentalConsentItemByID */],action.payload.itemID);case 2:_ref=_context.sent;studentID=_ref.studentID;// TODO: highlighting/scrollTo
__WEBPACK_IMPORTED_MODULE_2_state_history__["a" /* history */].push("/school_money/parental_consent/"+studentID+"/");case 5:case"end":return _context.stop();}}},_marked,this);}

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateParentalConsentSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(updateParentalConsentSaga);function updateParentalConsentSaga(action){var _action$payload,itemID,status,_ref,serverID,remoteSchoolID,remoteParentID,remoteInstallmentID;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function updateParentalConsentSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_action$payload=action.payload,itemID=_action$payload.itemID,status=_action$payload.status;_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_19" /* getParentalConsentItemByID */],itemID);case 3:_ref=_context.sent;serverID=_ref.serverID;remoteSchoolID=_ref.remoteSchoolID;remoteParentID=_ref.remoteParentID;remoteInstallmentID=_ref.remoteInstallmentID;_context.prev=8;_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_2_state_fetchSagas__["b" /* sendSchoolMoneyDataRequest */],"update_parental_consent",{server_id:serverID,remote_school_id:remoteSchoolID,remote_parent_id:remoteParentID,installment_id:remoteInstallmentID,consent:status});case 11:_context.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_114" /* updateParentalConsentSucceeded */])(itemID,status));case 13:_context.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_54" /* fetchActivePayments */])());case 15:_context.next=21;break;case 17:_context.prev=17;_context.t0=_context["catch"](8);_context.next=21;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_113" /* updateParentalConsentFailed */])(itemID,_context.t0));case 21:case"end":return _context.stop();}}},_marked,this,[[8,17]]);}

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = markAsSeenSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(markAsSeenSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(clubBookings),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(dinnerBookings),_marked4=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(payments),_marked5=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(shopItems);/**
 * Pages dispatch actions whenever the visible student is changed
 *   to mark everything on that student's page as seen.
 * This saga converts the studentID into a list of entity IDs.
 */function markAsSeenSaga(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function markAsSeenSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_31" /* STUDENT_CLUB_BOOKINGS_MARK_AS_SEEN */],clubBookings);case 2:_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_32" /* STUDENT_DINNER_BOOKINGS_MARK_AS_SEEN */],dinnerBookings);case 4:_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_33" /* STUDENT_PAYMENTS_MARK_AS_SEEN */],payments);case 6:_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["i" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_34" /* STUDENT_SHOP_ITEMS_MARK_AS_SEEN */],shopItems);case 8:case"end":return _context.stop();}}},_marked,this);}function clubBookings(action){var studentID,clubBookingIDList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function clubBookings$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:studentID=action.payload.studentID;_context2.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_49" /* getStudentClubBookingIDList */],studentID);case 3:clubBookingIDList=_context2.sent;_context2.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_74" /* markClubBookingsAsSeen */])(clubBookingIDList));case 6:case"end":return _context2.stop();}}},_marked2,this);}function dinnerBookings(action){var studentID,dinnerBookingIDList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function dinnerBookings$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:studentID=action.payload.studentID;_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_50" /* getStudentDinnerBookingIDList */],studentID);case 3:dinnerBookingIDList=_context3.sent;_context3.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_75" /* markDinnerBookingsAsSeen */])(dinnerBookingIDList));case 6:case"end":return _context3.stop();}}},_marked3,this);}function payments(action){var studentID,paymentIDList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function payments$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:studentID=action.payload.studentID;_context4.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_54" /* getStudentPaymentIDList */],studentID);case 3:paymentIDList=_context4.sent;_context4.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_76" /* markPaymentsAsSeen */])(paymentIDList));case 6:case"end":return _context4.stop();}}},_marked4,this);}function shopItems(action){var studentID,shopItemIDList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function shopItems$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:studentID=action.payload.studentID;_context5.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_5" /* getFilteredShopItemIDList */],studentID);case 3:shopItemIDList=_context5.sent;_context5.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_77" /* markShopItemsAsSeen */])(shopItemIDList));case 6:case"end":return _context5.stop();}}},_marked5,this);}

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = secureTradingProcessPSD2Response;
/* harmony export (immutable) */ __webpack_exports__["b"] = secureTradingGetJWTString;
/* harmony export (immutable) */ __webpack_exports__["a"] = processGooglePayResponseSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_aggregate__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lib_appserver_responseExceptions_RemoteServerCompleteFailureError__ = __webpack_require__(76);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(secureTradingProcessPSD2Response),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(secureTradingGetJWTString),_marked3=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(processGooglePayResponseSaga);function secureTradingProcessPSD2Response(){var secureTradingErrorCode,secureTradingErrorMessage;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function secureTradingProcessPSD2Response$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_39" /* getSecureTradingPSD2ErrorCode */]);case 2:secureTradingErrorCode=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_40" /* getSecureTradingPSD2ErrorMessage */]);case 5:secureTradingErrorMessage=_context.sent;_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_93" /* saveAudit */])("ST_PAYMENT_RESPONSE"));case 8:if(!(secureTradingErrorCode==="0")){_context.next=15;break;}_context.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_93" /* saveAudit */])("PAYMENT_SUCCESS"));case 11:_context.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_51" /* completeCheckout */])());case 13:_context.next=19;break;case 15:_context.next=17;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_93" /* saveAudit */])("PAYMENT_FAILED"));case 17:_context.next=19;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_94" /* secureTradingError */])({code:secureTradingErrorCode,description:secureTradingErrorMessage}));case 19:case"end":return _context.stop();}}},_marked,this);}function secureTradingGetJWTString(){var transactionID,cardHolderName,schoolID,mobileNumber,deviceToken,amount,cardHolderEmail,_deconstructSchoolID,serverID,remoteSchoolID,dataRequestParameters,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function secureTradingGetJWTString$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["G" /* getCheckoutTransactionID */]);case 2:transactionID=_context2.sent;_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_37" /* getSecureTradingCardHolderName */]);case 5:cardHolderName=_context2.sent;_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["D" /* getCheckoutSchoolID */]);case 8:schoolID=_context2.sent;_context2.next=11;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_app_selectors__["j" /* getMobileNumber */]);case 11:mobileNumber=_context2.sent;_context2.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_state_app_selectors__["c" /* getDeviceToken */]);case 14:deviceToken=_context2.sent;_context2.next=17;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["F" /* getCheckoutTotalToPay */]);case 17:amount=_context2.sent;_context2.next=20;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_18" /* getParentEmailAddress */],schoolID);case 20:cardHolderEmail=_context2.sent;_deconstructSchoolID=Object(__WEBPACK_IMPORTED_MODULE_2_lib_appserver_aggregate__["e" /* deconstructSchoolID */])(schoolID),serverID=_deconstructSchoolID.serverID,remoteSchoolID=_deconstructSchoolID.remoteSchoolID;dataRequestParameters={};dataRequestParameters.server_id=serverID;dataRequestParameters.remote_school_id=remoteSchoolID;dataRequestParameters.mobile_number=mobileNumber;dataRequestParameters.device_token=deviceToken;dataRequestParameters.amount=amount;dataRequestParameters.cardholdername=cardHolderName;dataRequestParameters.cardholderemail=validateEmail(cardHolderEmail)?cardHolderEmail:"";dataRequestParameters.cardholderphone=mobileNumber;dataRequestParameters.transaction_id=transactionID;_context2.prev=32;_context2.next=35;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */])(__WEBPACK_IMPORTED_MODULE_3_state_fetchSagas__["b" /* sendSchoolMoneyDataRequest */],"get_st_jwt",dataRequestParameters);case 35:response=_context2.sent;if(!(response.status==="error")){_context2.next=40;break;}_context2.next=39;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_94" /* secureTradingError */])({code:response.code,description:response.message}));case 39:return _context2.abrupt("return");case 40:_context2.next=42;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_68" /* getSecureTradingGetJwtStringComplete */])(response.data.jwt));case 42:_context2.next=53;break;case 44:_context2.prev=44;_context2.t0=_context2["catch"](32);if(!(_context2.t0.type===__WEBPACK_IMPORTED_MODULE_7_lib_appserver_responseExceptions_RemoteServerCompleteFailureError__["a" /* default */].type)){_context2.next=52;break;}_context2.next=49;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_100" /* setCheckoutError */])("ERROR_REMOTE_SERVER_FAIL"));case 49:return _context2.abrupt("return");case 52:throw _context2.t0;case 53:case"end":return _context2.stop();}}},_marked2,this,[[32,44]]);}function validateEmail(emailAddress){if(emailAddress.search(/^\S+((-\S+)|(\.\S+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/)===-1||emailAddress.indexOf("@")>64){return false;}return true;}function processGooglePayResponseSaga(paymentResponse){var decryptedJWT;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function processGooglePayResponseSaga$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_93" /* saveAudit */])("Saga picked up google pay response: "+JSON.stringify(paymentResponse)));case 3:paymentResponse=paymentResponse.payload.response;decryptedJWT=JSON.parse(atob(paymentResponse.jwt.split('.')[1]));if(!(paymentResponse.paymentResponse==="cancelled")){_context3.next=10;break;}_context3.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_49" /* closeCheckout */])());case 8:_context3.next=21;break;case 10:if(!(paymentResponse.jwt===undefined||decryptedJWT.payload.response[0].errorcode!=="0")){_context3.next=17;break;}_context3.next=13;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_93" /* saveAudit */])("Saga processing failed payment"));case 13:_context3.next=15;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_85" /* processSecureTradingPaymentResponse */])({errorcode:"INVALID_RESPONSE",errormessage:"Invalid payment response",jwt:""}));case 15:_context3.next=21;break;case 17:_context3.next=19;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_93" /* saveAudit */])("Saga processing successful payment"));case 19:_context3.next=21;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_85" /* processSecureTradingPaymentResponse */])({errorcode:"0",errormessage:"",jwt:paymentResponse.jwt}));case 21:_context3.next=27;break;case 23:_context3.prev=23;_context3.t0=_context3["catch"](0);_context3.next=27;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["e" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_85" /* processSecureTradingPaymentResponse */])({errorcode:"GOOGLE_PAY_INVALID_CARD_DETAILS",errormessage:"Invalid card details",jwt:""}));case 27:case"end":return _context3.stop();}}},_marked3,this,[[0,23]]);}

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = saveAuditSaga;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_appserver_aggregate__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_fetchSagas__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__ = __webpack_require__(2);
var _marked=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(saveAuditSaga),_marked2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(getAuditDetail);// Saga to handle save audit action
function saveAuditSaga(action){var schoolID,studentID,_deconstructSchoolID,serverID,remoteSchoolID,_deconstructStudentID,remoteStudentID,googlePayLogMobileNumbers;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function saveAuditSaga$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["D" /* getCheckoutSchoolID */]);case 2:schoolID=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_60" /* getStudentsHavingBasketItems */],schoolID);case 5:studentID=_context.sent;_deconstructSchoolID=Object(__WEBPACK_IMPORTED_MODULE_2_lib_appserver_aggregate__["e" /* deconstructSchoolID */])(schoolID),serverID=_deconstructSchoolID.serverID,remoteSchoolID=_deconstructSchoolID.remoteSchoolID;_deconstructStudentID=Object(__WEBPACK_IMPORTED_MODULE_2_lib_appserver_aggregate__["f" /* deconstructStudentID */])(studentID.toList().get(0)),remoteStudentID=_deconstructStudentID.remoteStudentID;googlePayLogMobileNumbers=["+447970266062","+447808768954","+447448548748"];_context.t0=getAuditTitle(action.payload.type)==="Siva DEBUG";if(!_context.t0){_context.next=16;break;}_context.t1=googlePayLogMobileNumbers;_context.next=14;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_app_selectors__["j" /* getMobileNumber */]);case 14:_context.t2=_context.sent;_context.t0=!_context.t1.includes.call(_context.t1,_context.t2);case 16:if(!_context.t0){_context.next=18;break;}return _context.abrupt("return");case 18:_context.prev=18;_context.t3=__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["b" /* call */];_context.t4=__WEBPACK_IMPORTED_MODULE_4_state_fetchSagas__["b" /* sendSchoolMoneyDataRequest */];_context.t5=serverID;_context.t6=remoteSchoolID;_context.next=25;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_app_selectors__["j" /* getMobileNumber */]);case 25:_context.t7=_context.sent;_context.next=28;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_3_state_app_selectors__["c" /* getDeviceToken */]);case 28:_context.t8=_context.sent;_context.t9=getAuditTitle(action.payload.type);_context.next=32;return getAuditDetail(action.payload.type);case 32:_context.t10=_context.sent;_context.t11=remoteStudentID;_context.t12={server_id:_context.t5,remote_school_id:_context.t6,mobile_number:_context.t7,device_token:_context.t8,type:_context.t9,detail:_context.t10,student_fk:_context.t11};_context.next=37;return(0,_context.t3)(_context.t4,"save_audit_log",_context.t12);case 37:_context.next=42;break;case 39:_context.prev=39;_context.t13=_context["catch"](18);console.log("Failed to add logs");case 42:case"end":return _context.stop();}}},_marked,this,[[18,39]]);}function getAuditTitle(auditType){switch(auditType){case"ST_CARD_DETAILS_TOKEN_GENERATED":return"Card Details Token Generated";case"ST_APPLE_PAY_TOKEN_GENERATED":return"Apple Pay Token Generated";case"ST_GOOGLE_PAY_TOKEN_GENERATED":return"Google Pay Token Generated";case"ST_PAYMENT_RESPONSE":return"ST Payment Response";case"PAYMENT_PROCESS_STARTED":return"Payment Process started";case"PAYMENT_SUCCESS":return"Payment Successfully Completed";case"PAYMENT_FAILED":return"Payment failed";case"GOOGLE_PAY_PAYMENT_PROCESS_STARTED":return"Google pay process started";default:return"Siva DEBUG";}}function getAuditDetail(auditType){var transactionID,errorCode,errorMessage;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function getAuditDetail$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["G" /* getCheckoutTransactionID */]);case 2:transactionID=_context2.sent;_context2.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_39" /* getSecureTradingPSD2ErrorCode */]);case 5:errorCode=_context2.sent;_context2.next=8;return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_40" /* getSecureTradingPSD2ErrorMessage */]);case 8:errorMessage=_context2.sent;_context2.t0=auditType;_context2.next=_context2.t0==="ST_CARD_DETAILS_TOKEN_GENERATED"?12:_context2.t0==="ST_APPLE_PAY_TOKEN_GENERATED"?13:_context2.t0==="ST_GOOGLE_PAY_TOKEN_GENERATED"?14:_context2.t0==="ST_PAYMENT_RESPONSE"?15:_context2.t0==="PAYMENT_PROCESS_STARTED"?16:_context2.t0==="PAYMENT_SUCCESS"?17:_context2.t0==="PAYMENT_FAILED"?18:_context2.t0==="GOOGLE_PAY_PAYMENT_PROCESS_STARTED"?19:20;break;case 12:return _context2.abrupt("return","Secure Trading card payment token has been generated - order reference: "+transactionID+".");case 13:return _context2.abrupt("return","Secure Trading Apple payment token has been generated - order reference: "+transactionID+".");case 14:return _context2.abrupt("return","Secure Trading Google payment token has been generated - order reference: "+transactionID+".");case 15:return _context2.abrupt("return","Payment response received from SecureTrading for order reference: "+transactionID+" - Error Code: "+errorCode+" and Error Message: "+errorMessage+".");case 16:return _context2.abrupt("return","Payment process has been initialised - order reference: "+transactionID+".");case 17:return _context2.abrupt("return","Secure Trading payment has been successfully completed - order reference: "+transactionID+".");case 18:return _context2.abrupt("return","There was an issue with SecureTrading payment for order reference: "+transactionID+".");case 19:return _context2.abrupt("return","Google pay payment process has been initialised - order reference: "+transactionID+".");case 20:return _context2.abrupt("return",auditType);case 21:case"end":return _context2.stop();}}},_marked2,this);}

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_redux__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_reducer__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_teachers_reducer__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_reducer__ = __webpack_require__(421);
/**
 * @module state/rootReducer
 * Root reducer for the Redux store.
 * Delegates to individual `state/<application>/reducer.js`.
 * We use a solution that looks a bit like Redux's `combineReducers`,
 *   but deals with Immutable state.
 */var initialState=new __WEBPACK_IMPORTED_MODULE_1_immutable__["Map"]();// slice state and delegate to each reducer.
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];return state.set("app",Object(__WEBPACK_IMPORTED_MODULE_2_state_app_reducer__["a" /* default */])(state.get("app"),action)).set("teachers",Object(__WEBPACK_IMPORTED_MODULE_3_state_teachers_reducer__["a" /* default */])(state.get("teachers"),action)).set("school_money",Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_reducer__["a" /* default */])(state.get("school_money"),action)).set("router",Object(__WEBPACK_IMPORTED_MODULE_0_react_router_redux__["d" /* routerReducer */])(state.get("router"),action));});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_persist__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flux_standard_action__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flux_standard_action___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_flux_standard_action__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_date__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(9);
var initialState=new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"]({clientInitDate:Object(__WEBPACK_IMPORTED_MODULE_4_lib_date__["c" /* nowString */])(),availableProducts:new __WEBPACK_IMPORTED_MODULE_0_immutable__["List"]([]),isLoadingAvailableProducts:false,isMenuOpen:false,fatalError:null,isDownTimeReporterOpen:true,isCustomerNoticesOpen:true,lastReadSchoolMoneyCustomerNoticesKey:null,lastReadTeachers2ParentsCustomerNoticesKey:null,lastReadAppNoticesKey:null,userIdentity:new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"]({status:"unset",mobileNumber:null,deviceToken:null}),isInformationModalOpen:false,informationModalMessage:"",informationModalTitle:"",isLoadingFrameOpen:false});// Handle FETCH_AVAILABLE_PRODUCTS_COMPLETE
function reduceFetchAvailableProductsComplete(state,action){// set loading state off
var nextState=state.set("isLoadingAvailableProducts",false);// if no error, input payload into state
if(Object(__WEBPACK_IMPORTED_MODULE_3_flux_standard_action__["isError"])(action)){return nextState;}else{var appReferrer=state.getIn(["userIdentity","appReferrer"]);return nextState.set("availableProducts",getAvailableProductForReferrer(action.payload,appReferrer));}}function reduceSetUserIdentity(state,action){if(Object(__WEBPACK_IMPORTED_MODULE_3_flux_standard_action__["isError"])(action)){return state.set("userIdentity",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({status:"error",mobileNumber:null,deviceToken:null}));}else{return state.set("userIdentity",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(Object.assign({},action.payload,{status:"success"})));}}function getAvailableProductForReferrer(availableProducts,appReferrer){if(appReferrer==="xpressions"||appReferrer==="parentapps"){var teachersProductIndex=availableProducts.indexOf("teachers");availableProducts.splice(teachersProductIndex,1);}return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(availableProducts);}function mergeHydrateState(state,action){var hydratedState=action.payload.state;// default to the initialised version if the hydrated clientInitDate is undefined
var clientInitDate=hydratedState.getIn(["app","clientInitDate"])||state.get("clientInitDate");return state.set("availableProducts",hydratedState.getIn(["app","availableProducts"])).set("clientInitDate",clientInitDate).set("lastReadSchoolMoneyCustomerNoticesKey",hydratedState.getIn(["app","lastReadSchoolMoneyCustomerNoticesKey"])).set("lastReadTeachers2ParentsCustomerNoticesKey",hydratedState.getIn(["app","lastReadTeachers2ParentsCustomerNoticesKey"])).set("lastReadAppNoticesKey",hydratedState.getIn(["app","lastReadAppNoticesKey"]));}// Reducer function (state, action) => state
function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_2_state_persist__["a" /* STATE_HYDRATE */]:return mergeHydrateState(state,action);case __WEBPACK_IMPORTED_MODULE_5__actions__["n" /* MAIN_MENU_OPEN */]:return state.set("isMenuOpen",true);// menu close button, location change both cause menu close
case __WEBPACK_IMPORTED_MODULE_5__actions__["m" /* MAIN_MENU_CLOSE */]:case __WEBPACK_IMPORTED_MODULE_1_react_router_redux__["b" /* LOCATION_CHANGE */]:return state.set("isMenuOpen",false);case __WEBPACK_IMPORTED_MODULE_5__actions__["i" /* FETCH_AVAILABLE_PRODUCTS */]:return state.set("isLoadingAvailableProducts",true);case __WEBPACK_IMPORTED_MODULE_5__actions__["j" /* FETCH_AVAILABLE_PRODUCTS_COMPLETE */]:return reduceFetchAvailableProductsComplete(state,action);case __WEBPACK_IMPORTED_MODULE_5__actions__["y" /* SET_USER_IDENTITY */]:return reduceSetUserIdentity(state,action);// client is out of date and about to be reloaded. remove clientInitDate for re-init
case __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* CLEAR_CLIENT_INIT_DATE */]:return state.delete("clientInitDate");// User is being kicked out. set userIdentity to Error as a precaution
// This will cause the UserIdentityValidator to
case __WEBPACK_IMPORTED_MODULE_5__actions__["k" /* FORCE_REGISTRATION */]:return state.setIn(["userIdentity","status"],"error");case __WEBPACK_IMPORTED_MODULE_5__actions__["g" /* ERROR_FATAL */]:return state.set("fatalError",action.payload.error);case __WEBPACK_IMPORTED_MODULE_5__actions__["d" /* CLOSE_DOWN_TIME_REPORTER */]:return state.set("isDownTimeReporterOpen",false);case __WEBPACK_IMPORTED_MODULE_5__actions__["c" /* CLOSE_CUSTOMER_NOTICES_FRAME */]:return state.set("isCustomerNoticesOpen",false);case __WEBPACK_IMPORTED_MODULE_5__actions__["o" /* MARK_CUSTOMER_NOTICE_AS_READ */]:return state.set("isCustomerNoticesOpen",false).set("lastReadSchoolMoneyCustomerNoticesKey","schoolmoney_1").set("lastReadTeachers2ParentsCustomerNoticesKey","teachers_1").set("lastReadAppNoticesKey","app_2");case __WEBPACK_IMPORTED_MODULE_5__actions__["q" /* OPEN_INFORMATION_MODAL */]:var _ref=action.payload.informationDetails||{},message=_ref.message,title=_ref.title;return state.set("isInformationModalOpen",true).set("informationModalMessage",message).set("informationModalTitle",title===null||title===undefined?"Alert":title);case __WEBPACK_IMPORTED_MODULE_5__actions__["e" /* CLOSE_INFORMATION_MODAL */]:return state.set("isInformationModalOpen",false).set("informationModalMessage","").set("informationModalTitle","");case __WEBPACK_IMPORTED_MODULE_5__actions__["r" /* OPEN_LOADING_FRAME */]:return state.set("isLoadingFrameOpen",true);case __WEBPACK_IMPORTED_MODULE_5__actions__["f" /* CLOSE_LOADING_FRAME */]:return state.set("isLoadingFrameOpen",false);// unknown action; no change
default:return state;}}

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isString2 = __webpack_require__(411);

var _isString3 = _interopRequireDefault(_isString2);

var _isPlainObject2 = __webpack_require__(417);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

exports.isFSA = isFSA;
exports.isError = isError;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isFSA(action) {
  return (0, _isPlainObject3.default)(action) && (0, _isString3.default)(action.type) && Object.keys(action).every(isValidKey);
}

function isError(action) {
  return isFSA(action) && action.error === true;
}

function isValidKey(key) {
  return ['type', 'payload', 'error', 'meta'].indexOf(key) > -1;
}

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(166),
    isArray = __webpack_require__(416),
    isObjectLike = __webpack_require__(168);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(413);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)))

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(167);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 415 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 416 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(166),
    getPrototype = __webpack_require__(418),
    isObjectLike = __webpack_require__(168);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(419);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 419 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_date__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_persist__ = __webpack_require__(78);
// We'll need so many actions here we might as well import them all
var initialState=new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"]({lastSchoolID:undefined,isSchoolsLoading:true,schools:new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](),migratedSchools:new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](),isMessagesLoading:true,messages:new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](),isNoticesLoading:true,notices:new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](),isTermsLoading:true,terms:new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](),readMessageIDs:new __WEBPACK_IMPORTED_MODULE_0_immutable__["Set"](),replyDrafts:new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](),pendingReplies:new __WEBPACK_IMPORTED_MODULE_0_immutable__["Map"](),expandedNoticeID:null,isGuideOpen:false,goToMessageID:null,goToNoticeID:null});function failAllPendingReplies(hydratedPendingReplies){return hydratedPendingReplies.toSeq().map(function(pendingReply){return pendingReply.set("status","failed");}).toMap();}function mergeHydrateState(state,action){var hydratedState=action.payload.state;return state.set("replyDrafts",hydratedState.getIn(["teachers","replyDrafts"])).set("readMessageIDs",hydratedState.getIn(["teachers","readMessageIDs"],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).toSet()).set("guideShownDate",hydratedState.getIn(["teachers","guideShownDate"])).set("pendingReplies",failAllPendingReplies(hydratedState.getIn(["teachers","pendingReplies"])));}// Root reducer
function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_3_state_persist__["a" /* STATE_HYDRATE */]:return mergeHydrateState(state,action);case __WEBPACK_IMPORTED_MODULE_2__actions__["w" /* SET_LAST_SCHOOL */]:return state.set("lastSchoolID",action.payload.schoolID);case __WEBPACK_IMPORTED_MODULE_2__actions__["j" /* FETCH_SCHOOLS */]:return state.set("isSchoolsLoading",true);case __WEBPACK_IMPORTED_MODULE_2__actions__["f" /* FETCH_MESSAGES */]:return state.set("isMessagesLoading",true);case __WEBPACK_IMPORTED_MODULE_2__actions__["h" /* FETCH_NOTICES */]:return state.set("isNoticesLoading",true);case __WEBPACK_IMPORTED_MODULE_2__actions__["l" /* FETCH_TERMS */]:return state.set("isTermsLoading",true);case __WEBPACK_IMPORTED_MODULE_2__actions__["k" /* FETCH_SCHOOLS_COMPLETED */]:return state.set("isSchoolsLoading",false).set('schools',action.payload.schools).set("migratedSchools",action.payload.migratedSchools).set("lastSchoolID",action.payload.schools.first().id);case __WEBPACK_IMPORTED_MODULE_2__actions__["g" /* FETCH_MESSAGES_COMPLETED */]:var pendingReplies=state.get("pendingReplies").filter(function(pendingReply){return pendingReply.get("status")!=="sent";});return state.set("isMessagesLoading",false).set('messages',action.payload.messages).set("pendingReplies",pendingReplies);case __WEBPACK_IMPORTED_MODULE_2__actions__["r" /* MERGE_MESSAGES */]:var migratedSchools=state.get("migratedSchools");var messages=state.get("messages");return state.set("messages",messages.map(function(m){var school=migratedSchools.find(function(s){return s.schoolID===m.schoolID;});// If the school has been migrated then set the school ID of the message to the ID of the Neo school instead
return school!==undefined?m.set("schoolID",school.neoId):m;}));case __WEBPACK_IMPORTED_MODULE_2__actions__["i" /* FETCH_NOTICES_COMPLETED */]:return state.set("isNoticesLoading",false).set('notices',Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.payload.notices));case __WEBPACK_IMPORTED_MODULE_2__actions__["m" /* FETCH_TERMS_COMPLETED */]:return state.set("isTermsLoading",false).set('terms',Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.payload.terms));case __WEBPACK_IMPORTED_MODULE_2__actions__["p" /* MARK_MESSAGES_READ */]:return state.mergeIn(["readMessageIDs"],action.payload.messageIDs);case __WEBPACK_IMPORTED_MODULE_2__actions__["y" /* SET_REPLY_DRAFT */]:return state.setIn(["replyDrafts",action.payload.schoolID],action.payload.body);case __WEBPACK_IMPORTED_MODULE_2__actions__["u" /* SEND_REPLY */]:return state.deleteIn(["replyDrafts",action.payload.schoolID]);case __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* ADD_PENDING_REPLY */]:return state.setIn(["pendingReplies",action.payload.pendingReplyID],Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(action.payload.pendingReply));case __WEBPACK_IMPORTED_MODULE_2__actions__["t" /* RETRY_PENDING_REPLY */]:var pendingReplyID=action.payload.pendingReplyID;var _state$getIn$toJS=state.getIn(["pendingReplies",pendingReplyID]).toJS(),body=_state$getIn$toJS.body,schoolID=_state$getIn$toJS.schoolID;return state.setIn(["replyDrafts",schoolID],body).deleteIn(["pendingReplies",pendingReplyID]);case __WEBPACK_IMPORTED_MODULE_2__actions__["x" /* SET_PENDING_REPLY_STATUS */]:return state.setIn(["pendingReplies",action.payload.pendingReplyID,"status"],action.payload.status);case __WEBPACK_IMPORTED_MODULE_2__actions__["v" /* SET_EXPANDED_NOTICE */]:return state.set("expandedNoticeID",action.payload.noticeID);case __WEBPACK_IMPORTED_MODULE_2__actions__["s" /* OPEN_GUIDE */]:return state.set("isGuideOpen",true);case __WEBPACK_IMPORTED_MODULE_2__actions__["d" /* CLOSE_GUIDE */]:return state.set("isGuideOpen",false).set("guideShownDate",Object(__WEBPACK_IMPORTED_MODULE_1_lib_date__["c" /* nowString */])());case __WEBPACK_IMPORTED_MODULE_2__actions__["n" /* GO_TO_MESSAGE */]:return state.set("goToMessageID",action.payload.messageID);case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* CLEAR_GO_TO_MESSAGE */]:return state.set("goToMessageID",null);case __WEBPACK_IMPORTED_MODULE_2__actions__["o" /* GO_TO_NOTICE */]:return state.set("goToNoticeID",action.payload.noticeID);case __WEBPACK_IMPORTED_MODULE_2__actions__["c" /* CLEAR_GO_TO_NOTICE */]:return state.set("goToNoticeID",null);default:return state;}}

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_id__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_persist__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_entities_BasketItem__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_Checkout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_SecureTrading__ = __webpack_require__(423);
var initialState=Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({isGuideOpen:false,guideShownDate:null,secureTrading:Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_SecureTrading__["a" /* default */])(),parents:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),isParentsLoading:false,schools:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),isSchoolsLoading:true,students:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),isStudentsLoading:true,lastStudentID:undefined,basketItems:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),expandedSchoolBasketID:null,basketItemsIssues:null,isBasketItemsIssuesModalOpen:false,checkout:Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_Checkout__["a" /* default */])(),isActivePaymentsLoading:true,clubBookings:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),dinnerBookings:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),otherPayments:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),expandedClubBookingID:null,seenClubBookingIDs:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(),goToClubBookingID:null,isAllergiesWarningEnabled:true,expandedDinnerBookingID:null,seenDinnerBookingIDs:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(),goToDinnerBookingID:null,expandedPaymentID:null,seenOtherPaymentIDs:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(),goToPaymentID:null,shopItems:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),isShopLoading:true,seenShopItemIDs:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(),goToShopItemID:null,history:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),isHistoryLoading:true,parentalConsentItems:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),pendingParentalConsentItems:Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(),shopItemSearchQuery:""});function mergeHydratedState(state,action){var hydratedState=action.payload.state.get("school_money");return state.set("guideShownDate",hydratedState.get("guideShownDate",null)).set("basketItems",hydratedState.get("basketItems",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()).map(function(ofType){return ofType.map(__WEBPACK_IMPORTED_MODULE_4_state_school_money_entities_BasketItem__["a" /* default */]);})).set("seenClubBookingIDs",hydratedState.get("seenClubBookingIDs",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).toSet()).set("seenDinnerBookingIDs",hydratedState.get("seenDinnerBookingIDs",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).toSet()).set("seenOtherPaymentIDs",hydratedState.get("seenOtherPaymentIDs",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).toSet()).set("seenShopItemIDs",hydratedState.get("seenShopItemIDs",Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).toSet());}function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_3_state_persist__["a" /* STATE_HYDRATE */]:return mergeHydratedState(state,action);// secure trading: payment provider
case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_11" /* SECURE_TRADING_PROCESS_TOKEN */]:return state.setIn(["checkout","status"],__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_Checkout__["a" /* default */].status.PROCESSING);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_12" /* SECURE_TRADING_PROCESS_TOKEN_COMPLETED */]:return state.setIn(["checkout","status"],__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_Checkout__["a" /* default */].status.PENDING).set("secureTrading",action.payload.secureTrading);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_14" /* SECURE_TRADING_THREEDS_STATUS_UPDATE */]:return state.setIn(["secureTrading","threeds_status"],action.payload.status).setIn(["checkout","status"],__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_Checkout__["a" /* default */].status.PROCESSING);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_13" /* SECURE_TRADING_RESET_COMPLETED */]:return state.set("secureTrading",action.payload.secureTrading);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_8" /* SECURE_TRADING_GET_JWT_STRING */]:return state.setIn(["checkout","status"],__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_Checkout__["a" /* default */].status.PREPARING).setIn(["secureTrading","card_holder_name"],action.payload.cardHolderName);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_9" /* SECURE_TRADING_GET_JWT_STRING_COMPLETED */]:return state.setIn(["secureTrading","payment_request_jwt_string"],action.payload.jwtString).setIn(["checkout","status"],__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_Checkout__["a" /* default */].status.PENDING);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_10" /* SECURE_TRADING_PROCESS_PAYMENT_RESPONSE */]:return state.setIn(["secureTrading","error_code"],action.payload.paymentResult.errorcode).setIn(["secureTrading","error_message"],action.payload.paymentResult.errormessage).setIn(["secureTrading","payment_response_jwt_string"],action.payload.paymentResult.jwt).setIn(["checkout","status"],__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_Checkout__["a" /* default */].status.PROCESSING);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["t" /* CLEAR_SECURE_TRADING_WALLET_PAY_JWT_STRING */]:return state.setIn(["secureTrading","wallet_pay_jwt_string"],undefined);// parents
case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["U" /* PARENTS_FETCH */]:case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["W" /* PARENT_EMAIL_ADDRESS_UPDATE */]:return state.set("isParentsLoading",true);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["V" /* PARENTS_FETCH_COMPLETED */]:return state.set("parents",action.payload.parents).set("isParentsLoading",false);// schools
case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_6" /* SCHOOLS_FETCH */]:return state.set("isSchoolsLoading",true);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_7" /* SCHOOLS_FETCH_COMPLETED */]:return state.set("schools",action.payload.schools).set("isSchoolsLoading",false);// students
case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_29" /* STUDENTS_FETCH */]:return state.set("isStudentsLoading",true);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_30" /* STUDENTS_FETCH_COMPLETED */]:return state.set("students",action.payload.students).set("isStudentsLoading",false);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_19" /* SET_LAST_STUDENT */]:return state.set("lastStudentID",action.payload.studentID);// all payments
case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["a" /* ACTIVE_PAYMENTS_FETCH */]:return state.set("isActivePaymentsLoading",true);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["b" /* ACTIVE_PAYMENTS_FETCH_COMPLETED */]:return state.set("clubBookings",action.payload.clubPayments).set("dinnerBookings",action.payload.dinnerPayments).set("otherPayments",action.payload.otherPayments).set("parentalConsentItems",action.payload.parentalConsentItems).set("isActivePaymentsLoading",false);// basket
case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["k" /* BASKET_ITEM_SET */]:return state.setIn(["basketItems",action.payload.type,action.payload.basketItemID],__WEBPACK_IMPORTED_MODULE_4_state_school_money_entities_BasketItem__["a" /* default */].fromAction(action));case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["i" /* BASKET_ITEM_DELETE */]:return state.deleteIn(["basketItems",action.payload.type,action.payload.basketItemID]);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["j" /* BASKET_ITEM_DELETE_GROUP */]:return state.updateIn(["basketItems",action.payload.type],function(basketItems){return basketItems.filterNot(function(basketItem){return basketItem.get("groupID")===action.payload.groupID;});});case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["f" /* BASKET_ITEMS_ISSUES_SET */]:return state.set("basketItemsIssues",action.payload.issues);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["e" /* BASKET_ITEMS_ISSUES_MODAL_OPEN */]:return state.set("isBasketIssuesModalOpen",true).set("basketItemsIssues",action.payload.issues);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["d" /* BASKET_ITEMS_ISSUES_MODAL_CLOSE */]:return state.set("isBasketIssuesModalOpen",false).update("basketItemsIssues",function(issues){return issues.clear();});case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_18" /* SET_EXPANDED_SCHOOL_BASKET */]:return state.set("expandedSchoolBasketID",action.payload.schoolID);// clubs
case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["z" /* CLUB_BOOKING_SESSION_SELECT */]:return state.setIn(["clubBookings",action.payload.clubBookingID,"selectedSessionIDs",action.payload.weekdayIndex],action.payload.sessionID);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["K" /* EXPANDED_CLUB_BOOKING_SET */]:return state.set("expandedClubBookingID",action.payload.clubBookingID);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["u" /* CLUB_BOOKINGS_MARK_AS_SEEN */]:return state.mergeIn(["seenClubBookingIDs"],action.payload.clubBookingIDs);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["w" /* CLUB_BOOKING_GO_TO */]:return state.set("goToClubBookingID",action.payload.clubBookingID);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["x" /* CLUB_BOOKING_GO_TO_CLEAR */]:return state.set("goToClubBookingID",null);// dinners
case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["G" /* DINNER_BOOKING_OPTION_SELECT */]:return state.setIn(["dinnerBookings",action.payload.dinnerBookingID,"selectedOptionIDs",action.payload.weekdayIndex],action.payload.optionID);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_15" /* SET_ALLERGIES_WARNING_STATUS */]:return state.set("isAllergiesWarningEnabled",action.payload.isEnabled);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_16" /* SET_EXPANDED_DINNER_BOOKING */]:return state.set("expandedDinnerBookingID",action.payload.dinnerBookingID);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["C" /* DINNER_BOOKINGS_MARK_AS_SEEN */]:return state.mergeIn(["seenDinnerBookingIDs"],action.payload.dinnerBookingIDs);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["E" /* DINNER_BOOKING_GO_TO */]:return state.set("goToDinnerBookingID",action.payload.dinnerBookingID);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["F" /* DINNER_BOOKING_GO_TO_CLEAR */]:return state.set("goToDinnerBookingID",null);// shop
case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_22" /* SHOP_ITEMS_FETCH_COMPLETED */]:return state.set("shopItems",action.payload.shopItems).set("isShopLoading",false);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_23" /* SHOP_ITEMS_MARK_AS_SEEN */]:return state.mergeIn(["seenShopItemIDs"],action.payload.shopItemIDs);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_24" /* SHOP_ITEM_GO_TO */]:return state.set("goToShopItemID",Object(__WEBPACK_IMPORTED_MODULE_1_lib_id__["a" /* aggregateID */])(action.payload.studentID,action.payload.shopItemID));case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_25" /* SHOP_ITEM_GO_TO_CLEAR */]:return state.set("goToShopItemID",null);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_28" /* SHOP_ITEM_SET_SEARCH_QUERY */]:return state.set("shopItemSearchQuery",action.payload.searchQuery);// other payments
case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_20" /* SET_PAYMENT_INSTALLMENT_SELECTED_PRICE */]:return state.setIn(["otherPayments",action.payload.paymentID,"installments",action.payload.installmentNumber,"selectedPrice"],action.payload.selectedPrice);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_17" /* SET_EXPANDED_PAYMENT */]:return state.set("expandedPaymentID",action.payload.paymentID);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["X" /* PAYMENTS_MARK_AS_SEEN */]:return state.mergeIn(["seenOtherPaymentIDs"],action.payload.paymentIDs);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["Y" /* PAYMENT_GO_TO */]:return state.set("goToPaymentID",action.payload.paymentID);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["Z" /* PAYMENT_GO_TO_CLEAR */]:return state.set("goToPaymentID",null);// history
case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["P" /* HISTORY_FETCH_COMPLETED */]:return state.set("history",action.payload.history).set("isHistoryLoading",false);// parental consent
case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["R" /* PARENTAL_CONSENT_UPDATE */]:return state.setIn(["pendingParentalConsentItems",action.payload.itemID],"saving");case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["T" /* PARENTAL_CONSENT_UPDATE_SUCCEEDED */]:return state.setIn(["pendingParentalConsentItems",action.payload.itemID],"saved");case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["S" /* PARENTAL_CONSENT_UPDATE_FAILED */]:return state.setIn(["pendingParentalConsentItems",action.payload.itemID],"failed");case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_3" /* PENDING_PARENTAL_CONSENT_ITEMS_CLEAR_FAILURES */]:return state.update("pendingParentalConsentItems",function(items){return items.filterNot(function(status){return status==="failed";});});case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["_4" /* PENDING_PARENTAL_CONSENT_ITEMS_CLEAR_SAVED */]:return state.update("pendingParentalConsentItems",function(items){return items.filterNot(function(status){return status==="saved";});});// checkout
case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["q" /* CHECKOUT_START */]:return state.setIn(["checkout","schoolID"],action.payload.schoolID).setIn(["checkout","status"],__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_Checkout__["a" /* default */].status.PREPARING);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["r" /* CHECKOUT_TRANSACTION_DETAILS_SET */]:return state.setIn(["checkout","transactionID"],action.payload.transactionID).setIn(["checkout","totalToPay"],action.payload.totalToPay).setIn(["checkout","status"],__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_Checkout__["a" /* default */].status.PENDING).setIn(["secureTrading","wallet_pay_jwt_string"],action.payload.walletPayJWTString);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["s" /* CHECKOUT_TRANSACTION_PROCESS */]:return state.setIn(["checkout","status"],__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_Checkout__["a" /* default */].status.PROCESSING);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["m" /* CHECKOUT_COMPLETE */]:return state.setIn(["checkout","status"],__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_Checkout__["a" /* default */].status.COMPLETED);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["l" /* CHECKOUT_CLOSE */]:// reset checkout to initial
return state.set("checkout",Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_Checkout__["a" /* default */])()).set("secureTrading",Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_entities_SecureTrading__["a" /* default */])());case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["o" /* CHECKOUT_ERROR_SET */]:return state.setIn(["checkout","error"],action.payload.error).setIn(["checkout","errorCode"],action.payload.errorCode);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["n" /* CHECKOUT_ERROR_CLEAR */]:return state.setIn(["checkout","error"],null).setIn(["checkout","errorCode"],null).setIn(["checkout","status"],__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_Checkout__["a" /* default */].status.PENDING);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["p" /* CHECKOUT_RESTART */]:return state.setIn(["checkout","error"],null).setIn(["checkout","errorCode"],null).setIn(["checkout","status"],__WEBPACK_IMPORTED_MODULE_5_state_school_money_entities_Checkout__["a" /* default */].status.PENDING).setIn(["secureTrading","payment_request_jwt_string"],undefined);// guide
case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["N" /* GUIDE_OPEN */]:return state.set("isGuideOpen",true);case __WEBPACK_IMPORTED_MODULE_2_state_school_money_actions__["M" /* GUIDE_CLOSE */]:return state.set("isGuideOpen",false).set("guideShownDate",action.payload.timestamp);// default
default:return state;}}

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
var BasketItem=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record({basketItemID:undefined,groupID:undefined,studentID:undefined,schoolID:undefined,type:undefined,price:undefined,quantity:undefined,payload:new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map()},"Basket Item");function buildBasketItemFromAction(_ref){var payload=_ref.payload;return BasketItem({basketItemID:payload.basketItemID,groupID:payload.groupID,studentID:payload.studentID,schoolID:payload.schoolID,type:payload.type,price:payload.price,quantity:payload.quantity,payload:new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map(payload.payload)});}BasketItem.fromAction=buildBasketItemFromAction;/* harmony default export */ __webpack_exports__["a"] = (BasketItem);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
var SecureTrading=new __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Record({status:undefined,message:undefined,code:undefined,threeds_status:undefined,threeds_enrolled:undefined,threeds_acsurl:undefined,threeds_pareq:undefined,threeds_termurl:undefined,threeds_md:undefined,card_holder_name:undefined,payment_request_jwt_string:undefined,error_code:undefined,error_message:undefined,payment_response_jwt_string:undefined,wallet_pay_jwt_string:undefined},"SecureTrading");function buildSecureTradingFromAppserver(rawSecureTrading){return SecureTrading({status:rawSecureTrading.status,message:rawSecureTrading.message,code:rawSecureTrading.code,threeds_status:rawSecureTrading.threeds_status,threeds_enrolled:rawSecureTrading.threeds_enrolled,threeds_acsurl:rawSecureTrading.threeds_acsurl,threeds_pareq:rawSecureTrading.threeds_pareq,threeds_termurl:rawSecureTrading.threeds_termurl,threeds_md:rawSecureTrading.threeds_md});}SecureTrading.fromAppserver=buildSecureTradingFromAppserver;/* harmony default export */ __webpack_exports__["a"] = (SecureTrading);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rootDehydrate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_state_app_dehydrate__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_teachers_dehydrate__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_dehydrate__ = __webpack_require__(427);
/**
 * @module state/rootDehydrate
 * Dehydrate state ready for localStorage.
 * Delegates to individual `state/<application>/dehydrate.js`.
 *//**
 * rootDehydrate - dehydrate state into a form where it can be persisted efficiently
 * Mainly this involves deleting keys we don't want to serialize
 * This is delegated to the individual dehydrate methods in the app domains
 *
 * @returns {Immutable.Map} state
 */function rootDehydrate(state){return state.set("app",Object(__WEBPACK_IMPORTED_MODULE_0_state_app_dehydrate__["a" /* default */])(state.get("app"))).set("teachers",Object(__WEBPACK_IMPORTED_MODULE_1_state_teachers_dehydrate__["a" /* default */])(state.get("teachers"))).set("school_money",Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_dehydrate__["a" /* default */])(state.get("school_money"))).delete("router");}

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dehydrate;
/**
 * dehydrate - dehydrate this slice of state into a serializable form
 */function dehydrate(state){// You can't persist a fatal error! that's the point, reloading should try again.
return state.delete("fatalError");}

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dehydrate;
/**
 * dehydrate - dehydrate this slice of state into a serializable form
 */function dehydrate(state){return state;}

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dehydrate;
/**
 * dehydrate - dehydrate this slice of state into a serializable form
 */function dehydrate(state){return state;}

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_UserIdentityValidator__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_app_bar_AppBar__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_app_home_HomePage__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_app_info_InfoPage__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_app_help_HelpPage__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_app_MainMenu__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_app_InformationModal__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_LoadingPage__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_app_NotFoundPage__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_app_MainMenuTouchGuard__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_app_error_FatalErrorReporter__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_FatalErrorBoundary__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_app_ProductDownTimeReporter__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_app_CustomerNotices__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_app_LoadingFrame__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_teachers_TeachersPage__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_school_money_SchoolMoneyPage__ = __webpack_require__(587);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RootPage=function(_React$Component){_inherits(RootPage,_React$Component);function RootPage(){_classCallCheck(this,RootPage);return _possibleConstructorReturn(this,(RootPage.__proto__||Object.getPrototypeOf(RootPage)).apply(this,arguments));}_createClass(RootPage,[{key:"render",value:function render(){var _props=this.props,availableProducts=_props.availableProducts,isLoading=_props.isLoading,hasFatalError=_props.hasFatalError;var hasTeachers=availableProducts.includes("teachers");var hasSchoolMoney=availableProducts.includes("school_money");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"app"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_app_error_FatalErrorReporter__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_UserIdentityValidator__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_app_ProductDownTimeReporter__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_components_app_CustomerNotices__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_components_app_LoadingFrame__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_FatalErrorBoundary__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_app_MainMenuTouchGuard__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_app_bar_AppBar__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_app_MainMenu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_app_InformationModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-container"},hasFatalError?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Switch */],null,isLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_11_components_LoadingPage__["a" /* default */]}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:"/info/",component:__WEBPACK_IMPORTED_MODULE_7_components_app_info_InfoPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:"/help/",component:__WEBPACK_IMPORTED_MODULE_8_components_app_help_HelpPage__["a" /* default */]}),hasTeachers?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:"/teachers/",component:__WEBPACK_IMPORTED_MODULE_19_components_teachers_TeachersPage__["a" /* default */]}):null,hasSchoolMoney?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:"/school_money/",component:__WEBPACK_IMPORTED_MODULE_20_components_school_money_SchoolMoneyPage__["a" /* default */]}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:"/",exact:true,component:__WEBPACK_IMPORTED_MODULE_6_components_app_home_HomePage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_12_components_app_NotFoundPage__["a" /* default */]})))));}}]);return RootPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{availableProducts:Object(__WEBPACK_IMPORTED_MODULE_3_state_app_selectors__["a" /* getAvailableProducts */])(state),isLoading:Object(__WEBPACK_IMPORTED_MODULE_3_state_app_selectors__["q" /* isLoadingAvailableProducts */])(state),hasFatalError:Object(__WEBPACK_IMPORTED_MODULE_3_state_app_selectors__["d" /* getFatalError */])(state)!==null};},undefined,undefined,// components depends on routing
{pure:false})(RootPage));

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserIdentityValidator_css__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UserIdentityValidator_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__UserIdentityValidator_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UserIdentityValidator=function(_React$Component){_inherits(UserIdentityValidator,_React$Component);function UserIdentityValidator(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UserIdentityValidator);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UserIdentityValidator.__proto__||Object.getPrototypeOf(UserIdentityValidator)).call.apply(_ref,[this].concat(args))),_this),_this.backToRegistration=function(){Object(__WEBPACK_IMPORTED_MODULE_3_state_app_actions__["J" /* forceRegistration */])();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UserIdentityValidator,[{key:"render",value:function render(){var isError=this.props.userIdentityStatus==="error";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ModalDialog__["a" /* default */],{fitScreen:true,isOpen:isError},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"user-identity-validator"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"user-identity-validator__heading"},"Oops!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"user-identity-validator__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Your identity could not be verified."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"You should be redirected to the registration screen. If not, please close the app and and try again."))));}}]);return UserIdentityValidator;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){return{userIdentityStatus:Object(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["m" /* getUserIdentityStatus */])(state)};},{forceRegistration:__WEBPACK_IMPORTED_MODULE_3_state_app_actions__["J" /* forceRegistration */]})(UserIdentityValidator));

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Gate__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Overlay__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modal_css__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Modal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Modal=function(_React$Component){_inherits(Modal,_React$Component);function Modal(){_classCallCheck(this,Modal);return _possibleConstructorReturn(this,(Modal.__proto__||Object.getPrototypeOf(Modal)).apply(this,arguments));}_createClass(Modal,[{key:"render",value:function render(){var classNames=["modal"];if(!this.props.fitScreen){classNames.push("modal-frame");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Gate__["a" /* default */],{isOpen:this.props.isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Overlay__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},this.props.children))));}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Modal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,fitScreen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};Modal.defaultProps={isOpen:true,fitScreen:false};/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dialog_css__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Dialog_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Dialog=function(_React$Component){_inherits(Dialog,_React$Component);function Dialog(){_classCallCheck(this,Dialog);return _possibleConstructorReturn(this,(Dialog.__proto__||Object.getPrototypeOf(Dialog)).apply(this,arguments));}_createClass(Dialog,[{key:"render",value:function render(){var classNames=["dialog"];this.props.fitScreen?classNames.push("dialog-screen"):classNames.push("dialog-frame");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},this.props.children);}}]);return Dialog;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Dialog.propTypes={fitScreen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};Dialog.defaultProps={fitScreen:false};/* harmony default export */ __webpack_exports__["a"] = (Dialog);

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_app_bar_Accent__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_app_bar_HamburgerMenu__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_app_bar_Context__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AppBar_css__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AppBar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__AppBar_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Presentational component
var AppBar=function(_React$Component){_inherits(AppBar,_React$Component);function AppBar(){_classCallCheck(this,AppBar);return _possibleConstructorReturn(this,(AppBar.__proto__||Object.getPrototypeOf(AppBar)).apply(this,arguments));}_createClass(AppBar,[{key:'render',value:function render(){// Swap the menubutton onclick to close if the menu is open, and vice versa
var menuButtonOnClick=this.props.isMenuOpen?this.props.closeAppMenu:this.props.openAppMenu;var appReferrer=this.props.appReferrer;var productTitle=appReferrer==="xpressions"||appReferrer==="parentapps"?"schoolmoney":"eduspot";// Update the app title if its only sm app
if(appReferrer==="xpressions"||appReferrer==="parentapps"){document.title="SchoolMoney";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'app-bar__brand'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */],{path:'/:product?',component:__WEBPACK_IMPORTED_MODULE_7_components_app_bar_Accent__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* NavLink */],{to:'/',className:'app-bar__title',activeClassName:'app-bar__title--selected'},productTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_app_bar_HamburgerMenu__["a" /* default */],{isMenuOpen:this.props.isMenuOpen,onClick:menuButtonOnClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Route */],{component:__WEBPACK_IMPORTED_MODULE_9_components_app_bar_Context__["a" /* default */]}));}}]);return AppBar;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);// container component
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isMenuOpen:Object(__WEBPACK_IMPORTED_MODULE_6_state_app_selectors__["s" /* isMenuOpen */])(state),appReferrer:Object(__WEBPACK_IMPORTED_MODULE_6_state_app_selectors__["l" /* getUserIdentityAppReferrer */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({openAppMenu:__WEBPACK_IMPORTED_MODULE_5_state_app_actions__["M" /* openAppMenu */],closeAppMenu:__WEBPACK_IMPORTED_MODULE_5_state_app_actions__["A" /* closeAppMenu */]},dispatch);},null,// The appbar is impure because it depends on routing state
// This is required to make the appbar re-render on location change (outside of the menu click)
{pure:false})(AppBar));

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(102);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(24);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(90);

var _PathUtils = __webpack_require__(54);

var _createTransitionManager = __webpack_require__(91);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(169);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(102);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(19);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(24);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(90);

var _PathUtils = __webpack_require__(54);

var _createTransitionManager = __webpack_require__(91);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(169);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(124);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(170);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(127);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(128);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(131);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(132);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(72);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(133);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_selectors__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Accent=function(_React$Component){_inherits(Accent,_React$Component);function Accent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Accent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Accent.__proto__||Object.getPrototypeOf(Accent)).call.apply(_ref,[this].concat(args))),_this),_this.getActiveProducts=function(){var _this$props=_this.props,availableProducts=_this$props.availableProducts,match=_this$props.match;var urlProduct=match.params.product;if(availableProducts.includes(urlProduct)){return[urlProduct];}else{return availableProducts;}},_this.renderAccentSection=function(product){var isActive=_this.getActiveProducts().includes(product);var classNames=["app-bar__accent-section"];var cssModifier=isActive?"active":"inactive";classNames.push("app-bar__accent-section--"+cssModifier);classNames.push("app-bar__accent-section--"+product);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" "),key:product});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Accent,[{key:"render",value:function render(){var appReferrer=this.props.appReferrer;var classNames=["app-bar__accent"];if(appReferrer==="xpressions"||appReferrer==="parentapps"){classNames.push("app-bar__accent-width--school_money");}else{classNames.push("app-bar__accent-width--eduspot");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},this.props.availableProducts.map(this.renderAccentSection));}}]);return Accent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{availableProducts:Object(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["a" /* getAvailableProducts */])(state),appReferrer:Object(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["l" /* getUserIdentityAppReferrer */])(state)};})(Accent));

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HamburgerMenu_css__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HamburgerMenu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__HamburgerMenu_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HamburgerMenu=function(_React$Component){_inherits(HamburgerMenu,_React$Component);function HamburgerMenu(){_classCallCheck(this,HamburgerMenu);return _possibleConstructorReturn(this,(HamburgerMenu.__proto__||Object.getPrototypeOf(HamburgerMenu)).apply(this,arguments));}_createClass(HamburgerMenu,[{key:"render",value:function render(){var buttonClass="app-menu-button hamburger hamburger--squeeze";if(this.props.isMenuOpen){buttonClass=buttonClass+" is-active";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:buttonClass,type:"button",onClick:this.props.onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"hamburger-box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"hamburger-inner"})));}}]);return HamburgerMenu;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (HamburgerMenu);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_transition_group__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_app_bar_InfoButton__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_BasketButton__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Context_css__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Context_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Context_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Renders the contextual button in the app bar (if any)
 * This is (currently) either the Info button or the Basket button
 * Transitions are applied between different buttons
 */var Context=function(_React$Component){_inherits(Context,_React$Component);function Context(){_classCallCheck(this,Context);return _possibleConstructorReturn(this,(Context.__proto__||Object.getPrototypeOf(Context)).apply(this,arguments));}_createClass(Context,[{key:"render",value:function render(){var _props=this.props,location=_props.location,isMenuOpen=_props.isMenuOpen;// state key for InfoButton is whether menu is open
var infoButtonKey="menu:"+isMenuOpen;// state key for route-based button is derived from location
// WARNING: this assumes that the button only and always changes
//   when the top-level part of the path changes (e.g. the product)
var routeButtonKey="route:"+location.hash.split("/")[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"app-bar__context"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__["TransitionGroup"],null,isMenuOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__["CSSTransition"],{key:infoButtonKey,classNames:"app-bar__context-item",timeout:200},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_app_bar_InfoButton__["a" /* default */],null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__["CSSTransition"],{key:routeButtonKey,classNames:"app-bar__context-item",timeout:200,"in":!this.props.isMenuOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Switch */],{location:location},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:"/school_money/",component:__WEBPACK_IMPORTED_MODULE_6_components_school_money_BasketButton__["a" /* default */]})))));}}]);return Context;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isMenuOpen:Object(__WEBPACK_IMPORTED_MODULE_4_state_app_selectors__["s" /* isMenuOpen */])(state)};})(Context));

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(3);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(452);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(454);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(174);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(175);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');
      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');
      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';

      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName,
        doneClassName = _getClassNames.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    /* eslint-disable no-unused-expressions */
    node && node.scrollTop;
    /* eslint-enable no-unused-expressions */
    addClass(node, className);
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(453);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(67);

var _TransitionGroup = __webpack_require__(176);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  in: _propTypes2.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react2.default.Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');

    return null;
  }
};

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = function (_React$Component) {
  _inherits(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReplaceTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReplaceTransition.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react2.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  ReplaceTransition.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        inProp = _props.in,
        props = _objectWithoutProperties(_props, ['children', 'in']);

    var _React$Children$toArr = _react2.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;

    return _react2.default.createElement(
      _TransitionGroup2.default,
      props,
      inProp ? _react2.default.cloneElement(first, {
        key: 'first',
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered

      }) : _react2.default.cloneElement(second, {
        key: 'second',
        onEnter: this.handleExit,
        onEntering: this.handleExiting,
        onEntered: this.handleExited
      })
    );
  };

  return ReplaceTransition;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleEnter = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _this2.handleLifecycle('onEnter', 0, args);
  };

  this.handleEntering = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _this2.handleLifecycle('onEntering', 0, args);
  };

  this.handleEntered = function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _this2.handleLifecycle('onEntered', 0, args);
  };

  this.handleExit = function () {
    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _this2.handleLifecycle('onExit', 1, args);
  };

  this.handleExiting = function () {
    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _this2.handleLifecycle('onExiting', 1, args);
  };

  this.handleExited = function () {
    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return _this2.handleLifecycle('onExited', 1, args);
  };
};

ReplaceTransition.propTypes =  false ? propTypes : {};

exports.default = ReplaceTransition;
module.exports = exports['default'];

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_assets_images_app_info_svg__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_assets_images_app_info_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_assets_images_app_info_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InfoButton_css__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InfoButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InfoButton_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Infobutton - button active when main-menu is open
 */var InfoButton=function(_React$Component){_inherits(InfoButton,_React$Component);function InfoButton(){_classCallCheck(this,InfoButton);return _possibleConstructorReturn(this,(InfoButton.__proto__||Object.getPrototypeOf(InfoButton)).apply(this,arguments));}_createClass(InfoButton,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* NavLink */],{to:"/info/",className:"app-info-button",activeClassName:"app-info-button--selected"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"app-info-button__icon",src:__WEBPACK_IMPORTED_MODULE_2_components_assets_images_app_info_svg___default.a,alt:""}));}}]);return InfoButton;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (InfoButton);

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/app-info.04353961.svg";

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_assets_images_school_money_basket_svg__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_assets_images_school_money_basket_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_assets_images_school_money_basket_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BasketButton_css__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BasketButton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__BasketButton_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BasketButton=function(_React$Component){_inherits(BasketButton,_React$Component);function BasketButton(){_classCallCheck(this,BasketButton);return _possibleConstructorReturn(this,(BasketButton.__proto__||Object.getPrototypeOf(BasketButton)).apply(this,arguments));}_createClass(BasketButton,[{key:"render",/*
   * NOTE: the `key` prop on CSSTransition is very important here.
   * TransitionGroup allows animating elements as they enter and leave.
   * When totalPrice changes, we want to animate the old price out and the new price in.
   * Using key={totalPrice} we ensure that the CSSTransition component is not reused.
   * So when totalPrice changes, a new CSSTransition will be mounted and the old one will be unmounted.
   * Due to the wrapping TransitionGroup, this allows both CSSTransition components to animate
   *   simultaneously (one in, one out).
   */value:function render(){var _props=this.props,isEmpty=_props.isEmpty,totalPrice=_props.totalPrice,totalQuantity=_props.totalQuantity;var basketState=isEmpty?"empty":"not-empty";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* NavLink */],{to:"/school_money/basket/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-button basket-button--"+basketState},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"basket-button__img",src:__WEBPACK_IMPORTED_MODULE_6_components_assets_images_school_money_basket_svg___default.a,alt:"basket"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__["TransitionGroup"],null,!isEmpty?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__["CSSTransition"],{key:totalQuantity+":"+totalPrice,classNames:"basket-button__info",timeout:500},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-button__info"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Currency__["a" /* default */],{className:"basket-button__total-price",amount:totalPrice}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-button__total-quantity"},totalQuantity))):null)));}}]);return BasketButton;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isEmpty:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_68" /* isBasketEmpty */])(state),totalPrice:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["z" /* getBasketTotalPrice */])(state),totalQuantity:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["A" /* getBasketTotalQuantity */])(state)};})(BasketButton));

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/basket.cf07bfe8.svg";

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_app_Preloader__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_app_home_AvailableProductsHomeSections__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HomePage_css__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HomePage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__HomePage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HomePage=function(_React$Component){_inherits(HomePage,_React$Component);function HomePage(){_classCallCheck(this,HomePage);return _possibleConstructorReturn(this,(HomePage.__proto__||Object.getPrototypeOf(HomePage)).apply(this,arguments));}_createClass(HomePage,[{key:"getGreeting",value:function getGreeting(){var now=__WEBPACK_IMPORTED_MODULE_1_moment___default()();var morningCutoff=__WEBPACK_IMPORTED_MODULE_1_moment___default()(now).hour(12).startOf("hour");var afternoonCutoff=__WEBPACK_IMPORTED_MODULE_1_moment___default()(now).hour(18).startOf("hour");if(now.isBefore(morningCutoff)){return"Good Morning!";}if(now.isBefore(afternoonCutoff)){return"Good Afternoon!";}return"Good Evening!";}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"home-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"home-greeting"},this.getGreeting()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"home-page-sections"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_app_Preloader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_app_home_AvailableProductsHomeSections__["a" /* default */],null))));}}]);return HomePage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (HomePage);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Gate__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_LoadingPage__ = __webpack_require__(59);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Preloader=function(_React$Component){_inherits(Preloader,_React$Component);function Preloader(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Preloader);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Preloader.__proto__||Object.getPrototypeOf(Preloader)).call.apply(_ref,[this].concat(args))),_this),_this.placeholder=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_LoadingPage__["a" /* default */],null),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Preloader,[{key:"render",value:function render(){var _props=this.props,isLoadingAvailableProducts=_props.isLoadingAvailableProducts,children=_props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Gate__["a" /* default */],{isOpen:!isLoadingAvailableProducts,placeholder:this.placeholder},children);}}]);return Preloader;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isLoadingAvailableProducts:Object(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["q" /* isLoadingAvailableProducts */])(state)};})(Preloader));

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_validate__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_app_home_sections_teachers_TeachersHomeSection__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_app_home_sections_school_money_SchoolMoneyHomeSection__ = __webpack_require__(478);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * This component delegates to any of the sections in the
 *   'sections' subdirectory, based on the available products.
 */var AvailableProductsHomeSections=function(_React$Component){_inherits(AvailableProductsHomeSections,_React$Component);function AvailableProductsHomeSections(){_classCallCheck(this,AvailableProductsHomeSections);return _possibleConstructorReturn(this,(AvailableProductsHomeSections.__proto__||Object.getPrototypeOf(AvailableProductsHomeSections)).apply(this,arguments));}_createClass(AvailableProductsHomeSections,[{key:"render",value:function render(){var availableProducts=this.props.availableProducts;var sections=[];if(availableProducts.includes("teachers")&&Object(__WEBPACK_IMPORTED_MODULE_3_lib_validate__["e" /* isProductAvailable */])("teachers")&&Object(__WEBPACK_IMPORTED_MODULE_3_lib_validate__["c" /* isAppserverOnline */])()){sections.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_app_home_sections_teachers_TeachersHomeSection__["a" /* default */],{key:"teachers"}));}if(availableProducts.includes("school_money")&&Object(__WEBPACK_IMPORTED_MODULE_3_lib_validate__["e" /* isProductAvailable */])("school_money")&&Object(__WEBPACK_IMPORTED_MODULE_3_lib_validate__["c" /* isAppserverOnline */])()){sections.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_app_home_sections_school_money_SchoolMoneyHomeSection__["a" /* default */],{key:"school_money"}));}return sections;}}]);return AvailableProductsHomeSections;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{availableProducts:Object(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["a" /* getAvailableProducts */])(state)};})(AvailableProductsHomeSections));

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_app_home_sections_teachers_RecentMessages__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_app_home_sections_teachers_RecentNotices__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TeachersHomeSection_css__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TeachersHomeSection_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TeachersHomeSection_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Delegate to each of the sections for the T2P product
 */var TeachersHomeSection=function(_React$Component){_inherits(TeachersHomeSection,_React$Component);function TeachersHomeSection(){_classCallCheck(this,TeachersHomeSection);return _possibleConstructorReturn(this,(TeachersHomeSection.__proto__||Object.getPrototypeOf(TeachersHomeSection)).apply(this,arguments));}_createClass(TeachersHomeSection,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-home"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_app_home_sections_teachers_RecentMessages__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_app_home_sections_teachers_RecentNotices__["a" /* default */],null));}}]);return TeachersHomeSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (TeachersHomeSection);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Gate__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_app_home_Preloader__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_app_home_sections_teachers_Message__ = __webpack_require__(472);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// number of messages to display
var MESSAGE_COUNT=3;var RecentMessages=function(_React$Component){_inherits(RecentMessages,_React$Component);function RecentMessages(){_classCallCheck(this,RecentMessages);return _possibleConstructorReturn(this,(RecentMessages.__proto__||Object.getPrototypeOf(RecentMessages)).apply(this,arguments));}_createClass(RecentMessages,[{key:"renderPlaceholder",value:function renderPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"home-section-placeholder"},"There are currently no messages to display.");}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"home-section teachers-home-messages"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"home-section-heading home-section-heading--teachers teachers-home-messages__heading"},"Recent Messages"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_app_home_Preloader__["a" /* default */],{isLoading:this.props.isMessagesLoading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Gate__["a" /* default */],{isOpen:this.props.messages.size>0,placeholder:this.renderPlaceholder()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-home-messages__body"},this.props.messages.map(function(message){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_app_home_sections_teachers_Message__["a" /* default */],{key:message.get("id"),message:message});})))));}}]);return RecentMessages;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{messages:Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["h" /* getRecentMessages */])(state,MESSAGE_COUNT),isMessagesLoading:Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["x" /* isMessagesLoading */])(state)};})(RecentMessages));

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_truncate__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_app_home_Card__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_app_home_BulletItem__ = __webpack_require__(62);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Message=function(_React$Component){_inherits(Message,_React$Component);function Message(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Message);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Message.__proto__||Object.getPrototypeOf(Message)).call.apply(_ref,[this].concat(args))),_this),_this.goToMessage=function(){_this.props.goToMessage(_this.props.message.get("id"));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Message,[{key:"render",value:function render(){var message=this.props.message;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-home-messages__link",onClick:this.goToMessage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_app_home_Card__["a" /* default */],{className:"teachers-home-messages__message"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_app_home_BulletItem__["a" /* default */],{cssModifier:"teachers"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-home-messages__message-body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_truncate__["a" /* default */],{lines:3,trimWhitespace:true},message.get("body"))))));}}]);return Message;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(undefined,{goToMessage:__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["M" /* goToMessage */]})(Message));

/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Gate__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_app_home_Preloader__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_app_home_sections_teachers_Notice__ = __webpack_require__(476);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NOTICE_COUNT=3;var RecentNotices=function(_React$Component){_inherits(RecentNotices,_React$Component);function RecentNotices(){_classCallCheck(this,RecentNotices);return _possibleConstructorReturn(this,(RecentNotices.__proto__||Object.getPrototypeOf(RecentNotices)).apply(this,arguments));}_createClass(RecentNotices,[{key:"renderPlaceholder",value:function renderPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-home-notices__placeholder"},"There are currently no notices to display.");}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"home-section teachers-home-notices"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"home-section-heading home-section-heading--teachers teachers-home-notices__heading"},"Recent Notices"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_app_home_Preloader__["a" /* default */],{isLoading:this.props.isLoading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Gate__["a" /* default */],{isOpen:this.props.notices.size>0,placeholder:this.renderPlaceholder()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-home-notices__body"},this.props.notices.map(function(notice){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_app_home_sections_teachers_Notice__["a" /* default */],{key:notice.get("id"),notice:notice});})))));}}]);return RecentNotices;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{notices:Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["i" /* getRecentNotices */])(state,NOTICE_COUNT),isLoading:Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["z" /* isNoticesLoading */])(state)};})(RecentNotices));

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_truncate__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Date__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_app_home_Card__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_app_home_BulletItem__ = __webpack_require__(62);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Notice=function(_React$Component){_inherits(Notice,_React$Component);function Notice(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Notice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Notice.__proto__||Object.getPrototypeOf(Notice)).call.apply(_ref,[this].concat(args))),_this),_this.goToNotice=function(){_this.props.goToNotice(_this.props.notice.get("id"));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Notice,[{key:"render",value:function render(){var notice=this.props.notice;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-home-notices__link",onClick:this.goToNotice},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_app_home_Card__["a" /* default */],{className:"teachers-home-notices__notice"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_app_home_BulletItem__["a" /* default */],{cssModifier:"teachers"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-home-notices__notice-subject"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_truncate__["a" /* default */],{lines:1,trimWhitespace:true},notice.get("subject"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-home-notices__notice-timestamp"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Date__["a" /* default */],{date:notice.get("postedDate")})))));}}]);return Notice;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(undefined,{goToNotice:__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["N" /* goToNotice */]})(Notice));

/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_app_home_sections_school_money_NewPayments__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_app_home_sections_school_money_OverduePayments__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_app_home_sections_school_money_NewShopItems__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SchoolMoneyHomeSection_css__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SchoolMoneyHomeSection_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SchoolMoneyHomeSection_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Delegate to each of the sections for the SM product
 */var SchoolMoneyHomeSection=function(_React$Component){_inherits(SchoolMoneyHomeSection,_React$Component);function SchoolMoneyHomeSection(){_classCallCheck(this,SchoolMoneyHomeSection);return _possibleConstructorReturn(this,(SchoolMoneyHomeSection.__proto__||Object.getPrototypeOf(SchoolMoneyHomeSection)).apply(this,arguments));}_createClass(SchoolMoneyHomeSection,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-home"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_app_home_sections_school_money_NewPayments__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_app_home_sections_school_money_OverduePayments__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_app_home_sections_school_money_NewShopItems__["a" /* default */],null));}}]);return SchoolMoneyHomeSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (SchoolMoneyHomeSection);

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_app_home_Preloader__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_app_home_Card__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_app_home_BulletItem__ = __webpack_require__(62);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewPayments=function(_React$Component){_inherits(NewPayments,_React$Component);function NewPayments(){_classCallCheck(this,NewPayments);return _possibleConstructorReturn(this,(NewPayments.__proto__||Object.getPrototypeOf(NewPayments)).apply(this,arguments));}_createClass(NewPayments,[{key:"getPaymentTypePath",value:function getPaymentTypePath(paymentType){switch(paymentType){case"payment":return"payments";case"dinnerBooking":return"dinners";case"clubBooking":return"clubs";default:return"";}}},{key:"getPaymentTypeLabel",value:function getPaymentTypeLabel(paymentType){switch(paymentType){case"payment":return"Payments";case"dinnerBooking":return"Dinner Bookings";case"clubBooking":return"Club Bookings";default:return"";}}},{key:"renderItem",value:function renderItem(paymentType,count){var pathPart=this.getPaymentTypePath(paymentType);var label=this.getPaymentTypeLabel(paymentType);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{key:paymentType,className:"school_money-home-new-payments__link",to:"/school_money/"+pathPart+"/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_app_home_Card__["a" /* default */],{className:"school_money-home-new-payments__card"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_app_home_BulletItem__["a" /* default */],{cssModifier:"school_money"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-home-new-payments__item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-home-new-payments__payment-type"},label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-home-new-payments__count"},count)))));}},{key:"render",value:function render(){var _this2=this;var _props=this.props,isLoading=_props.isLoading,newCounts=_props.newCounts;var items=newCounts.filter(function(_ref){var _ref2=_slicedToArray(_ref,2),paymentType=_ref2[0],count=_ref2[1];return count>0;});if(items.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"home-section school_money-home-new-payments"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"home-section-heading home-section-heading--school_money school_money-home-new-payments__heading"},"New Payments"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_app_home_Preloader__["a" /* default */],{isLoading:isLoading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-home-new-payments__body"},items.map(function(_ref3){var _ref4=_slicedToArray(_ref3,2),paymentType=_ref4[0],count=_ref4[1];return _this2.renderItem(paymentType,count);}))));}}]);return NewPayments;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isLoading:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_63" /* isActivePaymentsLoading */])(state),newCounts:[["payment",Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_15" /* getNewPaymentCount */])(state)],["dinnerBooking",Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_14" /* getNewDinnerBookingCount */])(state)],["clubBooking",Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_13" /* getNewClubBookingCount */])(state)]]};})(NewPayments));

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_app_home_Preloader__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_app_home_Card__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_app_home_BulletItem__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentName__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Date__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OverduePayments=function(_React$Component){_inherits(OverduePayments,_React$Component);function OverduePayments(){_classCallCheck(this,OverduePayments);return _possibleConstructorReturn(this,(OverduePayments.__proto__||Object.getPrototypeOf(OverduePayments)).apply(this,arguments));}_createClass(OverduePayments,[{key:"renderPayment",value:function renderPayment(payment){var _this2=this;var _payment$toObject=payment.toObject(),paymentID=_payment$toObject.paymentID,description=_payment$toObject.description,dueDate=_payment$toObject.dueDate,studentID=_payment$toObject.studentID;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:paymentID,className:"school_money-home-overdue-payments__link",onClick:function onClick(){return _this2.props.goToPayment(paymentID);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_app_home_Card__["a" /* default */],{className:"school_money-home-overdue-payments__payment"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_app_home_BulletItem__["a" /* default */],{cssModifier:"school_money"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-home-overdue-payments__payment-details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-home-overdue-payments__description"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentName__["a" /* default */],{studentID:studentID,last:false})," - ",description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-home-overdue-payments__due-date"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Date__["a" /* default */],{date:dueDate}))))));}},{key:"render",value:function render(){var _this3=this;var _props=this.props,payments=_props.payments,isReady=_props.isReady;if(payments.size===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"home-section school_money-home-overdue-payments"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"home-section-heading home-section-heading--school_money school_money-home-overdue-payments__heading"},"Overdue Payments"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_app_home_Preloader__["a" /* default */],{isLoading:!isReady},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-home-overdue-payments__body"},payments.map(function(payment){return _this3.renderPayment(payment);}))));}}]);return OverduePayments;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{payments:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_17" /* getOverduePayments */])(state),isReady:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_106" /* isPaymentsReady */])(state)&&Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_111" /* isStudentsReady */])(state)};},{goToPayment:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_72" /* goToPayment */]})(OverduePayments));

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_app_home_Preloader__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_app_home_sections_school_money_ShopItem__ = __webpack_require__(482);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// maximum number of shop items to show
var MAX_SHOP_ITEMS_COUNT=3;var NewShopItems=function(_React$Component){_inherits(NewShopItems,_React$Component);function NewShopItems(){_classCallCheck(this,NewShopItems);return _possibleConstructorReturn(this,(NewShopItems.__proto__||Object.getPrototypeOf(NewShopItems)).apply(this,arguments));}_createClass(NewShopItems,[{key:"render",value:function render(){var _props=this.props,shopItems=_props.shopItems,isLoading=_props.isLoading;if(shopItems.size===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"home-section school_money-home-shop-items"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"home-section-heading home-section-heading--school_money school_money-home-shop-items__heading"},"New Shop Items"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_app_home_Preloader__["a" /* default */],{isLoading:isLoading},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-home-shop-items__body"},shopItems.map(function(shopItem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_app_home_sections_school_money_ShopItem__["a" /* default */],{key:shopItem.id,shopItem:shopItem});}))));}}]);return NewShopItems;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isLoading:!Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_110" /* isShopReady */])(state),shopItems:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_16" /* getNewShopItems */])(state,MAX_SHOP_ITEMS_COUNT)};})(NewShopItems));

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_app_home_Card__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_app_home_BulletItem__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Currency__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShopItem=function(_React$Component){_inherits(ShopItem,_React$Component);function ShopItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ShopItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ShopItem.__proto__||Object.getPrototypeOf(ShopItem)).call.apply(_ref,[this].concat(args))),_this),_this.goToShopItem=function(){var _this$props=_this.props,shopItem=_this$props.shopItem,studentID=_this$props.studentID;_this.props.goToShopItem(shopItem.id,studentID);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ShopItem,[{key:"render",value:function render(){var _props$shopItem=this.props.shopItem,id=_props$shopItem.id,name=_props$shopItem.name,price=_props$shopItem.price;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:id,onClick:this.goToShopItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_app_home_Card__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_app_home_BulletItem__["a" /* default */],{cssModifier:"school_money"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-home-shop-items__shop-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-home-shop-items__name"},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-home-shop-items__price"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Currency__["a" /* default */],{amount:price}))))));}}]);return ShopItem;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/**
 * Get default studentID to go to on click.
 * First student ID for the shop item's school.
 *//* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref2){var shopItem=_ref2.shopItem;return{studentID:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_34" /* getSchoolStudentIDList */])(state,shopItem.schoolID).first()};},{goToShopItem:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_73" /* goToShopItem */]})(ShopItem));

/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ExpandingBox__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_app_AppInfoTable__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_app_info_AvailableProductsSchoolList__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InfoPage_css__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InfoPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__InfoPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InfoPage=function(_React$Component){_inherits(InfoPage,_React$Component);function InfoPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InfoPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InfoPage.__proto__||Object.getPrototypeOf(InfoPage)).call.apply(_ref,[this].concat(args))),_this),_this.teachersGuideOnClick=function(event){event.stopPropagation();_this.props.openTeachersGuide();__WEBPACK_IMPORTED_MODULE_7_state_history__["a" /* history */].push("/teachers/");},_this.schoolMoneyGuideOnClick=function(event){event.stopPropagation();_this.props.openSchoolMoneyGuide();__WEBPACK_IMPORTED_MODULE_7_state_history__["a" /* history */].push("/school_money/");},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InfoPage,[{key:"render",value:function render(){var teachersGuideButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Button__["a" /* default */],{className:"app-info-teachers-guide__button",onClick:this.teachersGuideOnClick},"View Teachers2Parents Introduction");var schoolMoneyGuideButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Button__["a" /* default */],{className:"app-info-school_money-guide__button",onClick:this.schoolMoneyGuideOnClick},"View SchoolMoney Introduction");var isTeachersAvailable=this.props.availableProducts.includes("teachers");var isSchoolMoneyAvailable=this.props.availableProducts.includes("school_money");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"info-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"page-header__title"},"Information"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"info-list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"info-list__registered-schools-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_app_info_AvailableProductsSchoolList__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",{className:"info-list__subhr"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"info-list__app-info-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"app-info-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ExpandingBox__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ExpandingBox__["a" /* default */].Header,{toggleOnClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"app-info-item__title"},"About Us")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ExpandingBox__["a" /* default */].Body,{toggleOnClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Eduspot is an educational software company that has been providing online solutions for schools country-wide for over a decade."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We develop web-based systems that make life easier for both parents and schools alike. The Eduspot brand includes several successful and innovative products such as the messaging service Teachers2Parents, payment system SchoolMoney, and management information system SchoolPod."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"app-info-guide-buttons"},isTeachersAvailable?teachersGuideButton:null,isSchoolMoneyAvailable?schoolMoneyGuideButton:null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"app-info-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ExpandingBox__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ExpandingBox__["a" /* default */].Header,{toggleOnClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"app-info-item__title"},"App Info")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ExpandingBox__["a" /* default */].Body,{toggleOnClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_app_AppInfoTable__["a" /* default */],{cssBlockName:"app-info-table"})))))));}}]);return InfoPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{availableProducts:Object(__WEBPACK_IMPORTED_MODULE_6_state_app_selectors__["a" /* getAvailableProducts */])(state)};},{openTeachersGuide:__WEBPACK_IMPORTED_MODULE_8_state_teachers_actions__["R" /* openGuide */],openSchoolMoneyGuide:__WEBPACK_IMPORTED_MODULE_9_state_school_money_actions__["_82" /* openGuide */]})(InfoPage));

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_validate__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_app_info_TeachersSchoolList__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_app_info_SchoolMoneySchoolList__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_assets_images_teachers_teachers_logo_text_right_svg__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_assets_images_teachers_teachers_logo_text_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_assets_images_teachers_teachers_logo_text_right_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_assets_images_school_money_school_money_logo_text_right_svg__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_assets_images_school_money_school_money_logo_text_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_assets_images_school_money_school_money_logo_text_right_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AvailableProductsSchoolList_css__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AvailableProductsSchoolList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AvailableProductsSchoolList_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var products={teachers:{name:"Teachers2Parents",logo:__WEBPACK_IMPORTED_MODULE_6_components_assets_images_teachers_teachers_logo_text_right_svg___default.a},school_money:{name:"SchoolMoney",logo:__WEBPACK_IMPORTED_MODULE_7_components_assets_images_school_money_school_money_logo_text_right_svg___default.a}};var AvailableProductsSchoolList=function(_React$Component){_inherits(AvailableProductsSchoolList,_React$Component);function AvailableProductsSchoolList(){_classCallCheck(this,AvailableProductsSchoolList);return _possibleConstructorReturn(this,(AvailableProductsSchoolList.__proto__||Object.getPrototypeOf(AvailableProductsSchoolList)).apply(this,arguments));}_createClass(AvailableProductsSchoolList,[{key:"renderProductSchoolList",value:function renderProductSchoolList(product){switch(product){case"teachers":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_app_info_TeachersSchoolList__["a" /* default */],null);case"school_money":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_app_info_SchoolMoneySchoolList__["a" /* default */],null);default:return null;}}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"school-list__heading"},"Registered Schools"),this.props.availableProducts.sort().map(function(product){return Object(__WEBPACK_IMPORTED_MODULE_3_lib_validate__["e" /* isProductAvailable */])(product)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-list__product-section school-list__product-section--"+product,key:product},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-list__product-heading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"school-list__product-logo",src:products[product].logo,alt:products[product].name})),_this2.renderProductSchoolList(product)):null;}));}}]);return AvailableProductsSchoolList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{availableProducts:Object(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["a" /* getAvailableProducts */])(state)};})(AvailableProductsSchoolList));

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Spinner__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_teachers_SchoolLogo__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_app_info_SchoolInfo__ = __webpack_require__(181);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TeachersSchoolList=function(_React$Component){_inherits(TeachersSchoolList,_React$Component);function TeachersSchoolList(){_classCallCheck(this,TeachersSchoolList);return _possibleConstructorReturn(this,(TeachersSchoolList.__proto__||Object.getPrototypeOf(TeachersSchoolList)).apply(this,arguments));}_createClass(TeachersSchoolList,[{key:"render",value:function render(){if(!this.props.isReady){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-list__placeholder"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Spinner__["a" /* default */],{size:"standalone",color:"teachers"}));}return this.props.schoolList.map(function(school){var _school$toObject=school.toObject(),id=_school$toObject.id,name=_school$toObject.name,websiteURL=_school$toObject.websiteURL,phoneNumber=_school$toObject.phoneNumber,emailAddress=_school$toObject.emailAddress;var logo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_teachers_SchoolLogo__["a" /* default */],{school:school,cssBlockName:"school-info"});var props={name:name,websiteURL:websiteURL,phoneNumber:phoneNumber,emailAddress:emailAddress,logo:logo};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_app_info_SchoolInfo__["a" /* default */],Object.assign({key:id,product:"teachers"},props));});}}]);return TeachersSchoolList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{schoolList:Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["m" /* getSchoolList */])(state),isReady:Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["B" /* isSchoolsReady */])(state)};})(TeachersSchoolList));

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_validate__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_assets_images_teachers_teachers_logo_new_svg__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_assets_images_teachers_teachers_logo_new_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_assets_images_teachers_teachers_logo_new_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_SchoolLogo__ = __webpack_require__(180);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SchoolLogo=function(_React$Component){_inherits(SchoolLogo,_React$Component);function SchoolLogo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SchoolLogo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SchoolLogo.__proto__||Object.getPrototypeOf(SchoolLogo)).call.apply(_ref,[this].concat(args))),_this),_this.getLogoURL=function(){var _this$props$school$to=_this.props.school.toJS(),serverHostname=_this$props$school$to.serverHostname,logoFileName=_this$props$school$to.logoFileName;if(logoFileName===""||!Object(__WEBPACK_IMPORTED_MODULE_3_lib_validate__["d" /* isLogoPathValid */])(logoFileName)){return __WEBPACK_IMPORTED_MODULE_4_components_assets_images_teachers_teachers_logo_new_svg___default.a;}return"https://"+serverHostname+"/public/teachers/school_logo/"+logoFileName;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SchoolLogo,[{key:"render",value:function render(){var _props=this.props,school=_props.school,cssBlockName=_props.cssBlockName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_SchoolLogo__["a" /* default */],{logoURL:this.getLogoURL(),schoolName:school.get("name"),cssBlockName:cssBlockName,cssModifier:"teachers"});}}]);return SchoolLogo;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);SchoolLogo.propTypes={school:__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.shape({serverHostname:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,logoFileName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired}).isRequired,cssBlockName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (SchoolLogo);

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/teachers-logo--new.eaf45896.svg";

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Spinner__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_SchoolLogo__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_app_info_SchoolInfo__ = __webpack_require__(181);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SchoolMoneySchoolList=function(_React$Component){_inherits(SchoolMoneySchoolList,_React$Component);function SchoolMoneySchoolList(){_classCallCheck(this,SchoolMoneySchoolList);return _possibleConstructorReturn(this,(SchoolMoneySchoolList.__proto__||Object.getPrototypeOf(SchoolMoneySchoolList)).apply(this,arguments));}_createClass(SchoolMoneySchoolList,[{key:"render",value:function render(){if(!this.props.isReady){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-list__placeholder"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Spinner__["a" /* default */],{size:"standalone",color:"school_money"}));}return this.props.schoolList.map(function(school){var _school$toObject=school.toObject(),id=_school$toObject.id,name=_school$toObject.name,websiteURL=_school$toObject.websiteURL,phoneNumber=_school$toObject.phoneNumber,emailAddress=_school$toObject.emailAddress;var logo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_SchoolLogo__["a" /* default */],{school:school,cssBlockName:"school-info"});var props={name:name,websiteURL:websiteURL,phoneNumber:phoneNumber,emailAddress:emailAddress,logo:logo};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_app_info_SchoolInfo__["a" /* default */],Object.assign({key:id,product:"school_money"},props));});}}]);return SchoolMoneySchoolList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{schoolList:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_32" /* getSchoolList */])(state),isReady:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_108" /* isSchoolsReady */])(state)};})(SchoolMoneySchoolList));

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/school_money-logo--new.c4776dc0.svg";

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_text__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_SearchBar__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_app_help_HelpItem__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__staticHelpContent__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__staticHelpContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__staticHelpContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HelpPage_css__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HelpPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__HelpPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// structure: staticHelpContent.items[index].sections[index]
var HelpPage=function(_React$Component){_inherits(HelpPage,_React$Component);function HelpPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HelpPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HelpPage.__proto__||Object.getPrototypeOf(HelpPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={helpItems:__WEBPACK_IMPORTED_MODULE_5__staticHelpContent___default.a.items,query:""},_this.onSearch=function(query){_this.setState({helpItems:HelpPage.filterHelpItems(__WEBPACK_IMPORTED_MODULE_5__staticHelpContent___default.a.items,query),query:query});},_this.getHelpList=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"help-list"},_this.state.helpItems.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_app_help_HelpItem__["a" /* default */],Object.assign({key:item.title},item));}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HelpPage,[{key:"render",value:function render(){var hasItems=this.state.helpItems.length>0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"help-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"page-header__title"},"Help"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_SearchBar__["a" /* default */],{onSearch:this.onSearch,query:this.state.query}),hasItems?this.getHelpList():HelpPage.placeholder);}}],[{key:"filterHelpSections",/**
   * Filter an array of help sections based on a search query
   *
   * @returns {Array} a new array containing only the sections that contain the query string in the header or body
   */value:function filterHelpSections(helpSections,query){return helpSections.filter(function(helpSection){return Object(__WEBPACK_IMPORTED_MODULE_1_lib_text__["c" /* search */])(helpSection.header,query)||Object(__WEBPACK_IMPORTED_MODULE_1_lib_text__["c" /* search */])(helpSection.body,query);});}/**
   * Filter an array of help items based on a search query
   *
   * @returns {Array} a new array containing only the items that contain the query string in the title or sections
   */},{key:"filterHelpItems",value:function filterHelpItems(helpItems,query){return helpItems// First, filter the sections of each item
.map(function(helpItem){// don't filter the sections if the item title matches the query!
if(Object(__WEBPACK_IMPORTED_MODULE_1_lib_text__["c" /* search */])(helpItem.title,query)){return helpItem;}var sections=HelpPage.filterHelpSections(helpItem.sections,query);return Object.assign({},helpItem,{sections:sections});})// now filter out those items that have no matching sections
.filter(function(helpItem){return helpItem.sections.length>0;});}}]);return HelpPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);HelpPage.placeholder=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"help-list__placeholder"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Card__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Card__["a" /* default */].Body,null,"There are no help topics matching your search.")));/* harmony default export */ __webpack_exports__["a"] = (HelpPage);

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/search--light.10350d2d.svg";

/***/ }),
/* 503 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ExpandingBox__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Accordion__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HelpItem_css__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HelpItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__HelpItem_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HelpItem=function(_React$Component){_inherits(HelpItem,_React$Component);function HelpItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HelpItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HelpItem.__proto__||Object.getPrototypeOf(HelpItem)).call.apply(_ref,[this].concat(args))),_this),_this.state={isExpanded:false},_this.onExpand=function(){_this.setState({isExpanded:true});},_this.onCollapse=function(){_this.setState({isExpanded:false});},_this.showHelpItem=function(applications){var availableProducts=_this.props.availableProducts;var find=function find(product){return availableProducts.includes(product);};if(applications.find(find)===undefined){return false;}return true;},_temp),_possibleConstructorReturn(_this,_ret);}// Show help item if user is registered to product.
_createClass(HelpItem,[{key:"render",value:function render(){var _props=this.props,title=_props.title,applications=_props.applications,sections=_props.sections;var isExpanded=this.state.isExpanded;var classNames=["help-item",isExpanded?"help-item--expanded":"help-item--collapsed"];// If user isn't registered to product do not show them the products help items.  
if(this.showHelpItem(applications)===false){return"";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ExpandingBox__["a" /* default */],{expanded:isExpanded,onExpand:this.onExpand,onCollapse:this.onCollapse},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ExpandingBox__["a" /* default */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"help-item__header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"help-item__accent"},applications.map(function(application){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"help-item__accent-piece help-item__accent-piece--"+application});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"help-item__title"},title))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ExpandingBox__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Accordion__["a" /* default */],{className:"help-accordion"},sections.map(function(_ref2){var header=_ref2.header,body=_ref2.body;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Accordion__["a" /* default */].Section,{key:header},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Accordion__["a" /* default */].Section.Header,null,header),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Accordion__["a" /* default */].Section.Body,null,body));})))));}}]);return HelpItem;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(state){return{availableProducts:Object(__WEBPACK_IMPORTED_MODULE_4_state_app_selectors__["a" /* getAvailableProducts */])(state)};})(HelpItem));

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_animate_height__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_animate_height___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_animate_height__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Accordion_css__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Accordion_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Accordion_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AccordionSectionHeader=function(_React$Component){_inherits(AccordionSectionHeader,_React$Component);function AccordionSectionHeader(){_classCallCheck(this,AccordionSectionHeader);return _possibleConstructorReturn(this,(AccordionSectionHeader.__proto__||Object.getPrototypeOf(AccordionSectionHeader)).apply(this,arguments));}_createClass(AccordionSectionHeader,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"accordion__section__header "+this.props.className+"__section__header"},this.props.children);}}]);return AccordionSectionHeader;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var AccordionSectionBody=function(_React$Component2){_inherits(AccordionSectionBody,_React$Component2);function AccordionSectionBody(){_classCallCheck(this,AccordionSectionBody);return _possibleConstructorReturn(this,(AccordionSectionBody.__proto__||Object.getPrototypeOf(AccordionSectionBody)).apply(this,arguments));}_createClass(AccordionSectionBody,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"accordion__section__body "+this.props.className+"__section__body"},this.props.children);}}]);return AccordionSectionBody;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var AccordionSection=function(_React$Component3){_inherits(AccordionSection,_React$Component3);function AccordionSection(){var _ref;var _temp,_this3,_ret;_classCallCheck(this,AccordionSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this3=_possibleConstructorReturn(this,(_ref=AccordionSection.__proto__||Object.getPrototypeOf(AccordionSection)).call.apply(_ref,[this].concat(args))),_this3),_this3.handleExpand=function(){_this3.props.onExpand(_this3.props.id);},_this3.handleCollapse=function(){_this3.props.onCollapse(_this3.props.id);},_temp),_possibleConstructorReturn(_this3,_ret);}_createClass(AccordionSection,[{key:"render",value:function render(){var bodyHeight=this.props.expanded?"auto":"0";var expandedClassName="accordion__section "+this.props.className+"__section accordion__section--expanded "+this.props.className+"__section--expanded";var collapsedClassName="accordion__section "+this.props.className+"__section accordion__section--collapsed "+this.props.className+"__section--collapsed";var className=this.props.expanded?expandedClassName:collapsedClassName;var header=this.props.children.filter(function(child){return child.type===AccordionSectionHeader;})[0];var body=this.props.children.filter(function(child){return child.type===AccordionSectionBody;})[0];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:className,onClick:this.props.expanded?this.handleCollapse:this.handleExpand},__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(header,{className:this.props.className}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_animate_height___default.a,{duration:300,height:bodyHeight},__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(body,{className:this.props.className})));}}]);return AccordionSection;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);AccordionSection.Header=AccordionSectionHeader;AccordionSection.Body=AccordionSectionBody;var Accordion=function(_React$Component4){_inherits(Accordion,_React$Component4);function Accordion(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,Accordion);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=Accordion.__proto__||Object.getPrototypeOf(Accordion)).call.apply(_ref2,[this].concat(args))),_this4),_this4.state={expandedIndex:null},_this4.handleChildExpand=function(id){_this4.setState({expandedIndex:id});},_this4.handleChildCollapse=function(id){_this4.setState({expandedIndex:null});},_temp2),_possibleConstructorReturn(_this4,_ret2);}_createClass(Accordion,[{key:"render",value:function render(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"accordion "+this.props.className},this.props.children.map(function(section,index){var childProps={key:index,id:index,expanded:_this5.state.expandedIndex===index,onExpand:_this5.handleChildExpand,onCollapse:_this5.handleChildCollapse,className:_this5.props.className};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(section,childProps);}));}}]);return Accordion;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Accordion.Section=AccordionSection;/* harmony default export */ __webpack_exports__["a"] = (Accordion);

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = {"items":[{"title":"General","applications":["teachers","school_money"],"sections":[{"header":"How do you know my mobile number?","body":"The mobile number you used to register with the app is the one the school has on record as a contact number for your child, and was already being used to contact you."},{"header":"If I get a new mobile number, can I still use the app?","body":"When you update your mobile number you will need to inform the school so that they can update their records. If you are using the same phone, you will be required to re-register with your new number. If you have a new phone, you will need to install the app on the new phone and register your new number."},{"header":"Does it cost me anything to use the app?","body":"It doesn’t! The app is free for you to use."},{"header":"Is the app secure?","body":"Absolutely. Your security is our priority, which is why all information processed via the app is end-to-end encrypted. Please be aware, however, that anyone with access to your device will have access to the Eduspot app."},{"header":"Is my information secure?","body":"All information such as your child’s details, your mobile number and your email address, are stored on our secure servers."},{"header":"How does the app know which school(s) my child attends?","body":"Your child's school will have your mobile phone number on record which they use to contact you via Eduspot services. As we recognise the schools that have your mobile number, we are then able to connect you to those schools."},{"header":"Some of the information provided in the app is incorrect or missing.","body":"Parts of the app are managed by the school. If something is incorrect or has expired we advise that you contact your child’s school who will be able to update it."},{"header":"What do you do with my information?","body":"Your mobile number and any details you provide via the app is stored on a secure UK server. Your personal information will never be passed on to anyone else. If you do not want the school to use your information for Eduspot services, please contact the school directly."},{"header":"Is my phone supported?","body":"This mobile app is supported on the following platforms: iOS 10 and above (iPhone). Android 4.4 and above."},{"header":"Can I save my login details?","body":"Once you have registered for the Eduspot App, you will not need to log in again."},{"header":"Can I change my password?","body":"When first logging in to the Eduspot app, you will not need a password, just a secure code that the app will send you upon registration. Once you have logged in once, you will not need to log in again."}]},{"title":"Messages","applications":["teachers"],"sections":[{"header":"Is it safe to send and receive messages in the app?","body":"Yes. It is just as safe as sending and receiving regular text messages to and from the school. If the school sends a message specifically to your mobile number, no-one else will be able to see this. Only the staff members at the school with access to Teachers2Parents will be able to see the messages that you send to them."},{"header":"Why don’t I receive text messages from the school anymore?","body":"Whilst you have the app installed on your phone, the Teachers2Parents system will automatically send any messages to the app instead of by SMS text message."},{"header":"Can I delete messages showing in the app?","body":"You cannot currently delete messages that show in the app."},{"header":"Why don’t I get a notification when I receive a new message?","body":"If you are not receiving any notifications, please check your phone's settings and ensure that app notifications are enabled."},{"header":"How do I send messages to the school? Why can’t I reply to the school’s messages?","body":"If you want to send a message to the school, type your message in the text box at the bottom of the message feed and tap the arrow icon to send. If you cannot see the text box or arrow icon, this means that replies have been disabled by the school and you should contact them through the usual means."},{"header":"Why won't my messages load?","body":"Messages should load instantly but please be aware that this can be affected by your wifi strength and speed, which may slow things down."},{"header":"Can I delete a Notice?","body":"Only the school is able to add, edit or delete their Notices."},{"header":"One of the dates in the Term Calendar  is missing or incorrect. Can I fix it?","body":"Because that section is managed by the school, you will need to contact the school to let them know if a mistake has been made."},{"header":"Why did I receive an SMS message even though I have the app?","body":"If the system is unable to send a message to the app, it will send as an SMS message instead. This will usually happen if you do not have access to either wifi or mobile data."},{"header":"Can I still receive messages even when I’m abroad?","body":"As long as you have access to wifi or mobile data, you will receive messages via the app as normal."}]},{"title":"Payments","applications":["school_money"],"sections":[{"header":"How do I know what to pay for?","body":"In the Payments section of the Eduspot app you will have listed anything that the school might want you to pay such as swimming, trips or music lessons."},{"header":"Why can’t I see any payments to add to the basket?","body":"If there is nothing listed in the payments section, it meant that either the school has not made the payment available for your child or there is nothing that you need to pay for."},{"header":"Some of the costs are labelled Partial and Voluntary, what does this mean?","body":"If a cost is labelled Partial, it means that you can pay off the cost in partial payments. Change the charge to a lesser amount that you want to pay and the next time you login, you will have the remaining amount to pay.\n\nIf the cost is labelled Voluntary, it means that you can choose how much of the cost you want to pay and this is the only amount you will be asked to put towards the payment."},{"header":"How can I see what I have paid?","body":"To see the transactions that you have made, go to the History section. Any payment you will have made will show up in here."},{"header":"I paid for the wrong thing; can I amend the payment I have already made?","body":"If you have paid for a payment that you did not want to put money towards, you will need to contact your child’s school directly and they will either be able to move the money to the correct payment or process a refund."},{"header":"Where can I see my dinner/club credit?","body":"Any dinner/club credit will appear in the dinner/club section of the Eduspot app. It will be listed clearly below your child’s name."}]},{"title":"Bookings","applications":["school_money"],"sections":[{"header":"How do I make bookings for dinners?","body":"To book the dinner days: click on the Dinner option from the menu and you will see listed the weeks available for booking. Select the week and the box will collapse down to show you blank boxes for each day. Select the boxes next to the days you want to book and press the plus sign to add to the basket. Repeat as needed.\n\nTo book meat and veg options: click on the Dinner option from the menu and you will see listed the weeks available for booking. Select the week and the box will collapse down to show you two blank boxes for each day labeled Meat and Veg. Select the boxes next to the days and option you want to book and press the plus sign to add to the basket. Repeat as needed.\n\nTo book meal items:  click on the Dinner option from the menu and you will see listed the weeks available for booking. Select the week and the box will collapse down to show you a drop down box for each day. In these dropdowns, choose the meal items you want your child to eat and press the plus sign to add to the basket. Repeat as needed."},{"header":"How do I make bookings for clubs?","body":"Click on the Club option from the menu and you will see listed the weeks available for booking. Select the week and the box will collapse down to show you a drop down box for each day. In these dropdowns, choose the club sessions you want your child to attend and press the plus sign to add to the basket. Repeat as needed."},{"header":"Can I change a booking that I have made?","body":"You can make changes to any bookings that you have made, up until the day before the session/meal. Click on the weeks that you want to amend, make the changes and add it to the basket."},{"header":"Why can’t I see any weeks to make bookings for?","body":"If you cannot see any weeks your child’s school may not have made them available for booking yet. We advise that you contact the school to confirm."},{"header":"I don’t want to pay at the time of booking, can I reserve my space and pay later?","body":"When booking dinners, payment must always be made at the time of booking with either credit that is already on your account or debit/credit card.\n\nSchools may allow you to reserve spaces without booking for clubs but this will be at the discretion of the school. We advise that you check with them directly to be sure."}]},{"title":"Checkout","applications":["school_money"],"sections":[{"header":"What form of payments do you accept?","body":"SchoolMoney accepts all types of card payment except American Express."},{"header":"Can I save my card details?","body":"The Eduspot App does not save your card details. You will need to enter them each time you want to pay as an extra security measure."},{"header":"Are my card details secure?","body":"As we do not store any card details on the Eduspot App, your details are secure."},{"header":"How do I know that my payment has been processed and accepted?","body":"Once you have entered your card details and have gone through the payment process, you will receive a message to let you know that your payment has been successful. Shortly after, you will receive an email receipt for the payment you have made to the email address you registered with SchoolMoney."},{"header":"Do I have to log in for each child?","body":"The Eduspot App keeps all of your children on one account so you can manage all of your school payments in one place. This includes pupils who are in different schools (that both use SchoolMoney) so you can make payments to multiple schools in the app."},{"header":"What is the 3D Authentication screen?","body":"The 3D authentication screen is an extra layer of security that is provided by your bank. When you are making a payment, the bank will be contacted to ensure that the payment is secure. Usually, you are asked to enter your banking security information at this stage. Should you experience any problems with the 3D authentication, you will need to contact your bank directly."},{"header":"Why have my card details not been accepted?","body":"If your card details have not been accepted, contact your bank directly and make sure that the transaction is not being blocked."}]}]}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_validate__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_assets_images_app_warning_svg__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_assets_images_app_warning_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_assets_images_app_warning_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_app_MainMenu_css__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_app_MainMenu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_app_MainMenu_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Assign each menu item a unique ID, for React key parameter-ing
// This data is totally static, so it belongs here, rather than in state
var availableProductsMenuItems={teachers:[{title:"Messages",path:"/teachers/messages/"},{title:"Noticeboard",path:"/teachers/noticeboard/"},{title:"Term Calendar",path:"/teachers/term_calendar/"}],school_money:[{title:"Payments",path:"/school_money/payments/"},{title:"Dinners",path:"/school_money/dinners/"},{title:"Clubs",path:"/school_money/clubs/"},{title:"Shop",path:"/school_money/shop/"},{title:"Parental Consent",path:"/school_money/parental_consent/"},{title:"History",path:"/school_money/history/"}]};// Render an entire menu section based on the product name
// Uses the availableProductsMenuItems
/**
 * getProductMenuSection - get the menu section element for a given productName
 *
 * @param  {String} productName
 * @returns {type}             description
 */function getProductMenuSection(productName){var productItems=availableProductsMenuItems[productName];// Bad product name - no section to render
// consider throw error here, as it means we are trying to draw an app we don't support
if(productItems===undefined){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-menu__section main-menu__section--'+productName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-menu__accent main-menu__accent--'+productName}),productItems.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{key:productName+'_'+index,to:item.path,className:'main-menu__item main-menu__item--'+productName,activeClassName:'main-menu__item--'+productName+'--selected'},item.title);}));}/**
 * Main Menu - Uses a static list of menu items which are displayed as Navlinks
 * @constructor
 */var MainMenu=function(_React$Component){_inherits(MainMenu,_React$Component);function MainMenu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MainMenu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MainMenu.__proto__||Object.getPrototypeOf(MainMenu)).call.apply(_ref,[this].concat(args))),_this),_this.openPaymentSecurityInfoLink=function(clickEvent){clickEvent.stopPropagation();var onlinePaymentSecurityLink="https://eduspot.co.uk/online-payments-security/";_this.props.openURL(onlinePaymentSecurityLink);},_this.getOnlinePaymentSecurityLink=function(){var onlinePaymentSecuritySectionTitle="Important Notice regarding Online Payment Security";// React router dom will not support opening a new link, so we add in link manually
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-menu__item--payment_security_link_container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'main-menu__item',key:'payment_security_link',onClick:_this.openPaymentSecurityInfoLink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-menu__item--payment_security_link_icon_container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'main-menu__item--payment_security_link_icon',src:__WEBPACK_IMPORTED_MODULE_6_components_assets_images_app_warning_svg___default.a,alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-menu__item--payment_security_link_label'},onlinePaymentSecuritySectionTitle)));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MainMenu,[{key:'render',value:function render(){var menuClassName='main-menu '+(this.props.isMenuOpen?"main-menu--open":"");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:menuClassName},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-menu__body'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-menu__section-container'},this.props.availableProducts.includes("teachers")&&Object(__WEBPACK_IMPORTED_MODULE_4_lib_validate__["e" /* isProductAvailable */])("teachers")&&Object(__WEBPACK_IMPORTED_MODULE_4_lib_validate__["c" /* isAppserverOnline */])()?getProductMenuSection("teachers"):null,this.props.availableProducts.includes("school_money")&&Object(__WEBPACK_IMPORTED_MODULE_4_lib_validate__["e" /* isProductAvailable */])("school_money")&&Object(__WEBPACK_IMPORTED_MODULE_4_lib_validate__["c" /* isAppserverOnline */])()?getProductMenuSection("school_money"):null,this.props.availableProducts.includes("school_money")&&Object(__WEBPACK_IMPORTED_MODULE_4_lib_validate__["e" /* isProductAvailable */])("school_money")&&Object(__WEBPACK_IMPORTED_MODULE_4_lib_validate__["c" /* isAppserverOnline */])()?this.getOnlinePaymentSecurityLink():null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-menu__hr-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-menu__hr'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* NavLink */],{to:'/help/',className:'main-menu__help',activeClassName:'main-menu__help--selected'},'Help')));}}]);return MainMenu;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(// props
function(state){return{availableProducts:Object(__WEBPACK_IMPORTED_MODULE_3_state_app_selectors__["a" /* getAvailableProducts */])(state),isMenuOpen:Object(__WEBPACK_IMPORTED_MODULE_3_state_app_selectors__["s" /* isMenuOpen */])(state)};},{openURL:__WEBPACK_IMPORTED_MODULE_5_state_app_actions__["R" /* openURL */]})(MainMenu));

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/app-warning.9db45cf9.svg";

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InformationModal_css__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InformationModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__InformationModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InformationModal=function(_React$Component){_inherits(InformationModal,_React$Component);function InformationModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InformationModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InformationModal.__proto__||Object.getPrototypeOf(InformationModal)).call.apply(_ref,[this].concat(args))),_this),_this.onClose=function(){_this.props.closeInformationModal();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InformationModal,[{key:"render",value:function render(){var _props=this.props,isOpen=_props.isOpen,title=_props.title,message=_props.message;if(!isOpen){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ModalDialog__["a" /* default */],{isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"information-modal__title"},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"information-modal__message"},message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"information-modal__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Button__["a" /* default */],{className:"information-modal__ok-button",onClick:this.onClose},"OK"))));}}]);return InformationModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["p" /* isInformationModalOpen */])(state),message:Object(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["e" /* getInformationModalMessage */])(state),title:Object(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["f" /* getInformationModalTitle */])(state)};},{closeInformationModal:__WEBPACK_IMPORTED_MODULE_3_state_app_actions__["E" /* closeInformationModal */]})(InformationModal));

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotFoundPage_css__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotFoundPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NotFoundPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// a Page-level component that is displayed in the top-level switch when nothing else is matched
// Shouldn't really be possible when using the native clients,
//  but it doesn't hurt to create some forward-facing infrastructure.
var NotFoundPage=function(_React$Component){_inherits(NotFoundPage,_React$Component);function NotFoundPage(){_classCallCheck(this,NotFoundPage);return _possibleConstructorReturn(this,(NotFoundPage.__proto__||Object.getPrototypeOf(NotFoundPage)).apply(this,arguments));}_createClass(NotFoundPage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-not-found"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"page-not-found__title"},"Oops!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Page Not Found"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{to:"/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Click here to return to Home")));}}]);return NotFoundPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (NotFoundPage);

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainMenuTouchGuard_css__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MainMenuTouchGuard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MainMenuTouchGuard_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Renders only when the menu is open - closes the menu on click
var MainMenuTouchGuard=function(_React$Component){_inherits(MainMenuTouchGuard,_React$Component);function MainMenuTouchGuard(){_classCallCheck(this,MainMenuTouchGuard);return _possibleConstructorReturn(this,(MainMenuTouchGuard.__proto__||Object.getPrototypeOf(MainMenuTouchGuard)).apply(this,arguments));}_createClass(MainMenuTouchGuard,[{key:"render",value:function render(){if(this.props.isMenuOpen){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{onClick:this.props.closeAppMenu,className:"main-menu-touch-guard"});}else{return null;}}}]);return MainMenuTouchGuard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isMenuOpen:Object(__WEBPACK_IMPORTED_MODULE_4_state_app_selectors__["s" /* isMenuOpen */])(state)};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({closeAppMenu:__WEBPACK_IMPORTED_MODULE_3_state_app_actions__["A" /* closeAppMenu */]},dispatch);})(MainMenuTouchGuard));

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_app_error_ErrorDetailsModal__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FatalErrorReporter_css__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FatalErrorReporter_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FatalErrorReporter_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * The "Oops, something went wrong" reporter for the app
 */var FatalErrorReporterModal=function(_React$Component){_inherits(FatalErrorReporterModal,_React$Component);function FatalErrorReporterModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FatalErrorReporterModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FatalErrorReporterModal.__proto__||Object.getPrototypeOf(FatalErrorReporterModal)).call.apply(_ref,[this].concat(args))),_this),_this.state={isDetailsModalOpen:true},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FatalErrorReporterModal,[{key:"render",value:function render(){if(this.props.fatalError!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fatal-error-reporter"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_app_error_ErrorDetailsModal__["a" /* default */],{isOpen:this.state.isDetailsModalOpen,error:this.props.fatalError}));}return null;}}]);return FatalErrorReporterModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{fatalError:Object(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["d" /* getFatalError */])(state)};},{reload:__WEBPACK_IMPORTED_MODULE_3_state_app_actions__["V" /* reload */]})(FatalErrorReporterModal));

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_app_AppInfoTable__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_error_details__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_assets_images_error_svg__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_assets_images_error_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_assets_images_error_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ErrorDetailsModal_css__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ErrorDetailsModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ErrorDetailsModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DATE_TIME_FORMAT="DD/MM/YYYY HH:mm:ss";/**
 * Show the user some key information after an error has occurred.
 * More helpful for our diagnostic than theirs.
 */var ErrorDetailsModal=function(_React$Component){_inherits(ErrorDetailsModal,_React$Component);function ErrorDetailsModal(){_classCallCheck(this,ErrorDetailsModal);return _possibleConstructorReturn(this,(ErrorDetailsModal.__proto__||Object.getPrototypeOf(ErrorDetailsModal)).apply(this,arguments));}_createClass(ErrorDetailsModal,[{key:"shouldObfuscate",/**
   * Some details will be hidden based on this result.
   * In dev we show everything, prod we show less.
   */value:function shouldObfuscate(){return "production"!=="development";}},{key:"getAction",value:function getAction(error){if(Object(__WEBPACK_IMPORTED_MODULE_5_lib_error_details__["a" /* getErrorCode */])(error)==="UNKNOWN_DEVICE - APP_003"){return"Device is no longer registered, please register again. If the issue persists then report this to our support team.";}return"Please close and reopen the app. If the issue persists then report this to our support team.";}},{key:"getMessage",value:function getMessage(error){var errorCode=Object(__WEBPACK_IMPORTED_MODULE_5_lib_error_details__["a" /* getErrorCode */])(error);if(errorCode==="UNKNOWN_DEVICE - APP_003"){return"We are unable to recognise your device.";}if(errorCode==="API_ERROR - APP_001"||errorCode==="API_DATA_ERROR - APP_002"){return"We are unable to process the data we received for your device.";}return"We are unable to process your request.";}},{key:"render",value:function render(){var _props=this.props,isOpen=_props.isOpen,error=_props.error;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ModalDialog__["a" /* default */],{isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"error-details-modal__image",src:__WEBPACK_IMPORTED_MODULE_6_components_assets_images_error_svg___default.a,alt:"Error"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"error-details-modal__title"},"Error")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__description"},"We're sorry, but the system has encountered a serious error and cannot continue."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",{className:"error-details-modal__separator"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_app_AppInfoTable__["a" /* default */],{cssBlockName:"error-app-info-table"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__label"},"Code"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__detail"},Object(__WEBPACK_IMPORTED_MODULE_5_lib_error_details__["a" /* getErrorCode */])(error))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__label"},"Message"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__detail"},this.getMessage(error))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__label"},"Date / Time"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__detail"},__WEBPACK_IMPORTED_MODULE_7_moment___default()(new Date()).format(DATE_TIME_FORMAT))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__label"},"Action"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__detail"},this.getAction(error))),this.shouldObfuscate()?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__label"},"Stack Trace"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__detail"},error.stack))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"error-details-modal__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Button__["a" /* default */],{className:"error-details-modal__refresh-button",onClick:this.props.reload},"Reload Application")));}}]);return ErrorDetailsModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(undefined,{reload:__WEBPACK_IMPORTED_MODULE_8_state_app_actions__["V" /* reload */]})(ErrorDetailsModal));

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/error.76758a29.svg";

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_ReactError__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_app_actions__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Catch exceptions thrown below here in the tree, and dispatch
 *   fatal error actions instead of letting react crash outright.
 */var FatalErrorBoundary=function(_React$Component){_inherits(FatalErrorBoundary,_React$Component);function FatalErrorBoundary(){_classCallCheck(this,FatalErrorBoundary);return _possibleConstructorReturn(this,(FatalErrorBoundary.__proto__||Object.getPrototypeOf(FatalErrorBoundary)).apply(this,arguments));}_createClass(FatalErrorBoundary,[{key:"componentDidCatch",value:function componentDidCatch(error,info){this.props.fatalError(new __WEBPACK_IMPORTED_MODULE_2_lib_ReactError__["a" /* default */](error,info));}},{key:"render",value:function render(){return this.props.hasFatalError?null:this.props.children;}}]);return FatalErrorBoundary;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{hasFatalError:Object(__WEBPACK_IMPORTED_MODULE_3_state_app_selectors__["d" /* getFatalError */])(state)!==null};},{fatalError:__WEBPACK_IMPORTED_MODULE_4_state_app_actions__["G" /* fatalError */]})(FatalErrorBoundary));

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReactError=function(_Error){_inherits(ReactError,_Error);function ReactError(error,info){_classCallCheck(this,ReactError);var _this=_possibleConstructorReturn(this,(ReactError.__proto__||Object.getPrototypeOf(ReactError)).call(this,"Exception thrown in react tree: "+error.toString()));_this.originalError=error;_this.details=info;_this.type=ReactError.type;return _this;}return ReactError;}(Error);ReactError.type="ReactError";/* harmony default export */ __webpack_exports__["a"] = (ReactError);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_validate__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_assets_images_product_notification_png__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_assets_images_product_notification_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_assets_images_product_notification_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProductDownTimeReporter_css__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProductDownTimeReporter_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ProductDownTimeReporter_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DATE_FORMAT="DD/MM HH:mm";var ProductDownTimeReporter=function(_React$Component){_inherits(ProductDownTimeReporter,_React$Component);function ProductDownTimeReporter(){_classCallCheck(this,ProductDownTimeReporter);return _possibleConstructorReturn(this,(ProductDownTimeReporter.__proto__||Object.getPrototypeOf(ProductDownTimeReporter)).apply(this,arguments));}_createClass(ProductDownTimeReporter,[{key:"formatDate",value:function formatDate(dateTime){return __WEBPACK_IMPORTED_MODULE_2_moment___default()(dateTime).format(DATE_FORMAT);}},{key:"getappDownTimeContent",value:function getappDownTimeContent(){if(Object(__WEBPACK_IMPORTED_MODULE_5_lib_validate__["c" /* isAppserverOnline */])()){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The app will be undergoing maintenance on ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"product-down-time-reporter__bold"},"Monday 22nd December")," between ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"product-down-time-reporter__bold"},"10:00-13:00 GMT"),"."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"During this period, our services will be temporarily unavailable. We apologise for any inconvenience this may cause and appreciate your understanding as we work to enhance your experience."));}},{key:"getProductNotification",value:function getProductNotification(product,startDate,endDate){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"We are working on improving ",product," for the Teachers2Parents app. Our Services are paused whilst our Network Technicians work on improving our systems. This planned outage is expected from ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"product-down-time-reporter__bold"},this.formatDate(startDate))," to ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"product-down-time-reporter__bold"},this.formatDate(endDate),".")));}},{key:"getProductDownTimeContent",value:function getProductDownTimeContent(availableProducts){var schoolMoneyContent=availableProducts.includes("school_money")&&!Object(__WEBPACK_IMPORTED_MODULE_5_lib_validate__["e" /* isProductAvailable */])("school_money")?this.getProductNotification("SchoolMoney","2023-11-13 17:50","2023-11-13 18:40"):null;var teachers2ParentsContent=availableProducts.includes("teachers")&&!Object(__WEBPACK_IMPORTED_MODULE_5_lib_validate__["e" /* isProductAvailable */])("teachers")?this.getProductNotification("Teachers2Parents","2021-12-08 10:10","2021-12-08 11:00"):null;if(schoolMoneyContent===null&&teachers2ParentsContent===null){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,teachers2ParentsContent,schoolMoneyContent);}},{key:"render",value:function render(){var _props=this.props,availableProducts=_props.availableProducts,isDownTimeReporterOpen=_props.isDownTimeReporterOpen;var appDownTimeContent=this.getappDownTimeContent();var content=appDownTimeContent!==null?appDownTimeContent:this.getProductDownTimeContent(availableProducts);if(content===null){return null;}if(isDownTimeReporterOpen){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_ModalDialog__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"product-down-time-reporter__image",src:__WEBPACK_IMPORTED_MODULE_8_components_assets_images_product_notification_png___default.a,alt:"Product Notification"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"product-down-time-reporter__title"},"System admin downtime"),content,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Thank you for your patience."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Button__["a" /* default */],{className:"product-down-time-reporter__close-button",onClick:this.props.closeDownTimeReporter},"Close Notification")));}return null;}}]);return ProductDownTimeReporter;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isDownTimeReporterOpen:Object(__WEBPACK_IMPORTED_MODULE_3_state_app_selectors__["o" /* isDownTimeReporterOpen */])(state),availableProducts:Object(__WEBPACK_IMPORTED_MODULE_3_state_app_selectors__["a" /* getAvailableProducts */])(state)};},{closeDownTimeReporter:__WEBPACK_IMPORTED_MODULE_4_state_app_actions__["D" /* closeDownTimeReporter */]})(ProductDownTimeReporter));

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_validate__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomerNotices_css__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CustomerNotices_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CustomerNotices_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bar_HamburgerMenu_css__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bar_HamburgerMenu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__bar_HamburgerMenu_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CustomerNotices=function(_React$Component){_inherits(CustomerNotices,_React$Component);function CustomerNotices(){_classCallCheck(this,CustomerNotices);return _possibleConstructorReturn(this,(CustomerNotices.__proto__||Object.getPrototypeOf(CustomerNotices)).apply(this,arguments));}_createClass(CustomerNotices,[{key:"getTeachers2parentsNotice",value:function getTeachers2parentsNotice(){var _props=this.props,teachers2parentsNoticeKey=_props.teachers2parentsNoticeKey,availableProducts=_props.availableProducts;if(!availableProducts.includes("teachers")||teachers2parentsNoticeKey==="teachers_1"||Object(__WEBPACK_IMPORTED_MODULE_4_lib_validate__["b" /* hasTimePassed */])("2025-12-18 14:00:59")){return null;}return null;}},{key:"getSchoolMoneyNotice",value:function getSchoolMoneyNotice(){var _props2=this.props,schoolMoneyNoticeKey=_props2.schoolMoneyNoticeKey,availableProducts=_props2.availableProducts;if(!availableProducts.includes("school_money")||schoolMoneyNoticeKey==="schoolmoney_1"||Object(__WEBPACK_IMPORTED_MODULE_4_lib_validate__["b" /* hasTimePassed */])("2025-12-18 14:00:59")){return null;}return null;}},{key:"getAppNotice",value:function getAppNotice(){var appNoticeKey=this.props.appNoticeKey;if(appNoticeKey==="app_2"||Object(__WEBPACK_IMPORTED_MODULE_4_lib_validate__["b" /* hasTimePassed */])("2025-12-18 12:19:59")){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The app will be undergoing maintenance on ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"customer-notices__bold"},"Monday 22nd December")," between ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"customer-notices__bold"},"10:00-13:00 GMT"),"."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"During this period, our services will be temporarily unavailable. We apologise for any inconvenience this may cause and appreciate your understanding as we work to enhance your experience."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Thank you for your patience."));}},{key:"render",value:function render(){if(!this.props.isOpen){return null;}var appContent=null;var schoolMoneyContent=this.getSchoolMoneyNotice();var teachers2parentsContent=this.getTeachers2parentsNotice();if(schoolMoneyContent===null&&teachers2parentsContent===null&&appContent===null){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_ModalDialog__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:["app-menu-button","hamburger","hamburger--squeeze","is-active","customer-notices__close-button"].join(" "),onClick:this.props.closeCustomerNoticeFrame},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"hamburger-box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"hamburger-inner"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"customer-notices__title"},"Important Message!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"customer-notices__container"},appContent,teachers2parentsContent,schoolMoneyContent),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Button__["a" /* default */],{className:"customer-notices__next-button",onClick:this.props.markCustomerNoticeAsRead},"Mark As Read")));}}]);return CustomerNotices;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{schoolMoneyNoticeKey:Object(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["h" /* getLastReadSchoolMoneyCustomerNoticesKey */])(state),teachers2parentsNoticeKey:Object(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["i" /* getLastReadTeachers2ParentsCustomerNoticesKey */])(state),appNoticeKey:Object(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["g" /* getLastReadAppNoticesKey */])(state),isOpen:Object(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["n" /* isCustomerNoticesOpen */])(state),availableProducts:Object(__WEBPACK_IMPORTED_MODULE_2_state_app_selectors__["a" /* getAvailableProducts */])(state)};},{closeCustomerNoticeFrame:__WEBPACK_IMPORTED_MODULE_3_state_app_actions__["C" /* closeCustomerNoticeFrame */],markCustomerNoticeAsRead:__WEBPACK_IMPORTED_MODULE_3_state_app_actions__["L" /* markCustomerNoticeAsRead */]})(CustomerNotices));

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoadingFrame_css__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LoadingFrame_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LoadingFrame_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LOADING_TEXTS=["Fetching data…","Almost there…","Not long now…"];var LoadingFrame=function(_Component){_inherits(LoadingFrame,_Component);function LoadingFrame(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LoadingFrame);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LoadingFrame.__proto__||Object.getPrototypeOf(LoadingFrame)).call.apply(_ref,[this].concat(args))),_this),_this.state={textIndex:0,intervalId:null},_this.startTextRotation=function(){// Ensure we don't create multiple timers
_this.stopTextRotation();var intervalId=setInterval(function(){_this.setState(function(prev){var lastIdx=LOADING_TEXTS.length-1;if(prev.textIndex<lastIdx){return{textIndex:prev.textIndex+1};}else{// at last index keep showing last text and clear interval
if(_this.state.intervalId){clearInterval(_this.state.intervalId);}return{intervalId:null};}});},5000);_this.setState({intervalId:intervalId});},_this.stopTextRotation=function(){var intervalId=_this.state.intervalId;if(intervalId){clearInterval(intervalId);_this.setState({intervalId:null});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LoadingFrame,[{key:"componentDidMount",value:function componentDidMount(){if(this.props.isOpen){this.startTextRotation();}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var isOpen=this.props.isOpen;// When modal opens: reset index and start rotation
if(!prevProps.isOpen&&isOpen){this.setState({textIndex:0},this.startTextRotation);}// When modal closes: clear timer & reset index
if(prevProps.isOpen&&!isOpen){this.stopTextRotation();this.setState({textIndex:0});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.stopTextRotation();}},{key:"render",value:function render(){var isOpen=this.props.isOpen;if(!isOpen)return null;var textIndex=this.state.textIndex;var currentText=LOADING_TEXTS[textIndex];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ModalDialog__["a" /* default */],{isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"loading-frame__content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"loading-frame__text"},currentText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"loading-frame"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"throbber"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce3"})))));}}]);return LoadingFrame;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3_state_app_selectors__["r" /* isLoadingFrameOpen */])(state)};})(LoadingFrame));

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages_MessagesPage__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__noticeboard_NoticeboardPage__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__term_calendar_TermCalendarPage__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_teachers_Preloader__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_teachers_guide_Guide__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TeachersPage_css__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TeachersPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TeachersPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Root-level /teachers/ component
// Big Switch router for delegating into the individual pages
// Also contains a redirect to default stray navigation into /teachers/messages
var TeachersPage=function(_React$Component){_inherits(TeachersPage,_React$Component);function TeachersPage(){_classCallCheck(this,TeachersPage);return _possibleConstructorReturn(this,(TeachersPage.__proto__||Object.getPrototypeOf(TeachersPage)).apply(this,arguments));}_createClass(TeachersPage,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_teachers_Preloader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_teachers_guide_Guide__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* Redirect */],{exact:true,from:"/teachers/",to:"/teachers/messages/"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */],{path:"/teachers/messages/:schoolID?/",component:__WEBPACK_IMPORTED_MODULE_2__messages_MessagesPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */],{path:"/teachers/noticeboard/:schoolID?/",component:__WEBPACK_IMPORTED_MODULE_3__noticeboard_NoticeboardPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["b" /* Route */],{path:"/teachers/term_calendar/:schoolID?/",component:__WEBPACK_IMPORTED_MODULE_4__term_calendar_TermCalendarPage__["a" /* default */]}))));}}]);return TeachersPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (TeachersPage);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_teachers_MaintainValidSchoolID__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_teachers_Preloader__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_teachers_SchoolSelector__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_teachers_SchoolCarousel__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_teachers_messages_SchoolMessageList__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MessagesPage_css__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MessagesPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__MessagesPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MessagesPage=function(_React$Component){_inherits(MessagesPage,_React$Component);function MessagesPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MessagesPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MessagesPage.__proto__||Object.getPrototypeOf(MessagesPage)).call.apply(_ref,[this].concat(args))),_this),_this.replyInputs={},_this.refReplyInput=function(schoolID,element){_this.replyInputs[schoolID]=element;},_this.isPageReady=function(state){return Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["y" /* isMessagesReady */])(state,_this.props.match.params.schoolID);},_this.generatePath=function(schoolID){return"/teachers/messages/"+schoolID+"/";},_this.blurReplyInputs=function(){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.values(_this.replyInputs)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var replyInput=_step.value;if(replyInput!==null){replyInput.blur();}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}},_this.onSchoolChange=function(schoolID,prevSchoolID){_this.blurReplyInputs();_this.props.markSchoolMessagesRead(prevSchoolID);},_temp),_possibleConstructorReturn(_this,_ret);}/**
   * Distract focus from all reply input elements.
   * Called by onChange of SchoolCarousel.
   * We have to do this so that the device keyboard closes when
   *   you swipe between schools, otherwise you can type into a
   *   reply input which is off-screen.
   */_createClass(MessagesPage,[{key:"componentWillUnmount",value:function componentWillUnmount(){this.props.markSchoolMessagesRead(this.props.match.params.schoolID);}},{key:"render",value:function render(){var _this2=this;var schoolID=this.props.match.params.schoolID;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_teachers_MaintainValidSchoolID__["a" /* default */],{currentSchoolID:schoolID,generatePath:this.generatePath},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_teachers_Preloader__["a" /* default */],{isPageReady:this.isPageReady},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"messages-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"page-header__title"},"Messages"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_teachers_SchoolSelector__["a" /* default */],{selectedSchoolID:schoolID,generatePath:this.generatePath})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_teachers_SchoolCarousel__["a" /* default */],{activeSchoolID:schoolID,generatePath:this.generatePath,onChange:this.onSchoolChange},function(schoolID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_teachers_messages_SchoolMessageList__["a" /* default */],{key:schoolID,schoolID:schoolID,refReplyInput:_this2.refReplyInput});}))));}}]);return MessagesPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(undefined,{markSchoolMessagesRead:__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["P" /* markSchoolMessagesRead */]})(MessagesPage));

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SchoolName=function(_React$Component){_inherits(SchoolName,_React$Component);function SchoolName(){_classCallCheck(this,SchoolName);return _possibleConstructorReturn(this,(SchoolName.__proto__||Object.getPrototypeOf(SchoolName)).apply(this,arguments));}_createClass(SchoolName,[{key:"render",value:function render(){return this.props.school.get("name");}}]);return SchoolName;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var schoolID=_ref.schoolID;return{school:Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["j" /* getSchoolByID */])(state,schoolID)};})(SchoolName));

/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_swiper_dist_js_swiper__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_swiper_dist_js_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_swiper_dist_js_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_swiper_dist_css_swiper_min_css__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_swiper_dist_css_swiper_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_swiper_dist_css_swiper_min_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
WARNING
Swiper is problematic. Their package.module entry point is ES6, whereas
create-react-app requires import to be ES5. The workaround is to specify
the full import path and point ourselves at their ES5 entry point instead.
This is a bit jank because we're relying on Swiper's internal file
structure, but then we're forced to do that for the CSS anyway, so maybe
it's not a big deal. /shrug
*//**
 * Wrapper for using swiper.
 * This component does the minimum abstraction of the swiper library.
 * We set up the DOM layout, initialise the swiper instance with the given
 *   options, and then pass the swiper instance to the parent.
 */var SwiperComponent=function(_React$Component){_inherits(SwiperComponent,_React$Component);function SwiperComponent(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SwiperComponent);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SwiperComponent.__proto__||Object.getPrototypeOf(SwiperComponent)).call.apply(_ref,[this].concat(args))),_this),_this.refContainer=function(container){var _this$props=_this.props,options=_this$props.options,refSwiper=_this$props.refSwiper;_this.swiper=new __WEBPACK_IMPORTED_MODULE_2_swiper_dist_js_swiper___default.a(container,options);if(refSwiper){refSwiper(_this.swiper);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SwiperComponent,[{key:"render",value:function render(){var classNames=this.props.classNames;var containerClassNames=["swiper-container"];var wrapperClassNames=["swiper-wrapper"];var slideClassNames=["swiper-slide"];if(classNames!==undefined){if(classNames.container!==undefined){containerClassNames.push(classNames.container);}if(classNames.wrapper!==undefined){wrapperClassNames.push(classNames.wrapper);}if(classNames.slide!==undefined){slideClassNames.push(classNames.slide);}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:containerClassNames.join(" "),ref:this.refContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:wrapperClassNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(this.props.children,function(slide,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:slideClassNames.join(" ")},slide);})));}}]);return SwiperComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);SwiperComponent.propTypes={classNames:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({container:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,wrapper:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,slide:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string}),children:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node).isRequired,options:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};/* harmony default export */ __webpack_exports__["a"] = (SwiperComponent);

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Swiper 4.2.2
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2018 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: April 1, 2018
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.Swiper = factory());
}(this, (function () { 'use strict';

/**
 * SSR Window 1.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2018, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 10, 2018
 */
var d;
if (typeof document === 'undefined') {
  d = {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: '',
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {},
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        },
      };
    },
    location: { hash: '' },
  };
} else {
  // eslint-disable-next-line
  d = document;
}

var doc = d;

var w;
if (typeof window === 'undefined') {
  w = {
    document: doc,
    navigator: {
      userAgent: '',
    },
    location: {},
    history: {},
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        },
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
  };
} else {
  // eslint-disable-next-line
  w = window;
}

var win = w;

/**
 * Dom7 2.0.3
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * http://framework7.io/docs/dom.html
 *
 * Copyright 2018, Vladimir Kharlampidi
 * The iDangero.us
 * http://www.idangero.us/
 *
 * Licensed under MIT
 *
 * Released on: February 21, 2018
 */

var Dom7 = function Dom7(arr) {
  var self = this;
  // Create array-like object
  for (var i = 0; i < arr.length; i += 1) {
    self[i] = arr[i];
  }
  self.length = arr.length;
  // Return collection with methods
  return this;
};

function $(selector, context) {
  var arr = [];
  var i = 0;
  if (selector && !context) {
    if (selector instanceof Dom7) {
      return selector;
    }
  }
  if (selector) {
      // String
    if (typeof selector === 'string') {
      var els;
      var tempParent;
      var html = selector.trim();
      if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
        var toCreate = 'div';
        if (html.indexOf('<li') === 0) { toCreate = 'ul'; }
        if (html.indexOf('<tr') === 0) { toCreate = 'tbody'; }
        if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) { toCreate = 'tr'; }
        if (html.indexOf('<tbody') === 0) { toCreate = 'table'; }
        if (html.indexOf('<option') === 0) { toCreate = 'select'; }
        tempParent = doc.createElement(toCreate);
        tempParent.innerHTML = html;
        for (i = 0; i < tempParent.childNodes.length; i += 1) {
          arr.push(tempParent.childNodes[i]);
        }
      } else {
        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
          // Pure ID selector
          els = [doc.getElementById(selector.trim().split('#')[1])];
        } else {
          // Other selectors
          els = (context || doc).querySelectorAll(selector.trim());
        }
        for (i = 0; i < els.length; i += 1) {
          if (els[i]) { arr.push(els[i]); }
        }
      }
    } else if (selector.nodeType || selector === win || selector === doc) {
      // Node/element
      arr.push(selector);
    } else if (selector.length > 0 && selector[0].nodeType) {
      // Array of elements or instance of Dom
      for (i = 0; i < selector.length; i += 1) {
        arr.push(selector[i]);
      }
    }
  }
  return new Dom7(arr);
}

$.fn = Dom7.prototype;
$.Class = Dom7;
$.Dom7 = Dom7;

function unique(arr) {
  var uniqueArray = [];
  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) { uniqueArray.push(arr[i]); }
  }
  return uniqueArray;
}

// Classes and attributes
function addClass(className) {
  var this$1 = this;

  if (typeof className === 'undefined') {
    return this;
  }
  var classes = className.split(' ');
  for (var i = 0; i < classes.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      if (typeof this$1[j].classList !== 'undefined') { this$1[j].classList.add(classes[i]); }
    }
  }
  return this;
}
function removeClass(className) {
  var this$1 = this;

  var classes = className.split(' ');
  for (var i = 0; i < classes.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      if (typeof this$1[j].classList !== 'undefined') { this$1[j].classList.remove(classes[i]); }
    }
  }
  return this;
}
function hasClass(className) {
  if (!this[0]) { return false; }
  return this[0].classList.contains(className);
}
function toggleClass(className) {
  var this$1 = this;

  var classes = className.split(' ');
  for (var i = 0; i < classes.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      if (typeof this$1[j].classList !== 'undefined') { this$1[j].classList.toggle(classes[i]); }
    }
  }
  return this;
}
function attr(attrs, value) {
  var arguments$1 = arguments;
  var this$1 = this;

  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) { return this[0].getAttribute(attrs); }
    return undefined;
  }

  // Set attrs
  for (var i = 0; i < this.length; i += 1) {
    if (arguments$1.length === 2) {
      // String
      this$1[i].setAttribute(attrs, value);
    } else {
      // Object
      // eslint-disable-next-line
      for (var attrName in attrs) {
        this$1[i][attrName] = attrs[attrName];
        this$1[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }
  return this;
}
// eslint-disable-next-line
function removeAttr(attr) {
  var this$1 = this;

  for (var i = 0; i < this.length; i += 1) {
    this$1[i].removeAttribute(attr);
  }
  return this;
}
function data(key, value) {
  var this$1 = this;

  var el;
  if (typeof value === 'undefined') {
    el = this[0];
    // Get value
    if (el) {
      if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
        return el.dom7ElementDataStorage[key];
      }

      var dataKey = el.getAttribute(("data-" + key));
      if (dataKey) {
        return dataKey;
      }
      return undefined;
    }
    return undefined;
  }

  // Set value
  for (var i = 0; i < this.length; i += 1) {
    el = this$1[i];
    if (!el.dom7ElementDataStorage) { el.dom7ElementDataStorage = {}; }
    el.dom7ElementDataStorage[key] = value;
  }
  return this;
}
// Transforms
// eslint-disable-next-line
function transform(transform) {
  var this$1 = this;

  for (var i = 0; i < this.length; i += 1) {
    var elStyle = this$1[i].style;
    elStyle.webkitTransform = transform;
    elStyle.transform = transform;
  }
  return this;
}
function transition(duration) {
  var this$1 = this;

  if (typeof duration !== 'string') {
    duration = duration + "ms"; // eslint-disable-line
  }
  for (var i = 0; i < this.length; i += 1) {
    var elStyle = this$1[i].style;
    elStyle.webkitTransitionDuration = duration;
    elStyle.transitionDuration = duration;
  }
  return this;
}
// Events
function on() {
  var this$1 = this;
  var assign;

  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];
  var eventType = args[0];
  var targetSelector = args[1];
  var listener = args[2];
  var capture = args[3];
  if (typeof args[1] === 'function') {
    (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
    targetSelector = undefined;
  }
  if (!capture) { capture = false; }

  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) { return; }
    var eventData = e.target.dom7EventData || [];
    eventData.unshift(e);
    if ($(target).is(targetSelector)) { listener.apply(target, eventData); }
    else {
      var parents = $(target).parents(); // eslint-disable-line
      for (var k = 0; k < parents.length; k += 1) {
        if ($(parents[k]).is(targetSelector)) { listener.apply(parents[k], eventData); }
      }
    }
  }
  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];
    eventData.unshift(e);
    listener.apply(this, eventData);
  }
  var events = eventType.split(' ');
  var j;
  for (var i = 0; i < this.length; i += 1) {
    var el = this$1[i];
    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        if (!el.dom7Listeners) { el.dom7Listeners = []; }
        el.dom7Listeners.push({
          type: eventType,
          listener: listener,
          proxyListener: handleEvent,
        });
        el.addEventListener(events[j], handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        if (!el.dom7LiveListeners) { el.dom7LiveListeners = []; }
        el.dom7LiveListeners.push({
          type: eventType,
          listener: listener,
          proxyListener: handleLiveEvent,
        });
        el.addEventListener(events[j], handleLiveEvent, capture);
      }
    }
  }
  return this;
}
function off() {
  var this$1 = this;
  var assign;

  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];
  var eventType = args[0];
  var targetSelector = args[1];
  var listener = args[2];
  var capture = args[3];
  if (typeof args[1] === 'function') {
    (assign = args, eventType = assign[0], listener = assign[1], capture = assign[2]);
    targetSelector = undefined;
  }
  if (!capture) { capture = false; }

  var events = eventType.split(' ');
  for (var i = 0; i < events.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      var el = this$1[j];
      if (!targetSelector) {
        if (el.dom7Listeners) {
          for (var k = 0; k < el.dom7Listeners.length; k += 1) {
            if (listener) {
              if (el.dom7Listeners[k].listener === listener) {
                el.removeEventListener(events[i], el.dom7Listeners[k].proxyListener, capture);
              }
            } else if (el.dom7Listeners[k].type === events[i]) {
              el.removeEventListener(events[i], el.dom7Listeners[k].proxyListener, capture);
            }
          }
        }
      } else if (el.dom7LiveListeners) {
        for (var k$1 = 0; k$1 < el.dom7LiveListeners.length; k$1 += 1) {
          if (listener) {
            if (el.dom7LiveListeners[k$1].listener === listener) {
              el.removeEventListener(events[i], el.dom7LiveListeners[k$1].proxyListener, capture);
            }
          } else if (el.dom7LiveListeners[k$1].type === events[i]) {
            el.removeEventListener(events[i], el.dom7LiveListeners[k$1].proxyListener, capture);
          }
        }
      }
    }
  }
  return this;
}
function trigger() {
  var this$1 = this;
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var events = args[0].split(' ');
  var eventData = args[1];
  for (var i = 0; i < events.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      var evt = (void 0);
      try {
        evt = new win.CustomEvent(events[i], {
          detail: eventData,
          bubbles: true,
          cancelable: true,
        });
      } catch (e) {
        evt = doc.createEvent('Event');
        evt.initEvent(events[i], true, true);
        evt.detail = eventData;
      }
      // eslint-disable-next-line
      this$1[j].dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
      this$1[j].dispatchEvent(evt);
      this$1[j].dom7EventData = [];
      delete this$1[j].dom7EventData;
    }
  }
  return this;
}
function transitionEnd(callback) {
  var events = ['webkitTransitionEnd', 'transitionend'];
  var dom = this;
  var i;
  function fireCallBack(e) {
    /* jshint validthis:true */
    if (e.target !== this) { return; }
    callback.call(this, e);
    for (i = 0; i < events.length; i += 1) {
      dom.off(events[i], fireCallBack);
    }
  }
  if (callback) {
    for (i = 0; i < events.length; i += 1) {
      dom.on(events[i], fireCallBack);
    }
  }
  return this;
}
function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      // eslint-disable-next-line
      var styles = this.styles();
      return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      // eslint-disable-next-line
      var styles = this.styles();
      return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function offset() {
  if (this.length > 0) {
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = doc.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === win ? win.scrollY : el.scrollTop;
    var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
    return {
      top: (box.top + scrollTop) - clientTop,
      left: (box.left + scrollLeft) - clientLeft,
    };
  }

  return null;
}
function styles() {
  if (this[0]) { return win.getComputedStyle(this[0], null); }
  return {};
}
function css(props, value) {
  var this$1 = this;

  var i;
  if (arguments.length === 1) {
    if (typeof props === 'string') {
      if (this[0]) { return win.getComputedStyle(this[0], null).getPropertyValue(props); }
    } else {
      for (i = 0; i < this.length; i += 1) {
        // eslint-disable-next-line
        for (var prop in props) {
          this$1[i].style[prop] = props[prop];
        }
      }
      return this;
    }
  }
  if (arguments.length === 2 && typeof props === 'string') {
    for (i = 0; i < this.length; i += 1) {
      this$1[i].style[props] = value;
    }
    return this;
  }
  return this;
}
// Iterate over the collection passing elements to `callback`
function each(callback) {
  var this$1 = this;

  // Don't bother continuing without a callback
  if (!callback) { return this; }
  // Iterate over the current collection
  for (var i = 0; i < this.length; i += 1) {
    // If the callback returns false
    if (callback.call(this$1[i], i, this$1[i]) === false) {
      // End the loop early
      return this$1;
    }
  }
  // Return `this` to allow chained DOM operations
  return this;
}
// eslint-disable-next-line
function html(html) {
  var this$1 = this;

  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : undefined;
  }

  for (var i = 0; i < this.length; i += 1) {
    this$1[i].innerHTML = html;
  }
  return this;
}
// eslint-disable-next-line
function text(text) {
  var this$1 = this;

  if (typeof text === 'undefined') {
    if (this[0]) {
      return this[0].textContent.trim();
    }
    return null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this$1[i].textContent = text;
  }
  return this;
}
function is(selector) {
  var el = this[0];
  var compareWith;
  var i;
  if (!el || typeof selector === 'undefined') { return false; }
  if (typeof selector === 'string') {
    if (el.matches) { return el.matches(selector); }
    else if (el.webkitMatchesSelector) { return el.webkitMatchesSelector(selector); }
    else if (el.msMatchesSelector) { return el.msMatchesSelector(selector); }

    compareWith = $(selector);
    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) { return true; }
    }
    return false;
  } else if (selector === doc) { return el === doc; }
  else if (selector === win) { return el === win; }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;
    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) { return true; }
    }
    return false;
  }
  return false;
}
function index() {
  var child = this[0];
  var i;
  if (child) {
    i = 0;
    // eslint-disable-next-line
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) { i += 1; }
    }
    return i;
  }
  return undefined;
}
// eslint-disable-next-line
function eq(index) {
  if (typeof index === 'undefined') { return this; }
  var length = this.length;
  var returnIndex;
  if (index > length - 1) {
    return new Dom7([]);
  }
  if (index < 0) {
    returnIndex = length + index;
    if (returnIndex < 0) { return new Dom7([]); }
    return new Dom7([this[returnIndex]]);
  }
  return new Dom7([this[index]]);
}
function append() {
  var this$1 = this;
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var newChild;

  for (var k = 0; k < args.length; k += 1) {
    newChild = args[k];
    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = doc.createElement('div');
        tempDiv.innerHTML = newChild;
        while (tempDiv.firstChild) {
          this$1[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this$1[i].appendChild(newChild[j]);
        }
      } else {
        this$1[i].appendChild(newChild);
      }
    }
  }

  return this;
}
function prepend(newChild) {
  var this$1 = this;

  var i;
  var j;
  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = doc.createElement('div');
      tempDiv.innerHTML = newChild;
      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this$1[i].insertBefore(tempDiv.childNodes[j], this$1[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this$1[i].insertBefore(newChild[j], this$1[i].childNodes[0]);
      }
    } else {
      this$1[i].insertBefore(newChild, this$1[i].childNodes[0]);
    }
  }
  return this;
}
function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return new Dom7([this[0].nextElementSibling]);
      }
      return new Dom7([]);
    }

    if (this[0].nextElementSibling) { return new Dom7([this[0].nextElementSibling]); }
    return new Dom7([]);
  }
  return new Dom7([]);
}
function nextAll(selector) {
  var nextEls = [];
  var el = this[0];
  if (!el) { return new Dom7([]); }
  while (el.nextElementSibling) {
    var next = el.nextElementSibling; // eslint-disable-line
    if (selector) {
      if ($(next).is(selector)) { nextEls.push(next); }
    } else { nextEls.push(next); }
    el = next;
  }
  return new Dom7(nextEls);
}
function prev(selector) {
  if (this.length > 0) {
    var el = this[0];
    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return new Dom7([el.previousElementSibling]);
      }
      return new Dom7([]);
    }

    if (el.previousElementSibling) { return new Dom7([el.previousElementSibling]); }
    return new Dom7([]);
  }
  return new Dom7([]);
}
function prevAll(selector) {
  var prevEls = [];
  var el = this[0];
  if (!el) { return new Dom7([]); }
  while (el.previousElementSibling) {
    var prev = el.previousElementSibling; // eslint-disable-line
    if (selector) {
      if ($(prev).is(selector)) { prevEls.push(prev); }
    } else { prevEls.push(prev); }
    el = prev;
  }
  return new Dom7(prevEls);
}
function parent(selector) {
  var this$1 = this;

  var parents = []; // eslint-disable-line
  for (var i = 0; i < this.length; i += 1) {
    if (this$1[i].parentNode !== null) {
      if (selector) {
        if ($(this$1[i].parentNode).is(selector)) { parents.push(this$1[i].parentNode); }
      } else {
        parents.push(this$1[i].parentNode);
      }
    }
  }
  return $(unique(parents));
}
function parents(selector) {
  var this$1 = this;

  var parents = []; // eslint-disable-line
  for (var i = 0; i < this.length; i += 1) {
    var parent = this$1[i].parentNode; // eslint-disable-line
    while (parent) {
      if (selector) {
        if ($(parent).is(selector)) { parents.push(parent); }
      } else {
        parents.push(parent);
      }
      parent = parent.parentNode;
    }
  }
  return $(unique(parents));
}
function closest(selector) {
  var closest = this; // eslint-disable-line
  if (typeof selector === 'undefined') {
    return new Dom7([]);
  }
  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }
  return closest;
}
function find(selector) {
  var this$1 = this;

  var foundElements = [];
  for (var i = 0; i < this.length; i += 1) {
    var found = this$1[i].querySelectorAll(selector);
    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }
  return new Dom7(foundElements);
}
function children(selector) {
  var this$1 = this;

  var children = []; // eslint-disable-line
  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this$1[i].childNodes;

    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector) {
        if (childNodes[j].nodeType === 1) { children.push(childNodes[j]); }
      } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }
  return new Dom7(unique(children));
}
function remove() {
  var this$1 = this;

  for (var i = 0; i < this.length; i += 1) {
    if (this$1[i].parentNode) { this$1[i].parentNode.removeChild(this$1[i]); }
  }
  return this;
}
function add() {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var dom = this;
  var i;
  var j;
  for (i = 0; i < args.length; i += 1) {
    var toAdd = $(args[i]);
    for (j = 0; j < toAdd.length; j += 1) {
      dom[dom.length] = toAdd[j];
      dom.length += 1;
    }
  }
  return dom;
}

var Methods = {
  addClass: addClass,
  removeClass: removeClass,
  hasClass: hasClass,
  toggleClass: toggleClass,
  attr: attr,
  removeAttr: removeAttr,
  data: data,
  transform: transform,
  transition: transition,
  on: on,
  off: off,
  trigger: trigger,
  transitionEnd: transitionEnd,
  outerWidth: outerWidth,
  outerHeight: outerHeight,
  offset: offset,
  css: css,
  each: each,
  html: html,
  text: text,
  is: is,
  index: index,
  eq: eq,
  append: append,
  prepend: prepend,
  next: next,
  nextAll: nextAll,
  prev: prev,
  prevAll: prevAll,
  parent: parent,
  parents: parents,
  closest: closest,
  find: find,
  children: children,
  remove: remove,
  add: add,
  styles: styles,
};

Object.keys(Methods).forEach(function (methodName) {
  $.fn[methodName] = Methods[methodName];
});

var Utils = {
  deleteProps: function deleteProps(obj) {
    var object = obj;
    Object.keys(object).forEach(function (key) {
      try {
        object[key] = null;
      } catch (e) {
        // no getter for object
      }
      try {
        delete object[key];
      } catch (e) {
        // something got wrong
      }
    });
  },
  nextTick: function nextTick(callback, delay) {
    if ( delay === void 0 ) delay = 0;

    return setTimeout(callback, delay);
  },
  now: function now() {
    return Date.now();
  },
  getTranslate: function getTranslate(el, axis) {
    if ( axis === void 0 ) axis = 'x';

    var matrix;
    var curTransform;
    var transformMatrix;

    var curStyle = win.getComputedStyle(el, null);

    if (win.WebKitCSSMatrix) {
      curTransform = curStyle.transform || curStyle.webkitTransform;
      if (curTransform.split(',').length > 6) {
        curTransform = curTransform.split(', ').map(function (a) { return a.replace(',', '.'); }).join(', ');
      }
      // Some old versions of Webkit choke when 'none' is passed; pass
      // empty string instead in this case
      transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
      transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
      matrix = transformMatrix.toString().split(',');
    }

    if (axis === 'x') {
      // Latest Chrome and webkits Fix
      if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m41; }
      // Crazy IE10 Matrix
      else if (matrix.length === 16) { curTransform = parseFloat(matrix[12]); }
      // Normal Browsers
      else { curTransform = parseFloat(matrix[4]); }
    }
    if (axis === 'y') {
      // Latest Chrome and webkits Fix
      if (win.WebKitCSSMatrix) { curTransform = transformMatrix.m42; }
      // Crazy IE10 Matrix
      else if (matrix.length === 16) { curTransform = parseFloat(matrix[13]); }
      // Normal Browsers
      else { curTransform = parseFloat(matrix[5]); }
    }
    return curTransform || 0;
  },
  parseUrlQuery: function parseUrlQuery(url) {
    var query = {};
    var urlToParse = url || win.location.href;
    var i;
    var params;
    var param;
    var length;
    if (typeof urlToParse === 'string' && urlToParse.length) {
      urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
      params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
      length = params.length;

      for (i = 0; i < length; i += 1) {
        param = params[i].replace(/#\S+/g, '').split('=');
        query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
      }
    }
    return query;
  },
  isObject: function isObject(o) {
    return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
  },
  extend: function extend() {
    var args = [], len$1 = arguments.length;
    while ( len$1-- ) args[ len$1 ] = arguments[ len$1 ];

    var to = Object(args[0]);
    for (var i = 1; i < args.length; i += 1) {
      var nextSource = args[i];
      if (nextSource !== undefined && nextSource !== null) {
        var keysArray = Object.keys(Object(nextSource));
        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
          var nextKey = keysArray[nextIndex];
          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== undefined && desc.enumerable) {
            if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
              Utils.extend(to[nextKey], nextSource[nextKey]);
            } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
              to[nextKey] = {};
              Utils.extend(to[nextKey], nextSource[nextKey]);
            } else {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
    }
    return to;
  },
};

var Support = (function Support() {
  var testDiv = doc.createElement('div');
  return {
    touch: (win.Modernizr && win.Modernizr.touch === true) || (function checkTouch() {
      return !!(('ontouchstart' in win) || (win.DocumentTouch && doc instanceof win.DocumentTouch));
    }()),

    pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent),
    prefixedPointerEvents: !!win.navigator.msPointerEnabled,

    transition: (function checkTransition() {
      var style = testDiv.style;
      return ('transition' in style || 'webkitTransition' in style || 'MozTransition' in style);
    }()),
    transforms3d: (win.Modernizr && win.Modernizr.csstransforms3d === true) || (function checkTransforms3d() {
      var style = testDiv.style;
      return ('webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style);
    }()),

    flexbox: (function checkFlexbox() {
      var style = testDiv.style;
      var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
      for (var i = 0; i < styles.length; i += 1) {
        if (styles[i] in style) { return true; }
      }
      return false;
    }()),

    observer: (function checkObserver() {
      return ('MutationObserver' in win || 'WebkitMutationObserver' in win);
    }()),

    passiveListener: (function checkPassiveListener() {
      var supportsPassive = false;
      try {
        var opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get: function get() {
            supportsPassive = true;
          },
        });
        win.addEventListener('testPassiveListener', null, opts);
      } catch (e) {
        // No support
      }
      return supportsPassive;
    }()),

    gestures: (function checkGestures() {
      return 'ongesturestart' in win;
    }()),
  };
}());

var SwiperClass = function SwiperClass(params) {
  if ( params === void 0 ) params = {};

  var self = this;
  self.params = params;

  // Events
  self.eventsListeners = {};

  if (self.params && self.params.on) {
    Object.keys(self.params.on).forEach(function (eventName) {
      self.on(eventName, self.params.on[eventName]);
    });
  }
};

var staticAccessors = { components: { configurable: true } };
SwiperClass.prototype.on = function on (events, handler, priority) {
  var self = this;
  if (typeof handler !== 'function') { return self; }
  var method = priority ? 'unshift' : 'push';
  events.split(' ').forEach(function (event) {
    if (!self.eventsListeners[event]) { self.eventsListeners[event] = []; }
    self.eventsListeners[event][method](handler);
  });
  return self;
};
SwiperClass.prototype.once = function once (events, handler, priority) {
  var self = this;
  if (typeof handler !== 'function') { return self; }
  function onceHandler() {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

    handler.apply(self, args);
    self.off(events, onceHandler);
  }
  return self.on(events, onceHandler, priority);
};
SwiperClass.prototype.off = function off (events, handler) {
  var self = this;
  if (!self.eventsListeners) { return self; }
  events.split(' ').forEach(function (event) {
    if (typeof handler === 'undefined') {
      self.eventsListeners[event] = [];
    } else {
      self.eventsListeners[event].forEach(function (eventHandler, index) {
        if (eventHandler === handler) {
          self.eventsListeners[event].splice(index, 1);
        }
      });
    }
  });
  return self;
};
SwiperClass.prototype.emit = function emit () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

  var self = this;
  if (!self.eventsListeners) { return self; }
  var events;
  var data;
  var context;
  if (typeof args[0] === 'string' || Array.isArray(args[0])) {
    events = args[0];
    data = args.slice(1, args.length);
    context = self;
  } else {
    events = args[0].events;
    data = args[0].data;
    context = args[0].context || self;
  }
  var eventsArray = Array.isArray(events) ? events : events.split(' ');
  eventsArray.forEach(function (event) {
    if (self.eventsListeners && self.eventsListeners[event]) {
      var handlers = [];
      self.eventsListeners[event].forEach(function (eventHandler) {
        handlers.push(eventHandler);
      });
      handlers.forEach(function (eventHandler) {
        eventHandler.apply(context, data);
      });
    }
  });
  return self;
};
SwiperClass.prototype.useModulesParams = function useModulesParams (instanceParams) {
  var instance = this;
  if (!instance.modules) { return; }
  Object.keys(instance.modules).forEach(function (moduleName) {
    var module = instance.modules[moduleName];
    // Extend params
    if (module.params) {
      Utils.extend(instanceParams, module.params);
    }
  });
};
SwiperClass.prototype.useModules = function useModules (modulesParams) {
    if ( modulesParams === void 0 ) modulesParams = {};

  var instance = this;
  if (!instance.modules) { return; }
  Object.keys(instance.modules).forEach(function (moduleName) {
    var module = instance.modules[moduleName];
    var moduleParams = modulesParams[moduleName] || {};
    // Extend instance methods and props
    if (module.instance) {
      Object.keys(module.instance).forEach(function (modulePropName) {
        var moduleProp = module.instance[modulePropName];
        if (typeof moduleProp === 'function') {
          instance[modulePropName] = moduleProp.bind(instance);
        } else {
          instance[modulePropName] = moduleProp;
        }
      });
    }
    // Add event listeners
    if (module.on && instance.on) {
      Object.keys(module.on).forEach(function (moduleEventName) {
        instance.on(moduleEventName, module.on[moduleEventName]);
      });
    }

    // Module create callback
    if (module.create) {
      module.create.bind(instance)(moduleParams);
    }
  });
};
staticAccessors.components.set = function (components) {
  var Class = this;
  if (!Class.use) { return; }
  Class.use(components);
};
SwiperClass.installModule = function installModule (module) {
    var params = [], len = arguments.length - 1;
    while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

  var Class = this;
  if (!Class.prototype.modules) { Class.prototype.modules = {}; }
  var name = module.name || (((Object.keys(Class.prototype.modules).length) + "_" + (Utils.now())));
  Class.prototype.modules[name] = module;
  // Prototype
  if (module.proto) {
    Object.keys(module.proto).forEach(function (key) {
      Class.prototype[key] = module.proto[key];
    });
  }
  // Class
  if (module.static) {
    Object.keys(module.static).forEach(function (key) {
      Class[key] = module.static[key];
    });
  }
  // Callback
  if (module.install) {
    module.install.apply(Class, params);
  }
  return Class;
};
SwiperClass.use = function use (module) {
    var params = [], len = arguments.length - 1;
    while ( len-- > 0 ) params[ len ] = arguments[ len + 1 ];

  var Class = this;
  if (Array.isArray(module)) {
    module.forEach(function (m) { return Class.installModule(m); });
    return Class;
  }
  return Class.installModule.apply(Class, [ module ].concat( params ));
};

Object.defineProperties( SwiperClass, staticAccessors );

function updateSize () {
  var swiper = this;
  var width;
  var height;
  var $el = swiper.$el;
  if (typeof swiper.params.width !== 'undefined') {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }
  if (typeof swiper.params.height !== 'undefined') {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }
  if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
    return;
  }

  // Subtract paddings
  width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
  height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

  Utils.extend(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height,
  });
}

function updateSlides () {
  var swiper = this;
  var params = swiper.params;

  var $wrapperEl = swiper.$wrapperEl;
  var swiperSize = swiper.size;
  var rtl = swiper.rtlTranslate;
  var wrongRTL = swiper.wrongRTL;
  var slides = $wrapperEl.children(("." + (swiper.params.slideClass)));
  var isVirtual = swiper.virtual && params.virtual.enabled;
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];

  var offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  var offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  var previousSlidesLength = slidesLength;
  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.snapGrid.length;

  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;
  if (typeof swiperSize === 'undefined') {
    return;
  }
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
  }

  swiper.virtualSize = -spaceBetween;

  // reset margins
  if (rtl) { slides.css({ marginLeft: '', marginTop: '' }); }
  else { slides.css({ marginRight: '', marginBottom: '' }); }

  var slidesNumberEvenToRows;
  if (params.slidesPerColumn > 1) {
    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
    }
    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    }
  }

  // Calc slides
  var slideSize;
  var slidesPerColumn = params.slidesPerColumn;
  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
  var numFullColumns = slidesPerRow - ((params.slidesPerColumn * slidesPerRow) - slidesLength);
  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var slide = slides.eq(i);
    if (params.slidesPerColumn > 1) {
      // Set slides order
      var newSlideOrderIndex = (void 0);
      var column = (void 0);
      var row = (void 0);
      if (params.slidesPerColumnFill === 'column') {
        column = Math.floor(i / slidesPerColumn);
        row = i - (column * slidesPerColumn);
        if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
          row += 1;
          if (row >= slidesPerColumn) {
            row = 0;
            column += 1;
          }
        }
        newSlideOrderIndex = column + ((row * slidesNumberEvenToRows) / slidesPerColumn);
        slide
          .css({
            '-webkit-box-ordinal-group': newSlideOrderIndex,
            '-moz-box-ordinal-group': newSlideOrderIndex,
            '-ms-flex-order': newSlideOrderIndex,
            '-webkit-order': newSlideOrderIndex,
            order: newSlideOrderIndex,
          });
      } else {
        row = Math.floor(i / slidesPerRow);
        column = i - (row * slidesPerRow);
      }
      slide
        .css(
          ("margin-" + (swiper.isHorizontal() ? 'top' : 'left')),
          (row !== 0 && params.spaceBetween) && (((params.spaceBetween) + "px"))
        )
        .attr('data-swiper-column', column)
        .attr('data-swiper-row', row);
    }
    if (slide.css('display') === 'none') { continue; } // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      var slideStyles = win.getComputedStyle(slide[0], null);
      if (swiper.isHorizontal()) {
        slideSize = slide[0].getBoundingClientRect().width +
          parseFloat(slideStyles.getPropertyValue('margin-left')) +
          parseFloat(slideStyles.getPropertyValue('margin-right'));
      } else {
        slideSize = slide[0].getBoundingClientRect().height +
          parseFloat(slideStyles.getPropertyValue('margin-top')) +
          parseFloat(slideStyles.getPropertyValue('margin-bottom'));
      }
      if (params.roundLengths) { slideSize = Math.floor(slideSize); }
    } else {
      slideSize = (swiperSize - ((params.slidesPerView - 1) * spaceBetween)) / params.slidesPerView;
      if (params.roundLengths) { slideSize = Math.floor(slideSize); }

      if (slides[i]) {
        if (swiper.isHorizontal()) {
          slides[i].style.width = slideSize + "px";
        } else {
          slides[i].style.height = slideSize + "px";
        }
      }
    }
    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);


    if (params.centeredSlides) {
      slidePosition = slidePosition + (slideSize / 2) + (prevSlideSize / 2) + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
      if (i === 0) { slidePosition = slidePosition - (swiperSize / 2) - spaceBetween; }
      if (Math.abs(slidePosition) < 1 / 1000) { slidePosition = 0; }
      if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
      slidesGrid.push(slidePosition);
    } else {
      if ((index) % params.slidesPerGroup === 0) { snapGrid.push(slidePosition); }
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;

    prevSlideSize = slideSize;

    index += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  var newSlidesGrid;

  if (
    rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") });
  }
  if (!Support.flexbox || params.setWrapperSize) {
    if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
    else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
  }

  if (params.slidesPerColumn > 1) {
    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
    if (swiper.isHorizontal()) { $wrapperEl.css({ width: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
    else { $wrapperEl.css({ height: ((swiper.virtualSize + params.spaceBetween) + "px") }); }
    if (params.centeredSlides) {
      newSlidesGrid = [];
      for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
        if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) { newSlidesGrid.push(snapGrid[i$1]); }
      }
      snapGrid = newSlidesGrid;
    }
  }

  // Remove last grid elements depending on width
  if (!params.centeredSlides) {
    newSlidesGrid = [];
    for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
      if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(snapGrid[i$2]);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (snapGrid.length === 0) { snapGrid = [0]; }

  if (params.spaceBetween !== 0) {
    if (swiper.isHorizontal()) {
      if (rtl) { slides.css({ marginLeft: (spaceBetween + "px") }); }
      else { slides.css({ marginRight: (spaceBetween + "px") }); }
    } else { slides.css({ marginBottom: (spaceBetween + "px") }); }
  }

  Utils.extend(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid,
  });

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) { swiper.checkOverflow(); }
    swiper.emit('snapGridLengthChange');
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateSlidesOffset();
  }
}

function updateAutoHeight (speed) {
  var swiper = this;
  var activeSlides = [];
  var newHeight = 0;
  var i;
  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  // Find slides currently in view
  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
      var index = swiper.activeIndex + i;
      if (index > swiper.slides.length) { break; }
      activeSlides.push(swiper.slides.eq(index)[0]);
    }
  } else {
    activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
  }

  // Find new height from highest slide in view
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }

  // Update Height
  if (newHeight) { swiper.$wrapperEl.css('height', (newHeight + "px")); }
}

function updateSlidesOffset () {
  var swiper = this;
  var slides = swiper.slides;
  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}

function updateSlidesProgress (translate) {
  if ( translate === void 0 ) translate = this.translate || 0;

  var swiper = this;
  var params = swiper.params;

  var slides = swiper.slides;
  var rtl = swiper.rtlTranslate;

  if (slides.length === 0) { return; }
  if (typeof slides[0].swiperSlideOffset === 'undefined') { swiper.updateSlidesOffset(); }

  var offsetCenter = -translate;
  if (rtl) { offsetCenter = translate; }

  // Visible Slides
  slides.removeClass(params.slideVisibleClass);

  for (var i = 0; i < slides.length; i += 1) {
    var slide = slides[i];
    var slideProgress =
      (
        (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0)) - slide.swiperSlideOffset
      ) / (slide.swiperSlideSize + params.spaceBetween);
    if (params.watchSlidesVisibility) {
      var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
      var isVisible =
                (slideBefore >= 0 && slideBefore < swiper.size) ||
                (slideAfter > 0 && slideAfter <= swiper.size) ||
                (slideBefore <= 0 && slideAfter >= swiper.size);
      if (isVisible) {
        slides.eq(i).addClass(params.slideVisibleClass);
      }
    }
    slide.progress = rtl ? -slideProgress : slideProgress;
  }
}

function updateProgress (translate) {
  if ( translate === void 0 ) translate = this.translate || 0;

  var swiper = this;
  var params = swiper.params;

  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress;
  var isBeginning = swiper.isBeginning;
  var isEnd = swiper.isEnd;
  var wasBeginning = isBeginning;
  var wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / (translatesDiff);
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }
  Utils.extend(swiper, {
    progress: progress,
    isBeginning: isBeginning,
    isEnd: isEnd,
  });

  if (params.watchSlidesProgress || params.watchSlidesVisibility) { swiper.updateSlidesProgress(translate); }

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }
  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }
  if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}

function updateSlidesClasses () {
  var swiper = this;

  var slides = swiper.slides;
  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl;
  var activeIndex = swiper.activeIndex;
  var realIndex = swiper.realIndex;
  var isVirtual = swiper.virtual && params.virtual.enabled;

  slides.removeClass(((params.slideActiveClass) + " " + (params.slideNextClass) + " " + (params.slidePrevClass) + " " + (params.slideDuplicateActiveClass) + " " + (params.slideDuplicateNextClass) + " " + (params.slideDuplicatePrevClass)));

  var activeSlide;
  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + activeIndex + "\"]"));
  } else {
    activeSlide = slides.eq(activeIndex);
  }

  // Active classes
  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl
        .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + realIndex + "\"]"))
        .addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl
        .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]"))
        .addClass(params.slideDuplicateActiveClass);
    }
  }
  // Next Slide
  var nextSlide = activeSlide.nextAll(("." + (params.slideClass))).eq(0).addClass(params.slideNextClass);
  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  }
  // Prev Slide
  var prevSlide = activeSlide.prevAll(("." + (params.slideClass))).eq(0).addClass(params.slidePrevClass);
  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }
  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl
        .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
        .addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl
        .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (nextSlide.attr('data-swiper-slide-index')) + "\"]"))
        .addClass(params.slideDuplicateNextClass);
    }
    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl
        .children(("." + (params.slideClass) + ":not(." + (params.slideDuplicateClass) + ")[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
        .addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl
        .children(("." + (params.slideClass) + "." + (params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + (prevSlide.attr('data-swiper-slide-index')) + "\"]"))
        .addClass(params.slideDuplicatePrevClass);
    }
  }
}

function updateActiveIndex (newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var slidesGrid = swiper.slidesGrid;
  var snapGrid = swiper.snapGrid;
  var params = swiper.params;
  var previousIndex = swiper.activeIndex;
  var previousRealIndex = swiper.realIndex;
  var previousSnapIndex = swiper.snapIndex;
  var activeIndex = newActiveIndex;
  var snapIndex;
  if (typeof activeIndex === 'undefined') {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - ((slidesGrid[i + 1] - slidesGrid[i]) / 2)) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') { activeIndex = 0; }
    }
  }
  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }
  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }
    return;
  }

  // Get real index
  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

  Utils.extend(swiper, {
    snapIndex: snapIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex,
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');
  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }
  swiper.emit('slideChange');
}

function updateClickedSlide (e) {
  var swiper = this;
  var params = swiper.params;
  var slide = $(e.target).closest(("." + (params.slideClass)))[0];
  var slideFound = false;
  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) { slideFound = true; }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = $(slide).index();
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide,
};

function getTranslate (axis) {
  if ( axis === void 0 ) axis = this.isHorizontal() ? 'x' : 'y';

  var swiper = this;

  var params = swiper.params;
  var rtl = swiper.rtlTranslate;
  var translate = swiper.translate;
  var $wrapperEl = swiper.$wrapperEl;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
  if (rtl) { currentTranslate = -currentTranslate; }

  return currentTranslate || 0;
}

function setTranslate (translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate;
  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl;
  var progress = swiper.progress;
  var x = 0;
  var y = 0;
  var z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (!params.virtualTranslate) {
    if (Support.transforms3d) { $wrapperEl.transform(("translate3d(" + x + "px, " + y + "px, " + z + "px)")); }
    else { $wrapperEl.transform(("translate(" + x + "px, " + y + "px)")); }
  }

  swiper.translate = swiper.isHorizontal() ? x : y;

  // Check if we need to update progress
  var newProgress;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / (translatesDiff);
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate () {
  return (-this.snapGrid[0]);
}

function maxTranslate () {
  return (-this.snapGrid[this.snapGrid.length - 1]);
}

var translate = {
  getTranslate: getTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
};

function setTransition (duration, byController) {
  var swiper = this;

  swiper.$wrapperEl.transition(duration);

  swiper.emit('setTransition', duration, byController);
}

function transitionStart (runCallbacks, direction) {
  if ( runCallbacks === void 0 ) runCallbacks = true;

  var swiper = this;
  var activeIndex = swiper.activeIndex;
  var params = swiper.params;
  var previousIndex = swiper.previousIndex;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  var dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) { dir = 'next'; }
    else if (activeIndex < previousIndex) { dir = 'prev'; }
    else { dir = 'reset'; }
  }

  swiper.emit('transitionStart');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionStart');
      return;
    }
    swiper.emit('slideChangeTransitionStart');
    if (dir === 'next') {
      swiper.emit('slideNextTransitionStart');
    } else {
      swiper.emit('slidePrevTransitionStart');
    }
  }
}

function transitionEnd$1 (runCallbacks, direction) {
  if ( runCallbacks === void 0 ) runCallbacks = true;

  var swiper = this;
  var activeIndex = swiper.activeIndex;
  var previousIndex = swiper.previousIndex;
  swiper.animating = false;
  swiper.setTransition(0);

  var dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) { dir = 'next'; }
    else if (activeIndex < previousIndex) { dir = 'prev'; }
    else { dir = 'reset'; }
  }

  swiper.emit('transitionEnd');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionEnd');
      return;
    }
    swiper.emit('slideChangeTransitionEnd');
    if (dir === 'next') {
      swiper.emit('slideNextTransitionEnd');
    } else {
      swiper.emit('slidePrevTransitionEnd');
    }
  }
}

var transition$1 = {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd$1,
};

function slideTo (index, speed, runCallbacks, internal) {
  if ( index === void 0 ) index = 0;
  if ( speed === void 0 ) speed = this.params.speed;
  if ( runCallbacks === void 0 ) runCallbacks = true;

  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) { slideIndex = 0; }

  var params = swiper.params;
  var snapGrid = swiper.snapGrid;
  var slidesGrid = swiper.slidesGrid;
  var previousIndex = swiper.previousIndex;
  var activeIndex = swiper.activeIndex;
  var rtl = swiper.rtlTranslate;
  var $wrapperEl = swiper.$wrapperEl;
  if (swiper.animating && params.preventIntercationOnTransition) {
    return false;
  }

  var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) { snapIndex = snapGrid.length - 1; }

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  var translate = -snapGrid[snapIndex];

  // Update progress
  swiper.updateProgress(translate);

  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
        slideIndex = i;
      }
    }
  }
  // Directions locks
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) { return false; }
    }
  }

  var direction;
  if (slideIndex > activeIndex) { direction = 'next'; }
  else if (slideIndex < activeIndex) { direction = 'prev'; }
  else { direction = 'reset'; }


  // Update Index
  if ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate)) {
    swiper.updateActiveIndex(slideIndex);
    // Update Height
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }
    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }

  if (speed === 0 || !Support.transition) {
    swiper.setTransition(0);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    swiper.transitionEnd(runCallbacks, direction);
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (!swiper.animating) {
      swiper.animating = true;
      $wrapperEl.transitionEnd(function () {
        if (!swiper || swiper.destroyed) { return; }
        swiper.transitionEnd(runCallbacks, direction);
      });
    }
  }

  return true;
}

function slideToLoop (index, speed, runCallbacks, internal) {
  if ( index === void 0 ) index = 0;
  if ( speed === void 0 ) speed = this.params.speed;
  if ( runCallbacks === void 0 ) runCallbacks = true;

  var swiper = this;
  var newIndex = index;
  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideNext (speed, runCallbacks, internal) {
  if ( speed === void 0 ) speed = this.params.speed;
  if ( runCallbacks === void 0 ) runCallbacks = true;

  var swiper = this;
  var params = swiper.params;
  var animating = swiper.animating;
  if (params.loop) {
    if (animating) { return false; }
    swiper.loopFix();
    // eslint-disable-next-line
    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev (speed, runCallbacks, internal) {
  if ( speed === void 0 ) speed = this.params.speed;
  if ( runCallbacks === void 0 ) runCallbacks = true;

  var swiper = this;
  var params = swiper.params;
  var animating = swiper.animating;
  var snapGrid = swiper.snapGrid;
  var slidesGrid = swiper.slidesGrid;
  var rtlTranslate = swiper.rtlTranslate;

  if (params.loop) {
    if (animating) { return false; }
    swiper.loopFix();
    // eslint-disable-next-line
    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }
  var translate = rtlTranslate ? swiper.translate : -swiper.translate;
  var currentSnap = snapGrid[snapGrid.indexOf(translate)];
  var prevSnap = snapGrid[snapGrid.indexOf(translate) - 1];
  var prevIndex;

  if (prevSnap) {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) { prevIndex = swiper.activeIndex - 1; }
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset (speed, runCallbacks, internal) {
  if ( speed === void 0 ) speed = this.params.speed;
  if ( runCallbacks === void 0 ) runCallbacks = true;

  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest (speed, runCallbacks, internal) {
  if ( speed === void 0 ) speed = this.params.speed;
  if ( runCallbacks === void 0 ) runCallbacks = true;

  var swiper = this;
  var index = swiper.activeIndex;
  var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);

  if (snapIndex < swiper.snapGrid.length - 1) {
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];

    if ((translate - currentSnap) > (nextSnap - currentSnap) / 2) {
      index = swiper.params.slidesPerGroup;
    }
  }

  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide () {
  var swiper = this;
  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl;

  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex;
  if (params.loop) {
    if (swiper.animating) { return; }
    realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    if (params.centeredSlides) {
      if (
        (slideToIndex < swiper.loopedSlides - (slidesPerView / 2)) ||
        (slideToIndex > (swiper.slides.length - swiper.loopedSlides) + (slidesPerView / 2))
      ) {
        swiper.loopFix();
        slideToIndex = $wrapperEl
          .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
          .eq(0)
          .index();

        Utils.nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl
        .children(("." + (params.slideClass) + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + (params.slideDuplicateClass) + ")"))
        .eq(0)
        .index();

      Utils.nextTick(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide,
};

function loopCreate () {
  var swiper = this;
  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl;
  // Remove duplicated slides
  $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();

  var slides = $wrapperEl.children(("." + (params.slideClass)));

  if (params.loopFillGroupWithBlank) {
    var blankSlidesNum = params.slidesPerGroup - (slides.length % params.slidesPerGroup);
    if (blankSlidesNum !== params.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankNode = $(doc.createElement('div')).addClass(((params.slideClass) + " " + (params.slideBlankClass)));
        $wrapperEl.append(blankNode);
      }
      slides = $wrapperEl.children(("." + (params.slideClass)));
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) { params.loopedSlides = slides.length; }

  swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
  swiper.loopedSlides += params.loopAdditionalSlides;
  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }

  var prependSlides = [];
  var appendSlides = [];
  slides.each(function (index, el) {
    var slide = $(el);
    if (index < swiper.loopedSlides) { appendSlides.push(el); }
    if (index < slides.length && index >= slides.length - swiper.loopedSlides) { prependSlides.push(el); }
    slide.attr('data-swiper-slide-index', index);
  });
  for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
    $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
  for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
    $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}

function loopFix () {
  var swiper = this;
  var params = swiper.params;
  var activeIndex = swiper.activeIndex;
  var slides = swiper.slides;
  var loopedSlides = swiper.loopedSlides;
  var allowSlidePrev = swiper.allowSlidePrev;
  var allowSlideNext = swiper.allowSlideNext;
  var snapGrid = swiper.snapGrid;
  var rtl = swiper.rtlTranslate;
  var newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;

  var snapTranslate = -snapGrid[activeIndex];
  var diff = snapTranslate - swiper.getTranslate();


  // Fix For Negative Oversliding
  if (activeIndex < loopedSlides) {
    newIndex = (slides.length - (loopedSlides * 3)) + activeIndex;
    newIndex += loopedSlides;
    var slideChanged = swiper.slideTo(newIndex, 0, false, true);
    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if ((params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2) || (activeIndex > slides.length - (params.slidesPerView * 2))) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;
    var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
    if (slideChanged$1 && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
}

function loopDestroy () {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl;
  var params = swiper.params;
  var slides = swiper.slides;
  $wrapperEl.children(("." + (params.slideClass) + "." + (params.slideDuplicateClass))).remove();
  slides.removeAttr('data-swiper-slide-index');
}

var loop = {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy,
};

function setGrabCursor (moving) {
  var swiper = this;
  if (Support.touch || !swiper.params.simulateTouch) { return; }
  var el = swiper.el;
  el.style.cursor = 'move';
  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}

function unsetGrabCursor () {
  var swiper = this;
  if (Support.touch) { return; }
  swiper.el.style.cursor = '';
}

var grabCursor = {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor,
};

function appendSlide (slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl;
  var params = swiper.params;
  if (params.loop) {
    swiper.loopDestroy();
  }
  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) { $wrapperEl.append(slides[i]); }
    }
  } else {
    $wrapperEl.append(slides);
  }
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
}

function prependSlide (slides) {
  var swiper = this;
  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl;
  var activeIndex = swiper.activeIndex;

  if (params.loop) {
    swiper.loopDestroy();
  }
  var newActiveIndex = activeIndex + 1;
  if (typeof slides === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) { $wrapperEl.prepend(slides[i]); }
    }
    newActiveIndex = activeIndex + slides.length;
  } else {
    $wrapperEl.prepend(slides);
  }
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
  swiper.slideTo(newActiveIndex, 0, false);
}

function removeSlide (slidesIndexes) {
  var swiper = this;
  var params = swiper.params;
  var $wrapperEl = swiper.$wrapperEl;
  var activeIndex = swiper.activeIndex;

  if (params.loop) {
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children(("." + (params.slideClass)));
  }
  var newActiveIndex = activeIndex;
  var indexToRemove;

  if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
    for (var i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
      if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
    }
    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) { swiper.slides.eq(indexToRemove).remove(); }
    if (indexToRemove < newActiveIndex) { newActiveIndex -= 1; }
    newActiveIndex = Math.max(newActiveIndex, 0);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeAllSlides () {
  var swiper = this;

  var slidesIndexes = [];
  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }
  swiper.removeSlide(slidesIndexes);
}

var manipulation = {
  appendSlide: appendSlide,
  prependSlide: prependSlide,
  removeSlide: removeSlide,
  removeAllSlides: removeAllSlides,
};

var Device = (function Device() {
  var ua = win.navigator.userAgent;

  var device = {
    ios: false,
    android: false,
    androidChrome: false,
    desktop: false,
    windows: false,
    iphone: false,
    ipod: false,
    ipad: false,
    cordova: win.cordova || win.phonegap,
    phonegap: win.cordova || win.phonegap,
  };

  var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);


  // Windows
  if (windows) {
    device.os = 'windows';
    device.osVersion = windows[2];
    device.windows = true;
  }
  // Android
  if (android && !windows) {
    device.os = 'android';
    device.osVersion = android[2];
    device.android = true;
    device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
  }
  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  }
  // iOS
  if (iphone && !ipod) {
    device.osVersion = iphone[2].replace(/_/g, '.');
    device.iphone = true;
  }
  if (ipad) {
    device.osVersion = ipad[2].replace(/_/g, '.');
    device.ipad = true;
  }
  if (ipod) {
    device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
    device.iphone = true;
  }
  // iOS 8+ changed UA
  if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
    if (device.osVersion.split('.')[0] === '10') {
      device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
    }
  }

  // Desktop
  device.desktop = !(device.os || device.android || device.webView);

  // Webview
  device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

  // Minimal UI
  if (device.os && device.os === 'ios') {
    var osVersionArr = device.osVersion.split('.');
    var metaViewport = doc.querySelector('meta[name="viewport"]');
    device.minimalUi =
      !device.webView &&
      (ipod || iphone) &&
      (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) &&
      metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
  }

  // Pixel Ratio
  device.pixelRatio = win.devicePixelRatio || 1;

  // Export object
  return device;
}());

function onTouchStart (event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params;
  var touches = swiper.touches;
  if (swiper.animating && params.preventIntercationOnTransition) {
    return;
  }
  var e = event;
  if (e.originalEvent) { e = e.originalEvent; }
  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) { return; }
  if (data.isTouched && data.isMoved) { return; }
  if (params.noSwiping && $(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : ("." + (params.noSwipingClass)))[0]) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!$(e).closest(params.swipeHandler)[0]) { return; }
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY;

  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

  if (
    Device.ios &&
    !Device.cordova &&
    params.iOSEdgeSwipeDetection &&
    (startX <= params.iOSEdgeSwipeThreshold) &&
    (startX >= win.screen.width - params.iOSEdgeSwipeThreshold)
  ) {
    return;
  }

  Utils.extend(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined,
  });

  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = Utils.now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) { data.allowThresholdMove = false; }
  if (e.type !== 'touchstart') {
    var preventDefault = true;
    if ($(e.target).is(data.formElements)) { preventDefault = false; }
    if (
      doc.activeElement &&
      $(doc.activeElement).is(data.formElements) &&
      doc.activeElement !== e.target
    ) {
      doc.activeElement.blur();
    }
    if (preventDefault && swiper.allowTouchMove) {
      e.preventDefault();
    }
  }
  swiper.emit('touchStart', e);
}

function onTouchMove (event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params;
  var touches = swiper.touches;
  var rtl = swiper.rtlTranslate;
  var e = event;
  if (e.originalEvent) { e = e.originalEvent; }
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    return;
  }
  if (data.isTouchEvent && e.type === 'mousemove') { return; }
  var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
  var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    // isMoved = true;
    swiper.allowClick = false;
    if (data.isTouched) {
      Utils.extend(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY,
      });
      data.touchStartTime = Utils.now();
    }
    return;
  }
  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (
        (pageY < touches.startY && swiper.translate <= swiper.maxTranslate()) ||
        (pageY > touches.startY && swiper.translate >= swiper.minTranslate())
      ) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (
      (pageX < touches.startX && swiper.translate <= swiper.maxTranslate()) ||
      (pageX > touches.startX && swiper.translate >= swiper.minTranslate())
    ) {
      return;
    }
  }
  if (data.isTouchEvent && doc.activeElement) {
    if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }
  if (e.targetTouches && e.targetTouches.length > 1) { return; }

  touches.currentX = pageX;
  touches.currentY = pageY;

  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;

  if (typeof data.isScrolling === 'undefined') {
    var touchAngle;
    if ((swiper.isHorizontal() && touches.currentY === touches.startY) || (swiper.isVertical() && touches.currentX === touches.startX)) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if ((diffX * diffX) + (diffY * diffY) >= 25) {
        touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : (90 - touchAngle > params.touchAngle);
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }
  if (typeof startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  e.preventDefault();
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop) {
      swiper.loopFix();
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }
    data.allowMomentumBounce = false;
    // Grab Cursor
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit('sliderFirstMove', e);
  }
  swiper.emit('sliderMove', e);
  data.isMoved = true;

  var diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;

  diff *= params.touchRatio;
  if (rtl) { diff = -diff; }

  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;

  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if ((diff > 0 && data.currentTranslate > swiper.minTranslate())) {
    disableParentSwiper = false;
    if (params.resistance) { data.currentTranslate = (swiper.minTranslate() - 1) + (Math.pow( (-swiper.minTranslate() + data.startTranslate + diff), resistanceRatio )); }
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) { data.currentTranslate = (swiper.maxTranslate() + 1) - (Math.pow( (swiper.maxTranslate() - data.startTranslate - diff), resistanceRatio )); }
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }

  // Directions locks
  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }


  // Threshold
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger) { return; }

  // Update active index in free mode
  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (params.freeMode) {
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime,
      });
    }
    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: Utils.now(),
    });
  }
  // Update progress
  swiper.updateProgress(data.currentTranslate);
  // Update translate
  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd (event) {
  var swiper = this;
  var data = swiper.touchEventsData;

  var params = swiper.params;
  var touches = swiper.touches;
  var rtl = swiper.rtlTranslate;
  var $wrapperEl = swiper.$wrapperEl;
  var slidesGrid = swiper.slidesGrid;
  var snapGrid = swiper.snapGrid;
  var e = event;
  if (e.originalEvent) { e = e.originalEvent; }
  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  // Return Grab Cursor
  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }

  // Time diff
  var touchEndTime = Utils.now();
  var timeDiff = touchEndTime - data.touchStartTime;

  // Tap, doubleTap, Click
  if (swiper.allowClick) {
    swiper.updateClickedSlide(e);
    swiper.emit('tap', e);
    if (timeDiff < 300 && (touchEndTime - data.lastClickTime) > 300) {
      if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
      data.clickTimeout = Utils.nextTick(function () {
        if (!swiper || swiper.destroyed) { return; }
        swiper.emit('click', e);
      }, 300);
    }
    if (timeDiff < 300 && (touchEndTime - data.lastClickTime) < 300) {
      if (data.clickTimeout) { clearTimeout(data.clickTimeout); }
      swiper.emit('doubleTap', e);
    }
  }

  data.lastClickTime = Utils.now();
  Utils.nextTick(function () {
    if (!swiper.destroyed) { swiper.allowClick = true; }
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;

  var currentPos;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.freeMode) {
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    } else if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }
      return;
    }

    if (params.freeModeMomentum) {
      if (data.velocities.length > 1) {
        var lastMoveEvent = data.velocities.pop();
        var velocityEvent = data.velocities.pop();

        var distance = lastMoveEvent.position - velocityEvent.position;
        var time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;
        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
          swiper.velocity = 0;
        }
        // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.
        if (time > 150 || (Utils.now() - lastMoveEvent.time) > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }
      swiper.velocity *= params.freeModeMomentumVelocityRatio;

      data.velocities.length = 0;
      var momentumDuration = 1000 * params.freeModeMomentumRatio;
      var momentumDistance = swiper.velocity * momentumDuration;

      var newPosition = swiper.translate + momentumDistance;
      if (rtl) { newPosition = -newPosition; }

      var doBounce = false;
      var afterBouncePosition;
      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
      var needsLoopFix;
      if (newPosition < swiper.maxTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }
          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }
        if (params.loop && params.centeredSlides) { needsLoopFix = true; }
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }
          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }
        if (params.loop && params.centeredSlides) { needsLoopFix = true; }
      } else if (params.freeModeSticky) {
        var nextSlide;
        for (var j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }
        newPosition = -newPosition;
      }
      if (needsLoopFix) {
        swiper.once('transitionEnd', function () {
          swiper.loopFix();
        });
      }
      // Fix duration
      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeModeMomentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(function () {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) { return; }
          swiper.emit('momentumBounce');

          swiper.setTransition(params.speed);
          swiper.setTranslate(afterBouncePosition);
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) { return; }
            swiper.transitionEnd();
          });
        });
      } else if (swiper.velocity) {
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) { return; }
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeModeSticky) {
      swiper.slideToClosest();
      return;
    }

    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    return;
  }

  // Find current slide
  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];
  for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
    if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
        stopIndex = i;
        groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }

  // Find current slide size
  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
      else { swiper.slideTo(stopIndex); }
    }
    if (swiper.swipeDirection === 'prev') {
      if (ratio > (1 - params.longSwipesRatio)) { swiper.slideTo(stopIndex + params.slidesPerGroup); }
      else { swiper.slideTo(stopIndex); }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      swiper.slideTo(stopIndex + params.slidesPerGroup);
    }
    if (swiper.swipeDirection === 'prev') {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize () {
  var swiper = this;

  var params = swiper.params;
  var el = swiper.el;

  if (el && el.offsetWidth === 0) { return; }

  // Breakpoints
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }

  // Save locks
  var allowSlideNext = swiper.allowSlideNext;
  var allowSlidePrev = swiper.allowSlidePrev;
  var snapGrid = swiper.snapGrid;

  // Disable locks on resize
  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;

  swiper.updateSize();
  swiper.updateSlides();

  if (params.freeMode) {
    var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
    swiper.setTranslate(newTranslate);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
  } else {
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
      swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
  }
  // Return locks after resize
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick (e) {
  var swiper = this;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) { e.preventDefault(); }
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function attachEvents() {
  var swiper = this;
  var params = swiper.params;
  var touchEvents = swiper.touchEvents;
  var el = swiper.el;
  var wrapperEl = swiper.wrapperEl;

  {
    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);

  var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
  var capture = !!params.nested;

  // Touch Events
  {
    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
      doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
      doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (Support.touch) {
        var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
        target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
        target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
      }
      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
        target.addEventListener('mousedown', swiper.onTouchStart, false);
        doc.addEventListener('mousemove', swiper.onTouchMove, capture);
        doc.addEventListener('mouseup', swiper.onTouchEnd, false);
      }
    }
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) {
      target.addEventListener('click', swiper.onClick, true);
    }
  }

  // Resize handler
  swiper.on('resize observerUpdate', onResize, true);
}

function detachEvents() {
  var swiper = this;

  var params = swiper.params;
  var touchEvents = swiper.touchEvents;
  var el = swiper.el;
  var wrapperEl = swiper.wrapperEl;

  var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
  var capture = !!params.nested;

  // Touch Events
  {
    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
      doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (Support.touch) {
        var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
        target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
      }
      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
        target.removeEventListener('mousedown', swiper.onTouchStart, false);
        doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
        doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
      }
    }
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) {
      target.removeEventListener('click', swiper.onClick, true);
    }
  }

  // Resize handler
  swiper.off('resize observerUpdate', onResize);
}

var events = {
  attachEvents: attachEvents,
  detachEvents: detachEvents,
};

function setBreakpoint () {
  var swiper = this;
  var activeIndex = swiper.activeIndex;
  var loopedSlides = swiper.loopedSlides; if ( loopedSlides === void 0 ) loopedSlides = 0;
  var params = swiper.params;
  var breakpoints = params.breakpoints;
  if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0)) { return; }
  // Set breakpoint for window width and update parameters
  var breakpoint = swiper.getBreakpoint(breakpoints);
  if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
    var breakPointsParams = breakpoint in breakpoints ? breakpoints[breakpoint] : swiper.originalParams;
    var needsReLoop = params.loop && (breakPointsParams.slidesPerView !== params.slidesPerView);

    Utils.extend(swiper.params, breakPointsParams);

    Utils.extend(swiper, {
      allowTouchMove: swiper.params.allowTouchMove,
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
    });

    swiper.currentBreakpoint = breakpoint;

    if (needsReLoop) {
      swiper.loopDestroy();
      swiper.loopCreate();
      swiper.updateSlides();
      swiper.slideTo((activeIndex - loopedSlides) + swiper.loopedSlides, 0, false);
    }
    swiper.emit('breakpoint', breakPointsParams);
  }
}

function getBreakpoint (breakpoints) {
  // Get breakpoint for window width
  if (!breakpoints) { return undefined; }
  var breakpoint = false;
  var points = [];
  Object.keys(breakpoints).forEach(function (point) {
    points.push(point);
  });
  points.sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); });
  for (var i = 0; i < points.length; i += 1) {
    var point = points[i];
    if (point >= win.innerWidth && !breakpoint) {
      breakpoint = point;
    }
  }
  return breakpoint || 'max';
}

var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };

var Browser = (function Browser() {
  function isSafari() {
    var ua = win.navigator.userAgent.toLowerCase();
    return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
  }
  return {
    isIE: !!win.navigator.userAgent.match(/Trident/g) || !!win.navigator.userAgent.match(/MSIE/g),
    isSafari: isSafari(),
    isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent),
  };
}());

function addClasses () {
  var swiper = this;
  var classNames = swiper.classNames;
  var params = swiper.params;
  var rtl = swiper.rtl;
  var $el = swiper.$el;
  var suffixes = [];

  suffixes.push(params.direction);

  if (params.freeMode) {
    suffixes.push('free-mode');
  }
  if (!Support.flexbox) {
    suffixes.push('no-flexbox');
  }
  if (params.autoHeight) {
    suffixes.push('autoheight');
  }
  if (rtl) {
    suffixes.push('rtl');
  }
  if (params.slidesPerColumn > 1) {
    suffixes.push('multirow');
  }
  if (Device.android) {
    suffixes.push('android');
  }
  if (Device.ios) {
    suffixes.push('ios');
  }
  // WP8 Touch Events Fix
  if (Browser.isIE && (Support.pointerEvents || Support.prefixedPointerEvents)) {
    suffixes.push(("wp8-" + (params.direction)));
  }

  suffixes.forEach(function (suffix) {
    classNames.push(params.containerModifierClass + suffix);
  });

  $el.addClass(classNames.join(' '));
}

function removeClasses () {
  var swiper = this;
  var $el = swiper.$el;
  var classNames = swiper.classNames;

  $el.removeClass(classNames.join(' '));
}

var classes = { addClasses: addClasses, removeClasses: removeClasses };

function loadImage (imageEl, src, srcset, sizes, checkForComplete, callback) {
  var image;
  function onReady() {
    if (callback) { callback(); }
  }
  if (!imageEl.complete || !checkForComplete) {
    if (src) {
      image = new win.Image();
      image.onload = onReady;
      image.onerror = onReady;
      if (sizes) {
        image.sizes = sizes;
      }
      if (srcset) {
        image.srcset = srcset;
      }
      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}

function preloadImages () {
  var swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');
  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) { return; }
    if (swiper.imagesLoaded !== undefined) { swiper.imagesLoaded += 1; }
    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) { swiper.update(); }
      swiper.emit('imagesReady');
    }
  }
  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
    var imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(
      imageEl,
      imageEl.currentSrc || imageEl.getAttribute('src'),
      imageEl.srcset || imageEl.getAttribute('srcset'),
      imageEl.sizes || imageEl.getAttribute('sizes'),
      true,
      onReady
    );
  }
}

var images = {
  loadImage: loadImage,
  preloadImages: preloadImages,
};

function checkOverflow() {
  var swiper = this;
  var wasLocked = swiper.isLocked;

  swiper.isLocked = swiper.snapGrid.length === 1;
  swiper.allowSlideNext = !swiper.isLocked;
  swiper.allowSlidePrev = !swiper.isLocked;

  // events
  if (wasLocked !== swiper.isLocked) { swiper.emit(swiper.isLocked ? 'lock' : 'unlock'); }

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
    swiper.navigation.update();
  }
}

var checkOverflow$1 = { checkOverflow: checkOverflow };

var defaults = {
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'container',
  initialSlide: 0,
  speed: 300,
  //
  preventIntercationOnTransition: false,

  // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
  iOSEdgeSwipeDetection: false,
  iOSEdgeSwipeThreshold: 20,

  // Free mode
  freeMode: false,
  freeModeMomentum: true,
  freeModeMomentumRatio: 1,
  freeModeMomentumBounce: true,
  freeModeMomentumBounceRatio: 1,
  freeModeMomentumVelocityRatio: 1,
  freeModeSticky: false,
  freeModeMinimumVelocity: 0.02,

  // Autoheight
  autoHeight: false,

  // Set wrapper width
  setWrapperSize: false,

  // Virtual Translate
  virtualTranslate: false,

  // Effects
  effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

  // Breakpoints
  breakpoints: undefined,

  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerColumnFill: 'column',
  slidesPerGroup: 1,
  centeredSlides: false,
  slidesOffsetBefore: 0, // in px
  slidesOffsetAfter: 0, // in px
  normalizeSlideIndex: true,

  // Disable swiper and hide navigation when container not overflow
  watchOverflow: false,

  // Round length
  roundLengths: false,

  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: true,
  touchReleaseOnEdges: false,

  // Unique Navigation Elements
  uniqueNavElements: true,

  // Resistance
  resistance: true,
  resistanceRatio: 0.85,

  // Progress
  watchSlidesProgress: false,
  watchSlidesVisibility: false,

  // Cursor
  grabCursor: false,

  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,

  // Images
  preloadImages: true,
  updateOnImagesReady: true,

  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,

  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null, // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,

  // Passive Listeners
  passiveListeners: true,

  // NS
  containerModifierClass: 'swiper-container-', // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',

  // Callbacks
  runCallbacksOnInit: true,
};

var prototypes = {
  update: update,
  translate: translate,
  transition: transition$1,
  slide: slide,
  loop: loop,
  grabCursor: grabCursor,
  manipulation: manipulation,
  events: events,
  breakpoints: breakpoints,
  checkOverflow: checkOverflow$1,
  classes: classes,
  images: images,
};

var extendedDefaults = {};

var Swiper = (function (SwiperClass$$1) {
  function Swiper() {
    var assign;

    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    var el;
    var params;
    if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
      params = args[0];
    } else {
      (assign = args, el = assign[0], params = assign[1]);
    }
    if (!params) { params = {}; }

    params = Utils.extend({}, params);
    if (el && !params.el) { params.el = el; }

    SwiperClass$$1.call(this, params);

    Object.keys(prototypes).forEach(function (prototypeGroup) {
      Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
        if (!Swiper.prototype[protoMethod]) {
          Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
        }
      });
    });

    // Swiper Instance
    var swiper = this;
    if (typeof swiper.modules === 'undefined') {
      swiper.modules = {};
    }
    Object.keys(swiper.modules).forEach(function (moduleName) {
      var module = swiper.modules[moduleName];
      if (module.params) {
        var moduleParamName = Object.keys(module.params)[0];
        var moduleParams = module.params[moduleParamName];
        if (typeof moduleParams !== 'object') { return; }
        if (!(moduleParamName in params && 'enabled' in moduleParams)) { return; }
        if (params[moduleParamName] === true) {
          params[moduleParamName] = { enabled: true };
        }
        if (
          typeof params[moduleParamName] === 'object' &&
          !('enabled' in params[moduleParamName])
        ) {
          params[moduleParamName].enabled = true;
        }
        if (!params[moduleParamName]) { params[moduleParamName] = { enabled: false }; }
      }
    });

    // Extend defaults with modules params
    var swiperParams = Utils.extend({}, defaults);
    swiper.useModulesParams(swiperParams);

    // Extend defaults with passed params
    swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = Utils.extend({}, swiper.params);
    swiper.passedParams = Utils.extend({}, params);

    // Save Dom lib
    swiper.$ = $;

    // Find el
    var $el = $(swiper.params.el);
    el = $el[0];

    if (!el) {
      return undefined;
    }

    if ($el.length > 1) {
      var swipers = [];
      $el.each(function (index, containerEl) {
        var newParams = Utils.extend({}, params, { el: containerEl });
        swipers.push(new Swiper(newParams));
      });
      return swipers;
    }

    el.swiper = swiper;
    $el.data('swiper', swiper);

    // Find Wrapper
    var $wrapperEl = $el.children(("." + (swiper.params.wrapperClass)));

    // Extend Swiper
    Utils.extend(swiper, {
      $el: $el,
      el: el,
      $wrapperEl: $wrapperEl,
      wrapperEl: $wrapperEl[0],

      // Classes
      classNames: [],

      // Slides
      slides: $(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],

      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },
      // RTL
      rtl: (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box',

      // Indexes
      activeIndex: 0,
      realIndex: 0,

      //
      isBeginning: true,
      isEnd: false,

      // Props
      translate: 0,
      progress: 0,
      velocity: 0,
      animating: false,

      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,

      // Touch Events
      touchEvents: (function touchEvents() {
        var touch = ['touchstart', 'touchmove', 'touchend'];
        var desktop = ['mousedown', 'mousemove', 'mouseup'];
        if (Support.pointerEvents) {
          desktop = ['pointerdown', 'pointermove', 'pointerup'];
        } else if (Support.prefixedPointerEvents) {
          desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
        }
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2],
        };
        return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }()),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        formElements: 'input, select, option, textarea, button, video',
        // Last click time
        lastClickTime: Utils.now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined,
      },

      // Clicks
      allowClick: true,

      // Touches
      allowTouchMove: swiper.params.allowTouchMove,

      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0,
      },

      // Images
      imagesToLoad: [],
      imagesLoaded: 0,

    });

    // Install Modules
    swiper.useModules();

    // Init
    if (swiper.params.init) {
      swiper.init();
    }

    // Return app instance
    return swiper;
  }

  if ( SwiperClass$$1 ) Swiper.__proto__ = SwiperClass$$1;
  Swiper.prototype = Object.create( SwiperClass$$1 && SwiperClass$$1.prototype );
  Swiper.prototype.constructor = Swiper;

  var staticAccessors = { extendedDefaults: { configurable: true },defaults: { configurable: true },Class: { configurable: true },$: { configurable: true } };
  Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic () {
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides;
    var slidesGrid = swiper.slidesGrid;
    var swiperSize = swiper.size;
    var activeIndex = swiper.activeIndex;
    var spv = 1;
    if (params.centeredSlides) {
      var slideSize = slides[activeIndex].swiperSlideSize;
      var breakLoop;
      for (var i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) { breakLoop = true; }
        }
      }
      for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
        if (slides[i$1] && !breakLoop) {
          slideSize += slides[i$1].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) { breakLoop = true; }
        }
      }
    } else {
      for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
        if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
          spv += 1;
        }
      }
    }
    return spv;
  };
  Swiper.prototype.update = function update$$1 () {
    var swiper = this;
    if (!swiper || swiper.destroyed) { return; }
    var snapGrid = swiper.snapGrid;
    var params = swiper.params;
    // Breakpoints
    if (params.breakpoints) {
      swiper.setBreakpoint();
    }
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    var translated;
    if (swiper.params.freeMode) {
      setTranslate();
      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }
      if (!translated) {
        setTranslate();
      }
    }
    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }
    swiper.emit('update');
  };
  Swiper.prototype.init = function init () {
    var swiper = this;
    if (swiper.initialized) { return; }

    swiper.emit('beforeInit');

    // Set breakpoint
    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    }

    // Add Classes
    swiper.addClasses();

    // Create loop
    if (swiper.params.loop) {
      swiper.loopCreate();
    }

    // Update size
    swiper.updateSize();

    // Update slides
    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    }

    // Set Grab Cursor
    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    }

    // Slide To Initial Slide
    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
    }

    // Attach events
    swiper.attachEvents();

    // Init Flag
    swiper.initialized = true;

    // Emit
    swiper.emit('init');
  };
  Swiper.prototype.destroy = function destroy (deleteInstance, cleanStyles) {
    if ( deleteInstance === void 0 ) deleteInstance = true;
    if ( cleanStyles === void 0 ) cleanStyles = true;

    var swiper = this;
    var params = swiper.params;
    var $el = swiper.$el;
    var $wrapperEl = swiper.$wrapperEl;
    var slides = swiper.slides;
    swiper.emit('beforeDestroy');

    // Init Flag
    swiper.initialized = false;

    // Detach events
    swiper.detachEvents();

    // Destroy loop
    if (params.loop) {
      swiper.loopDestroy();
    }

    // Cleanup styles
    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');
      if (slides && slides.length) {
        slides
          .removeClass([
            params.slideVisibleClass,
            params.slideActiveClass,
            params.slideNextClass,
            params.slidePrevClass ].join(' '))
          .removeAttr('style')
          .removeAttr('data-swiper-slide-index')
          .removeAttr('data-swiper-column')
          .removeAttr('data-swiper-row');
      }
    }

    swiper.emit('destroy');

    // Detach emitter events
    Object.keys(swiper.eventsListeners).forEach(function (eventName) {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      swiper.$el.data('swiper', null);
      Utils.deleteProps(swiper);
    }
    swiper.destroyed = true;
  };
  Swiper.extendDefaults = function extendDefaults (newDefaults) {
    Utils.extend(extendedDefaults, newDefaults);
  };
  staticAccessors.extendedDefaults.get = function () {
    return extendedDefaults;
  };
  staticAccessors.defaults.get = function () {
    return defaults;
  };
  staticAccessors.Class.get = function () {
    return SwiperClass$$1;
  };
  staticAccessors.$.get = function () {
    return $;
  };

  Object.defineProperties( Swiper, staticAccessors );

  return Swiper;
}(SwiperClass));

var Device$1 = {
  name: 'device',
  proto: {
    device: Device,
  },
  static: {
    device: Device,
  },
};

var Support$1 = {
  name: 'support',
  proto: {
    support: Support,
  },
  static: {
    support: Support,
  },
};

var Browser$1 = {
  name: 'browser',
  proto: {
    browser: Browser,
  },
  static: {
    browser: Browser,
  },
};

var Resize = {
  name: 'resize',
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      resize: {
        resizeHandler: function resizeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
          swiper.emit('beforeResize');
          swiper.emit('resize');
        },
        orientationChangeHandler: function orientationChangeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) { return; }
          swiper.emit('orientationchange');
        },
      },
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      // Emit resize
      win.addEventListener('resize', swiper.resize.resizeHandler);

      // Emit orientationchange
      win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    },
    destroy: function destroy() {
      var swiper = this;
      win.removeEventListener('resize', swiper.resize.resizeHandler);
      win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    },
  },
};

var Observer = {
  func: win.MutationObserver || win.WebkitMutationObserver,
  attach: function attach(target, options) {
    if ( options === void 0 ) options = {};

    var swiper = this;

    var ObserverFunc = Observer.func;
    var observer = new ObserverFunc(function (mutations) {
      mutations.forEach(function (mutation) {
        swiper.emit('observerUpdate', mutation);
      });
    });

    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
    });

    swiper.observer.observers.push(observer);
  },
  init: function init() {
    var swiper = this;
    if (!Support.observer || !swiper.params.observer) { return; }
    if (swiper.params.observeParents) {
      var containerParents = swiper.$el.parents();
      for (var i = 0; i < containerParents.length; i += 1) {
        swiper.observer.attach(containerParents[i]);
      }
    }
    // Observe container
    swiper.observer.attach(swiper.$el[0], { childList: false });

    // Observe wrapper
    swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.observer.observers.forEach(function (observer) {
      observer.disconnect();
    });
    swiper.observer.observers = [];
  },
};

var Observer$1 = {
  name: 'observer',
  params: {
    observer: false,
    observeParents: false,
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      observer: {
        init: Observer.init.bind(swiper),
        attach: Observer.attach.bind(swiper),
        destroy: Observer.destroy.bind(swiper),
        observers: [],
      },
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      swiper.observer.init();
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.destroy();
    },
  },
};

var Virtual = {
  update: function update(force) {
    var swiper = this;
    var ref = swiper.params;
    var slidesPerView = ref.slidesPerView;
    var slidesPerGroup = ref.slidesPerGroup;
    var centeredSlides = ref.centeredSlides;
    var ref$1 = swiper.virtual;
    var previousFrom = ref$1.from;
    var previousTo = ref$1.to;
    var slides = ref$1.slides;
    var previousSlidesGrid = ref$1.slidesGrid;
    var renderSlide = ref$1.renderSlide;
    var previousOffset = ref$1.offset;
    swiper.updateActiveIndex();
    var activeIndex = swiper.activeIndex || 0;

    var offsetProp;
    if (swiper.rtlTranslate) { offsetProp = 'right'; }
    else { offsetProp = swiper.isHorizontal() ? 'left' : 'top'; }

    var slidesAfter;
    var slidesBefore;
    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1);
      slidesBefore = slidesPerGroup;
    }
    var from = Math.max((activeIndex || 0) - slidesBefore, 0);
    var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
    var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

    Utils.extend(swiper.virtual, {
      from: from,
      to: to,
      offset: offset,
      slidesGrid: swiper.slidesGrid,
    });

    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      if (swiper.lazy && swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    }

    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.css(offsetProp, (offset + "px"));
      }
      swiper.updateProgress();
      return;
    }
    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset: offset,
        from: from,
        to: to,
        slides: (function getSlides() {
          var slidesToRender = [];
          for (var i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }
          return slidesToRender;
        }()),
      });
      onRendered();
      return;
    }
    var prependIndexes = [];
    var appendIndexes = [];
    if (force) {
      swiper.$wrapperEl.find(("." + (swiper.params.slideClass))).remove();
    } else {
      for (var i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          swiper.$wrapperEl.find(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + i + "\"]")).remove();
        }
      }
    }
    for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
      if (i$1 >= from && i$1 <= to) {
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(i$1);
        } else {
          if (i$1 > previousTo) { appendIndexes.push(i$1); }
          if (i$1 < previousFrom) { prependIndexes.push(i$1); }
        }
      }
    }
    appendIndexes.forEach(function (index) {
      swiper.$wrapperEl.append(renderSlide(slides[index], index));
    });
    prependIndexes.sort(function (a, b) { return a < b; }).forEach(function (index) {
      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
    });
    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, (offset + "px"));
    onRendered();
  },
  renderSlide: function renderSlide(slide, index) {
    var swiper = this;
    var params = swiper.params.virtual;
    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }
    var $slideEl = params.renderSlide
      ? $(params.renderSlide.call(swiper, slide, index))
      : $(("<div class=\"" + (swiper.params.slideClass) + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>"));
    if (!$slideEl.attr('data-swiper-slide-index')) { $slideEl.attr('data-swiper-slide-index', index); }
    if (params.cache) { swiper.virtual.cache[index] = $slideEl; }
    return $slideEl;
  },
  appendSlide: function appendSlide(slide) {
    var swiper = this;
    swiper.virtual.slides.push(slide);
    swiper.virtual.update(true);
  },
  prependSlide: function prependSlide(slide) {
    var swiper = this;
    swiper.virtual.slides.unshift(slide);
    if (swiper.params.virtual.cache) {
      var cache = swiper.virtual.cache;
      var newCache = {};
      Object.keys(cache).forEach(function (cachedIndex) {
        newCache[cachedIndex + 1] = cache[cachedIndex];
      });
      swiper.virtual.cache = newCache;
    }
    swiper.virtual.update(true);
    swiper.slideNext(0);
  },
};

var Virtual$1 = {
  name: 'virtual',
  params: {
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      virtual: {
        update: Virtual.update.bind(swiper),
        appendSlide: Virtual.appendSlide.bind(swiper),
        prependSlide: Virtual.prependSlide.bind(swiper),
        renderSlide: Virtual.renderSlide.bind(swiper),
        slides: swiper.params.virtual.slides,
        cache: {},
      },
    });
  },
  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (!swiper.params.virtual.enabled) { return; }
      swiper.classNames.push(((swiper.params.containerModifierClass) + "virtual"));
      var overwriteParams = {
        watchSlidesProgress: true,
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);

      swiper.virtual.update();
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.virtual.enabled) { return; }
      swiper.virtual.update();
    },
  },
};

var Keyboard = {
  handle: function handle(event) {
    var swiper = this;
    var rtl = swiper.rtlTranslate;
    var e = event;
    if (e.originalEvent) { e = e.originalEvent; } // jquery fix
    var kc = e.keyCode || e.charCode;
    // Directions locks
    if (!swiper.allowSlideNext && ((swiper.isHorizontal() && kc === 39) || (swiper.isVertical() && kc === 40))) {
      return false;
    }
    if (!swiper.allowSlidePrev && ((swiper.isHorizontal() && kc === 37) || (swiper.isVertical() && kc === 38))) {
      return false;
    }
    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }
    if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
      return undefined;
    }
    if (swiper.params.keyboard.onlyInViewport && (kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
      var inView = false;
      // Check that swiper should be inside of visible area of window
      if (swiper.$el.parents(("." + (swiper.params.slideClass))).length > 0 && swiper.$el.parents(("." + (swiper.params.slideActiveClass))).length === 0) {
        return undefined;
      }
      var windowWidth = win.innerWidth;
      var windowHeight = win.innerHeight;
      var swiperOffset = swiper.$el.offset();
      if (rtl) { swiperOffset.left -= swiper.$el[0].scrollLeft; }
      var swiperCoord = [
        [swiperOffset.left, swiperOffset.top],
        [swiperOffset.left + swiper.width, swiperOffset.top],
        [swiperOffset.left, swiperOffset.top + swiper.height],
        [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height] ];
      for (var i = 0; i < swiperCoord.length; i += 1) {
        var point = swiperCoord[i];
        if (
          point[0] >= 0 && point[0] <= windowWidth &&
          point[1] >= 0 && point[1] <= windowHeight
        ) {
          inView = true;
        }
      }
      if (!inView) { return undefined; }
    }
    if (swiper.isHorizontal()) {
      if (kc === 37 || kc === 39) {
        if (e.preventDefault) { e.preventDefault(); }
        else { e.returnValue = false; }
      }
      if ((kc === 39 && !rtl) || (kc === 37 && rtl)) { swiper.slideNext(); }
      if ((kc === 37 && !rtl) || (kc === 39 && rtl)) { swiper.slidePrev(); }
    } else {
      if (kc === 38 || kc === 40) {
        if (e.preventDefault) { e.preventDefault(); }
        else { e.returnValue = false; }
      }
      if (kc === 40) { swiper.slideNext(); }
      if (kc === 38) { swiper.slidePrev(); }
    }
    swiper.emit('keyPress', kc);
    return undefined;
  },
  enable: function enable() {
    var swiper = this;
    if (swiper.keyboard.enabled) { return; }
    $(doc).on('keydown', swiper.keyboard.handle);
    swiper.keyboard.enabled = true;
  },
  disable: function disable() {
    var swiper = this;
    if (!swiper.keyboard.enabled) { return; }
    $(doc).off('keydown', swiper.keyboard.handle);
    swiper.keyboard.enabled = false;
  },
};

var Keyboard$1 = {
  name: 'keyboard',
  params: {
    keyboard: {
      enabled: false,
      onlyInViewport: true,
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      keyboard: {
        enabled: false,
        enable: Keyboard.enable.bind(swiper),
        disable: Keyboard.disable.bind(swiper),
        handle: Keyboard.handle.bind(swiper),
      },
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.keyboard.enabled) {
        swiper.keyboard.enable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.keyboard.enabled) {
        swiper.keyboard.disable();
      }
    },
  },
};

function isEventSupported() {
  var eventName = 'onwheel';
  var isSupported = eventName in doc;

  if (!isSupported) {
    var element = doc.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported &&
    doc.implementation &&
    doc.implementation.hasFeature &&
    // always returns true in newer browsers as per the standard.
    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
    doc.implementation.hasFeature('', '') !== true
  ) {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}
var Mousewheel = {
  lastScrollTime: Utils.now(),
  event: (function getEvent() {
    if (win.navigator.userAgent.indexOf('firefox') > -1) { return 'DOMMouseScroll'; }
    return isEventSupported() ? 'wheel' : 'mousewheel';
  }()),
  normalize: function normalize(e) {
    // Reasonable defaults
    var PIXEL_STEP = 10;
    var LINE_HEIGHT = 40;
    var PAGE_HEIGHT = 800;

    var sX = 0;
    var sY = 0; // spinX, spinY
    var pX = 0;
    var pY = 0; // pixelX, pixelY

    // Legacy
    if ('detail' in e) {
      sY = e.detail;
    }
    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }
    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }
    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    }

    // side scrolling on FF with DOMMouseScroll
    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }

    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;

    if ('deltaY' in e) {
      pY = e.deltaY;
    }
    if ('deltaX' in e) {
      pX = e.deltaX;
    }

    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) { // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else { // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    }

    // Fall-back if spin cannot be determined
    if (pX && !sX) {
      sX = (pX < 1) ? -1 : 1;
    }
    if (pY && !sY) {
      sY = (pY < 1) ? -1 : 1;
    }

    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY,
    };
  },
  handleMouseEnter: function handleMouseEnter() {
    var swiper = this;
    swiper.mouseEntered = true;
  },
  handleMouseLeave: function handleMouseLeave() {
    var swiper = this;
    swiper.mouseEntered = false;
  },
  handle: function handle(event) {
    var e = event;
    var swiper = this;
    var params = swiper.params.mousewheel;

    if (!swiper.mouseEntered && !params.releaseOnEdges) { return true; }

    if (e.originalEvent) { e = e.originalEvent; } // jquery fix
    var delta = 0;
    var rtlFactor = swiper.rtlTranslate ? -1 : 1;

    var data = Mousewheel.normalize(e);

    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) { delta = data.pixelX * rtlFactor; }
        else { return true; }
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) { delta = data.pixelY; }
      else { return true; }
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }

    if (delta === 0) { return true; }

    if (params.invert) { delta = -delta; }

    if (!swiper.params.freeMode) {
      if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
        if (delta < 0) {
          if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
            swiper.slideNext();
            swiper.emit('scroll', e);
          } else if (params.releaseOnEdges) { return true; }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
          swiper.slidePrev();
          swiper.emit('scroll', e);
        } else if (params.releaseOnEdges) { return true; }
      }
      swiper.mousewheel.lastScrollTime = (new win.Date()).getTime();
    } else {
      // Freemode or scrollContainer:
      if (swiper.params.loop) {
        swiper.loopFix();
      }
      var position = swiper.getTranslate() + (delta * params.sensitivity);
      var wasBeginning = swiper.isBeginning;
      var wasEnd = swiper.isEnd;

      if (position >= swiper.minTranslate()) { position = swiper.minTranslate(); }
      if (position <= swiper.maxTranslate()) { position = swiper.maxTranslate(); }

      swiper.setTransition(0);
      swiper.setTranslate(position);
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();

      if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
        swiper.updateSlidesClasses();
      }

      if (swiper.params.freeModeSticky) {
        clearTimeout(swiper.mousewheel.timeout);
        swiper.mousewheel.timeout = Utils.nextTick(function () {
          swiper.slideToClosest();
        }, 300);
      }
      // Emit event
      swiper.emit('scroll', e);

      // Stop autoplay
      if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) { swiper.stopAutoplay(); }
      // Return page scroll on edge positions
      if (position === swiper.minTranslate() || position === swiper.maxTranslate()) { return true; }
    }

    if (e.preventDefault) { e.preventDefault(); }
    else { e.returnValue = false; }
    return false;
  },
  enable: function enable() {
    var swiper = this;
    if (!Mousewheel.event) { return false; }
    if (swiper.mousewheel.enabled) { return false; }
    var target = swiper.$el;
    if (swiper.params.mousewheel.eventsTarged !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarged);
    }
    target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
    target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
    target.on(Mousewheel.event, swiper.mousewheel.handle);
    swiper.mousewheel.enabled = true;
    return true;
  },
  disable: function disable() {
    var swiper = this;
    if (!Mousewheel.event) { return false; }
    if (!swiper.mousewheel.enabled) { return false; }
    var target = swiper.$el;
    if (swiper.params.mousewheel.eventsTarged !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarged);
    }
    target.off(Mousewheel.event, swiper.mousewheel.handle);
    swiper.mousewheel.enabled = false;
    return true;
  },
};

var Mousewheel$1 = {
  name: 'mousewheel',
  params: {
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarged: 'container',
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      mousewheel: {
        enabled: false,
        enable: Mousewheel.enable.bind(swiper),
        disable: Mousewheel.disable.bind(swiper),
        handle: Mousewheel.handle.bind(swiper),
        handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
        handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
        lastScrollTime: Utils.now(),
      },
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.mousewheel.enabled) { swiper.mousewheel.enable(); }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.mousewheel.enabled) { swiper.mousewheel.disable(); }
    },
  },
};

var Navigation = {
  update: function update() {
    // Update Navigation Buttons
    var swiper = this;
    var params = swiper.params.navigation;

    if (swiper.params.loop) { return; }
    var ref = swiper.navigation;
    var $nextEl = ref.$nextEl;
    var $prevEl = ref.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        $prevEl.addClass(params.disabledClass);
      } else {
        $prevEl.removeClass(params.disabledClass);
      }
      $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        $nextEl.addClass(params.disabledClass);
      } else {
        $nextEl.removeClass(params.disabledClass);
      }
      $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.navigation;
    if (!(params.nextEl || params.prevEl)) { return; }

    var $nextEl;
    var $prevEl;
    if (params.nextEl) {
      $nextEl = $(params.nextEl);
      if (
        swiper.params.uniqueNavElements &&
        typeof params.nextEl === 'string' &&
        $nextEl.length > 1 &&
        swiper.$el.find(params.nextEl).length === 1
      ) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }
    if (params.prevEl) {
      $prevEl = $(params.prevEl);
      if (
        swiper.params.uniqueNavElements &&
        typeof params.prevEl === 'string' &&
        $prevEl.length > 1 &&
        swiper.$el.find(params.prevEl).length === 1
      ) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', function (e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop) { return; }
        swiper.slideNext();
      });
    }
    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', function (e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop) { return; }
        swiper.slidePrev();
      });
    }

    Utils.extend(swiper.navigation, {
      $nextEl: $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl: $prevEl,
      prevEl: $prevEl && $prevEl[0],
    });
  },
  destroy: function destroy() {
    var swiper = this;
    var ref = swiper.navigation;
    var $nextEl = ref.$nextEl;
    var $prevEl = ref.$prevEl;
    if ($nextEl && $nextEl.length) {
      $nextEl.off('click');
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }
    if ($prevEl && $prevEl.length) {
      $prevEl.off('click');
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  },
};

var Navigation$1 = {
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,

      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock',
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      navigation: {
        init: Navigation.init.bind(swiper),
        update: Navigation.update.bind(swiper),
        destroy: Navigation.destroy.bind(swiper),
      },
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge: function toEdge() {
      var swiper = this;
      swiper.navigation.update();
    },
    fromEdge: function fromEdge() {
      var swiper = this;
      swiper.navigation.update();
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.navigation.destroy();
    },
    click: function click(e) {
      var swiper = this;
      var ref = swiper.navigation;
      var $nextEl = ref.$nextEl;
      var $prevEl = ref.$prevEl;
      if (
        swiper.params.navigation.hideOnClick &&
        !$(e.target).is($prevEl) &&
        !$(e.target).is($nextEl)
      ) {
        if ($nextEl) { $nextEl.toggleClass(swiper.params.navigation.hiddenClass); }
        if ($prevEl) { $prevEl.toggleClass(swiper.params.navigation.hiddenClass); }
      }
    },
  },
};

var Pagination = {
  update: function update() {
    // Render || Update Pagination bullets/items
    var swiper = this;
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    // Current/Total
    var current;
    var total = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
      if (current > slidesLength - 1 - (swiper.loopedSlides * 2)) {
        current -= (slidesLength - (swiper.loopedSlides * 2));
      }
      if (current > total - 1) { current -= total; }
      if (current < 0 && swiper.params.paginationType !== 'bullets') { current = total + current; }
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    }
    // Types
    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex;
      var lastIndex;
      var midIndex;
      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', ((swiper.pagination.bulletSize * (params.dynamicMainBullets + 4)) + "px"));
        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += (current - swiper.previousIndex);
          if (swiper.pagination.dynamicBulletIndex > (params.dynamicMainBullets - 1)) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }
        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.removeClass(((params.bulletActiveClass) + " " + (params.bulletActiveClass) + "-next " + (params.bulletActiveClass) + "-next-next " + (params.bulletActiveClass) + "-prev " + (params.bulletActiveClass) + "-prev-prev " + (params.bulletActiveClass) + "-main"));
      if ($el.length > 1) {
        bullets.each(function (index, bullet) {
          var $bullet = $(bullet);
          var bulletIndex = $bullet.index();
          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(((params.bulletActiveClass) + "-main"));
            }
            if (bulletIndex === firstIndex) {
              $bullet
                .prev()
                .addClass(((params.bulletActiveClass) + "-prev"))
                .prev()
                .addClass(((params.bulletActiveClass) + "-prev-prev"));
            }
            if (bulletIndex === lastIndex) {
              $bullet
                .next()
                .addClass(((params.bulletActiveClass) + "-next"))
                .next()
                .addClass(((params.bulletActiveClass) + "-next-next"));
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        $bullet.addClass(params.bulletActiveClass);
        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);
          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(((params.bulletActiveClass) + "-main"));
          }
          $firstDisplayedBullet
            .prev()
            .addClass(((params.bulletActiveClass) + "-prev"))
            .prev()
            .addClass(((params.bulletActiveClass) + "-prev-prev"));
          $lastDisplayedBullet
            .next()
            .addClass(((params.bulletActiveClass) + "-next"))
            .next()
            .addClass(((params.bulletActiveClass) + "-next-next"));
        }
      }
      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (((swiper.pagination.bulletSize * dynamicBulletsLength) - (swiper.pagination.bulletSize)) / 2) - (midIndex * swiper.pagination.bulletSize);
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', (bulletsOffset + "px"));
      }
    }
    if (params.type === 'fraction') {
      $el.find(("." + (params.currentClass))).text(current + 1);
      $el.find(("." + (params.totalClass))).text(total);
    }
    if (params.type === 'progressbar') {
      var progressbarDirection;
      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }
      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;
      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }
      $el.find(("." + (params.progressbarFillClass))).transform(("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")")).transition(swiper.params.speed);
    }
    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', swiper, $el[0]);
    } else {
      swiper.emit('paginationUpdate', swiper, $el[0]);
    }
    $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
  },
  render: function render() {
    // Render Container
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

    var $el = swiper.pagination.$el;
    var paginationHTML = '';
    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - (swiper.loopedSlides * 2)) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += "<" + (params.bulletElement) + " class=\"" + (params.bulletClass) + "\"></" + (params.bulletElement) + ">";
        }
      }
      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(("." + (params.bulletClass)));
    }
    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML =
        "<span class=\"" + (params.currentClass) + "\"></span>" +
        ' / ' +
        "<span class=\"" + (params.totalClass) + "\"></span>";
      }
      $el.html(paginationHTML);
    }
    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = "<span class=\"" + (params.progressbarFillClass) + "\"></span>";
      }
      $el.html(paginationHTML);
    }
    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el) { return; }

    var $el = $(params.el);
    if ($el.length === 0) { return; }

    if (
      swiper.params.uniqueNavElements &&
      typeof params.el === 'string' &&
      $el.length > 1 &&
      swiper.$el.find(params.el).length === 1
    ) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass(("" + (params.modifierClass) + (params.type) + "-dynamic"));
      swiper.pagination.dynamicBulletIndex = 0;
      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }
    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', ("." + (params.bulletClass)), function onClick(e) {
        e.preventDefault();
        var index = $(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) { index += swiper.loopedSlides; }
        swiper.slideTo(index);
      });
    }

    Utils.extend(swiper.pagination, {
      $el: $el,
      el: $el[0],
    });
  },
  destroy: function destroy() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) { return; }
    var $el = swiper.pagination.$el;

    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) { swiper.pagination.bullets.removeClass(params.bulletActiveClass); }
    if (params.clickable) {
      $el.off('click', ("." + (params.bulletClass)));
    }
  },
};

var Pagination$1 = {
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-', // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable', // NEW
      lockClass: 'swiper-pagination-lock',
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      pagination: {
        init: Pagination.init.bind(swiper),
        render: Pagination.render.bind(swiper),
        update: Pagination.update.bind(swiper),
        destroy: Pagination.destroy.bind(swiper),
        dynamicBulletIndex: 0,
      },
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange: function activeIndexChange() {
      var swiper = this;
      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange: function snapIndexChange() {
      var swiper = this;
      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange: function slidesLengthChange() {
      var swiper = this;
      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange: function snapGridLengthChange() {
      var swiper = this;
      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.pagination.destroy();
    },
    click: function click(e) {
      var swiper = this;
      if (
        swiper.params.pagination.el &&
        swiper.params.pagination.hideOnClick &&
        swiper.pagination.$el.length > 0 &&
        !$(e.target).hasClass(swiper.params.pagination.bulletClass)
      ) {
        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    },
  },
};

var Scrollbar = {
  setTranslate: function setTranslate() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
    var scrollbar = swiper.scrollbar;
    var rtl = swiper.rtlTranslate;
    var progress = swiper.progress;
    var dragSize = scrollbar.dragSize;
    var trackSize = scrollbar.trackSize;
    var $dragEl = scrollbar.$dragEl;
    var $el = scrollbar.$el;
    var params = swiper.params.scrollbar;

    var newSize = dragSize;
    var newPos = (trackSize - dragSize) * progress;
    if (rtl) {
      newPos = -newPos;
      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }
    if (swiper.isHorizontal()) {
      if (Support.transforms3d) {
        $dragEl.transform(("translate3d(" + newPos + "px, 0, 0)"));
      } else {
        $dragEl.transform(("translateX(" + newPos + "px)"));
      }
      $dragEl[0].style.width = newSize + "px";
    } else {
      if (Support.transforms3d) {
        $dragEl.transform(("translate3d(0px, " + newPos + "px, 0)"));
      } else {
        $dragEl.transform(("translateY(" + newPos + "px)"));
      }
      $dragEl[0].style.height = newSize + "px";
    }
    if (params.hide) {
      clearTimeout(swiper.scrollbar.timeout);
      $el[0].style.opacity = 1;
      swiper.scrollbar.timeout = setTimeout(function () {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }
    swiper.scrollbar.$dragEl.transition(duration);
  },
  updateSize: function updateSize() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) { return; }

    var scrollbar = swiper.scrollbar;
    var $dragEl = scrollbar.$dragEl;
    var $el = scrollbar.$el;

    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

    var divider = swiper.size / swiper.virtualSize;
    var moveDivider = divider * (trackSize / swiper.size);
    var dragSize;
    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = dragSize + "px";
    } else {
      $dragEl[0].style.height = dragSize + "px";
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }
    if (swiper.params.scrollbarHide) {
      $el[0].style.opacity = 0;
    }
    Utils.extend(scrollbar, {
      trackSize: trackSize,
      divider: divider,
      moveDivider: moveDivider,
      dragSize: dragSize,
    });
    scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
  },
  setDragPosition: function setDragPosition(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar;
    var rtl = swiper.rtlTranslate;
    var $el = scrollbar.$el;
    var dragSize = scrollbar.dragSize;
    var trackSize = scrollbar.trackSize;

    var pointerPosition;
    if (swiper.isHorizontal()) {
      pointerPosition = ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX);
    } else {
      pointerPosition = ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY);
    }
    var positionRatio;
    positionRatio = ((pointerPosition) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    var position = swiper.minTranslate() + ((swiper.maxTranslate() - swiper.minTranslate()) * positionRatio);

    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  },
  onDragStart: function onDragStart(e) {
    var swiper = this;
    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar;
    var $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el;
    var $dragEl = scrollbar.$dragEl;
    swiper.scrollbar.isTouched = true;
    e.preventDefault();
    e.stopPropagation();

    $wrapperEl.transition(100);
    $dragEl.transition(100);
    scrollbar.setDragPosition(e);

    clearTimeout(swiper.scrollbar.dragTimeout);

    $el.transition(0);
    if (params.hide) {
      $el.css('opacity', 1);
    }
    swiper.emit('scrollbarDragStart', e);
  },
  onDragMove: function onDragMove(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar;
    var $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el;
    var $dragEl = scrollbar.$dragEl;

    if (!swiper.scrollbar.isTouched) { return; }
    if (e.preventDefault) { e.preventDefault(); }
    else { e.returnValue = false; }
    scrollbar.setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    swiper.emit('scrollbarDragMove', e);
  },
  onDragEnd: function onDragEnd(e) {
    var swiper = this;

    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar;
    var $el = scrollbar.$el;

    if (!swiper.scrollbar.isTouched) { return; }
    swiper.scrollbar.isTouched = false;
    if (params.hide) {
      clearTimeout(swiper.scrollbar.dragTimeout);
      swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }
    swiper.emit('scrollbarDragEnd', e);
    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  },
  enableDraggable: function enableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) { return; }
    var scrollbar = swiper.scrollbar;
    var touchEvents = swiper.touchEvents;
    var touchEventsDesktop = swiper.touchEventsDesktop;
    var params = swiper.params;
    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = Support.passiveListener && params.passiveListener ? { passive: false, capture: false } : false;
    var passiveListener = Support.passiveListener && params.passiveListener ? { passive: true, capture: false } : false;
    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      if (Support.touch) {
        target.addEventListener(touchEvents.start, swiper.scrollbar.onDragStart, activeListener);
        target.addEventListener(touchEvents.move, swiper.scrollbar.onDragMove, activeListener);
        target.addEventListener(touchEvents.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
        target.addEventListener('mousedown', swiper.scrollbar.onDragStart, activeListener);
        doc.addEventListener('mousemove', swiper.scrollbar.onDragMove, activeListener);
        doc.addEventListener('mouseup', swiper.scrollbar.onDragEnd, passiveListener);
      }
    }
  },
  disableDraggable: function disableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) { return; }
    var scrollbar = swiper.scrollbar;
    var touchEvents = swiper.touchEvents;
    var touchEventsDesktop = swiper.touchEventsDesktop;
    var params = swiper.params;
    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = Support.passiveListener && params.passiveListener ? { passive: false, capture: false } : false;
    var passiveListener = Support.passiveListener && params.passiveListener ? { passive: true, capture: false } : false;
    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      if (Support.touch) {
        target.removeEventListener(touchEvents.start, swiper.scrollbar.onDragStart, activeListener);
        target.removeEventListener(touchEvents.move, swiper.scrollbar.onDragMove, activeListener);
        target.removeEventListener(touchEvents.end, swiper.scrollbar.onDragEnd, passiveListener);
      }
      if ((params.simulateTouch && !Device.ios && !Device.android) || (params.simulateTouch && !Support.touch && Device.ios)) {
        target.removeEventListener('mousedown', swiper.scrollbar.onDragStart, activeListener);
        doc.removeEventListener('mousemove', swiper.scrollbar.onDragMove, activeListener);
        doc.removeEventListener('mouseup', swiper.scrollbar.onDragEnd, passiveListener);
      }
    }
  },
  init: function init() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) { return; }
    var scrollbar = swiper.scrollbar;
    var $swiperEl = swiper.$el;
    var params = swiper.params.scrollbar;

    var $el = $(params.el);
    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    var $dragEl = $el.find(("." + (swiper.params.scrollbar.dragClass)));
    if ($dragEl.length === 0) {
      $dragEl = $(("<div class=\"" + (swiper.params.scrollbar.dragClass) + "\"></div>"));
      $el.append($dragEl);
    }

    Utils.extend(scrollbar, {
      $el: $el,
      el: $el[0],
      $dragEl: $dragEl,
      dragEl: $dragEl[0],
    });

    if (params.draggable) {
      scrollbar.enableDraggable();
    }
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.scrollbar.disableDraggable();
  },
};

var Scrollbar$1 = {
  name: 'scrollbar',
  params: {
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag',
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      scrollbar: {
        init: Scrollbar.init.bind(swiper),
        destroy: Scrollbar.destroy.bind(swiper),
        updateSize: Scrollbar.updateSize.bind(swiper),
        setTranslate: Scrollbar.setTranslate.bind(swiper),
        setTransition: Scrollbar.setTransition.bind(swiper),
        enableDraggable: Scrollbar.enableDraggable.bind(swiper),
        disableDraggable: Scrollbar.disableDraggable.bind(swiper),
        setDragPosition: Scrollbar.setDragPosition.bind(swiper),
        onDragStart: Scrollbar.onDragStart.bind(swiper),
        onDragMove: Scrollbar.onDragMove.bind(swiper),
        onDragEnd: Scrollbar.onDragEnd.bind(swiper),
        isTouched: false,
        timeout: null,
        dragTimeout: null,
      },
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      swiper.scrollbar.init();
      swiper.scrollbar.updateSize();
      swiper.scrollbar.setTranslate();
    },
    update: function update() {
      var swiper = this;
      swiper.scrollbar.updateSize();
    },
    resize: function resize() {
      var swiper = this;
      swiper.scrollbar.updateSize();
    },
    observerUpdate: function observerUpdate() {
      var swiper = this;
      swiper.scrollbar.updateSize();
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      swiper.scrollbar.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      swiper.scrollbar.setTransition(duration);
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.scrollbar.destroy();
    },
  },
};

var Parallax = {
  setTransform: function setTransform(el, progress) {
    var swiper = this;
    var rtl = swiper.rtl;

    var $el = $(el);
    var rtlFactor = rtl ? -1 : 1;

    var p = $el.attr('data-swiper-parallax') || '0';
    var x = $el.attr('data-swiper-parallax-x');
    var y = $el.attr('data-swiper-parallax-y');
    var scale = $el.attr('data-swiper-parallax-scale');
    var opacity = $el.attr('data-swiper-parallax-opacity');

    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }

    if ((x).indexOf('%') >= 0) {
      x = (parseInt(x, 10) * progress * rtlFactor) + "%";
    } else {
      x = (x * progress * rtlFactor) + "px";
    }
    if ((y).indexOf('%') >= 0) {
      y = (parseInt(y, 10) * progress) + "%";
    } else {
      y = (y * progress) + "px";
    }

    if (typeof opacity !== 'undefined' && opacity !== null) {
      var currentOpacity = opacity - ((opacity - 1) * (1 - Math.abs(progress)));
      $el[0].style.opacity = currentOpacity;
    }
    if (typeof scale === 'undefined' || scale === null) {
      $el.transform(("translate3d(" + x + ", " + y + ", 0px)"));
    } else {
      var currentScale = scale - ((scale - 1) * (1 - Math.abs(progress)));
      $el.transform(("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")"));
    }
  },
  setTranslate: function setTranslate() {
    var swiper = this;
    var $el = swiper.$el;
    var slides = swiper.slides;
    var progress = swiper.progress;
    var snapGrid = swiper.snapGrid;
    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
      .each(function (index, el) {
        swiper.parallax.setTransform(el, progress);
      });
    slides.each(function (slideIndex, slideEl) {
      var slideProgress = slideEl.progress;
      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - (progress * (snapGrid.length - 1));
      }
      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
        .each(function (index, el) {
          swiper.parallax.setTransform(el, slideProgress);
        });
    });
  },
  setTransition: function setTransition(duration) {
    if ( duration === void 0 ) duration = this.params.speed;

    var swiper = this;
    var $el = swiper.$el;
    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]')
      .each(function (index, parallaxEl) {
        var $parallaxEl = $(parallaxEl);
        var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
        if (duration === 0) { parallaxDuration = 0; }
        $parallaxEl.transition(parallaxDuration);
      });
  },
};

var Parallax$1 = {
  name: 'parallax',
  params: {
    parallax: {
      enabled: false,
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      parallax: {
        setTransform: Parallax.setTransform.bind(swiper),
        setTranslate: Parallax.setTranslate.bind(swiper),
        setTransition: Parallax.setTransition.bind(swiper),
      },
    });
  },
  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (!swiper.params.parallax.enabled) { return; }
      swiper.params.watchSlidesProgress = true;
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.parallax) { return; }
      swiper.parallax.setTranslate();
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.parallax) { return; }
      swiper.parallax.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (!swiper.params.parallax) { return; }
      swiper.parallax.setTransition(duration);
    },
  },
};

var Zoom = {
  // Calc Scale From Multi-touches
  getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
    if (e.targetTouches.length < 2) { return 1; }
    var x1 = e.targetTouches[0].pageX;
    var y1 = e.targetTouches[0].pageY;
    var x2 = e.targetTouches[1].pageX;
    var y2 = e.targetTouches[1].pageY;
    var distance = Math.sqrt((Math.pow( (x2 - x1), 2 )) + (Math.pow( (y2 - y1), 2 )));
    return distance;
  },
  // Events
  onGestureStart: function onGestureStart(e) {
    var swiper = this;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;
    zoom.fakeGestureTouched = false;
    zoom.fakeGestureMoved = false;
    if (!Support.gestures) {
      if (e.type !== 'touchstart' || (e.type === 'touchstart' && e.targetTouches.length < 2)) {
        return;
      }
      zoom.fakeGestureTouched = true;
      gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
    }
    if (!gesture.$slideEl || !gesture.$slideEl.length) {
      gesture.$slideEl = $(e.target).closest('.swiper-slide');
      if (gesture.$slideEl.length === 0) { gesture.$slideEl = swiper.slides.eq(swiper.activeIndex); }
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
      gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      if (gesture.$imageWrapEl.length === 0) {
        gesture.$imageEl = undefined;
        return;
      }
    }
    gesture.$imageEl.transition(0);
    swiper.zoom.isScaling = true;
  },
  onGestureChange: function onGestureChange(e) {
    var swiper = this;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;
    if (!Support.gestures) {
      if (e.type !== 'touchmove' || (e.type === 'touchmove' && e.targetTouches.length < 2)) {
        return;
      }
      zoom.fakeGestureMoved = true;
      gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
    if (Support.gestures) {
      swiper.zoom.scale = e.scale * zoom.currentScale;
    } else {
      zoom.scale = (gesture.scaleMove / gesture.scaleStart) * zoom.currentScale;
    }
    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = (gesture.maxRatio - 1) + (Math.pow( ((zoom.scale - gesture.maxRatio) + 1), 0.5 ));
    }
    if (zoom.scale < params.minRatio) {
      zoom.scale = (params.minRatio + 1) - (Math.pow( ((params.minRatio - zoom.scale) + 1), 0.5 ));
    }
    gesture.$imageEl.transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
  },
  onGestureEnd: function onGestureEnd(e) {
    var swiper = this;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;
    if (!Support.gestures) {
      if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
        return;
      }
      if (e.type !== 'touchend' || (e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android)) {
        return;
      }
      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.$imageEl.transition(swiper.params.speed).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
    zoom.currentScale = zoom.scale;
    zoom.isScaling = false;
    if (zoom.scale === 1) { gesture.$slideEl = undefined; }
  },
  onTouchStart: function onTouchStart(e) {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;
    var image = zoom.image;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
    if (image.isTouched) { return; }
    if (Device.android) { e.preventDefault(); }
    image.isTouched = true;
    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  },
  onTouchMove: function onTouchMove(e) {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;
    var image = zoom.image;
    var velocity = zoom.velocity;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
    swiper.allowClick = false;
    if (!image.isTouched || !gesture.$slideEl) { return; }

    if (!image.isMoved) {
      image.width = gesture.$imageEl[0].offsetWidth;
      image.height = gesture.$imageEl[0].offsetHeight;
      image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
      image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
      gesture.$imageWrapEl.transition(0);
      if (swiper.rtl) {
        image.startX = -image.startX;
        image.startY = -image.startY;
      }
    }
    // Define if we need image drag
    var scaledWidth = image.width * zoom.scale;
    var scaledHeight = image.height * zoom.scale;

    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) { return; }

    image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
    image.maxX = -image.minX;
    image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
    image.maxY = -image.minY;

    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

    if (!image.isMoved && !zoom.isScaling) {
      if (
        swiper.isHorizontal() &&
        (
          (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x) ||
          (Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)
        )
      ) {
        image.isTouched = false;
        return;
      } else if (
        !swiper.isHorizontal() &&
        (
          (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y) ||
          (Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)
        )
      ) {
        image.isTouched = false;
        return;
      }
    }
    e.preventDefault();
    e.stopPropagation();

    image.isMoved = true;
    image.currentX = (image.touchesCurrent.x - image.touchesStart.x) + image.startX;
    image.currentY = (image.touchesCurrent.y - image.touchesStart.y) + image.startY;

    if (image.currentX < image.minX) {
      image.currentX = (image.minX + 1) - (Math.pow( ((image.minX - image.currentX) + 1), 0.8 ));
    }
    if (image.currentX > image.maxX) {
      image.currentX = (image.maxX - 1) + (Math.pow( ((image.currentX - image.maxX) + 1), 0.8 ));
    }

    if (image.currentY < image.minY) {
      image.currentY = (image.minY + 1) - (Math.pow( ((image.minY - image.currentY) + 1), 0.8 ));
    }
    if (image.currentY > image.maxY) {
      image.currentY = (image.maxY - 1) + (Math.pow( ((image.currentY - image.maxY) + 1), 0.8 ));
    }

    // Velocity
    if (!velocity.prevPositionX) { velocity.prevPositionX = image.touchesCurrent.x; }
    if (!velocity.prevPositionY) { velocity.prevPositionY = image.touchesCurrent.y; }
    if (!velocity.prevTime) { velocity.prevTime = Date.now(); }
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) { velocity.x = 0; }
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) { velocity.y = 0; }
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();

    gesture.$imageWrapEl.transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
  },
  onTouchEnd: function onTouchEnd() {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;
    var image = zoom.image;
    var velocity = zoom.velocity;
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }
    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }
    image.isTouched = false;
    image.isMoved = false;
    var momentumDurationX = 300;
    var momentumDurationY = 300;
    var momentumDistanceX = velocity.x * momentumDurationX;
    var newPositionX = image.currentX + momentumDistanceX;
    var momentumDistanceY = velocity.y * momentumDurationY;
    var newPositionY = image.currentY + momentumDistanceY;

    // Fix duration
    if (velocity.x !== 0) { momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x); }
    if (velocity.y !== 0) { momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y); }
    var momentumDuration = Math.max(momentumDurationX, momentumDurationY);

    image.currentX = newPositionX;
    image.currentY = newPositionY;

    // Define if we need image drag
    var scaledWidth = image.width * zoom.scale;
    var scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(((gesture.slideWidth / 2) - (scaledWidth / 2)), 0);
    image.maxX = -image.minX;
    image.minY = Math.min(((gesture.slideHeight / 2) - (scaledHeight / 2)), 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

    gesture.$imageWrapEl.transition(momentumDuration).transform(("translate3d(" + (image.currentX) + "px, " + (image.currentY) + "px,0)"));
  },
  onTransitionEnd: function onTransitionEnd() {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;
    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
      gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
      gesture.$imageWrapEl.transform('translate3d(0,0,0)');
      gesture.$slideEl = undefined;
      gesture.$imageEl = undefined;
      gesture.$imageWrapEl = undefined;

      zoom.scale = 1;
      zoom.currentScale = 1;
    }
  },
  // Toggle Zoom
  toggle: function toggle(e) {
    var swiper = this;
    var zoom = swiper.zoom;

    if (zoom.scale && zoom.scale !== 1) {
      // Zoom Out
      zoom.out();
    } else {
      // Zoom In
      zoom.in(e);
    }
  },
  in: function in$1(e) {
    var swiper = this;

    var zoom = swiper.zoom;
    var params = swiper.params.zoom;
    var gesture = zoom.gesture;
    var image = zoom.image;

    if (!gesture.$slideEl) {
      gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
      gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

    gesture.$slideEl.addClass(("" + (params.zoomedSlideClass)));

    var touchX;
    var touchY;
    var offsetX;
    var offsetY;
    var diffX;
    var diffY;
    var translateX;
    var translateY;
    var imageWidth;
    var imageHeight;
    var scaledWidth;
    var scaledHeight;
    var translateMinX;
    var translateMinY;
    var translateMaxX;
    var translateMaxY;
    var slideWidth;
    var slideHeight;

    if (typeof image.touchesStart.x === 'undefined' && e) {
      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }

    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    if (e) {
      slideWidth = gesture.$slideEl[0].offsetWidth;
      slideHeight = gesture.$slideEl[0].offsetHeight;
      offsetX = gesture.$slideEl.offset().left;
      offsetY = gesture.$slideEl.offset().top;
      diffX = (offsetX + (slideWidth / 2)) - touchX;
      diffY = (offsetY + (slideHeight / 2)) - touchY;

      imageWidth = gesture.$imageEl[0].offsetWidth;
      imageHeight = gesture.$imageEl[0].offsetHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;

      translateMinX = Math.min(((slideWidth / 2) - (scaledWidth / 2)), 0);
      translateMinY = Math.min(((slideHeight / 2) - (scaledHeight / 2)), 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;

      translateX = diffX * zoom.scale;
      translateY = diffY * zoom.scale;

      if (translateX < translateMinX) {
        translateX = translateMinX;
      }
      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }

      if (translateY < translateMinY) {
        translateY = translateMinY;
      }
      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }
    gesture.$imageWrapEl.transition(300).transform(("translate3d(" + translateX + "px, " + translateY + "px,0)"));
    gesture.$imageEl.transition(300).transform(("translate3d(0,0,0) scale(" + (zoom.scale) + ")"));
  },
  out: function out() {
    var swiper = this;

    var zoom = swiper.zoom;
    var params = swiper.params.zoom;
    var gesture = zoom.gesture;

    if (!gesture.$slideEl) {
      gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
      gesture.$imageWrapEl = gesture.$imageEl.parent(("." + (params.containerClass)));
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) { return; }

    zoom.scale = 1;
    zoom.currentScale = 1;
    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
    gesture.$slideEl.removeClass(("" + (params.zoomedSlideClass)));
    gesture.$slideEl = undefined;
  },
  // Attach/Detach Events
  enable: function enable() {
    var swiper = this;
    var zoom = swiper.zoom;
    if (zoom.enabled) { return; }
    zoom.enabled = true;

    var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

    // Scale image
    if (Support.gestures) {
      swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
    }

    // Move image
    swiper.$wrapperEl.on(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
  },
  disable: function disable() {
    var swiper = this;
    var zoom = swiper.zoom;
    if (!zoom.enabled) { return; }

    swiper.zoom.enabled = false;

    var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

    // Scale image
    if (Support.gestures) {
      swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
    }

    // Move image
    swiper.$wrapperEl.off(swiper.touchEvents.move, ("." + (swiper.params.zoom.containerClass)), zoom.onTouchMove);
  },
};

var Zoom$1 = {
  name: 'zoom',
  params: {
    zoom: {
      enabled: false,
      maxRatio: 3,
      minRatio: 1,
      toggle: true,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed',
    },
  },
  create: function create() {
    var swiper = this;
    var zoom = {
      enabled: false,
      scale: 1,
      currentScale: 1,
      isScaling: false,
      gesture: {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3,
      },
      image: {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {},
      },
      velocity: {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined,
      },
    };
    ('onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out').split(' ').forEach(function (methodName) {
      zoom[methodName] = Zoom[methodName].bind(swiper);
    });
    Utils.extend(swiper, {
      zoom: zoom,
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.zoom.enabled) {
        swiper.zoom.enable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.zoom.disable();
    },
    touchStart: function touchStart(e) {
      var swiper = this;
      if (!swiper.zoom.enabled) { return; }
      swiper.zoom.onTouchStart(e);
    },
    touchEnd: function touchEnd(e) {
      var swiper = this;
      if (!swiper.zoom.enabled) { return; }
      swiper.zoom.onTouchEnd(e);
    },
    doubleTap: function doubleTap(e) {
      var swiper = this;
      if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
        swiper.zoom.toggle(e);
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;
      if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
        swiper.zoom.onTransitionEnd();
      }
    },
  },
};

var Lazy = {
  loadInSlide: function loadInSlide(index, loadInDuplicate) {
    if ( loadInDuplicate === void 0 ) loadInDuplicate = true;

    var swiper = this;
    var params = swiper.params.lazy;
    if (typeof index === 'undefined') { return; }
    if (swiper.slides.length === 0) { return; }
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

    var $slideEl = isVirtual
      ? swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]"))
      : swiper.slides.eq(index);

    var $images = $slideEl.find(("." + (params.elementClass) + ":not(." + (params.loadedClass) + "):not(." + (params.loadingClass) + ")"));
    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
      $images = $images.add($slideEl[0]);
    }
    if ($images.length === 0) { return; }

    $images.each(function (imageIndex, imageEl) {
      var $imageEl = $(imageEl);
      $imageEl.addClass(params.loadingClass);

      var background = $imageEl.attr('data-background');
      var src = $imageEl.attr('data-src');
      var srcset = $imageEl.attr('data-srcset');
      var sizes = $imageEl.attr('data-sizes');

      swiper.loadImage($imageEl[0], (src || background), srcset, sizes, false, function () {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || (swiper && !swiper.params) || swiper.destroyed) { return; }
        if (background) {
          $imageEl.css('background-image', ("url(\"" + background + "\")"));
          $imageEl.removeAttr('data-background');
        } else {
          if (srcset) {
            $imageEl.attr('srcset', srcset);
            $imageEl.removeAttr('data-srcset');
          }
          if (sizes) {
            $imageEl.attr('sizes', sizes);
            $imageEl.removeAttr('data-sizes');
          }
          if (src) {
            $imageEl.attr('src', src);
            $imageEl.removeAttr('data-src');
          }
        }

        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
        $slideEl.find(("." + (params.preloaderClass))).remove();
        if (swiper.params.loop && loadInDuplicate) {
          var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
            var originalSlide = swiper.$wrapperEl.children(("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + (swiper.params.slideDuplicateClass) + ")"));
            swiper.lazy.loadInSlide(originalSlide.index(), false);
          } else {
            var duplicatedSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideDuplicateClass) + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]"));
            swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
          }
        }
        swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
      });

      swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
    });
  },
  load: function load() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl;
    var swiperParams = swiper.params;
    var slides = swiper.slides;
    var activeIndex = swiper.activeIndex;
    var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
    var params = swiperParams.lazy;

    var slidesPerView = swiperParams.slidesPerView;
    if (slidesPerView === 'auto') {
      slidesPerView = 0;
    }

    function slideExist(index) {
      if (isVirtual) {
        if ($wrapperEl.children(("." + (swiperParams.slideClass) + "[data-swiper-slide-index=\"" + index + "\"]")).length) {
          return true;
        }
      } else if (slides[index]) { return true; }
      return false;
    }
    function slideIndex(slideEl) {
      if (isVirtual) {
        return $(slideEl).attr('data-swiper-slide-index');
      }
      return $(slideEl).index();
    }

    if (!swiper.lazy.initialImageLoaded) { swiper.lazy.initialImageLoaded = true; }
    if (swiper.params.watchSlidesVisibility) {
      $wrapperEl.children(("." + (swiperParams.slideVisibleClass))).each(function (elIndex, slideEl) {
        var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
        swiper.lazy.loadInSlide(index);
      });
    } else if (slidesPerView > 1) {
      for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
        if (slideExist(i)) { swiper.lazy.loadInSlide(i); }
      }
    } else {
      swiper.lazy.loadInSlide(activeIndex);
    }
    if (params.loadPrevNext) {
      if (slidesPerView > 1 || (params.loadPrevNextAmount && params.loadPrevNextAmount > 1)) {
        var amount = params.loadPrevNextAmount;
        var spv = slidesPerView;
        var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
        var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
        // Next Slides
        for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
          if (slideExist(i$1)) { swiper.lazy.loadInSlide(i$1); }
        }
        // Prev Slides
        for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
          if (slideExist(i$2)) { swiper.lazy.loadInSlide(i$2); }
        }
      } else {
        var nextSlide = $wrapperEl.children(("." + (swiperParams.slideNextClass)));
        if (nextSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(nextSlide)); }

        var prevSlide = $wrapperEl.children(("." + (swiperParams.slidePrevClass)));
        if (prevSlide.length > 0) { swiper.lazy.loadInSlide(slideIndex(prevSlide)); }
      }
    }
  },
};

var Lazy$1 = {
  name: 'lazy',
  params: {
    lazy: {
      enabled: false,
      loadPrevNext: false,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: false,

      elementClass: 'swiper-lazy',
      loadingClass: 'swiper-lazy-loading',
      loadedClass: 'swiper-lazy-loaded',
      preloaderClass: 'swiper-lazy-preloader',
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      lazy: {
        initialImageLoaded: false,
        load: Lazy.load.bind(swiper),
        loadInSlide: Lazy.loadInSlide.bind(swiper),
      },
    });
  },
  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
        swiper.params.preloadImages = false;
      }
    },
    init: function init() {
      var swiper = this;
      if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
        swiper.lazy.load();
      }
    },
    scroll: function scroll() {
      var swiper = this;
      if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
        swiper.lazy.load();
      }
    },
    resize: function resize() {
      var swiper = this;
      if (swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    },
    scrollbarDragMove: function scrollbarDragMove() {
      var swiper = this;
      if (swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    },
    transitionStart: function transitionStart() {
      var swiper = this;
      if (swiper.params.lazy.enabled) {
        if (swiper.params.lazy.loadOnTransitionStart || (!swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded)) {
          swiper.lazy.load();
        }
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;
      if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
        swiper.lazy.load();
      }
    },
  },
};

/* eslint no-bitwise: ["error", { "allow": [">>"] }] */

var Controller = {
  LinearSpline: function LinearSpline(x, y) {
    var binarySearch = (function search() {
      var maxIndex;
      var minIndex;
      var guess;
      return function (array, val) {
        minIndex = -1;
        maxIndex = array.length;
        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;
          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }
        return maxIndex;
      };
    }());
    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1;
    // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.
    var i1;
    var i3;

    this.interpolate = function interpolate(x2) {
      if (!x2) { return 0; }

      // Get the indexes of x1 and x3 (the array indexes before and after given x2):
      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1;

      // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
      return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1])) + this.y[i1];
    };
    return this;
  },
  // xxx: for now i will just save one spline function to to
  getInterpolateFunction: function getInterpolateFunction(c) {
    var swiper = this;
    if (!swiper.controller.spline) {
      swiper.controller.spline = swiper.params.loop ?
        new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) :
        new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
    }
  },
  setTranslate: function setTranslate(setTranslate$1, byController) {
    var swiper = this;
    var controlled = swiper.controller.control;
    var multiplier;
    var controlledTranslate;
    function setControlledTranslate(c) {
      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
      if (swiper.params.controller.by === 'slide') {
        swiper.controller.getInterpolateFunction(c);
        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out
        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }

      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        controlledTranslate = ((translate - swiper.minTranslate()) * multiplier) + c.minTranslate();
      }

      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }
      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }
    if (Array.isArray(controlled)) {
      for (var i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  },
  setTransition: function setTransition(duration, byController) {
    var swiper = this;
    var controlled = swiper.controller.control;
    var i;
    function setControlledTransition(c) {
      c.setTransition(duration, swiper);
      if (duration !== 0) {
        c.transitionStart();
        c.$wrapperEl.transitionEnd(function () {
          if (!controlled) { return; }
          if (c.params.loop && swiper.params.controller.by === 'slide') {
            c.loopFix();
          }
          c.transitionEnd();
        });
      }
    }
    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  },
};
var Controller$1 = {
  name: 'controller',
  params: {
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide', // or 'container'
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      controller: {
        control: swiper.params.controller.control,
        getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
        setTranslate: Controller.setTranslate.bind(swiper),
        setTransition: Controller.setTransition.bind(swiper),
      },
    });
  },
  on: {
    update: function update() {
      var swiper = this;
      if (!swiper.controller.control) { return; }
      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    resize: function resize() {
      var swiper = this;
      if (!swiper.controller.control) { return; }
      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    observerUpdate: function observerUpdate() {
      var swiper = this;
      if (!swiper.controller.control) { return; }
      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    setTranslate: function setTranslate(translate, byController) {
      var swiper = this;
      if (!swiper.controller.control) { return; }
      swiper.controller.setTranslate(translate, byController);
    },
    setTransition: function setTransition(duration, byController) {
      var swiper = this;
      if (!swiper.controller.control) { return; }
      swiper.controller.setTransition(duration, byController);
    },
  },
};

var a11y = {
  makeElFocusable: function makeElFocusable($el) {
    $el.attr('tabIndex', '0');
    return $el;
  },
  addElRole: function addElRole($el, role) {
    $el.attr('role', role);
    return $el;
  },
  addElLabel: function addElLabel($el, label) {
    $el.attr('aria-label', label);
    return $el;
  },
  disableEl: function disableEl($el) {
    $el.attr('aria-disabled', true);
    return $el;
  },
  enableEl: function enableEl($el) {
    $el.attr('aria-disabled', false);
    return $el;
  },
  onEnterKey: function onEnterKey(e) {
    var swiper = this;
    var params = swiper.params.a11y;
    if (e.keyCode !== 13) { return; }
    var $targetEl = $(e.target);
    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }
      if (swiper.isEnd) {
        swiper.a11y.notify(params.lastSlideMessage);
      } else {
        swiper.a11y.notify(params.nextSlideMessage);
      }
    }
    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }
      if (swiper.isBeginning) {
        swiper.a11y.notify(params.firstSlideMessage);
      } else {
        swiper.a11y.notify(params.prevSlideMessage);
      }
    }
    if (swiper.pagination && $targetEl.is(("." + (swiper.params.pagination.bulletClass)))) {
      $targetEl[0].click();
    }
  },
  notify: function notify(message) {
    var swiper = this;
    var notification = swiper.a11y.liveRegion;
    if (notification.length === 0) { return; }
    notification.html('');
    notification.html(message);
  },
  updateNavigation: function updateNavigation() {
    var swiper = this;

    if (swiper.params.loop) { return; }
    var ref = swiper.navigation;
    var $nextEl = ref.$nextEl;
    var $prevEl = ref.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        swiper.a11y.disableEl($prevEl);
      } else {
        swiper.a11y.enableEl($prevEl);
      }
    }
    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        swiper.a11y.disableEl($nextEl);
      } else {
        swiper.a11y.enableEl($nextEl);
      }
    }
  },
  updatePagination: function updatePagination() {
    var swiper = this;
    var params = swiper.params.a11y;
    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
        var $bulletEl = $(bulletEl);
        swiper.a11y.makeElFocusable($bulletEl);
        swiper.a11y.addElRole($bulletEl, 'button');
        swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
      });
    }
  },
  init: function init() {
    var swiper = this;

    swiper.$el.append(swiper.a11y.liveRegion);

    // Navigation
    var params = swiper.params.a11y;
    var $nextEl;
    var $prevEl;
    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }
    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }
    if ($nextEl) {
      swiper.a11y.makeElFocusable($nextEl);
      swiper.a11y.addElRole($nextEl, 'button');
      swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
      $nextEl.on('keydown', swiper.a11y.onEnterKey);
    }
    if ($prevEl) {
      swiper.a11y.makeElFocusable($prevEl);
      swiper.a11y.addElRole($prevEl, 'button');
      swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
      $prevEl.on('keydown', swiper.a11y.onEnterKey);
    }

    // Pagination
    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.on('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) { swiper.a11y.liveRegion.remove(); }

    var $nextEl;
    var $prevEl;
    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }
    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }
    if ($nextEl) {
      $nextEl.off('keydown', swiper.a11y.onEnterKey);
    }
    if ($prevEl) {
      $prevEl.off('keydown', swiper.a11y.onEnterKey);
    }

    // Pagination
    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.off('keydown', ("." + (swiper.params.pagination.bulletClass)), swiper.a11y.onEnterKey);
    }
  },
};
var A11y = {
  name: 'a11y',
  params: {
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      a11y: {
        liveRegion: $(("<span class=\"" + (swiper.params.a11y.notificationClass) + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")),
      },
    });
    Object.keys(a11y).forEach(function (methodName) {
      swiper.a11y[methodName] = a11y[methodName].bind(swiper);
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) { return; }
      swiper.a11y.init();
      swiper.a11y.updateNavigation();
    },
    toEdge: function toEdge() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) { return; }
      swiper.a11y.updateNavigation();
    },
    fromEdge: function fromEdge() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) { return; }
      swiper.a11y.updateNavigation();
    },
    paginationUpdate: function paginationUpdate() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) { return; }
      swiper.a11y.updatePagination();
    },
    destroy: function destroy() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) { return; }
      swiper.a11y.destroy();
    },
  },
};

var History = {
  init: function init() {
    var swiper = this;
    if (!swiper.params.history) { return; }
    if (!win.history || !win.history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }
    var history = swiper.history;
    history.initialized = true;
    history.paths = History.getPathValues();
    if (!history.paths.key && !history.paths.value) { return; }
    history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
    if (!swiper.params.history.replaceState) {
      win.addEventListener('popstate', swiper.history.setHistoryPopState);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (!swiper.params.history.replaceState) {
      win.removeEventListener('popstate', swiper.history.setHistoryPopState);
    }
  },
  setHistoryPopState: function setHistoryPopState() {
    var swiper = this;
    swiper.history.paths = History.getPathValues();
    swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
  },
  getPathValues: function getPathValues() {
    var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) { return part !== ''; });
    var total = pathArray.length;
    var key = pathArray[total - 2];
    var value = pathArray[total - 1];
    return { key: key, value: value };
  },
  setHistory: function setHistory(key, index) {
    var swiper = this;
    if (!swiper.history.initialized || !swiper.params.history.enabled) { return; }
    var slide = swiper.slides.eq(index);
    var value = History.slugify(slide.attr('data-history'));
    if (!win.location.pathname.includes(key)) {
      value = key + "/" + value;
    }
    var currentState = win.history.state;
    if (currentState && currentState.value === value) {
      return;
    }
    if (swiper.params.history.replaceState) {
      win.history.replaceState({ value: value }, null, value);
    } else {
      win.history.pushState({ value: value }, null, value);
    }
  },
  slugify: function slugify(text) {
    return text.toString().toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w-]+/g, '')
      .replace(/--+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  },
  scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
    var swiper = this;
    if (value) {
      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
        var slide = swiper.slides.eq(i);
        var slideHistory = History.slugify(slide.attr('data-history'));
        if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          var index = slide.index();
          swiper.slideTo(index, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  },
};

var History$1 = {
  name: 'history',
  params: {
    history: {
      enabled: false,
      replaceState: false,
      key: 'slides',
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      history: {
        init: History.init.bind(swiper),
        setHistory: History.setHistory.bind(swiper),
        setHistoryPopState: History.setHistoryPopState.bind(swiper),
        scrollToSlide: History.scrollToSlide.bind(swiper),
        destroy: History.destroy.bind(swiper),
      },
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.history.enabled) {
        swiper.history.init();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.history.enabled) {
        swiper.history.destroy();
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;
      if (swiper.history.initialized) {
        swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
      }
    },
  },
};

var HashNavigation = {
  onHashCange: function onHashCange() {
    var swiper = this;
    var newHash = doc.location.hash.replace('#', '');
    var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
    if (newHash !== activeSlideHash) {
      swiper.slideTo(swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-hash=\"" + newHash + "\"]")).index());
    }
  },
  setHash: function setHash() {
    var swiper = this;
    if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) { return; }
    if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
      win.history.replaceState(null, null, (("#" + (swiper.slides.eq(swiper.activeIndex).attr('data-hash'))) || ''));
    } else {
      var slide = swiper.slides.eq(swiper.activeIndex);
      var hash = slide.attr('data-hash') || slide.attr('data-history');
      doc.location.hash = hash || '';
    }
  },
  init: function init() {
    var swiper = this;
    if (!swiper.params.hashNavigation.enabled || (swiper.params.history && swiper.params.history.enabled)) { return; }
    swiper.hashNavigation.initialized = true;
    var hash = doc.location.hash.replace('#', '');
    if (hash) {
      var speed = 0;
      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
        var slide = swiper.slides.eq(i);
        var slideHash = slide.attr('data-hash') || slide.attr('data-history');
        if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
          var index = slide.index();
          swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
        }
      }
    }
    if (swiper.params.hashNavigation.watchState) {
      $(win).on('hashchange', swiper.hashNavigation.onHashCange);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (swiper.params.hashNavigation.watchState) {
      $(win).off('hashchange', swiper.hashNavigation.onHashCange);
    }
  },
};
var HashNavigation$1 = {
  name: 'hash-navigation',
  params: {
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false,
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      hashNavigation: {
        initialized: false,
        init: HashNavigation.init.bind(swiper),
        destroy: HashNavigation.destroy.bind(swiper),
        setHash: HashNavigation.setHash.bind(swiper),
        onHashCange: HashNavigation.onHashCange.bind(swiper),
      },
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.hashNavigation.enabled) {
        swiper.hashNavigation.init();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.hashNavigation.enabled) {
        swiper.hashNavigation.destroy();
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;
      if (swiper.hashNavigation.initialized) {
        swiper.hashNavigation.setHash();
      }
    },
  },
};

var Autoplay = {
  run: function run() {
    var swiper = this;
    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    var delay = swiper.params.autoplay.delay;
    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }
    swiper.autoplay.timeout = Utils.nextTick(function () {
      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isBeginning) {
          swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.isEnd) {
        swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        swiper.slideTo(0, swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else {
        swiper.autoplay.stop();
      }
    }, delay);
  },
  start: function start() {
    var swiper = this;
    if (typeof swiper.autoplay.timeout !== 'undefined') { return false; }
    if (swiper.autoplay.running) { return false; }
    swiper.autoplay.running = true;
    swiper.emit('autoplayStart');
    swiper.autoplay.run();
    return true;
  },
  stop: function stop() {
    var swiper = this;
    if (!swiper.autoplay.running) { return false; }
    if (typeof swiper.autoplay.timeout === 'undefined') { return false; }

    if (swiper.autoplay.timeout) {
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = undefined;
    }
    swiper.autoplay.running = false;
    swiper.emit('autoplayStop');
    return true;
  },
  pause: function pause(speed) {
    var swiper = this;
    if (!swiper.autoplay.running) { return; }
    if (swiper.autoplay.paused) { return; }
    if (swiper.autoplay.timeout) { clearTimeout(swiper.autoplay.timeout); }
    swiper.autoplay.paused = true;
    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      swiper.autoplay.run();
    } else {
      swiper.$wrapperEl.transitionEnd(function () {
        if (!swiper || swiper.destroyed) { return; }
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) {
          swiper.autoplay.stop();
        } else {
          swiper.autoplay.run();
        }
      });
    }
  },
};

var Autoplay$1 = {
  name: 'autoplay',
  params: {
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false,
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      autoplay: {
        running: false,
        paused: false,
        run: Autoplay.run.bind(swiper),
        start: Autoplay.start.bind(swiper),
        stop: Autoplay.stop.bind(swiper),
        pause: Autoplay.pause.bind(swiper),
      },
    });
  },
  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.autoplay.enabled) {
        swiper.autoplay.start();
      }
    },
    beforeTransitionStart: function beforeTransitionStart(speed, internal) {
      var swiper = this;
      if (swiper.autoplay.running) {
        if (internal || !swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.pause(speed);
        } else {
          swiper.autoplay.stop();
        }
      }
    },
    sliderFirstMove: function sliderFirstMove() {
      var swiper = this;
      if (swiper.autoplay.running) {
        if (swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.stop();
        } else {
          swiper.autoplay.pause();
        }
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
    },
  },
};

var Fade = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var slides = swiper.slides;
    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = swiper.slides.eq(i);
      var offset = $slideEl[0].swiperSlideOffset;
      var tx = -offset;
      if (!swiper.params.virtualTranslate) { tx -= swiper.translate; }
      var ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }
      var slideOpacity = swiper.params.fadeEffect.crossFade ?
        Math.max(1 - Math.abs($slideEl[0].progress), 0) :
        1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
      $slideEl
        .css({
          opacity: slideOpacity,
        })
        .transform(("translate3d(" + tx + "px, " + ty + "px, 0px)"));
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var slides = swiper.slides;
    var $wrapperEl = swiper.$wrapperEl;
    slides.transition(duration);
    if (swiper.params.virtualTranslate && duration !== 0) {
      var eventTriggered = false;
      slides.transitionEnd(function () {
        if (eventTriggered) { return; }
        if (!swiper || swiper.destroyed) { return; }
        eventTriggered = true;
        swiper.animating = false;
        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
        for (var i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  },
};

var EffectFade = {
  name: 'effect-fade',
  params: {
    fadeEffect: {
      crossFade: false,
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      fadeEffect: {
        setTranslate: Fade.setTranslate.bind(swiper),
        setTransition: Fade.setTransition.bind(swiper),
      },
    });
  },
  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'fade') { return; }
      swiper.classNames.push(((swiper.params.containerModifierClass) + "fade"));
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true,
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'fade') { return; }
      swiper.fadeEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'fade') { return; }
      swiper.fadeEffect.setTransition(duration);
    },
  },
};

var Cube = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var $el = swiper.$el;
    var $wrapperEl = swiper.$wrapperEl;
    var slides = swiper.slides;
    var swiperWidth = swiper.width;
    var swiperHeight = swiper.height;
    var rtl = swiper.rtlTranslate;
    var swiperSize = swiper.size;
    var params = swiper.params.cubeEffect;
    var isHorizontal = swiper.isHorizontal();
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var wrapperRotate = 0;
    var $cubeShadowEl;
    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
          $wrapperEl.append($cubeShadowEl);
        }
        $cubeShadowEl.css({ height: (swiperWidth + "px") });
      } else {
        $cubeShadowEl = $el.find('.swiper-cube-shadow');
        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
          $el.append($cubeShadowEl);
        }
      }
    }
    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = slides.eq(i);
      var slideIndex = i;
      if (isVirtual) {
        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
      }
      var slideAngle = slideIndex * 90;
      var round = Math.floor(slideAngle / 360);
      if (rtl) {
        slideAngle = -slideAngle;
        round = Math.floor(-slideAngle / 360);
      }
      var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      var tx = 0;
      var ty = 0;
      var tz = 0;
      if (slideIndex % 4 === 0) {
        tx = -round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + (round * 4 * swiperSize);
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = (3 * swiperSize) + (swiperSize * 4 * round);
      }
      if (rtl) {
        tx = -tx;
      }

      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }

      var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
      if (progress <= 1 && progress > -1) {
        wrapperRotate = (slideIndex * 90) + (progress * 90);
        if (rtl) { wrapperRotate = (-slideIndex * 90) - (progress * 90); }
      }
      $slideEl.transform(transform);
      if (params.slideShadows) {
        // Set shadows
        var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
          shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
          $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
          shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
          $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
        if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
      }
    }
    $wrapperEl.css({
      '-webkit-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
      '-moz-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
      '-ms-transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
      'transform-origin': ("50% 50% -" + (swiperSize / 2) + "px"),
    });

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl.transform(("translate3d(0px, " + ((swiperWidth / 2) + params.shadowOffset) + "px, " + (-swiperWidth / 2) + "px) rotateX(90deg) rotateZ(0deg) scale(" + (params.shadowScale) + ")"));
      } else {
        var shadowAngle = Math.abs(wrapperRotate) - (Math.floor(Math.abs(wrapperRotate) / 90) * 90);
        var multiplier = 1.5 - (
          (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2) +
          (Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2)
        );
        var scale1 = params.shadowScale;
        var scale2 = params.shadowScale / multiplier;
        var offset = params.shadowOffset;
        $cubeShadowEl.transform(("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + ((swiperHeight / 2) + offset) + "px, " + (-swiperHeight / 2 / scale2) + "px) rotateX(-90deg)"));
      }
    }
    var zFactor = (Browser.isSafari || Browser.isUiWebView) ? (-swiperSize / 2) : 0;
    $wrapperEl
      .transform(("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)"));
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var $el = swiper.$el;
    var slides = swiper.slides;
    slides
      .transition(duration)
      .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
      .transition(duration);
    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      $el.find('.swiper-cube-shadow').transition(duration);
    }
  },
};

var EffectCube = {
  name: 'effect-cube',
  params: {
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94,
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      cubeEffect: {
        setTranslate: Cube.setTranslate.bind(swiper),
        setTransition: Cube.setTransition.bind(swiper),
      },
    });
  },
  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'cube') { return; }
      swiper.classNames.push(((swiper.params.containerModifierClass) + "cube"));
      swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        resistanceRatio: 0,
        spaceBetween: 0,
        centeredSlides: false,
        virtualTranslate: true,
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'cube') { return; }
      swiper.cubeEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'cube') { return; }
      swiper.cubeEffect.setTransition(duration);
    },
  },
};

var Flip = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var slides = swiper.slides;
    var rtl = swiper.rtlTranslate;
    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = slides.eq(i);
      var progress = $slideEl[0].progress;
      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      }
      var offset = $slideEl[0].swiperSlideOffset;
      var rotate = -180 * progress;
      var rotateY = rotate;
      var rotateX = 0;
      var tx = -offset;
      var ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

      if (swiper.params.flipEffect.slideShadows) {
        // Set shadows
        var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
          shadowBefore = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>"));
          $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
          shadowAfter = $(("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>"));
          $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) { shadowBefore[0].style.opacity = Math.max(-progress, 0); }
        if (shadowAfter.length) { shadowAfter[0].style.opacity = Math.max(progress, 0); }
      }
      $slideEl
        .transform(("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)"));
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var slides = swiper.slides;
    var activeIndex = swiper.activeIndex;
    var $wrapperEl = swiper.$wrapperEl;
    slides
      .transition(duration)
      .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
      .transition(duration);
    if (swiper.params.virtualTranslate && duration !== 0) {
      var eventTriggered = false;
      // eslint-disable-next-line
      slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
        if (eventTriggered) { return; }
        if (!swiper || swiper.destroyed) { return; }
        // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
        eventTriggered = true;
        swiper.animating = false;
        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
        for (var i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  },
};

var EffectFlip = {
  name: 'effect-flip',
  params: {
    flipEffect: {
      slideShadows: true,
      limitRotation: true,
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      flipEffect: {
        setTranslate: Flip.setTranslate.bind(swiper),
        setTransition: Flip.setTransition.bind(swiper),
      },
    });
  },
  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'flip') { return; }
      swiper.classNames.push(((swiper.params.containerModifierClass) + "flip"));
      swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true,
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'flip') { return; }
      swiper.flipEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'flip') { return; }
      swiper.flipEffect.setTransition(duration);
    },
  },
};

var Coverflow = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var swiperWidth = swiper.width;
    var swiperHeight = swiper.height;
    var slides = swiper.slides;
    var $wrapperEl = swiper.$wrapperEl;
    var slidesSizesGrid = swiper.slidesSizesGrid;
    var params = swiper.params.coverflowEffect;
    var isHorizontal = swiper.isHorizontal();
    var transform = swiper.translate;
    var center = isHorizontal ? -transform + (swiperWidth / 2) : -transform + (swiperHeight / 2);
    var rotate = isHorizontal ? params.rotate : -params.rotate;
    var translate = params.depth;
    // Each slide offset from center
    for (var i = 0, length = slides.length; i < length; i += 1) {
      var $slideEl = slides.eq(i);
      var slideSize = slidesSizesGrid[i];
      var slideOffset = $slideEl[0].swiperSlideOffset;
      var offsetMultiplier = ((center - slideOffset - (slideSize / 2)) / slideSize) * params.modifier;

      var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
      // var rotateZ = 0
      var translateZ = -translate * Math.abs(offsetMultiplier);

      var translateY = isHorizontal ? 0 : params.stretch * (offsetMultiplier);
      var translateX = isHorizontal ? params.stretch * (offsetMultiplier) : 0;

      // Fix for ultra small values
      if (Math.abs(translateX) < 0.001) { translateX = 0; }
      if (Math.abs(translateY) < 0.001) { translateY = 0; }
      if (Math.abs(translateZ) < 0.001) { translateZ = 0; }
      if (Math.abs(rotateY) < 0.001) { rotateY = 0; }
      if (Math.abs(rotateX) < 0.001) { rotateX = 0; }

      var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";

      $slideEl.transform(slideTransform);
      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
      if (params.slideShadows) {
        // Set shadows
        var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if ($shadowBeforeEl.length === 0) {
          $shadowBeforeEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>"));
          $slideEl.append($shadowBeforeEl);
        }
        if ($shadowAfterEl.length === 0) {
          $shadowAfterEl = $(("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>"));
          $slideEl.append($shadowAfterEl);
        }
        if ($shadowBeforeEl.length) { $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0; }
        if ($shadowAfterEl.length) { $shadowAfterEl[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0; }
      }
    }

    // Set correct perspective for IE10
    if (Support.pointerEvents || Support.prefixedPointerEvents) {
      var ws = $wrapperEl[0].style;
      ws.perspectiveOrigin = center + "px 50%";
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    swiper.slides
      .transition(duration)
      .find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
      .transition(duration);
  },
};

var EffectCoverflow = {
  name: 'effect-coverflow',
  params: {
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true,
    },
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      coverflowEffect: {
        setTranslate: Coverflow.setTranslate.bind(swiper),
        setTransition: Coverflow.setTransition.bind(swiper),
      },
    });
  },
  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'coverflow') { return; }

      swiper.classNames.push(((swiper.params.containerModifierClass) + "coverflow"));
      swiper.classNames.push(((swiper.params.containerModifierClass) + "3d"));

      swiper.params.watchSlidesProgress = true;
      swiper.originalParams.watchSlidesProgress = true;
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'coverflow') { return; }
      swiper.coverflowEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'coverflow') { return; }
      swiper.coverflowEffect.setTransition(duration);
    },
  },
};

// Swiper Class

var components = [
  Device$1,
  Support$1,
  Browser$1,
  Resize,
  Observer$1,
  Virtual$1,
  Keyboard$1,
  Mousewheel$1,
  Navigation$1,
  Pagination$1,
  Scrollbar$1,
  Parallax$1,
  Zoom$1,
  Lazy$1,
  Controller$1,
  A11y,
  History$1,
  HashNavigation$1,
  Autoplay$1,
  EffectFade,
  EffectCube,
  EffectFlip,
  EffectCoverflow
];

if (typeof Swiper.use === 'undefined') {
  Swiper.use = Swiper.Class.use;
  Swiper.installModule = Swiper.Class.installModule;
}

Swiper.use(components);

return Swiper;

})));


/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ScrollableList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_List__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_teachers_PlaceholderCard__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_teachers_messages_Message__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_teachers_messages_ReplyInput__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_LoadingThrobber__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_debounce__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_debounce__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LOAD_MESSAGE_DEBOUNCE_DELAY=1500;var SchoolMessageList=function(_React$Component){_inherits(SchoolMessageList,_React$Component);function SchoolMessageList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SchoolMessageList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SchoolMessageList.__proto__||Object.getPrototypeOf(SchoolMessageList)).call.apply(_ref,[this].concat(args))),_this),_this.state={messagesLimit:15,initialMessages:_this.props.messageIDList,alignToBottom:true,loadingMessages:false},_this.refReplyInput=function(element){_this.props.refReplyInput(_this.props.schoolID,element);},_this.addNewMessages=__WEBPACK_IMPORTED_MODULE_10_debounce___default()(function(){_this.setState({loadingMessages:false,alignToBottom:false,messagesLimit:_this.state.messagesLimit+10});},LOAD_MESSAGE_DEBOUNCE_DELAY),_this.loadMoreMessages=function(){if(_this.state.loadingMessages===true||_this.state.messagesLimit>=_this.state.initialMessages.size){return;}_this.setState({loadingMessages:true});_this.addNewMessages();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SchoolMessageList,[{key:"render",value:function render(){var _props=this.props,messageIDList=_props.messageIDList,school=_props.school,schoolID=_props.schoolID,goToMessageID=_props.goToMessageID;var repliesEnabled=school.repliesEnabled;var placeholder=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_teachers_PlaceholderCard__["a" /* default */],{school:school,objectName:"messages"});var messagesCount=this.state.messagesLimit;var loadingMessages=this.state.loadingMessages;var filteredMessageIDList=messageIDList.map(function(messageID,index){if(index<messagesCount){return messageID;}return undefined;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ScrollableList__["a" /* default */],{className:"message-list",onScroll:this.props.clearGoTo,scrollTargetID:goToMessageID,alignToBottom:this.state.alignToBottom,infiniteScroll:true,loadMore:this.loadMoreMessages},function(refChild){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_List__["a" /* default */],{className:"message-list__inner",placeholder:placeholder,reversed:true},filteredMessageIDList.map(function(messageID){return messageID!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_teachers_messages_Message__["a" /* default */],{key:messageID,messageID:messageID,innerRef:function innerRef(child){return refChild(child,messageID);}}):null;}),loadingMessages?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_LoadingThrobber__["a" /* default */],null):null);}),repliesEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_teachers_messages_ReplyInput__["a" /* default */],{schoolID:schoolID,refInput:this.refReplyInput}):null);}}]);return SchoolMessageList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref2){var schoolID=_ref2.schoolID;return{messageIDList:Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["n" /* getSchoolMessageIDList */])(state,schoolID),school:Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["j" /* getSchoolByID */])(state,schoolID),goToMessageID:Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["b" /* getGoToMessageID */])(state)};},{clearGoTo:__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["A" /* clearGoToMessage */]})(SchoolMessageList));

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserInfo = /** @class */ (function () {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
    }
    return BrowserInfo;
}());
exports.BrowserInfo = BrowserInfo;
var NodeInfo = /** @class */ (function () {
    function NodeInfo(version) {
        this.version = version;
        this.name = 'node';
        this.os = process.platform;
    }
    return NodeInfo;
}());
exports.NodeInfo = NodeInfo;
var BotInfo = /** @class */ (function () {
    function BotInfo() {
        this.bot = true; // NOTE: deprecated test name instead
        this.name = 'bot';
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}());
exports.BotInfo = BotInfo;
// tslint:disable-next-line:max-line-length
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [
    ['aol', /AOLShield\/([0-9\._]+)/],
    ['edge', /Edge\/([0-9\._]+)/],
    ['yandexbrowser', /YaBrowser\/([0-9\._]+)/],
    ['vivaldi', /Vivaldi\/([0-9\.]+)/],
    ['kakaotalk', /KAKAOTALK\s([0-9\.]+)/],
    ['samsung', /SamsungBrowser\/([0-9\.]+)/],
    ['silk', /\bSilk\/([0-9._-]+)\b/],
    ['miui', /MiuiBrowser\/([0-9\.]+)$/],
    ['beaker', /BeakerBrowser\/([0-9\.]+)/],
    ['edge-chromium', /Edg\/([0-9\.]+)/],
    [
        'chromium-webview',
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/,
    ],
    ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
    ['phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/],
    ['crios', /CriOS\/([0-9\.]+)(:?\s|$)/],
    ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/],
    ['fxios', /FxiOS\/([0-9\.]+)/],
    ['opera-mini', /Opera Mini.*Version\/([0-9\.]+)/],
    ['opera', /Opera\/([0-9\.]+)(?:\s|$)/],
    ['opera', /OPR\/([0-9\.]+)(:?\s|$)/],
    ['ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
    ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
    ['ie', /MSIE\s(7\.0)/],
    ['bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/],
    ['android', /Android\s([0-9\.]+)/],
    ['ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/],
    ['safari', /Version\/([0-9\._]+).*Safari/],
    ['facebook', /FBAV\/([0-9\.]+)/],
    ['instagram', /Instagram\s([0-9\.]+)/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
    ['searchbot', SEARCHBOX_UA_REGEX],
];
var operatingSystemRules = [
    ['iOS', /iP(hone|od|ad)/],
    ['Android OS', /Android/],
    ['BlackBerry OS', /BlackBerry|BB10/],
    ['Windows Mobile', /IEMobile/],
    ['Amazon OS', /Kindle/],
    ['Windows 3.11', /Win16/],
    ['Windows 95', /(Windows 95)|(Win95)|(Windows_95)/],
    ['Windows 98', /(Windows 98)|(Win98)/],
    ['Windows 2000', /(Windows NT 5.0)|(Windows 2000)/],
    ['Windows XP', /(Windows NT 5.1)|(Windows XP)/],
    ['Windows Server 2003', /(Windows NT 5.2)/],
    ['Windows Vista', /(Windows NT 6.0)/],
    ['Windows 7', /(Windows NT 6.1)/],
    ['Windows 8', /(Windows NT 6.2)/],
    ['Windows 8.1', /(Windows NT 6.3)/],
    ['Windows 10', /(Windows NT 10.0)/],
    ['Windows ME', /Windows ME/],
    ['Open BSD', /OpenBSD/],
    ['Sun OS', /SunOS/],
    ['Chrome OS', /CrOS/],
    ['Linux', /(Linux)|(X11)/],
    ['Mac OS', /(Mac_PowerPC)|(Macintosh)/],
    ['QNX', /QNX/],
    ['BeOS', /BeOS/],
    ['OS/2', /OS\/2/],
    ['Search Bot', SEARCHBOT_OS_REGEX],
];
function detect(userAgent) {
    if (!!userAgent) {
        return parseUserAgent(userAgent);
    }
    if (typeof navigator !== 'undefined') {
        return parseUserAgent(navigator.userAgent);
    }
    return getNodeVersion();
}
exports.detect = detect;
function parseUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    var matchedRule = ua !== '' &&
        userAgentRules.reduce(function (matched, _a) {
            var browser = _a[0], regex = _a[1];
            if (matched) {
                return matched;
            }
            var uaMatch = regex.exec(ua);
            return !!uaMatch && [browser, uaMatch];
        }, false);
    if (!matchedRule) {
        return null;
    }
    var name = matchedRule[0], match = matchedRule[1];
    if (name === 'searchbot') {
        return new BotInfo();
    }
    var versionParts = match[1] && match[1].split(/[._]/).slice(0, 3);
    if (versionParts) {
        if (versionParts.length < REQUIRED_VERSION_PARTS) {
            versionParts = __spreadArrays(versionParts, createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length));
        }
    }
    else {
        versionParts = [];
    }
    return new BrowserInfo(name, versionParts.join('.'), detectOS(ua));
}
exports.parseUserAgent = parseUserAgent;
function detectOS(ua) {
    for (var ii = 0, count = operatingSystemRules.length; ii < count; ii++) {
        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.test(ua);
        if (match) {
            return os;
        }
    }
    return null;
}
exports.detectOS = detectOS;
function getNodeVersion() {
    var isNode = typeof process !== 'undefined' && process.version;
    return isNode ? new NodeInfo(process.version.slice(1)) : null;
}
exports.getNodeVersion = getNodeVersion;
function createVersionParts(count) {
    var output = [];
    for (var ii = 0; ii < count; ii++) {
        output.push('0');
    }
    return output;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(97)))

/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_linkify__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_linkify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_linkify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_format__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Highlight__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_LiveDate__ = __webpack_require__(189);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Map statuses to the text that should be displayed
var statusTexts={sending:"Message sending...",failed:"Message failed. Tap to retry.",sent:"Message sent"};var Message=function(_Component){_inherits(Message,_Component);function Message(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Message);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Message.__proto__||Object.getPrototypeOf(Message)).call.apply(_ref,[this].concat(args))),_this),_this.linkifyProperties={onClick:function onClick(clickEvent){_this.props.openURL(clickEvent.target.href);clickEvent.preventDefault();}/**
   * onClick handler for failed messages
   */},_this.retryFailedMessage=function(){_this.props.retryPendingReply(_this.props.message.get("id"));},_this.getFormattedBody=function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_linkify___default.a,{properties:_this.linkifyProperties},Object(__WEBPACK_IMPORTED_MODULE_4_lib_format__["c" /* nl2br */])(_this.props.message.get("body")));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Message,[{key:"render",value:function render(){var _props=this.props,message=_props.message,isHighlighted=_props.isHighlighted;var _message$toObject=message.toObject(),pending=_message$toObject.pending,sentDate=_message$toObject.sentDate,sender=_message$toObject.sender,unread=_message$toObject.unread,timezoneOffset=_message$toObject.timezoneOffset,status=_message$toObject.status;var classNames=["message"];// Result will be different for pending vs normal messages
if(pending){classNames.push("message--sent-by-parent");classNames.push("message--"+status);// Failed messages should retry on click
var onClick=null;if(status==="failed"){onClick=this.retryFailedMessage;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message__header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message__status"},statusTexts[status])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message__body",onClick:onClick},this.getFormattedBody()));}else{classNames.push("message--sent-by-"+sender);if(unread){classNames.push("message--unread");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" "),ref:this.props.innerRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message__header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message__sent-date"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_LiveDate__["a" /* default */],{date:sentDate,timezoneOffset:timezoneOffset})),unread?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message__unread-indicator"},"New!"):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Highlight__["a" /* default */],{cssModifier:"teachers",isHighlighted:isHighlighted},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"message__body"},this.getFormattedBody())));}}}]);return Message;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state,_ref2){var messageID=_ref2.messageID;return{message:Object(__WEBPACK_IMPORTED_MODULE_5_state_teachers_selectors__["f" /* getMessageByID */])(state,messageID),isHighlighted:Object(__WEBPACK_IMPORTED_MODULE_5_state_teachers_selectors__["b" /* getGoToMessageID */])(state)===messageID};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])({retryPendingReply:__WEBPACK_IMPORTED_MODULE_6_state_teachers_actions__["S" /* retryPendingReply */],openURL:__WEBPACK_IMPORTED_MODULE_7_state_app_actions__["R" /* openURL */]},dispatch);})(Message));

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



////////////////////////////////////////////////////////////////////////////////
// Helpers

// Merge objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) { return; }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

function _class(obj) { return Object.prototype.toString.call(obj); }
function isString(obj) { return _class(obj) === '[object String]'; }
function isObject(obj) { return _class(obj) === '[object Object]'; }
function isRegExp(obj) { return _class(obj) === '[object RegExp]'; }
function isFunction(obj) { return _class(obj) === '[object Function]'; }


function escapeRE(str) { return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&'); }

////////////////////////////////////////////////////////////////////////////////


var defaultOptions = {
  fuzzyLink: true,
  fuzzyEmail: true,
  fuzzyIP: false
};


function isOptionsObj(obj) {
  return Object.keys(obj || {}).reduce(function (acc, k) {
    return acc || defaultOptions.hasOwnProperty(k);
  }, false);
}


var defaultSchemas = {
  'http:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.http) {
        // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.http =  new RegExp(
          '^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i'
        );
      }
      if (self.re.http.test(tail)) {
        return tail.match(self.re.http)[0].length;
      }
      return 0;
    }
  },
  'https:':  'http:',
  'ftp:':    'http:',
  '//':      {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.no_http) {
      // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.no_http =  new RegExp(
          '^' +
          self.re.src_auth +
          // Don't allow single-level domains, because of false positives like '//test'
          // with code comments
          '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' +
          self.re.src_port +
          self.re.src_host_terminator +
          self.re.src_path,

          'i'
        );
      }

      if (self.re.no_http.test(tail)) {
        // should not be `://` & `///`, that protects from errors in protocol name
        if (pos >= 3 && text[pos - 3] === ':') { return 0; }
        if (pos >= 3 && text[pos - 3] === '/') { return 0; }
        return tail.match(self.re.no_http)[0].length;
      }
      return 0;
    }
  },
  'mailto:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.mailto) {
        self.re.mailto =  new RegExp(
          '^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i'
        );
      }
      if (self.re.mailto.test(tail)) {
        return tail.match(self.re.mailto)[0].length;
      }
      return 0;
    }
  }
};

/*eslint-disable max-len*/

// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';

// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var tlds_default = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');

/*eslint-enable max-len*/

////////////////////////////////////////////////////////////////////////////////

function resetScanCache(self) {
  self.__index__ = -1;
  self.__text_cache__   = '';
}

function createValidator(re) {
  return function (text, pos) {
    var tail = text.slice(pos);

    if (re.test(tail)) {
      return tail.match(re)[0].length;
    }
    return 0;
  };
}

function createNormalizer() {
  return function (match, self) {
    self.normalize(match);
  };
}

// Schemas compiler. Build regexps.
//
function compile(self) {

  // Load & clone RE patterns.
  var re = self.re = __webpack_require__(546)(self.__opts__);

  // Define dynamic patterns
  var tlds = self.__tlds__.slice();

  self.onCompile();

  if (!self.__tlds_replaced__) {
    tlds.push(tlds_2ch_src_re);
  }
  tlds.push(re.src_xn);

  re.src_tlds = tlds.join('|');

  function untpl(tpl) { return tpl.replace('%TLDS%', re.src_tlds); }

  re.email_fuzzy      = RegExp(untpl(re.tpl_email_fuzzy), 'i');
  re.link_fuzzy       = RegExp(untpl(re.tpl_link_fuzzy), 'i');
  re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
  re.host_fuzzy_test  = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');

  //
  // Compile each schema
  //

  var aliases = [];

  self.__compiled__ = {}; // Reset compiled data

  function schemaError(name, val) {
    throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
  }

  Object.keys(self.__schemas__).forEach(function (name) {
    var val = self.__schemas__[name];

    // skip disabled methods
    if (val === null) { return; }

    var compiled = { validate: null, link: null };

    self.__compiled__[name] = compiled;

    if (isObject(val)) {
      if (isRegExp(val.validate)) {
        compiled.validate = createValidator(val.validate);
      } else if (isFunction(val.validate)) {
        compiled.validate = val.validate;
      } else {
        schemaError(name, val);
      }

      if (isFunction(val.normalize)) {
        compiled.normalize = val.normalize;
      } else if (!val.normalize) {
        compiled.normalize = createNormalizer();
      } else {
        schemaError(name, val);
      }

      return;
    }

    if (isString(val)) {
      aliases.push(name);
      return;
    }

    schemaError(name, val);
  });

  //
  // Compile postponed aliases
  //

  aliases.forEach(function (alias) {
    if (!self.__compiled__[self.__schemas__[alias]]) {
      // Silently fail on missed schemas to avoid errons on disable.
      // schemaError(alias, self.__schemas__[alias]);
      return;
    }

    self.__compiled__[alias].validate =
      self.__compiled__[self.__schemas__[alias]].validate;
    self.__compiled__[alias].normalize =
      self.__compiled__[self.__schemas__[alias]].normalize;
  });

  //
  // Fake record for guessed links
  //
  self.__compiled__[''] = { validate: null, normalize: createNormalizer() };

  //
  // Build schema condition
  //
  var slist = Object.keys(self.__compiled__)
                      .filter(function (name) {
                        // Filter disabled & fake schemas
                        return name.length > 0 && self.__compiled__[name];
                      })
                      .map(escapeRE)
                      .join('|');
  // (?!_) cause 1.5x slowdown
  self.re.schema_test   = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
  self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');

  self.re.pretest       = RegExp(
                            '(' + self.re.schema_test.source + ')|' +
                            '(' + self.re.host_fuzzy_test.source + ')|' +
                            '@',
                            'i');

  //
  // Cleanup
  //

  resetScanCache(self);
}

/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/
function Match(self, shift) {
  var start = self.__index__,
      end   = self.__last_index__,
      text  = self.__text_cache__.slice(start, end);

  /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/
  this.schema    = self.__schema__.toLowerCase();
  /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/
  this.index     = start + shift;
  /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/
  this.lastIndex = end + shift;
  /**
   * Match#raw -> String
   *
   * Matched string.
   **/
  this.raw       = text;
  /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/
  this.text      = text;
  /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/
  this.url       = text;
}

function createMatch(self, shift) {
  var match = new Match(self, shift);

  self.__compiled__[match.schema].normalize(match, self);

  return match;
}


/**
 * class LinkifyIt
 **/

/**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/
function LinkifyIt(schemas, options) {
  if (!(this instanceof LinkifyIt)) {
    return new LinkifyIt(schemas, options);
  }

  if (!options) {
    if (isOptionsObj(schemas)) {
      options = schemas;
      schemas = {};
    }
  }

  this.__opts__           = assign({}, defaultOptions, options);

  // Cache last tested result. Used to skip repeating steps on next `match` call.
  this.__index__          = -1;
  this.__last_index__     = -1; // Next scan position
  this.__schema__         = '';
  this.__text_cache__     = '';

  this.__schemas__        = assign({}, defaultSchemas, schemas);
  this.__compiled__       = {};

  this.__tlds__           = tlds_default;
  this.__tlds_replaced__  = false;

  this.re = {};

  compile(this);
}


/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/
LinkifyIt.prototype.add = function add(schema, definition) {
  this.__schemas__[schema] = definition;
  compile(this);
  return this;
};


/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/
LinkifyIt.prototype.set = function set(options) {
  this.__opts__ = assign(this.__opts__, options);
  return this;
};


/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/
LinkifyIt.prototype.test = function test(text) {
  // Reset scan cache
  this.__text_cache__ = text;
  this.__index__      = -1;

  if (!text.length) { return false; }

  var m, ml, me, len, shift, next, re, tld_pos, at_pos;

  // try to scan for link with schema - that's the most simple rule
  if (this.re.schema_test.test(text)) {
    re = this.re.schema_search;
    re.lastIndex = 0;
    while ((m = re.exec(text)) !== null) {
      len = this.testSchemaAt(text, m[2], re.lastIndex);
      if (len) {
        this.__schema__     = m[2];
        this.__index__      = m.index + m[1].length;
        this.__last_index__ = m.index + m[0].length + len;
        break;
      }
    }
  }

  if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
    // guess schemaless links
    tld_pos = text.search(this.re.host_fuzzy_test);
    if (tld_pos >= 0) {
      // if tld is located after found link - no need to check fuzzy pattern
      if (this.__index__ < 0 || tld_pos < this.__index__) {
        if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {

          shift = ml.index + ml[1].length;

          if (this.__index__ < 0 || shift < this.__index__) {
            this.__schema__     = '';
            this.__index__      = shift;
            this.__last_index__ = ml.index + ml[0].length;
          }
        }
      }
    }
  }

  if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
    // guess schemaless emails
    at_pos = text.indexOf('@');
    if (at_pos >= 0) {
      // We can't skip this check, because this cases are possible:
      // 192.168.1.1@gmail.com, my.in@example.com
      if ((me = text.match(this.re.email_fuzzy)) !== null) {

        shift = me.index + me[1].length;
        next  = me.index + me[0].length;

        if (this.__index__ < 0 || shift < this.__index__ ||
            (shift === this.__index__ && next > this.__last_index__)) {
          this.__schema__     = 'mailto:';
          this.__index__      = shift;
          this.__last_index__ = next;
        }
      }
    }
  }

  return this.__index__ >= 0;
};


/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/
LinkifyIt.prototype.pretest = function pretest(text) {
  return this.re.pretest.test(text);
};


/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/
LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
  // If not supported schema check requested - terminate
  if (!this.__compiled__[schema.toLowerCase()]) {
    return 0;
  }
  return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};


/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/
LinkifyIt.prototype.match = function match(text) {
  var shift = 0, result = [];

  // Try to take previous element from cache, if .test() called before
  if (this.__index__ >= 0 && this.__text_cache__ === text) {
    result.push(createMatch(this, shift));
    shift = this.__last_index__;
  }

  // Cut head if cache was used
  var tail = shift ? text.slice(shift) : text;

  // Scan string until end reached
  while (this.test(tail)) {
    result.push(createMatch(this, shift));

    tail = tail.slice(this.__last_index__);
    shift += this.__last_index__;
  }

  if (result.length) {
    return result;
  }

  return null;
};


/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/
LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
  list = Array.isArray(list) ? list : [ list ];

  if (!keepOld) {
    this.__tlds__ = list.slice();
    this.__tlds_replaced__ = true;
    compile(this);
    return this;
  }

  this.__tlds__ = this.__tlds__.concat(list)
                                  .sort()
                                  .filter(function (el, idx, arr) {
                                    return el !== arr[idx - 1];
                                  })
                                  .reverse();

  compile(this);
  return this;
};

/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/
LinkifyIt.prototype.normalize = function normalize(match) {

  // Do minimal possible changes by default. Need to collect feedback prior
  // to move forward https://github.com/markdown-it/linkify-it/issues/1

  if (!match.schema) { match.url = 'http://' + match.url; }

  if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) {
    match.url = 'mailto:' + match.url;
  }
};


/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/
LinkifyIt.prototype.onCompile = function onCompile() {
};


module.exports = LinkifyIt;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



module.exports = function (opts) {
  var re = {};

  // Use direct extract instead of `regenerate` to reduse browserified size
  re.src_Any = __webpack_require__(547).source;
  re.src_Cc  = __webpack_require__(548).source;
  re.src_Z   = __webpack_require__(549).source;
  re.src_P   = __webpack_require__(550).source;

  // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
  re.src_ZPCc = [ re.src_Z, re.src_P, re.src_Cc ].join('|');

  // \p{\Z\Cc} (white spaces + control)
  re.src_ZCc = [ re.src_Z, re.src_Cc ].join('|');

  // Experimental. List of chars, completely prohibited in links
  // because can separate it from other part of text
  var text_separators = '[><\uff5c]';

  // All possible word characters (everything without punctuation, spaces & controls)
  // Defined via punctuation & spaces to save space
  // Should be something like \p{\L\N\S\M} (\w but without `_`)
  re.src_pseudo_letter       = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
  // The same as abothe but without [0-9]
  // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';

  ////////////////////////////////////////////////////////////////////////////////

  re.src_ip4 =

    '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';

  // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
  re.src_auth    = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';

  re.src_port =

    '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';

  re.src_host_terminator =

    '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';

  re.src_path =

    '(?:' +
      '[/?#]' +
        '(?:' +
          '(?!' + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' +
          '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' +
          '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' +
          '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' +
          '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' +
          "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" +
          "\\'(?=" + re.src_pseudo_letter + '|[-]).|' +  // allow `I'm_king` if no pair found
          '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
                                     // - english
                                     // - percent-encoded
                                     // - parts of file path
                                     // until more examples found.
          '\\.(?!' + re.src_ZCc + '|[.]).|' +
          (opts && opts['---'] ?
            '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
          :
            '\\-+|'
          ) +
          '\\,(?!' + re.src_ZCc + ').|' +      // allow `,,,` in paths
          '\\!(?!' + re.src_ZCc + '|[!]).|' +
          '\\?(?!' + re.src_ZCc + '|[?]).' +
        ')+' +
      '|\\/' +
    ')?';

  re.src_email_name =

    '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';

  re.src_xn =

    'xn--[a-z0-9\\-]{1,59}';

  // More to read about domain names
  // http://serverfault.com/questions/638260/

  re.src_domain_root =

    // Allow letters & digits (http://test1)
    '(?:' +
      re.src_xn +
      '|' +
      re.src_pseudo_letter + '{1,63}' +
    ')';

  re.src_domain =

    '(?:' +
      re.src_xn +
      '|' +
      '(?:' + re.src_pseudo_letter + ')' +
      '|' +
      // don't allow `--` in domain names, because:
      // - that can conflict with markdown &mdash; / &ndash;
      // - nobody use those anyway
      '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' +
    ')';

  re.src_host =

    '(?:' +
    // Don't need IP check, because digits are already allowed in normal domain names
    //   src_ip4 +
    // '|' +
      '(?:(?:(?:' + re.src_domain + ')\\.)*' + re.src_domain/*_root*/ + ')' +
    ')';

  re.tpl_host_fuzzy =

    '(?:' +
      re.src_ip4 +
    '|' +
      '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' +
    ')';

  re.tpl_host_no_ip_fuzzy =

    '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';

  re.src_host_strict =

    re.src_host + re.src_host_terminator;

  re.tpl_host_fuzzy_strict =

    re.tpl_host_fuzzy + re.src_host_terminator;

  re.src_host_port_strict =

    re.src_host + re.src_port + re.src_host_terminator;

  re.tpl_host_port_fuzzy_strict =

    re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;

  re.tpl_host_port_no_ip_fuzzy_strict =

    re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;


  ////////////////////////////////////////////////////////////////////////////////
  // Main rules

  // Rude test fuzzy links by host, for quick deny
  re.tpl_host_fuzzy_test =

    'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';

  re.tpl_email_fuzzy =

      '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';

  re.tpl_link_fuzzy =
      // Fuzzy link can't be prepended with .:/\- and non punctuation.
      // but can start with > (markdown blockquote)
      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';

  re.tpl_link_no_ip_fuzzy =
      // Fuzzy link can't be prepended with .:/\- and non punctuation.
      // but can start with > (markdown blockquote)
      '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' +
      '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';

  return re;
};


/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports=/[\0-\x1F\x7F-\x9F]/

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports=/[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports=/[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports = [
  "aaa",
  "aarp",
  "abarth",
  "abb",
  "abbott",
  "abbvie",
  "abc",
  "able",
  "abogado",
  "abudhabi",
  "ac",
  "academy",
  "accenture",
  "accountant",
  "accountants",
  "aco",
  "active",
  "actor",
  "ad",
  "adac",
  "ads",
  "adult",
  "ae",
  "aeg",
  "aero",
  "aetna",
  "af",
  "afamilycompany",
  "afl",
  "africa",
  "ag",
  "agakhan",
  "agency",
  "ai",
  "aig",
  "aigo",
  "airbus",
  "airforce",
  "airtel",
  "akdn",
  "al",
  "alfaromeo",
  "alibaba",
  "alipay",
  "allfinanz",
  "allstate",
  "ally",
  "alsace",
  "alstom",
  "am",
  "americanexpress",
  "americanfamily",
  "amex",
  "amfam",
  "amica",
  "amsterdam",
  "analytics",
  "android",
  "anquan",
  "anz",
  "ao",
  "aol",
  "apartments",
  "app",
  "apple",
  "aq",
  "aquarelle",
  "ar",
  "arab",
  "aramco",
  "archi",
  "army",
  "arpa",
  "art",
  "arte",
  "as",
  "asda",
  "asia",
  "associates",
  "at",
  "athleta",
  "attorney",
  "au",
  "auction",
  "audi",
  "audible",
  "audio",
  "auspost",
  "author",
  "auto",
  "autos",
  "avianca",
  "aw",
  "aws",
  "ax",
  "axa",
  "az",
  "azure",
  "ba",
  "baby",
  "baidu",
  "banamex",
  "bananarepublic",
  "band",
  "bank",
  "bar",
  "barcelona",
  "barclaycard",
  "barclays",
  "barefoot",
  "bargains",
  "baseball",
  "basketball",
  "bauhaus",
  "bayern",
  "bb",
  "bbc",
  "bbt",
  "bbva",
  "bcg",
  "bcn",
  "bd",
  "be",
  "beats",
  "beauty",
  "beer",
  "bentley",
  "berlin",
  "best",
  "bestbuy",
  "bet",
  "bf",
  "bg",
  "bh",
  "bharti",
  "bi",
  "bible",
  "bid",
  "bike",
  "bing",
  "bingo",
  "bio",
  "biz",
  "bj",
  "black",
  "blackfriday",
  "blanco",
  "blockbuster",
  "blog",
  "bloomberg",
  "blue",
  "bm",
  "bms",
  "bmw",
  "bn",
  "bnl",
  "bnpparibas",
  "bo",
  "boats",
  "boehringer",
  "bofa",
  "bom",
  "bond",
  "boo",
  "book",
  "booking",
  "boots",
  "bosch",
  "bostik",
  "boston",
  "bot",
  "boutique",
  "box",
  "br",
  "bradesco",
  "bridgestone",
  "broadway",
  "broker",
  "brother",
  "brussels",
  "bs",
  "bt",
  "budapest",
  "bugatti",
  "build",
  "builders",
  "business",
  "buy",
  "buzz",
  "bv",
  "bw",
  "by",
  "bz",
  "bzh",
  "ca",
  "cab",
  "cafe",
  "cal",
  "call",
  "calvinklein",
  "cam",
  "camera",
  "camp",
  "cancerresearch",
  "canon",
  "capetown",
  "capital",
  "capitalone",
  "car",
  "caravan",
  "cards",
  "care",
  "career",
  "careers",
  "cars",
  "cartier",
  "casa",
  "case",
  "caseih",
  "cash",
  "casino",
  "cat",
  "catering",
  "catholic",
  "cba",
  "cbn",
  "cbre",
  "cbs",
  "cc",
  "cd",
  "ceb",
  "center",
  "ceo",
  "cern",
  "cf",
  "cfa",
  "cfd",
  "cg",
  "ch",
  "chanel",
  "channel",
  "chase",
  "chat",
  "cheap",
  "chintai",
  "christmas",
  "chrome",
  "chrysler",
  "church",
  "ci",
  "cipriani",
  "circle",
  "cisco",
  "citadel",
  "citi",
  "citic",
  "city",
  "cityeats",
  "ck",
  "cl",
  "claims",
  "cleaning",
  "click",
  "clinic",
  "clinique",
  "clothing",
  "cloud",
  "club",
  "clubmed",
  "cm",
  "cn",
  "co",
  "coach",
  "codes",
  "coffee",
  "college",
  "cologne",
  "com",
  "comcast",
  "commbank",
  "community",
  "company",
  "compare",
  "computer",
  "comsec",
  "condos",
  "construction",
  "consulting",
  "contact",
  "contractors",
  "cooking",
  "cookingchannel",
  "cool",
  "coop",
  "corsica",
  "country",
  "coupon",
  "coupons",
  "courses",
  "cr",
  "credit",
  "creditcard",
  "creditunion",
  "cricket",
  "crown",
  "crs",
  "cruise",
  "cruises",
  "csc",
  "cu",
  "cuisinella",
  "cv",
  "cw",
  "cx",
  "cy",
  "cymru",
  "cyou",
  "cz",
  "dabur",
  "dad",
  "dance",
  "data",
  "date",
  "dating",
  "datsun",
  "day",
  "dclk",
  "dds",
  "de",
  "deal",
  "dealer",
  "deals",
  "degree",
  "delivery",
  "dell",
  "deloitte",
  "delta",
  "democrat",
  "dental",
  "dentist",
  "desi",
  "design",
  "dev",
  "dhl",
  "diamonds",
  "diet",
  "digital",
  "direct",
  "directory",
  "discount",
  "discover",
  "dish",
  "diy",
  "dj",
  "dk",
  "dm",
  "dnp",
  "do",
  "docs",
  "doctor",
  "dodge",
  "dog",
  "doha",
  "domains",
  "dot",
  "download",
  "drive",
  "dtv",
  "dubai",
  "duck",
  "dunlop",
  "duns",
  "dupont",
  "durban",
  "dvag",
  "dvr",
  "dz",
  "earth",
  "eat",
  "ec",
  "eco",
  "edeka",
  "edu",
  "education",
  "ee",
  "eg",
  "email",
  "emerck",
  "energy",
  "engineer",
  "engineering",
  "enterprises",
  "epost",
  "epson",
  "equipment",
  "er",
  "ericsson",
  "erni",
  "es",
  "esq",
  "estate",
  "esurance",
  "et",
  "etisalat",
  "eu",
  "eurovision",
  "eus",
  "events",
  "everbank",
  "exchange",
  "expert",
  "exposed",
  "express",
  "extraspace",
  "fage",
  "fail",
  "fairwinds",
  "faith",
  "family",
  "fan",
  "fans",
  "farm",
  "farmers",
  "fashion",
  "fast",
  "fedex",
  "feedback",
  "ferrari",
  "ferrero",
  "fi",
  "fiat",
  "fidelity",
  "fido",
  "film",
  "final",
  "finance",
  "financial",
  "fire",
  "firestone",
  "firmdale",
  "fish",
  "fishing",
  "fit",
  "fitness",
  "fj",
  "fk",
  "flickr",
  "flights",
  "flir",
  "florist",
  "flowers",
  "fly",
  "fm",
  "fo",
  "foo",
  "food",
  "foodnetwork",
  "football",
  "ford",
  "forex",
  "forsale",
  "forum",
  "foundation",
  "fox",
  "fr",
  "free",
  "fresenius",
  "frl",
  "frogans",
  "frontdoor",
  "frontier",
  "ftr",
  "fujitsu",
  "fujixerox",
  "fun",
  "fund",
  "furniture",
  "futbol",
  "fyi",
  "ga",
  "gal",
  "gallery",
  "gallo",
  "gallup",
  "game",
  "games",
  "gap",
  "garden",
  "gb",
  "gbiz",
  "gd",
  "gdn",
  "ge",
  "gea",
  "gent",
  "genting",
  "george",
  "gf",
  "gg",
  "ggee",
  "gh",
  "gi",
  "gift",
  "gifts",
  "gives",
  "giving",
  "gl",
  "glade",
  "glass",
  "gle",
  "global",
  "globo",
  "gm",
  "gmail",
  "gmbh",
  "gmo",
  "gmx",
  "gn",
  "godaddy",
  "gold",
  "goldpoint",
  "golf",
  "goo",
  "goodhands",
  "goodyear",
  "goog",
  "google",
  "gop",
  "got",
  "gov",
  "gp",
  "gq",
  "gr",
  "grainger",
  "graphics",
  "gratis",
  "green",
  "gripe",
  "grocery",
  "group",
  "gs",
  "gt",
  "gu",
  "guardian",
  "gucci",
  "guge",
  "guide",
  "guitars",
  "guru",
  "gw",
  "gy",
  "hair",
  "hamburg",
  "hangout",
  "haus",
  "hbo",
  "hdfc",
  "hdfcbank",
  "health",
  "healthcare",
  "help",
  "helsinki",
  "here",
  "hermes",
  "hgtv",
  "hiphop",
  "hisamitsu",
  "hitachi",
  "hiv",
  "hk",
  "hkt",
  "hm",
  "hn",
  "hockey",
  "holdings",
  "holiday",
  "homedepot",
  "homegoods",
  "homes",
  "homesense",
  "honda",
  "honeywell",
  "horse",
  "hospital",
  "host",
  "hosting",
  "hot",
  "hoteles",
  "hotels",
  "hotmail",
  "house",
  "how",
  "hr",
  "hsbc",
  "ht",
  "hu",
  "hughes",
  "hyatt",
  "hyundai",
  "ibm",
  "icbc",
  "ice",
  "icu",
  "id",
  "ie",
  "ieee",
  "ifm",
  "ikano",
  "il",
  "im",
  "imamat",
  "imdb",
  "immo",
  "immobilien",
  "in",
  "industries",
  "infiniti",
  "info",
  "ing",
  "ink",
  "institute",
  "insurance",
  "insure",
  "int",
  "intel",
  "international",
  "intuit",
  "investments",
  "io",
  "ipiranga",
  "iq",
  "ir",
  "irish",
  "is",
  "iselect",
  "ismaili",
  "ist",
  "istanbul",
  "it",
  "itau",
  "itv",
  "iveco",
  "iwc",
  "jaguar",
  "java",
  "jcb",
  "jcp",
  "je",
  "jeep",
  "jetzt",
  "jewelry",
  "jio",
  "jlc",
  "jll",
  "jm",
  "jmp",
  "jnj",
  "jo",
  "jobs",
  "joburg",
  "jot",
  "joy",
  "jp",
  "jpmorgan",
  "jprs",
  "juegos",
  "juniper",
  "kaufen",
  "kddi",
  "ke",
  "kerryhotels",
  "kerrylogistics",
  "kerryproperties",
  "kfh",
  "kg",
  "kh",
  "ki",
  "kia",
  "kim",
  "kinder",
  "kindle",
  "kitchen",
  "kiwi",
  "km",
  "kn",
  "koeln",
  "komatsu",
  "kosher",
  "kp",
  "kpmg",
  "kpn",
  "kr",
  "krd",
  "kred",
  "kuokgroup",
  "kw",
  "ky",
  "kyoto",
  "kz",
  "la",
  "lacaixa",
  "ladbrokes",
  "lamborghini",
  "lamer",
  "lancaster",
  "lancia",
  "lancome",
  "land",
  "landrover",
  "lanxess",
  "lasalle",
  "lat",
  "latino",
  "latrobe",
  "law",
  "lawyer",
  "lb",
  "lc",
  "lds",
  "lease",
  "leclerc",
  "lefrak",
  "legal",
  "lego",
  "lexus",
  "lgbt",
  "li",
  "liaison",
  "lidl",
  "life",
  "lifeinsurance",
  "lifestyle",
  "lighting",
  "like",
  "lilly",
  "limited",
  "limo",
  "lincoln",
  "linde",
  "link",
  "lipsy",
  "live",
  "living",
  "lixil",
  "lk",
  "loan",
  "loans",
  "locker",
  "locus",
  "loft",
  "lol",
  "london",
  "lotte",
  "lotto",
  "love",
  "lpl",
  "lplfinancial",
  "lr",
  "ls",
  "lt",
  "ltd",
  "ltda",
  "lu",
  "lundbeck",
  "lupin",
  "luxe",
  "luxury",
  "lv",
  "ly",
  "ma",
  "macys",
  "madrid",
  "maif",
  "maison",
  "makeup",
  "man",
  "management",
  "mango",
  "map",
  "market",
  "marketing",
  "markets",
  "marriott",
  "marshalls",
  "maserati",
  "mattel",
  "mba",
  "mc",
  "mckinsey",
  "md",
  "me",
  "med",
  "media",
  "meet",
  "melbourne",
  "meme",
  "memorial",
  "men",
  "menu",
  "meo",
  "merckmsd",
  "metlife",
  "mg",
  "mh",
  "miami",
  "microsoft",
  "mil",
  "mini",
  "mint",
  "mit",
  "mitsubishi",
  "mk",
  "ml",
  "mlb",
  "mls",
  "mm",
  "mma",
  "mn",
  "mo",
  "mobi",
  "mobile",
  "mobily",
  "moda",
  "moe",
  "moi",
  "mom",
  "monash",
  "money",
  "monster",
  "mopar",
  "mormon",
  "mortgage",
  "moscow",
  "moto",
  "motorcycles",
  "mov",
  "movie",
  "movistar",
  "mp",
  "mq",
  "mr",
  "ms",
  "msd",
  "mt",
  "mtn",
  "mtr",
  "mu",
  "museum",
  "mutual",
  "mv",
  "mw",
  "mx",
  "my",
  "mz",
  "na",
  "nab",
  "nadex",
  "nagoya",
  "name",
  "nationwide",
  "natura",
  "navy",
  "nba",
  "nc",
  "ne",
  "nec",
  "net",
  "netbank",
  "netflix",
  "network",
  "neustar",
  "new",
  "newholland",
  "news",
  "next",
  "nextdirect",
  "nexus",
  "nf",
  "nfl",
  "ng",
  "ngo",
  "nhk",
  "ni",
  "nico",
  "nike",
  "nikon",
  "ninja",
  "nissan",
  "nissay",
  "nl",
  "no",
  "nokia",
  "northwesternmutual",
  "norton",
  "now",
  "nowruz",
  "nowtv",
  "np",
  "nr",
  "nra",
  "nrw",
  "ntt",
  "nu",
  "nyc",
  "nz",
  "obi",
  "observer",
  "off",
  "office",
  "okinawa",
  "olayan",
  "olayangroup",
  "oldnavy",
  "ollo",
  "om",
  "omega",
  "one",
  "ong",
  "onl",
  "online",
  "onyourside",
  "ooo",
  "open",
  "oracle",
  "orange",
  "org",
  "organic",
  "origins",
  "osaka",
  "otsuka",
  "ott",
  "ovh",
  "pa",
  "page",
  "panasonic",
  "panerai",
  "paris",
  "pars",
  "partners",
  "parts",
  "party",
  "passagens",
  "pay",
  "pccw",
  "pe",
  "pet",
  "pf",
  "pfizer",
  "pg",
  "ph",
  "pharmacy",
  "phd",
  "philips",
  "phone",
  "photo",
  "photography",
  "photos",
  "physio",
  "piaget",
  "pics",
  "pictet",
  "pictures",
  "pid",
  "pin",
  "ping",
  "pink",
  "pioneer",
  "pizza",
  "pk",
  "pl",
  "place",
  "play",
  "playstation",
  "plumbing",
  "plus",
  "pm",
  "pn",
  "pnc",
  "pohl",
  "poker",
  "politie",
  "porn",
  "post",
  "pr",
  "pramerica",
  "praxi",
  "press",
  "prime",
  "pro",
  "prod",
  "productions",
  "prof",
  "progressive",
  "promo",
  "properties",
  "property",
  "protection",
  "pru",
  "prudential",
  "ps",
  "pt",
  "pub",
  "pw",
  "pwc",
  "py",
  "qa",
  "qpon",
  "quebec",
  "quest",
  "qvc",
  "racing",
  "radio",
  "raid",
  "re",
  "read",
  "realestate",
  "realtor",
  "realty",
  "recipes",
  "red",
  "redstone",
  "redumbrella",
  "rehab",
  "reise",
  "reisen",
  "reit",
  "reliance",
  "ren",
  "rent",
  "rentals",
  "repair",
  "report",
  "republican",
  "rest",
  "restaurant",
  "review",
  "reviews",
  "rexroth",
  "rich",
  "richardli",
  "ricoh",
  "rightathome",
  "ril",
  "rio",
  "rip",
  "rmit",
  "ro",
  "rocher",
  "rocks",
  "rodeo",
  "rogers",
  "room",
  "rs",
  "rsvp",
  "ru",
  "rugby",
  "ruhr",
  "run",
  "rw",
  "rwe",
  "ryukyu",
  "sa",
  "saarland",
  "safe",
  "safety",
  "sakura",
  "sale",
  "salon",
  "samsclub",
  "samsung",
  "sandvik",
  "sandvikcoromant",
  "sanofi",
  "sap",
  "sapo",
  "sarl",
  "sas",
  "save",
  "saxo",
  "sb",
  "sbi",
  "sbs",
  "sc",
  "sca",
  "scb",
  "schaeffler",
  "schmidt",
  "scholarships",
  "school",
  "schule",
  "schwarz",
  "science",
  "scjohnson",
  "scor",
  "scot",
  "sd",
  "se",
  "search",
  "seat",
  "secure",
  "security",
  "seek",
  "select",
  "sener",
  "services",
  "ses",
  "seven",
  "sew",
  "sex",
  "sexy",
  "sfr",
  "sg",
  "sh",
  "shangrila",
  "sharp",
  "shaw",
  "shell",
  "shia",
  "shiksha",
  "shoes",
  "shop",
  "shopping",
  "shouji",
  "show",
  "showtime",
  "shriram",
  "si",
  "silk",
  "sina",
  "singles",
  "site",
  "sj",
  "sk",
  "ski",
  "skin",
  "sky",
  "skype",
  "sl",
  "sling",
  "sm",
  "smart",
  "smile",
  "sn",
  "sncf",
  "so",
  "soccer",
  "social",
  "softbank",
  "software",
  "sohu",
  "solar",
  "solutions",
  "song",
  "sony",
  "soy",
  "space",
  "spiegel",
  "spot",
  "spreadbetting",
  "sr",
  "srl",
  "srt",
  "st",
  "stada",
  "staples",
  "star",
  "starhub",
  "statebank",
  "statefarm",
  "statoil",
  "stc",
  "stcgroup",
  "stockholm",
  "storage",
  "store",
  "stream",
  "studio",
  "study",
  "style",
  "su",
  "sucks",
  "supplies",
  "supply",
  "support",
  "surf",
  "surgery",
  "suzuki",
  "sv",
  "swatch",
  "swiftcover",
  "swiss",
  "sx",
  "sy",
  "sydney",
  "symantec",
  "systems",
  "sz",
  "tab",
  "taipei",
  "talk",
  "taobao",
  "target",
  "tatamotors",
  "tatar",
  "tattoo",
  "tax",
  "taxi",
  "tc",
  "tci",
  "td",
  "tdk",
  "team",
  "tech",
  "technology",
  "tel",
  "telecity",
  "telefonica",
  "temasek",
  "tennis",
  "teva",
  "tf",
  "tg",
  "th",
  "thd",
  "theater",
  "theatre",
  "tiaa",
  "tickets",
  "tienda",
  "tiffany",
  "tips",
  "tires",
  "tirol",
  "tj",
  "tjmaxx",
  "tjx",
  "tk",
  "tkmaxx",
  "tl",
  "tm",
  "tmall",
  "tn",
  "to",
  "today",
  "tokyo",
  "tools",
  "top",
  "toray",
  "toshiba",
  "total",
  "tours",
  "town",
  "toyota",
  "toys",
  "tr",
  "trade",
  "trading",
  "training",
  "travel",
  "travelchannel",
  "travelers",
  "travelersinsurance",
  "trust",
  "trv",
  "tt",
  "tube",
  "tui",
  "tunes",
  "tushu",
  "tv",
  "tvs",
  "tw",
  "tz",
  "ua",
  "ubank",
  "ubs",
  "uconnect",
  "ug",
  "uk",
  "unicom",
  "university",
  "uno",
  "uol",
  "ups",
  "us",
  "uy",
  "uz",
  "va",
  "vacations",
  "vana",
  "vanguard",
  "vc",
  "ve",
  "vegas",
  "ventures",
  "verisign",
  "versicherung",
  "vet",
  "vg",
  "vi",
  "viajes",
  "video",
  "vig",
  "viking",
  "villas",
  "vin",
  "vip",
  "virgin",
  "visa",
  "vision",
  "vista",
  "vistaprint",
  "viva",
  "vivo",
  "vlaanderen",
  "vn",
  "vodka",
  "volkswagen",
  "volvo",
  "vote",
  "voting",
  "voto",
  "voyage",
  "vu",
  "vuelos",
  "wales",
  "walmart",
  "walter",
  "wang",
  "wanggou",
  "warman",
  "watch",
  "watches",
  "weather",
  "weatherchannel",
  "webcam",
  "weber",
  "website",
  "wed",
  "wedding",
  "weibo",
  "weir",
  "wf",
  "whoswho",
  "wien",
  "wiki",
  "williamhill",
  "win",
  "windows",
  "wine",
  "winners",
  "wme",
  "wolterskluwer",
  "woodside",
  "work",
  "works",
  "world",
  "wow",
  "ws",
  "wtc",
  "wtf",
  "xbox",
  "xerox",
  "xfinity",
  "xihuan",
  "xin",
  "कॉम", // xn--11b4c3d
  "セール", // xn--1ck2e1b
  "佛山", // xn--1qqw23a
  "ಭಾರತ", // xn--2scrj9c
  "慈善", // xn--30rr7y
  "集团", // xn--3bst00m
  "在线", // xn--3ds443g
  "한국", // xn--3e0b707e
  "ଭାରତ", // xn--3hcrj9c
  "大众汽车", // xn--3oq18vl8pn36a
  "点看", // xn--3pxu8k
  "คอม", // xn--42c2d9a
  "ভাৰত", // xn--45br5cyl
  "ভারত", // xn--45brj9c
  "八卦", // xn--45q11c
  "موقع", // xn--4gbrim
  "বাংলা", // xn--54b7fta0cc
  "公益", // xn--55qw42g
  "公司", // xn--55qx5d
  "香格里拉", // xn--5su34j936bgsg
  "网站", // xn--5tzm5g
  "移动", // xn--6frz82g
  "我爱你", // xn--6qq986b3xl
  "москва", // xn--80adxhks
  "қаз", // xn--80ao21a
  "католик", // xn--80aqecdr1a
  "онлайн", // xn--80asehdb
  "сайт", // xn--80aswg
  "联通", // xn--8y0a063a
  "срб", // xn--90a3ac
  "бг", // xn--90ae
  "бел", // xn--90ais
  "קום", // xn--9dbq2a
  "时尚", // xn--9et52u
  "微博", // xn--9krt00a
  "淡马锡", // xn--b4w605ferd
  "ファッション", // xn--bck1b9a5dre4c
  "орг", // xn--c1avg
  "नेट", // xn--c2br7g
  "ストア", // xn--cck2b3b
  "삼성", // xn--cg4bki
  "சிங்கப்பூர்", // xn--clchc0ea0b2g2a9gcd
  "商标", // xn--czr694b
  "商店", // xn--czrs0t
  "商城", // xn--czru2d
  "дети", // xn--d1acj3b
  "мкд", // xn--d1alf
  "ею", // xn--e1a4c
  "ポイント", // xn--eckvdtc9d
  "新闻", // xn--efvy88h
  "工行", // xn--estv75g
  "家電", // xn--fct429k
  "كوم", // xn--fhbei
  "中文网", // xn--fiq228c5hs
  "中信", // xn--fiq64b
  "中国", // xn--fiqs8s
  "中國", // xn--fiqz9s
  "娱乐", // xn--fjq720a
  "谷歌", // xn--flw351e
  "భారత్", // xn--fpcrj9c3d
  "ලංකා", // xn--fzc2c9e2c
  "電訊盈科", // xn--fzys8d69uvgm
  "购物", // xn--g2xx48c
  "クラウド", // xn--gckr3f0f
  "ભારત", // xn--gecrj9c
  "通販", // xn--gk3at1e
  "भारतम्", // xn--h2breg3eve
  "भारत", // xn--h2brj9c
  "भारोत", // xn--h2brj9c8c
  "网店", // xn--hxt814e
  "संगठन", // xn--i1b6b1a6a2e
  "餐厅", // xn--imr513n
  "网络", // xn--io0a7i
  "ком", // xn--j1aef
  "укр", // xn--j1amh
  "香港", // xn--j6w193g
  "诺基亚", // xn--jlq61u9w7b
  "食品", // xn--jvr189m
  "飞利浦", // xn--kcrx77d1x4a
  "台湾", // xn--kprw13d
  "台灣", // xn--kpry57d
  "手表", // xn--kpu716f
  "手机", // xn--kput3i
  "мон", // xn--l1acc
  "الجزائر", // xn--lgbbat1ad8j
  "عمان", // xn--mgb9awbf
  "ارامكو", // xn--mgba3a3ejt
  "ایران", // xn--mgba3a4f16a
  "العليان", // xn--mgba7c0bbn0a
  "اتصالات", // xn--mgbaakc7dvf
  "امارات", // xn--mgbaam7a8h
  "بازار", // xn--mgbab2bd
  "پاکستان", // xn--mgbai9azgqp6j
  "الاردن", // xn--mgbayh7gpa
  "موبايلي", // xn--mgbb9fbpob
  "بارت", // xn--mgbbh1a
  "بھارت", // xn--mgbbh1a71e
  "المغرب", // xn--mgbc0a9azcg
  "ابوظبي", // xn--mgbca7dzdo
  "السعودية", // xn--mgberp4a5d4ar
  "ڀارت", // xn--mgbgu82a
  "كاثوليك", // xn--mgbi4ecexp
  "سودان", // xn--mgbpl2fh
  "همراه", // xn--mgbt3dhd
  "عراق", // xn--mgbtx2b
  "مليسيا", // xn--mgbx4cd0ab
  "澳門", // xn--mix891f
  "닷컴", // xn--mk1bu44c
  "政府", // xn--mxtq1m
  "شبكة", // xn--ngbc5azd
  "بيتك", // xn--ngbe9e0a
  "عرب", // xn--ngbrx
  "გე", // xn--node
  "机构", // xn--nqv7f
  "组织机构", // xn--nqv7fs00ema
  "健康", // xn--nyqy26a
  "ไทย", // xn--o3cw4h
  "سورية", // xn--ogbpf8fl
  "рус", // xn--p1acf
  "рф", // xn--p1ai
  "珠宝", // xn--pbt977c
  "تونس", // xn--pgbs0dh
  "大拿", // xn--pssy2u
  "みんな", // xn--q9jyb4c
  "グーグル", // xn--qcka1pmc
  "ελ", // xn--qxam
  "世界", // xn--rhqv96g
  "書籍", // xn--rovu88b
  "ഭാരതം", // xn--rvc1e0am3e
  "ਭਾਰਤ", // xn--s9brj9c
  "网址", // xn--ses554g
  "닷넷", // xn--t60b56a
  "コム", // xn--tckwe
  "天主教", // xn--tiq49xqyj
  "游戏", // xn--unup4y
  "vermögensberater", // xn--vermgensberater-ctb
  "vermögensberatung", // xn--vermgensberatung-pwb
  "企业", // xn--vhquv
  "信息", // xn--vuq861b
  "嘉里大酒店", // xn--w4r85el8fhu5dnra
  "嘉里", // xn--w4rs40l
  "مصر", // xn--wgbh1c
  "قطر", // xn--wgbl6a
  "广东", // xn--xhq521b
  "இலங்கை", // xn--xkc2al3hye2a
  "இந்தியா", // xn--xkc2dl3a5ee0h
  "հայ", // xn--y9a3aq
  "新加坡", // xn--yfro4i67o
  "فلسطين", // xn--ygbi2ammx
  "政务", // xn--zfr164b
  "xperia",
  "xxx",
  "xyz",
  "yachts",
  "yahoo",
  "yamaxun",
  "yandex",
  "ye",
  "yodobashi",
  "yoga",
  "yokohama",
  "you",
  "youtube",
  "yt",
  "yun",
  "za",
  "zappos",
  "zara",
  "zero",
  "zip",
  "zippo",
  "zm",
  "zone",
  "zuerich",
  "zw"
];


/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debounce__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lib_text__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_teachers_selectors__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var INPUT_DEBOUNCE_DELAY=500;var MAX_REPLY_LENGTH=300;var ReplyInput=function(_React$Component){_inherits(ReplyInput,_React$Component);function ReplyInput(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ReplyInput);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ReplyInput.__proto__||Object.getPrototypeOf(ReplyInput)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_this.setReplyDraft=__WEBPACK_IMPORTED_MODULE_3_debounce___default()(function(replyDraft){_this.props.setReplyDraft(_this.props.schoolID,replyDraft);},INPUT_DEBOUNCE_DELAY),_this.onChange=function(event){var replyDraft=_this.textarea.value;// Remove smart quote characters
replyDraft=Object(__WEBPACK_IMPORTED_MODULE_4_lib_text__["a" /* convertSmartQuotes */])(replyDraft);// Check if the input is text message-compatible
if(Object(__WEBPACK_IMPORTED_MODULE_4_lib_text__["b" /* isValidTextMessage */])(replyDraft)&&replyDraft.length<=MAX_REPLY_LENGTH){_this.setReplyDraft(replyDraft);_this.setState({replyDraft:replyDraft});}else{// Prevent invalid input
event.preventDefault();}},_this.onSend=function(){var replyDraft=_this.state.replyDraft;var trimmedReplyDraft=replyDraft.trim();if(trimmedReplyDraft.length>0){// cancel any pending debounced calls to setReplyDraft
_this.setReplyDraft.clear();// dispatch an action to send the message
_this.props.sendReply(_this.props.schoolID,trimmedReplyDraft);// clear the replyDraft from local state
_this.setState({replyDraft:""});}},_this.refTextarea=function(textarea){_this.textarea=textarea;if(_this.props.refInput!==undefined){_this.props.refInput(textarea);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ReplyInput,[{key:"render",value:function render(){var replyDraft=this.state.replyDraft;var hasReply=replyDraft.length>0;var sendButtonClassList=["reply-input__send-button"];if(!hasReply){sendButtonClassList.push("reply-input__send-button--disabled");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"reply-input"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{className:"reply-input__textarea",rows:1,maxLength:MAX_REPLY_LENGTH,ref:this.refTextarea,onChange:this.onChange,value:replyDraft,placeholder:"Reply to "+this.props.schoolName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:sendButtonClassList.join(" "),onClick:this.onSend}));}}],[{key:"getDerivedStateFromProps",value:function getDerivedStateFromProps(nextProps){return{replyDraft:nextProps.replyDraft};}/**
   * Set school's replyDraft (on debounce timer)
   *//**
   * Callback for change event of textarea
   */}]);return ReplyInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){return{schoolName:Object(__WEBPACK_IMPORTED_MODULE_6_state_teachers_selectors__["o" /* getSchoolName */])(state,ownProps.schoolID),replyDraft:Object(__WEBPACK_IMPORTED_MODULE_6_state_teachers_selectors__["r" /* getSchoolReplyDraft */])(state,ownProps.schoolID)};},function(dispatch,ownProps){return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({sendReply:__WEBPACK_IMPORTED_MODULE_5_state_teachers_actions__["T" /* sendReply */],setReplyDraft:__WEBPACK_IMPORTED_MODULE_5_state_teachers_actions__["X" /* setReplyDraft */]},dispatch);})(ReplyInput));

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoadingThrobber_css__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoadingThrobber_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LoadingThrobber_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoadingThrobber=function(_Component){_inherits(LoadingThrobber,_Component);function LoadingThrobber(){_classCallCheck(this,LoadingThrobber);return _possibleConstructorReturn(this,(LoadingThrobber.__proto__||Object.getPrototypeOf(LoadingThrobber)).apply(this,arguments));}_createClass(LoadingThrobber,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"throbber"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce3"}));}}]);return LoadingThrobber;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LoadingThrobber);

/***/ }),
/* 555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_teachers_MaintainValidSchoolID__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_teachers_Preloader__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_teachers_SchoolSelector__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_teachers_SchoolCarousel__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_teachers_noticeboard_SchoolNoticeList__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NoticeboardPage_css__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NoticeboardPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__NoticeboardPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NoticeboardPage=function(_React$Component){_inherits(NoticeboardPage,_React$Component);function NoticeboardPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NoticeboardPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NoticeboardPage.__proto__||Object.getPrototypeOf(NoticeboardPage)).call.apply(_ref,[this].concat(args))),_this),_this.isNoticesReady=function(state){return Object(__WEBPACK_IMPORTED_MODULE_1_state_teachers_selectors__["A" /* isNoticesReady */])(state,_this.props.schoolID);},_this.generatePath=function(schoolID){return"/teachers/noticeboard/"+schoolID+"/";},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NoticeboardPage,[{key:"render",value:function render(){var schoolID=this.props.match.params.schoolID;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_teachers_MaintainValidSchoolID__["a" /* default */],{currentSchoolID:schoolID,generatePath:this.generatePath},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_teachers_Preloader__["a" /* default */],{isPageReady:this.isNoticesReady},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"noticeboard-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"page-header__title"},"Noticeboard"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_teachers_SchoolSelector__["a" /* default */],{selectedSchoolID:schoolID,generatePath:this.generatePath})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_teachers_SchoolCarousel__["a" /* default */],{activeSchoolID:schoolID,generatePath:this.generatePath},function(schoolID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_teachers_noticeboard_SchoolNoticeList__["a" /* default */],{key:schoolID,schoolID:schoolID});}))));}}]);return NoticeboardPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (NoticeboardPage);;

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ScrollableList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_List__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_teachers_PlaceholderCard__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_teachers_noticeboard_Notice__ = __webpack_require__(559);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SchoolNoticeList=function(_React$Component){_inherits(SchoolNoticeList,_React$Component);function SchoolNoticeList(){_classCallCheck(this,SchoolNoticeList);return _possibleConstructorReturn(this,(SchoolNoticeList.__proto__||Object.getPrototypeOf(SchoolNoticeList)).apply(this,arguments));}_createClass(SchoolNoticeList,[{key:"render",value:function render(){var _props=this.props,noticeIDList=_props.noticeIDList,school=_props.school,goToNoticeID=_props.goToNoticeID;var placeholder=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_teachers_PlaceholderCard__["a" /* default */],{school:school,objectName:"notices"});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ScrollableList__["a" /* default */],{className:"notice-list",onScroll:this.props.clearGoTo,scrollTargetID:goToNoticeID},function(refChild){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_List__["a" /* default */],{placeholder:placeholder},noticeIDList.map(function(noticeID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_teachers_noticeboard_Notice__["a" /* default */],{key:noticeID,noticeID:noticeID,innerRef:function innerRef(child){return refChild(child,noticeID);}});}));});}}]);return SchoolNoticeList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var schoolID=_ref.schoolID;return{noticeIDList:Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["p" /* getSchoolNoticeIDList */])(state,schoolID),school:Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["j" /* getSchoolByID */])(state,schoolID),goToNoticeID:Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["c" /* getGoToNoticeID */])(state)};},{clearGoTo:__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["B" /* clearGoToNotice */]})(SchoolNoticeList));

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_format__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_linkify__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_linkify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_linkify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_app_actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Highlight__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_teachers_ExpandingBox__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_LiveDate__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_assets_images_teachers_noticeboard_arts_svg__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_assets_images_teachers_noticeboard_arts_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_assets_images_teachers_noticeboard_arts_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_assets_images_teachers_noticeboard_bars_svg__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_assets_images_teachers_noticeboard_bars_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_assets_images_teachers_noticeboard_bars_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_assets_images_teachers_noticeboard_calendar_svg__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_assets_images_teachers_noticeboard_calendar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_assets_images_teachers_noticeboard_calendar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_assets_images_teachers_noticeboard_clock_svg__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_assets_images_teachers_noticeboard_clock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_assets_images_teachers_noticeboard_clock_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_assets_images_teachers_noticeboard_football_svg__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_assets_images_teachers_noticeboard_football_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_components_assets_images_teachers_noticeboard_football_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_assets_images_teachers_noticeboard_hands_svg__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_assets_images_teachers_noticeboard_hands_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_components_assets_images_teachers_noticeboard_hands_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_assets_images_teachers_noticeboard_map_svg__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_assets_images_teachers_noticeboard_map_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_components_assets_images_teachers_noticeboard_map_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_assets_images_teachers_noticeboard_message_svg__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_assets_images_teachers_noticeboard_message_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_components_assets_images_teachers_noticeboard_message_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_assets_images_teachers_noticeboard_music_svg__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_assets_images_teachers_noticeboard_music_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_components_assets_images_teachers_noticeboard_music_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_assets_images_teachers_noticeboard_trophy_svg__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_components_assets_images_teachers_noticeboard_trophy_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_components_assets_images_teachers_noticeboard_trophy_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var iconFiles=new Map([["arts.svg",__WEBPACK_IMPORTED_MODULE_11_components_assets_images_teachers_noticeboard_arts_svg___default.a],["bars.svg",__WEBPACK_IMPORTED_MODULE_12_components_assets_images_teachers_noticeboard_bars_svg___default.a],["calendar.svg",__WEBPACK_IMPORTED_MODULE_13_components_assets_images_teachers_noticeboard_calendar_svg___default.a],["clock.svg",__WEBPACK_IMPORTED_MODULE_14_components_assets_images_teachers_noticeboard_clock_svg___default.a],["football.svg",__WEBPACK_IMPORTED_MODULE_15_components_assets_images_teachers_noticeboard_football_svg___default.a],["hands.svg",__WEBPACK_IMPORTED_MODULE_16_components_assets_images_teachers_noticeboard_hands_svg___default.a],["map.svg",__WEBPACK_IMPORTED_MODULE_17_components_assets_images_teachers_noticeboard_map_svg___default.a],["message.svg",__WEBPACK_IMPORTED_MODULE_18_components_assets_images_teachers_noticeboard_message_svg___default.a],["music.svg",__WEBPACK_IMPORTED_MODULE_19_components_assets_images_teachers_noticeboard_music_svg___default.a],["trophy.svg",__WEBPACK_IMPORTED_MODULE_20_components_assets_images_teachers_noticeboard_trophy_svg___default.a]]);var Notice=function(_React$Component){_inherits(Notice,_React$Component);function Notice(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Notice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Notice.__proto__||Object.getPrototypeOf(Notice)).call.apply(_ref,[this].concat(args))),_this),_this.linkifyProperties={onClick:function onClick(clickEvent){_this.props.openURL(clickEvent.target.href);clickEvent.preventDefault();}},_this.expand=function(){_this.props.setExpandedNotice(_this.props.notice.get("id"));},_this.collapse=function(){_this.props.setExpandedNotice(null);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Notice,[{key:"componentWillUnmount",/**
   * If this notice is expanded, unset expandedNoticeID when it unmounts
   */value:function componentWillUnmount(){if(this.props.notice.get("expanded")){this.collapse();}}},{key:"render",value:function render(){var _props=this.props,notice=_props.notice,isHighlighted=_props.isHighlighted;var _notice$toObject=notice.toObject(),subject=_notice$toObject.subject,icon=_notice$toObject.icon,description=_notice$toObject.description,postedDate=_notice$toObject.postedDate,timezoneOffset=_notice$toObject.timezoneOffset,expanded=_notice$toObject.expanded;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"notice",ref:this.props.innerRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Highlight__["a" /* default */],{cssModifier:"teachers",isHighlighted:isHighlighted},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_teachers_ExpandingBox__["a" /* default */],{onExpand:this.expand,onCollapse:this.collapse,expanded:expanded},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_teachers_ExpandingBox__["a" /* default */].Header,{toggleOnClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"notice__header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"notice__icon",src:iconFiles.get(icon),alt:"notice icon"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"notice__header-text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"notice__subject"},subject),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"notice__post-date"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_LiveDate__["a" /* default */],{date:postedDate,timezoneOffset:timezoneOffset}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_teachers_ExpandingBox__["a" /* default */].Body,{toggleOnClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"notice__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"notice__description"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_linkify___default.a,{properties:this.linkifyProperties},Object(__WEBPACK_IMPORTED_MODULE_3_lib_format__["c" /* nl2br */])(description))))))));}}]);return Notice;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);;/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref2){var noticeID=_ref2.noticeID;return{notice:Object(__WEBPACK_IMPORTED_MODULE_6_state_teachers_selectors__["g" /* getNoticeByID */])(state,noticeID),isHighlighted:Object(__WEBPACK_IMPORTED_MODULE_6_state_teachers_selectors__["c" /* getGoToNoticeID */])(state)===noticeID};},function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({setExpandedNotice:__WEBPACK_IMPORTED_MODULE_7_state_teachers_actions__["U" /* setExpandedNotice */],openURL:__WEBPACK_IMPORTED_MODULE_5_state_app_actions__["R" /* openURL */]},dispatch);})(Notice));

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ExpandingBox__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ExpandingBox=function(_Component){_inherits(ExpandingBox,_Component);function ExpandingBox(){_classCallCheck(this,ExpandingBox);return _possibleConstructorReturn(this,(ExpandingBox.__proto__||Object.getPrototypeOf(ExpandingBox)).apply(this,arguments));}_createClass(ExpandingBox,[{key:"render",// Copy generic Header and Body sub-components
value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ExpandingBox__["a" /* default */],Object.assign({cssModifier:"teachers"},this.props),this.props.children);}}]);return ExpandingBox;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);ExpandingBox.Header=__WEBPACK_IMPORTED_MODULE_1_components_ExpandingBox__["a" /* default */].Header;ExpandingBox.Body=__WEBPACK_IMPORTED_MODULE_1_components_ExpandingBox__["a" /* default */].Body;/* harmony default export */ __webpack_exports__["a"] = (ExpandingBox);

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arts.e1ecd7df.svg";

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bars.8e698339.svg";

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/calendar.0448c8fd.svg";

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/clock.1b94f7b7.svg";

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/football.a45eb548.svg";

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hands.ccfe15d8.svg";

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map.d5576619.svg";

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/message.7dbf2f58.svg";

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/music.0e1f6ddf.svg";

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/trophy.a07aca7a.svg";

/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_teachers_MaintainValidSchoolID__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_teachers_Preloader__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_teachers_SchoolSelector__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_teachers_SchoolCarousel__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_teachers_term_calendar_SchoolTermList__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TermCalendarPage_css__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TermCalendarPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TermCalendarPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TermCalendarPage=function(_React$Component){_inherits(TermCalendarPage,_React$Component);function TermCalendarPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TermCalendarPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TermCalendarPage.__proto__||Object.getPrototypeOf(TermCalendarPage)).call.apply(_ref,[this].concat(args))),_this),_this.isTermsReady=function(state){return Object(__WEBPACK_IMPORTED_MODULE_1_state_teachers_selectors__["C" /* isTermsReady */])(state,_this.props.schoolID);},_this.generatePath=function(schoolID){return"/teachers/term_calendar/"+schoolID+"/";},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TermCalendarPage,[{key:"render",value:function render(){var schoolID=this.props.match.params.schoolID;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_teachers_MaintainValidSchoolID__["a" /* default */],{currentSchoolID:schoolID,generatePath:this.generatePath},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_teachers_Preloader__["a" /* default */],{isPageReady:this.isTermsReady},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"term-calendar-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"page-header__title"},"Term Calendar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_teachers_SchoolSelector__["a" /* default */],{selectedSchoolID:schoolID,generatePath:this.generatePath})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_teachers_SchoolCarousel__["a" /* default */],{activeSchoolID:schoolID,generatePath:this.generatePath},function(schoolID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_teachers_term_calendar_SchoolTermList__["a" /* default */],{key:schoolID,schoolID:schoolID});}))));}}]);return TermCalendarPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (TermCalendarPage);;

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_List__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_teachers_PlaceholderCard__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_teachers_term_calendar_Term__ = __webpack_require__(574);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SchoolTermList=function(_React$Component){_inherits(SchoolTermList,_React$Component);function SchoolTermList(){_classCallCheck(this,SchoolTermList);return _possibleConstructorReturn(this,(SchoolTermList.__proto__||Object.getPrototypeOf(SchoolTermList)).apply(this,arguments));}_createClass(SchoolTermList,[{key:"render",value:function render(){var _props=this.props,termIDList=_props.termIDList,school=_props.school;var placeholder=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_teachers_PlaceholderCard__["a" /* default */],{school:school,objectName:"terms"});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_List__["a" /* default */],{className:"term-list",placeholder:placeholder},termIDList.map(function(termID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_teachers_term_calendar_Term__["a" /* default */],{key:termID,termID:termID});}));}}]);return SchoolTermList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var schoolID=_ref.schoolID;return{termIDList:Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["s" /* getSchoolTermIDList */])(state,schoolID),school:Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["j" /* getSchoolByID */])(state,schoolID)};})(SchoolTermList));

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Date__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// "name", "startDate", "endDate", "breakStartDate", "breakEndDate"
var Term=function(_React$Component){_inherits(Term,_React$Component);function Term(){_classCallCheck(this,Term);return _possibleConstructorReturn(this,(Term.__proto__||Object.getPrototypeOf(Term)).apply(this,arguments));}_createClass(Term,[{key:"render",value:function render(){var _props$term$toJS=this.props.term.toJS(),name=_props$term$toJS.name,startDate=_props$term$toJS.startDate,breakStartDate=_props$term$toJS.breakStartDate,breakEndDate=_props$term$toJS.breakEndDate,endDate=_props$term$toJS.endDate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Card__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Card__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"term"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"term__name"},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"term__dates"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"term__date-label"},"Term Starts"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"term__date-value"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Date__["a" /* default */],{date:startDate}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"term__date-label"},"Half Term Starts"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"term__date-value"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Date__["a" /* default */],{date:breakStartDate}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"term__date-label"},"Half Term Ends"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"term__date-value"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Date__["a" /* default */],{date:breakEndDate}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"term__date-label"},"Term Ends"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"term__date-value"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Date__["a" /* default */],{date:endDate}))))))));}}]);return Term;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var termID=_ref.termID;return{term:Object(__WEBPACK_IMPORTED_MODULE_2_state_teachers_selectors__["v" /* getTermByID */])(state,termID)};})(Term));

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_teachers_selectors__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_WelcomeGuide__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_assets_images_teachers_teachers_logo_text_right_svg__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_assets_images_teachers_teachers_logo_text_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_components_assets_images_teachers_teachers_logo_text_right_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_assets_images_teachers_teachers_logo_no_text_svg__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_assets_images_teachers_teachers_logo_no_text_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_assets_images_teachers_teachers_logo_no_text_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_assets_images_teachers_guide_term_calendar_svg__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_assets_images_teachers_guide_term_calendar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_assets_images_teachers_guide_term_calendar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_assets_images_teachers_guide_messages_svg__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_assets_images_teachers_guide_messages_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_assets_images_teachers_guide_messages_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_assets_images_teachers_guide_noticeboard_svg__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_assets_images_teachers_guide_noticeboard_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_assets_images_teachers_guide_noticeboard_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_assets_images_teachers_guide_multi_school_support_svg__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_assets_images_teachers_guide_multi_school_support_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_assets_images_teachers_guide_multi_school_support_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_assets_images_teachers_guide_verification_svg__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_assets_images_teachers_guide_verification_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_assets_images_teachers_guide_verification_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_assets_images_teachers_guide_faq_svg__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_assets_images_teachers_guide_faq_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_assets_images_teachers_guide_faq_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Guide_css__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Guide_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__Guide_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Guide=function(_React$Component){_inherits(Guide,_React$Component);function Guide(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Guide);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Guide.__proto__||Object.getPrototypeOf(Guide)).call.apply(_ref,[this].concat(args))),_this),_this.guideChildren=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page",key:"welcome"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page__icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_7_components_assets_images_teachers_teachers_logo_no_text_svg___default.a,alt:"Teachers2Parents"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"Welcome!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The Teachers2Parents app allows you to see all the messages that are sent to you from your child\u2019s school as well as any notices that they might have posted to announce or remind you of upcoming events. A term calendar is also available to you, so that you can easily keep track of any notable dates."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page",key:"messages"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page__icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_9_components_assets_images_teachers_guide_messages_svg___default.a,alt:"Messages"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"Messages"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The messages section allows you to read any messages that have been sent to you from your child\u2019s school."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Any new messages will appear at the bottom of the screen; you will also be able to scroll up to see any previous messages you have received."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page",key:"noticeboard"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page__icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_10_components_assets_images_teachers_guide_noticeboard_svg___default.a,alt:"Noticeboard"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"Noticeboard"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"In the Noticeboard section, you will be able to see any additional information or news updates that the school has posted. This could include any upcoming events or any general announcements that you might need to know about."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The school may send you notifications about some of these events or announcements to make sure that you are kept fully up-to-date."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page",key:"term_calendar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page__icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_8_components_assets_images_teachers_guide_term_calendar_svg___default.a,alt:"Term Calendar"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"Term Calendar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Schools can add their term dates to the Term Calendar so you always have them handy!"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page",key:"multi_school_support"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page__icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_11_components_assets_images_teachers_guide_multi_school_support_svg___default.a,alt:"Multiple School Support"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"Multi-School Support"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you have children at multiple schools that use the Teachers2Parents service, you can switch between schools with the school selector in each section of the app."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page",key:"built_in_verification"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page__icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_12_components_assets_images_teachers_guide_verification_svg___default.a,alt:"No Need for Message Verification"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"Built-in Verification"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"With our end to end encrypted messages, there is no need to verify the messages you receive."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page",key:"faq"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page__icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_13_components_assets_images_teachers_guide_faq_svg___default.a,alt:"FAQ"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"teachers-guide-page__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"FAQ"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:"/help/",onClick:_this.props.closeGuide},"Click Here")," to view our FAQs on why we have your phone number and what Teachers2Parents & Eduspot are.")))],_this.onClose=function(){_this.props.closeGuide();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Guide,[{key:"render",value:function render(){var _props=this.props,isOpen=_props.isOpen,close=_props.close;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_WelcomeGuide__["a" /* default */],{cssModifier:"teachers",logoPath:__WEBPACK_IMPORTED_MODULE_6_components_assets_images_teachers_teachers_logo_text_right_svg___default.a,isOpen:isOpen,onClose:close},this.guideChildren);}}]);return Guide;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_4_state_teachers_selectors__["w" /* isGuideOpen */])(state)};},{close:__WEBPACK_IMPORTED_MODULE_3_state_teachers_actions__["C" /* closeGuide */]})(Guide));

/***/ }),
/* 577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/teachers-logo--no-text.9e8fd35d.svg";

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/term-calendar.b51466e3.svg";

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/messages.7ec13ccb.svg";

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/noticeboard.1c9cad79.svg";

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/multi-school-support.4b19e471.svg";

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/verification.e5fb09e7.svg";

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/faq.aa343b5a.svg";

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_Preloader__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_school_money_guide_Guide__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_basket_BasketPage__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_dinners_DinnersPage__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_shop_ShopPage__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_school_money_history_HistoryPage__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_school_money_clubs_ClubsPage__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_school_money_payments_PaymentsPage__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_school_money_parental_consent_ParentalConsentPage__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_school_money_ParentEmailInputPage__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SchoolMoneyPage_css__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SchoolMoneyPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__SchoolMoneyPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SchoolMoneyPage=function(_React$Component){_inherits(SchoolMoneyPage,_React$Component);function SchoolMoneyPage(){_classCallCheck(this,SchoolMoneyPage);return _possibleConstructorReturn(this,(SchoolMoneyPage.__proto__||Object.getPrototypeOf(SchoolMoneyPage)).apply(this,arguments));}_createClass(SchoolMoneyPage,[{key:"render",value:function render(){var showParentEmailPage=this.props.showParentEmailPage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money"},showParentEmailPage?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_school_money_ParentEmailInputPage__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_Preloader__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_school_money_guide_Guide__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Redirect */],{exact:true,from:"/school_money/",to:"/school_money/dinners/"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:"/school_money/dinners/:studentID?/:paymentID?/",component:__WEBPACK_IMPORTED_MODULE_7_components_school_money_dinners_DinnersPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:"/school_money/dinners/:studentID?/",component:__WEBPACK_IMPORTED_MODULE_7_components_school_money_dinners_DinnersPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:"/school_money/history/:studentID?/",component:__WEBPACK_IMPORTED_MODULE_9_components_school_money_history_HistoryPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:"/school_money/basket/",component:__WEBPACK_IMPORTED_MODULE_6_components_school_money_basket_BasketPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:"/school_money/shop/:studentID?/",component:__WEBPACK_IMPORTED_MODULE_8_components_school_money_shop_ShopPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:"/school_money/clubs/:studentID?/:paymentID?/",component:__WEBPACK_IMPORTED_MODULE_10_components_school_money_clubs_ClubsPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:"/school_money/clubs/:studentID?/",component:__WEBPACK_IMPORTED_MODULE_10_components_school_money_clubs_ClubsPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:"/school_money/payments/:studentID?/:paymentID?/",component:__WEBPACK_IMPORTED_MODULE_11_components_school_money_payments_PaymentsPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:"/school_money/payments/:studentID?/",component:__WEBPACK_IMPORTED_MODULE_11_components_school_money_payments_PaymentsPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */],{path:"/school_money/parental_consent/:studentID?/",component:__WEBPACK_IMPORTED_MODULE_12_components_school_money_parental_consent_ParentalConsentPage__["a" /* default */]}))));}}]);return SchoolMoneyPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{showParentEmailPage:!Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["a" /* areAllParentEmailAddressesSet */])(state)};})(SchoolMoneyPage));

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_date__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_WelcomeGuide__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Guide_css__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Guide_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Guide_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_assets_images_school_money_school_money_logo_text_right_svg__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_assets_images_school_money_school_money_logo_text_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_assets_images_school_money_school_money_logo_text_right_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_assets_images_school_money_school_money_logo_no_text_svg__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_assets_images_school_money_school_money_logo_no_text_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_assets_images_school_money_school_money_logo_no_text_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_assets_images_school_money_guide_clubs_svg__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_assets_images_school_money_guide_clubs_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_assets_images_school_money_guide_clubs_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_assets_images_school_money_guide_dinners_svg__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_assets_images_school_money_guide_dinners_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_assets_images_school_money_guide_dinners_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_assets_images_school_money_guide_history_svg__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_assets_images_school_money_guide_history_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_assets_images_school_money_guide_history_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_assets_images_school_money_guide_payments_svg__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_assets_images_school_money_guide_payments_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_assets_images_school_money_guide_payments_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_assets_images_school_money_guide_shop_svg__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_assets_images_school_money_guide_shop_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_components_assets_images_school_money_guide_shop_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_assets_images_school_money_guide_parental_consent_svg__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_assets_images_school_money_guide_parental_consent_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_components_assets_images_school_money_guide_parental_consent_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Guide=function(_React$Component){_inherits(Guide,_React$Component);function Guide(){_classCallCheck(this,Guide);return _possibleConstructorReturn(this,(Guide.__proto__||Object.getPrototypeOf(Guide)).apply(this,arguments));}_createClass(Guide,[{key:"render",value:function render(){var _props=this.props,isOpen=_props.isOpen,onClose=_props.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_WelcomeGuide__["a" /* default */],{cssModifier:"school_money",logoPath:__WEBPACK_IMPORTED_MODULE_7_components_assets_images_school_money_school_money_logo_text_right_svg___default.a,isOpen:isOpen,onClose:onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page__icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_8_components_assets_images_school_money_school_money_logo_no_text_svg___default.a,alt:"SchoolMoney"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page__title"},"Welcome!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The SchoolMoney app has been designed with you - the parents and guardians - in mind. SchoolMoney allows you to make payments and bookings easily and securely, keeping all of your children\u2019s information in one place no matter which school they attend."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page__icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_12_components_assets_images_school_money_guide_payments_svg___default.a,alt:"payments"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"school_money-guide-page__title"},"Payments"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"When your child\u2019s school sends you payment requests, you can use the SchoolMoney app to manage these payments and make transactions at a time and place that suits you. To add an item to the basket, select the plus sign next to the relevant payment."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page__icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_10_components_assets_images_school_money_guide_dinners_svg___default.a,alt:"dinners"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"school_money-guide-page__title"},"Dinners"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The Dinners section of our app enables you to make top-ups or bookings onto your child\u2019s dinner money account. From here you can manage your child\u2019s meals, credits and debts."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page__icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_9_components_assets_images_school_money_guide_clubs_svg___default.a,alt:"clubs"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"school_money-guide-page__title"},"Clubs"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The Clubs section allows you to manage any clubs that your child might attend such as breakfast or after school club. Through this section you can make payments, reservations and bookings for your child once the places open up."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page__icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_13_components_assets_images_school_money_guide_shop_svg___default.a,alt:"shop"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"school_money-guide-page__title"},"Shop"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Within the shop, your child\u2019s school can set up items for you to purchase online such as uniform, bookbags or concert DVDs. These items will sit in your account under Shop should you ever wish to purchase them."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page__icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_11_components_assets_images_school_money_guide_history_svg___default.a,alt:"history"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"school_money-guide-page__title"},"History"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Within the History section you will be able to see all of the transactions that you have made on the SchoolMoney system. This will show both online payments and any cash/cheque payments you may have made directly to the school."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page__icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_14_components_assets_images_school_money_guide_parental_consent_svg___default.a,alt:"parental consent"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school_money-guide-page__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"school_money-guide-page__title"},"Parental Consent"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The Parental Consent section of the app enables parents to view and manage the consent that they have given, or still need to give towards various trips/clubs. Parents can add consent as needed."))));}}]);return Guide;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_93" /* isGuideOpen */])(state)};},{onClose:function onClose(){return Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_50" /* closeGuide */])(Object(__WEBPACK_IMPORTED_MODULE_2_lib_date__["c" /* nowString */])());}})(Guide));

/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/school_money-logo--no-text.c4776dc0.svg";

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/clubs.560a3dfc.svg";

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dinners.a83d4e8e.svg";

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/history.82650fbf.svg";

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/payments.3946f741.svg";

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shop.b348042f.svg";

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/parental-consent.417d81ae.svg";

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_school_money_Preloader__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ScrollableContainer__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_List__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_basket_BasketItemsIssuesModal__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_basket_SchoolBasket__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_school_money_basket_checkout_CheckoutWindow__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BasketPage_css__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BasketPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__BasketPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BasketPage=function(_React$Component){_inherits(BasketPage,_React$Component);function BasketPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BasketPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BasketPage.__proto__||Object.getPrototypeOf(BasketPage)).call.apply(_ref,[this].concat(args))),_this),_this.isReady=function(){return!_this.props.isValidating;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BasketPage,[{key:"render",value:function render(){var _props=this.props,isValid=_props.isValid,schoolIDs=_props.schoolIDs,isCheckoutWindowOpen=_props.isCheckoutWindowOpen,checkoutSchoolID=_props.checkoutSchoolID;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_school_money_Preloader__["a" /* default */],{isPageReady:this.isReady},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"page-header__title"},"Basket")),isValid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ScrollableContainer__["a" /* default */],{className:"basket-school-list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_List__["a" /* default */],{placeholder:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Placeholder,null)},schoolIDs.map(function(schoolID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_basket_SchoolBasket__["a" /* default */],{key:schoolID,schoolID:schoolID});}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_basket_BasketItemsIssuesModal__["a" /* default */],null),isCheckoutWindowOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_school_money_basket_checkout_CheckoutWindow__["a" /* default */],{schoolID:checkoutSchoolID}):null));}}]);return BasketPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{schoolIDs:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_35" /* getSchoolsHavingBasketItems */])(state),isValidating:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_70" /* isBasketItemsValidating */])(state),isValid:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_69" /* isBasketItemsValid */])(state),isCheckoutWindowOpen:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_71" /* isCheckoutWindowOpen */])(state),checkoutSchoolID:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["D" /* getCheckoutSchoolID */])(state)};})(BasketPage));var Placeholder=function(_React$Component2){_inherits(Placeholder,_React$Component2);function Placeholder(){_classCallCheck(this,Placeholder);return _possibleConstructorReturn(this,(Placeholder.__proto__||Object.getPrototypeOf(Placeholder)).apply(this,arguments));}_createClass(Placeholder,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-school-list__placeholder"},"There are no items in the basket.")));}}]);return Placeholder;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ScrollableContainer__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentName__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_basket_BasketItemIssue__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BasketItemsIssuesModal_css__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BasketItemsIssuesModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__BasketItemsIssuesModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BasketItemsIssuesModal=function(_React$Component){_inherits(BasketItemsIssuesModal,_React$Component);function BasketItemsIssuesModal(){_classCallCheck(this,BasketItemsIssuesModal);return _possibleConstructorReturn(this,(BasketItemsIssuesModal.__proto__||Object.getPrototypeOf(BasketItemsIssuesModal)).apply(this,arguments));}_createClass(BasketItemsIssuesModal,[{key:"getReasonHeading",value:function getReasonHeading(reason){switch(reason){case"expired":return"Expired";case"limited_places":return"Places Unavailable";case"out_of_stock":return"Out of Stock";case"insufficient_stock":return"Insufficient Stock";case"bookings_changed":return"Bookings Updated by School";default:return"Other";}}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ModalDialog__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-items-issues"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-items-issues__heading"},"Important Message!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"basket-items-issues__description"},"The following items in your basket are no longer available.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Below are the items affected."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",{className:"basket-items-issues__student-hr"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ScrollableContainer__["a" /* default */],{className:"basket-items-issues__body"},this.props.issuesByStudentAndReason.map(function(issuesByReason,studentID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-items-issues__student",key:studentID},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-items-issues__student-name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentName__["a" /* default */],{studentID:studentID})),issuesByReason.map(function(issues,reason){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-items-issues__reason",key:reason},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-items-issues__reason-heading"},_this2.getReasonHeading(reason)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-items-issues__items"},issues.map(function(issue){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_basket_BasketItemIssue__["a" /* default */],Object.assign({key:issue.get("itemType")+":"+issue.get("basketItemID")},issue.toObject()));})));}).toList());}).toList().interpose(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",{className:"basket-items-issues__student-hr"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",{className:"basket-items-issues__student-hr"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-items-issues__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Button__["a" /* default */],{className:"basket-items-issues__resolve-button",onClick:this.props.resolveBasketItemsIssues},"Update"))));}}]);return BasketItemsIssuesModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{issuesByStudentAndReason:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["x" /* getBasketItemsIssuesByStudentAndReason */])(state)};},{resolveBasketItemsIssues:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_92" /* resolveBasketItemsIssues */]})(BasketItemsIssuesModal));

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Date__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BasketItemIssue_css__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BasketItemIssue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__BasketItemIssue_css__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BasketItemIssue=function(_React$Component){_inherits(BasketItemIssue,_React$Component);function BasketItemIssue(){_classCallCheck(this,BasketItemIssue);return _possibleConstructorReturn(this,(BasketItemIssue.__proto__||Object.getPrototypeOf(BasketItemIssue)).apply(this,arguments));}_createClass(BasketItemIssue,[{key:"getClubBookingDescription",value:function getClubBookingDescription(payload){var _payload$get$toObject=payload.get("clubBooking").toObject(),description=_payload$get$toObject.description,startDate=_payload$get$toObject.startDate;return[description,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"W/C ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Date__["a" /* default */],{date:startDate}))];}},{key:"getDinnerBookingDescription",value:function getDinnerBookingDescription(payload){var _payload$get$toObject2=payload.get("dinnerBooking").toObject(),description=_payload$get$toObject2.description,startDate=_payload$get$toObject2.startDate;return[description,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"W/C ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Date__["a" /* default */],{date:startDate}))];}},{key:"getPaymentInstallmentDescription",value:function getPaymentInstallmentDescription(payload){var _payload$toObject=payload.toObject(),payment=_payload$toObject.payment,installmentNumber=_payload$toObject.installmentNumber;var _payment$toObject=payment.toObject(),description=_payment$toObject.description,installments=_payment$toObject.installments;var _installments$get$toO=installments.get(installmentNumber).toObject(),dueDate=_installments$get$toO.dueDate;var firstLine=description+" (instalment "+installmentNumber+")";return[firstLine,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Due ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Date__["a" /* default */],{date:dueDate}))];}},{key:"getShopItemDescription",value:function getShopItemDescription(payload){var _payload$toObject2=payload.toObject(),quantity=_payload$toObject2.quantity,shopItem=_payload$toObject2.shopItem;return[shopItem.get("name"),"Quantity x"+quantity];}},{key:"getItemDescription",value:function getItemDescription(){var _props$basketItem$toO=this.props.basketItem.toObject(),type=_props$basketItem$toO.type,payload=_props$basketItem$toO.payload;switch(type){case"clubBooking":return this.getClubBookingDescription(payload);case"dinnerBooking":return this.getDinnerBookingDescription(payload);case"payment":return this.getPaymentInstallmentDescription(payload);case"shopItem":return this.getShopItemDescription(payload);default:return"";}}},{key:"render",value:function render(){var _getItemDescription=this.getItemDescription(),_getItemDescription2=_slicedToArray(_getItemDescription,2),firstLine=_getItemDescription2[0],secondLine=_getItemDescription2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-item-issue"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-item-issue__first-line"},firstLine),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-item-issue__second-line"},secondLine));}}]);return BasketItemIssue;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var itemType=_ref.itemType,basketItemID=_ref.basketItemID;return{basketItem:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["t" /* getBasketItemByID */])(state,itemType,basketItemID)};})(BasketItemIssue));

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ExpandingBox__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_SchoolLogo__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_basket_StudentBasketItemList__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_school_money_basket_MinimumPaymentAmountAlert__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_app_alert_AlertModal__ = __webpack_require__(624);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DINNER_ALERT_TEXT="Important: Your student's outstanding dinner arrears will be paid off first. You can still make future bookings, but they may require payment. Please reach out if you have any questions.";var SchoolBasket=function(_React$Component){_inherits(SchoolBasket,_React$Component);function SchoolBasket(props){_classCallCheck(this,SchoolBasket);var _this=_possibleConstructorReturn(this,(SchoolBasket.__proto__||Object.getPrototypeOf(SchoolBasket)).call(this,props));_this.onMinimumPaymentAmountAlertClose=function(){_this.setState({isTotalPriceValid:true});};_this.expand=function(){_this.props.setExpandedSchoolBasket(_this.props.schoolID);};_this.collapse=function(){_this.props.setExpandedSchoolBasket(null);};_this.startCheckout=function(){var _this$props=_this.props,totalPrice=_this$props.totalPrice,minimumPaymentAmount=_this$props.minimumPaymentAmount;if(totalPrice>0&&totalPrice<minimumPaymentAmount){_this.setState({isTotalPriceValid:false});return;}_this.props.startCheckout(_this.props.schoolID);};_this.onPayButtonClick=function(event){// we've handled this event, so don't allow it to propagate, e.g. to ExpandingBox
// TODO: find a better way of doing this, as stopPropagation could be problematic
event.stopPropagation();var basketHasDinnerBookingWithArrear=_this.props.basketHasDinnerBookingWithArrear;if(basketHasDinnerBookingWithArrear){_this.setState({displayDinnerArrearPaymentAlert:true});return;}_this.startCheckout();};_this.onDinnerAlertModalClose=function(){_this.setState({displayDinnerArrearPaymentAlert:false});_this.startCheckout();};_this.state={isTotalPriceValid:true,displayDinnerArrearPaymentAlert:false};return _this;}_createClass(SchoolBasket,[{key:"render",value:function render(){var _props=this.props,school=_props.school,studentIDs=_props.studentIDs,totalPrice=_props.totalPrice,isExpanded=_props.isExpanded,creditUsed=_props.creditUsed,minimumPaymentAmount=_props.minimumPaymentAmount;var showCreditUsed=Object.values(creditUsed).some(function(amount){return amount>0;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ExpandingBox__["a" /* default */],{cssModifier:"school_money",expanded:isExpanded,onExpand:this.expand,onCollapse:this.collapse},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ExpandingBox__["a" /* default */].Header,{toggleOnClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-basket__header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_SchoolLogo__["a" /* default */],{school:school,cssBlockName:"school-basket"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-basket__school-name"},school.get("name")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-basket__header-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-basket__total-price"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-basket__total-price-label"},"Total To Pay:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Currency__["a" /* default */],{className:"school-basket__total-price-amount",amount:totalPrice}),minimumPaymentAmount>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-basket__minimum-payment-amount-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-basket__minimum-payment-amount-label"},"Minimum total amount allowed:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Currency__["a" /* default */],{className:"school-basket__minimum-payment-amount",amount:minimumPaymentAmount})):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Button__["a" /* default */],{className:"school-basket__pay-button",onClick:this.onPayButtonClick},"Pay"))),showCreditUsed?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-basket__header-row school-basket__credit-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-basket__dinners-credit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-basket__dinners-credit-label"},"Dinner Credit"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Currency__["a" /* default */],{className:"school-basket__dinners-credit-amount",amount:creditUsed.dinners})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-basket__clubs-credit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-basket__clubs-credit-label"},"Club Credit"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Currency__["a" /* default */],{className:"school-basket__clubs-credit-amount",amount:creditUsed.clubs}))):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ExpandingBox__["a" /* default */].Body,{toggleOnClick:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",{className:"school-basket__body-hr"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"school-basket__body"},studentIDs.map(function(studentID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_basket_StudentBasketItemList__["a" /* default */],{key:studentID,studentID:studentID});})))),!this.state.isTotalPriceValid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_school_money_basket_MinimumPaymentAmountAlert__["a" /* default */],{minimumPaymentAmount:minimumPaymentAmount,onClose:this.onMinimumPaymentAmountAlertClose}):null,this.state.displayDinnerArrearPaymentAlert?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_app_alert_AlertModal__["a" /* default */],{alertText:DINNER_ALERT_TEXT,onClose:this.onDinnerAlertModalClose}):null);}}]);return SchoolBasket;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var schoolID=_ref.schoolID;return{school:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_29" /* getSchoolByID */])(state,schoolID),studentIDs:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_60" /* getStudentsHavingBasketItems */])(state,schoolID),totalPrice:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_28" /* getSchoolBasketTotalToPay */])(state,schoolID),isExpanded:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_107" /* isSchoolBasketExpanded */])(state,schoolID),creditUsed:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["S" /* getCreditUsedInBasket */])(state,schoolID),minimumPaymentAmount:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_12" /* getMinimumPaymentAmount */])(state,schoolID),basketHasDinnerBookingWithArrear:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["b" /* basketHasDinnerBookingWithArrear */])(state,schoolID)};},{setExpandedSchoolBasket:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_105" /* setExpandedSchoolBasket */],startCheckout:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_110" /* startCheckout */]})(SchoolBasket));

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_school_money_StudentName__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_basket_BasketItemGroup__ = __webpack_require__(604);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StudentBasketItemList=function(_React$Component){_inherits(StudentBasketItemList,_React$Component);function StudentBasketItemList(){_classCallCheck(this,StudentBasketItemList);return _possibleConstructorReturn(this,(StudentBasketItemList.__proto__||Object.getPrototypeOf(StudentBasketItemList)).apply(this,arguments));}_createClass(StudentBasketItemList,[{key:"render",value:function render(){var _props=this.props,studentID=_props.studentID,basketItemGroups=_props.basketItemGroups;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"student-basket-item-list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"student-basket-item-list__header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"student-basket-item-list__student-name"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_school_money_StudentName__["a" /* default */],{studentID:studentID}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"student-basket-item-list__body"},basketItemGroups.map(function(basketItemGroup,groupID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_basket_BasketItemGroup__["a" /* default */],{key:groupID,basketItemGroup:basketItemGroup});})));}}]);return StudentBasketItemList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var studentID=_ref.studentID;return{basketItemGroups:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["u" /* getBasketItemGroupList */])(state,studentID)};})(StudentBasketItemList));

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_school_money_basket_items_clubBooking_ClubBooking__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_school_money_basket_items_dinnerBooking_DinnerBooking__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_school_money_basket_items_payment_Payment__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_basket_items_shopItem_ShopItem__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_school_money_basket_items_creditTopUp_CreditTopUp__ = __webpack_require__(620);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BasketItemGroup=function(_React$Component){_inherits(BasketItemGroup,_React$Component);function BasketItemGroup(){_classCallCheck(this,BasketItemGroup);return _possibleConstructorReturn(this,(BasketItemGroup.__proto__||Object.getPrototypeOf(BasketItemGroup)).apply(this,arguments));}_createClass(BasketItemGroup,[{key:"renderItemDetail",value:function renderItemDetail(){var basketItemGroup=this.props.basketItemGroup;var _basketItemGroup$toOb=basketItemGroup.toObject(),type=_basketItemGroup$toOb.type,groupID=_basketItemGroup$toOb.groupID,items=_basketItemGroup$toOb.items,totalPrice=_basketItemGroup$toOb.totalPrice;var payloads=items.map(function(item){return item.get("payload");});// for simple groups that only ever have one item and pass their whole payload
var payload=payloads.first().toObject();switch(type){case"clubBooking":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_school_money_basket_items_clubBooking_ClubBooking__["a" /* default */],Object.assign({},payload,{price:totalPrice}));case"dinnerBooking":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_school_money_basket_items_dinnerBooking_DinnerBooking__["a" /* default */],Object.assign({},payload,{price:totalPrice}));case"payment":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_school_money_basket_items_payment_Payment__["a" /* default */],{paymentID:groupID,installments:payloads,totalPrice:totalPrice});case"shopItem":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_basket_items_shopItem_ShopItem__["a" /* default */],Object.assign({},payload,{price:totalPrice}));case"creditTopUp":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_school_money_basket_items_creditTopUp_CreditTopUp__["a" /* default */],Object.assign({},payload,{amount:totalPrice}));default:return null;}}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-item-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",{className:"basket-item-group__hr"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"basket-item-group__body"},this.renderItemDetail()));}}]);return BasketItemGroup;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BasketItemGroup);

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Date__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_RemoveButton__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ClubBooking_css__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ClubBooking_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ClubBooking_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClubBooking=function(_React$Component){_inherits(ClubBooking,_React$Component);function ClubBooking(){_classCallCheck(this,ClubBooking);return _possibleConstructorReturn(this,(ClubBooking.__proto__||Object.getPrototypeOf(ClubBooking)).apply(this,arguments));}_createClass(ClubBooking,[{key:"render",value:function render(){var _props=this.props,clubBooking=_props.clubBooking,price=_props.price,reserve=_props.reserve;var _clubBooking$toObject=clubBooking.toObject(),description=_clubBooking$toObject.description,startDate=_clubBooking$toObject.startDate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"club-booking-basket-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"club-booking-basket-item__label"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"club-booking-basket-item__description"},description,reserve?" (reservation)":""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"club-booking-basket-item__date"},"W/C ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Date__["a" /* default */],{date:startDate}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"club-booking-basket-item__price"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Currency__["a" /* default */],{className:"club-booking-basket-item__amount",amount:price}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_RemoveButton__["a" /* default */],{className:"club-booking-basket-item__remove-button",onClick:this.props.remove})));}}]);return ClubBooking;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var clubBookingID=_ref.clubBookingID;return{clubBooking:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["I" /* getClubBookingByID */])(state,clubBookingID)};},function(dispatch,_ref2){var clubBookingID=_ref2.clubBookingID;return{remove:function remove(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_87" /* removeClubBookingFromBasket */])(clubBookingID));}};})(ClubBooking));

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/item-remove.c67db317.svg";

/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Date__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_RemoveButton__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DinnerBooking_css__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DinnerBooking_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DinnerBooking_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DinnerBooking=function(_React$Component){_inherits(DinnerBooking,_React$Component);function DinnerBooking(){_classCallCheck(this,DinnerBooking);return _possibleConstructorReturn(this,(DinnerBooking.__proto__||Object.getPrototypeOf(DinnerBooking)).apply(this,arguments));}_createClass(DinnerBooking,[{key:"render",value:function render(){var _props=this.props,dinnerBooking=_props.dinnerBooking,price=_props.price;var _dinnerBooking$toJS=dinnerBooking.toJS(),description=_dinnerBooking$toJS.description,startDate=_dinnerBooking$toJS.startDate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinner-booking-basket-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinner-booking-basket-item__label"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinner-booking-basket-item__description"},description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinner-booking-basket-item__date"},"W/C ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Date__["a" /* default */],{date:startDate}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinner-booking-basket-item__price"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Currency__["a" /* default */],{className:"dinner-booking-basket-item__amount",amount:price}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_RemoveButton__["a" /* default */],{className:"dinner-booking-basket-item__remove-button",onClick:this.props.remove})));}}]);return DinnerBooking;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var dinnerBookingID=_ref.dinnerBookingID;return{dinnerBooking:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["V" /* getDinnerBookingByID */])(state,dinnerBookingID)};},function(dispatch,_ref2){var dinnerBookingID=_ref2.dinnerBookingID;return{remove:function remove(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_89" /* removeDinnerBookingFromBasket */])(dinnerBookingID));}};})(DinnerBooking));

/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_basket_items_payment_PaymentInstallment__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Payment_css__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Payment_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Payment_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Payment=function(_React$Component){_inherits(Payment,_React$Component);function Payment(){_classCallCheck(this,Payment);return _possibleConstructorReturn(this,(Payment.__proto__||Object.getPrototypeOf(Payment)).apply(this,arguments));}_createClass(Payment,[{key:"render",value:function render(){var _props=this.props,payment=_props.payment,installments=_props.installments,totalPrice=_props.totalPrice;var _payment$toObject=payment.toObject(),description=_payment$toObject.description;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-basket-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-basket-item__header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-basket-item__description"},description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-basket-item__price"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-basket-item__price-amount"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Currency__["a" /* default */],{amount:totalPrice})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-basket-item__button-placeholder"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"payment-basket-item__installments"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,installments.map(function(payload){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_basket_items_payment_PaymentInstallment__["a" /* default */],{key:payload.get("installmentNumber"),paymentID:payload.get("paymentID"),installmentNumber:payload.get("installmentNumber")});}))));}}]);return Payment;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var paymentID=_ref.paymentID;return{payment:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_21" /* getPaymentByID */])(state,paymentID)};})(Payment));

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Date__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_RemoveButton__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentInstallment_css__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentInstallment_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__PaymentInstallment_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentInstallment=function(_React$Component){_inherits(PaymentInstallment,_React$Component);function PaymentInstallment(){_classCallCheck(this,PaymentInstallment);return _possibleConstructorReturn(this,(PaymentInstallment.__proto__||Object.getPrototypeOf(PaymentInstallment)).apply(this,arguments));}_createClass(PaymentInstallment,[{key:"render",value:function render(){var _props=this.props,selectedPrice=_props.selectedPrice,installment=_props.installment;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"payment-basket-item-installment"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"payment-basket-item-installment__due-date"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Date__["a" /* default */],{date:installment.dueDate})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"payment-basket-item-installment__price"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Currency__["a" /* default */],{className:"payment-basket-item-installment__price-amount",amount:selectedPrice})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"payment-basket-item-installment__button"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_RemoveButton__["a" /* default */],{className:"payment-basket-item-installment__remove-button",onClick:this.props.remove})));}}]);return PaymentInstallment;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var paymentID=_ref.paymentID,installmentNumber=_ref.installmentNumber;return{installment:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_23" /* getPaymentInstallment */])(state,paymentID,installmentNumber),selectedPrice:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_24" /* getPaymentInstallmentSelectedPrice */])(state,paymentID,installmentNumber)};},function(dispatch,_ref2){var paymentID=_ref2.paymentID,installmentNumber=_ref2.installmentNumber;return{remove:function remove(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_90" /* removePaymentInstallmentFromBasket */])(paymentID,installmentNumber));}};})(PaymentInstallment));

/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_school_money_RemoveButton__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_QuantitySelector__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ShopItem_css__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ShopItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ShopItem_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShopItem=function(_React$Component){_inherits(ShopItem,_React$Component);function ShopItem(){_classCallCheck(this,ShopItem);return _possibleConstructorReturn(this,(ShopItem.__proto__||Object.getPrototypeOf(ShopItem)).apply(this,arguments));}_createClass(ShopItem,[{key:"render",value:function render(){var _props=this.props,shopItem=_props.shopItem,price=_props.price,quantity=_props.quantity,maxQuantity=_props.maxQuantity;var name=shopItem.name;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shop-item-basket-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shop-item-basket-item__details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shop-item-basket-item__name"},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shop-item-basket-item__price"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Currency__["a" /* default */],{className:"shop-item-basket-item__price-amount",amount:price}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_school_money_RemoveButton__["a" /* default */],{className:"shop-item-basket-item__remove-button",onClick:this.props.remove}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shop-item-basket-item__quantity"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shop-item-basket-item__quantity-label"},"Quantity"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_QuantitySelector__["a" /* default */],{className:"shop-item-basket-item__quantity-selector",quantity:quantity,max:maxQuantity,onChange:this.props.setQuantity})));}}]);return ShopItem;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var studentID=_ref.studentID,shopItemID=_ref.shopItemID;return{shopItem:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_44" /* getShopItemByID */])(state,shopItemID),maxQuantity:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_46" /* getShopItemMaxBasketQuantity */])(state,shopItemID)};},function(dispatch,_ref2){var shopItemID=_ref2.shopItemID,studentID=_ref2.studentID;return{setQuantity:function setQuantity(quantity){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_108" /* setShopItemBasketQuantity */])(shopItemID,studentID,quantity));},remove:function remove(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_91" /* removeShopItemFromBasket */])(shopItemID,studentID));}};})(ShopItem));

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_IconButton__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_assets_images_school_money_arrow_left_svg__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_assets_images_school_money_arrow_left_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_assets_images_school_money_arrow_left_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_assets_images_school_money_arrow_right_svg__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_assets_images_school_money_arrow_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_assets_images_school_money_arrow_right_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__QuantitySelector_css__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__QuantitySelector_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__QuantitySelector_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QuantitySelector=function(_React$Component){_inherits(QuantitySelector,_React$Component);function QuantitySelector(){var _ref;var _temp,_this,_ret;_classCallCheck(this,QuantitySelector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=QuantitySelector.__proto__||Object.getPrototypeOf(QuantitySelector)).call.apply(_ref,[this].concat(args))),_this),_this.increase=function(){_this.onChange(_this.props.quantity+1);},_this.decrease=function(){_this.onChange(_this.props.quantity-1);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(QuantitySelector,[{key:"canChangeTo",value:function canChangeTo(newQuantity){var _props=this.props,quantity=_props.quantity,min=_props.min,max=_props.max;return(// don't fire onChange if the value is the same
newQuantity!==quantity&&// check min and max bounds
newQuantity>=min&&newQuantity<=max);}},{key:"onChange",value:function onChange(newQuantity){if(this.canChangeTo(newQuantity)){this.props.onChange(newQuantity,this.props.quantity);}}},{key:"render",value:function render(){var _props2=this.props,quantity=_props2.quantity,className=_props2.className;var canIncrease=this.canChangeTo(quantity+1);var canDecrease=this.canChangeTo(quantity-1);var classNames=["quantity-selector"];if(className){classNames.push(className);}if(!canIncrease){classNames.push("quantity-selector--no-increase");}if(!canDecrease){classNames.push("quantity-selector--no-decrease");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_IconButton__["a" /* default */],{className:"quantity-selector__arrow quantity-selector__arrow--decrease",src:__WEBPACK_IMPORTED_MODULE_3_components_assets_images_school_money_arrow_left_svg___default.a,onClick:this.decrease}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"quantity-selector__quantity"},this.props.quantity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_IconButton__["a" /* default */],{className:"quantity-selector__arrow quantity-selector__arrow--increase",src:__WEBPACK_IMPORTED_MODULE_4_components_assets_images_school_money_arrow_right_svg___default.a,onClick:this.increase}));}}]);return QuantitySelector;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);QuantitySelector.propTypes={quantity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,min:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,max:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,// onChange args: (newQuantity, oldQuantity)
onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired};QuantitySelector.defaultProps={min:1,max:Infinity};/* harmony default export */ __webpack_exports__["a"] = (QuantitySelector);

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrow-left.92be9eb6.svg";

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrow-right.cf09d4cf.svg";

/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_school_money_RemoveButton__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreditTopUp_css__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreditTopUp_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CreditTopUp_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreditTopUp=function(_React$Component){_inherits(CreditTopUp,_React$Component);function CreditTopUp(){_classCallCheck(this,CreditTopUp);return _possibleConstructorReturn(this,(CreditTopUp.__proto__||Object.getPrototypeOf(CreditTopUp)).apply(this,arguments));}_createClass(CreditTopUp,[{key:"getLabel",value:function getLabel(){switch(this.props.creditType){case"dinner_money":return"Dinner Credit Top Up";case"club_extended_services":return"Club Credit Top Up";case"external_top_up":return this.props.externalCashlessName+" Top Up";default:return"Credit Top Up";}}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"credit-basket-item-detail"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"credit-basket-item-detail__label"},this.getLabel()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"credit-basket-item-detail__price"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Currency__["a" /* default */],{className:"credit-basket-item-detail__amount",amount:this.props.amount}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_school_money_RemoveButton__["a" /* default */],{className:"credit-basket-item-detail__remove-button",onClick:this.props.remove})));}}]);return CreditTopUp;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var studentID=_ref.studentID;return{externalCashlessName:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_4" /* getExternalCashlessName */])(state,Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_56" /* getStudentSchoolID */])(state,studentID))};},function(dispatch,_ref2){var creditType=_ref2.creditType,studentID=_ref2.studentID;return{remove:function remove(){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_88" /* removeCreditTopUpFromBasket */])(creditType,studentID));}};})(CreditTopUp));

/***/ }),
/* 621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MinimumPaymentAmountAlert_css__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MinimumPaymentAmountAlert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__MinimumPaymentAmountAlert_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MinimumPaymentAmountAlert=function(_React$Component){_inherits(MinimumPaymentAmountAlert,_React$Component);function MinimumPaymentAmountAlert(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MinimumPaymentAmountAlert);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MinimumPaymentAmountAlert.__proto__||Object.getPrototypeOf(MinimumPaymentAmountAlert)).call.apply(_ref,[this].concat(args))),_this),_this.onOKClick=function(){_this.props.onClose(true);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MinimumPaymentAmountAlert,[{key:"render",value:function render(){var _props=this.props,isOpen=_props.isOpen,minimumPaymentAmount=_props.minimumPaymentAmount;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ModalDialog__["a" /* default */],{isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"minimum-payment-amount__title"},"Alert"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"minimum-payment-amount__message"},"Please make your payment at least \xA3",minimumPaymentAmount/100),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"minimum-payment-amount__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Button__["a" /* default */],{className:"minimum-payment-amount__ok-button",onClick:this.onOKClick},"OK"))));}}]);return MinimumPaymentAmountAlert;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);MinimumPaymentAmountAlert.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,minimumPaymentAmount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired};MinimumPaymentAmountAlert.defaultProps={isOpen:true};/* harmony default export */ __webpack_exports__["a"] = (MinimumPaymentAmountAlert);

/***/ }),
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AlertModal_css__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AlertModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AlertModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AlertModal=function(_React$Component){_inherits(AlertModal,_React$Component);function AlertModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AlertModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AlertModal.__proto__||Object.getPrototypeOf(AlertModal)).call.apply(_ref,[this].concat(args))),_this),_this.onClose=function(){_this.props.onClose(true);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AlertModal,[{key:"render",value:function render(){var _props=this.props,isOpen=_props.isOpen,alertTitle=_props.alertTitle,alertText=_props.alertText;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ModalDialog__["a" /* default */],{isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"alert-modal__title"},alertTitle===undefined?"Alert":alertTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"alert-modal__message"},alertText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"alert-modal__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Button__["a" /* default */],{className:"alert-modal__ok-button",onClick:this.onClose},"OK"))));}}]);return AlertModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);AlertModal.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,alertTitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,alertText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};AlertModal.defaultProps={isOpen:true};/* harmony default export */ __webpack_exports__["a"] = (AlertModal);

/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_basket_checkout_paysafe_PaymentForm__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_school_money_basket_checkout_secure_trading_PSD2PaymentForm__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_basket_checkout_CheckoutInformationModal__ = __webpack_require__(648);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CheckoutWindow=function(_React$Component){_inherits(CheckoutWindow,_React$Component);function CheckoutWindow(){_classCallCheck(this,CheckoutWindow);return _possibleConstructorReturn(this,(CheckoutWindow.__proto__||Object.getPrototypeOf(CheckoutWindow)).apply(this,arguments));}_createClass(CheckoutWindow,[{key:"render",value:function render(){var paymentProvider=this.props.paymentProvider;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_ModalDialog__["a" /* default */],{fitScreen:true},paymentProvider==="ps"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_basket_checkout_paysafe_PaymentForm__["a" /* default */],{schoolID:this.props.schoolID}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_school_money_basket_checkout_secure_trading_PSD2PaymentForm__["a" /* default */],{schoolID:this.props.schoolID})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_basket_checkout_CheckoutInformationModal__["a" /* default */],null));}}]);return CheckoutWindow;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var schoolID=_ref.schoolID;return{paymentProvider:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_113" /* paymentProvider */])(state,schoolID)};})(CheckoutWindow));

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_validate__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_school_money_basket_checkout_paysafe_paysafe__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_SchoolLogo__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaymentForm_css__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaymentForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__PaymentForm_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_assets_images_cvv_svg__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_assets_images_cvv_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_assets_images_cvv_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_assets_images_accepted_card_logos_svg__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_assets_images_accepted_card_logos_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_assets_images_accepted_card_logos_svg__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var paysafeLogo="https://developer.paysafe.com/fileadmin/content/logos/powered_by_Paysafe_standard.png";var PaymentForm=function(_React$Component){_inherits(PaymentForm,_React$Component);function PaymentForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PaymentForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PaymentForm.__proto__||Object.getPrototypeOf(PaymentForm)).call.apply(_ref,[this].concat(args))),_this),_this.instance=undefined,_this.state={cardholderName:"",isFieldValid:{CardholderName:false,CardNumber:false,Cvv:false,ExpiryDate:false},isFieldHighlighted:{CardholderName:false,CardNumber:false,Cvv:false,ExpiryDate:false}},_this.onCardholderNameChange=function(event){var value=event.target.value;var isValid=!Object(__WEBPACK_IMPORTED_MODULE_2_lib_validate__["f" /* isStringEmpty */])(value);_this.setState({cardholderName:value});_this.setFieldState("CardholderName",isValid);_this.unhighlightField("CardholderName");},_this.pay=function(){if(_this.isAllValid()){__WEBPACK_IMPORTED_MODULE_3_components_school_money_basket_checkout_paysafe_paysafe__["c" /* tokenize */](_this.instance,_this.props.totalToPay,_this.props.school,_this.state.cardholderName).then(function(result){_this.props.processTransaction(result.token,_this.state.cardholderName);},_this.props.onError);}else{_this.highlightInvalidFields();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PaymentForm,[{key:"isAllValid",value:function isAllValid(){return Object.values(this.state.isFieldValid).every(function(isValid){return isValid;});}},{key:"setFieldState",value:function setFieldState(fieldName,isValid){this.setState({isFieldValid:Object.assign({},this.state.isFieldValid,_defineProperty({},fieldName,isValid))});}},{key:"highlightInvalidFields",value:function highlightInvalidFields(){var isFieldHighlighted=Object.entries(this.state.isFieldValid).reduce(function(isFieldHighlighted,_ref2){var _ref3=_slicedToArray(_ref2,2),fieldName=_ref3[0],isValid=_ref3[1];return Object.assign({},isFieldHighlighted,_defineProperty({},fieldName,!isValid));},{});this.setState({isFieldHighlighted:isFieldHighlighted});}},{key:"unhighlightField",value:function unhighlightField(fieldName){this.setState({isFieldHighlighted:Object.assign({},this.state.isFieldHighlighted,_defineProperty({},fieldName,false))});}},{key:"componentDidMount",value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_3_components_school_money_basket_checkout_paysafe_paysafe__["b" /* setup */]().then(function(instance){_this2.instance=instance;instance.fields("cardNumber cvv expiryDate").on("Valid Invalid",function(instance,event){var isValid=event.type==="Valid";_this2.setFieldState(event.target.fieldName,isValid);});instance.fields("cardNumber cvv expiryDate").on("FieldValueChange",function(instance,event){_this2.unhighlightField(event.target.fieldName);});},this.props.onError);}},{key:"renderCardholderNameInput",value:function renderCardholderNameInput(){var isHighlighted=this.state.isFieldHighlighted.CardholderName;var classNames=["checkout-payment__input"];if(isHighlighted){classNames.push("checkout-payment__input--highlighted");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"checkout-payment__name-input",placeholder:"Your Name",value:this.state.cardholderName,onChange:this.onCardholderNameChange}));}},{key:"renderPaysafeInput",value:function renderPaysafeInput(fieldName,className){var isHighlighted=this.state.isFieldHighlighted[fieldName];var classNames=["checkout-payment__input",className];if(isHighlighted){classNames.push("checkout-payment__input--highlighted");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" "),id:"paysafe"+fieldName});}},{key:"render",value:function render(){var _props=this.props,school=_props.school,totalToPay=_props.totalToPay;var cssModifier=this.isAllValid()?"valid":"invalid";var classNames=["checkout-payment","checkout-payment--"+cssModifier];var isTestEnvironment=__WEBPACK_IMPORTED_MODULE_3_components_school_money_basket_checkout_paysafe_paysafe__["a" /* environment */]==="TEST";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__total-to-pay"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__total-to-pay-label"},"Total To Pay"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__total-to-pay-amount"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Currency__["a" /* default */],{amount:totalToPay}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__school"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_SchoolLogo__["a" /* default */],{cssBlockName:"checkout-payment",school:school}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__input-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__input-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__input-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__input-label"},"Cardholder Name"),this.renderCardholderNameInput())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__input-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__input-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__input-label"},"Card Number",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"checkout-payment__card-logos",src:__WEBPACK_IMPORTED_MODULE_11_components_assets_images_accepted_card_logos_svg___default.a,alt:"Mastercard, Visa"})),this.renderPaysafeInput("CardNumber","checkout-payment__card-number"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__input-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__input-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__input-label"},"Expires"),this.renderPaysafeInput("ExpiryDate","checkout-payment__expiry-date")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__input-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__input-label"},"CVV ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"checkout-payment__cvv-icon",src:__WEBPACK_IMPORTED_MODULE_10_components_assets_images_cvv_svg___default.a,alt:"CVV"})),this.renderPaysafeInput("Cvv","checkout-payment__cvv")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Button__["a" /* default */],{className:"checkout-payment__cancel-button",onClick:this.props.onClose},"Cancel"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Button__["a" /* default */],{className:"checkout-payment__pay-button",onClick:this.pay},"Pay Now")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__footer"},"Powered by ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"checkout-payment__paysafe-logo",src:paysafeLogo,alt:"Paysafe"})),isTestEnvironment?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__environment-indicator"},"TEST environment"):null);}}]);return PaymentForm;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref4){var schoolID=_ref4.schoolID;return{school:Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_29" /* getSchoolByID */])(state,schoolID),totalToPay:Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["F" /* getCheckoutTotalToPay */])(state)};},{processTransaction:__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_84" /* processCheckoutTransaction */],onClose:__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_49" /* closeCheckout */],onError:__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_83" /* paysafeError */]})(PaymentForm));

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export apiKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return environment; });
/* harmony export (immutable) */ __webpack_exports__["b"] = setup;
/* harmony export (immutable) */ __webpack_exports__["c"] = tokenize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_log__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_paysafe_promise__ = __webpack_require__(629);
/**
 * PaymentForm requires Paysafe.js plugin from {@link module:lib/paysafe/promise}.
 * So as not to overcrowd the component file, this file contains all of the
 *   logic for setting up and handling the Paysafe plugin.
 */// get options from ENV
var apiKey="T1QtOTMyMTpCLXAxLTAtNWIwNDFiN2QtMC0zMDJjMDIxNDRkZGY4N2YwNDM4ZWRlY2YzYWMzYzYzNTlhYjQ2YmE5NDlkYmU4Y2EwMjE0MGJiOTJiNGQxNjU4ZTdmZWFmOGQ2ZGFiYjcxNmIyMTY1MmZhMDVmMQ==";var environment="LIVE";// helpful for debugging
__WEBPACK_IMPORTED_MODULE_0_lib_log__["a" /* default */].debug("paysafe API key:",apiKey);__WEBPACK_IMPORTED_MODULE_0_lib_log__["a" /* default */].debug("paysafe environment:",environment);/**
 * paysafe.fields.setup with our options.
 * @returns {Promise}
 */function setup(){return __WEBPACK_IMPORTED_MODULE_1_lib_paysafe_promise__["a" /* setup */](apiKey,{environment:environment,fields:{cardNumber:{selector:"#paysafeCardNumber",placeholder:"xxxx xxxx xxxx xxxx"},cvv:{selector:"#paysafeCvv",placeholder:"xxx"},expiryDate:{selector:"#paysafeExpiryDate",placeholder:"mm / yy"}},style:{"input":{"font-size":"14px"}}});}/**
 * paysafe~instance.tokenize with our options.
 * Require some details from the component.
 * @returns {Promise}
 */function tokenize(instance,amount,school,cardHolderName){return __WEBPACK_IMPORTED_MODULE_1_lib_paysafe_promise__["b" /* tokenize */](instance,{threeDS:{amount:amount,currency:"GBP",accountId:school.paysafeAccountNumber},value:{cardHolderName:cardHolderName}});}

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setup;
/* harmony export (immutable) */ __webpack_exports__["b"] = tokenize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lib_paysafe__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_paysafe_PaysafeError__ = __webpack_require__(631);
/**
 * @module lib/paysafe/promise
 * Paysafe's JS API is callback based. We would prefer to
 *   deal with promises since it's 2018 (get with the times, Paysafe).
 *//**
 * @param {string} apiKey single-use-token generating key
 * @param {Object} options setup options
 * @returns {Promise} resolve: instance, reject: error
 */function setup(apiKey,options){return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_0_lib_paysafe__["a" /* default */].fields.setup(apiKey,options,function(instance,error){if(error){reject(error);}else{resolve(instance);}});}).catch(function(error){throw new __WEBPACK_IMPORTED_MODULE_1_lib_paysafe_PaysafeError__["a" /* default */]("setup",error);});}/**
 * @param instance Paysafe instance returned from paysafe.fields.setup
 * @param options tokenize options
 * @returns {Promise} resolve: tokenize result, reject: error
 */function tokenize(instance,options){return new Promise(function(resolve,reject){instance.tokenize(options,function(instance,error,result){if(error){reject(error);}else{resolve(result);}});}).catch(function(error){throw new __WEBPACK_IMPORTED_MODULE_1_lib_paysafe_PaysafeError__["a" /* default */]("tokenize",error);});}

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * paysafe.js is imported in index.html and exposes `window.paysafe`.
 * This module serves only to provide that object as an export.
 * Importing the module is more clear then simply plucking it from thin (global) air.
 * Also eslint complains that it is undefined unless you use `window.paysafe`.
 *//* harmony default export */ __webpack_exports__["a"] = (window.paysafe);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaysafeError=function(_Error){_inherits(PaysafeError,_Error);function PaysafeError(stage,error){_classCallCheck(this,PaysafeError);var _this=_possibleConstructorReturn(this,(PaysafeError.__proto__||Object.getPrototypeOf(PaysafeError)).call(this,"PaysafeError: "+stage+": ["+error.code+"] "+error.detailedMessage));_this.stage=stage;_this.originalError=error;_this.code=error.code;_this.displayMessage=error.displayMessage;_this.detailedMessage=error.detailedMessage;_this.type=PaysafeError.type;// expose details property for BB reporting
_this.details=error;return _this;}return PaysafeError;}(Error);PaysafeError.type="PaysafeError";/* harmony default export */ __webpack_exports__["a"] = (PaysafeError);

/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cvv.d9f708f1.svg";

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/accepted-card-logos.dc8eec22.svg";

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_SchoolLogo__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_school_money_basket_checkout_secure_trading_CardHolderName__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_basket_checkout_secure_trading_CardDetails__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_school_money_entities_Checkout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_basket_checkout_PaymentSuccess__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_school_money_basket_checkout_PaymentStatus__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_school_money_basket_checkout_secure_trading_PaymentTypeSelector__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_assets_images_school_money_secure_trading_trust_payments_png__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_assets_images_school_money_secure_trading_trust_payments_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_assets_images_school_money_secure_trading_trust_payments_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_assets_images_school_money_school_money_logo_text_right_svg__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_assets_images_school_money_school_money_logo_text_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_components_assets_images_school_money_school_money_logo_text_right_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PSD2PaymentForm_css__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PSD2PaymentForm_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__PSD2PaymentForm_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PSD2PaymentForm=function(_React$Component){_inherits(PSD2PaymentForm,_React$Component);function PSD2PaymentForm(){_classCallCheck(this,PSD2PaymentForm);return _possibleConstructorReturn(this,(PSD2PaymentForm.__proto__||Object.getPrototypeOf(PSD2PaymentForm)).apply(this,arguments));}_createClass(PSD2PaymentForm,[{key:"getPaymentComponent",value:function getPaymentComponent(){var _props=this.props,walletPayJWTString=_props.walletPayJWTString,status=_props.status,userIdentity=_props.userIdentity;var isCardPayJWTSet=this.props.cardPayJWTString!==undefined;if(status===__WEBPACK_IMPORTED_MODULE_7_state_school_money_entities_Checkout__["a" /* default */].status.PREPARING){return null;}if(walletPayJWTString!==undefined){if(userIdentity.get("platform")==="iphone"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_school_money_basket_checkout_secure_trading_PaymentTypeSelector__["a" /* default */],{walletType:"apple",walletJWTString:walletPayJWTString});}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_school_money_basket_checkout_secure_trading_PaymentTypeSelector__["a" /* default */],{walletType:"google",walletJWTString:walletPayJWTString});}}if(isCardPayJWTSet){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_basket_checkout_secure_trading_CardDetails__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_school_money_basket_checkout_secure_trading_CardHolderName__["a" /* default */],null);}},{key:"render",value:function render(){var testMode="TEST"==="TEST";var _props2=this.props,applePayJWTString=_props2.applePayJWTString,status=_props2.status;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__school-money-logo-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"checkout-payment__school-money-logo",src:__WEBPACK_IMPORTED_MODULE_12_components_assets_images_school_money_school_money_logo_text_right_svg___default.a,alt:"School Money"})),applePayJWTString===undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_school_money_basket_checkout_PaymentStatus__["a" /* default */],null):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__total-to-pay"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__total-to-pay-label"},"Total To Pay"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__total-to-pay-amount"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Currency__["a" /* default */],{amount:this.props.totalToPay}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__school"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_SchoolLogo__["a" /* default */],{className:"checkout-payment",school:this.props.school}))),status===__WEBPACK_IMPORTED_MODULE_7_state_school_money_entities_Checkout__["a" /* default */].status.COMPLETED?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_basket_checkout_PaymentSuccess__["a" /* default */],{schoolID:this.props.schoolID}):this.getPaymentComponent(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__footer"},"Powered by ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"checkout-payment__secure-trading-logo",src:__WEBPACK_IMPORTED_MODULE_11_components_assets_images_school_money_secure_trading_trust_payments_png___default.a,alt:"Secure Trading"})),testMode?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-payment__environment-indicator"},"TEST environment"):""));}}]);return PSD2PaymentForm;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);PSD2PaymentForm.propTypes={schoolID:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state,_ref){var schoolID=_ref.schoolID;return{status:Object(__WEBPACK_IMPORTED_MODULE_14_state_school_money_selectors__["E" /* getCheckoutStatus */])(state),school:Object(__WEBPACK_IMPORTED_MODULE_14_state_school_money_selectors__["_29" /* getSchoolByID */])(state,schoolID),totalToPay:Object(__WEBPACK_IMPORTED_MODULE_14_state_school_money_selectors__["F" /* getCheckoutTotalToPay */])(state),cardPayJWTString:Object(__WEBPACK_IMPORTED_MODULE_14_state_school_money_selectors__["_38" /* getSecureTradingCardPayJWTString */])(state),walletPayJWTString:Object(__WEBPACK_IMPORTED_MODULE_14_state_school_money_selectors__["_41" /* getSecureTradingWalletPayJWTString */])(state),userIdentity:Object(__WEBPACK_IMPORTED_MODULE_13_state_app_selectors__["k" /* getUserIdentity */])(state)};},undefined)(PSD2PaymentForm));

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CardHolderName_css__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CardHolderName_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CardHolderName_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CardHolderName=function(_React$Component){_inherits(CardHolderName,_React$Component);function CardHolderName(props){_classCallCheck(this,CardHolderName);var _this=_possibleConstructorReturn(this,(CardHolderName.__proto__||Object.getPrototypeOf(CardHolderName)).call(this,props));_this.onChange=function(){var cardHolderName=_this.input.value;_this.setState({cardHolderName:cardHolderName});if(cardHolderName!==""){_this.setState({isInputValid:true});}};_this.refInput=function(input){_this.input=input;};_this.getJWTString=function(){var cardHolderName=_this.state.cardHolderName;if(cardHolderName.trim()===""){_this.setState({isInputValid:false});_this.setState({errorMessage:"Field is required"});return;}else if(!/[a-zA-Z ]/.test(cardHolderName)||/[<>&]/.test(cardHolderName)){_this.setState({isInputValid:false});_this.setState({errorMessage:"Invalid name"});return;}_this.props.getJWTString(encodeURIComponent(cardHolderName));};_this.state={cardHolderName:"",isInputValid:true,errorMessage:"Field is required"};return _this;}_createClass(CardHolderName,[{key:"render",value:function render(){var inputClassNames=["cardholder-name__input"];var errorClassNames=["cardholder-name__error-field"];if(!this.state.isInputValid){inputClassNames.push("cardholder-name__input--invalid");errorClassNames.push("cardholder-name__error-field--display");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cardholder-name__input-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cardholder-name__input-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cardholder-name__input-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cardholder-name__input-label"},"Cardholder Name"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:inputClassNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:"cardholder-name_name",ref:this.refInput,placeholder:"Cardholder Name",onChange:this.onChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:errorClassNames.join(" ")},this.state.errorMessage)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cardholder-name__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Button__["a" /* default */],{className:"cardholder-name__cancel-button",onClick:this.props.onClose},"Cancel"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Button__["a" /* default */],{className:"cardholder-name__next-button",onClick:this.getJWTString},"Next")));}}]);return CardHolderName;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{};},{onClose:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_49" /* closeCheckout */],getJWTString:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_67" /* getSecureTradingGetJwtString */]})(CardHolderName));

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Spinner__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CardDetails_css__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CardDetails_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CardDetails_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ONLINE_PAY_BUTTON_CHECK_DELAY=500;var CardDetails=function(_React$Component){_inherits(CardDetails,_React$Component);function CardDetails(props){_classCallCheck(this,CardDetails);var _this=_possibleConstructorReturn(this,(CardDetails.__proto__||Object.getPrototypeOf(CardDetails)).call(this,props));_this.processPaymentResponse=function(response){if(response.errorcode==="30000"){return;}_this.props.processPaymentResponse(response);};_this.auditPaymentStart=function(){_this.props.saveAudit("PAYMENT_PROCESS_STARTED");};_this.checkCardPaymentFields=function(){if(document.getElementById("st-card-number").innerHTML!==""){_this.setState({isLoading:false});clearInterval(_this.state.cardPayButtonCheckInterval);}};_this.getPayButtonContent=function(){if(!_this.state.payButtonClicked){return"Pay";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Spinner__["a" /* default */],{size:"small",color:"white"});};_this.state={isLoading:true,cardPayButtonCheckInterval:undefined,payButtonClicked:false};return _this;}_createClass(CardDetails,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.props.saveAudit("ST_CARD_DETAILS_TOKEN_GENERATED");this.setState({cardPayButtonCheckInterval:setInterval(this.checkCardPaymentFields,ONLINE_PAY_BUTTON_CHECK_DELAY)});var st=window.SecureTrading({jwt:this.props.jwtString,styles:{'border-radius-input':'9999px','border-color-input':'#DADAD9','border-size-input':'1px','font-size-input':'14px','border-radius-input-error':'9999px','border-color-input-error':'#E44E3F','font-size-label':'16px','font-size-message':'16px','color-error':'#E44E3F','line-height-body':'0','background-color-input-error':'#FFFFFF'},submitOnSuccess:false,submitCallback:this.processPaymentResponse,disableNotification:true,livestatus:parseInt("0",10),translations:{"Value mismatch pattern":"Invalid value"}});st.Components();st.on("paymentStarted",function(data){_this2.setState({payButtonClicked:true});});}},{key:"render",value:function render(){var loadingFrameStyle=this.state.isLoading?{display:"block"}:{display:"none"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-details__container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:loadingFrameStyle,className:"card-details__spinner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Please wait..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Spinner__["a" /* default */],{size:"standalone",color:"school_money"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"st-notification-frame"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{id:"st-form",action:"",method:"POST"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"st-card-number",className:"st-card-number"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"st-expiration-date",className:"st-expiration-date"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"st-security-code",className:"st-security-code"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{id:"st-form__submit",type:"submit",className:"card-details__pay-button",onClick:this.auditPaymentStart},this.getPayButtonContent())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"card-details__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Button__["a" /* default */],{className:"card-details__cancel-button",onClick:this.props.onClose},"Cancel")));}}]);return CardDetails;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{jwtString:Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_selectors__["_38" /* getSecureTradingCardPayJWTString */])(state)};},{onClose:__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_49" /* closeCheckout */],processPaymentResponse:__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_85" /* processSecureTradingPaymentResponse */],saveAudit:__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_93" /* saveAudit */]})(CardDetails));

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentSuccess_css__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PaymentSuccess_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PaymentSuccess_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentSuccess=function(_React$Component){_inherits(PaymentSuccess,_React$Component);function PaymentSuccess(){_classCallCheck(this,PaymentSuccess);return _possibleConstructorReturn(this,(PaymentSuccess.__proto__||Object.getPrototypeOf(PaymentSuccess)).apply(this,arguments));}_createClass(PaymentSuccess,[{key:"render",value:function render(){var emailAddress=this.props.emailAddress;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"payment-success__heading"},"Payment successful!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-success__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Thank you for your payment! Please note that there may be a slight delay in processing, but we will have it completed shortly. A receipt will be sent to ",emailAddress,".")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Button__["a" /* default */],{className:"payment-success__close-button",onClick:this.props.close},"Done"));}}]);return PaymentSuccess;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);PaymentSuccess.propTypes={schoolID:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state,_ref){var schoolID=_ref.schoolID;return{emailAddress:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_18" /* getParentEmailAddress */])(state,schoolID)};},{close:__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_49" /* closeCheckout */]})(PaymentSuccess));

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_entities_Checkout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaymentStatus_css__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PaymentStatus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PaymentStatus_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentStatus=function(_React$Component){_inherits(PaymentStatus,_React$Component);function PaymentStatus(){_classCallCheck(this,PaymentStatus);return _possibleConstructorReturn(this,(PaymentStatus.__proto__||Object.getPrototypeOf(PaymentStatus)).apply(this,arguments));}_createClass(PaymentStatus,[{key:"render",value:function render(){var processingStatusClassNames=["payment-status__pending"];var completedStatusClassNames=["payment-status__pending"];var status=this.props.status;if(status===__WEBPACK_IMPORTED_MODULE_2_state_school_money_entities_Checkout__["a" /* default */].status.PROCESSING){processingStatusClassNames.push("payment-status__complete");}if(status===__WEBPACK_IMPORTED_MODULE_2_state_school_money_entities_Checkout__["a" /* default */].status.COMPLETED){processingStatusClassNames.push("payment-status__complete");completedStatusClassNames.push("payment-status__complete");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-status__wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-status__pending payment-status__complete"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-status__status-text"},"Card Details"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-status__separator"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:processingStatusClassNames.join(" ")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-status__status-text"},"Processing"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-status__separator"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:completedStatusClassNames.join(" ")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-status__status-text"},"Complete!"));}}]);return PaymentStatus;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{status:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["E" /* getCheckoutStatus */])(state)};})(PaymentStatus));

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_money__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Spinner__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_state_app_selectors__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaymentTypeSelector_css__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaymentTypeSelector_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__PaymentTypeSelector_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ONLINE_PAY_BUTTON_CHECK_DELAY=500;var GOOGLE_PAY_BUTTON_ID="google-pay";var APPLE_PAY_BUTTON_ID="st-apple-pay";var PaymentTypeSelector=function(_React$Component){_inherits(PaymentTypeSelector,_React$Component);function PaymentTypeSelector(props){_classCallCheck(this,PaymentTypeSelector);var _this=_possibleConstructorReturn(this,(PaymentTypeSelector.__proto__||Object.getPrototypeOf(PaymentTypeSelector)).call(this,props));_this.getWalletButtonID=function(){return _this.props.walletType==="apple"?APPLE_PAY_BUTTON_ID:GOOGLE_PAY_BUTTON_ID;};_this.getGooglePaySetup=function(){return{JWT:_this.props.walletJWTString,ApiVersion:2,ApiVersionMinor:0,AllowedPaymentMethod:[{AllowedPaymentMethodParameters:{AllowedAuthMethods:["PAN_ONLY","CRYPTOGRAM_3DS"],AllowedCardNetworks:["VISA","MASTERCARD"]},TokenizationSpecification:{Parameters:{Gateway:"trustpayments",GatewayMerchantId:"test_smartthreedtwo83732"},Type:"PAYMENT_GATEWAY"},Type:"CARD"}],TransactionInfo:{CountryCode:"GB",CurrencyCode:"GBP",TotalPriceStatus:"FINAL",TotalPrice:Object(__WEBPACK_IMPORTED_MODULE_3_lib_money__["b" /* moneyToString */])(Math.abs(_this.props.totalToPay)).toString()},MerchantInfo:{MerchantId:"BCR2DN4T7DZYVHSW",MerchantName:"SchoolMoney"},scaexemptionindicator:14};};_this.getApplePayeMerchantId=function(){return _this.props.appReferrer==="xpressions"?"merchant.com.groupcall.emerge.parental.req":"merchant.schoolmoney.dev";};_this.getApplePaySetup=function(){return{buttonStyle:"black",buttonText:"plain",merchantId:_this.getApplePayeMerchantId(),paymentRequest:{countryCode:"GB",currencyCode:"GBP",merchantCapabilities:["supports3DS","supportsCredit","supportsDebit"],supportedNetworks:["visa","masterCard"],total:{label:"Schoolmoney",amount:_this.props.totalToPay.toString()}},buttonPlacement:_this.getWalletButtonID()};};_this.checkWalletPayButton=function(){if(document.getElementById(_this.getWalletButtonID()).innerHTML!==""){_this.setState({isLoading:false});clearInterval(_this.state.onlinePayButtonCheckInterval);}};_this.processPaymentResponse=function(response){if(response.errorcode==="cancelled"){_this.props.onClose();}else{_this.props.processPaymentResponse(response);}};_this.initiateCardPayment=function(){if(_this.props.walletType==="apple"){_this.state.secureTradingReference.destroy();}_this.props.initiateCardPayment();};_this.displayLoadingFrame=function(){_this.setState({isLoading:true});_this.setState({loadingFrameInfo:"Processing payment."});_this.props.saveAudit("PAYMENT_PROCESS_STARTED");};_this.initiateGooglePay=function(){_this.props.saveAudit("GOOGLE_PAY_PAYMENT_PROCESS_STARTED");_this.props.setProcessingStatus();_this.props.saveAudit("Google payload for native: "+JSON.stringify(_this.getGooglePaySetup()));window.android.gpBridgeCallback(JSON.stringify(_this.getGooglePaySetup()));};_this.state={secureTradingReference:undefined,isLoading:true,onlinePayButtonCheckInterval:undefined,loadingFrameInfo:"Preparing payment options.",setupError:undefined};return _this;}_createClass(PaymentTypeSelector,[{key:"componentDidMount",value:function componentDidMount(){try{this.setState({onlinePayButtonCheckInterval:setInterval(this.checkWalletPayButton,ONLINE_PAY_BUTTON_CHECK_DELAY)});if(this.props.walletType==="google"){var paymentsClient=new window.google.payments.api.PaymentsClient({environment:"TEST"});var container=document.getElementById(GOOGLE_PAY_BUTTON_ID);var button=paymentsClient.createButton({buttonColor:"default",buttonType:"pay",buttonSizeMode:"fill",onClick:this.initiateGooglePay});container.appendChild(button);this.props.saveAudit("ST_GOOGLE_PAY_TOKEN_GENERATED");}else{var st=window.SecureTrading({jwt:this.props.walletJWTString,submitOnSuccess:false,submitCallback:this.processPaymentResponse,disableNotification:true,livestatus:Number("0")});st.ApplePay(this.getApplePaySetup());this.props.saveAudit("ST_APPLE_PAY_TOKEN_GENERATED");}}catch(error){this.setState({setupError:error});}this.setState({secureTradingReference:st});}},{key:"getWalletPayElements",value:function getWalletPayElements(){if(this.props.walletType==="apple"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{id:"st-form",action:"#"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-type-selector__apple-pay-button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"st-apple-pay",className:"payment-type-selector__apple-pay-button"})));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"google-pay",className:"payment-type-selector__google-pay-button"});}}},{key:"render",value:function render(){var paymentTypeSelectorStlye=this.state.isLoading?{display:"none"}:{display:"block"};var loadingFrameStyle=this.state.isLoading?{display:"block"}:{display:"none"};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:loadingFrameStyle,className:"payment-type-selector__spinner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.state.loadingFrameInfo," Please wait..."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Spinner__["a" /* default */],{size:"standalone",color:"school_money"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:paymentTypeSelectorStlye,className:"payment-type-selector__container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-type-selector__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Button__["a" /* default */],{className:"payment-type-selector__pay-button",onClick:this.initiateCardPayment,style:{borderRadius:"5px"}},"Pay with Card")),this.getWalletPayElements(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-type-selector__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Button__["a" /* default */],{className:"payment-type-selector__cancel-button",onClick:this.props.onClose,style:{borderRadius:"5px"}},"Cancel"))));}}]);return PaymentTypeSelector;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);PaymentTypeSelector.propTypes={walletType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,walletJWTString:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{totalToPay:Object(__WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors__["F" /* getCheckoutTotalToPay */])(state),status:Object(__WEBPACK_IMPORTED_MODULE_7_state_school_money_selectors__["E" /* getCheckoutStatus */])(state),appReferrer:Object(__WEBPACK_IMPORTED_MODULE_8_state_app_selectors__["l" /* getUserIdentityAppReferrer */])(state)};},{processPaymentResponse:__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_85" /* processSecureTradingPaymentResponse */],initiateCardPayment:__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_48" /* clearWalletPayJWTString */],onClose:__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_49" /* closeCheckout */],saveAudit:__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_93" /* saveAudit */],setProcessingStatus:__WEBPACK_IMPORTED_MODULE_6_state_school_money_actions__["_86" /* processSecureTradingToken */]})(PaymentTypeSelector));

/***/ }),
/* 645 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/trust_payments.d801dce6.png";

/***/ }),
/* 647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_entities_Checkout__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Spinner__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CheckoutInformationModal_css__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CheckoutInformationModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__CheckoutInformationModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var errorMessage={PROGRAMMING_ERROR:"Programming error occurred.",ERROR_CONNECTION:"There was a problem connecting to the payment servers.",ERROR_UNABLE_TO_PROCESS_PAYMENT:"Unable to process your payment.",ERROR_CARD_DETAILS_INCORRECT:"There was a problem with the details provided.",ERROR_PROCESS_PAYMENT:"There was an issue processing the payment.",ERROR_AUTHORISE_PAYMENT:"There was a problem when trying to authorise the payment.",DUPLICATE_TRANSACTION:"This transaction has already been completed.",INVALID_AMOUNT:"There was a problem with initialising your transaction.",SERVER_ERROR:"An unknown error has occurred.",INVALID_RESPONSE:"There was an issue processing the payment response from the provider.",API_ERROR:"The payment was unsuccessful.",ISSUING_BANK_SYSTEM_ERROR:"The issuing bank returned a system error.",ERROR_ISSUING_BANK_DECLINED_PAYMENT:"The issuing bank declined the payment.",UNKNOWN_ERROR:"An issue occurred with initiating your payment.",INIT_FAIL:"An issue occurred with initiating your payment. Please refresh and try again.",BUYER_ACCOUNT_ERROR:"Unable to collect your Google pay details. Please refresh and try again.",MERCHANT_ACCOUNT_ERROR:"The site that accesses the Google Pay API doesn't have the right permission.",GOOGLE_PAY_INVALID_CARD_DETAILS:"Invalid card details were provided."/**
 * Display success or error messages about the checkout process.
 */};var CheckoutInformationModal=function(_React$Component){_inherits(CheckoutInformationModal,_React$Component);function CheckoutInformationModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CheckoutInformationModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CheckoutInformationModal.__proto__||Object.getPrototypeOf(CheckoutInformationModal)).call.apply(_ref,[this].concat(args))),_this),_this.clearError=function(){_this.props.clearError();_this.props.close();},_this.checkoutRestart=function(){_this.props.checkoutRestart();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CheckoutInformationModal,[{key:"getErrorMessage",value:function getErrorMessage(error,errorCode){var errorDescription=errorMessage[error]||"";var errorCodeDescription=errorCode!==null&&errorCode!==undefined?" Error code: "+errorCode+".":"";return errorDescription+errorCodeDescription;}},{key:"getActionMessage",value:function getActionMessage(error){return error==="DUPLICATE_TRANSACTION"?"Please contact product support.":"Please check your details and try again.";}},{key:"getContent",value:function getContent(status,error,errorCode){if(error!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-info-modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"checkout-info-modal__heading"},"Oops!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-info-modal__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"There was a problem processing your details."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.getErrorMessage(error,errorCode)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.getActionMessage(error))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-info-modal__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Button__["a" /* default */],{className:"checkout-info-modal__next-button",onClick:this.checkoutRestart},"Try Again"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Button__["a" /* default */],{className:"checkout-info-modal__cancel-button",onClick:this.clearError},"Cancel")));}switch(status){case __WEBPACK_IMPORTED_MODULE_4_state_school_money_entities_Checkout__["a" /* default */].status.PREPARING:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-info-modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"checkout-info-modal__heading"},"Preparing"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-info-modal__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Please wait while we prepare your payment.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-info-modal__spinner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Spinner__["a" /* default */],{size:"standalone",color:"school_money"})));case __WEBPACK_IMPORTED_MODULE_4_state_school_money_entities_Checkout__["a" /* default */].status.PROCESSING:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-info-modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"checkout-info-modal__heading"},"Processing"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-info-modal__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Please wait while we process your payment.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"checkout-info-modal__spinner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Spinner__["a" /* default */],{size:"standalone",color:"school_money"})));default:return null;}}},{key:"render",value:function render(){var _props=this.props,status=_props.status,error=_props.error,errorCode=_props.errorCode;var content=this.getContent(status,error,errorCode);if(content===null){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ModalDialog__["a" /* default */],null,content);}}]);return CheckoutInformationModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{status:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["E" /* getCheckoutStatus */])(state),error:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["B" /* getCheckoutError */])(state),errorCode:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["C" /* getCheckoutErrorCode */])(state)};},{close:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_49" /* closeCheckout */],clearError:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_41" /* clearCheckoutError */],checkoutRestart:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_39" /* checkoutRestart */]})(CheckoutInformationModal));

/***/ }),
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_Preloader__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_school_money_MaintainValidStudentID__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_StudentSelector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_dinners_StudentDinnersList__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DinnersPage_css__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DinnersPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__DinnersPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DinnersPage=function(_React$Component){_inherits(DinnersPage,_React$Component);function DinnersPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DinnersPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DinnersPage.__proto__||Object.getPrototypeOf(DinnersPage)).call.apply(_ref,[this].concat(args))),_this),_this.isDinnersReady=function(state){return Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_90" /* isDinnersReady */])(state,_this.props.studentID);},_this.onStudentChange=function(studentID,prevStudentID){_this.props.markStudentDinnerBookingsAsSeen(prevStudentID);_this.clearFocus();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DinnersPage,[{key:"generatePath",value:function generatePath(studentID){return"/school_money/dinners/"+studentID+"/";}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.props.markStudentDinnerBookingsAsSeen(this.props.match.params.studentID);}// ---------------------------------------------------------------------------
// Clear focus is nescessary to turn off focus on dropdown menus when the
// student is changed. At present changing the focus of the page to a div
// element corrects this problem (IOS).
// ---------------------------------------------------------------------------
},{key:"clearFocus",value:function clearFocus(){// Get the first dinners-page element, should only be one.
var dinnerPageElement=document.getElementsByClassName("dinners-page")[0];// Catch error when element is missing, do not continue;
if(dinnerPageElement===undefined){return;}// To be able to focus on a div element we need to add a tabindex.
dinnerPageElement.tabIndex=-1;dinnerPageElement.focus();}},{key:"render",value:function render(){var studentID=this.props.match.params.studentID;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_school_money_MaintainValidStudentID__["a" /* default */],{currentStudentID:studentID,generatePath:this.generatePath},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_Preloader__["a" /* default */],{isPageReady:this.isDinnersReady},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinners-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"page-header__title"},"Dinners"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_StudentSelector__["a" /* default */],{selectedStudentID:studentID,generatePath:this.generatePath})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentCarousel__["a" /* default */],{activeStudentID:studentID,generatePath:this.generatePath,onChange:this.onStudentChange},function(studentID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_dinners_StudentDinnersList__["a" /* default */],{key:studentID,studentID:studentID});}))));}}]);return DinnersPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(undefined,{markStudentDinnerBookingsAsSeen:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_79" /* markStudentDinnerBookingsAsSeen */]})(DinnersPage));

/***/ }),
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ScrollableList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_List__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_PlaceholderCard__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentCreditBalance__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_dinners_DinnerCreditTopUp__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_school_money_dinners_DinnerBooking__ = __webpack_require__(659);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StudentDinnersList=function(_React$Component){_inherits(StudentDinnersList,_React$Component);function StudentDinnersList(){_classCallCheck(this,StudentDinnersList);return _possibleConstructorReturn(this,(StudentDinnersList.__proto__||Object.getPrototypeOf(StudentDinnersList)).apply(this,arguments));}_createClass(StudentDinnersList,[{key:"render",value:function render(){var _props=this.props,studentID=_props.studentID,dinnerBookingIDList=_props.dinnerBookingIDList,isDinnersEnabled=_props.isDinnersEnabled,isTopUpsEnabled=_props.isTopUpsEnabled,school=_props.school,canStudentTopUp=_props.canStudentTopUp,isExternalTopUpEnabled=_props.isExternalTopUpEnabled,isXodActive=_props.isXodActive,isExternal=_props.isExternal,studentHasMisId=_props.studentHasMisId;var placeholder=isExternal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_PlaceholderCard__["a" /* default */],{objectName:"dinner bookings",school:school,message:"Top Ups are currently unavailable."}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_PlaceholderCard__["a" /* default */],{objectName:"dinner bookings",school:school});var footerMessage="The Dinner Balance can take a while to update. The amount displayed may not accurately reflect the current balance.";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ScrollableList__["a" /* default */],{className:"dinners-list",scrollTargetID:this.props.goToDinnerBookingID,onScroll:this.props.clearGoTo},function(refChild){return isExternal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentCreditBalance__["a" /* default */],{studentID:studentID,type:"dinner_money"}),isExternalTopUpEnabled&&isXodActive&&studentHasMisId?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_dinners_DinnerCreditTopUp__["a" /* default */],{studentID:studentID}):placeholder,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinners-list___footer"},footerMessage)):isDinnersEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentCreditBalance__["a" /* default */],{studentID:studentID,type:"dinner_money"}),isTopUpsEnabled&&canStudentTopUp?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_dinners_DinnerCreditTopUp__["a" /* default */],{studentID:studentID}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_List__["a" /* default */],{placeholder:placeholder},dinnerBookingIDList.map(function(dinnerBookingID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_school_money_dinners_DinnerBooking__["a" /* default */],{key:dinnerBookingID,dinnerBookingID:dinnerBookingID,innerRef:function innerRef(child){return refChild(child,dinnerBookingID);}});}))):placeholder;});}}]);return StudentDinnersList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var studentID=_ref.studentID;return{dinnerBookingIDList:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_50" /* getStudentDinnerBookingIDList */])(state,studentID),isDinnersEnabled:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_89" /* isDinnersEnabled */])(state,Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_56" /* getStudentSchoolID */])(state,studentID)),isTopUpsEnabled:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_88" /* isDinnerTopUpsEnabled */])(state,Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_56" /* getStudentSchoolID */])(state,studentID)),school:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_30" /* getSchoolByStudentID */])(state,studentID),goToDinnerBookingID:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_7" /* getGoToDinnerBookingID */])(state),canStudentTopUp:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["d" /* canStudentDoDinnerTopUp */])(state,studentID),isExternalTopUpEnabled:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_91" /* isExternalTopUpEnabled */])(state,Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_56" /* getStudentSchoolID */])(state,studentID)),isXodActive:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_112" /* isXodActive */])(state,Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_56" /* getStudentSchoolID */])(state,studentID)),isExternal:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["q" /* doesStudentUseExternalCashless */])(state,studentID),studentHasMisId:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["p" /* doesStudentHasMisId */])(state,studentID)};},{clearGoTo:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_44" /* clearGoToDinnerBooking */]})(StudentDinnersList));

/***/ }),
/* 654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_CreditTopUp__ = __webpack_require__(191);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DinnerCreditTopUp=function(_React$Component){_inherits(DinnerCreditTopUp,_React$Component);function DinnerCreditTopUp(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DinnerCreditTopUp);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DinnerCreditTopUp.__proto__||Object.getPrototypeOf(DinnerCreditTopUp)).call.apply(_ref,[this].concat(args))),_this),_this.addToBasket=function(amount){var _this$props=_this.props,studentID=_this$props.studentID,isExternal=_this$props.isExternal;if(isExternal){_this.props.addToBasket("external_top_up",studentID,amount);}else{_this.props.addToBasket("dinner_money",studentID,amount);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DinnerCreditTopUp,[{key:"render",value:function render(){var _props=this.props,defaultAmount=_props.defaultAmount,externalCashlessName=_props.externalCashlessName,isExternal=_props.isExternal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_CreditTopUp__["a" /* default */],{label:isExternal?externalCashlessName+" Top Up":"Dinner Top Up",defaultAmount:defaultAmount,onAddToBasket:this.addToBasket});}}]);return DinnerCreditTopUp;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref2){var studentID=_ref2.studentID;var schoolID=Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_56" /* getStudentSchoolID */])(state,studentID);return{schoolID:schoolID,defaultAmount:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_3" /* getDinnerTopUpDefaultAmount */])(state,schoolID),externalCashlessName:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_4" /* getExternalCashlessName */])(state,schoolID),isExternal:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["q" /* doesStudentUseExternalCashless */])(state,studentID)};},{addToBasket:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_36" /* addCreditTopUpToBasket */]})(DinnerCreditTopUp));

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/item-add.44db02a8.svg";

/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ExpandingBox__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Highlight__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Date__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_ShortDate__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_school_money_AddButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_school_money_NewIndicator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_school_money_dinners_WeeklyMealInput__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_school_money_dinners_AllergiesIndicator__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_school_money_dinners_AllergiesModal__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_school_money_BasketModificationModal__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DinnerBooking_css__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__DinnerBooking_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__DinnerBooking_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DinnerBooking=function(_React$Component){_inherits(DinnerBooking,_React$Component);function DinnerBooking(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DinnerBooking);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DinnerBooking.__proto__||Object.getPrototypeOf(DinnerBooking)).call.apply(_ref,[this].concat(args))),_this),_this.state={isAllergiesWarningModalOpen:false,isBasketModificationModalOpen:false/**
   * This is not called directly from the Add button click
   * confirmAddToBasket is called first, which will show the allergies
   *   warning if applicable
   */},_this.addToBasket=function(){_this.props.addToBasket();_this.props.collapse();},_this.confirmAddToBasket=function(){var _this$props=_this.props,isAllergiesWarningEnabled=_this$props.isAllergiesWarningEnabled,allergyInformation=_this$props.allergyInformation,isModified=_this$props.isModified,isInBasket=_this$props.isInBasket;var hasAllergyInformation=allergyInformation.some(function(allergyInformation){return allergyInformation!=="";});var isCashless=_this.props.dinnerBooking.toJS().isCashless;// if the booking is in the basket then show an alert
if(isInBasket){_this.onReadOnlyClick();// don't do anything if no changes have been made yet
}else if(isModified){if(isAllergiesWarningEnabled&&hasAllergyInformation&&isCashless){_this.setState({isAllergiesWarningModalOpen:true});}else{_this.addToBasket();}}},_this.removeFromBasket=function(){_this.props.removeFromBasket();},_this.onReadOnlyClick=function(){_this.setState({isBasketModificationModalOpen:true});},_this.onBasketModificationModalClose=function(result){if(result){_this.removeFromBasket();}_this.setState({isBasketModificationModalOpen:false});},_this.onAllergiesWarningModalClose=function(result){if(result){_this.addToBasket();}_this.setState({isAllergiesWarningModalOpen:false});},_temp),_possibleConstructorReturn(_this,_ret);}/**
   * Show the allergies warning alert if applicable
   * If not, just add to basket
   *//**
   * this is only used by the callback of the BasketModificationModal
   *//**
   * When the user tries to make a change but the booking is in the basket,
   *   show an alert warning them that they have to remove it first
   *//**
   * If the modal was closed with a positive/"yes" then remove from basket
   *//**
   * If the modal was closed with a positive/"yes" then add to basket
   * Otherwise just close
   */_createClass(DinnerBooking,[{key:"render",value:function render(){var _props=this.props,dinnerBooking=_props.dinnerBooking,dinnerBookingID=_props.dinnerBookingID,totalPrice=_props.totalPrice,hasFSMEligibility=_props.hasFSMEligibility,isExpanded=_props.isExpanded,isInBasket=_props.isInBasket,isModified=_props.isModified,isSeen=_props.isSeen,isBooked=_props.isBooked,isHighlighted=_props.isHighlighted,expand=_props.expand,collapse=_props.collapse;var _dinnerBooking$toJS=dinnerBooking.toJS(),description=_dinnerBooking$toJS.description,startDate=_dinnerBooking$toJS.startDate,isCashless=_dinnerBooking$toJS.isCashless,fsmLimitPerDay=_dinnerBooking$toJS.fsmLimitPerDay,lastModifiedDate=_dinnerBooking$toJS.lastModifiedDate;var hasFSMLimit=fsmLimitPerDay!==null;var hasLastModifiedDate=lastModifiedDate!=="";var status=null;if(isBooked){status="Booked";}var classNames=["dinner-booking"];if(isModified){classNames.push("dinner-booking--is-modified");}else{classNames.push("dinner-booking--not-modified");}if(isInBasket){classNames.push("dinner-booking--in-basket");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" "),ref:this.props.innerRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_school_money_BasketModificationModal__["a" /* default */],{isOpen:this.state.isBasketModificationModalOpen,onClose:this.onBasketModificationModalClose,itemName:"week"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Highlight__["a" /* default */],{cssModifier:"school_money",isHighlighted:isHighlighted},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ExpandingBox__["a" /* default */],{cssModifier:"school_money",expanded:isExpanded,onExpand:expand,onCollapse:collapse},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ExpandingBox__["a" /* default */].Header,{toggleOnClick:true},isSeen?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_school_money_NewIndicator__["a" /* default */],{className:"dinner-booking__new-indicator"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinner-booking__header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinner-booking__description"},description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinner-booking__week-date"},"W/C ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Date__["a" /* default */],{date:startDate}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinner-booking__status"},status)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ExpandingBox__["a" /* default */].Body,{toggleOnClick:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinner-booking__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinner-booking__meal_selections"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_school_money_dinners_WeeklyMealInput__["a" /* default */],{dinnerBookingID:dinnerBookingID,onReadOnlyClick:this.onReadOnlyClick})),isCashless?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_school_money_dinners_AllergiesIndicator__["a" /* default */],{className:"dinner-booking__allergies-indicator",dinnerBookingID:dinnerBookingID}):null,hasFSMEligibility&&hasFSMLimit&&isCashless?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinner-booking__fsm-limit"},"Free Meals Limit: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Currency__["a" /* default */],{className:"dinner-booking__fsm-limit-amount",amount:fsmLimitPerDay}),"/Day"):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinner-booking__row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinner-booking__total"},"Total: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_Currency__["a" /* default */],{className:"dinner-booking__total-amount",amount:totalPrice})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_school_money_AddButton__["a" /* default */],{className:"dinner-booking__add-button",onClick:this.confirmAddToBasket})),hasLastModifiedDate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"dinner-booking__last-modified"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"dinner-booking__last-modified-label"},"Last Modified "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"dinner-booking__last-modified-date"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_ShortDate__["a" /* default */],{date:lastModifiedDate}))):null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_school_money_dinners_AllergiesModal__["a" /* default */],{dinnerBookingID:dinnerBookingID,isWarning:true,isOpen:this.state.isAllergiesWarningModalOpen,onClose:this.onAllergiesWarningModalClose})));}}]);return DinnerBooking;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref2){var dinnerBookingID=_ref2.dinnerBookingID;return{dinnerBooking:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["V" /* getDinnerBookingByID */])(state,dinnerBookingID),totalPrice:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_2" /* getDinnerBookingTotalPrice */])(state,dinnerBookingID),allergyInformation:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["T" /* getDinnerBookingAllergyInformation */])(state,dinnerBookingID),isAllergiesWarningEnabled:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_64" /* isAllergiesWarningEnabled */])(state),isExpanded:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_85" /* isDinnerBookingExpanded */])(state,dinnerBookingID),hasFSMEligibility:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["k" /* doesDinnerBookingHaveFSMEligibility */])(state,dinnerBookingID),isInBasket:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_86" /* isDinnerBookingInBasket */])(state,dinnerBookingID),isModified:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_62" /* hasDinnerBookingBeenModified */])(state,dinnerBookingID),isSeen:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_87" /* isDinnerBookingSeen */])(state,dinnerBookingID),isBooked:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["j" /* doesDinnerBookingHaveBookings */])(state,dinnerBookingID),isHighlighted:dinnerBookingID===Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_7" /* getGoToDinnerBookingID */])(state)};},function(dispatch,_ref3){var dinnerBookingID=_ref3.dinnerBookingID;return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({addToBasket:function addToBasket(){return Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_37" /* addDinnerBookingToBasket */])(dinnerBookingID);},removeFromBasket:function removeFromBasket(){return Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_89" /* removeDinnerBookingFromBasket */])(dinnerBookingID);},expand:function expand(){return Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_103" /* setExpandedDinnerBooking */])(dinnerBookingID);},collapse:function collapse(){return Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_103" /* setExpandedDinnerBooking */])(null);}},dispatch);})(DinnerBooking));

/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_WeekdayTable__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_school_money_dinners_DailyMealInput__ = __webpack_require__(662);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WeeklyMealInput=function(_React$Component){_inherits(WeeklyMealInput,_React$Component);function WeeklyMealInput(){_classCallCheck(this,WeeklyMealInput);return _possibleConstructorReturn(this,(WeeklyMealInput.__proto__||Object.getPrototypeOf(WeeklyMealInput)).apply(this,arguments));}_createClass(WeeklyMealInput,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_WeekdayTable__["a" /* default */],{cssBlockName:"weekly-meal-input"},function(weekdayIndex,weekdayName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_school_money_dinners_DailyMealInput__["a" /* default */],{key:weekdayIndex,weekdayIndex:weekdayIndex,weekdayName:weekdayName,dinnerBookingID:_this2.props.dinnerBookingID,onReadOnlyClick:_this2.props.onReadOnlyClick});});}}]);return WeeklyMealInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (WeeklyMealInput);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_DailyBookingInput__ = __webpack_require__(663);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var inputTypes=__WEBPACK_IMPORTED_MODULE_4_components_school_money_DailyBookingInput__["a" /* default */].types;var DailyMealInput=function(_React$Component){_inherits(DailyMealInput,_React$Component);function DailyMealInput(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DailyMealInput);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DailyMealInput.__proto__||Object.getPrototypeOf(DailyMealInput)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(optionID){var _this$props=_this.props,dinnerBookingID=_this$props.dinnerBookingID,weekdayIndex=_this$props.weekdayIndex,isCashless=_this$props.isCashless;if(isCashless&&optionID!==null){optionID=Number(optionID);}_this.props.selectDinnerBookingOption(dinnerBookingID,weekdayIndex,optionID);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DailyMealInput,[{key:"render",value:function render(){var _props=this.props,weekdayIndex=_props.weekdayIndex,weekdayName=_props.weekdayName,optionList=_props.optionList,selectedOptionID=_props.selectedOptionID,isCashless=_props.isCashless,isHoliday=_props.isHoliday,isInBasket=_props.isInBasket,isExpired=_props.isExpired;/**
     * TODO: Migrate away from DailyBookingInput. ClubBooking no longer
     *   uses DailyBookingInput, meaning that DinnerBooking is now the
     *   only use for it. Therefore, it doesn't really need to exist.
     */return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_DailyBookingInput__["a" /* default */],{weekdayIndex:weekdayIndex,weekdayName:weekdayName,cssBlockName:"daily-meal-input",type:isCashless?inputTypes.DROPDOWN:inputTypes.RADIO_BUTTONS,options:optionList,selectedOptionID:String(selectedOptionID),onChange:this.onChange,disabled:isHoliday||isExpired,readOnly:isInBasket,onReadOnlyClick:this.props.onReadOnlyClick});}}]);return DailyMealInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref2){var dinnerBookingID=_ref2.dinnerBookingID,weekdayIndex=_ref2.weekdayIndex;return{optionList:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["Y" /* getDinnerBookingOptionList */])(state,dinnerBookingID,weekdayIndex),selectedOptionID:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_0" /* getDinnerBookingSelectedOptionID */])(state,dinnerBookingID,weekdayIndex),isCashless:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_82" /* isDinnerBookingCashless */])(state,dinnerBookingID),isHoliday:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_84" /* isDinnerBookingDayHoliday */])(state,dinnerBookingID,weekdayIndex),isInBasket:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_86" /* isDinnerBookingInBasket */])(state,dinnerBookingID),isExpired:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_83" /* isDinnerBookingDayExpired */])(state,dinnerBookingID,weekdayIndex)};},{selectDinnerBookingOption:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_96" /* selectDinnerBookingOption */]})(DailyMealInput));

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export inputTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Checkbox__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Dropdown__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Currency__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// possible values for the type prop
var inputTypes={CHECKBOXES:"checkboxes",RADIO_BUTTONS:"radio_buttons",DROPDOWN:"dropdown"/**
 * Intended to be used as a child of WeekdayTable
 */};var DailyBookingInput=function(_React$Component){_inherits(DailyBookingInput,_React$Component);function DailyBookingInput(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DailyBookingInput);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DailyBookingInput.__proto__||Object.getPrototypeOf(DailyBookingInput)).call.apply(_ref,[this].concat(args))),_this),_this.onInputClick=function(){if(_this.props.readOnly){_this.props.onReadOnlyClick();}},_this.onCheckboxChange=function(optionID,checked){if(checked){_this.onChange(optionID);}else{_this.onChange("");}},_this.onRadioButtonChange=function(optionID){_this.onChange(optionID);},_this.onDropdownChange=function(selectedOptionID){_this.onChange(selectedOptionID);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DailyBookingInput,[{key:"getSelectedOptionID",value:function getSelectedOptionID(){return this.props.selectedOptionID;}},{key:"getOptionByID",value:function getOptionByID(optionID){return this.props.options.find(function(option){return option.get("id").toString()===optionID;})||null;}},{key:"getSelectedOption",value:function getSelectedOption(){return this.getOptionByID(this.getSelectedOptionID());}},{key:"isOptionSelected",value:function isOptionSelected(){return this.getSelectedOption()!==null;}/**
   * Get the price of the selected option
   */},{key:"getSelectedOptionPrice",value:function getSelectedOptionPrice(){return this.isOptionSelected()?this.getSelectedOption().get("price"):0;}/**
   * We need to detect if the user has tried to make a change when the option is disabled/readOnly
   */},{key:"onChange",/**
   * When an option is changed, update the state and fire a callback
   */value:function onChange(selectedOptionID){var previousOptionID=this.getSelectedOptionID();var _props=this.props,disabled=_props.disabled,readOnly=_props.readOnly;if(this.props.onChange&&!disabled&&!readOnly){this.props.onChange(selectedOptionID,previousOptionID);}}/**
   * When a checkbox is un/checked, update the state
   *//**
   * When a radio button is checked, update the state
   *//**
   * When a dropdown is changed, update the state
   */},{key:"renderCheckboxes",value:function renderCheckboxes(){var _this2=this;var options=this.props.options;return options.map(function(option){var id=option.get("id");var selected=id===_this2.getSelectedOptionID();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Checkbox__["a" /* default */],{cssModifier:"school_money",checked:selected,onChange:function onChange(checked){return _this2.onCheckboxChange(id,checked);}});});}},{key:"renderRadioButtons",value:function renderRadioButtons(){var _this3=this;var _props2=this.props,options=_props2.options,cssBlockName=_props2.cssBlockName;return options.map(function(option){var id=option.get("id");var selected=id===_this3.getSelectedOptionID();var classNames=[cssBlockName+"__radio-button"];if(selected){classNames.push(cssBlockName+"__radio-button--selected");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{key:option.get("id"),className:classNames.join(" "),onClick:function onClick(){return _this3.onRadioButtonChange(id);}},option.get("name"));});}},{key:"renderDropdown",value:function renderDropdown(){var _props3=this.props,options=_props3.options,disabled=_props3.disabled,readOnly=_props3.readOnly;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Dropdown__["a" /* default */],{cssModifier:"school_money",options:options,selectedOptionID:this.getSelectedOptionID(),onChange:this.onDropdownChange,placeholder:"No Selection",readOnly:disabled||readOnly});// we provide out own styling for "disabled" state, so don't set it on the dropdown
}/**
   * Delegate to either renderCheckboxes or renderDropdown, based on the `type` prop
   */},{key:"renderType",value:function renderType(){switch(this.props.type){case inputTypes.CHECKBOXES:return this.renderCheckboxes();case inputTypes.RADIO_BUTTONS:return this.renderRadioButtons();case inputTypes.DROPDOWN:return this.renderDropdown();default:return null;}}},{key:"render",value:function render(){var _props4=this.props,cssBlockName=_props4.cssBlockName,disabled=_props4.disabled,readOnly=_props4.readOnly,disabledPlaceholder=_props4.disabledPlaceholder;var showPlaceholder=disabled&&disabledPlaceholder!==undefined;var classNames=[cssBlockName];if(disabled){classNames.push(cssBlockName+"--disabled");}if(readOnly){classNames.push(cssBlockName+"--read-only");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:cssBlockName+"__weekday-cell"},this.props.weekdayName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:cssBlockName+"__input-cell",onClick:this.onInputClick},showPlaceholder?disabledPlaceholder:this.renderType()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:cssBlockName+"__price-cell"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Currency__["a" /* default */],{amount:this.getSelectedOptionPrice()})));}}]);return DailyBookingInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);DailyBookingInput.types=inputTypes;DailyBookingInput.propTypes={options:__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.listOf(__WEBPACK_IMPORTED_MODULE_2_react_immutable_proptypes___default.a.contains({id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any.isRequired,name:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,price:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired})).isRequired,selectedOptionID:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(Object.values(inputTypes)),cssBlockName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,disabledPlaceholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,readOnly:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool};DailyBookingInput.defaultProps={type:inputTypes.DROPDOWN,disabled:false,readOnly:false};/* harmony default export */ __webpack_exports__["a"] = (DailyBookingInput);

/***/ }),
/* 664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_dinners_AllergiesModal__ = __webpack_require__(195);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AllergiesIndicator=function(_React$Component){_inherits(AllergiesIndicator,_React$Component);function AllergiesIndicator(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AllergiesIndicator);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AllergiesIndicator.__proto__||Object.getPrototypeOf(AllergiesIndicator)).call.apply(_ref,[this].concat(args))),_this),_this.state={isModalOpen:false},_this.openModal=function(){_this.setState({isModalOpen:true});},_this.closeModal=function(){_this.setState({isModalOpen:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AllergiesIndicator,[{key:"render",value:function render(){var _props=this.props,className=_props.className,dinnerBookingID=_props.dinnerBookingID,active=_props.active;var isModalOpen=this.state.isModalOpen;var classNames=[className];classNames.push(active?className+"--active":className+"--inactive");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" "),onClick:active?this.openModal:undefined},"Allergies"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_dinners_AllergiesModal__["a" /* default */],{dinnerBookingID:dinnerBookingID,isWarning:false,isOpen:isModalOpen,onClose:this.closeModal}));}}]);return AllergiesIndicator;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);AllergiesIndicator.propTypes={className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state,ownProps){var allergyInformationList=Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["T" /* getDinnerBookingAllergyInformation */])(state,ownProps.dinnerBookingID);var active=allergyInformationList.some(function(allergyInformation){return allergyInformation!=="";});return{active:active};})(AllergiesIndicator));

/***/ }),
/* 667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_throttleit__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_throttleit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_throttleit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_SearchBar__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_MaintainValidStudentID__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_Preloader__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_StudentSelector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_school_money_StudentCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_school_money_shop_StudentShopItemList__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ShopPage_css__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ShopPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__ShopPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var INPUT_THROTTLE_DELAY=500;var ShopPage=function(_React$Component){_inherits(ShopPage,_React$Component);function ShopPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ShopPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ShopPage.__proto__||Object.getPrototypeOf(ShopPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={searchQuery:""/**
   * Update the global state using a throttle
   */},_this.setGlobalSearchQueryState=__WEBPACK_IMPORTED_MODULE_2_throttleit___default()(function(searchQuery){_this.props.setShopItemSearchQuery(searchQuery);},INPUT_THROTTLE_DELAY),_this.onSearch=function(searchQuery){_this.setState({searchQuery:searchQuery});_this.setGlobalSearchQueryState(searchQuery);},_this.generatePath=function(studentID){return"/school_money/shop/"+studentID+"/";},_this.onStudentChange=function(studentID,prevStudentID){_this.props.markStudentShopItemsAsSeen(prevStudentID);},_temp),_possibleConstructorReturn(_this,_ret);}// initialise state
_createClass(ShopPage,[{key:"componentWillUnmount",value:function componentWillUnmount(){this.props.markStudentShopItemsAsSeen(this.props.match.params.studentID);}},{key:"render",value:function render(){var studentID=this.props.match.params.studentID;var searchQuery=this.state.searchQuery;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_MaintainValidStudentID__["a" /* default */],{currentStudentID:studentID,generatePath:this.generatePath},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_Preloader__["a" /* default */],{isPageReady:__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_110" /* isShopReady */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shop-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-header__title"},"Shop"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_StudentSelector__["a" /* default */],{selectedStudentID:studentID,generatePath:this.generatePath})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_SearchBar__["a" /* default */],{onSearch:this.onSearch,query:searchQuery}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_school_money_StudentCarousel__["a" /* default */],{activeStudentID:studentID,generatePath:this.generatePath,onChange:this.onStudentChange},function(studentID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_school_money_shop_StudentShopItemList__["a" /* default */],{key:studentID,studentID:studentID});}))));}}]);return ShopPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(undefined,{markStudentShopItemsAsSeen:__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_81" /* markStudentShopItemsAsSeen */],setShopItemSearchQuery:__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_109" /* setShopItemSearchQuery */]})(ShopPage));

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports = throttle;

/**
 * Returns a new function that, when invoked, invokes `func` at most once per `wait` milliseconds.
 *
 * @param {Function} func Function to wrap.
 * @param {Number} wait Number of milliseconds that must elapse between `func` invocations.
 * @return {Function} A new function that wraps the `func` function passed in.
 */

function throttle (func, wait) {
  var ctx, args, rtn, timeoutID; // caching
  var last = 0;

  return function throttled () {
    ctx = this;
    args = arguments;
    var delta = new Date() - last;
    if (!timeoutID)
      if (delta >= wait) call();
      else timeoutID = setTimeout(call, wait - delta);
    return rtn;
  };

  function call () {
    timeoutID = 0;
    last = +new Date();
    rtn = func.apply(ctx, args);
    ctx = null;
    args = null;
  }
}


/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_id__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ScrollableList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Gate__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_PlaceholderCard__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_school_money_shop_ShopItem__ = __webpack_require__(674);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StudentShopItemList=function(_React$Component){_inherits(StudentShopItemList,_React$Component);function StudentShopItemList(){_classCallCheck(this,StudentShopItemList);return _possibleConstructorReturn(this,(StudentShopItemList.__proto__||Object.getPrototypeOf(StudentShopItemList)).apply(this,arguments));}_createClass(StudentShopItemList,[{key:"render",value:function render(){var _props=this.props,studentID=_props.studentID,shopItemIDList=_props.shopItemIDList,searchQuery=_props.searchQuery,school=_props.school;var hasQuery=searchQuery!=="";var hasItems=shopItemIDList.size>0;// use a custom placeholder if the search has returned no results
var defaultPlaceholder=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_PlaceholderCard__["a" /* default */],{school:school,objectName:"shop items"});var searchPlaceholder=StudentShopItemList.renderSearchPlaceholder();var placeholder=hasQuery?searchPlaceholder:defaultPlaceholder;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ScrollableList__["a" /* default */],{className:"shop-item-list",onScroll:this.props.clearGoTo,scrollTargetID:this.props.goToShopItemID},function(refChild){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Gate__["a" /* default */],{isOpen:hasItems,placeholder:placeholder},shopItemIDList.map(function(shopItemID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_school_money_shop_ShopItem__["a" /* default */],{key:shopItemID,shopItemID:shopItemID,studentID:studentID,innerRef:function innerRef(child){return refChild(child,Object(__WEBPACK_IMPORTED_MODULE_2_lib_id__["a" /* aggregateID */])(studentID,shopItemID));}});}));});}}],[{key:"renderSearchPlaceholder",value:function renderSearchPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Card__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shop-item-list__placeholder"},"There are no shop items matching your search.")));}}]);return StudentShopItemList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var studentID=_ref.studentID,searchQuery=_ref.searchQuery;return{shopItemIDList:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_5" /* getFilteredShopItemIDList */])(state,studentID),school:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_30" /* getSchoolByStudentID */])(state,studentID),goToShopItemID:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_9" /* getGoToShopItemID */])(state),searchQuery:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_47" /* getShopItemSearchQuery */])(state)};},{clearGoTo:__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_46" /* clearGoToShopItem */]})(StudentShopItemList));

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lib_id__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Highlight__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_school_money_AddButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_school_money_NewIndicator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_school_money_shop_StockLimitReachedAlert__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ShopItem_css__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ShopItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ShopItem_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShopItem=function(_React$Component){_inherits(ShopItem,_React$Component);function ShopItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ShopItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ShopItem.__proto__||Object.getPrototypeOf(ShopItem)).call.apply(_ref,[this].concat(args))),_this),_this.state={showStockLimitReachedAlert:false},_this.onStockLimitReachedAlertClose=function(){_this.setState({showStockLimitReachedAlert:false});},_this.incrementBasketQuantity=function(){if(_this.isAtMaxBasketQuantity()){_this.setState({showStockLimitReachedAlert:true});}else{_this.props.setBasketQuantity(_this.props.quantityInBasket+1);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ShopItem,[{key:"isAtMaxBasketQuantity",value:function isAtMaxBasketQuantity(){var _props=this.props,quantityInBasket=_props.quantityInBasket,maxBasketQuantity=_props.maxBasketQuantity;return quantityInBasket>=maxBasketQuantity;}},{key:"render",value:function render(){var _props2=this.props,shopItem=_props2.shopItem,quantityInBasket=_props2.quantityInBasket,isSeen=_props2.isSeen,isHighlighted=_props2.isHighlighted,innerRef=_props2.innerRef;var name=shopItem.name,price=shopItem.price;var isInBasket=quantityInBasket>0;var classNames=["shop-item"];if(isInBasket){classNames.push("shop-item--in-basket");}if(this.isAtMaxBasketQuantity()){classNames.push("shop-item--at-max-quantity");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" "),ref:innerRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Highlight__["a" /* default */],{cssModifier:"school_money",isHighlighted:isHighlighted},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Card__["a" /* default */].Body,null,isSeen?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_school_money_NewIndicator__["a" /* default */],{className:"shop-item__new-indicator"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shop-item__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shop-item__name"},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shop-item__price"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Currency__["a" /* default */],{amount:price}),isInBasket?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shop-item__basket-quantity"},quantityInBasket):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"shop-item__button"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_school_money_AddButton__["a" /* default */],{className:"shop-item__add-button",onClick:this.incrementBasketQuantity})),this.state.showStockLimitReachedAlert?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_school_money_shop_StockLimitReachedAlert__["a" /* default */],{itemName:name,onClose:this.onStockLimitReachedAlertClose}):null)))));}}]);return ShopItem;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref2){var studentID=_ref2.studentID,shopItemID=_ref2.shopItemID;return{shopItem:Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_44" /* getShopItemByID */])(state,shopItemID),quantityInBasket:Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_43" /* getShopItemBasketQuantity */])(state,shopItemID,studentID),isSeen:Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_109" /* isShopItemSeen */])(state,shopItemID),isHighlighted:Object(__WEBPACK_IMPORTED_MODULE_3_lib_id__["a" /* aggregateID */])(studentID,shopItemID)===Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_9" /* getGoToShopItemID */])(state),maxBasketQuantity:Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_46" /* getShopItemMaxBasketQuantity */])(state,shopItemID)};},function(dispatch,_ref3){var shopItemID=_ref3.shopItemID,studentID=_ref3.studentID;return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({setBasketQuantity:function setBasketQuantity(quantity){return Object(__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_108" /* setShopItemBasketQuantity */])(shopItemID,studentID,quantity);}},dispatch);})(ShopItem));

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StockLimitReachedAlert_css__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StockLimitReachedAlert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__StockLimitReachedAlert_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StockLimitReachedAlert=function(_React$Component){_inherits(StockLimitReachedAlert,_React$Component);function StockLimitReachedAlert(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StockLimitReachedAlert);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StockLimitReachedAlert.__proto__||Object.getPrototypeOf(StockLimitReachedAlert)).call.apply(_ref,[this].concat(args))),_this),_this.onOKClick=function(){_this.props.onClose(true);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StockLimitReachedAlert,[{key:"render",value:function render(){var _props=this.props,isOpen=_props.isOpen,itemName=_props.itemName;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_ModalDialog__["a" /* default */],{isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"stock-limit-reached__title"},"Alert"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"stock-limit-reached__message"},"Stock Limit reached for item ",itemName,". Please check back later."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"stock-limit-reached__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Button__["a" /* default */],{className:"stock-limit-reached__ok-button",onClick:this.onOKClick},"OK"))));}}]);return StockLimitReachedAlert;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);StockLimitReachedAlert.propTypes={isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,itemName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired};StockLimitReachedAlert.defaultProps={isOpen:true};/* harmony default export */ __webpack_exports__["a"] = (StockLimitReachedAlert);

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_MaintainValidStudentID__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_school_money_Preloader__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_StudentSelector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_history_HistoryCard__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HistoryPage_css__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HistoryPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__HistoryPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var cards=[{type:"payment",title:"Transaction History"},{type:"club",title:"Club History"},{type:"dinner",title:"Dinner History"},{type:"meal",title:"Meal Selections"}];// TODO move to appropirate place
function getSortByMethod(historyType){/**
   * Sort by the appropriate date for the history type, negated for desc sort
   *  unless it's default/id, in which case, asc
   */switch(historyType){case"payment":return function(historyItem){return-historyItem.get("paidDate");};case"dinner":return function(historyItem){return-historyItem.get("startDate");};case"club":return function(historyItem){return-historyItem.get("startDate");};case"meal":return function(historyItem){return-historyItem.get("date");};default:return function(historyItem){return historyItem.get("id");};}}// TODO move to appropirate place
/**
 * @returns {Immutable.List}
 */function getHistoryCardItemList(historyItems,type,studentID){// we sort on a different property for each history type
var sortByMethod=getSortByMethod(type);return historyItems.get(type).filter(function(historyItem){return historyItem.get("studentID")===studentID;}).sortBy(sortByMethod).valueSeq().toList();}var HistoryPage=function(_React$PureComponent){_inherits(HistoryPage,_React$PureComponent);function HistoryPage(props){_classCallCheck(this,HistoryPage);var _this=_possibleConstructorReturn(this,(HistoryPage.__proto__||Object.getPrototypeOf(HistoryPage)).call(this,props));_this.generatePath=function(studentID){return"/school_money/history/"+studentID+"/";};_this.isHistoryReady=function(state){return Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_94" /* isHistoryReady */])(state,_this.props.studentID);};_this.onCardExpand=function(studentID,type){_this.setState({expandedCardKey:studentID+":"+type});};_this.onCardCollapse=function(){_this.setState({expandedCardKey:null});};_this.state={expandedCardKey:null};return _this;}_createClass(HistoryPage,[{key:"componentDidMount",value:function componentDidMount(){this.props.fetchHistory();}},{key:"render",value:function render(){var _this2=this;var allHistoryItems=this.props.allHistoryItems;var studentID=this.props.match.params.studentID;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_MaintainValidStudentID__["a" /* default */],{currentStudentID:studentID,generatePath:this.generatePath},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_school_money_Preloader__["a" /* default */],{isPageReady:this.isHistoryReady},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"history-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"page-header__title"},"History"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_StudentSelector__["a" /* default */],{selectedStudentID:studentID,generatePath:this.generatePath})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentCarousel__["a" /* default */],{activeStudentID:studentID,generatePath:this.generatePath},function(studentID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"history-card-list",key:studentID},cards.map(function(_ref){var type=_ref.type,title=_ref.title;var historyCardItems=getHistoryCardItemList(allHistoryItems,type,studentID);var key=studentID+":"+type;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_history_HistoryCard__["a" /* default */],{key:key,type:type,title:title,studentID:studentID,expanded:_this2.state.expandedCardKey===key,onExpand:_this2.onCardExpand,onCollapse:_this2.onCardCollapse,historyItems:historyCardItems});}));}))));}}]);return HistoryPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){return{allHistoryItems:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["s" /* getAllHistoryItems */])(state)};},{fetchHistory:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_57" /* fetchHistory */]})(HistoryPage));

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_ExpandingBox__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_List__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_school_money_history_HistoryItem__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_StudentCreditBalance__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HistoryCard_css__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HistoryCard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__HistoryCard_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HistoryCard=function(_React$PureComponent){_inherits(HistoryCard,_React$PureComponent);function HistoryCard(props){_classCallCheck(this,HistoryCard);var _this=_possibleConstructorReturn(this,(HistoryCard.__proto__||Object.getPrototypeOf(HistoryCard)).call(this,props));_this.footerMessage=false;return _this;}_createClass(HistoryCard,[{key:"getPlaceholderText",value:function getPlaceholderText(){switch(this.props.type){case"payment":return"No Payments Made";case"dinner":return"No Dinner Bookings Made";case"club":return"No Club Bookings Made";case"meal":return"No Meal Selections Made";default:return"";}}},{key:"renderPlaceholder",value:function renderPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"history-card__placeholder"},this.getPlaceholderText());}// Only show this footer bar for external cashless meals.
},{key:"renderExternalCashlessMealFooterBar",value:function renderExternalCashlessMealFooterBar(){if(this.props.type!=="meal"){return;}if(!this.props.isExternalCashlessStudent){return;}this.footerMessage="The Dinner Balance can take a while to update. The amount displayed may not accurately reflect the current balance.";}// Generates a footer bar if there is a footer message set.
},{key:"renderFooterBar",value:function renderFooterBar(){if(this.footerMessage===false){return;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"history-card__footer"},this.footerMessage);}},{key:"render",value:function render(){var _this2=this;var _props=this.props,historyItems=_props.historyItems,title=_props.title,type=_props.type,studentID=_props.studentID,expanded=_props.expanded;var showCredit=type==="meal";// Set footer bar message for external cashless students meal selections.
this.renderExternalCashlessMealFooterBar();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"history-card history-card--"+type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ExpandingBox__["a" /* default */],{cssModifier:"school_money",expanded:expanded,onExpand:function onExpand(){return _this2.props.onExpand(_this2.props.studentID,_this2.props.type);},onCollapse:function onCollapse(){return _this2.props.onCollapse(null);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ExpandingBox__["a" /* default */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"history-card__header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"history-card__title"},title),showCredit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_StudentCreditBalance__["a" /* default */],{studentID:studentID,type:"dinner_money"}):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_ExpandingBox__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"history-card__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_List__["a" /* default */],{placeholder:this.renderPlaceholder()},historyItems.map(function(historyItem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_school_money_history_HistoryItem__["a" /* default */],{key:historyItem.get("id"),type:type,historyItem:historyItem});}))),this.renderFooterBar())));}}]);return HistoryCard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(function(state,ownProps){return{isExternalCashlessStudent:Object(__WEBPACK_IMPORTED_MODULE_6_state_school_money_selectors__["q" /* doesStudentUseExternalCashless */])(state,ownProps.studentID)};})(HistoryCard));

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lib_date__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Date__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_history_ClubBookingStatusIndicator__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_school_money_history_DinnerBookingStatusIndicator__ = __webpack_require__(684);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HistoryItem=function(_React$Component){_inherits(HistoryItem,_React$Component);function HistoryItem(){_classCallCheck(this,HistoryItem);return _possibleConstructorReturn(this,(HistoryItem.__proto__||Object.getPrototypeOf(HistoryItem)).apply(this,arguments));}_createClass(HistoryItem,[{key:"formatPaymentMethod",value:function formatPaymentMethod(paymentMethod){switch(paymentMethod){case"cc":return"Credit Card";case"dc":return"Debit Card";case"ca":return"Cash";case"ba":return"Bank Transfer";case"vo":return"Voucher";case"pp":return"PayPoint";case"ch":return"Cheque";default:return"Unknown";}}},{key:"getPaymentItemDetails",value:function getPaymentItemDetails(){var payment=this.props.historyItem.toJS();// -1 installment means this is a credit payment
var isCredit=payment.installmentNumber===-1;return[["Instalment",isCredit?"Credit":payment.installmentNumber],["Paid",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Currency__["a" /* default */],{amount:payment.paidAmount})],["Payment Date",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Date__["a" /* default */],{date:payment.paidDate})],["Refunded",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Currency__["a" /* default */],{amount:payment.refundedAmount})],["Payment Method",this.formatPaymentMethod(payment.paymentMethod)]];}},{key:"getDinnerItemDetails",value:function getDinnerItemDetails(){var dinner=this.props.historyItem.toJS();var weekdayStatus=__WEBPACK_IMPORTED_MODULE_1_lib_date__["a" /* WEEKDAYS */].map(function(weekdayName,weekdayIndex){return[weekdayName,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_school_money_history_DinnerBookingStatusIndicator__["a" /* default */],dinner.booking[weekdayIndex])];});return[["Dinner",dinner.description],["Start Date",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Date__["a" /* default */],{date:dinner.startDate})],["End Date",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Date__["a" /* default */],{date:dinner.endDate})]].concat(_toConsumableArray(weekdayStatus),[["Weekly Total",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Currency__["a" /* default */],{amount:dinner.totalPrice})]]);}},{key:"getClubItemDetails",value:function getClubItemDetails(){var club=this.props.historyItem.toJS();var weekdayStatus=__WEBPACK_IMPORTED_MODULE_1_lib_date__["a" /* WEEKDAYS */].map(function(weekdayName,weekdayIndex){return[weekdayName,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_history_ClubBookingStatusIndicator__["a" /* default */],club.booking[weekdayIndex])];});return[["Start Date",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Date__["a" /* default */],{date:club.startDate})],["End Date",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Date__["a" /* default */],{date:club.endDate})]].concat(_toConsumableArray(weekdayStatus),[["Weekly Total",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Currency__["a" /* default */],{amount:club.weeklyTotalAmount})],["Amount Paid",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Currency__["a" /* default */],{amount:club.paidAmount})],["Amount Due",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Currency__["a" /* default */],{amount:club.dueAmount})]]);}},{key:"getMealItemDetails",value:function getMealItemDetails(){var meal=this.props.historyItem.toJS();return meal.selections.map(function(_ref){var name=_ref.name,price=_ref.price;return[name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Currency__["a" /* default */],{amount:price})];});}},{key:"getDetails",value:function getDetails(){switch(this.props.type){case"payment":return this.getPaymentItemDetails();case"dinner":return this.getDinnerItemDetails();case"club":return this.getClubItemDetails();case"meal":return this.getMealItemDetails();default:return[];}}},{key:"renderPaymentHeader",value:function renderPaymentHeader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"history-item__header-text"},this.props.historyItem.get("description"));}},{key:"renderClubHeader",value:function renderClubHeader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"history-item__header-text"},this.props.historyItem.get("description"));}},{key:"renderMealHeader",value:function renderMealHeader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"history-item__header-text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_Date__["a" /* default */],{date:this.props.historyItem.get("date")}));}},{key:"renderHeader",value:function renderHeader(){switch(this.props.type){case"payment":return this.renderPaymentHeader();case"club":return this.renderClubHeader();case"meal":return this.renderMealHeader();default:return null;}}},{key:"renderDetails",value:function renderDetails(){return this.getDetails().map(function(row,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"history-item__detail-label"},row[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"history-item__detail-value"},row[1]));});}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"history-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr",{className:"history-item__separator"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"history-item__header"},this.renderHeader()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"history-item__details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,this.renderDetails())));}}]);return HistoryItem;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (HistoryItem);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_school_money_history_StatusIndicator__ = __webpack_require__(196);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClubBookingStatusIndicator=function(_React$Component){_inherits(ClubBookingStatusIndicator,_React$Component);function ClubBookingStatusIndicator(){_classCallCheck(this,ClubBookingStatusIndicator);return _possibleConstructorReturn(this,(ClubBookingStatusIndicator.__proto__||Object.getPrototypeOf(ClubBookingStatusIndicator)).apply(this,arguments));}_createClass(ClubBookingStatusIndicator,[{key:"getStatusIndicatorProps",value:function getStatusIndicatorProps(){var _props=this.props,status=_props.status,sessionNumber=_props.sessionNumber;switch(status){case"ATTENDED":if(sessionNumber===null){return{color:"#87BC49",label:"Attended"};}else{return{color:"#87BC49",label:"Attended",iconContent:sessionNumber};}case"NOT_ATTENDED":return{color:"#B5CFDB",label:"Not Attended"};case"HOLIDAY":return{color:"#808080",label:"School Holiday"};default:return{};}}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_school_money_history_StatusIndicator__["a" /* default */],this.getStatusIndicatorProps());}}]);return ClubBookingStatusIndicator;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ClubBookingStatusIndicator);

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_school_money_history_StatusIndicator__ = __webpack_require__(196);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DinnerBookingStatusIndicator=function(_React$Component){_inherits(DinnerBookingStatusIndicator,_React$Component);function DinnerBookingStatusIndicator(){_classCallCheck(this,DinnerBookingStatusIndicator);return _possibleConstructorReturn(this,(DinnerBookingStatusIndicator.__proto__||Object.getPrototypeOf(DinnerBookingStatusIndicator)).apply(this,arguments));}_createClass(DinnerBookingStatusIndicator,[{key:"getStatusIndicatorProps",value:function getStatusIndicatorProps(){switch(this.props.status){case"MEAL":return{color:"#87BC49",label:"Paid Meal"};case"SANDWICH":return{color:"#895196",label:"Sandwiches"};case"FSM":return{color:"#134D68",label:"Free Meal"};case"NONE":return{color:"#B5CFDB",label:"No Dinner"};case"HOLIDAY":return{color:"#808080",label:"School Holiday"};case"UFSM":return{color:"#AC3524",label:"Infant Free Meal"};default:return{};}}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_school_money_history_StatusIndicator__["a" /* default */],this.getStatusIndicatorProps());}}]);return DinnerBookingStatusIndicator;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (DinnerBookingStatusIndicator);

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_MaintainValidStudentID__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_school_money_Preloader__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_StudentSelector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_clubs_StudentClubBookingList__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ClubsPage_css__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ClubsPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ClubsPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClubsPage=function(_React$Component){_inherits(ClubsPage,_React$Component);function ClubsPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClubsPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClubsPage.__proto__||Object.getPrototypeOf(ClubsPage)).call.apply(_ref,[this].concat(args))),_this),_this.isPageReady=function(state){return Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_81" /* isClubsReady */])(state,_this.props.match.params.studentID);},_this.generatePath=function(studentID){return"/school_money/clubs/"+studentID+"/";},_this.onStudentChange=function(studentID,prevStudentID){_this.props.markStudentClubBookingsAsSeen(prevStudentID);_this.clearFocus();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClubsPage,[{key:"componentWillUnmount",value:function componentWillUnmount(){this.props.markStudentClubBookingsAsSeen(this.props.match.params.studentID);}// ---------------------------------------------------------------------------
// Clear focus is nescessary to turn off focus on dropdown menus when the
// student is changed. At present changing the focus of the page to a div
// element corrects this problem (IOS).
// ---------------------------------------------------------------------------
},{key:"clearFocus",value:function clearFocus(){// Get the first clubs-page element, should only be one.
var dinnerPageElement=document.getElementsByClassName("clubs-page")[0];// Catch error when element is missing, do not continue;
if(dinnerPageElement===undefined){return;}// To be able to focus on a div element we need to add a tabindex.
dinnerPageElement.tabIndex=-1;dinnerPageElement.focus();}},{key:"render",value:function render(){var studentID=this.props.match.params.studentID;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_MaintainValidStudentID__["a" /* default */],{currentStudentID:studentID,generatePath:this.generatePath},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_school_money_Preloader__["a" /* default */],{isPageReady:this.isPageReady},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clubs-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"page-header__title"},"Clubs"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_StudentSelector__["a" /* default */],{selectedStudentID:studentID,generatePath:this.generatePath})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentCarousel__["a" /* default */],{activeStudentID:studentID,generatePath:this.generatePath,onChange:this.onStudentChange},function(studentID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_clubs_StudentClubBookingList__["a" /* default */],{key:studentID,studentID:studentID});}))));}}]);return ClubsPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(undefined,{markStudentClubBookingsAsSeen:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_78" /* markStudentClubBookingsAsSeen */]})(ClubsPage));

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ScrollableList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_List__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_PlaceholderCard__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentCreditBalance__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_clubs_ClubCreditTopUp__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_school_money_clubs_ClubBooking__ = __webpack_require__(690);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StudentClubBookingList=function(_React$Component){_inherits(StudentClubBookingList,_React$Component);function StudentClubBookingList(){_classCallCheck(this,StudentClubBookingList);return _possibleConstructorReturn(this,(StudentClubBookingList.__proto__||Object.getPrototypeOf(StudentClubBookingList)).apply(this,arguments));}_createClass(StudentClubBookingList,[{key:"hasChildren",value:function hasChildren(){return;}},{key:"render",value:function render(){var _props=this.props,studentID=_props.studentID,clubBookingIDList=_props.clubBookingIDList,school=_props.school,isTopUpsEnabled=_props.isTopUpsEnabled,canStudentTopUp=_props.canStudentTopUp,forceClubBooking=_props.forceClubBooking;var placeholder=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_PlaceholderCard__["a" /* default */],{objectName:"club bookings",school:school});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ScrollableList__["a" /* default */],{className:"club-booking-list",scrollTargetID:this.props.goToClubBookingID,onScroll:this.props.clearGoTo},function(refChild){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentCreditBalance__["a" /* default */],{studentID:studentID,type:"club_extended_services"}),isTopUpsEnabled&&canStudentTopUp&&!forceClubBooking?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_clubs_ClubCreditTopUp__["a" /* default */],{studentID:studentID}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,isTopUpsEnabled&&canStudentTopUp&&forceClubBooking?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_clubs_ClubCreditTopUp__["a" /* default */],{studentID:studentID}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_List__["a" /* default */],{placeholder:placeholder},clubBookingIDList.map(function(clubBookingID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_school_money_clubs_ClubBooking__["a" /* default */],{key:clubBookingID,clubBookingID:clubBookingID,innerRef:function innerRef(ref){return refChild(ref,clubBookingID);}});}))));});}}]);return StudentClubBookingList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var studentID=_ref.studentID;return{clubBookingIDList:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_49" /* getStudentClubBookingIDList */])(state,studentID),school:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_30" /* getSchoolByStudentID */])(state,studentID),isTopUpsEnabled:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_80" /* isClubTopUpsEnabled */])(state,Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_56" /* getStudentSchoolID */])(state,studentID)),goToClubBookingID:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_6" /* getGoToClubBookingID */])(state),canStudentTopUp:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["c" /* canStudentDoClubTopUp */])(state,studentID),forceClubBooking:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["r" /* forceClubBookingForStudent */])(state,studentID)};},{clearGoTo:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_43" /* clearGoToClubBooking */]})(StudentClubBookingList));

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_CreditTopUp__ = __webpack_require__(191);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClubCreditTopUp=function(_React$Component){_inherits(ClubCreditTopUp,_React$Component);function ClubCreditTopUp(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClubCreditTopUp);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClubCreditTopUp.__proto__||Object.getPrototypeOf(ClubCreditTopUp)).call.apply(_ref,[this].concat(args))),_this),_this.addToBasket=function(amount){var studentID=_this.props.studentID;_this.props.addToBasket("club_extended_services",studentID,amount);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClubCreditTopUp,[{key:"render",value:function render(){var defaultAmount=this.props.defaultAmount;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_CreditTopUp__["a" /* default */],{label:"Club Top Up",defaultAmount:defaultAmount,onAddToBasket:this.addToBasket});}}]);return ClubCreditTopUp;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref2){var studentID=_ref2.studentID;var schoolID=Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_56" /* getStudentSchoolID */])(state,studentID);return{schoolID:schoolID,defaultAmount:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["Q" /* getClubTopUpDefaultAmount */])(state,schoolID)};},{addToBasket:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_36" /* addCreditTopUpToBasket */]})(ClubCreditTopUp));

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_ExpandingBox__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Highlight__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Date__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_ShortDate__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_WeekdayTable__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_school_money_AddButton__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_school_money_NewIndicator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_school_money_BasketModificationModal__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_school_money_AddToBasketConfirmationModal__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_school_money_clubs_DailyClubSessionInput__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ClubBooking_css__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ClubBooking_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__ClubBooking_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClubBooking=function(_React$Component){_inherits(ClubBooking,_React$Component);function ClubBooking(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClubBooking);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClubBooking.__proto__||Object.getPrototypeOf(ClubBooking)).call.apply(_ref,[this].concat(args))),_this),_this.state={isBasketConfirmationModalOpen:false,shouldReserveAfterConfirmation:undefined,isBasketModificationModalOpen:false},_this.addToBasket=function(reserve){_this.props.addToBasket(reserve);_this.props.collapse();},_this.onBasketConfirmationModalClose=function(result){if(result){_this.addToBasket(_this.state.shouldReserveAfterConfirmation);}_this.setState({isBasketConfirmationModalOpen:false,shouldReserveAfterConfirmation:undefined});},_this.confirmAddToBasket=function(reserve){if(_this.props.limitedPlaces.enabled||_this.props.clubBooking.requiresParentalConsent){_this.setState({isBasketConfirmationModalOpen:true,shouldReserveAfterConfirmation:reserve});}else{_this.addToBasket(reserve);}},_this.onAddToBasketClick=function(){// if the booking is in the basket then show an alert
if(_this.props.isInBasket){_this.onReadOnlyClick();// add to basket if we have modifications
}else if(_this.props.isModified||_this.props.isReserved){_this.confirmAddToBasket(false);}},_this.onReserveClick=function(){if(_this.props.isInBasket){_this.onReadOnlyClick();}else if(_this.props.isModified){_this.confirmAddToBasket(true);}},_this.removeFromBasket=function(){_this.props.removeFromBasket();},_this.onReadOnlyClick=function(){_this.setState({isBasketModificationModalOpen:true});},_this.onBasketModificationModalClose=function(result){if(result){_this.removeFromBasket();}_this.setState({isBasketModificationModalOpen:false});},_temp),_possibleConstructorReturn(_this,_ret);}/**
   * If the modal was closed with a positive/"yes" then remove from basket
   */_createClass(ClubBooking,[{key:"render",value:function render(){var _this2=this;var _props=this.props,clubBooking=_props.clubBooking,clubBookingID=_props.clubBookingID,totalPrice=_props.totalPrice,limitedPlaces=_props.limitedPlaces,isExpanded=_props.isExpanded,isModified=_props.isModified,isInBasket=_props.isInBasket,isSeen=_props.isSeen,isBooked=_props.isBooked,isReserved=_props.isReserved,isHighlighted=_props.isHighlighted,expand=_props.expand,collapse=_props.collapse;var _clubBooking$toJS=clubBooking.toJS(),description=_clubBooking$toJS.description,startDate=_clubBooking$toJS.startDate,lastModifiedDate=_clubBooking$toJS.lastModifiedDate,isReservationsEnabled=_clubBooking$toJS.isReservationsEnabled,requiresParentalConsent=_clubBooking$toJS.requiresParentalConsent;var hasLastModifiedDate=lastModifiedDate!=="";var status=null;if(isReserved){status="Reserved";}else if(isBooked){status="Booked";}var classNames=["club-booking"];if(!isModified){classNames.push("club-booking--no-reserve");}if(!isReserved&&!isModified){classNames.push("club-booking--no-add-to-basket");}if(isInBasket){classNames.push("club-booking--in-basket");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" "),ref:this.props.innerRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_components_school_money_BasketModificationModal__["a" /* default */],{isOpen:this.state.isBasketModificationModalOpen,onClose:this.onBasketModificationModalClose,itemName:"week"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_components_school_money_AddToBasketConfirmationModal__["a" /* default */],{type:"club",isOpen:this.state.isBasketConfirmationModalOpen,consentRequired:requiresParentalConsent,limitedPlaces:limitedPlaces,onClose:this.onBasketConfirmationModalClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Highlight__["a" /* default */],{cssModifier:"school_money",isHighlighted:isHighlighted},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ExpandingBox__["a" /* default */],{cssModifier:"school_money",expanded:isExpanded,onExpand:expand,onCollapse:collapse},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ExpandingBox__["a" /* default */].Header,null,isSeen?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_components_school_money_NewIndicator__["a" /* default */],{className:"club-booking__new-indicator"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"club-booking__header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"club-booking__description"},description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"club-booking__week-date"},"W/C ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Date__["a" /* default */],{date:startDate}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"club-booking__status"},status)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_ExpandingBox__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"club-booking__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"club-booking__session-selections"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_components_WeekdayTable__["a" /* default */],{cssBlockName:"weekly-session-input"},function(weekdayIndex,weekdayName){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_components_school_money_clubs_DailyClubSessionInput__["a" /* default */],{key:weekdayIndex,clubBookingID:clubBookingID,weekdayIndex:weekdayIndex,weekdayName:weekdayName,onReadOnlyClick:_this2.onReadOnlyClick});})),limitedPlaces.enabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"club-booking__limited-places"},"Limited Places"):null,isReservationsEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"club-booking__row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Button__["a" /* default */],{className:"club-booking__reserve-button",onClick:this.onReserveClick},"Reserve")):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"club-booking__row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"club-booking__total"},"Total: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_components_Currency__["a" /* default */],{className:"club-booking__total-amount",amount:totalPrice})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_components_school_money_AddButton__["a" /* default */],{className:"club-booking__add-button",onClick:this.onAddToBasketClick}))),hasLastModifiedDate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"club-booking__last-modified"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"club-booking__last-modified-label"},"Last Modified "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"club-booking__last-modified-date"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_ShortDate__["a" /* default */],{date:lastModifiedDate}))):null))));}}]);return ClubBooking;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref2){var clubBookingID=_ref2.clubBookingID;return{clubBooking:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["I" /* getClubBookingByID */])(state,clubBookingID),totalPrice:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["P" /* getClubBookingTotalPrice */])(state,clubBookingID),limitedPlaces:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["L" /* getClubBookingLimitedPlacesDetails */])(state,clubBookingID),isExpanded:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_76" /* isClubBookingExpanded */])(state,clubBookingID),isInBasket:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_77" /* isClubBookingInBasket */])(state,clubBookingID),isModified:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_61" /* hasClubBookingBeenModified */])(state,clubBookingID),isSeen:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_79" /* isClubBookingSeen */])(state,clubBookingID),isBooked:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["h" /* doesClubBookingHaveBookings */])(state,clubBookingID),isReserved:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_78" /* isClubBookingReserved */])(state,clubBookingID),isHighlighted:clubBookingID===Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_6" /* getGoToClubBookingID */])(state)};},function(dispatch,_ref3){var clubBookingID=_ref3.clubBookingID;return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({addToBasket:function addToBasket(reserve){return Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_35" /* addClubBookingToBasket */])(clubBookingID,reserve);},removeFromBasket:function removeFromBasket(){return Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_87" /* removeClubBookingFromBasket */])(clubBookingID);},expand:function expand(){return Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_102" /* setExpandedClubBooking */])(clubBookingID);},collapse:function collapse(){return Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_102" /* setExpandedClubBooking */])(null);}},dispatch);})(ClubBooking));

/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Dropdown__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DailyClubSessionInput_css__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DailyClubSessionInput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DailyClubSessionInput_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DailyClubSessionInput=function(_React$Component){_inherits(DailyClubSessionInput,_React$Component);function DailyClubSessionInput(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DailyClubSessionInput);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DailyClubSessionInput.__proto__||Object.getPrototypeOf(DailyClubSessionInput)).call.apply(_ref,[this].concat(args))),_this),_this.onClick=function(event){// trigger the alert if we're in the basket but would be selectable otherwise
if(_this.isReadOnly()&&!_this.isDisabled()){_this.props.onReadOnlyClick(event);}},_this.onSessionSelected=function(sessionID){if(sessionID!==null){sessionID=Number(sessionID);}_this.props.selectSession(sessionID);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DailyClubSessionInput,[{key:"isDisabled",value:function isDisabled(){var _props=this.props,isBooked=_props.isBooked,isHoliday=_props.isHoliday,isFull=_props.isFull,isExpired=_props.isExpired;return isHoliday||isFull&&!isBooked||isExpired;}},{key:"isReadOnly",value:function isReadOnly(){return this.props.isInBasket;}},{key:"isSessionSelected",value:function isSessionSelected(){return this.props.selectedSession!==undefined;}/**
   * NB: Dropdown requires IDs as strings, so we need to convert back and forth
   */},{key:"renderDropdown",value:function renderDropdown(){var _props2=this.props,sessionList=_props2.sessionList,selectedSession=_props2.selectedSession;var selectedSessionID=this.isSessionSelected()?selectedSession.get("id"):"";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Dropdown__["a" /* default */],{cssModifier:"school_money",options:sessionList,selectedOptionID:selectedSessionID.toString(),onChange:this.onSessionSelected,placeholder:"No Selection",disabled:this.isDisabled(),readOnly:this.isReadOnly()});}},{key:"render",value:function render(){var _props3=this.props,weekdayName=_props3.weekdayName,isFull=_props3.isFull,selectedSession=_props3.selectedSession;var sessionPrice=this.isSessionSelected()?selectedSession.get("price"):0;var showFull=this.isDisabled()&&isFull;var classNames=["daily-session-input"];if(this.isDisabled()){classNames.push("daily-session-input--disabled");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:classNames.join(" "),onClick:this.onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"daily-session-input__weekday"},weekdayName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"daily-session-input__input"},this.renderDropdown(),showFull?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"daily-session-input__full"},"FULL"):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"daily-session-input__price"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Currency__["a" /* default */],{amount:sessionPrice})));}}]);return DailyClubSessionInput;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref2){var clubBookingID=_ref2.clubBookingID,weekdayIndex=_ref2.weekdayIndex;return{sessionList:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["O" /* getClubBookingSessionList */])(state,clubBookingID,weekdayIndex),selectedSession:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["M" /* getClubBookingSelectedSession */])(state,clubBookingID,weekdayIndex),isBooked:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_72" /* isClubBookingDayBooked */])(state,clubBookingID,weekdayIndex),isHoliday:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_75" /* isClubBookingDayHoliday */])(state,clubBookingID,weekdayIndex),isFull:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_74" /* isClubBookingDayFull */])(state,clubBookingID,weekdayIndex),isInBasket:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_77" /* isClubBookingInBasket */])(state,clubBookingID),isExpired:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_73" /* isClubBookingDayExpired */])(state,clubBookingID,weekdayIndex)};},function(dispatch,_ref3){var clubBookingID=_ref3.clubBookingID,weekdayIndex=_ref3.weekdayIndex;return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({selectSession:function selectSession(sessionID){return Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_95" /* selectClubBookingSession */])(clubBookingID,weekdayIndex,sessionID);}},dispatch);})(DailyClubSessionInput));

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_Preloader__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_school_money_MaintainValidStudentID__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_StudentSelector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_payments_StudentPaymentList__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaymentsPage_css__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaymentsPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__PaymentsPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentsPage=function(_React$Component){_inherits(PaymentsPage,_React$Component);function PaymentsPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PaymentsPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PaymentsPage.__proto__||Object.getPrototypeOf(PaymentsPage)).call.apply(_ref,[this].concat(args))),_this),_this.isPaymentsReady=function(state){return Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_106" /* isPaymentsReady */])(state,_this.props.studentID);},_this.onStudentChange=function(studentID,prevStudentID){_this.props.markStudentPaymentsAsSeen(prevStudentID);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PaymentsPage,[{key:"generatePath",value:function generatePath(studentID){return"/school_money/payments/"+studentID+"/";}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.props.markStudentPaymentsAsSeen(this.props.match.params.studentID);}},{key:"render",value:function render(){var studentID=this.props.match.params.studentID;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_school_money_MaintainValidStudentID__["a" /* default */],{currentStudentID:studentID,generatePath:this.generatePath},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_Preloader__["a" /* default */],{isPageReady:this.isPaymentsReady},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payments-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"page-header__title"},"Payments"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_StudentSelector__["a" /* default */],{selectedStudentID:studentID,generatePath:this.generatePath})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_StudentCarousel__["a" /* default */],{activeStudentID:studentID,generatePath:this.generatePath,onChange:this.onStudentChange},function(studentID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_payments_StudentPaymentList__["a" /* default */],{key:studentID,studentID:studentID});}))));}}]);return PaymentsPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(undefined,{markStudentPaymentsAsSeen:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_80" /* markStudentPaymentsAsSeen */]})(PaymentsPage));

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ScrollableList__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_List__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_PlaceholderCard__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_payments_Payment__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_payments_UnpaidDinnerMoneyPayment__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_school_money_payments_UnpaidClubMoneyPayment__ = __webpack_require__(708);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StudentPaymentList=function(_React$Component){_inherits(StudentPaymentList,_React$Component);function StudentPaymentList(){_classCallCheck(this,StudentPaymentList);return _possibleConstructorReturn(this,(StudentPaymentList.__proto__||Object.getPrototypeOf(StudentPaymentList)).apply(this,arguments));}_createClass(StudentPaymentList,[{key:"renderPayments",value:function renderPayments(refChild){var _props=this.props,studentID=_props.studentID,paymentIDList=_props.paymentIDList,hasUnpaidDinnerMoney=_props.hasUnpaidDinnerMoney,hasUnpaidClubMoney=_props.hasUnpaidClubMoney,school=_props.school;var placeholder=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_PlaceholderCard__["a" /* default */],{objectName:"payments",school:school});// We have to make sure we only add UnpaidDinnerMoneyPayment if it is
//   actually going to render. Otherwise, List gets confused and doesn't
//   render our placeholder.
var payments=paymentIDList.map(function(paymentID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_payments_Payment__["a" /* default */],{key:paymentID,paymentID:paymentID,innerRef:function innerRef(child){return refChild(child,paymentID);}});});if(hasUnpaidDinnerMoney){payments=payments.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_payments_UnpaidDinnerMoneyPayment__["a" /* default */],{key:"dinner",studentID:studentID,innerRef:function innerRef(child){return refChild(child,"dinner");}}));}if(hasUnpaidClubMoney){payments=payments.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_school_money_payments_UnpaidClubMoneyPayment__["a" /* default */],{key:"club",studentID:studentID,innerRef:function innerRef(child){return refChild(child,"club");}}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_List__["a" /* default */],{placeholder:placeholder},payments);}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ScrollableList__["a" /* default */],{className:"payments-list",scrollTargetID:this.props.goToPaymentID,onScroll:this.props.clearGoTo},function(refChild){return _this2.renderPayments(refChild);});}}]);return StudentPaymentList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var studentID=_ref.studentID;return{paymentIDList:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_54" /* getStudentPaymentIDList */])(state,studentID),school:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_30" /* getSchoolByStudentID */])(state,studentID),hasUnpaidDinnerMoney:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_59" /* getStudentTotalCreditAmountToPay */])(state,studentID,"dinner_money")<0,hasUnpaidClubMoney:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_59" /* getStudentTotalCreditAmountToPay */])(state,studentID,"club_extended_services")<0,goToPaymentID:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_8" /* getGoToPaymentID */])(state)};},{clearGoTo:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_45" /* clearGoToPayment */]})(StudentPaymentList));

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ExpandingBox__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Highlight__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_payments_PaymentHeader__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_payments_OfflineOnlyPaymentBody__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_school_money_payments_PaymentInstallmentList__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Payment_css__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Payment_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Payment_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Payment=function(_React$Component){_inherits(Payment,_React$Component);function Payment(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Payment);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Payment.__proto__||Object.getPrototypeOf(Payment)).call.apply(_ref,[this].concat(args))),_this),_this.expand=function(){_this.props.setExpandedPayment(_this.props.paymentID);},_this.collapse=function(){_this.props.setExpandedPayment(null);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Payment,[{key:"hasMultipleInstallments",value:function hasMultipleInstallments(){return this.props.payment.get("installments").size>1;}},{key:"getlimitedPlacesIndicator",value:function getlimitedPlacesIndicator(){var _props$payment$toObje=this.props.payment.toObject(),hasLimitedPlaces=_props$payment$toObje.hasLimitedPlaces;return hasLimitedPlaces?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment__limited-places"},"Limited Places"):null;}},{key:"renderOfflineOnlyPayment",value:function renderOfflineOnlyPayment(){var _props=this.props,paymentID=_props.paymentID,isExpanded=_props.isExpanded;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ExpandingBox__["a" /* default */],{cssModifier:"school_money",expanded:isExpanded,onExpand:this.expand,onCollapse:this.collapse},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ExpandingBox__["a" /* default */].Header,{toggleOnClick:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_payments_PaymentHeader__["a" /* default */],{paymentID:paymentID})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ExpandingBox__["a" /* default */].Body,{toggleOnClick:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_payments_OfflineOnlyPaymentBody__["a" /* default */],{paymentID:paymentID}),this.getlimitedPlacesIndicator()));}},{key:"renderExpandingPayment",value:function renderExpandingPayment(){var _props2=this.props,paymentID=_props2.paymentID,payment=_props2.payment,isExpanded=_props2.isExpanded;var installmentNumberList=payment.get("installments").keySeq().toArray();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ExpandingBox__["a" /* default */],{cssModifier:"school_money",expanded:isExpanded,onExpand:this.expand,onCollapse:this.collapse},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ExpandingBox__["a" /* default */].Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_payments_PaymentHeader__["a" /* default */],{paymentID:paymentID})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ExpandingBox__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_school_money_payments_PaymentInstallmentList__["a" /* default */],{paymentID:paymentID,installmentNumberList:installmentNumberList,showAddRemoveButtons:this.hasMultipleInstallments()}),this.getlimitedPlacesIndicator()));}},{key:"renderSimplePayment",value:function renderSimplePayment(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card__["a" /* default */],{className:"payment"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_payments_PaymentHeader__["a" /* default */],{paymentID:this.props.paymentID,limitedPlacesIndicator:this.getlimitedPlacesIndicator()})));}},{key:"render",value:function render(){var _props$payment$toObje2=this.props.payment.toObject(),isOfflineOnly=_props$payment$toObje2.isOfflineOnly,isPartial=_props$payment$toObje2.isPartial,isVoluntary=_props$payment$toObje2.isVoluntary;var hasMultipleInstallments=this.hasMultipleInstallments();var innerChild=void 0;if(isOfflineOnly){innerChild=this.renderOfflineOnlyPayment();}else if(hasMultipleInstallments||isVoluntary||isPartial){innerChild=this.renderExpandingPayment();}else{innerChild=this.renderSimplePayment();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:this.props.innerRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Highlight__["a" /* default */],{cssModifier:"school_money",isHighlighted:this.props.isHighlighted},innerChild));}}]);return Payment;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref2){var paymentID=_ref2.paymentID;return{payment:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_21" /* getPaymentByID */])(state,paymentID),isExpanded:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_98" /* isPaymentExpanded */])(state,paymentID),isHighlighted:paymentID===Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_8" /* getGoToPaymentID */])(state)};},{setExpandedPayment:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_104" /* setExpandedPayment */]})(Payment));

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Date__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_school_money_NewIndicator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_payments_PaymentBasketButton__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentHeader_css__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PaymentHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__PaymentHeader_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentHeader=function(_React$Component){_inherits(PaymentHeader,_React$Component);function PaymentHeader(){_classCallCheck(this,PaymentHeader);return _possibleConstructorReturn(this,(PaymentHeader.__proto__||Object.getPrototypeOf(PaymentHeader)).apply(this,arguments));}_createClass(PaymentHeader,[{key:"getInstallmentCount",value:function getInstallmentCount(){return this.props.payment.get("installments").size;}},{key:"hasMultipleInstallments",value:function hasMultipleInstallments(){return this.getInstallmentCount()>1;}},{key:"getInstallment",value:function getInstallment(){return this.props.payment.get("installments").first();}},{key:"getAnnotation",value:function getAnnotation(){var _props$payment$toObje=this.props.payment.toObject(),isPartial=_props$payment$toObje.isPartial,isVoluntary=_props$payment$toObje.isVoluntary,isOfflineOnly=_props$payment$toObje.isOfflineOnly;if(isOfflineOnly){return"Offline Only";}if(this.hasMultipleInstallments()){var installmentCount=this.getInstallmentCount();if(isVoluntary){return installmentCount+" Voluntary Payments";}if(isPartial){return installmentCount+" Partial Payments";}return installmentCount+" Payments";}if(isVoluntary){return"Voluntary Payment";}if(isPartial){return"Partial Payment";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Date__["a" /* default */],{date:this.getInstallment().get("dueDate")});}},{key:"getStatus",value:function getStatus(){if(this.props.isOverdue){return"Overdue";}return null;}},{key:"render",value:function render(){var _props=this.props,payment=_props.payment,paymentID=_props.paymentID,totalPrice=_props.totalPrice,isOverdue=_props.isOverdue,isSeen=_props.isSeen,limitedPlacesIndicator=_props.limitedPlacesIndicator;var _payment$toObject=payment.toObject(),description=_payment$toObject.description,isOfflineOnly=_payment$toObject.isOfflineOnly;var isSinglePaymentInstallment=!this.hasMultipleInstallments()&&!payment.isVoluntary&&!payment.isPartial;var classNames=["payment-header"];if(isOverdue){classNames.push("payment-header--overdue");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},isSeen?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_school_money_NewIndicator__["a" /* default */],{className:"payment-header__new-indicator"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__description"},description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__annotation"+(isSinglePaymentInstallment&&isOverdue?" payment-header__annotation--overdue":"")},this.getAnnotation())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__controls"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__price"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_Currency__["a" /* default */],{amount:totalPrice})),isOfflineOnly||this.hasMultipleInstallments()?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_payments_PaymentBasketButton__["a" /* default */],{cssBlockName:"payment-header",paymentID:paymentID,installmentNumber:this.getInstallment().get("number")}))),limitedPlacesIndicator,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__status"},this.getStatus()));}}]);return PaymentHeader;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var paymentID=_ref.paymentID;return{payment:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_21" /* getPaymentByID */])(state,paymentID),totalPrice:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_26" /* getPaymentTotalOutstandingPrice */])(state,paymentID),isOverdue:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_103" /* isPaymentOverdue */])(state,paymentID),isSeen:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_105" /* isPaymentSeen */])(state,paymentID)};})(PaymentHeader));

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Date__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OfflineOnlyPaymentBody_css__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OfflineOnlyPaymentBody_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__OfflineOnlyPaymentBody_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OfflineOnlyPaymentBody=function(_React$Component){_inherits(OfflineOnlyPaymentBody,_React$Component);function OfflineOnlyPaymentBody(){_classCallCheck(this,OfflineOnlyPaymentBody);return _possibleConstructorReturn(this,(OfflineOnlyPaymentBody.__proto__||Object.getPrototypeOf(OfflineOnlyPaymentBody)).apply(this,arguments));}_createClass(OfflineOnlyPaymentBody,[{key:"render",value:function render(){var _props=this.props,payment=_props.payment,isOverdue=_props.isOverdue;var _payment$installments=payment.installments.first(),dueDate=_payment$installments.dueDate;var classNames=["payment-body","offline-only-payment-body"];if(isOverdue){classNames.push("offline-only-payment-body--overdue");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Due ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"offline-only-payment-body__due-date"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_Date__["a" /* default */],{date:dueDate}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"offline-only-payment-body__message"},"Payment for this item can only be made in school. Please bring your payment into school.")));}}]);return OfflineOnlyPaymentBody;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var paymentID=_ref.paymentID;return{payment:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_21" /* getPaymentByID */])(state,paymentID),isOverdue:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_103" /* isPaymentOverdue */])(state,paymentID)};})(OfflineOnlyPaymentBody));

/***/ }),
/* 702 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_school_money_payments_PaymentInstallment__ = __webpack_require__(704);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentInstallmentList=function(_React$Component){_inherits(PaymentInstallmentList,_React$Component);function PaymentInstallmentList(){_classCallCheck(this,PaymentInstallmentList);return _possibleConstructorReturn(this,(PaymentInstallmentList.__proto__||Object.getPrototypeOf(PaymentInstallmentList)).apply(this,arguments));}_createClass(PaymentInstallmentList,[{key:"render",value:function render(){var _props=this.props,paymentID=_props.paymentID,installmentNumberList=_props.installmentNumberList,showAddRemoveButtons=_props.showAddRemoveButtons;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"payment-installments"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,installmentNumberList.map(function(installmentNumber){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_components_school_money_payments_PaymentInstallment__["a" /* default */],{key:installmentNumber,paymentID:paymentID,installmentNumber:installmentNumber,showAddRemoveButtons:showAddRemoveButtons});})));}}]);return PaymentInstallmentList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PaymentInstallmentList);

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Date__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_MoneyInput__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_BasketModificationModal__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_school_money_payments_PaymentBasketButton__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PaymentInstallment_css__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PaymentInstallment_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__PaymentInstallment_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentInstallment=function(_React$Component){_inherits(PaymentInstallment,_React$Component);function PaymentInstallment(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PaymentInstallment);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PaymentInstallment.__proto__||Object.getPrototypeOf(PaymentInstallment)).call.apply(_ref,[this].concat(args))),_this),_this.state={isBasketModificationModalOpen:false,isInputValid:true},_this.onReadOnlyClick=function(){_this.setState({isBasketModificationModalOpen:true});},_this.closeBasketModificationModal=function(result){if(result){_this.props.removeFromBasket();}_this.setState({isBasketModificationModalOpen:false});},_this.onSelectedPriceChange=function(amount){_this.props.setSelectedPrice(amount);},_this.validateInput=function(amount){var isVoluntary=_this.props.payment.isVoluntary;var maxPrice=isVoluntary?Infinity:_this.props.installment.outstandingPrice;return amount>0&&amount<=maxPrice;},_this.onInputValidityChange=function(isInputValid){_this.setState({isInputValid:isInputValid});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PaymentInstallment,[{key:"render",value:function render(){var _props=this.props,payment=_props.payment,paymentID=_props.paymentID,installment=_props.installment,installmentNumber=_props.installmentNumber,selectedPrice=_props.selectedPrice,isInBasket=_props.isInBasket,isOverdue=_props.isOverdue,showAddRemoveButtons=_props.showAddRemoveButtons;var _payment$toObject=payment.toObject(),isPartial=_payment$toObject.isPartial,isVoluntary=_payment$toObject.isVoluntary;var _installment$toObject=installment.toObject(),dueDate=_installment$toObject.dueDate,outstandingPrice=_installment$toObject.outstandingPrice;var isInputValid=this.state.isInputValid;var classNames=["payment-installment"];if(isInBasket){classNames.push("payment-installment--in-basket");}if(isOverdue){classNames.push("payment-installment--overdue");}if(!showAddRemoveButtons){classNames.push("payment-installment--no-buttons");}if(!isInputValid){classNames.push("payment-installment--invalid");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:classNames.join(" ")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_BasketModificationModal__["a" /* default */],{isOpen:this.state.isBasketModificationModalOpen,onClose:this.closeBasketModificationModal,itemName:"installment"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"payment-installment__price"},isPartial||isVoluntary?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_MoneyInput__["a" /* default */],{className:"payment-installment__price-input",initialAmount:selectedPrice,defaultAmount:outstandingPrice,onChange:this.onSelectedPriceChange,validateInput:this.validateInput,onValidityChange:this.onInputValidityChange,readOnly:isInBasket,onReadOnlyClick:this.onReadOnlyClick}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Currency__["a" /* default */],{className:"payment-installment__price-amount",amount:selectedPrice})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"payment-installment__due-date"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Date__["a" /* default */],{date:dueDate})),showAddRemoveButtons?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"payment-installment__button"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_components_school_money_payments_PaymentBasketButton__["a" /* default */],{cssBlockName:"payment-installment",paymentID:paymentID,installmentNumber:installmentNumber,canAddToBasket:isInputValid})):null);}}]);return PaymentInstallment;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref2){var paymentID=_ref2.paymentID,installmentNumber=_ref2.installmentNumber;return{payment:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_21" /* getPaymentByID */])(state,paymentID),installment:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_23" /* getPaymentInstallment */])(state,paymentID,installmentNumber),selectedPrice:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_24" /* getPaymentInstallmentSelectedPrice */])(state,paymentID,installmentNumber),isOverdue:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_101" /* isPaymentInstallmentOverdue */])(state,paymentID,installmentNumber),isInBasket:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_100" /* isPaymentInstallmentInBasket */])(state,paymentID,installmentNumber)};},function(dispatch,_ref3){var paymentID=_ref3.paymentID,installmentNumber=_ref3.installmentNumber;return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({setSelectedPrice:function setSelectedPrice(inputPrice){return Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_107" /* setPaymentInstallmentSelectedPrice */])(paymentID,installmentNumber,inputPrice);},removeFromBasket:function removeFromBasket(){return Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_90" /* removePaymentInstallmentFromBasket */])(paymentID,installmentNumber);}},dispatch);})(PaymentInstallment));

/***/ }),
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_AddOrRemoveButton__ = __webpack_require__(115);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UnpaidDinnerMoneyPayment=function(_React$Component){_inherits(UnpaidDinnerMoneyPayment,_React$Component);function UnpaidDinnerMoneyPayment(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UnpaidDinnerMoneyPayment);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UnpaidDinnerMoneyPayment.__proto__||Object.getPrototypeOf(UnpaidDinnerMoneyPayment)).call.apply(_ref,[this].concat(args))),_this),_this.addToBasket=function(){_this.props.addToBasket("dinner_money",_this.props.studentID,_this.props.arrearsAmount);},_this.removeFromBasket=function(){_this.props.removeFromBasket("dinner_money",_this.props.studentID);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UnpaidDinnerMoneyPayment,[{key:"render",value:function render(){var _props=this.props,studentID=_props.studentID,arrearsAmount=_props.arrearsAmount,isInBasket=_props.isInBasket;if(arrearsAmount<=0){return null;}var linkPath="/school_money/history/"+studentID+"/";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__description"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:linkPath},"Unpaid Dinner Money")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__annotation"},"Tap to view history")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__controls"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__price"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Currency__["a" /* default */],{amount:arrearsAmount})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_AddOrRemoveButton__["a" /* default */],{cssBlockName:"payment-header",isAdded:isInBasket,onRemove:this.removeFromBasket,onAdd:this.addToBasket})))))));}}]);return UnpaidDinnerMoneyPayment;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref2){var studentID=_ref2.studentID;return{arrearsAmount:-Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_59" /* getStudentTotalCreditAmountToPay */])(state,studentID,"dinner_money"),isInBasket:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["R" /* getCreditTopUpAmount */])(state,studentID,"dinner_money")>0};},{addToBasket:__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_36" /* addCreditTopUpToBasket */],removeFromBasket:__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_88" /* removeCreditTopUpFromBasket */]})(UnpaidDinnerMoneyPayment));

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Currency__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_AddOrRemoveButton__ = __webpack_require__(115);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var UnpaidClubMoneyPayment=function(_React$Component){_inherits(UnpaidClubMoneyPayment,_React$Component);function UnpaidClubMoneyPayment(){var _ref;var _temp,_this,_ret;_classCallCheck(this,UnpaidClubMoneyPayment);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=UnpaidClubMoneyPayment.__proto__||Object.getPrototypeOf(UnpaidClubMoneyPayment)).call.apply(_ref,[this].concat(args))),_this),_this.addToBasket=function(){_this.props.addToBasket("club_extended_services",_this.props.studentID,_this.props.arrearsAmount);},_this.removeFromBasket=function(){_this.props.removeFromBasket("club_extended_services",_this.props.studentID);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UnpaidClubMoneyPayment,[{key:"render",value:function render(){var _props=this.props,studentID=_props.studentID,arrearsAmount=_props.arrearsAmount,isInBasket=_props.isInBasket;if(arrearsAmount<=0){return null;}var linkPath="/school_money/history/"+studentID+"/";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__description"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:linkPath},"Unpaid Club Money")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__annotation"},"Tap to view history")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__controls"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-header__price"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Currency__["a" /* default */],{amount:arrearsAmount})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_AddOrRemoveButton__["a" /* default */],{cssBlockName:"payment-header",isAdded:isInBasket,onRemove:this.removeFromBasket,onAdd:this.addToBasket})))))));}}]);return UnpaidClubMoneyPayment;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref2){var studentID=_ref2.studentID;return{arrearsAmount:-Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_59" /* getStudentTotalCreditAmountToPay */])(state,studentID,"club_extended_services"),isInBasket:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["R" /* getCreditTopUpAmount */])(state,studentID,"club_extended_services")>0};},{addToBasket:__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_36" /* addCreditTopUpToBasket */],removeFromBasket:__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_88" /* removeCreditTopUpFromBasket */]})(UnpaidClubMoneyPayment));

/***/ }),
/* 709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_school_money_Preloader__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_school_money_MaintainValidStudentID__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_school_money_StudentSelector__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_school_money_StudentCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_parental_consent_StudentParentalConsentList__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_school_money_parental_consent_ParentalConsentErrorModal__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_school_money_parental_consent_ParentalConsentSuccessModal__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ParentalConsentPage_css__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ParentalConsentPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ParentalConsentPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ParentalConsentPage=function(_React$Component){_inherits(ParentalConsentPage,_React$Component);function ParentalConsentPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ParentalConsentPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ParentalConsentPage.__proto__||Object.getPrototypeOf(ParentalConsentPage)).call.apply(_ref,[this].concat(args))),_this),_this.isParentalConsentReady=function(state){return Object(__WEBPACK_IMPORTED_MODULE_1_state_school_money_selectors__["_95" /* isParentalConsentReady */])(state,_this.props.studentID);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ParentalConsentPage,[{key:"generatePath",value:function generatePath(studentID){return"/school_money/parental_consent/"+studentID+"/";}},{key:"render",value:function render(){var studentID=this.props.match.params.studentID;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_school_money_MaintainValidStudentID__["a" /* default */],{currentStudentID:studentID,generatePath:this.generatePath},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_school_money_parental_consent_ParentalConsentErrorModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_school_money_parental_consent_ParentalConsentSuccessModal__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parental-consent-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page-header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",{className:"page-header__title"},"Parental Consent"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_school_money_StudentSelector__["a" /* default */],{selectedStudentID:studentID,generatePath:this.generatePath})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_components_school_money_Preloader__["a" /* default */],{isPageReady:this.isParentalConsentReady},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_school_money_StudentCarousel__["a" /* default */],{activeStudentID:studentID,generatePath:this.generatePath},function(studentID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_parental_consent_StudentParentalConsentList__["a" /* default */],{key:studentID,studentID:studentID});}))));}}]);return ParentalConsentPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (ParentalConsentPage);

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_List__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ScrollableContainer__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_school_money_PlaceholderCard__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_school_money_parental_consent_ParentalConsentItem__ = __webpack_require__(712);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StudentParentalConsentList=function(_React$Component){_inherits(StudentParentalConsentList,_React$Component);function StudentParentalConsentList(){_classCallCheck(this,StudentParentalConsentList);return _possibleConstructorReturn(this,(StudentParentalConsentList.__proto__||Object.getPrototypeOf(StudentParentalConsentList)).apply(this,arguments));}_createClass(StudentParentalConsentList,[{key:"renderPlaceholder",value:function renderPlaceholder(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_school_money_PlaceholderCard__["a" /* default */],{objectName:"parental consent",school:this.props.school});}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ScrollableContainer__["a" /* default */],{className:"parental-consent-list"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_components_List__["a" /* default */],{placeholder:this.renderPlaceholder()},this.props.parentalConsentIDList.map(function(itemID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_school_money_parental_consent_ParentalConsentItem__["a" /* default */],{key:itemID,itemID:itemID});})));}}]);return StudentParentalConsentList;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref){var studentID=_ref.studentID;return{parentalConsentIDList:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_53" /* getStudentParentConsentIDList */])(state,studentID),school:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_29" /* getSchoolByID */])(state,Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_56" /* getStudentSchoolID */])(state,studentID))};})(StudentParentalConsentList));

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Card__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Date__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Checkbox__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_Spinner__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ParentalConsentItem_css__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ParentalConsentItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ParentalConsentItem_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ParentalConsentItem=function(_React$Component){_inherits(ParentalConsentItem,_React$Component);function ParentalConsentItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ParentalConsentItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ParentalConsentItem.__proto__||Object.getPrototypeOf(ParentalConsentItem)).call.apply(_ref,[this].concat(args))),_this),_this.onChange=function(checked){_this.props.update(checked);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ParentalConsentItem,[{key:"render",value:function render(){var _props=this.props,item=_props.item,isSaving=_props.isSaving;var description=item.description,dueDate=item.dueDate,isGiven=item.isGiven;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Card__["a" /* default */].Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parental-consent-item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parental-consent-item__details"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parental-consent-item__description"},description),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parental-consent-item__due-date"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Date__["a" /* default */],{date:dueDate}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parental-consent-item__checkbox-container"},isSaving?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_Spinner__["a" /* default */],{color:"school_money"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Checkbox__["a" /* default */],{cssModifier:"school_money",checked:isGiven,disabled:isGiven,onChange:this.onChange})))));}}]);return ParentalConsentItem;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,_ref2){var itemID=_ref2.itemID;return{item:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_19" /* getParentalConsentItemByID */])(state,itemID),isSaving:Object(__WEBPACK_IMPORTED_MODULE_3_state_school_money_selectors__["_96" /* isParentalConsentSaving */])(state,itemID)};},function(dispatch,_ref3){var itemID=_ref3.itemID;return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["bindActionCreators"])({update:function update(checked){return Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_actions__["_112" /* updateParentalConsent */])(itemID,checked);}},dispatch);})(ParentalConsentItem));

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ParentalConsentErrorModal_css__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ParentalConsentErrorModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ParentalConsentErrorModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ParentalConsentErrorModal=function(_React$Component){_inherits(ParentalConsentErrorModal,_React$Component);function ParentalConsentErrorModal(){_classCallCheck(this,ParentalConsentErrorModal);return _possibleConstructorReturn(this,(ParentalConsentErrorModal.__proto__||Object.getPrototypeOf(ParentalConsentErrorModal)).apply(this,arguments));}_createClass(ParentalConsentErrorModal,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ModalDialog__["a" /* default */],{isOpen:this.props.isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parental-consent-error"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parental-consent-error__title"},"Oops!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parental-consent-error__message"},"Sorry! Something went wrong and your consent could not be saved. Please try again later."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parental-consent-error__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Button__["a" /* default */],{className:"parental-consent-error__close-button",onClick:this.props.onClose},"OK"))));}}]);return ParentalConsentErrorModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_65" /* isAnyPendingParentalConsentItemFailed */])(state)};},{onClose:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_42" /* clearFailedPendingParentalConsentItems */]})(ParentalConsentErrorModal));

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_ModalDialog__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ParentalConsentSuccessModal_css__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ParentalConsentSuccessModal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ParentalConsentSuccessModal_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ParentalConsentSuccessModal=function(_React$Component){_inherits(ParentalConsentSuccessModal,_React$Component);function ParentalConsentSuccessModal(){_classCallCheck(this,ParentalConsentSuccessModal);return _possibleConstructorReturn(this,(ParentalConsentSuccessModal.__proto__||Object.getPrototypeOf(ParentalConsentSuccessModal)).apply(this,arguments));}_createClass(ParentalConsentSuccessModal,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_components_ModalDialog__["a" /* default */],{isOpen:this.props.isOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parental-consent-success"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parental-consent-success__title"},"Consent Saved"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parental-consent-success__message"},"Consent saved successfully."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parental-consent-sucess__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_components_Button__["a" /* default */],{className:"parental-consent-success__close-button",onClick:this.props.onClose},"OK"))));}}]);return ParentalConsentSuccessModal;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{isOpen:Object(__WEBPACK_IMPORTED_MODULE_2_state_school_money_selectors__["_66" /* isAnyPendingParentalConsentItemSaved */])(state)};},{onClose:__WEBPACK_IMPORTED_MODULE_3_state_school_money_actions__["_47" /* clearSavedPendingParentalConsentItems */]})(ParentalConsentSuccessModal));

/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lib_validate__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_state_history__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Overlay__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_LoadingPage__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_assets_images_eduspot_logo_svg__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_assets_images_eduspot_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_components_assets_images_eduspot_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_assets_images_school_money_item_tick_svg__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_assets_images_school_money_item_tick_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_components_assets_images_school_money_item_tick_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_assets_images_school_money_item_incorrect_svg__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_assets_images_school_money_item_incorrect_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_components_assets_images_school_money_item_incorrect_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ParentEmailInputPage_css__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ParentEmailInputPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ParentEmailInputPage_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ParentEmailInputPage=function(_React$Component){_inherits(ParentEmailInputPage,_React$Component);function ParentEmailInputPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ParentEmailInputPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ParentEmailInputPage.__proto__||Object.getPrototypeOf(ParentEmailInputPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={isEmailValid:false,emailValue:"",confirmValue:""},_this.onEmailInputChange=function(event){_this.setState({emailValue:event.target.value,isEmailValid:event.target.validity.valid});},_this.onConfirmInputChange=function(event){_this.setState({confirmValue:event.target.value});},_this.onBackButtonClick=function(){__WEBPACK_IMPORTED_MODULE_3_state_history__["a" /* history */].push("/");},_this.onContinueButtonClick=function(){if(_this.isAllValid()){_this.props.updateParentEmailAddress(_this.state.emailValue);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ParentEmailInputPage,[{key:"doInputsMatch",value:function doInputsMatch(){var _state=this.state,emailValue=_state.emailValue,confirmValue=_state.confirmValue;return Object(__WEBPACK_IMPORTED_MODULE_2_lib_validate__["a" /* doStringsMatch */])(emailValue,confirmValue);}},{key:"isEmailValid",value:function isEmailValid(){var isEmpty=Object(__WEBPACK_IMPORTED_MODULE_2_lib_validate__["f" /* isStringEmpty */])(this.state.emailValue);var isValid=this.state.isEmailValid;return!isEmpty&&isValid;}},{key:"isConfirmValid",value:function isConfirmValid(){return this.isEmailValid()&&this.doInputsMatch();}},{key:"isAllValid",value:function isAllValid(){return this.isEmailValid()&&this.doInputsMatch();}},{key:"renderInputIndicator",value:function renderInputIndicator(isEmpty,isValid){var showTick=isValid&&!isEmpty;var showCross=!isValid&&!isEmpty;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parent-email-input-page__input-indicator"},showTick?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_10_components_assets_images_school_money_item_tick_svg___default.a,alt:"valid"}):null,showCross?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_11_components_assets_images_school_money_item_incorrect_svg___default.a,alt:"invalid"}):null);}},{key:"renderInputRow",value:function renderInputRow(value,isEmpty,isValid,label,onChange){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parent-email-input-page__input-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"parent-email-input-page__input",type:"email",placeholder:label,value:value,onChange:onChange}),this.renderInputIndicator(isEmpty,isValid));}},{key:"renderEmailInputRow",value:function renderEmailInputRow(){var value=this.state.emailValue;var isEmpty=Object(__WEBPACK_IMPORTED_MODULE_2_lib_validate__["f" /* isStringEmpty */])(value);var isValid=this.isEmailValid();return this.renderInputRow(value,isEmpty,isValid,"Email address",this.onEmailInputChange);}},{key:"renderConfirmInputRow",value:function renderConfirmInputRow(){var value=this.state.confirmValue;var isEmpty=Object(__WEBPACK_IMPORTED_MODULE_2_lib_validate__["f" /* isStringEmpty */])(value);var isValid=this.isConfirmValid();return this.renderInputRow(value,isEmpty,isValid,"Confirm email address",this.onConfirmInputChange);}},{key:"renderPage",value:function renderPage(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parent-email-input-page__body"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"parent-email-input-page__logo",src:__WEBPACK_IMPORTED_MODULE_9_components_assets_images_eduspot_logo_svg___default.a,alt:"Eduspot Logo"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parent-email-input-page__brand-text"},"eduspot"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parent-email-input-page__blurb"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Welcome"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"To begin making Payments and Bookings for your child, SchoolMoney requires your email address to send receipts.")),this.renderEmailInputRow(),this.renderConfirmInputRow(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parent-email-input-page__button-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Button__["a" /* default */],{className:"parent-email-input-page__button",onClick:this.onBackButtonClick},"Back"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_components_Button__["a" /* default */],{className:"parent-email-input-page__button parent-email-input-page__button--continue",onClick:this.onContinueButtonClick},"Continue")));}},{key:"render",value:function render(){var cssModifier=this.isAllValid()?"valid":"invalid";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_components_Overlay__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parent-email-input-page parent-email-input-page--"+cssModifier},this.props.isReady?this.renderPage():__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_components_LoadingPage__["a" /* default */],null)));}}]);return ParentEmailInputPage;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{schools:Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_36" /* getSchoolsLackingParentEmailAddresses */])(state),isReady:Object(__WEBPACK_IMPORTED_MODULE_4_state_school_money_selectors__["_97" /* isParentsReady */])(state)};},{updateParentEmailAddress:__WEBPACK_IMPORTED_MODULE_5_state_school_money_actions__["_111" /* updateParentEmailAddress */]})(ParentEmailInputPage));

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/eduspot-logo.da5cf1bf.svg";

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/item-tick.b6259229.svg";

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/item-incorrect.3b014467.svg";

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.ac3427df.js